(function ()
{
    'use strict';

    angular
        .module('app.wooapps', ['app.wooadmin'])
        .config(config)
    /** @ngInject */
    function config($stateProvider, $urlRouterProvider, $translatePartialLoaderProvider,
         msNavigationServiceProvider,Models)
    {
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.wooapps')
        //.controller('OldWooAppEditController', WooAppEditController);

    /** @ngInject */
    function WooAppEditController($state, WooApp, WooPlan, WooLocation) {
        var vm = this;
        vm.id = $state.params.id;
        if (vm.id) {
            vm.obj = vm.wooapp = WooApp.get({obj_id:vm.id})
            vm.editing=true;
            vm.save_button='WOOAPPS.SAVE';
            vm.form=WooApp.form({form_type:'user'})
        } else {
            vm.obj = vm.wooapp=new WooApp();
            vm.save_button='WOOAPPS.CREATE';
            vm.form=WooApp.form({form_type:'user'},function(form) {
                for (var l in form.default) {
                    vm.obj[l]=form.default[l]
                }
            })
        }
        vm.model={name:'app'};
        vm.save = function () { vm.isSaving=true; saveApp($state,vm.wooapp,{obj_id:vm.id}); }

        vm.cancel = function () {cancel($state)};
    }

    function saveApp($state,app,args) {
        app.$save(args, function () {
            $state.go('app.wooapps');
        });
    }

    function cancel($state,event) {
        $state.go('app.wooapps')
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.wtWhois',[])
        .controller('wtWhoisController', Controller)
        .directive('wtWhois', Directive);

    /** @ngInject */
    function Controller($scope, $attrs, $http)
    {
        var vm = this
        var domain = $scope.wtDomainName

        $scope.domain = domain

        var config = {
            withCredentials: false // Prevents CORS error
        }
        $http.get('https://whois.templ.io/api/v1/'+domain, config)
            .then(function(response){
                console.log(response.data.formatted_data)
                $scope.nameservers = response.data.formatted_data.nameServers
                $scope.registrar = response.data.formatted_data.registrar
                $scope.expirationDate = response.data.formatted_data.expirationDate
                $scope.loading = false
            })
            .catch(function(error){
                console.error(error)
                $scope.loading = false
                $scope.error = true
            })
        
    }

    /** @ngInject */
    function Directive()
    {
        return {
            restrict: 'E',
            scope: {
                'wtDomainName': '=',
            },
            controller : 'wtWhoisController as vm',
            templateUrl: 'app/main/directives/wt-whois/wt-whois.html',
            transclude : false,
            compile: function compile() {
                return {
                    post: function postLink(scope, iElement, iAttrs, Controller) {
                        var vm = scope.vm
                        scope.loading = true
                        scope.error = false
                    }
                }
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.wtTooltip',[])
        .controller('WtTooltipController', Controller)
        .directive('wtTooltip', Directive);

    /** @ngInject */
    function Controller()
    {
        var vm = this;
    }


    /** @ngInject */
    function Directive()
    {
        return {
            restrict   : 'E',
            scope: {
                text:'=',
            },
            controller : 'WtTooltipController as vm',
            templateUrl: 'app/main/directives/wt-tooltip/wt-tooltip.html',
            transclude : true,
            compile: function compile(tElement, tAttrs, transclude) {
                return {
                    post: function postLink(scope, iElement, iAttrs, controller) {
                        //console.log('postLink 2',scope,iElement,iAttrs,controller);
                        var vm=scope.vm
                        vm.text=iAttrs.wtText
                        //vm.list=iAttrs.list
                        //vm.initFrame(vm.help_frame,iElement.find('.help-page-container'))
                    }
                }
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.wtText',[])
        .controller('WtTextController', Controller)
        .directive('wtText', Directive);

    /** @ngInject */
    function Controller($scope,WooLinks,$translate)
    {
        WooLinks().then(function(data){
            var msg=$scope.msg
            var link=data[msg] || $scope.link
            if (link) {
                $scope.link=link
                $scope.link_text= $scope.link_text ||msg+'_LINK'
            }
        })
    }


    /** @ngInject */
    function Directive()
    {
        return {
            restrict   : 'E',
            scope: {
                'wt-msg':'=',
                'wt-trunc':'=?',
                'wt-link':'=?',
                'wt-link-target':'=?',
                'wt-translate-values':'=?',
            },
            controller : 'WtTextController as vm',
            templateUrl: 'app/main/directives/wt-text/wt-text.html',
            //templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            transclude : true,
            compile: function compile(tElement, tAttrs, transclude) {
                return {
                    post: function postLink(scope, iElement, iAttrs, controller) {
                        scope.msg=iAttrs.wtMsg
                        scope.trunc=iAttrs.wtTrunc
                        scope.link=iAttrs.wtLink
                        scope.link_text=iAttrs.wtLinkText
                        scope.target=iAttrs.wtLinkTarget || "_blank"
                        scope.translate_values=iAttrs.wtTranslateValues || "{}"
                    }
                }
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.wtPlanQuiz',[])
        .controller('wtPlanQuizController', Controller)
        .directive('wtPlanQuiz', Directive);

    /** @ngInject */
    function Controller($scope, $translate, $uibModal)
    {
        var vm = this
        vm.openQuiz = function(ev) {
            var modal = $uibModal.open({
                backdrop: true,
                backdropClass: 'show',
                windowClass: 'd-flex justify-content-center align-items-center',
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/main/directives/wt-plan-quiz/wt-plan-quiz-modal.html',
                controller: 'wtPlanQuizController',
                controllerAs: 'vm',
            });
            modal.opened.then(function() {
                // Just remount vue app if script element already exists
                if(document.getElementById('suggesterScript')) {
                    document.dispatchEvent(new Event('remountPlanSuggester'));
                    return;
                }
                // Add plan suggester script
                var suggesterScript = document.createElement('script');
                suggesterScript.id = 'suggesterScript'
                suggesterScript.src = 'https://templ.io/app/themes/templ2/js/templ-plan-suggester.js?v=20241204-03';
                suggesterScript.type = 'module';
                document.head.appendChild(suggesterScript);
            })
        }
    }


    /** @ngInject */
    function Directive()
    {
        return {
            restrict: 'E',
            scope: {
                // ...
            },
            controller : 'wtPlanQuizController as vm',
            templateUrl: 'app/main/directives/wt-plan-quiz/wt-plan-quiz.html',
            transclude : true,
            compile: function compile() {
                return {
                    post: function postLink(scope, iElement, iAttrs) {
                        // ...
                    }
                }
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.wtRenewalDate',[])
        .controller('wtRenewalDateController', Controller)
        .directive('wtRenewalDate', Directive);

    /** @ngInject */
    function Controller()
    {
        var vm = this;
    }


    /** @ngInject */
    function Directive()
    {
        return {
            restrict   : 'E',
            scope: {
                time:'=',
            },
            controller : 'wtRenewalDateController as vm',
            templateUrl: 'app/main/directives/wt-renewal-date/wt-renewal-date.html',
            transclude : true,
            compile: function compile(tElement, tAttrs, transclude) {
                return {
                    post: function postLink(scope, iElement, iAttrs, controller) {

                        var vm=scope.vm

                        var renewalDate=new Date(iAttrs.wtTime)
                        var options = {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric',
                        }
                        var locale=window.navigator.language == 'sv-SE' ? 'sv-SE' : 'en-US'
                        vm.autoRenewal=iAttrs.wtAutoRenewal === 'true' // String to bool...
                        // console.log(vm.autoRenewal, typeof vm.autoRenewal)
                        // console.log(locale)
                        vm.date=renewalDate.toLocaleDateString(locale, options)

                        // console.log('wt-time', iAttrs.wtTime)
                        // console.log(vm.date)
                        // console.log(scope)
                        
                        var now=new Date()
                        var timeDifference=renewalDate.getTime()-now.getTime()
                        var daysBetween=timeDifference / (1000*60*60*24)
                        vm.renewsSoon=daysBetween<=30 && daysBetween>=0
                        vm.expired=daysBetween<0


                        // console.log('timeDifference', timeDifference)
                        // console.log('daysBetween', daysBetween)
                    }
                }
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.wtMessage',[])
        .controller('WtMessageController', Controller)
        .directive('wtMessage', Directive);

    /** @ngInject */
    function Controller(cachedMessages)
    {
        console.log('wt-message');
        var vm = this;

        cachedMessages().then(function(res) {
            vm.messages=res[vm.position]
            if (!vm.list) {
                // Get most important, or most recent, message
                vm.message=res.getTopMessage(vm.position)
                if (!vm.message) {
                    vm.message={body:'Default '+vm.position+' message'}
                }
            }
        })
    }


    /** @ngInject */
    function Directive()
    {
        return {
            restrict   : 'E',
            scope: {
                position:'=',
                list:'=?'
            },
            controller : 'WtMessageController as vm',
            templateUrl: 'app/main/directives/wt-message/wt-message.html',
            //templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            transclude : true,
            compile: function compile(tElement, tAttrs, transclude) {
                return {
                    post: function postLink(scope, iElement, iAttrs, controller) {
                        //console.log('postLink 2',scope,iElement,iAttrs,controller);
                        var vm=scope.vm
                        vm.position=iAttrs.position
                        vm.list=iAttrs.list
                        //vm.initFrame(vm.help_frame,iElement.find('.help-page-container'))
                    }
                }
            }
        };
    }

})();


(function ()
{
    'use strict';

    angular
        .module('app.wtInfo',[])
        .controller('wtInfoController', Controller)
        .directive('wtInfo', Directive);

    /** @ngInject */
    function Controller($scope, $translate)
    {
        // var vm = this
        // vm.hello = 'hello world'
        // vm.function = function() {
        //     alert('hello world')
        // }
    }


    /** @ngInject */
    function Directive()
    {
        return {
            restrict: 'E',
            scope: {
                'wt-title':'=',
                'wt-content':'=',
                'wt-translate-values':'=',
                'wt-type':'=',
            },
            controller : 'wtInfoController as vm',
            templateUrl: 'app/main/directives/wt-info/wt-info.html',
            transclude : true,
            compile: function compile() {
                return {
                    post: function postLink(scope, iElement, iAttrs) {
                        scope.title=iAttrs.wtTitle
                        scope.content=iAttrs.wtContent
                        scope.type=+iAttrs.wtType || 'alert'
                        scope.class='wt-info-'+scope.type
                        scope.translateValues=iAttrs.wtTranslateValues
                    }
                }
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.wtIcon',[])
        .controller('wtIconController', Controller)
        .directive('wtIcon', Directive);

    /** @ngInject */
    function Controller($scope, $translate)
    {
    }


    /** @ngInject */
    function Directive()
    {
        return {
            restrict: 'E',
            scope: {
                'wt-icon-src':'=',
                'wt-icon-alt':'=',
            },
            controller : 'wtIconController as vm',
            templateUrl: 'app/main/directives/wt-icon/wt-icon.html',
            transclude : true,
            compile: function compile() {
                return {
                    post: function postLink(scope, iElement, iAttrs) {
                        scope.src=iAttrs.wtIconSrc
                        scope.alt=iAttrs.wtIconAlt
                        if(scope.src.includes('/flags/')) {
                            scope.alt=iAttrs.wtIconAlt+' flag'
                            scope.class='wt-icon-flag'
                        }
                    }
                }
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.wtHelpButton',[])
        .controller('wtHelpButtonController', Controller)
        .directive('wtHelpButton', Directive);

    /** @ngInject */
    function Controller($scope, $translate)
    {
        // var vm = this
        // vm.hello = 'hello world'
        // vm.function = function() {
        //     alert('hello world')
        // }
    }


    /** @ngInject */
    function Directive($window)
    {
        return {
            restrict: 'E',
            scope: {
                'wt-help-url':'@',
                'wt-color': '@',
            },
            controller : 'wtInfoController as vm',
            templateUrl: 'app/main/directives/wt-help-button/wt-help-button.html',
            transclude : true,
            compile: function compile() {
                return {
                    post: function postLink(scope, iElement, iAttrs) {
                        scope.helpUrl = iAttrs.wtHelpUrl
                        scope.openHelp = function() {
                            if (scope.helpUrl) {
                                $window.open(scope.helpUrl, '_blank', 'noopener')
                            }
                        }
                        scope.color = iAttrs.wtColor || 'lightblue'
                    }
                }
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.wtForm',[])
        .controller('WtFormController', Controller)
        .directive('wtForm', Directive);

    /** @ngInject */
    function Controller()
    {
        var vm = this;
        vm.includes_option = function(val,options) {
            if (!val) {
                return true
            }
            for(var v in options) {
                v=options[v]
                if ((v.value||v)==(val._id||val)) {
                    return true
                }
            }
            return false
        }
    }


    /** @ngInject */
    function Directive()
    {
        return {
            restrict   : 'E',
            scope: {
                'wt-form':'=?',
                'wt-obj':'=?'
                ,'wt-tab':'=?'
            },
            controller : 'WtFormController as vm',
            templateUrl: 'app/main/directives/wt-form/wt-form.html',
            //templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            transclude : true,
            compile: function compile(tElement, tAttrs, transclude) {
                return {
                    post: function postLink(scope, iElement, iAttrs, controller) {
                        //console.log('postLink 2',scope,iElement,iAttrs,controller);
                        var vm=scope.vm
                        vm.obj=scope.obj=scope.$parent.vm[iAttrs.wtObj]
                        vm.form=scope.form=scope.$parent.vm[iAttrs.wtForm]
                        scope.fields=scope.form&&scope.form.fields
                        scope.modelForm=scope.$parent['modelForm']
                        if(iAttrs.wtTab) {
                            var tab=_.find(vm.form.tabs,function(tab){ return  (tab.name==iAttrs.wtTab)})
                            if (tab&&tab.fields) {
                                scope.fields=tab.fields
                            }
                        }
                    }
                }
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.wtField',[])
        .controller('WtFieldController', Controller)
        .directive('wtField', Directive)

    /** @ngInject */
    function Controller($scope)
    {
        var vm = this;
        vm.obj=$scope.obj
        vm.field=$scope.field
        vm.includes_option = function(val,options) {
            if (!val) {
                return true
            }
            for(var v in options) {
                v=options[v]
                if ((v&&v.value||v)==(val._id||val)) {
                    return true
                }
            }
            return false
        }

        vm.add_list_element = function(form, obj, field) {
            if (!obj[field]) {
                obj[field]=[]
            }
            if (vm.list_elem_type(form,field) == 'compound') {
                obj[field].push( {} )
            } else {
                obj[field].push( "" )
            }
        }

        vm.init_compound = function(obj,field) {
            if (!obj[field]) {
                obj[field]={}
            }
            return obj[field]
        }
        vm.path_add = function(path,field) {
            if (!path|| path=='') return field
            return path+'.'+field
        }
        vm.remove_list_element = function(list,index) {
            if ($scope.modelForm) {
                $scope.modelForm.$setDirty()
            }
            list.splice(index,1)
        }

        vm.list_elem_type = function(form,field) {
            if (form.subforms && form.subforms[field]) {
                return 'compound'
            }
            return 'simple'
        }

        vm.loadFile=function(element) {
            var reader = new FileReader();
            reader.onload = function () {
                $scope.obj[$scope.field] = reader.result;
                $scope.$apply();
            }
            reader.readAsText(element.files[0]);
        }

    }


    function setValue(scope) {
        var field=scope.field
        var value=scope.obj[field]
        var name=value && value.name
        value=value&&value._id||value
        var form=scope.form
        if(scope.type && scope.type.match('ui-select') && form.values && form.values[field]) {
            form.values[field]=form.values[field].docs||form.values[field]
            if(scope.type=='ui-select') scope.type='select'
            else scope.type='multiselect'
        }
        switch(scope.type) {
            case 'select':
                var vals=_.select(form.values&&form.values[field],function(option) {
                    return value==(option.value||option)
                })
                value=vals[0]
                scope.value=value&&value.name||name||value
                break
            case 'multiselect':
                var vals=_.select(form.values&&form.values[field],function(option) {
                    return value.indexOf(option.value||option)>=0
                })
                scope.value=_.map(vals,function(v){return v&&v.name||v}).join(', ')
                break
            case 'checkbox':
                scope.value=value?'YES':'NO';
                break
            default:
                scope.value=value
        }
    }

    function setObj(scope,obj) {
        var path=obj.split('.')
        var p=path.shift()
        var o=scope.$parent.vm[p]
        if (path.length) {
            scope.path=path.join('.')
        }
        while(path.length) {
            var p=path.shift()
            o=o[p]
        }
        scope.obj=o //scope.$parent.vm[iAttrs.wtObj]
        if (scope.details) setValue(scope)
    }


    /** @ngInject */
    function Directive()
    {
        return {
            restrict   : 'E',
            scope: {
                'wt-obj':'=?',
                'wt-form':'=?',
                'wt-type':'=?',
                'wt-label':'=?',
                'wt-field':'=?',
                'wt-description':'=?',
                'wt-note':'=?',
                'wt-disabled':'=?',
                'wt-details':'=?'
            },
            controller : 'WtFieldController as vm',
            templateUrl: 'app/main/directives/wt-field/wt-field-wrapper.html',
            //templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            transclude : true,
            compile: function compile(tElement, tAttrs, transclude) {
                return {
                    post: function postLink(scope, iElement, iAttrs, controller) {
                        //console.log('postLink 2',scope,iElement,iAttrs,controller);
                        var vm=scope.vm


                        if (iAttrs.wtForm) {
                            var path=iAttrs.wtForm.split('.')
                            var p=path.shift()
                            var form=scope.$parent.vm[p]
                            while(path.length) {
                                var p=path.shift()
                                form=form[p]
                            }
                            scope.form=form
                            //console.log("Using Form",iAttrs.wtForm,scope.form);
                        }
                        if (!scope.form) {
                            scope.form={
                                label:{},
                                disabled:{},
                                description:{},
                                note:{}
                            }
                        }

                        scope.modelForm=scope.$parent['modelForm']
                        scope.field=iAttrs.wtField||'field'
                        scope.type=iAttrs.wtType || scope.form.type && scope.form.type[scope.field]
                        scope.details=iAttrs.wtDetails
                        if (iAttrs.wtObj) {
                            var obj=iAttrs.wtObj
                            setObj(scope,obj)

                            scope.$parent.$watch('vm.'+obj,function() {
                                setObj(scope,obj)
                            })
                        } else {
                            scope.obj={}
                            scope.obj[scope.field]=iAttrs.wtValue
                        }

                        if (iAttrs.wtLabel) {
                            scope.form.label[scope.field]=iAttrs.wtLabel
                        }
                        if (iAttrs.wtDescription) {
                            scope.form.description[scope.field]=iAttrs.wtDescription
                        }
                        if (iAttrs.wtNote) {
                            scope.form.note[scope.field]=iAttrs.wtNote
                        }
                        if (iAttrs.wtDisabled) {
                            scope.form.disabled[scope.field]=iAttrs.wtDisabled
                        }

                        if (scope.details) {
                            setValue(scope)
                        }
                    }
                }
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.wtDropdownButton',[])
        .controller('wtDropdownButtonController', Controller)
        .directive('wtDropdownButton', Directive);

    /** @ngInject */
    function Controller($scope, $document, $element)
    {
        $scope.toggleDropdown = function () {
            $scope.isDropdownOpen = !$scope.isDropdownOpen;
            
            if ($scope.isDropdownOpen) {
                // Get button and dropdown elements
                var button = $element[0].querySelector('button');
                var dropdown = $element[0].querySelector('.wt-dropdown-menu');
                
                // Get button position and dimensions
                var buttonRect = button.getBoundingClientRect();
                
                // Get viewport dimensions
                var viewportHeight = window.innerHeight;
                var viewportWidth = window.innerWidth;
                
                // Calculate available space below and above button
                var spaceBelow = viewportHeight - buttonRect.bottom;
                var spaceAbove = buttonRect.top;
                
                // Position dropdown
                dropdown.style.position = 'absolute';
                
                // Always align right edge with button
                dropdown.style.right = '0';
                dropdown.style.left = 'auto';
                
                // Set vertical position based on available space
                var minSpaceNeeded = 200; // Minimum pixels needed below button
                
                if (spaceBelow >= minSpaceNeeded) {
                    // Position below button if enough space
                    dropdown.style.top = '100%';
                    dropdown.style.bottom = 'auto';
                } else {
                    // Position above button if not enough space below
                    dropdown.style.bottom = '100%';
                    dropdown.style.top = 'auto';
                }
            }
        };
    
        function closeDropdown() {
            $scope.$apply(function () {
                $scope.isDropdownOpen = false;
            });
        }
    
        // Close the dropdown when clicking anywhere else on the document
        $document.on('click', function (event) {
            if ($scope.isDropdownOpen && !$element[0].contains(event.target)) {
                closeDropdown();
            }
        });
    
        // Use event delegation to handle clicks on items with the class "wt-dropdown-item"
        $element.on('click', '.wt-dropdown-item', function () {
            closeDropdown();
        });
        
    }

    /** @ngInject */
    function Directive()
    {
        return {
            restrict: 'E',
            scope: {
                'wt-button-text':'=',
                'wt-button-class':'=',
            },
            controller : 'wtDropdownButtonController as vm',
            templateUrl: 'app/main/directives/wt-dropdown-button/wt-dropdown-button.html',
            transclude : true,
            compile: function compile() {
                return {
                    post: function postLink(scope, iElement, iAttrs, Controller) {
                        var vm = scope.vm
                        scope.buttonText = iAttrs.wtButtonText
                        scope.buttonClass = iAttrs.wtButtonClass || 'btn btn-outline-primary'
                    }
                }
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.wtDomainStatusBadge',[])
        .controller('wtDomainStatusBadgeController', Controller)
        .directive('wtDomainStatusBadge', Directive);

    /** @ngInject */
    function Controller($scope, $translate, wtUtils)
    {
        var vm = this
        vm.get_reg_state = wtUtils.getDomainRegistrationState
        // console.log('scope', $scope)
        vm.obj = $scope.$parent.obj || $scope.$parent.$parent.obj // The domain attribute is available as an object, but at different "addresses" depending on context (list vs details etc.)
    }


    /** @ngInject */
    function Directive()
    {
        return {
            restrict: 'E',
            scope: {
                'wt-domain-obj': '<', // One way binding - read only
            },
            controller : 'wtDomainStatusBadgeController as vm',
            templateUrl: 'app/main/directives/wt-domain-status-badge/wt-domain-status-badge.html',
            transclude : true,
            compile: function compile() {
                return {
                    post: function postLink(scope, iElement, iAttrs) {
                        var vm=scope.vm
                        // console.log('iAttrs', iAttrs)
                        // console.log('vm', vm)
                    }
                }
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.wtBreadcrumbs',[])
        .controller('wtBreadcrumbsController', Controller)
        .directive('wtBreadcrumbs', Directive);

    /** @ngInject */
    function Controller($scope, $translate)
    {
        // ...
    }


    /** @ngInject */
    function Directive()
    {
        return {
            restrict: 'E',
            scope: {
                'wt-breadcrumbs':'=',
            },
            controller : 'wtBreadcrumbsController as vm',
            templateUrl: 'app/main/directives/wt-breadcrumbs/wt-breadcrumbs.html',
            transclude : true,
            compile: function compile() {
                return {
                    post: function postLink(scope, iElement, iAttrs) {
                        var breadcrumbs = angular.fromJson(iAttrs.wtBreadcrumbs); // Convert string to array
                        scope.breadcrumbs = breadcrumbs;
                    }
                }
            }
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.wtColumnConfig', [])
        .controller('wtColumnConfigController', Controller)
        .directive('wtColumnConfig', Directive);

    /** @ngInject */
    function Controller($scope, $document, $element, $cookies) {
        var COOKIE_EXPIRY_DAYS = 365;

        $scope.isOpen = false;

        $scope.toggleDropdown = function() {
            $scope.isOpen = !$scope.isOpen;
        };

        $scope.isColumnVisible = function(columnId) {
            return $scope.visibleColumns.indexOf(columnId) !== -1;
        };

        $scope.toggleColumn = function(column) {
            if (column.locked) {
                return;
            }

            var index = $scope.visibleColumns.indexOf(column.id);
            if (index !== -1) {
                $scope.visibleColumns.splice(index, 1);
            } else {
                $scope.visibleColumns.push(column.id);
            }

            saveToCookie();
            notifyChange();
        };

        $scope.resetToDefault = function() {
            $scope.visibleColumns = getDefaultColumns();
            saveToCookie();
            notifyChange();
        };

        function getDefaultColumns() {
            var defaults = [];
            angular.forEach($scope.columns, function(col) {
                if (col.locked || col.defaultVisible) {
                    defaults.push(col.id);
                }
            });
            return defaults;
        }

        function loadFromCookie() {
            var cookieValue = $cookies.get($scope.cookieKey);
            if (cookieValue) {
                try {
                    var parsed = JSON.parse(cookieValue);
                    if (Array.isArray(parsed)) {
                        // Validate that all IDs exist in column config
                        var validIds = $scope.columns.map(function(c) { return c.id; });
                        var filtered = parsed.filter(function(id) {
                            return validIds.indexOf(id) !== -1;
                        });
                        // Ensure locked columns are always included
                        angular.forEach($scope.columns, function(col) {
                            if (col.locked && filtered.indexOf(col.id) === -1) {
                                filtered.push(col.id);
                            }
                        });
                        return filtered;
                    }
                } catch (e) {
                    // Invalid cookie, use defaults
                }
            }
            return getDefaultColumns();
        }

        function saveToCookie() {
            var expiry = new Date();
            expiry.setDate(expiry.getDate() + COOKIE_EXPIRY_DAYS);
            $cookies.put($scope.cookieKey, JSON.stringify($scope.visibleColumns), {
                expires: expiry,
                domain: '.templ.io'
            });
        }

        function notifyChange() {
            if ($scope.onChange) {
                $scope.onChange({ columns: $scope.visibleColumns });
            }
        }

        function closeDropdown() {
            $scope.$apply(function() {
                $scope.isOpen = false;
            });
        }

        // Close dropdown when clicking outside
        $document.on('click', function(event) {
            if ($scope.isOpen && !$element[0].contains(event.target)) {
                closeDropdown();
            }
        });

        // Initialize
        $scope.$watch('columns', function(newVal) {
            if (newVal && newVal.length) {
                $scope.visibleColumns = loadFromCookie();
                notifyChange();
            }
        });

        // Cleanup
        $scope.$on('$destroy', function() {
            $document.off('click');
        });
    }

    /** @ngInject */
    function Directive() {
        return {
            restrict: 'E',
            scope: {
                columns: '=wtColumns',
                cookieKey: '@wtCookieKey',
                onChange: '&wtOnChange'
            },
            controller: 'wtColumnConfigController',
            templateUrl: 'app/main/directives/wt-column-config/wt-column-config.html'
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.helpPage',[])
        .controller('MyHelpPageController', MyHelpPageController)
        .directive('myHelpPage', MyHelpPageDirective);

    /** @ngInject */
    function MyHelpPageController($location,$rootScope,$scope,$timeout,$http)
    {
        console.log('alive');
        var vm = this;
        vm.help_frame = {
            id:'help-page-frame'
            //,initial:'wootemple-initial-setup-guide'
            //,initial:"/assets/test.html"
            ,posts:{}
            ,history:[]
            //,loading:true
        }
        vm.frames=[vm.help_frame]

        vm.initFrame = function (frame,container) {
            console.log('initFrame',container);
            if (!frame.container) {
                frame.container=container
                if(frame.initial) {
                    vm.loadPost(frame,frame.initial)
                    frame.history.push({slug:frame.initial})
                    frame.history_ix=0
                }
            }
        }

        vm.wp_post_api='https://wootemple.com/wp-json/wp/v2/posts?slug='
        vm.loadPost=function(frame,slug,hash) {
            if(!slug) { return }
            if (frame.posts[slug]) {
                return vm.display_post(frame,slug,hash)
            }
            frame.loading=true
            $http.get(vm.wp_post_api+slug).then(function(res) {
                var post=res.data[0]
                frame.posts[slug]=post;
                vm.display_post(frame,slug,hash)
            })
        }

        vm.push_history = function(frame,slug,hash) {
            frame.history_ix += 1
            while(frame.history.length>frame.history_ix) {
                frame.history.pop()
            }
            frame.history.push({slug:slug,hash:hash})
            console.log(frame.history[frame.history_ix]);
        }
        vm.scroll_to_hash=function(frame,hash) {
            var container=frame.container
            var scrollTop=0
            if(hash) {
                var elem=container.find(hash)
                scrollTop = elem.offset().top-container.offset().top+container.scrollTop()
            }
            container.animate({
                scrollTop: scrollTop
            })
            frame.current_hash=hash
        }
        vm.display_post=function(frame,slug,hash) {
            var post=frame.posts[slug]
            frame.container.html($('<h1 class="wp-post-title">').html(post.title.rendered))
            var content=$('<div class="wp-post-content">').html(post.content.rendered)
            $('a',content).click(function(ev) {
                //alert("clicked "+this)
                if(this.hostname!=$location.host()) {
                    window.open(this.href, '_blank');
                } else {
                    var slug=this.pathname.replace(/^\/+|\/+$/g, '');
                    if (slug && slug.length && slug!=frame.current) {
                        vm.loadPost(frame,slug,this.hash)
                        vm.push_history(frame,slug,this.hash)
                    } else if (this.hash) {
                        if(this.hash!=frame.current_hash) {
                            vm.push_history(frame,frame.current,this.hash)
                        }
                        vm.scroll_to_hash(frame,this.hash)
                    }
                }
                ev.preventDefault()
                return false
            })
            frame.container.append(content)
            if (slug && slug.length) {
                frame.current=slug
            }
            vm.scroll_to_hash(frame,hash)
            frame.loading=false
        }
        vm.load_history=function(frame) {
            var hitem=frame.history[frame.history_ix]
            console.log(hitem);
            if (hitem.slug && hitem.slug.length) {
                vm.loadPost(frame,hitem.slug,hitem.hash)
            } else if (hitem.hash) {
                vm.scroll_to_hash(frame,hitem.hash)
            } else {
                return
            }
        }
        vm.frame_back=function(frame) {
            if (!frame.loading && frame.history_ix>0) {
                frame.history_ix -= 1
                vm.load_history(frame)
            }
        }
        vm.frame_forward=function(frame) {
            if (!frame.loading && frame.history_ix<frame.history.length-1) {
                frame.history_ix += 1
                vm.load_history(frame)
            }
        }
        vm.frame_reload=function(frame) {
            console.log('reload',frame);
            if (!frame.current) {return}
            if (frame.posts[frame.current]) {
                delete frame.posts[frame.current]
            }
            vm.loadPost(frame,frame.current,frame.current_hash)
        }
    }


    /** @ngInject */
    function MyHelpPageDirective($mdMedia)
    {
        return {
            restrict   : 'E',
            scope: {
                host:'='
                ,https:'=?'
                ,initial:'=?'
            },
            controller : 'MyHelpPageController as vm',
            templateUrl: 'app/main/directives/help-page/templates/help-page.html',
            //templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            transclude : true,
            compile: function compile(tElement, tAttrs, transclude) {
                return {
                    post: function postLink(scope, iElement, iAttrs, controller) {
                        //console.log('postLink 2',scope,iElement,iAttrs,controller);
                        var vm=scope.vm
                        var host=iAttrs.host

                        if (host) {
                            vm.wp_post_api=(iAttrs.http && 'http://' || 'https://') + host + '/wp-json/wp/v2/posts?slug='
                            vm.help_frame.initial=iAttrs.initial
                        }

                        vm.initFrame(vm.help_frame,iElement.find('.help-page-container'))
                    }
                }
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        /*msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);*/
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    String.prototype.capitalize = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
    }
    /* Where to put these ? */
    Array.prototype.removeItem = function(item) {
        var a = this;
        var ix = a.indexOf(item);
        if (ix>=0) {
            a.splice(ix,1);
        }
    }

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                //'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            //require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));
            shortcuts=[]
            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    /*{
                        'title'      : 'WooPanel',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }*/
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }
                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }
                //debugger
                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
            //console.log('Result:',vm.results);
        }

        /**
         * Expand
         */
        function expand()
        {
            if (!vm.collapsed) return
            //debugger
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    if (vm.results) {
                        vm.handleResultClick(vm.results[vm.selectedResultIndex]);
                    }

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    expand(event);
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            //return
            if ( vm.ignoreMouseEvents )
            {
                return;
            }
            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                //debugger
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = {}//$mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return true;//sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        //sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren /* FIXME: || $mdMedia('gt-md') */)
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.wordpress', ['app.wooadmin'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,
        Models)
    {
        var model = Models['WPApp']
        var sub_data={
            //populate:['domain','operation']
        }
        var filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            }
        ]
        // State
        $stateProvider
            .state('app.'+model.name, {
                url    : '/'+model.name,
                redirectTo: 'app.'+model.name+'.list'
            })
            .state('app.'+model.name+'.list', {
                url    : '/list/:page',
                params : {page: null},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/wooadmin/models/modellist.html',
                        controller : 'WordpressListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    List: ['$stateParams','wtUtils',model.model,'WooModelListResolver',function(params,utils,app,resolver) {
                        return resolver(app,params,{
                            populate:['operation','app.name'],
                            filters:filters
                        })
                    }],
                    CountUnfiltered: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{
                            __count_only__:true
                        })
                    }]
                },
                data : {
                    form_type: 'user'
                    ,model:model
                    ,populate:['operation','app.name']
                    ,filters:filters
                }

            })
            .state('app.'+model.name+'.processing', {
                url     : '/updating/:id',
                params  : {id:null},
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'WordpressProcessingController',
                        controllerAs:'vm'
                    }
                },
                resolve: {
                    Object:[
                        '$stateParams',model.model,'WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{
                                //populate:['operation','domain']
                            })
                        }
                    ]
                },
                data: sub_data
            })
            .state('app.'+model.name+'.update', {
                url     : '/update/:id/:app',
                params  : {id:null},
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'WordpressUpdateController',
                        controllerAs:'vm'
                    }
                },
                resolve: {
                    Object:[
                        '$stateParams',model.model,'WooModelResolver',
                        function(params,m,resolver) {
                            //debugger
                            if (params.id) {
                                return resolver(m,params,{})
                            }
                            var appid=params.app && parseInt(params.app)
                            if(typeof appid == 'number') {
                                return m.query({app:appid,user:'all'},{}).$promise
                            }
                        }
                    ],
                    Site:['Object','WooModelResolver','WooApp',function(wpapp,resolver,m) {
                        //wpapp = wpapp && wpapp.docs && wpapp.docs[0] || wpapp
                        return resolver(m,{id:wpapp.app},{select:['name','stages'],fill:['stages']})
                    }]
                },
                data: sub_data
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/wordpress');

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.wordpress')
        .controller('WPObjectListController',  list)
        //.controller('IncidentEditController', EditController)
        .controller('WPObjectController', details)
        .controller('WPSitesController',sites)
    /** @ngInject */
    function list($scope, $rootScope, $state, List, WPObject,CountUnfiltered, WooModelListController) {
            //ctrl,scope,rootScope,state,res,m,count)
        var vm = this;
        vm.scope=$scope
        vm.rootScope=$rootScope
        vm.nof_objects_unfiltered=CountUnfiltered && CountUnfiltered.count||0
        vm.api=WPObject; vm.res=List;
        vm.no_create=1
        vm.prefix='WPOBJECT.'
        vm.empty_title=vm.prefix+'EMPTY_TITLE'
        vm.empty_text=vm.prefix+'EMPTY_TEXT'
        var data=$state.current.data
        data.substates = {edit:'app.wpobject.details'}
        WooModelListController(vm,$state.current.data)

        vm.Title=vm.translate(vm.prefix+'LIST_TITLE')

        vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
        vm.list.filters=$state.current.data.filters

    }
    function details($scope, $state, wtUtils, WPObject, WooModelEditController, Object,Count) {
        if (!Object) return
        if (Object.docs) {
            //debugger
            Object=Object.docs && Object.docs[0]
            if (!Object) return
            return $state.go($state.current.name,{id:Object._id,app:null},{location:'replace'})
        }
        var vm=this;
        vm.prefix='WPOBJECT'
        vm.count=Count&&Count.count
        vm.content='app/main/layouts/wt-details-content.html'
        vm.details_template='app/main/wordpress/wpobject.html'
        vm.no_buttons=true
        vm.no_edit=true; vm.no_delete=true
        vm.Object=Object
        vm.id=Object._id
        vm.title=vm.prefix+".DETAILS_TITLE"
        vm.scope=$scope
        vm.api=WPObject

        WooModelEditController(vm,$state.current.data.back_state)
        wtUtils.detailsController(vm,$state)
    }
    function sites($scope, $rootScope, $state, WPApp, wtUtils, Object,
        WooModelListController, Count, $filter, List)
    {
        var vm = this;
        vm.scope=$scope
        vm.rootScope=$rootScope
        vm.nof_objects_unfiltered=Count && Count.count||0
        vm.api=WPApp; vm.res=List;
        vm.no_create=1
        vm.prefix='SITES.'
        vm.empty_title=vm.prefix+'EMPTY_TITLE'
        vm.empty_text=vm.prefix+'EMPTY_TEXT'
        var data=$state.current.data
        data.substates = {edit:'app.wordpress.update'}
        WooModelListController(vm,data)

        vm.list.headers=[
            {name:'Name',class:'name'},
            {name:'#Vulnerabilities',class:'status'},
            //{name:"Severity",class:'status'}
        ]
        vm.list.tableClass='website-list'
        vm.Title=vm.translate(vm.prefix+'LIST_TITLE')
        vm.list.item_template='app/main/vulns/site_list_item.html'

        vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
        //vm.list.filters=$state.current.data.filters
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.wordpress')
        .controller('WordpressListController',  [
            'WooModelListController','$scope', '$rootScope', '$state',  'List', 'WPApp','CountUnfiltered',
            ListController])
        //.controller('IncidentEditController', EditController)
        .controller('WordpressUpdateController', UpdateController)
        .controller('WordpressProcessingController', ProcessingController)

    /** @ngInject */
    function ListController(ctrl,scope,rootScope,state,res,m,count) {
        var vm = this;
        vm.scope=scope
        vm.rootScope=rootScope
        vm.nof_objects_unfiltered=count && count.count||0
        vm.api=m; vm.res=res;
        vm.no_create=1
        vm.prefix='WORDPRESS.'
        vm.empty_title=vm.prefix+'EMPTY_TITLE'
        vm.empty_text=vm.prefix+'EMPTY_TEXT'
        var data=state.current.data
        data.substates = {edit:'app.wordpress.update'}
        ctrl(vm,state.current.data)

        vm.Title=vm.translate(vm.prefix+'LIST_TITLE')

        vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
        vm.list.filters=state.current.data.filters

    }
    function UpdateController($scope, $state, wtUtils, WPApp,
        WebsiteCopyFrom, WooModelEditController, Object,Site
    ) {
        if (!Object) return
        if (Object.docs) {
            //debugger
            Object=Object.docs && Object.docs[0]
            if (!Object) return
            return $state.go($state.current.name,{id:Object._id,app:null},{location:'replace'})
        }
        var vm=this;
        vm.prefix='WORDPRESS'
        vm.content='app/main/layouts/wt-details-content.html'
        vm.details_template='app/main/wordpress/wordpress-update.html'
        vm.no_buttons=true
        vm.no_edit=true; vm.no_delete=true
        vm.Object=Object
        vm.id=Object._id
        vm.version=Object.version
        vm.plugs=Object.plugs
        vm.themes=Object.themes
        vm.title=vm.prefix+".DETAILS_TITLE"
        vm.scope=$scope
        vm.api=WPApp
        vm.selected={ plugs:{}, themes:{}}
        vm.form_obj=vm.copy_from={
            //partial:true
        }
        var stages=Site && Site.stages && Site.stages.map(function(s) { return {value:s._id,name:s.name}})||[]
        var name = Site && Site.name
        if (name) {
            name=name+' '+moment().format('YYYY-MM-DDTHH:m')
        }
        vm.staging={
            app:Object.staging_app||stages[0]&&stages[0].value||-1,
            name:name
        }
        stages.push({value:-1,name:'WORDPRESS.STAGING.NEW_STAGING'})
        vm.scope.$watch('vm.staging.app',function(val) {
            //TODO: Use the copy_from of selected app.
        })
        vm.staging_form={
            fields:['app','enabled','name'],
            type:{app:'select',enabled:'checkbox'},
            values:{
                app:stages
            },
            optional:{name:1}
        }
        wtUtils.addFormLabels('WORPDPRESS.STAGING',vm.staging_form,['note'])

        WooModelEditController(vm,$state.current.data.back_state)
        wtUtils.detailsController(vm,$state)
        WebsiteCopyFrom(vm)
        vm.update=function() {
            if(vm.staging.enabled) {
                var staging=vm.copy_from
                if (vm.staging.app>0) staging.app=vm.staging.app
                staging.name=vm.staging.name
                vm.selected.staging=staging
            }
            Object.do_update=vm.selected
            Object.$save({obj_id:Object._id},function() {
                $state.go('app.wordpress.processing',{id:Object._id})
            })
        }
    }

    function ProcessingController(WooModelEditController,WPApp,wtUtils,$scope,$state,Object) {
        var vm = this;

        vm.layout='app/main/layouts/wt-processing.html'
        vm.scope=$scope
        vm.api=WPApp
        vm.Object=Object
        vm.op=Object.operation
        vm.title=wtUtils.processing_title(vm.op)||'WORDPRESS.PROCESSING'
        var data={
            populate:['operation']
        }
        vm.continue=function() {
            $state.go('app.website.details',{id:vm.Object.app})
        }
        WooModelEditController(vm,data)
        //debugger
        //vm.title="Creating Website"
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.website', ['app.options','app.graphs'])
        .config(config)

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $translatePartialLoaderProvider.addPart('app/main/website');
        $translatePartialLoaderProvider.addPart('app/main/website/newdesign');
        msApiProvider.register('pricing',['api/woopricing?is_default=true&populate=discounts&page_size=-1'])
        msApiProvider.register('blueprints',['api/blueprints'])
        //msApiProvider.register('blueprints',['app/data/blueprints/blueprints.json'])

        var filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            },
            {
                name:'appType',label:'WEBSITE.FILTER.APP_TYPE',field:'app_class',kind:'select',options:[]
            },
            {
                name:'plan',label:'WEBSITE.FILTER.PLAN',field:'pcode',kind:'select',options:[]
            },
            {
                name:'location',label:'WEBSITE.FILTER.LOCATION',field:'lcode',kind:'select',options:[]
            }
        ]

        var tops=['app','appf']
        var subs = {
            list: {
                url: '/list/:page',
                params : {page: null},
                view: {
                    templateUrl: 'app/main/wooadmin/models/modellist.html',
                    controller : 'WebsiteListControlller',
                    controllerAs: 'vm'
                },
                resolve: {
                    List: ['$stateParams','wtUtils','WooApp','WooModelListResolver','$cookies',function(params,utils,app,resolver,$cookies) {
                        var f = utils.getCached('app.website.list')||filters
                        // Load sort preference from cookie
                        var sort = '-created'; // default: newest first
                        var sortCookie = $cookies.get('templ_website_sort');
                        if (sortCookie) {
                            try {
                                var sortPref = JSON.parse(sortCookie);
                                if (sortPref && sortPref.field) {
                                    sort = (sortPref.order || '') + sortPref.field;
                                }
                            } catch (e) {}
                        }
                        return resolver(app,params,{
                            populate:['operation','location','plan']
                            ,filters:f
                            ,query:{sort:sort}
                        })
                    }],
                    CountUnfiltered: ['$stateParams','WooApp','WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{
                            __count_only__:true
                        })
                    }],
                    Pricing: ['msApi','AuthService',function(msApi,auth) {
                        return msApi.resolve('pricing@get',{user:auth.selectedUser()})
                    }],
                    Translations: ['MyTranslations',function(MyTranslations) {
                        return MyTranslations(['WEBSITE.EMPTY_IMAGE'])
                    }]
                },
                data : {
                    form_type: 'user'
                    ,populate: ['location','plan','operation']
                    ,filters:filters
                    /*,Title:{
                        name:'Websites',top:true
                    }*/
                }
            },
            copyToApp : {
                url    : '/copy-app/:src/:id',
                params : {src: null, id:null },
                view : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'WebsiteCopyToAppController',
                    controllerAs: 'vm'
                },
                resolve: {
                    Src:[
                        '$stateParams','WooApp','WooModelResolver',
                        function($stateParams,WooApp,WooModelResolver) {
                            //debugger
                            return WooModelResolver(WooApp,{id:$stateParams.src},{})
                        }
                    ],
                    Dst:[
                        '$stateParams','WooApp','WooModelResolver',
                        function($stateParams,WooApp,WooModelResolver) {
                            //debugger
                            return WooModelResolver(WooApp,{id:$stateParams.id},{})
                        }
                    ],
                    Apps:[
                        '$stateParams','WooApp','AuthService',
                        function($stateParams,WooApp,auth) {
                            //debugger
                            if ($stateParams.id && $stateParams.src) {
                                return null
                            }
                            return WooApp.query({user:auth.selectedUser(),page_size:-1,select:['name','_id']}).$promise
                        }
                    ]
                }
            },

            createStaging : {
                url    : '/create-staging/:live_app',
                params : {live_app: null},
                view : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'WebsiteCreateStagingController',
                    controllerAs: 'vm'
                },
                resolve: {
                    Live:[
                        '$stateParams','WooApp','WooModelResolver',
                        function($stateParams,WooApp,WooModelResolver) {
                            return WooModelResolver(WooApp,{id:$stateParams.live_app},{populate:['location','plan']})
                        }
                    ]
                }
            },

            create : {
                url    : '/create/:from/:clone',
                params : {from: null,clone:null},
                view : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'WebsiteCreateController',
                    controllerAs: 'vm'
                },
                resolve: {

                    UserInfo: [
                        'UserInfo', function (info) {
                            return info();
                        }
                    ],

                    Form: [
                        '$stateParams','WooApp','WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'simple',paginate_values:10})
                        }
                    ],
                    Pricing: ['msApi', 'AuthService', function (msApi,auth) {
                        return msApi.resolve('pricing@get',{user:auth.selectedUser()})
                    }],
                    Billing: ['msApi','AuthService', function (msApi,auth)
                    {
                        return  msApi.resolve('userBilling@get',{create_missing:1,user:auth.selectedUser()})
                    }],
                    CopyFrom:[
                        '$stateParams','WooApp','WooModelResolver',function(params,m,resolver) {
                            return resolver(m,{id:params.clone},{select:['name','_id','pcode','lcode']})
                        }
                    ],
                    Blueprints:['msApi','AuthService',function(msApi,auth) {
                        return msApi.resolve('blueprints@get',{user:auth.selectedUser()})
                    }]
                }
            },

            migrate : {
                url    : '/migrate/:id',
                params : {id:null},
                view : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'WebsiteMigrateController',
                    controllerAs: 'vm'
                },
                resolve: {

                    UserInfo: [
                        'UserInfo', function (info) {
                            return info();
                        }
                    ],

                    Form: [
                        '$stateParams','WooApp','WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'simple',paginate_values:10})
                        }
                    ],
                    Obj:[
                        '$stateParams','WooApp','WooModelResolver',function(params,m,resolver) {
                            if (params.id) return resolver(m,params,{populate:['operation','location','plan']})
                        }
                    ],
                    Pricing: ['msApi', 'AuthService', function (msApi,auth) {
                        return msApi.resolve('pricing@get',{user:auth.selectedUser()})
                    }],
                    Billing: ['msApi','AuthService', function (msApi,auth)
                    {
                        return  msApi.resolve('userBilling@get',{create_missing:1,user:auth.selectedUser()})
                    }]
                }
            },

            upgrade : {
                url    : '/upgrade/:id',
                params  : {id:null},
                view  : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'WebsiteUpgradeController',
                    controllerAs: 'vm'
                },
                resolve: {
                    Obj:[
                        '$stateParams','WooApp','WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation','location','plan']})
                        }
                    ],
                    Upgrade:[
                        'Obj','WooUpgrade','WooModelResolver',function(Obj,WooUpgrade,WooModelResolver) {
                            return WooModelResolver(WooUpgrade,{id:Obj.upgrade},{populate:['location','plan']})
                        }
                    ],
                    Form: [
                        '$stateParams','WooApp','WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'simple',paginate_values:10})
                        }
                    ],
                    UserInfo: [
                        'UserInfo', function (info) {
                            return info();
                        }
                    ],
                    Pricing: ['msApi', 'AuthService', function (msApi,auth) {
                        return msApi.resolve('pricing@get',{user:auth.selectedUser()})
                    }],
                    Billing: ['msApi','AuthService', function (msApi,auth)
                    {
                        return  msApi.resolve('userBilling@get',{create_missing:1,user:auth.selectedUser()})
                    }]
                }
            },
            processing: {
                url    : '/processing/:id',
                view  : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'WebsiteProcessingController',
                    controllerAs: 'vm'
                },
                resolve: {
                    Obj:[
                        '$stateParams','WooApp','WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation','location','plan']})
                        }
                    ],
                    UserInfo: [
                        'UserInfo', function (info) {
                            return info();
                        }
                    ],
                }
            },
            edit: {
                url    : '/edit/:id',
                view  : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'WebsiteEditController',
                    controllerAs: 'vm'
                },
                resolve: {
                    Obj:[
                        '$stateParams','WooApp','WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation','location','main_app','plan']})
                        }
                    ],
                    Form:[
                        '$stateParams','WooApp','WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'user',paginate_values:20})
                        }
                    ],
                    UserInfo: [
                        'UserInfo', function (info) {
                            return info();
                        }
                    ],
                },
                data: {
                    populate:['operation','location','plan']
                }
            },
            relocate: {
                url    : '/relocate/:id',
                view  : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'WebsiteRelocateController',
                    controllerAs: 'vm'
                },
                resolve: {
                    Obj:[
                        '$stateParams','WooApp','WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation','location','plan']})
                        }
                    ],
                    Form:[
                        '$stateParams','WooApp','WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'simple'})
                        }
                    ],
                    UserInfo: [
                        'UserInfo', function (info) {
                            return info();
                        }
                    ],
                    Pricing: ['msApi', 'AuthService', function (msApi,auth) {
                        return msApi.resolve('pricing@get',{user:auth.selectedUser()})
                    }],
                    Billing: ['msApi','AuthService', function (msApi,auth)
                    {
                        return  msApi.resolve('userBilling@get',{create_missing:1,user:auth.selectedUser()})
                    }]
                },
                data: {
                    populate:['operation','location','plan']
                }
            },
            import: {
                url    : '/import/:id',
                view  : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'WebsiteImportController',
                    controllerAs: 'vm'
                },
                resolve: {
                    Obj:[
                        '$stateParams','WooApp','WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation','location','plan']})
                        }
                    ],
                    Links:[
                        'WooLinks',function(links) {
                            return links()
                        }
                    ],
                    UserInfo: [
                        'UserInfo', function (info) {
                            return info();
                        }
                    ],
                },
                data: {
                    populate:['operation','location','plan']
                }
            },
            backup: {
                url    : '/backup/:id',
                Title: 'Create Backup',
                view  : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'WebsiteBackupController',
                    controllerAs: 'vm'
                },
                resolve: {
                    Obj:[
                        '$stateParams','WooApp','WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation','location','plan']})
                        }
                    ],
                    Links:[
                        'WooLinks',function(links) {
                            return links()
                        }
                    ]
                }
            },
            blueprint: {
                url    : '/blueprint/:id',
                Title: 'Create Blueprint',
                view  : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'WebsiteBlueprintController',
                    controllerAs: 'vm'
                },
                resolve: {
                    Obj:[
                        '$stateParams','WooApp','WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation','location','plan']})
                        }
                    ],
                    Links:[
                        'WooLinks',function(links) {
                            return links()
                        }
                    ]
                }
            },

            restore: {
                url    : '/restore/:id',
                Title: 'Restore Backup',
                view  : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'WebsiteRestoreController',
                    controllerAs: 'vm'
                },
                resolve: {
                    Obj:[
                        '$stateParams','WooApp','WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation','location','plan']})
                        }
                    ],
                    Links:[
                        'WooLinks',function(links) {
                            return links()
                        }
                    ],
                    Backup: [
                        'WooBackup', 'AuthService', 'Obj',function(b,auth,obj) {
                            if (obj&&obj._id) {
                                return b.query({populate:['app._id','app.name'],app:obj._id, user:auth.selectedUser(),page:1,page_size:1}).$promise
                            }
                            return null
                        }
                    ],
                    Backups: [
                        'WooBackup', 'AuthService', 'Obj', 'Backup',  function(b,auth,app,backup) {
                            var args={populate:['app._id','app.name'],user:auth.selectedUser(),page:1,page_size:10}
                            if(app.restore_backup&&app.restore_backup.backup&&app.restore_backup.backup!=(backup&&backup._id)) {
                                args.page_size=1
                                args._id=app.restore_backup.backup
                            }
                            return b.query(args).$promise
                        }
                    ]
                },
                data: {
                    populate:['operation','location','plan'],
                }
            }
        }

        for (var top in tops) {
            top = tops[top]
            var name= top +'.website'
            var prefix=name+'.'

            $stateProvider
                .state(name, {
                    url        :  '/website',
                    redirectAfter :  prefix+'list',
                    redirectAlwaysEnter: true,
                    data:{
                        //Title: "Website"
                    }
                })

            for (var sub in subs) {
                var subdef=subs[sub]
                var views={}
                views['content@'+top]=subdef.view
                $stateProvider
                    .state(prefix+sub, {
                        url    : subdef.url,
                        views  : views,
                        resolve: subdef.resolve,
                        data   : subdef.data
                    })
            }
        }
        $stateProvider.state('app.website.details',{
            url    : '/details/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/website/details-wrapper.html',
                    controller : 'WebsiteDetailsController',
                    controllerAs: 'vm'
                },
                'advanced_options@app.website.details': {
                    templateUrl: 'app/main/website/newdesign/options.html',
                    controller : 'AdvancedController as vm'
                },
                'site_stats@app.website.details': {
                    templateUrl: 'app/main/website/newdesign/graphs.html',
                    controller : 'WebsiteStatsController as vm'
                }
            },
            resolve: {
                Obj:[
                    '$stateParams','WooApp','WooModelResolver',function(params,m,resolver) {
                        return resolver(m,params,{
                            populate:['operation','host','location','plan','backup_schedules','live_app.ssh_password','main_app','staging_app','container.manager.domainn','server.ip4']
                            ,fill:'incidents'
                        })
                    }
                ],
                Form:[
                    '$stateParams','WooApp','WooFormResolver',function(params,m,resolver) {
                        return resolver(m,params,{form_type:'details'})
                    }
                ],
                UserInfo: [
                    'UserInfo', function (info) {
                        return info();
                    }
                ],
                Options: function (msApi)
                {
                    return msApi.resolve('appoptions@get');
                },
                OptionGroups: function (msApi)
                {
                    return msApi.resolve('appoptiongroups@get');
                }
            },
            data: {
                populate:['operation','location','host','plan','backup_schedules','live_app.ssh_password','main_app','staging_app','container.manager.domainn']
                ,fill:'incidents'
            }
        })

        /**/
    }
})();

(function()
{
    angular
        .module('app.website')
        .controller('WebsiteStatsController',controller)

    function controller($scope,$q,$http,$location,$cookies,Obj,AuthService,UserInfo,GraphController0) {
        var vm=this
        this.selected_user=Obj && Obj.user
        //this.testing_options=true
        this.ranges=[
            {value:-300,name:'GRAPHS.5M'},
            {value:-3600,name:'GRAPHS.1H'},
            {value:-21600,name:'GRAPHS.6H'},
            {value:-43200,name:'GRAPHS.12H'},
            {value:-86400,name:'GRAPHS.24H'}
        ]

        GraphController0.call(this,$scope,$q,$http,$cookies,[Obj],AuthService,UserInfo,{
            skip_initial_load:true
        })
        if(vm.isAdmin) {
            this.ranges.push({value:-3*86400,name:'GRAPHS.3DAYS'})
            this.ranges.push({value:-7*86400,name:'GRAPHS.7DAYS'})
            this.ranges.push({value:-14*86400,name:'GRAPHS.14DAYS'})
            this.ranges.push({value:-30*86400,name:'GRAPHS.30DAYS'})
        }
        $scope.$watch(function() {
            return $location.hash()
        },
        function () {
            //debugger
            //console.log('hash changed',$location.hash());
            var hash=$location.hash() || 'overview'
            if(hash=='stats') {
                vm.start();
                //setTimeout(function(){ vm.start(); },100);
            }
        })
        $scope.$watch('vm.after',function () {
            vm.start()
        })
    }


})();

(function()
{
    angular
        .module('app.website')
        .controller('WebsiteRestoreController',restore)

    function restore(BackupLoader,wtUtils,WooApp,$scope,$state,WooModelEditController,Obj,Links,Backup,Backups) {
        var vm = this;
        vm.layout='app/main/website/website-restore.html'
        vm.scope=$scope
        vm.api=WooApp
        vm.restore_backup=vm.form_obj=Obj.restore_backup||{}
        vm.Object=Obj
        vm.restore_backup.remote = true; // Set remote to true by default
        vm.Form = {
            fields:["backup","remote","local_name","remote_name"],
            type:{backup:"ui-select",remote:"checkbox",remote_name:"ui-select",local_name:"ui-select"},
            values:{
                backup:[]
            },
            hidden:{
                local_name:vm.restore_backup.remote,
                remote_name:!vm.restore_backup.remote
            },
            optional:{
                local_name:vm.restore_backup.remote,
                remote_name:!vm.restore_backup.remote
            }
            ,help_link:Links.app.restore && Links.app.restore.help_link
        }
        wtUtils.addFormLabels('WEBSITE.RESTORE',vm.Form)
        vm.backups={}
        var vals=[];//vm.Form.values.backup
        _.each(Backups && Backups.docs||[],function(b) {
            if(b.app && b.app._id && Obj && b.app._id==Obj._id) return
            vm.backups[b._id]=b
            vals.push({name:b.get_name(),value:b._id})
        })

        if(Backup && Backup.docs && Backup.docs.length) {
            var b=Backup.docs[0]
            vals.unshift({name:b.get_name(),value:b._id})
            vm.backups[b._id]=b
            if(!vm.restore_backup.backup) vm.restore_backup.backup=b._id
        }

        // Reverse the order of the remote backups
        _.each(vm.backups, function(website) {
            website.remotes.reverse();
        });

        var loader=BackupLoader
        var docs = {
            user:Obj&&Obj.user,
            page_size:10,
            docs:vals,
            search:'',
            select:['name','app','remotes','locals'],
            populate:['app._id','app.name'],
            res:function(res) {
                var l=[]
                angular.forEach(res,function(b) {
                    vm.backups[b._id]=b
                    l.push({name:b.get_name(),value:b._id})
                })
                return l
            }
        }
        if(Backups && Backups.limit>1) {
            docs.page=Backups.page; docs.total_pages=Backups.pages
        }
        vm.Form.refresh={backup:function refresh_domains(search,scrolling) {
            loader(docs,search,scrolling)
        }}
        vm.Form.values.backup=docs
        vm.Form.type.backup='ui-select'


        var obj=vm.restore_backup
        //debugger
        obj.partial=obj.exclude_db || obj.exclude_files || !obj.exclude_files && obj.files && true
        if (obj.files && obj.files.length>0) {
            obj.files_text=obj.files.join('\n')
        }

        var data={
            next_state : {save:wtUtils.siblingState($state,'.processing')}
        }
        vm.continue=function() {
            var obj=vm.restore_backup
            obj.completed=false
            delete obj.files
            delete obj.tables
            if (!obj.partial) {
                delete obj.exclude_files
                delete obj.exclude_db
            } else {
                if (obj.files_text && obj.files_text.trim()) {
                    obj.files=obj.files_text.split(/\r?\n/)
                } else {
                    obj.files=[]
                }
            }

            vm.obj.restore_backup=obj
            wtUtils.confirm({
                title:"WEBSITE.RESTORE.CONFIRM_TITLE",
                text:"WEBSITE.RESTORE.CONFIRM_TEXT",
                ok:"UTILS.CONTINUE"
                //,focus:'ok'
            },function() {
                vm.save()
            })
        }

        function update() {

            //console.log("Updated",vm.restore_backup);
            if (vm.isSaving) {return}
            var b = vm.backups[vm.restore_backup.backup]
            if(!b) return
            vm.restore_backup.remote_name=null
            vm.restore_backup.local_name=null
            vm.Form.values.remote_name=_.map(b.remotes,function(r) {return r.name})
            vm.Form.values.local_name=_.map(b.locals,function(r) {return r.name})
            if (vm.restore_backup.remote) {
                 vm.form.hidden.local_name=true
             } else {
                 vm.form.hidden.local_name=false
             }
             vm.form.optional.local_name=vm.form.hidden.local_name
             vm.form.hidden.remote_name=!vm.form.hidden.local_name
             vm.form.optional.remote_name=!vm.form.hidden.local_name
             vm.restore_backup.app= b.app&&b.app._id
        }

        vm.title="WEBSITE.RESTORE.TITLE"
        vm.breadcrumbs=[
            {label:"BREADCRUMBS.WEBSITES", url: $state.href('app.website.list')},
            {label:Obj.name, url: $state.href('app.website.details', {id: Obj._id})},
            {label:"BACKUP", url: $state.href('app.website.details', {id: Obj._id}) + '#backup'},
            {label:"BREADCRUMBS.RESTORE_BACKUP"}
       ]
         vm.helpUrl="https://docs.templ.site/websites/backups/restore-a-backup"
        vm.partial_title="WEBSITE.PARTIAL_RESTORE.TITLE"
        vm.partial_description="WEBSITE.PARTIAL_RESTORE.DESCRIPTION"
        vm.partial_label="WEBSITE.PARTIAL_RESTORE.LABEL"
        vm.partial_db_description="WEBSITE.PARTIAL_RESTORE.DB_DESCRIPTION"
        vm.partial_files_exclude="WEBSITE.PARTIAL_RESTORE.FILES_EXCLUDE"
        vm.partial_files_include="WEBSITE.PARTIAL_RESTORE.FILES_INCLUDE"
        vm.partial_files_note="WEBSITE.PARTIAL_RESTORE.FILES_NOTE"

        WooModelEditController(vm,data)

        vm.scope.$watch('vm.restore_backup.backup',update)
        vm.scope.$watch('vm.restore_backup.remote',update)
        vm.editing=false
    }

})();

(function()
{
    angular
        .module('app.website')
        .controller('WebsiteCreateStagingController',createStaging)
        .controller('WebsiteCopyToAppController',copyToApp)

    function createStaging(wtUtils,$state,WooModelEditController,WooApp,Live, WebsiteCopyFrom) {
            var vm = this;
            //vm.layout='app/main/website/website-processing.html'
            //vm.processing_title="WEBSITE.CREATE_STAGING.PROCESSING_TITLE"
            vm.api=WooApp
            WooModelEditController(vm,{})
            vm.editing=false
            vm.translate_values=vm.translate_values||{}
            vm.translate_values.live_name=Live.name
            var obj=vm.obj
            obj.user=Live.user
            obj.app_class="staging"
            obj.copy_from={
                app:Live._id,
                completed:false
            }
            vm.copy_from=vm.form_obj=obj.copy_from

            vm.layout='app/main/website/website-copy.html'
            vm.title="WEBSITE.CREATE_STAGING.TITLE"
            vm.breadcrumbs=[
                {label:"BREADCRUMBS.WEBSITES", url: $state.href('app.website.list')},
                {label:Live.name, url: $state.href('app.website.details', {id: Live._id})},
                {label:"STAGING", url: $state.href('app.website.details', {id: Live._id}) + '#staging'},
                {label:"BREADCRUMBS.CREATE_STAGING"}
            ]
            WebsiteCopyFrom(vm)
            vm.continue=function () {
                vm.copy_continue()
                vm.save(function(res) {
                    return wtUtils.gotoState($state,'.processing',{id:res._id},{location:'replace'})()
                })
            }
    }


    function copyToApp($window,wtUtils,$state,$scope,WooModelEditController,WooApp,Src,Dst,Apps,WebsiteCopyFrom) {
        var vm = this;
        //vm.layout='app/main/website/website-processing.html'
        //vm.processing_title="WEBSITE.CREATE_STAGING.PROCESSING_TITLE"
        if (!Src || !Dst) {
            var apps=_.map(Apps.docs,function(app) { return {name:app.name, value:app._id}})
            apps=_.filter(apps,function(app) {return app.value != (Src&&Src._id || Dst&&Dst._id)})
            //debugger
            vm.form={
                fields:['app'],
                type:{app:'select'},
                label:{
                    app: Src && 'WEBSITE.CLONE.SELECT_DESTINATION' || 'WEBSITE.CLONE.SELECT_SOURCE'
                },
                values:{
                    app:apps
                }
            }
            vm.translate_values={
                src_name:Src && Src.name || '?',
                dst_name:Dst && Dst.name || '?'
            }
            vm.form.description = {
                app: Src && 'WEBSITE.CLONE.DESTINATION_DESCRIPTION' || 'WEBSITE.CLONE.SOURCE_DESCRIPTION'
            }
            vm.continue_button='WEBSITE.CLONE.CONTINUE_BUTTON'
            vm.obj={  }
            vm.layout='app/main/website/website-copy-select-app.html'
            vm.title="WEBSITE.CLONE.TITLE"
            vm.breadcrumbs=[
                {label:"BREADCRUMBS.WEBSITES", url: $state.href('app.website.list')},
                {label:Src.name, url: $state.href('app.website.details', {id: Src._id})},
                {label:"IMPORT_MENU_TITLE", url: $state.href('app.website.details', {id: Src._id}) + '#import'},
                {label:"BREADCRUMBS.CLONE_TO_EXISTING_APP"}
            ]

            function select_app(app) {
                //debugger
                if (!app) { return}
                var args=Src && {src:Src._id, id:app} || {src:app, id:Dst && Dst._id}
                $state.go('app.website.copyToApp',args,{reload:true,location:'replace'})
            }
            //$scope.$watch('vm.obj.app',select_app)
            vm.cancel=function() {
                $window.history.back()
            }
            vm.continue=function() {
                select_app(vm.obj.app)
            }
            return
        }
        vm.api=WooApp
        vm.scope=$scope
        vm.Object=Dst
        WooModelEditController(vm,{})
        vm.translate_values.src_name=Src.name
        vm.translate_values.dst_name=Dst.name

        var obj=vm.obj
        obj.copy_from=obj.copy_from||{}
        Object.assign(obj.copy_from,{
            app:Src._id,
            completed:false,
            incremental:true
        })

        vm.copy_from=vm.form_obj=obj.copy_from
        //debugger
        obj=vm.copy_from
        obj.partial = !!(obj.exclude_db || obj.exclude_files || (!obj.exclude_files && obj.files));
        if (obj.files && obj.files.length>0) {
            obj.files_text=obj.files.join('\n')
        }

        vm.editing=false
        WebsiteCopyFrom(vm)
        vm.continue=function () {
            wtUtils.confirm({
                title:"WEBSITE.COPY.CONFIRM_TITLE",
                text:"WEBSITE.COPY.CONFIRM_TEXT",
                args:{name:Dst.name},
                ok:"UTILS.CONTINUE"
            },function() {
                vm.copy_continue()
                vm.save(function(res) {
                    return wtUtils.gotoState($state,'.processing',{id:res._id},{location:'replace'})()
                })
            })
        }
        vm.layout='app/main/website/website-copy.html'
        vm.title="WEBSITE.COPY_FROM.TITLE"
        // Below disabled because used in two different contexts: copy between staging <-> production & clone between two apps
        // ... Couldn't not figure out how to get the context here...
        // vm.copy_direction = Src.app_class == 'staging' ? 'FROM_STAGING' : 'TO_STAGING'
        // vm.breadcrumbs=[
        //     {label:"BREADCRUMBS.WEBSITES", url: $state.href('app.website.list')},
        //     {label:Src.name, url: $state.href('app.website.details', {id: Src._id})},
        //     {label:"STAGING", url: $state.href('app.website.details', {id: Src._id}) + '#staging'},
        //     {label:"BREADCRUMBS.COPY."+vm.copy_direction}
        // ]
        vm.continue_button='WEBSITE.COPY.CONTINUE_BUTTON'
    }


})();

(function()
{
    angular
        .module('app.website')
        .factory('GetAPs', ['$window', '$location', getAPs ])
        .controller('WebsiteCreateController',create)
        .controller('WebsiteMigrateController',migrate)
        .controller('WebsiteUpgradeController',upgrade)
        .controller('WebsiteProcessingController',processing)
        .controller('WebsiteListControlller', [
           'WooModelListController','$scope', '$rootScope', '$state', 'List', 'WooApp',
           'GetAPs', 'CountUnfiltered', 'wtUtils', '$cookies', 'Pricing', 'WooModelListResolver', list
        ])
        .controller('WebsiteDetailsController',[
            '$window','$location','$translate','wtUtils',
            'WooModelEditController','$scope', '$state', 'Obj', 'Form',
            'WooApp','GetAPs', 'UserCommand', 'ChatService', '$uibModal', details
        ])
        .controller('DeactivatePluginModalController',['$uibModalInstance', deactivatePluginModal])
        .controller('WebsiteEditController',[ 'DomainLoader',
            'wtUtils','WooModelEditController','$scope', '$state', 'Obj', 'Form',
            'WooApp','$translate', edit
        ])
        .controller('WebsiteImportController',import_site)
        .controller('WebsiteRelocateController',relocate_site)
        .controller('WebsiteBackupController',backup)
        .controller('WebsiteBlueprintController',blueprint)

    function gotoState(state,s,params,options) {
        return function() {
            var parent=state.$current.parent
            state.go(parent+s,params,options)
        }
    }
    function siblingState(state,s) {
        var parent=state.$current.parent
        return parent.name+s
    }
    function AccessPoint (name,type,scheme,path,open,options) {
        this.label = name;
        this.scheme = scheme
        this.path = path;
        this.type=type
        this.action = function (event, object) {
            if (open) {
                open(this,object)
            }
        }
        this.options=options
    }

    function get_discount(item,group,discounts,prod) {
        var discount = discounts.find(function (d) { return (
            d.applies_to.includes(item) || d.applies_to.includes(group) || d.applies_to.includes('all') ||
            d.applies_to.includes('default_prices') && !(prod&&prod.is_custom) 
        )})
        return discount&&(discount.value/100)||0
    }
    function get_location_price(prices,lgroup) {
        return prices[lgroup] || prices['low']
    }
    function calculate_price(vm,obj,pricing) {
        if(!obj.pcode) return
        var plan=pricing.plans[obj.pcode]
        if(!plan) return
        var disk=pricing.addons.disk
        var cpu=pricing.addons.cpu
        var ram=pricing.addons.ram
        var disk_addon=0
        if (obj.pcode!='addon') {
            disk_addon=obj.disk_size-(plan.addons && plan.addons.disk && plan.addons.disk.includes || 0)
        }
        var cpu_addon=0
        var ram_addon=0
        if (obj.pcode=='custom') {
            cpu_addon=obj.cpu-(plan.addons && plan.addons.cpu && plan.addons.cpu.includes || 0)
            ram_addon=obj.ram-(plan.addons && plan.addons.ram && plan.addons.ram.includes || 0)
        }
        var period=vm.period
        if(!obj.lcode) return
        var location=pricing.location[obj.lcode]
        var lgroup=location.price_group
        var currency = vm.currency
        if (lgroup) {
            var conversion=pricing.conversions && pricing.conversions[currency]
            var ram_mul=Math.round(1/ram.amount||1)
            if (conversion) {
                vm.new_plan=conversion[get_location_price(plan.price,lgroup).id]
                vm.new_disk=conversion[get_location_price(disk.price,lgroup).id]*disk_addon
                vm.new_cpu=conversion[get_location_price(cpu.price,lgroup).id]*cpu_addon
                vm.new_ram=conversion[get_location_price(ram.price,lgroup).id]*ram_addon*ram_mul
            } else {
                vm.new_plan=get_location_price(plan.price,lgroup).price
                vm.new_disk=get_location_price(disk.price,lgroup).price*disk_addon
                vm.new_cpu=get_location_price(cpu.price,lgroup).price*cpu_addon
                vm.new_ram=get_location_price(ram.price,lgroup).price*ram_addon*ram_mul
            }
            vm.total_discount=0
            if(vm.discounts) {
                vm.plan_discount=get_discount(obj.pcode,'plans',vm.discounts,plan)*vm.new_plan
                vm.disk_discount=get_discount('disk','addons',vm.discounts,disk)*vm.new_disk
                vm.cpu_discount=get_discount('cpu','addons',vm.discounts,cpu)*vm.new_cpu
                vm.ram_discount=get_discount('ram','addons',vm.discounts,ram)*vm.new_ram
                vm.total_discount=vm.plan_discount+vm.disk_discount+vm.cpu_discount+vm.ram_discount
            }
            var new_total=vm.new_plan+vm.new_disk+vm.new_cpu+vm.new_ram - vm.total_discount
            vm.new_total=new_total.toFixed(2)
            vm.new_price= vm.new_total
            if(vm.total_discount)
                vm.new_discount=vm.total_discount.toFixed(2)

        } else {
            vm.new_plan=plan.price[period].price
            vm.new_disk=disk.price[period].price*disk_addon
            vm.new_total=vm.new_plan+vm.new_disk
            vm.discount=Math.round((location && location.discount||0)*vm.new_total/100)
            vm.new_price= vm.new_total - vm.discount
        }

    }
    function isSharedPlan(p) {

    }
    function check_addons(obj,pricing,disk_min) {
        var plan=pricing.plans[obj.pcode] || {}
        var disk_included=plan.addons && plan.addons.disk && plan.addons.disk.includes || 0
        if (disk_included) {
            if (!obj.disk_size || obj.disk_size<disk_included) {
                obj.disk_size=disk_included
            }
            if (obj.disk_size && obj.disk_size>disk_included){
                if(obj.orig_disk_size) disk_included=obj.orig_disk_size
                if (disk_included>disk_min) {
                    obj.disk_size=disk_included
                } else {
                    obj.disk_size=disk_min
                }
            }
        }

        if (!obj.disk_size || obj.disk_size<disk_min){
            obj.disk_size=disk_min
        }
        if (obj.pcode!='custom') {
            return
        }
        var cpu_min=plan.addons && plan.addons.cpu && plan.addons.cpu.min || 0
        var cpu_max=plan.addons && plan.addons.cpu && plan.addons.cpu.max
        if (!obj.cpu || obj.cpu<cpu_min) {
            obj.cpu=cpu_min
        } else if (cpu_max==0 || cpu_max && obj.cpu>cpu_max) {
            obj.cpu=cpu_max
        }
        var ram_min=plan.addons && plan.addons.ram && plan.addons.ram.min || 0
        var ram_max=plan.addons && plan.addons.ram && plan.addons.ram.max
        if (!obj.ram || obj.ram<ram_min) {
            obj.ram=ram_min
        } else if (ram_max==0||ram_max && obj.ram>ram_max) {
            obj.ram=ram_max
        }
    }
    function add_pricing(vm,utils,obj,form,pricing,uinfo,billing) {
        var subscription=obj.subscription||{}
        if (pricing.docs) {
            pricing=pricing.docs[0]
        }
        var currency=uinfo.getCurrency(pricing)
        if (billing.docs) {
            billing=billing.docs[0]
        }
        vm.pricing={
            old_price:subscription && subscription.total||0,
            period:subscription && subscription.period || 'month',
            currency:currency.selected,
            currencies:currency.options
            ,credit:billing.total_credit && billing.total_credit.toFixed(2) || 0
        }
        vm.pricing.period_name=utils.translate('UPGRADE.PERIOD.'+vm.pricing.period)
        if(pricing.discounts&&pricing.discounts.length) {
            vm.pricing.discounts=pricing.discounts.sort(function(d1,d2) {return d1.rate-d2.rate; })
        }
        function update() {
            calculate_price(vm.pricing,obj,pricing)
        }
        function update_custom(newValue,oldValue) {
            obj.cpu=parseInt(obj.cpu); obj.ram=Number.parseFloat(obj.ram)
            if (obj.pcode!='custom') {
                return update()
            }
            var is_server=obj.app_type && (obj.app_type.endsWith('container-server') || obj.app_type.startsWith('u16-lemp'))
            if(is_server && obj.cpu && obj.cpu>1 && obj.cpu%2==1) {
                // must be even number, or 1
                if (newValue>oldValue) {
                    obj.cpu += 1
                } else {
                    obj.cpu -= 1
                }
            }
            if (obj.cpu && obj.ram) {
                var minQ=0.9, maxQ=6.5
                if(!is_server) {
                    minQ=2; maxQ=4;
                }
                if (obj.ram<minQ*obj.cpu) {
                    //debugger
                    var ram=Math.round(minQ*obj.cpu*4)/4
                    while (ram<minQ*obj.cpu) {
                        ram += 0.25
                    }
                    obj.ram=ram
                }
                if (obj.ram>maxQ*obj.cpu) {
                    var ram=Math.round(maxQ*obj.cpu*4)/4
                    while (ram>maxQ*obj.cpu) {
                        ram -= 0.25
                    }
                    obj.ram=ram
                }
            }
            update()
        }
        function check_disk_min(pcode) {
            var plan=pricing.plans[pcode] || {}
            var disk_min=plan.addons && plan.addons.disk && plan.addons.disk.includes || 0
            if(pcode!='addon' && !disk_min) disk_min=5
            if(obj.disk_usage && obj.disk_usage>disk_min) disk_min=obj.disk_usage
            form.number.disk_size.min=disk_min
        }
        function checkPlan(plan,oldPlan) {
            if (plan=='addon' && oldPlan != 'addon') {
                //debugger
                form.hidden.disk_size=1
                form.hidden.main_app=0
                form.disabled.lcode=1
                form.optional.main_app=0
                obj.main_app=form.values.main_app[0].value
                obj.disk_size=0
                form.note.lcode='WEBSITE.ADDON_LOCATION_NOTE'
            } else if (oldPlan=='addon' && plan!='addon') {
                //obj.disk_size=10
                form.hidden.disk_size=0
                form.hidden.main_app=1
                form.disabled.lcode=0
                form.optional.main_app=1
                obj.main_app=null
            }
            check_disk_min(plan)
            if (plan=='custom' && oldPlan != 'custom') {
                form.hidden.cpu=0
                form.hidden.ram=0
                form.number.cpu.min=1
                form.number.ram.min=4
            } else if (oldPlan=='custom' && plan!='custom') {
                form.number.cpu.min=0
                form.number.ram.min=0
                form.optional.cpu=1
                form.optional.ram=1
                form.hidden.cpu=1
                form.hidden.ram=1
            }
            form.note.pcode='WEBSITE.SELECT_VALUES.PLAN_DESCRIPTIONS.'+plan.toUpperCase()
        }
        function update_plan(newValue, oldValue) {
            if (newValue!=oldValue) {
                checkPlan(newValue,oldValue)
                check_addons(obj,pricing,form.number.disk_size.min)
                update()
            }
        }
        function select_currency(newValue, oldValue) {
            if (newValue!=oldValue) {
                uinfo.selectCurrency(vm.pricing.currency)
                //console.log('Currency set');
                update()
            }
        }
        function main_app_set(newValue, oldValue) {
            if (newValue && newValue!=oldValue) {
                angular.forEach(form.values.main_app,function(app) {
                    if (newValue==app.value) {
                        obj.lcode=app.lcode
                    }
                })
            }
        }
        if (vm.pricing.old_price) {
            vm.pricing.new_price=vm.pricing.old_price
        } else {
            update_plan(vm.obj.pcode)
        }
        check_disk_min(obj.pcode)

        vm.scope.$watch('vm.obj.pcode',update_plan)
        vm.scope.$watch('vm.obj.lcode',update)
        vm.scope.$watch('vm.obj.disk_size',update)
        vm.scope.$watch('vm.obj.cpu',update_custom)
        vm.scope.$watch('vm.obj.ram',update_custom)
        vm.scope.$watch('vm.obj.main_app',main_app_set)
        vm.scope.$watch('vm.pricing.currency',select_currency)
    }

    function watch_plan_locations(vm,pricing) {
        if (pricing.docs) {
            pricing=pricing.docs[0]
        }
        var plan_locations=pricing.plan_locations
        if(!plan_locations) return

        function check_plan_location(newplan,oldplan) {
            if (plan_locations[oldplan]==plan_locations[newplan]) return
            pls=plan_locations[newplan]
            if(pls&&pls.length>0) {
                var d={}
                angular.forEach(pls,function(item) {
                    d[item]=1
                });
                if(!d[vm.obj.lcode]) {
                    vm.obj.lcode=pls[0]
                }

                angular.forEach(vm.Form.values.lcode,function(v) {
                    if(!d[v.value]) {
                        console.log('disable',v.value);
                        v.disabled=true
                    } else {
                        if (v.disabled) console.log('enable',v.value);
                        delete v.disabled
                    }
                })
            } else {
                angular.forEach(vm.Form.values.lcode,function(v) {
                    if (v.disabled) console.log('enable',v.value);
                    delete v.disabled
                })
            }
        }
        function check_location_plan(newloc,oldloc) {
        }
        vm.scope.$watch('vm.obj.pcode',check_plan_location)
        vm.scope.$watch('vm.obj.lcode',check_location_plan)
    }

    function adminForm(utils,vm,Form) {
        Form.advanced={
            fields:[
                'app_type','container_server','preemptible','image','disable_backup',
                'fileowner','disk_type','install_options'
            ]
        }
        Form.optional.container_server=1
        Form.type.preemptible='checkbox'
        Form.description['container_server']="The ID of the container server app (only applicable for u18-container-wp)."
        Form.description['image']="Sometimes there's a newer image that can be used."
        Form.description['disable_backup']="Disable automatic backups."
        Form.description['fileowner']="Server user that should own the file. User created if non existing."
        //Form.description['php_pool']="Server user that should own the file. User created if non existing."
        Form.description['install_options']="WEBSITE.DESCRIPTIONS.INSTALL_OPTIONS"
        //utils.addFormLabels('WEBSITE',Form)
        Form.description['disk_type']="standard or ssd."
        Form.description['preemptible']="Preemptible server will live at most 24hours, possibly shorter. It costs less than 1/3 of a normal server so it's good to use for testing purposes when it's OK that server stops. If it stops, it can be started again."
    }

    function initForm(utils, vm,Form) {
        Form.type['cpu']='slider'
        Form.type['ram']='slider'
        //Form.unit['disk_size']='GB'
        Form.number=Form.number||{}
        Form.number.cpu=Form.number.cpu||{min:0,step:1,max:32}
        Form.number.ram=Form.number.ram||{min:0,step:0.25,max:128}
        Form.number['disk_size']={min:10,step:1,max:65536}
        Form.default['cpu']=1
        Form.default['ram']=1
        Form.default['name']=utils.translate('WEBSITE.DEFAULT_NAME')
        Form.default['disk_size']=10
        Form.fields=['name','lcode','pcode','cpu','ram','main_app','disk_size']
        if (vm.is_trial ) {
            Form.fields=['name','lcode']//,'pcode','cpu','ram','disk_size']
            Form.disabled=Form.disabled||{}
            Form.disabled.pcode=1
            Form.disabled.disk_size=1
        }
        Form.hidden={
            cpu:1,ram:1,main_app:1
        }
        Form.disabled={}
        if (vm.migration) {
            if (__testing__) {
                Form.fields.unshift("migrate_message")
            }
            Form.fields.unshift("duplicator_url")
            Form.fields.unshift("panel_login_info")
            Form.fields.unshift("old_login_info")
            Form.fields.unshift("import_select")
            Form.type.import_select='select'
            Form.type.old_login_info='compound'
            Form.type.panel_login_info='compound'
            Form.type.migrate_message='text'
            Form.optional=Form.optional||{}
            Form.optional.migrate_message=true
            
            // Used by wt-info
            Form.info = {
                "title": {
                    "import_select": "WEBSITE.MIGRATE.INFO.IMPORT_SELECT.TITLE"
                },
                "content": {
                    "import_select": "WEBSITE.MIGRATE.INFO.IMPORT_SELECT.CONTENT"
                },
            }

        }

        // Populate flags
        Form.values.lcode = utils.populateFlags(Form.values.lcode)

        angular.forEach(Form.values.pcode,function(p) {
            p.name=p.translated||'WEBSITE.SELECT_VALUES.PLAN.'+p.value.toUpperCase()
        })
        utils.addFormLabels('WEBSITE',Form)
        //Form.label['disk_size']='WEBSITE.DISK_SIZE'
/*
        Form.label={
            name:'Website Name',
            lcode:'Website Location',
            pcode:'Website Plan',
            cpu:'Virtual CPUs',
            ram:'RAM size in GB',
            disk_size:'Size of disk in GB'
        }
        Form.description={
            name:'This is the name of your WordPress site.',
            lcode:'Choose location to optimize speed.',
            pcode:'Your Website Plan',
            cpu:'Virtual CPUs',
            ram:'RAM size in GB',
            disk_size:'Size of disk in GB'
        }
        */
        //return
    }

    function checkQuota($state,UserInfo,ErrorDialog) {
        if (!UserInfo.hasQuota('apps')) {
            if (UserInfo.is_trial) {
                ErrorDialog({type:'illegal',translate:'WEBSITE.CREATE_SITE_MUST_UPGRADE'})
            } else {
                ErrorDialog({type:'quota',translate:'WEBSITE.QUOTA_ERROR'})
            }
            $state.go(siblingState($state,'.list'))
            return true
        }
    }

    function createStaging(wtUtils,$state,WooModelEditController,WooApp,Live) {
            var vm = this;
            //vm.layout='app/main/website/website-processing.html'
            //vm.processing_title="WEBSITE.CREATE_STAGING.PROCESSING_TITLE"
            vm.api=WooApp
            WooModelEditController(vm,{})
            var obj=vm.obj
            obj.user=Live.user
            obj.app_class="staging"
            obj.copy_from={
                app:Live._id,
                completed:false
            }
            vm.save(function(res) {
                return gotoState($state,'.processing',{id:res._id},{location:'replace'})()
            })
    }

    function copyToApp(wtUtils,$state,$scope,WooModelEditController,WooApp,Src,Dst) {
            var vm = this;
            //vm.layout='app/main/website/website-processing.html'
            //vm.processing_title="WEBSITE.CREATE_STAGING.PROCESSING_TITLE"
            vm.api=WooApp
            vm.scope=$scope
            vm.Object=Dst
            WooModelEditController(vm,{})
            var obj=vm.obj
            obj.copy_from={
                app:Src._id,
                completed:false,
                incremental:true
            }
            vm.editing=false
            vm.save(function(res) {
                return gotoState($state,'.processing',{id:res._id},{location:'replace'})()
            })
    }

    function deactivatePluginModal($uibModalInstance) {
        var vm = this;
        vm.slug = '';
        vm.ok = function () {
            $uibModalInstance.close((vm.slug || '').trim());
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function create(wtUtils,WooModelEditController,WooApp,$scope,
        $state,Form,ErrorDialog,UserInfo,Pricing,Billing,WebsiteCopyFrom,CopyFrom,Blueprints) {
        var vm = this;
        vm.tag='website-create'
        vm.layout='app/main/website/website-create.html'
        vm.title="WEBSITE.CREATE.TITLE"
        vm.save_button="WEBSITE.CREATE.CONTINUE_BTN"
        vm.blueprints=Blueprints && Blueprints.docs

        vm.scope=$scope
        if (checkQuota($state,UserInfo,ErrorDialog)) {
            return
        }

        vm.trial_upgrade=$state.params.from=='upgrade-trial'
        vm.is_trial=UserInfo.is_trial && !vm.trial_upgrade
        Form.type.lcode='ui-select'
        //Form.no_labels=true
        initForm(wtUtils,vm,Form)
        vm.Form=Form
        vm.api=WooApp

        if(!CopyFrom && vm.blueprints && vm.blueprints.length>0) {
            Form.fields.splice(1,0,'blueprint') // Insert after 'name' field
            Form.type.blueprint='ui-select'
            Form.optional.blueprint=1
            Form.label.blueprint="WEBSITE.BLUEPRINT.FIELD_LABEL"
            Form.description.blueprint="WEBSITE.BLUEPRINT.FIELD_DESC"
            Form.values.blueprint=vm.blueprints
        }

        var data={
            populate:['operation','location','plan']
            ,next_state: {
                save:siblingState($state,'.processing')
            }
        }
        WooModelEditController(vm,data)
        if (vm.isAdmin) {
            adminForm(wtUtils,vm,Form)
        }

        Form.advanced = Form.advanced || {fields:['install_options']} // Makes install_options available in advanced tab for non admins
        Form.label.install_options="WEBSITE.LABELS.INSTALL_OPTIONS"
        
        Form.subforms.install_options.type=Form.subforms.install_options.type||{}
        Form.subforms.install_options.description=Form.subforms.install_options.description||{}
        Form.subforms.install_options.label=Form.subforms.install_options.label||{}
        
        Form.subforms.install_options.fields.push('skip_wp')
        Form.subforms.install_options.type.skip_wp='checkbox'
        Form.subforms.install_options.description['skip_wp']="WEBSITE.DESCRIPTIONS.SKIP_WP_INSTALL"
        Form.subforms.install_options.label['skip_wp']="WEBSITE.LABELS.SKIP_WP_INSTALL"
        Form.subforms.install_options.hidden={
            'version':true,
            'php-ver':true,
            'new_installer':true,
            'external_db':true,
            'project':true
        }

        if (CopyFrom) {
            vm.form_obj=vm.obj.copy_from={
                app:CopyFrom._id
            }
            vm.obj.name="Clone of " + CopyFrom.name
            vm.obj.pcode=CopyFrom.pcode
            vm.obj.lcode=CopyFrom.lcode
            vm.translate_values={src_name:CopyFrom.name}
            vm.title="WEBSITE.CLONE.TITLE"
            vm.breadcrumbs=[
                {label:"BREADCRUMBS.WEBSITES", url: $state.href('app.website.list')},
                {label:CopyFrom.name, url: $state.href('app.website.details', {id: CopyFrom._id})},
                {label:"IMPORT_MENU_TITLE", url: $state.href('app.website.details', {id: CopyFrom._id}) + '#import'},
                {label:"BREADCRUMBS.CLONE_TO_NEW_APP"}
            ]
            vm.cloning=true
            WebsiteCopyFrom(vm)
        }
        if(!vm.is_trial) {
            add_pricing(vm,wtUtils,vm.obj,Form,Pricing,UserInfo,Billing)
            watch_plan_locations(vm,Pricing)
        }
        vm.Form.type.pcode='plan-select'
        vm.continue=function() {
            if(vm.is_trial) {
                vm.obj.is_free_trial=true
                vm.obj.pcode='micro'
                vm.obj.disk_size=5
                return vm.save()
            }
            if (CopyFrom) {
                vm.copy_continue()
            }
            if(vm.obj.blueprint) {
                vm.obj.import_from={url:vm.obj.blueprint.url}
            }
            vm.save(function(res) {
                if(!res.upgrade) {
                    return gotoState($state,'.processing',{id:res._id},{location:'replace'})()
                }
                $state.go('appf.upgrade.billing',{id:res.upgrade && res.upgrade._id||res.upgrade})
            })
        }
        //vm.isSaving=true
    }

    function migrate(
        wtUtils,WooModelEditController,WooApp,$scope,
        $state,Form,ErrorDialog,UserInfo,Pricing,Billing,Obj
    ) {
        var vm=this
        vm.migration=true
        if(!Obj) {
            create.call(this,wtUtils,WooModelEditController,WooApp,$scope,
                $state,Form,ErrorDialog,UserInfo,Pricing,Billing)
            Form.description.name='WEBSITE.DESCRIPTIONS.MIGRATE_NAME'
        } else  {
            vm.scope=$scope
            vm.form=vm.Form=Form={
                fields:['old_login_info','panel_login_info','migrate_message'],
                type:{old_login_info:'compound',panel_login_info:'compound',migrate_message:'text'},
                subforms:{},
                values:{},
                optional:{migrate_message:true}
            }
            vm.obj=Obj
            vm.layout='app/main/website/website-create.html'
        }
        //vm.introduction="WEBSITE.MIGRATE.INTRODUCTION"
        vm.title="WEBSITE.MIGRATE.TITLE"
        if(Obj) {
            vm.breadcrumbs=[
                {label:"BREADCRUMBS.WEBSITES", url: $state.href('app.website.list')},
                {label:Obj.name, url: $state.href('app.website.details', {id: Obj._id})},
                {label:"IMPORT_MENU_TITLE", url: $state.href('app.website.details', {id: Obj._id}) + '#import'},
                {label:"BREADCRUMBS.MIGRATION_REQUEST"}
            ]
        } else {
            vm.breadcrumbs=[
                {label:"BREADCRUMBS.WEBSITES", url: $state.href('app.website.list')},
                {label:"BREADCRUMBS.MIGRATION_REQUEST"}
            ]
        }
        vm.save_button="WEBSITE.MIGRATE.CONTINUE_BTN"
        vm.tag='website-migrate'

        Form.subforms.old_login_info={
            fields:['url','username','password']
            ,type: {
                password:'password'
            }
            ,disable_pwgen:{
                password:true
            }
            ,label: {
                url: "WEBSITE.MIGRATE.WORDPRESS_LOGIN_URL"
            }
            ,placeholder: {
                url: "WEBSITE.MIGRATE.WORDPRESS_LOGIN_PLACEHOLDER"
            }

        }
        // console.log(Form.subforms.old_login_info)

        Form.subforms.panel_login_info={
            fields:['url','username','password']
            ,type: {
                password:'password'
            }
            ,disable_pwgen:{
                password:true
            }
            ,optional:{
                url:true,username:true,password:true
            }
            ,label: {
                url: "WEBSITE.MIGRATE.PANEL_LOGIN_URL"
            }
            ,info: {
                title: {
                    panel_login_info: "WEBSITE.MIGRATE.INFO.PANEL_LOGIN.TITLE"
                },
                content: {
                    panel_login_info: "WEBSITE.MIGRATE.INFO.PANEL_LOGIN.CONTENT"
                },
            }
        }
        if(Obj) {
            wtUtils.addFormLabels('WEBSITE',Form)
            Form.subforms.old_login_info.optional={
                url:true,username:true,password:true
            }
            if(vm.obj.migrate_from) {
                var from=vm.obj.migrate_from
                vm.obj.old_login_info = from.admin
                vm.obj.panel_login_info=from.panel
                vm.obj.migrate_message=from.message
            }
            vm.Object=Obj
            WooModelEditController(vm,{})
            Form.Obj_exists=true
        }
        if(!Obj) {
            Form.values.import_select=[
                {value:'manual',name:'WEBSITE.IMPORT.MANUAL'}
                ,{value:'auto',name:'WEBSITE.IMPORT.AUTO'}
            ]

            vm.scope.$watch('vm.obj.import_select',function() {
                if(vm.obj.import_select=='manual') {
                    Form.hidden.duplicator_url=true
                    Form.optional.duplicator_url=true
                    Form.hidden.migrate_message=false
                    Form.hidden.old_login_info=false
                    Form.hidden.panel_login_info=false
                    Form.subforms.old_login_info.optional={
                    }
                } else {
                    Form.hidden.duplicator_url=false
                    Form.optional.duplicator_url=false
                    Form.hidden.migrate_message=true
                    Form.hidden.old_login_info=true
                    Form.hidden.panel_login_info=true
                    Form.subforms.old_login_info.optional={
                        url:true,username:true,password:true
                    }
                }
            })

            vm.obj.import_select='manual'
        }
        vm.continue=function() {
            if(Obj) {
                vm.obj.update_migrate_from={
                    admin:vm.obj.old_login_info,
                    panel:vm.obj.panel_login_info,
                    message:vm.obj.migrate_message
                }
                delete vm.obj.old_login_info; delete vm.obj.panel_login_info; delete vm.obj.migrate_message;
            } else if (vm.obj.import_select=='manual') {
                vm.obj.migrate_from={
                    admin:vm.obj.old_login_info,
                    panel:vm.obj.panel_login_info,
                    message:vm.obj.migrate_message
                }
                delete vm.obj.old_login_info; delete vm.obj.panel_login_info; delete vm.obj.migrate_message;
            } else {
                vm.obj.import_from={
                    kind:'duplicator'
                    ,url:vm.obj.duplicator_url
                    ,update_admin:false
                    ,completed:false
                }
            }
            if(!Obj && vm.is_trial) {
                vm.obj.is_free_trial=true
                //vm.obj.pcode='micro'
                vm.obj.disk_size=5
                return vm.save()
            }
            vm.save(function(res) {
                if(Obj) {
                    return gotoState($state,'.details',{id:res._id})()
                }
                if(!res.upgrade) {
                    return gotoState($state,'.processing',{id:res._id})()
                }
                $state.go('appf.upgrade.billing',{id:res.upgrade && res.upgrade._id||res.upgrade})
            })
        }
        //vm.isSaving=true
    }

    function upgrade(wtUtils,WooModelEditController,$window,WooApp,WooUpgrade,UserInfo,AuthService,
        ErrorDialog,Pricing,Billing,$scope,$state,$filter,Form,Upgrade,Obj) {
        if (!Obj._id) {
            return $window.history.back()
        }
        var vm=this
        var old=Upgrade

        if (!old || old.state=='complete') {
            return create_upgrade()
        }

        if ( old.state=='new' ) {
            return create_upgrade(old)
        }
        if(old.state=='paid') {
            return complete_upgrade(old)
        }

        var $translate=$filter('translate')
        var Title=$translate('WEBSITE.UPGRADE.DIALOG_TITLE')
        var Body=$translate('WEBSITE.UPGRADE.DIALOG_BODY')
        var diagOK=$translate("WEBSITE.UPGRADE.DIALOG_OK")
        var diagCANCEL=$translate("WEBSITE.UPGRADE.DIALOG_CANCEL")
        wtUtils.confirm({title:Title,body:Body,ok:diagOK,cancel:diagCANCEL},function() {
            return $state.go('appf.upgrade.billing',{id:old._id})
        }, function() {
            var user=AuthService.selectedUser()||AuthService.user && AuthService.user.acctId
            WooUpgrade.delete({obj_id:old._id,user:user},function(res) {
                $state.go($state.current,{id:Obj._id},{reload:true,location:'replace'})
            })
        });

        function create_upgrade(old_upgrade) {
            // Create a new (or reuse an existing) upgrade
            vm.layout='app/main/website/website-create.html'
            vm.scope=$scope
            vm.app=Obj
            vm.Object=new WooUpgrade(old_upgrade)
            vm.Object.kind='AppUpgrade'
            vm.Object.doc=vm.app._id
            initForm(wtUtils,vm,Form)
            if (!old_upgrade) {
                var fields=['pcode','lcode','cpu','ram','disk_size']
                _.each(fields,function (f) {vm.Object[f]=Obj[f]})
            }
            Form.fields=['pcode','cpu','ram','disk_size']
            Form.disabled={
               name:1,lcode:1
            }
            Form.number=Form.number||{}
            Form.number.disk_size=Form.number.disk_size||{}
            Form.note.disk_size='WEBSITE.DISK_SIZE_UPGRADE_NOTE'
            Form.type.pcode='plan-select'
            vm.Form=Form
            vm.api=WooUpgrade
            var data={
               next_state: {save:'appf.upgrade.billing'}
            }
            vm.continue=function() {
               vm.save(function(res) {
                   $state.go('appf.upgrade.billing',{id:res && res._id||res})
               })
            }
            WooModelEditController(vm,data)

            /*if(false && vm.isAdmin && Obj.disk_usage) {
                Form.number.disk_size.min=Math.ceil(Obj.disk_size*Obj.disk_usage/100)
            }
            if(Form.number.disk_size.min<5) Form.number.disk_size.min=5*/
            if(vm.obj && !vm.obj.app_type) vm.obj.app_type=vm.app&&vm.app.app_type
            if(vm.app&&vm.app.disk_usage&&vm.app.disk_size) {
                var usage=vm.app.disk_usage
                usage = Math.ceil(usage * (vm.app.disk_size)/100)
                vm.obj.disk_usage=usage
            }
            vm.obj.orig_disk_size=vm.obj.disk_size
            add_pricing(vm,wtUtils,vm.obj,Form,Pricing,UserInfo,Billing)

            vm.id=old_upgrade && old_upgrade._id
            if (!old_upgrade) {
               vm.editing=false
            }
            vm.title="WEBSITE.UPGRADE.TITLE"
            vm.translate_values.app=vm.app
        }

        function complete_upgrade(upgrade) {
            vm.scope=$scope
            vm.Object=Obj
            WooModelEditController(vm,{})
            vm.layout='app/main/website/website-complete-upgrade.html'
            vm.title="WEBSITE.UPGRADE.TITLE"
            // vm.translate_values={app:Obj,Upgrade:wtUtils.translate(upgrade.is_downgrade?"Downgrade":"Upgrade")}
            vm.cancel_button='WEBSITE.UPGRADE.COMPLETE_LATER'
            vm.continue_button='WEBSITE.UPGRADE.COMPLETE_NOW'
            vm.cancel=function() {
                $state.go('app.website.details',{id:Obj._id})
            }
            var diffs=[]
            var count=0
            angular.forEach(['pcode','disk_size','cpu','ram','lcode'],function(l) {
                count += Obj[l]!=Upgrade[l]?1:0

                var d={name:l,old:Obj[l],new:Upgrade[l]}
                if(d.name=='pcode') {
                    d.name='Plan';d.old=Obj.plan.name;d.new=Upgrade.plan.name
                }
                if(d.name=='disk_size') {
                    d.name='Disk size'
                    //if(Obj[l]==Upgrade[l]) d=null
                }
                if(l=='lcode') {
                    d={name:'Location',old:Obj.location.name,new:Upgrade.location.name}
                    if(Obj[l]==Upgrade[l]) d=null
                }
                if (l=='cpu'||l=='ram') {
                    d={name:l.toUpperCase(),old:Obj[l]||'',new:Upgrade[l]||''}
                    if (!Obj[l] && !Upgrade[l]) d=null
                }
                if (d!=null) diffs.push(d)
            })
            vm.diffs=diffs
            //angular.forEach(['pcode'])
            vm.continue=function() {
                Obj.complete_upgrade=true
                Obj.$save({user:vm.user,obj_id:Obj._id},function(res) {
                    $state.go('app.website.processing',{id:Obj._id})
                })
            }
            if (count==0) {
                return vm.continue()
            }
        }
    }

function operation_type(type) {
    switch(type) {
        case 'initialize':return 'create';
        case 'updating-create_backup':return 'backup'
        case 'updating-restore_backup':return 'restore'
        case 'updating-import_from': return 'import'
        default: return 'update'
    }
}

function waiting_for_payment(app) {
    app.operation && app.operation.type=='pending-payment' && app.operation.status=='waiting'
}

   function processing(WooModelEditController,WooApp,$scope,$state,UserInfo,Obj) {
       var vm = this;
       var op_type=operation_type(Obj.operation && Obj.operation.type).toUpperCase()
       vm.continue_text='WEBSITE.PROCESSING.CONTINUE_TEXT'

       vm.layout='app/main/website/website-processing.html'

       vm.processing_title='WEBSITE.PROCESSING.'+op_type+'_PROCESSING_TITLE'
       vm.complete_title='WEBSITE.PROCESSING.'+op_type+'_COMPLETE_TITLE'
       vm.complete_text='WEBSITE.PROCESSING.'+op_type+'_COMPLETE_TEXT'

       // Allow different message when creating a staging website
       if (op_type == 'CREATE' && Obj.app_class && Obj.app_class == 'staging') {
           vm.processing_title='WEBSITE.PROCESSING.CREATE_STAGING_PROCESSING_TITLE'
           vm.complete_title='WEBSITE.PROCESSING.CREATE_STAGING_COMPLETE_TITLE'
           vm.complete_text='WEBSITE.PROCESSING.CREATE_STAGING_COMPLETE_TEXT'
       }

       // Different messages when creating a blueprint
       if (op_type == 'UPDATE' && Obj.operation && Obj.operation.type == 'updating-create_blueprint') {
            vm.processing_title = 'BLUEPRINTS.PROCESSING.PROCESSING_TITLE'
            vm.complete_title = 'BLUEPRINTS.PROCESSING.COMPLETE_TITLE'
            vm.complete_text = 'BLUEPRINTS.PROCESSING.COMPLETE_TEXT'
            vm.continue_text = false
       }

       vm.op_type = op_type

       vm.scope=$scope
       vm.api=WooApp
       vm.Object=Obj
       var data={
           populate:['operation','location','plan']
       }
       if (op_type=='BACKUP') {
           vm.extra_template='app/main/website/backup-complete.html'
       }
       vm.continue=function() {
           $state.go('app.website.details',{id:vm.Object._id},{location:'replace'})
       }
       if(waiting_for_payment(Obj)) {
           return vm.continue()
       }
       WooModelEditController(vm,data)

       //vm.title="Creating Website"
   }

   function add_backup_hour(vm,obj,scope) {
       var schedules = obj && obj.backup_schedules && obj.backup_schedules.schedules
       var s = schedules && schedules.find(function (s) { return s.server!='localhost'} )
       vm.backup_hour=s&&s.hour
       scope.$watch('vm.backup_hour',function(new_value,old) {
           console.log('Changing backup hour',old,new_value);
           if(new_value!=old) {
               vm.obj.set_backup_hour=parseInt(new_value)
               vm.save(function() {
                   vm.update_object()
               })
           }
       })
       //debugger
       var here=moment().startOf('day')
       var hour=moment(here).utc()
       if(hour.minutes()==0) {
           here.add(30,'minutes')
       }
       var values=[]
       for(var i=0; i<24; i += 1) {
           var label=moment(here)
           label=label.subtract(30,'minute').format('HH:mm')+'-'+label.add(1,'hour').format('HH:mm')
           values.push({value:hour.hour(),label:label})
           hour.add(1,'hour'); here.add(1,'hour')
       }
       vm.backup_hours = values
   }

    function details($win,$location,$translate,utils,
        ctrl,scope,state,obj,form,m,getAPs,UserCommand,ChatService,$uibModal) {
       var vm=this;
       vm.msg_level=utils.MSG_LEVEL_WAITING
       vm.devplan_autoupgrade=obj && obj.data && obj.data.find(function(d) { return d.tag=='devplan:autoupgrade'})
       if(vm.devplan_autoupgrade) {
           var due=vm.devplan_autoupgrade.value.due
           if(due) {
               due=moment(due);
               vm.devplan_autoupgrade_days=Math.round(moment.duration(due - moment()).asDays());
               if(vm.devplan_autoupgrade_days<0) vm.devplan_autoupgrade_days=0
           }
       }
       var newdesign=true //$location.search().newdesign
       vm.lang=$translate.use() || 'en'
       if (!obj.resolved) {
           var handler=function(event) {
               if (event.data=='resolved') {
                   obj.resolved=true
                   vm.update_object()
               }
               if (event.data=='authorized') {
                   vm.update_object()
               }
               if (event.data.status=='error') {
                   console.log('error received');
                   vm.disable_launcher=true
                   if (vm.launched && vm.launched[event.data.wname]) {
                       vm.launched[event.data.wname].close()
                   }
               }
            }
            $win.addEventListener("message", handler, false);
            scope.$on('destroy',function() {
                $win.removeEventListener("message",handler)
            })
       }
       if(obj&&obj.plan) {
           vm.plan_code=obj.plan.code
           if(obj.plan.visibility=='user') vm.plan_name=obj.plan.name
           else vm.plan_name="WEBSITE.SELECT_VALUES.PLAN."+obj.plan.code.toUpperCase()
       }
       vm.content='app/main/layouts/wt-details-content.html'
       // Populate flags
       if (newdesign) {
           vm.content='app/main/website/newdesign/website-main.html'
       }
       if (obj.app_class=='staging') {
           vm.details_template='app/main/website/staging-website-details.html'
           vm.delete_text="WEBSITE.CONFIRM_DELETE_MSG.STAGING"
       } else {
           vm.details_template='app/main/website/live-website-details.html'
           vm.delete_text="WEBSITE.CONFIRM_DELETE_MSG.LIVE"
       }
       vm.set_thumb=function (gen) {
           var obj=vm.obj
           if (obj && obj.thumb_image && obj.thumb_image.src) {
               var src=obj.thumb_image.src
               if (obj.thumb_image.version) {
                   src += '?version='+obj.thumb_image.version
               }
               vm.screenshot=src
               return
           }
           if (gen) {
               vm.generate_thumb()
           }
           vm.screenshot='/assets/images/wt-images/wootemple-thumb-2023.png'
       }
       vm.generate_thumb=function () {
           var obj=vm.obj
           if ( obj && obj.version >=3 && !vm.generating_thumb && !(obj.operation && !obj.operation.complete)) {
               vm.generating_thumb=1
               obj.generate_thumb=1
               vm.save(function() {
                   vm.generating_thumb=false
                   vm.init_object(vm.obj)
               })
           }
       }
       vm.getAP=function(label) {
           return getAP(vm.APs,label)
       }
       vm.home_page=function(a) {
           var home=getAP(vm.APs,'home')
           return home.action(null,vm.obj)
       }
       // Runs a tool AFTER confirmation
       vm.run_tool_confirm=function(t, title, text) {
           vm.confirm(title, text).then(function() {
               vm.run_tool(t)
           })
       }
        vm.run_tool=function(t) {
            vm.do_action(null,{value:t},function(){
                vm.update_object()
            })
        }

        // _suppress_op_id — banner suppression for UserCommand-driven operations.
        //
        // The top status banner (modelstatus.html via show_status()) is useful for
        // long-running ops like site creation or restores, but it's noisy for quick
        // background commands like disk-usage and log fetches that already show their
        // own in-tab loading state.
        //
        // We suppress the banner by storing the _id of the specific operation we just
        // dispatched. show_status() returns false only while that exact op is in flight.
        // If a *different* operation arrives (different _id — e.g. a server-triggered
        // auto-backup or restart) the banner comes back immediately, so we never
        // accidentally hide messages the user needs to see.
        //
        // Using a boolean flag instead would suppress *any* concurrent op, not just ours.
        vm._suppress_op_id = null;

        // --- Disk Usage (utils.list.files) ---
        vm.du_running = false;
        vm.du_rows = null;
        vm.du_total = null;
        vm.du_error = false;
        var du_op_pending = false;

        vm.run_disk_usage = function () {
            if (vm.du_running || vm.is_operating) { return; }
            vm.du_running = true;
            vm.du_rows = null;
            vm.du_total = null;
            vm.du_error = false;
            du_op_pending = true;
            UserCommand.run(vm, 'utils.list.files', {}).then(function () {
                // Capture the _id of the op we just dispatched so show_status() can
                // suppress the banner for this specific op only (see _suppress_op_id).
                vm._suppress_op_id = vm.obj.operation && vm.obj.operation._id;
            }).catch(function () {
                du_op_pending = false;
                vm.du_running = false;
                vm.du_error = true;
                vm._suppress_op_id = null;
            });
        };

        scope.$watch('vm.obj.operation', function (op) {
            if (!du_op_pending || !op) { return; }
            if (op.complete) {
                du_op_pending = false;
                vm.du_running = false;
                vm._suppress_op_id = null;
                if (op.status === 'error') {
                    vm.du_error = true;
                    return;
                }
                var parsed = parseDiskUsage(op.msgs);
                vm.du_rows = parsed.rows;
                vm.du_total = parsed.total;
            }
        }, true);

        vm.clear_disk_usage = function () {
            vm.du_rows = null;
            vm.du_total = null;
            vm.du_error = false;
        };

        function parseDiskUsage(msgs) {
            var rows = [];
            var total = null;
            if (!msgs || !msgs.length) { return { rows: rows, total: total }; }

            // msgs is an array of plain strings; the data is in the last msg
            // each msg may contain multiple lines joined by \n
            var allLines = [];
            angular.forEach(msgs, function (msg) {
                var text = (msg && msg.msg) ? msg.msg : msg;
                var lines = String(text).split('\n');
                allLines = allLines.concat(lines);
            });

            angular.forEach(allLines, function (line) {
                line = line.trim();
                if (!line) { return; }
                // Skip the "Running:" shell wrapper line
                if (line.indexOf('Running:') === 0) { return; }
                // "Completed utils.list.files: 561M\ttotal" — extract total size
                // Format: "Completed <cmd>: <size>\ttotal"
                if (line.indexOf('Completed ') === 0) {
                    var completedParts = line.split('\t');
                    if (completedParts.length >= 2 && completedParts[1].trim() === 'total') {
                        // size is the last token of the first part, e.g. "Completed utils.list.files: 561M"
                        var headerTokens = completedParts[0].trim().split(/\s+/);
                        total = headerTokens[headerTokens.length - 1];
                    }
                    return;
                }
                // Tab-separated data rows: "<size>\t<path>"
                var parts = line.split('\t');
                if (parts.length < 2) { return; }
                var size = parts[0].trim();
                var path = parts[1].trim();
                // Skip the root "." entry — not useful for users
                if (path === '.') { return; }
                rows.push({ size: size, path: path });
            });

            return { rows: rows, total: total };
        }
        // --- End Disk Usage ---

        // --- Logs (live.access.log / live.error.log) ---
        vm.log_options = [
            { name: 'live.access.log', label: 'LOGS.ACCESS' },
            { name: 'live.error.log',  label: 'LOGS.ERROR'  }
        ];
        vm.log_line_options   = [50, 100, 500];
        vm.selected_log       = vm.log_options[0].name;
        vm.selected_log_lines = 100;
        vm.log_running        = false;
        vm.log_output         = null;
        vm.log_error          = false;
        var log_op_pending    = false;

        vm.run_logs = function () {
            if (vm.log_running || vm.is_operating) { return; }
            vm.log_running = true;
            vm.log_output  = null;
            vm.log_error   = false;
            log_op_pending = true;
            UserCommand.run(vm, vm.selected_log, { lines: vm.selected_log_lines }).then(function () {
                // Capture the _id of the op we just dispatched so show_status() can
                // suppress the banner for this specific op only (see _suppress_op_id).
                vm._suppress_op_id = vm.obj.operation && vm.obj.operation._id;
            }).catch(function () {
                log_op_pending = false;
                vm.log_running = false;
                vm.log_error   = true;
                vm._suppress_op_id = null;
            });
        };

        scope.$watch('vm.obj.operation', function (op) {
            if (!log_op_pending || !op) { return; }
            if (op.complete) {
                log_op_pending = false;
                vm.log_running = false;
                vm._suppress_op_id = null;
                if (op.status === 'error') {
                    vm.log_error = true;
                    return;
                }
                vm.log_output = parseLogOutput(op.msgs);
                // Scroll to the bottom after the DOM updates so the user sees the
                // most recent log lines first (newest entries are at the end of the file).
                setTimeout(function () {
                    var el = document.querySelector('.log-output');
                    if (el) { el.scrollTop = el.scrollHeight; }
                }, 0);
            }
        }, true);

        function parseLogOutput(msgs) {
            if (!msgs || !msgs.length) { return ''; }
            var allLines = [];
            angular.forEach(msgs, function (msg) {
                var text = (msg && msg.msg) ? msg.msg : msg;
                var lines = String(text).split('\n');
                allLines = allLines.concat(lines);
            });
            var filtered = [];
            angular.forEach(allLines, function (line) {
                if (line.indexOf('Running:') === 0) { return; }
                if (line.indexOf('Completed ') === 0) { return; }
                filtered.push(line);
            });
            return filtered.join('\n');
        }
        // --- End Logs ---

        // --- Deactivate Plugins (wpcli.plugin-deactivate / wpcli.plugin-deactivate-all) ---
        vm.deactivate_plugin_last_slug = '';
        vm.deactivate_plugin_running   = false;
        // Feedback for the last run, or null. Shape: { severity, key, values }.
        //   severity: 'success' | 'warning' | 'error'  → drives the message colour
        //   key:      i18n key for the message
        //   values:   interpolation values for the key (slug, count)
        // The backend runs these commands with ignore_errors, and `wp plugin deactivate`
        // exits 0 even for already-inactive plugins, so op.status alone can't tell us what
        // happened — we classify by parsing the WP-CLI output in op.msgs.
        vm.deactivate_plugin_feedback  = null;
        var deactivate_plugin_op_pending = false;
        var deactivate_plugin_mode = null; // 'single' | 'all'

        // A single WordPress plugin slug: lowercase alphanumerics with dashes/underscores.
        // The backend command substitutes the value directly into a shell command template
        // ("wp plugin deactivate {{slug}} --skip-plugins"), so the slug is validated in the
        // modal (ng-pattern) and re-checked here before dispatch — we must never let
        // whitespace or shell metacharacters through.
        var PLUGIN_SLUG_RE = /^[a-z0-9][a-z0-9_-]*$/;

        vm.open_deactivate_plugin = function () {
            if (vm.deactivate_plugin_running || vm.is_operating) { return; }
            var modal = $uibModal.open({
                backdrop: true,
                backdropClass: 'show',
                windowClass: 'd-flex justify-content-center align-items-center',
                animation: true,
                templateUrl: 'app/main/website/newdesign/tools-deactivate-plugin-modal.html',
                controller: 'DeactivatePluginModalController',
                controllerAs: 'vm'
            });
            modal.result.then(function (slug) {
                run_deactivate_plugin(slug);
            }, angular.noop);
        };

        vm.confirm_deactivate_all_plugins = function () {
            if (vm.deactivate_plugin_running || vm.is_operating) { return; }
            vm.confirm('TOOLS.DEACTIVATE_PLUGIN.CONFIRM_ALL_TITLE',
                       'TOOLS.DEACTIVATE_PLUGIN.CONFIRM_ALL_TEXT').then(function () {
                run_deactivate_all_plugins();
            }, angular.noop);
        };

        function run_deactivate_plugin(rawSlug) {
            var slug = (rawSlug || '').trim();
            if (!PLUGIN_SLUG_RE.test(slug)) { return; }
            if (vm.deactivate_plugin_running || vm.is_operating) { return; }
            deactivate_plugin_mode = 'single';
            vm.deactivate_plugin_last_slug = slug;
            dispatch_deactivate('wpcli.plugin-deactivate', { slug: slug });
        }

        function run_deactivate_all_plugins() {
            if (vm.deactivate_plugin_running || vm.is_operating) { return; }
            deactivate_plugin_mode = 'all';
            dispatch_deactivate('wpcli.plugin-deactivate-all', {});
        }

        function dispatch_deactivate(command, opts) {
            vm.deactivate_plugin_running  = true;
            vm.deactivate_plugin_feedback = null;
            deactivate_plugin_op_pending  = true;
            UserCommand.run(vm, command, opts).then(function () {
                vm._suppress_op_id = vm.obj.operation && vm.obj.operation._id;
            }).catch(function () {
                deactivate_plugin_op_pending = false;
                vm.deactivate_plugin_running = false;
                vm.deactivate_plugin_feedback = { severity: 'error', key: 'TOOLS.DEACTIVATE_PLUGIN.ERROR' };
                vm._suppress_op_id = null;
            });
        }

        scope.$watch('vm.obj.operation', function (op) {
            if (!deactivate_plugin_op_pending || !op) { return; }
            if (op.complete) {
                deactivate_plugin_op_pending = false;
                vm.deactivate_plugin_running = false;
                vm._suppress_op_id = null;
                vm.deactivate_plugin_feedback = deactivate_plugin_mode === 'all'
                    ? classifyDeactivateAll(op)
                    : classifyDeactivateSingle(op);
            }
        }, true);

        function opText(op) {
            var text = '';
            angular.forEach(op && op.msgs, function (msg) {
                text += String((msg && msg.msg) ? msg.msg : msg) + '\n';
            });
            return text.toLowerCase();
        }

        // Classify a completed single-plugin deactivation by inspecting the WP-CLI output.
        // WP-CLI's message wording is stable across versions, so we match on the
        // distinctive fragments it emits for each outcome.
        function classifyDeactivateSingle(op) {
            if (op && op.status === 'error') { return { severity: 'error', key: 'TOOLS.DEACTIVATE_PLUGIN.ERROR' }; }
            var lower = opText(op);
            function has(needle) { return lower.indexOf(needle) !== -1; }
            var values = { slug: vm.deactivate_plugin_last_slug };

            // Order matters: a not-found run also emits "Error: No plugins deactivated",
            // and an already-inactive run also emits a "Warning:", so the specific
            // diagnoses must be checked before the generic error/success signals.
            if (has('could not be found') || has("isn't installed") || has('is not installed')) {
                return { severity: 'error', key: 'TOOLS.DEACTIVATE_PLUGIN.NOT_FOUND', values: values };
            }
            if (has("isn't active") || has('is not active') || has('already deactivated')) {
                return { severity: 'warning', key: 'TOOLS.DEACTIVATE_PLUGIN.ALREADY_INACTIVE', values: values };
            }
            if (has('success:') || has('deactivated 1 of') || has('deactivated.')) {
                return { severity: 'success', key: 'TOOLS.DEACTIVATE_PLUGIN.SUCCESS', values: values };
            }
            if (has('failed to complete') || has('error:')) {
                return { severity: 'error', key: 'TOOLS.DEACTIVATE_PLUGIN.ERROR' };
            }
            return { severity: 'warning', key: 'TOOLS.DEACTIVATE_PLUGIN.UNKNOWN' };
        }

        // Classify a completed "deactivate all" run. WP-CLI emits
        // "Success: Deactivated N of M plugins." (or a warning when nothing was active).
        function classifyDeactivateAll(op) {
            if (op && op.status === 'error') { return { severity: 'error', key: 'TOOLS.DEACTIVATE_PLUGIN.ERROR' }; }
            var lower = opText(op);
            function has(needle) { return lower.indexOf(needle) !== -1; }

            var m = lower.match(/deactivated\s+(\d+)\s+of\s+(\d+)/);
            if (m && parseInt(m[1], 10) > 0) {
                return { severity: 'success', key: 'TOOLS.DEACTIVATE_PLUGIN.SUCCESS_ALL', values: { count: parseInt(m[1], 10) } };
            }
            // "Success: Plugins already deactivated." — nothing was active.
            if (has('already deactivated') || has('no plugins') || has("aren't active") ||
                has('are not active') || (m && parseInt(m[1], 10) === 0)) {
                return { severity: 'warning', key: 'TOOLS.DEACTIVATE_PLUGIN.ALL_ALREADY_INACTIVE' };
            }
            if (has('success:')) {
                return { severity: 'success', key: 'TOOLS.DEACTIVATE_PLUGIN.SUCCESS_ALL_GENERIC' };
            }
            if (has('failed to complete') || has('error:')) {
                return { severity: 'error', key: 'TOOLS.DEACTIVATE_PLUGIN.ERROR' };
            }
            return { severity: 'warning', key: 'TOOLS.DEACTIVATE_PLUGIN.UNKNOWN' };
        }
        // --- End Deactivate Plugin ---

        // --- Deactivate Maintenance Mode ---
        // When a WordPress update is interrupted the site can get stuck showing the
        // "Briefly unavailable for scheduled maintenance" page. This tool runs the
        // wpcli.maintenance-mode.deactivate command (no options) to clear it.
        //
        // Same plumbing as Deactivate Plugin: dispatch via UserCommand, suppress the
        // top banner for our specific op (_suppress_op_id), then classify the WP-CLI
        // output in op.msgs because the command runs with ignore_errors and returns 0
        // even when the site wasn't in maintenance mode.
        //   feedback shape: { severity: 'success' | 'warning' | 'error', key }
        vm.maintenance_mode_running  = false;
        vm.maintenance_mode_feedback = null;
        var maintenance_mode_op_pending = false;

        vm.run_deactivate_maintenance = function () {
            if (vm.maintenance_mode_running || vm.is_operating) { return; }
            vm.maintenance_mode_running  = true;
            vm.maintenance_mode_feedback = null;
            maintenance_mode_op_pending  = true;
            UserCommand.run(vm, 'wpcli.maintenance-mode.deactivate', {}).then(function () {
                vm._suppress_op_id = vm.obj.operation && vm.obj.operation._id;
            }).catch(function () {
                maintenance_mode_op_pending  = false;
                vm.maintenance_mode_running  = false;
                vm.maintenance_mode_feedback = { severity: 'error', key: 'TOOLS.DEACTIVATE_MAINTENANCE_MODE.ERROR' };
                vm._suppress_op_id = null;
            });
        };

        scope.$watch('vm.obj.operation', function (op) {
            if (!maintenance_mode_op_pending || !op) { return; }
            if (op.complete) {
                maintenance_mode_op_pending  = false;
                vm.maintenance_mode_running  = false;
                vm._suppress_op_id = null;
                vm.maintenance_mode_feedback = classifyMaintenanceDeactivate(op);
            }
        }, true);

        // WP-CLI's `wp maintenance-mode deactivate` emits a stable message per outcome:
        //   "Success: Deactivated Maintenance mode."          → success
        //   "Error: Maintenance mode already deactivated."    → already off (warning)
        //
        // Gotcha: when the .maintenance file exists but holds a corrupt (non-numeric)
        // timestamp, WP-CLI can't process it and emits
        //   "Warning: Unable to read the maintenance file timestamp, non-numeric value detected."
        //   "Error: Maintenance mode already deactivated."
        // The site IS still stuck, so the "already deactivated" error is misleading here —
        // we must surface this as a real failure, not a benign "already off". Check for the
        // maintenance-file warning before the generic "already deactivated" branch.
        function classifyMaintenanceDeactivate(op) {
            if (op && op.status === 'error') { return { severity: 'error', key: 'TOOLS.DEACTIVATE_MAINTENANCE_MODE.ERROR' }; }
            var lower = opText(op);
            function has(needle) { return lower.indexOf(needle) !== -1; }

            if (has('maintenance file timestamp') || has('unable to read the maintenance')) {
                return { severity: 'error', key: 'TOOLS.DEACTIVATE_MAINTENANCE_MODE.ERROR' };
            }
            if (has('already deactivated') || has('not in maintenance') || has('is not active')) {
                return { severity: 'warning', key: 'TOOLS.DEACTIVATE_MAINTENANCE_MODE.ALREADY_OFF' };
            }
            if (has('deactivated maintenance') || has('success:')) {
                return { severity: 'success', key: 'TOOLS.DEACTIVATE_MAINTENANCE_MODE.SUCCESS' };
            }
            if (has('failed to complete') || has('error:')) {
                return { severity: 'error', key: 'TOOLS.DEACTIVATE_MAINTENANCE_MODE.ERROR' };
            }
            return { severity: 'warning', key: 'TOOLS.DEACTIVATE_MAINTENANCE_MODE.UNKNOWN' };
        }
        // --- End Deactivate Maintenance Mode ---

        vm.get_main=function() {
           return vm.obj && vm.obj.main_app || vm.obj
       }
       vm.set_ssh=function (obj) {
           vm.ssh_password = obj.ssh_password
           var main_app=obj.main_app
           if (main_app && (!obj.fileowner && !main_app.fileowner || obj.fileowner==main_app.fileowner)) {
               vm.ssh_password = obj.main_app.ssh_password
           }
           if (vm.ssh_password && !vm.ssh_password.user) { vm.ssh_password.user='woouser'}
           if (obj.is_container_app()) {
               vm.ssh_password.url='true'
               var live=obj.live_app
               if(live&&live.ssh_password) {
                   vm.ssh_password.password=live.ssh_password.password
                   vm.ssh_password.enabled=live.ssh_password.enabled
               }
           }
           var port=vm.ssh_password && !vm.ssh_password.hostname && vm.ssh_password.port||22
           var user=vm.ssh_password && vm.ssh_password.user||'woouser'
           var webroot=obj.webroot||'wordpress'
           //debugger
           var host=vm.ssh_password && vm.ssh_password.hostname||obj.server&&(obj.server.hostname || obj.server.ip4)||obj.ip4||'undefined'
           host=host.split(':')
           if(host.length>1) {
                port=host[1]
                host=host[0]
           } else {
                host=host[0]
           }
           host = host.split('@')
           if(host.length>1) {
                user=host[0]
                host=host[1]
           } else {
                host=host[0]
           }

           obj.ssh_host=host
           obj.ssh_port=port
           obj.ssh_user=user

           var sshfs='sshfs -p '+port+' -o reconnect,ServerAliveInterval=15,ServerAliveCountMax=3'
           obj.sshfs=sshfs+user+'@'+obj.ssh_host+':/home/'+user+' ~/templ-mounts/' + webroot
           obj.sshL='ssh -p '+port+' '+user+'@'+obj.ssh_host +' -L127.0.0.1:3306:/var/run/mysqld/mysqld.sock'

           obj.ssh_command='ssh -p '+port+' '+user+'@'+obj.ssh_host
           obj.ssh_config='Host '+obj.domainn+'\n  HostName '+obj.ssh_host+'\n  Port '+port+'\n  User '+user

           obj.ssh_tool_tab = 'command'

           obj.ssh_tool_show_command = function() {
            obj.ssh_tool_tab = 'command'
           }

           obj.ssh_tool_show_config = function() {
            obj.ssh_tool_tab = 'config'
           }

       }
       vm.open_ssh=function() {
           if(vm.ssh_password.enabled) {
               var url='https://'+obj.container.manager.domainn+'/wssh/?'
               url += 'hostname=localhost'
               url += '&username='+vm.ssh_password.user
               var port=vm.ssh_password.port
               if(!port) {
                   port=22000 + obj.container.N
                   if(obj.app_class=='staging') {
                       port += 1000
                   }
               }
               url += '&port='+port
               var encoded=btoa(vm.ssh_password.password)
               url += '&password='+encoded
               $win.open(url, "popup", "location=0,width=1200,height=600,left=10,top=150");
               return
           }
           vm.getAP('ssh').action(null,obj)
       }
       vm.toggle_pw=function(name) {
           vm.show_password=vm.show_password||{}
           vm.show_password[name]=!vm.show_password[name]
       }
       vm.show_status=function() {
           // Suppress the banner when the in-flight op is one we dispatched via
           // UserCommand and already have dedicated loading UI for (see _suppress_op_id).
           var op=vm.obj && vm.obj.operation
           if (vm._suppress_op_id && op && op._id === vm._suppress_op_id && !op.complete) {
               return false;
           }
           return op && !op.complete || vm.show_op(op)
       }
       vm.set_ssh(obj)
       vm.title=obj.name
       vm.no_edit=true
       function count_incidents(obj) {
           if (!vm.isAdmin) {
               obj.incidents=obj.incidents && obj.incidents.filter(function(i){
                   return ["disk_check","wpvulndb"].includes(i.kind)
               })
           } else {
               obj.incidents=obj.incidents && obj.incidents.map(function(i){
                   if (!["disk_check","wpvulndb"].includes(i.kind)) {
                       i.admin_only=1
                   }
                   return i
               })

           }
           vm.incident_count=obj.incidents && obj.incidents.length||0
       }
       vm.object_callback=function(obj) {
           vm.APs=getAPs(vm,obj)
           vm.set_thumb()
           vm.title=obj.name
           vm.set_ssh(obj)
           count_incidents(obj)
       }
       //filter_incidents(obj)
       vm.Object=obj
       vm.APs=getAPs(vm,obj)
       vm.Form=form
       vm.scope=scope
       vm.api=m
       vm.toggleSidenav=function() {
       }
       vm.tabs=[
           {name:'overview',title:'OVERVIEW'},
           {name:'backup',title:'BACKUP'},
           {name:'staging',title:'STAGING'},
           {name:'plan',title:'PLAN'},
           {name:'import',title:'IMPORT_MENU_TITLE'},
           {
               name:'incidents',title:'INCIDENTS_TAB_BUTTON',admin:true,
               count:{field:'incident_count'}
           },
           // {name:'location',title:'LOCATION'},
           {name:'stats',title:'STATS'},
            {name:'tools',title:'TOOLS.TITLE',new:true},
            {name:'logs',title:'LOGS.TITLE',new:true},
        //    {name:'advanced',title:'ADVANCED',admin:true},
           {name:'advanced',title:'ADVANCED.MENU_TITLE'},
           {name:'extended_support',title:'EXTENDED_SUPPORT.EXTENDED_SUPPORT_TITLE'},
           {name:'blueprints',title:'BLUEPRINTS.MENU_TITLE'},
       ]/*
       vm.hide_tab=function(tab) {
           return tab.name=='incidents' && (!vm.isAdmin || !(vm.Object.incidents&&vm.Object.incidents.length>0))
       }*/
       vm.selected=$location.hash() || 'overview'
       vm.selectTab=function(tab) {
           vm.selected=tab
           $location.hash(tab)
       }
       vm.scope.$watch(function() {
           return $location.hash()
       },
       function () {
           console.log('hash changed',$location.hash());
           var hash=$location.hash() || 'overview'
           if(hash!=vm.selected) vm.selected=hash
       })

       vm.create_backup=gotoState(state,'.backup',{id:obj._id})
       vm.restore_backup=gotoState(state,'.restore',{id:obj._id})
       vm.backups_id = obj.backup_schedules && obj.backup_schedules._id || 0
       vm.start_app = function () {
           vm.obj['app-start']=1
           vm.save()
       }
       vm.stop_app = function () {
           vm.obj['app-stop']=1
           vm.save()
       }
       vm.restart_app = function () {
           vm.obj['restart']=1
           //vm.obj['app-start']=1
           vm.save()
       }
       vm.get_disk_usage=function() {
           var q=(vm.obj.disk_usage||0)/((vm.obj.disk_size||10)*1024*1024)
           return Math.ceil(q *100) + "%"
       }
       vm.upgrade=function() {
           state.go('appf.website.upgrade',{id:vm.id})
       }
       vm.import=function() {
           state.go(siblingState(state,'.import'),{id:vm.id})
       }
       vm.migrate=function() {
           state.go(siblingState(state,'.migrate'),{id:vm.id})
       }
       vm.transferOwnership=function() {
            var domain = vm.obj.domainn
             var message = $translate.instant('TRANSFER_OWNERSHIP.INTERCOM_MESSAGE', {domain:domain})
             ChatService.openWithMessage(message);
       }
       vm.relocate=function() {
           state.go(siblingState(state,'.relocate'),{id:vm.id})
       }
       vm.home_ref=function(){
           var home=getAP(vm.APs,'home')
           return home && home.url || '.'
       }
       vm.create_staging=function() {
           vm.goto('app.website.createStaging',{live_app:vm.obj._id})
       }
       vm.copy_to_staging=function() {
           vm.goto('app.website.copyToApp',{src:vm.obj._id,id:vm.obj.staging_app._id})
       }
       vm.copy_to_production=function() {
           vm.goto('app.website.copyToApp',{src:vm.obj.staging_app._id,id:vm.obj._id})
       }
       vm.go_to_staging=function() {
           vm.goto('app.website.details',{id:vm.obj.staging_app._id})
       }
       vm.go_to_production=function() {
            vm.goto('app.website.details',{id:vm.obj.live_app&&vm.obj.live_app._id || vm.obj.live_app ||vm.obj.copy_from.app})
       }

       add_backup_hour(vm,obj,scope)

       var data=state.current.data
       data.next_state = {save:siblingState(state,'.processing'),cancel:siblingState(state,'.list')}
       data.details_controller=vm
       ctrl(vm,data)
       vm.set_thumb()
       if(vm.sharing&&!vm.sharing.share_all) {
           vm.disable_billing=true
           vm.disable_create_staging=true
       }

       vm.edit=gotoState(state,'.edit',{id:vm.Object._id})
       vm.editing=false
       vm.extra_buttons=[
           {label:'WEBSITE.DETAILS.RESTART_BUTTON',action:function() {vm.restart_app()},hidden:vm.obj.stopped},
           {label:'WEBSITE.DETAILS.IMPORT_BUTTON',action:function() {vm.import()},hidden:vm.obj.stopped}
       ]
       vm.started=function(){ return !vm.obj.stopped}
       vm.stopped=function(){ return vm.obj.stopped}
       if (vm.isAdmin && typeof(__LOCAL__)!=="undefined") {
           vm.test_polling=function () {
               vm.obj.test_polling=1
               vm.save()
           }
       }
       vm.get_included_disk=function() {
            var obj=vm.obj
            var disk_addon = obj.plan.addons.find(function(addon) { return addon.code == 'disk' })
            return disk_addon.includes
       }
       vm.has_upgraded_disk=function() {
            var obj=vm.obj
            return vm.get_included_disk() < obj.disk_size
       }
        vm.get_additional_disk=function() {
            var obj=vm.obj
            var disk_addon = obj.plan.addons.find(function(addon) { return addon.code == 'disk' })
            var disk_included = disk_addon.includes
            return obj.disk_size - disk_included
        }
        // Toggle between relative and absolute webroot
        vm.webroot = obj.webroot
        vm.toggleWebroot = function() {
            if(vm.webroot == obj.webroot) {
                var user=vm.ssh_password && vm.ssh_password.user||'woouser'
                var webroot=obj.webroot||'wordpress'
                vm.webroot='/home/'+user+'/'+webroot+'/'
            } else {
                vm.webroot = obj.webroot
            }
        }
        vm.getFlag=utils.getFlag
        vm.get_app_class=function() {
            if(obj.app_class=='live' && vm.plan_code!='dev-sm01' && vm.plan_code!='dev-micro' && vm.plan_code!='blueprint') {
                return 'production'
            } else if(obj.app_class=='staging' && vm.plan_code!='dev-sm01' && vm.plan_code!='dev-micro') {
                return 'staging'
            } else if(vm.plan_code=='dev-sm01' || vm.plan_code=='dev-micro' || vm.plan_code=='blueprint') {
                return 'development'
            }
            return 'unknown'
        }
        vm.get_plan_name=function() {
            if(vm.plan_name && vm.plan_code!='dev-sm01' && vm.plan_code!='dev-micro') {
                return vm.plan_name
            } else if(vm.plan_name && vm.plan_code=='dev-micro') {
                return 'WEBSITE.SELECT_VALUES.PLAN.MICRO'
            } else if(vm.plan_name && vm.plan_code=='dev-sm01') {
                return 'WEBSITE.SELECT_VALUES.PLAN.SM01'
            } else {
                return 'unknown'
            }
        }
        vm.has_staging=function() {
            return !!obj.staging_app
        }
        vm.is_staging=function() {
            return vm.get_app_class()=='staging'
        }
        vm.staging_copy_direction = 'production-to-staging';
        vm.do_copy = function() {
            var obj = vm.obj
            var production_app_id = vm.get_app_class() == 'production' || vm.get_app_class() == 'development' ? obj._id : obj.live_app && obj.live_app._id
            var staging_app_id = vm.get_app_class() == 'production' || vm.get_app_class() == 'development' ? obj.staging_app._id : obj._id
            if(vm.staging_copy_direction == 'staging-to-production') {
                vm.goto('app.website.copyToApp',{src:staging_app_id, id:production_app_id})
            } else {
                vm.goto('app.website.copyToApp',{src:production_app_id, id:staging_app_id})
            }
        }
   }

   function edit(DomainLoader,utils,ctrl,scope,state,obj,form,m,$translate) {
       var vm=this;
       vm.layout='app/main/website/website-create.html'
       vm.extra_buttons='app/main/website/website-edit-buttons.html'
       vm.title='WEBSITE.EDIT_TITLE'
       form.fields=['name','domainn','app_admin','http_auth']

       // Use ui-select
       var docs = form.values && form.values.domainn || {}
       if(!docs.page) docs= {docs:docs}
       docs.res=function(res) {
           var l=[]
           angular.forEach(res,function(d) {
               l.push(d.name)
           })
           return l
       }
       form.refresh={domainn:function refresh_domains(search,scrolling) {
           DomainLoader(docs,search,scrolling)
       }}
       form.values.domainn=docs
       form.type.domainn='ui-select'

       var main_app=obj.main_app
       if (main_app && (!obj.fileowner && !main_app.fileowner || obj.fileowner==main_app.fileowner)) {
           form.fields.push('ssh_password_addon')
           form.type.ssh_password_addon='sref-note'
           form.sref={
               ssh_password_addon:'app.website.edit'
           }
           form.sref_id={
               ssh_password_addon:obj.main_app._id
           }
           form.sref_text={
               ssh_password_addon:"WEBSITE.HELP_LINK_TEXT.SSH_PASSWORD_ADDON"
           }
       } else if (obj.live_app) {
           form.fields.push('ssh_password_staging')
           form.type.ssh_password_staging='sref-note'
           form.sref={
               ssh_password_staging:'app.website.edit'
           }
           form.sref_id={
               ssh_password_staging:obj.live_app
           }
           form.sref_text={
               ssh_password_staging:"WEBSITE.HELP_LINK_TEXT.SSH_PASSWORD_STAGING"
           }
       } else {
           form.fields.push('ssh_password')
           if (!obj.ssh_password || !obj.ssh_password.user) {
               obj.ssh_password = obj.ssh_password || {}
               obj.ssh_password.user=obj.fileowner || 'woouser'
           }
       }
       form.disabled=Object.assign({'lcode':1},form.disabled||{})
       vm.restart_app = function () {
           vm.obj['restart']=1
           //vm.obj['app-start']=1
           vm.save()
       }

       vm.Object=obj
       utils.addFormLabels('WEBSITE',form)
       utils.addFormLabels('WEBSITE.APP_ADMIN',form.subforms['app_admin'])
       form.note.domainn = $translate.instant('WEBSITE.NOTES.DOMAINN', {link: '/domain/list/'})
       vm.Form=form
       vm.scope=scope
       vm.api=m
       ctrl(vm,state.current.data)
       if(obj.app_class=='staging') {
           form.disabled.name=true
           form.description.name="WEBSITE.DESCRIPTIONS.STAGING_NAME"
           //Allow some users to change domain
           if(form.disabled&&form.disabled.domainn) {
               form.description.domainn="WEBSITE.DESCRIPTIONS.STAGING_DOMAIN"
           }
           //form.disabled.domainn=true
           //form.description.domainn="WEBSITE.DESCRIPTIONS.STAGING_DOMAIN"
       }
       vm.continue=vm.save
       vm.editing=false
   }

   function import_site(wtUtils,WooModelEditController,Links,WooApp,$scope,$state,UserInfo,Obj) {
       var vm = this;
       vm.layout='app/main/website/website-import.html'
       vm.scope=$scope
       vm.api=WooApp
       Obj.import_from=Obj.import_from||{kind:"backup"}
       vm.Object=Obj
       vm.form_obj=Obj.import_from
       vm.Form = {
           fields:["kind","url"],
           type:{kind:"select"},
           values:{kind:[
               {name:"Templ backup",value:"backup"},
               {name:"Duplicator",value:"duplicator"},
           ]},
           hidden:{"url":1},
           optional:{"url":1}
           ,help_link:Links.app.import && Links.app.import.help_link
           ,pattern:{url:"(file:///|https?://).*(zip|tgz)"}
           ,pattern_error:{url:"VALIDATION.INVALID_IMPORT_URL"}
       }
       wtUtils.addFormLabels('WEBSITE.IMPORT',vm.Form)
       var data={
           populate:['operation','location','plan'],
           next_state : {save:siblingState($state,'.processing')}
       }
       vm.continue=function() {
           vm.form_obj.completed=false
           vm.save()
       }
       if(waiting_for_payment(Obj)) {
           return vm.continue()
       }
       function update() {
           //console.log("Updated",vm.import_from.kind);
           if(['duplicator','backup'].indexOf(vm.form_obj.kind)>=0) {
               vm.form.hidden.url=false
               vm.form.optional.url=false
           } else {
               vm.form.hidden.url=false
               vm.form.optional.url=false
           }
       }
       vm.scope.$watch('vm.form_obj.kind',update)

       vm.title="WEBSITE.IMPORT.TITLE"
       vm.breadcrumbs = [
            {label:"BREADCRUMBS.WEBSITES", url: $state.href('app.website.list')},
            {label:Obj.name, url: $state.href('app.website.details', {id: Obj._id})},
            {label:"IMPORT_MENU_TITLE", url: $state.href('app.website.details', {id: Obj._id}) + '#import'},
            {label:"BREADCRUMBS.IMPORT"}
       ]
       WooModelEditController(vm,data)
       vm.editing=false
   }

   function relocate_site(wtUtils,WooModelEditController,WooApp,$scope,$state,UserInfo,Billing,Pricing,Form,Obj) {
       var vm = this;
       vm.layout='app/main/layouts/wt-unsupported.html'
       //vm.layout='app/main/website/website-create.html'
       vm.scope=$scope
       vm.api=WooApp
       vm.Object=Obj
       var data={
           populate:['operation','location','plan']
       }
       initForm(wtUtils,vm,Form)
       Form.fields=['lcode']
       wtUtils.addFormLabels('WEBSITE',Form)
       vm.Form=Form
       vm.is_trial=UserInfo.is_trial
       vm.continue=function() {
           $state.go('app.website.details',{id:vm.Object._id},{location:'replace'})
       }
       if(waiting_for_payment(Obj)) {
           return vm.continue()
       }

       WooModelEditController(vm,data)
       if(!vm.is_trial) {
           vm.obj.orig_disk_size=vm.obj.disk_size
           add_pricing(vm,wtUtils,vm.obj,Form,Pricing,UserInfo,Billing)
       }


       vm.title="WEBSITE.RELOCATE"
   }

   function api($http,ErrorDialog) {
       function restart(app, cb) {
           return $http.get(API_HOST+"/api/app/restart/"+app._id).then(
               function (res) {
                   if (res) {
                       res=res.data
                   }
                   if (res) {
                       if (res.op) {
                           cb(res.op)
                           return
                       } else if (res.error) {
                          ErrorDialog("Operation failed: " + res.error)
                          cb()
                          return
                      }
                   }
                   ErrorDialog("Operation failed: " + res)
                   cb()
               },
               function(err) {
                   ErrorDialog("Operation failed: " + err)
                   cb()
               }
           )
       }
       return {restart:restart}
   }

   function getAP(aps,type) {
       return _.find(aps,function(ap){ return ap.type==type })
   }
   function getAPs(win,location) {
       return function(vm,obj) {
           function getData(ap,app,auth) {
               var data={
                   id:app._id,
                   user:app.user,
                   redirect:1,
                   path:ap.path||'',
                   auth:auth||''
               }
               if(!app.resolved) {
                   data.test='.assets/app'+app._id+'.json'
               }
               return data
           }
           function getLauncher(data) {
               var host = location.host()
               var launcher='/launcher/launch?'
               if(data && data.auth_type=='tfm') launcher='/apps/launcher/?'
               if (host=='test.templ.io') {
                   launcher=':4200/launch?'
                   if(data && data.auth_type=='tfm') launcher=':4200/apps/launcher/?'
                }
               return location.protocol()+'://'+host + launcher
           }

           function getUrl(app,data) {
               var url='https://'+app.domainn+'/'+data.path
               if (app.version<4.1 || vm.disable_launcher || app.resolved && !data.auth ) {
                   return url
               }
               url += '?'
               if( app.resolved  && !data.auth_type ) {
                   var token=app.auth_token
                   if(token && token.name && token.expires && moment(token.expires)>moment()) {
                       data={'wt-token':token.name,'wt-login':app.app_admin.username}
                   } else {
                       // TEST:
                       //url='https://'+app.domainn+'?'

                       data.test=''
                       var json = JSON.stringify(data)
                       //console.log(json);
                       data = {'wt-check':json,'wt-login':app.app_admin.username,'wt-launcher':getLauncher()}
                   }
               } else {
                   url=getLauncher(data)
               }
               data=_.map(data,function(v,k){return k+'='+encodeURIComponent(v)})
               data = data.join('&')
               return url+data
           }

           function launch(ap,app,url) {
               var lwin=ap.type+"_wtapp"+app._id
               vm.launched=vm.launched||{}
               vm.launched[lwin]=window.open(url,lwin, ap.options)
           }

           function open(ap,app) {
               var url=getUrl(app,getData(ap,app))
               //console.log(url)
               launch(ap,app,url)
           }

           function openDB(ap,app) {
               if(!app.is_container_app()) return open(ap,app)

               var data=getData(ap,app)
               data.path='.sqladmin'
               data.auth=true
               data.auth_type='db'
               var url=getUrl(app,data)
               //console.log(url)
               launch(ap,app,url)
           }

           function openFM(ap,app) {
                if(!app.is_container_app()) return open(ap,app)

                var data=getData(ap,app)
                data.auth=true
                data.auth_type='tfm'
                var url=getUrl(app,data)
                //console.log(url)
                launch(ap,app,url)
            }

           function openSSH(ap,app) {
               //alert('Open SSH with launcher')
               var data=getData(ap,app)
               data.path='wssh'
               data.auth=true
               data.auth_type='ssh'
               data.iframe=true
               var url=getUrl(app,data)
               //console.log(url)
               launch(ap,app,url)
           }
           function openAuth(ap,app) {
               var url=getUrl(app,getData(ap,app,true))
               //console.log(url)
               launch(ap,app,url)
           }

           var menu = []
           var web
           var scheme='http'
           if(obj.https) {
               scheme='https'
           }
           for ( var ap in obj.accessPoints) {
               ap=obj.accessPoints[ap]
               if (ap.name) {
                   menu.push( new AccessPoint(ap.name,ap.type,scheme,ap.path,ap.auth?openAuth:open) );
               } else if (ap.sort=='domain') {
                   web=ap
               } else if (ap.sort=='ip4') {
                   web=web || ap
                   obj.ip4=ap.value
               } else if (ap.sort=='dedicatedIP') {
                   web=web || ap
                   obj.ip4_dedicated=ap.value
               } else if (ap.sort=='fullPageCdn') {
                   web=web || ap
                   obj.ip4_fpcdn=ap.value
               }
           }

           if (web) {
                menu.push(new AccessPoint(
                    obj.domainn,
                    'home',scheme,'',open)
                )
                menu.push(new AccessPoint(
                    'WEBSITE.DETAILS.WP_ADMIN_BUTTON',
                    'admin',scheme,obj.app_admin && obj.app_admin.path||'wp-admin/',openAuth)
                )
                menu.push(new AccessPoint(
                    'WEBSITE.DETAILS.DB_ADMIN_BUTTON',
                    'sql',scheme,'.sqladmin/',openDB)
                )
                menu.push(new AccessPoint(
                    'WEBSITE.DETAILS.FILE_MANAGER_BUTTON',
                    'tfm','https','',openFM)
                )
                menu.push(new AccessPoint(
                    'WEBSITE.OPEN_SSH_IN_BROWSER',
                    'ssh',scheme,'wssh/',openSSH,"location=0,width=1200,height=600,left=10,top=150")
                )
           }
           return menu
       }
   }

    function list(ctrl,scope,rootScope,state,res,m,getAPs,count,wtUtils,$cookies,Pricing,WooModelListResolver) {
       var vm = this;
       vm.dashboard='app/main/website/listdashboard.html'
       vm.rootScope=rootScope
       
       // Filter out blueprint websites from the list (they should only appear in the Blueprints section)
       // This fixes the issue where a user with only blueprints would see an empty table instead of the empty state graphic
       var filteredDocs = [];
       var blueprintCount = 0;
       for (var i=0; i<res.docs.length; i++) {
           if (res.docs[i].plan && res.docs[i].plan.code === 'blueprint') {
               blueprintCount++;
           } else {
               filteredDocs.push(res.docs[i]);
           }
       }
       res.docs = filteredDocs;
       
       // Adjust unfiltered count to exclude blueprints
       vm.nof_objects_unfiltered = (count && count.count || 0) - blueprintCount;

       vm.Title='WEBSITE.WEBSITES_TITLE'
       vm.empty_title='WEBSITE.EMPTY_TITLE'
       vm.empty_text='WEBSITE.EMPTY_TEXT'
       vm.scope=scope
       vm.prefix='WEBSITE.'
       vm.api=m; vm.res=res;
       vm.object_menu={}
       for (var i=0; i<res.docs.length; i++) {
           var obj=res.docs[i]
           var menu=getAPs(vm,obj)
           vm.object_menu[obj._id]=menu;
       }
       var model=state.current.data.model
       vm.model={}
       for (var l in model) {
           vm.model[l] = model[l]
       }
       var data=state.current.data
       data.substates = {edit:siblingState(state,'.details'),create:siblingState(state,'.create')}
       ctrl(vm,data)
       vm.extra_buttons=[{
           name:'WEBSITE.MIGRATE_BUTTON'
           ,fun:function() {
               gotoState(state,'.migrate')()
           },
           class:'wt-secondbtn',
           disabled:vm.sharing&&!vm.sharing.share_all
       },{
           name:'WEBSITE.UPDATE_WORDPRESS'
           ,sref:'app.wordpress.list'
           ,class:'wt-secondbtn'
           ,skip_on_empty:1
           ,adminOnly:1
       }]
       //vm.list.filter=true
       vm.list.filter_template='app/main/website/list_filter.html'
       vm.list.filters=state.current.data.filters
        vm.list.tableClass='website-list website-list--full'

       // Column configuration
       var COLUMN_COOKIE_KEY = 'templ_website_columns';
       vm.columnConfig = [
            {id: 'name', label: 'WEBSITE.LIST.NAME', locked: true, sortField: 'name__sort'},
            {id: 'domain', label: 'WEBSITE.LIST.DOMAIN', defaultVisible: true, sortField: 'domainn'},
            {id: 'plan', label: 'WEBSITE.LIST.PLAN', defaultVisible: true, sortField: 'pcode'},
            {id: 'location', label: 'WEBSITE.LIST.LOCATION', defaultVisible: true, sortField: 'lcode'},
            {id: 'disk', label: 'WEBSITE.LIST.DISK', defaultVisible: true, sortField: 'disk_usage', tooltip: 'WEBSITE.TOOLTIPS.DISK_USAGE'},
            {id: 'php', label: 'WEBSITE.LIST.PHP', defaultVisible: false, sortField: 'settings.phpgeneral.version', tooltip: 'WEBSITE.TOOLTIPS.PHP_VERSION'},
            {id: 'version', label: 'WEBSITE.LIST.VERSION', defaultVisible: false, sortField: 'settings.wp.version', tooltip: 'WEBSITE.TOOLTIPS.WP_VERSION'},
            {id: 'ip', label: 'WEBSITE.LIST.IP', defaultVisible: false},
            {id: 'created', label: 'WEBSITE.LIST.CREATED', defaultVisible: false, sortField: 'created'},
            {id: 'status', label: 'WEBSITE.LIST.STATUS', locked: true}
        ];

       // Initialize visible columns from cookie or defaults
       vm.visibleColumns = loadVisibleColumns();

       function getDefaultColumns() {
           var defaults = [];
           for (var i = 0; i < vm.columnConfig.length; i++) {
               var col = vm.columnConfig[i];
               if (col.locked || col.defaultVisible) {
                   defaults.push(col.id);
               }
           }
           return defaults;
       }

       function loadVisibleColumns() {
           var cookieValue = $cookies.get(COLUMN_COOKIE_KEY);
           if (cookieValue) {
               try {
                   var parsed = JSON.parse(cookieValue);
                   if (Array.isArray(parsed) && parsed.length > 0) {
                       // Validate IDs exist and ensure locked columns included
                       var validIds = vm.columnConfig.map(function(c) { return c.id; });
                       var filtered = parsed.filter(function(id) {
                           return validIds.indexOf(id) !== -1;
                       });
                       // Ensure locked columns are always included
                       for (var i = 0; i < vm.columnConfig.length; i++) {
                           var col = vm.columnConfig[i];
                           if (col.locked && filtered.indexOf(col.id) === -1) {
                               filtered.push(col.id);
                           }
                       }
                       return filtered;
                   }
               } catch (e) {
                   // Invalid cookie, use defaults
               }
           }
           return getDefaultColumns();
       }

       vm.isColumnVisible = function(columnId) {
           return vm.visibleColumns.indexOf(columnId) !== -1;
       };

       vm.onColumnsChange = function(columns) {
           vm.visibleColumns = columns;
           updateHeaders();
       };

       function updateHeaders() {
           vm.list.headers = [];
           for (var i = 0; i < vm.columnConfig.length; i++) {
               var col = vm.columnConfig[i];
               if (vm.isColumnVisible(col.id)) {
                   var header = {name: vm.translate(col.label), class: col.id};
                   if (col.tooltip) {
                       header.tooltip = col.tooltip;
                   }
                   vm.list.headers.push(header);
               }
           }
       }

       // Initialize headers
       updateHeaders();

       // Sort configuration
       var SORT_COOKIE_KEY = 'templ_website_sort';
       var DEFAULT_SORT_FIELD = 'created';
       var DEFAULT_SORT_ORDER = '-'; // descending (newest first)

       function loadSortPreference() {
           var cookieValue = $cookies.get(SORT_COOKIE_KEY);
           if (cookieValue) {
               try {
                   var parsed = JSON.parse(cookieValue);
                   if (parsed && parsed.field) {
                       return parsed;
                   }
               } catch (e) {
                   // Invalid cookie, use defaults
               }
           }
           return {field: DEFAULT_SORT_FIELD, order: DEFAULT_SORT_ORDER};
       }

       function saveSortPreference() {
           $cookies.put(SORT_COOKIE_KEY, JSON.stringify({
               field: vm.sortField,
               order: vm.sortOrder
           }));
       }

       var sortPref = loadSortPreference();
       vm.sortField = sortPref.field;
       vm.sortOrder = sortPref.order;

       // Set initial query with sort
       vm.query = vm.query || {};
       vm.query.sort = vm.sortOrder + vm.sortField;

       vm.toggleSort = function(col) {
           if (!col.sortField) return;

           if (vm.sortField === col.sortField) {
               // Toggle direction
               vm.sortOrder = vm.sortOrder === '' ? '-' : '';
           } else {
               // New field, default to ascending
               vm.sortField = col.sortField;
               vm.sortOrder = '';
           }

           // Update query and save preference
           vm.query.sort = vm.sortOrder + vm.sortField;
           saveSortPreference();

           // Reload list with new sort
           vm.reload(WooModelListResolver);
       };

       vm.isSortedBy = function(col) {
           return col.sortField && vm.sortField === col.sortField;
       };

       vm.isSortDesc = function() {
           return vm.sortOrder === '-';
       };

       vm.getColumnById = function(id) {
           for (var i = 0; i < vm.columnConfig.length; i++) {
               if (vm.columnConfig[i].id === id) {
                   return vm.columnConfig[i];
               }
           }
           return null;
       };

       // Populate location filter options
       var locationFilter = _.find(vm.list.filters, {name: 'location'});
       var pricingData = Pricing && Pricing.docs && Pricing.docs[0];
       if (locationFilter && pricingData && pricingData.location) {
           locationFilter.options = [{value: '', label: 'WEBSITE.FILTER.LOCATION_PLACEHOLDER'}];
           var locations = [];
           angular.forEach(pricingData.location, function(loc, code) {
               locations.push({value: code, label: loc.name});
           });
           // Sort locations alphabetically by name
           locations.sort(function(a, b) {
               return a.label.localeCompare(b.label);
           });
           locationFilter.options = locationFilter.options.concat(locations);
       }

           // Populate plan filter options (manual definition)
           var planFilter = _.find(vm.list.filters, {name: 'plan'});
           if (planFilter) {
               planFilter.options = [
                   {value: '', label: 'WEBSITE.FILTER.PLAN_PLACEHOLDER'},
                   {value: 'dev-micro', label: 'WEBSITE.SELECT_VALUES.PLAN.DEV-MICRO'},
                   {value: 'dev-sm01', label: 'WEBSITE.SELECT_VALUES.PLAN.DEV-SM01'},
                   {value: 'micro', label: 'WEBSITE.SELECT_VALUES.PLAN.MICRO'},
                   {value: 'sm01', label: 'WEBSITE.SELECT_VALUES.PLAN.SM01'},
                   {value: 'sm02', label: 'WEBSITE.SELECT_VALUES.PLAN.SM02'},
                   {value: 'med01', label: 'WEBSITE.SELECT_VALUES.PLAN.MED01'},
                   {value: 'lar01', label: 'WEBSITE.SELECT_VALUES.PLAN.LAR01'},
                   {value: 'custom', label: 'WEBSITE.SELECT_VALUES.PLAN.CUSTOM'},
               ];
           }

           // Populate app type filter options
           var appTypeFilter = _.find(vm.list.filters, {name: 'appType'});
           if (appTypeFilter) {
               appTypeFilter.options = [
                   {value: '', label: 'WEBSITE.FILTER.APP_TYPE_PLACEHOLDER'},
                   {value: 'live', label: 'WEBSITE.FILTER.APP_TYPE_PRODUCTION'},
                   {value: 'staging', label: 'WEBSITE.FILTER.APP_TYPE_STAGING'}
               ];
           }

       vm.list.headers_template='app/main/website/list_headers.html'
       vm.list.item_template='app/main/website/list_item.html'
       vm.empty_animation_template='app/main/animations/empty-websites.html'
       vm.getFlag=wtUtils.getFlag
       vm.getAP=function(label, obj) {
           var APs=getAPs(vm,obj)
           var AP=getAP(APs,label)
           return AP
       }
       vm.visitApp=function(obj) {
        var AP=vm.getAP('home',obj)
        AP.action(null,obj)
       }
       vm.wpAdmin=function(obj) {
        var AP=vm.getAP('admin',obj)
        AP.action(null,obj)
       }
       vm.fileManager=function(obj) {
        var AP=vm.getAP('tfm',obj)
        AP.action(null,obj)
       }
   }

   function blueprint(wtUtils,WooApp,$scope,$state,WooModelEditController,Links,Obj) {
       var vm = this;
       vm.layout='app/main/website/website-blueprint.html'
       vm.scope=$scope
       vm.api=WooApp
       vm.Object=Obj
       vm.form_obj={
            name:Obj.create_blueprint&&Obj.create_blueprint.name,
            exclude_files:Obj.create_blueprint&&Obj.create_blueprint.files&&Obj.create_blueprint.files.join('\n')||''
       }
       vm.Form = {
           fields:["name","exclude_files"],
           type:{exclude_files:"text"},
           optional:{exclude_files:1},
           //type:{remote:"checkbox"},
           help_link:Links.app.blueprint && Links.app.blueprint.help_link
       }
       if (Obj.app_class=='staging') {
           vm.Form.fields=["name"]
       }
       wtUtils.addFormLabels('WEBSITE.BLUEPRINT',vm.Form)
       // Force local backups for blueprint sites, and show a custom field description
       if (Obj.plan && Obj.plan.code == 'blueprint') {
           vm.Form.disabled = {
               remote: 1
           }
           //vm.Form.note.remote="WEBSITE.BLUEPRINT.REMOTE_BACKUPS_NOTE"
       }
       vm.title="WEBSITE.BLUEPRINT.TITLE"
       vm.breadcrumbs=[
            {label:"BREADCRUMBS.WEBSITES", url: $state.href('app.website.list')},
            {label:Obj.name, url: $state.href('app.website.details', {id: Obj._id})},
            //{label:"BACKUP", url: $state.href('app.website.details', {id: Obj._id}) + '#backup'},
             {label:"BREADCRUMBS.CREATE_BLUEPRINT"}
        ]
        vm.helpUrl="https://docs.templ.site/development/blueprints"
       WooModelEditController(vm,{
           next_state : {save:siblingState($state,'.processing')}
       })
       vm.continue=function() {
           vm.obj.create_blueprint={
                name:vm.form_obj.name,
                exclude_files:true,
                files:vm.form_obj.exclude_files&&vm.form_obj.exclude_files.split('\n')||undefined,
                completed:false
           }
           vm.save()
       }
       vm.editing=false
       vm.continue_button="WEBSITE.CONTINUE"
   }

   function backup(wtUtils,WooApp,$scope,$state,WooModelEditController,Links,Obj) {
       var vm = this;
       vm.layout='app/main/website/website-import.html'
       vm.scope=$scope
       vm.api=WooApp
       vm.Object=Obj
       vm.backup=vm.form_obj=Obj.create_backup||{}
       vm.backup.link=vm.backup.completed=null
       vm.backup.blueprint=false
       vm.Form = {
           fields:["name","remote"],
           type:{remote:"checkbox"}
           ,help_link:Links.app.backup && Links.app.backup.help_link
       }
       if (Obj.app_class=='staging') {
           vm.Form.fields=["name"]
       }
       wtUtils.addFormLabels('WEBSITE.BACKUP',vm.Form)
       // Force local backups for blueprint sites, and show a custom field description
       if (Obj.plan && Obj.plan.code == 'blueprint') {
           vm.Form.disabled = {
               remote: 1
           }
           vm.Form.note.remote="WEBSITE.BLUEPRINT.REMOTE_BACKUPS_NOTE"
       }
       vm.title="WEBSITE.BACKUP.TITLE"
       vm.breadcrumbs=[
            {label:"BREADCRUMBS.WEBSITES", url: $state.href('app.website.list')},
            {label:Obj.name, url: $state.href('app.website.details', {id: Obj._id})},
            {label:"BACKUP", url: $state.href('app.website.details', {id: Obj._id}) + '#backup'},
             {label:"BREADCRUMBS.CREATE_BACKUP"}
        ]
        vm.helpUrl="https://docs.templ.site/websites/backups/create-a-backup"
       WooModelEditController(vm,{
           next_state : {save:siblingState($state,'.processing')}
       })
       vm.continue=function() {
           vm.obj.create_backup=vm.backup
           vm.save()
       }
       vm.editing=false
       vm.continue_button="WEBSITE.CONTINUE"
   }
})();

(function ()
{
})();

(function ()
{
    'use strict';

    angular
        .module('app.usage', ['app.services'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msCacheProvider, msNavigationServiceProvider)
    {
        // State
/**/        $stateProvider
            .state('app.usage', {
                url    : '/usage',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'UsageController as vm'
                    }
                },
                resolve: {
                    Info: function (UserInfo)
                    {
                        return  UserInfo();
                    },
                    Quota: function (WooQuota,AuthService)
                    {
                        var args={user:AuthService.selectedUser(),fill:'templstatsData',page_size:-1}
                        return WooQuota.query(args).$promise
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/usage');

        // Api
        //msApiProvider.register('usage', ['app/data/usage/usage.json']);
        //msCacheProvider.register('usage', ['app/data/usage/usage.json'],{validity:180000});
        msCacheProvider.register('usage', ['api/wooquota'],{validity:30000});

/*
        msNavigationServiceProvider.saveItem('usage.bandwidth', {
            title    : 'BANDWIDTH',
            state    : 'app.usage_bandwidth',
            translate: 'USAGE.BANDWIDTH_NAV',
            //weight   : 1
        });
        */

        // templ-reports
        $stateProvider.state('app.usage.reports',{
            url:'/report/',
            //params:state.params,
            views:{
                'content@app':{
                    template:'<div id="templ-reports"></div>',
                    controller:['$scope','$rootScope','$state','$location','$translate','UserInfo',
                    function controller($scope,$rootScope,$state,$location,$translate, userInfo) {
                        console.log('Creating reports',$location.url(),window.location.href);
                        var app
                        reportsModule.init('#templ-reports',{
                            lang:$translate.use() || 'en',
                            userInfo:userInfo,
                            rootScope:$rootScope,
                            state:$state,
                        }).then(function (res) {
                            app=res
                        })
                        $scope.$on('$destroy',function() {
                            if(app) {
                                console.log('Destroying reports');
                                reportsModule.destroy(app)
                            }
                        })
                    }]
                }
            },
            resolve:{
                UserInfo: [
                    'UserInfo', function (info) {
                        return info();
                    }
                ]
            }
        })

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.usage')
        .controller('UsageController', UsageController);
        function daysInMonth(date) {
            return new Date(date.getYear(),date.getMonth()+1,0).getDate()
        }

        /** @ngInject */
        function UsageController(Info,Quota,AuthService)
        {
            var vm = this;
            Quota = Quota && Quota.docs && Quota.docs[0]||Quota

            vm.isAdmin=AuthService.isAdmin()
            vm.id=Info.data.quota._id
            vm.layout='app/main/usage/usage.html'
            // Data
            var quota = Info.data.quota.quota;
            var usage={}
            for (var u in quota ) {
                u = quota[u]

                if (u.label && !u.hidden) {
                    u.date=new Date(u.date)
                    usage[u.label]=u
                }
            }
            //debugger
            var bw=usage.bw
            // Data usage collected by new stats server
            if(Quota && Quota.templstatsData) bw.usage += (Quota.templstatsData.data||0)
            bw.overage_rate=0.20
            bw.current=Math.floor(bw.usage/(1024*1024))
            // Test
            //bw.current=1789
            var date = new Date()
            bw.projected=Math.floor(bw.current/(date.getDate())*daysInMonth(date))
            bw.month=moment(date).format("MMM, YYYY")
            bw.unit='MB'
            bw.overage=bw.projected>bw.max
            if (bw.current>5120) {

                bw.current=bw.current/1024
                bw.projected=bw.projected/1024
                bw.max=bw.max/1024
                usage.bw.unit='GB'

                bw.current=bw.current.toFixed(2)
                bw.projected=bw.projected.toFixed(2)
                bw.max=bw.max.toFixed(2)
            }
            // Add custom usages
            usage.bw_per_site = {
                label: 'bw_per_site'
            }
            // Remove usages that we don't want to display
            delete usage.apps
            delete usage.domains
            delete usage.emails
            // console.log('usage', usage)
            vm.usage=usage
        }

})();

(function ()
{
})();

(function ()
{
    'use strict';

    angular
        .module('app.vuln', ['app.wooadmin'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,
        Models)
    {
        var model = Models['WPVuln']
        var sub_data={
            //populate:['domain','operation']
        }
        var filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            },
            {
                name:'count',label:'COUNT_GTE',field:'site_count__$gte',kind:'input'
            },
            {name:'exploited',label:'Exploited',field:'severity',kind:'checkbox', multi:true, checked:true},
            {name:'critical',label:'Critical',field:'severity',kind:'checkbox', multi:true, checked:true},
            {name:'high',label:'High',field:'severity',kind:'checkbox', multi:true, },
            {name:'medium',label:'Medium',field:'severity',kind:'checkbox', multi:true, },
            {name:'low',label:'Low',field:'severity',kind:'checkbox', multi:true, },
        ]
        var site_filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            }
        ]
        // State
        $stateProvider
            .state('app.'+model.name, {
                url    : '/'+model.name,
                redirectTo: 'app.'+model.name+'.list'
            })
            .state('app.'+model.name+'.list', {
                url    : '/list/:page',
                params : {page: null},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/wooadmin/models/modellist.html',
                        controller : 'VulnListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    List: ['$stateParams','wtUtils',model.model,'WooModelListResolver',function(params,utils,app,resolver) {
                        //return [{app:{name:'hej'},_id:1}]
                        return resolver(app,params,{
                            filters:filters,
                            query:{sort:'-published_date'}
                        })
                    }],
                    Count: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        //return {count:1}
                        return resolver(app,params,{
                            __count_only__:true
                        })
                    }]
                },
                data : {
                    form_type: 'user'
                    ,model:model
                    //,populate:['app.name']
                    ,filters:filters
                }

            })
            .state('app.'+model.name+'.from_external', {
                url     : '/from-external/:external_id',
                views   : {
                    'content@app' : {
                        controller:function($state,Obj) {
                            debugger
                            Obj=Obj&&(Obj.docs&&Obj.docs[0]||Obj[0])
                            if(Obj) $state.go('app.'+model.name+'.details',{id:Obj._id,page:1},{location:'replace'})
                        }
                    }
                },
                resolve:{
                    Obj:[
                        '$stateParams',model.model,
                        function(params,m) {
                            return m.query({external_id:params.external_id}).$promise
                        }
                    ]
                }
            })
            .state('app.'+model.name+'.details', {
                url     : '/details/:id/:page',
                params  : {id:null,page:'1'},
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'VulnDetailsController',
                        controllerAs:'vm'
                    },
                    'website_list@app.vuln.details': {
                        templateUrl: 'app/main/wooadmin/models/modellist.html',
                        //templateUrl: 'app/main/dnszone/records.html',
                        controller : 'VulnSitesController as vm'
                    },
                },
                resolve: {
                    Obj:[
                        '$stateParams',model.model,'WooModelResolver',
                        function(params,m,resolver) {
                            //return {}
                            return resolver(m,params,{
                                //populate:['app.name'],
                            })
                        }
                    ],
                    WPObjs: ['$stateParams','wtUtils','Obj','WPObject',function(params,utils,obj,WPObject) {
                        return WPObject.query({"vulnerabilities.id":obj.external_id,select:['name','title','_id','vulnerabilities.id']}).$promise
                    }],
                    List: ['$stateParams','wtUtils','Obj','WPApp','WooModelListResolver',function(params,utils,obj,app,resolver) {
                        return resolver(app,{
                            page:params.page,
                            query:{'vulnerabilities.id':obj&&obj.external_id,user:"all"},
                        },{
                            populate:['app.name'],
                            filters:site_filters
                        })
                    }],
                    Count: ['$stateParams','Obj','WPApp','WooModelListResolver',function(params,obj,app,resolver) {
                        return resolver(app,{
                            query:{'vulnerabilities.id':obj&&obj.external_id}
                        },{
                            __count_only__:true
                        })
                    }]
                },
                data: sub_data
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/vulns');

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.vuln')
        .controller('VulnListController',ListController)
        .controller('VulnDetailsController', DetailsController)
        .controller('VulnSitesController', SitesController)

    function ListController($state,$scope,$rootScope,Count,List,WPVuln,WooModelListController) {
        var vm = this;
        vm.scope=$scope
        vm.rootScope=$rootScope
        vm.nof_objects_unfiltered=Count && Count.count||0
        vm.api=WPVuln; vm.res=List;
        vm.no_create=1;
        vm.prefix='VULN.'
        vm.empty_title=vm.prefix+'EMPTY_TITLE'
        vm.empty_text=vm.prefix+'EMPTY_TEXT'
        var data=$state.current.data
        data.substates = {edit:'app.vuln.details'}
        vm.query={sort:'-published_date'}
        WooModelListController(vm,data)

        vm.list.headers=[
            {name:'Title',class:'name'},
            {name:'Published',class:'name'},
            //{name:'Added at',class:'name'},
            {name:'#Sites',class:'status'},
            {name:"Severity",class:'status'}
        ]
        vm.list.tableClass='website-list'
        vm.Title=vm.translate(vm.prefix+'LIST_TITLE')
        vm.list.item_template='app/main/vulns/list_item.html'

        vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
        vm.list.filters=$state.current.data.filters
    }

    function DetailsController($scope, $state, $http, wtUtils, WPVuln,
        WooModelEditController, Obj, WPObjs) {
        var vm=this;
        vm.prefix='VULN'
        vm.no_edit=true; vm.no_delete=true
        vm.Object=Obj
        vm.id=Obj._id
        vm.version=Obj.version
        vm.title=Obj.title
        vm.scope=$scope
        vm.api=WPVuln
        vm.affects=Obj.affects
        var objs=WPObjs&&WPObjs.docs||WPObjs
        vm.affects.forEach(function(a) {
            if(!a.name) {
                var o=objs && objs.find(function(o) {o._id==a.object})
                a.name=o && o.name ||'unknown'
            }
        }) 
        WooModelEditController(vm,$state.current.data.back_state)
        vm.content='app/main/layouts/wt-details-content.html'
        vm.details_template='app/main/vulns/details.html'
        wtUtils.detailsController(vm,$state)
        $scope.obj=Obj
        $scope.references=Obj.references
        vm.form={
            optional:{note:true},
            values:{
                severity:['ignore',"low","medium",'high','critical','exploited'],
            }
        }
    }

    function SitesController($scope, $rootScope, $state, WPApp, wtUtils, Obj,
        WooModelListController, Count, $filter, List)
    {
        var vm = this;
        vm.scope=$scope
        vm.rootScope=$rootScope
        vm.nof_objects_unfiltered=Count && Count.count||0
        vm.api=WPApp; vm.res=List;
        vm.no_create=1
        vm.prefix='SITES.'
        vm.empty_title=vm.prefix+'EMPTY_TITLE'
        vm.empty_text=vm.prefix+'EMPTY_TEXT'
        var data=$state.current.data
        data.substates = {edit:'app.wordpress.update'}
        WooModelListController(vm,data)

        vm.list.headers=[
            {name:'Name',class:'name'},
            {name:'#Vulnerabilities',class:'status'},
            //{name:"Severity",class:'status'}
        ]
        vm.list.tableClass='website-list'
        vm.Title=vm.translate(vm.prefix+'LIST_TITLE')
        vm.list.item_template='app/main/vulns/site_list_item.html'

        vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
        vm.list.filters=$state.current.data.filters
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.upgrade', [])
        .config(config)

    /** @ngInject */

    function config($stateProvider, msApiProvider, $translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/main/upgrade');

        $stateProvider
        .state('appf.upgrade', {
            url      : '/upgrade',
            abstract : true
        })
        .state('appf.upgrade.trial', {
            url    : '/trial/:id',
            params  : {id:null},
            views  : {
                'content@appf': {
                    //templateUrl: 'app/main/upgrade/upgrade-trial.html',
                    controller : function($state,List) {
                        var vm = this;
                        var apps=List.docs
                        if (apps.length==0) {
                            $state.go('appf.website.create', {from:'upgrade-trial'},{location: 'replace'})
                        } else {
                            //console.log('Upgrading');
                            $state.go('appf.website.upgrade',{id:apps[0]._id},{location: 'replace'})
                        }
                    },
                    controllerAs: 'vm'
                }
            },
            resolve: {
                List: ['$stateParams','WooApp','WooModelListResolver',function(params,app,resolver) {
                    return resolver(app,params,{populate:'operation'})
                }]
            }
        })
        .state('appf.upgrade.billing', {
            url    : '/billing/:id',
            params  : {id:null},
            views  : {
                'content@appf': {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller:'UpgradeBillingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                Upgrade: [
                    '$stateParams','WooUpgrade','WooModelResolver',
                    function(params,model,resolver) {
                        return resolver(model,params,{populate:['doc','plan']})
                    }
                ],
                /*
                Previous:[
                    'Upgrade','WooUpgrade','WooModelResolver',
                    function(Upgrade,WooUpgrade,WooModelResolver) {
                        if (!Upgrade || Upgrade.state=='complete') {
                            return Upgrade
                        }
                        return WooModelResolver(WooUpgrade,{id:Upgrade.previous},{populate:['location','plan']})
                    }
                ],*/
                UserInfo: [
                    'UserInfo', function (info) {
                        return info();
                    }
                ],
                Pricing: ['msApi', function (msApi) {
                    return msApi.resolve('pricing@get')
                }],
                Billing: ['msApi', 'AuthService', function (msApi,auth)
                {
                    return  msApi.resolve('userBilling@get',{create_missing:1,user:auth.selectedUser()})
                }]
            }
        }).state('appf.upgrade.order', {
            url    : '/order/:id',
            params  : {id:null},
            views  : {
                'content@appf': {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller: 'UpgradeOrderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                Upgrade: [
                    '$stateParams','WooUpgrade',
                    function(params,model) {
                        return model.query({"subscription.order_id":params.id,user:'all'}).$promise
                    }
                ],
            }
        }).state('appf.upgrade.check', {
            url    : '/check/:id',
            params  : {id:null},
            views  : {
                'content@appf': {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller: 'UpgradeOrderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                Upgrade: [
                    '$stateParams','WooUpgrade','WooModelResolver',
                    function(params,model,resolver) {
                        return resolver(model,params,{})
                    }
                ],
            }
        }).state('appf.upgrade.thankyou', {
            url    : '/thankyou/:id',
            params  : {id:null},
            views  : {
                'content@appf': {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller: 'UpgradeThanksController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                Upgrade: [
                    '$stateParams','WooUpgrade',
                    function(params,model) {
                        return model.get({"obj_id":params.id,user:'all'}).$promise
                    }
                ]
            }
        })

        /*
        */
        msApiProvider.register('userBilling',['api/woobilling'])
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.upgrade')
        .controller('UpgradeBillingController',billing)
        .controller('UpgradeOrderController',orderwait)
        .controller('UpgradeThanksController',thankyou)
        //.factory('WooUpdateUpgrade',update_object)


    function update_object(WooUpgrade,Upgrade,next) {
        WooUpgrade.get({obj_id:Upgrade._id,user:Upgrade.user},{populate:'operation'},function (res) {
            var err,op=res.operation
            if(op && op.status=='error') {
                err=op.msgs[0]
            }
            next(err,res)
        })
    }
    function getUser(auth,args) {
        args.user=auth.selectedUser()
        return args
    }

    function setProrateName(vm,t) {
        var name
        var values=vm.values
        if (values.prorated_amount<=0) {
            return
        }
        if (values.is_upgrade) {
            name=t("UPGRADE.UPGRADE_WEBSITE",values)
        } else if(values.is_move) {
            name=t("UPGRADE.MOVE_WEBSITE",values)
        } else {
            name=t("UPGRADE.NEW_WEBSITE",values)
        }
        if(values.used_credit>0) {
            name = t("UPGRADE.USED_CREDIT_FOR",values) + name
        } /*else (values.used_credit>0 && values.due_today>0){
            name =
        }*/
        vm.prorate_name=name
    }

    function billing($window,$translate,$scope,$location,$state,wtUtils,AuthService,WooUpgrade,ErrorDialog,
        PollOperation,Upgrade,UserInfo,Pricing,Billing) {
        var vm=this
        var UserData = UserInfo.data
        vm.layout= 'app/main/upgrade/upgrade-billing.html'
        vm.values={}
        var values=vm.values
        if(Billing.docs) {
            Billing=Billing.docs[0]
        }
        values.is_initial= Upgrade.initial
        values.is_upgrade=!Upgrade.is_downgrade && !values.is_initial
        values.is_downgrade=Upgrade.is_downgrade && !values.is_initial
        values.is_move=Upgrade.is_move
        values.upgrade=wtUtils.translate('UPGRADE.'+(
            values.is_upgrade?'UPGRADE':(
                values.is_downgrade?'DOWNGRADE':(
                    values.is_move?'MOVE':(
                        values.is_initial?'THIS_WEBSITE':'THIS_OPERATION'
                    )
                )
            )
        ))
        vm.subscription=Upgrade.subscription || {}
        vm.title="UPGRADE.BILLING_TITLE"
        vm.cancel_button="WOOADMIN.CANCEL"
        vm.continue_button="UPGRADE.CONTINUE_TO_PAYMENT"
        if(AuthService.isAdmin()) {
            vm.admin_complete_button="UPGRADE.COMPLETE_PAYMENT"
            vm.complete_button2="UPGRADE.PAY_NEXT_RENEWAL"
        }
        vm.is_initial=Upgrade.initial
        vm.has_default_billing=Billing.default_subscription && Billing.default_subscription.id
        if (vm.has_default_billing && !vm.subscription.id) {
            vm.subscription.id=Billing.default_subscription.id
        }
        function upgrade_cost() {
            // TODO
            var price= Upgrade.price
            price=price && price[values.currency] || price
            price = price && price[values.billing_period] || 0
            return price
        }
        function init(pricing) {
            values.current_amount=vm.subscription.old_amount || 0
            values.billing_period=vm.subscription.period || Billing.default_period || "month"
            values.prorated_amount=vm.subscription.prorated_amount || 0
            values.prorated_days=vm.subscription.prorated_days || 0
            values.billing_period_name=wtUtils.translate('UPGRADE.PERIOD.'+values.billing_period)
            values.new_plan=Upgrade.plan && Upgrade.plan.name
            values.new_disk_size=Upgrade.disk_size
            if (pricing.docs) {
                pricing=pricing.docs[0]
            }
            var currency=UserInfo.getCurrency(pricing)
            values.currency=currency.selected
            values.currencies=currency.options
            values.new_amount=upgrade_cost()

            vm.is_downgrade=Upgrade.is_downgrade
            var day=moment(vm.subscription.billing_day)
            if(values.billing_period=='month') {
                values.billing_day=wtUtils.translate('UPGRADE.PERIOD.THE')+' '+day.format('Do')
            }
            if(values.billing_period=='year') {
                values.billing_day=day.format('MMMM Do')
            }

            values.credit=Billing.total_credit || 0
            values.new_credit=values.credit - values.prorated_amount
            if(values.new_credit<0) {
                values.new_credit=0
            }
            values.extra_credit=values.new_credit-values.credit
            values.used_credit=-values.extra_credit
            if(vm.subscription.id) {
                vm.use_credit=true
                values.due_today=values.prorated_amount
                values.due_today -= values.credit
                if(values.due_today<=0 ){
                    values.due_today=0
                    if(values.is_move) {
                        vm.continue_button="UPGRADE.CONTINUE_TO_RELOCATE"
                    } else if (values.current_amount==values.new_amount) {
                        // Nothing to be done
                        vm.continue_button="WEBSITE.CONTINUE"
                    } else if (values.is_upgrade) {
                        vm.continue_button="UPGRADE.CONTINUE_TO_UPGRADE"
                    } else if (values.is_downgrade) {
                        vm.continue_button="UPGRADE.CONTINUE_TO_DOWNGRADE"
                    } else {
                        vm.continue_button="WEBSITE.CONTINUE"
                    }
                }
                setProrateName(vm,$translate.instant)
            } else {
                values.due_today=values.new_amount
                $scope.$watch('vm.values.currency',function(){
                    values.new_amount=upgrade_cost()
                    values.due_today=values.new_amount;
                    UserInfo.selectCurrency(vm.values.currency)
                })
            }
            vm.obj=vm
            vm.includes_option=function(){return true}
            if (!vm.subscription.id && Billing.allow_select_period && Upgrade.price) {
                var periods=Object.keys(Upgrade.price)
                vm.select_period={
                    fields:['billing_period'],
                    label:{billing_period:"UPGRADE.SELECT_BILLING_PERIOD"},
                    type:{billing_period:"select"},
                    values:{billing_period:periods}
                }
                $scope.$watch('vm.values.billing_period',function(){
                    values.new_amount=upgrade_cost()
                    values.due_today=values.new_amount; //>vm.credit?vm.new_amount-vm.credit:0
                    //alert('billing_period set to '+vm.billing_period)
                })
            } else {
                vm.title="UPGRADE.BILLING_CONFIRM_TITLE"
            }
            if (vm.is_initial && vm.has_default_billing && Billing.allow_split_billing) {
                vm.select_subscription=false
                vm.split_billing={
                    fields:["select_subscription"],
                    label:{allow:"Add this order to another subscription"},
                    type:{allow:"checkbox"},
                    //values:{period:Upgrade.periods}
                }
            }
        }
        init(Pricing)
        vm.cancel=function() {
            vm.isSaving=true
            if (Upgrade.initial) {
                return WooUpgrade.delete(getUser(AuthService,{obj_id:Upgrade._id}),function(res) {
                    $window.history.back()
                })
            }
            $window.history.back()
        }
        vm.continue=function(complete,defer_upgrade) {
            vm.isSaving=true
            Upgrade.add_billing={
                subscription:vm.subscription,
                period:values.billing_period,
                complete:complete,
                currency:values.currency
            }
            if(defer_upgrade) {
                Upgrade.add_billing.defer_upgrade_payment=true
            }
            if (vm.prorate_name) {
                Upgrade.subscription.prorate_name=vm.prorate_name
                //debugger
                //return
            }

            Upgrade.$save(getUser(AuthService,{obj_id:Upgrade._id}),function(res) {
                //Upgrade=res
                if(vm.poll) {
                    vm.poll.cancel()
                }
                vm.poll=PollOperation(vm,res,next)
            })
        }
        vm.skip_check=function () {
            if (!AuthService.isAdmin()) {
                vm.layout='app/main/upgrade/upgrade-billing-continue.html'
                if (!vm.isSaving) {
                    vm.continue(false,true)
                }
            }
            return
            if (!AuthService.isAdmin() &&
                (values.is_initial && vm.subscription.id && (values.prorated_amount==0 || values.prorated_amount==values.new_amount) ||
                    !vm.subscription.id && !Billing.allow_select_period)) {
                if (vm.subscription.id) {
                    vm.title="UPGRADE.BILLING_CONTINUE_TITLE"
                } else {
                    vm.title="UPGRADE.BILLING_CONTINUE_TITLE_CREATE"
                }
                vm.layout='app/main/upgrade/upgrade-billing-continue.html'
                if (!vm.isSaving) vm.continue()
            }
        }
        function next(err,res) {
            if(err) {
                vm.isSaving=false;
                ErrorDialog(
                    "This is embarrassing... I couldn't complete the operation. A technician will check on this as soon as possible. Please stand by.",
                    ["ERROR: " +err]
                )
                return
            }
            if(res.state=='placed' ) {
                if (!vm.isSaving) {
                    return vm.continue()
                }
                return AuthService.getUser().then(function (user) {
                    if(res.subscription.order_url) {
                        //return alert("Going to order page")
                        if (res.user != user.acctId) {
                            // Upgrade belong to another user, we can't complete the order
                            // instead simply display some message about it and continue.
                            var Title=wtUtils.translate('UPGRADE.DIALOG_OTHER.TITLE')
                            var Body=wtUtils.translate('UPGRADE.DIALOG_OTHER.BODY',{
                                url:res.subscription.order_url
                            })
                            var diagOK=wtUtils.translate("UPGRADE.DIALOG_OTHER.OK")
                            return wtUtils.alert({title:Title,body:Body,ok:diagOK},function() {
                                return $state.go('app.website.list')
                            });
                        }
                        vm.isSaving=true
                        return $window.location.href=res.subscription.order_url
                    }

                    if(res.url) {
                      return $location.url(res.url)
                    }

                })
            }
            if(res.state!='new') {
                // Order is paid or complete
                //var ty=res.thankyou&&res.thankyou.state||'appf.upgrade.thankyou'
                //var id=res.thankyou&&res.thankyou.id||res._id
                //return $state.go(ty,{id:id})
                return $state.go('appf.upgrade.check',{id:Upgrade._id},{location:'replace'})

            }
            vm.isSaving=false;
            vm.skip_check()
        }
        vm.update_object=function(){ update_object(WooUpgrade,Upgrade,next) }
        vm.poll=PollOperation(vm,Upgrade,next)
        if (vm.poll) {
            vm.isSaving=true
        }
        $scope.$on('$destroy',function() {
            console.log("destroy called");
            if (vm.poll) {
                vm.poll.cancel()
            }
        })


        vm.skip_check()
    }
    function thankyou($state,ErrorDialog,PollOperation,Upgrade) {
        var vm =this
        vm.layout= 'app/main/upgrade/upgrade-thankyou.html'
        vm.upgrade=Upgrade
        vm.continue=function() {
            $state.go('app.start')
        }
        vm.continue_button="WEBSITE.CONTINUE"
        fbq('track','Purchase',{
            value:1,
            currency:'USD'
        })
    }
    function orderwait($state,$scope,ErrorDialog,PollOperation,WooUpgrade,Upgrade) {
        var vm =this
        vm.layout= 'app/main/upgrade/upgrade-order.html'
        if (Upgrade && !Upgrade._id && Upgrade.docs) {
            Upgrade=Upgrade.docs[0]
        }
        vm.update_object=function(){ update_object(WooUpgrade,Upgrade,next) }
        function next(err,res) {
            if(err) {
                vm.isSaving=false;
                ErrorDialog(
                    "Failure to compute!",
                    ["ERROR: " +err]
                )
                return
            }
            if(res.state=='paid' || res.state=='complete') {
                var ty=res.thankyou&&res.thankyou.state||'appf.upgrade.thankyou'
                var id=res.thankyou&&res.thankyou.id||res._id
                return $state.go(ty,{id:id},{location:'replace'})
            }
            res.wait_for_payment=true
            return res.$save({obj_id:res._id},function(res) {
                //Upgrade=res
                if(vm.poll) {
                    vm.poll.cancel()
                }
                vm.poll=PollOperation(vm,res,next)
            })
        }
        $scope.$on('$destroy',function() {
            console.log("destroy called");
            if (vm.poll) {
                vm.poll.cancel()
            }
        })

        vm.continue_button="WEBSITE.CONTINUE"
        //vm.poll=PollOperation(vm,Upgrade,next)
        vm.isSaving=true
        if(Upgrade && Upgrade._id) {
            return vm.update_object()
        }
        vm.wait_for_upgrade=function(time) {
            WooUpgrade.query({"subscription.order_id":$state.params.id,user:'all'}, function (res) {
                if(res && res.docs && res.docs.length>0) {
                    Upgrade=res.docs[0]
                    return vm.update_object()
                }
                setTimeout(function() {
                    vm.wait_for_upgrade((time*2>90)?90:time*2)
                },time*1000)
            })
        }
        vm.wait_for_upgrade(3)
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sharing', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $urlRouterProvider, $translatePartialLoaderProvider,
         msNavigationServiceProvider,Models)
    {
        var state_pre='app.'
        var model = Models['WooSharing']
        var sub_data={
            populate: ['operation']
            ,next_state:{save:state_pre+model.name+'.details'}
        }
        var filters=[
            {
                name:'search',label:'SHARING.SEARCH',field:'__search__',kind:'search'
            },
            {
                name:'direction',
                label:'SHARING.FILTER.DIRECTION',
                kind:'custom-select',
                options:[
                    {value:'',label:'SHARING.FILTER.ALL'},
                    {value:'outgoing',label:'SHARING.FILTER_SHARED_BY_ME'},
                    {value:'incoming',label:'SHARING.FILTER_SHARED_WITH_ME'}
                ]
            }
        ]

        // State
        $stateProvider
            .state(state_pre+model.name, {
                url    : '/'+model.name,
                redirectTo: state_pre+model.name+'.list'
            })
            .state(state_pre+model.name+'.list', {
                url    : '/list/:page',
                params : {page: null},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/sharing/list.html',
                        controller : 'SharingListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    HasUser:['AuthService',function(auth) {
                        var p=auth.getUser()
                        return p
                    }],
                    List: ['$stateParams','wtUtils',model.model,'WooModelListResolver',function(params,utils,app,resolver) {
                        var f = utils.getCached(state_pre+model.name+'.list')||filters
                        return resolver(app,params,{
                            populate:sub_data.populate,
                            filters:f
                        })
                    }],
                    CountUnfiltered: ['$stateParams','wtUtils',model.model,'WooModelListResolver',function(params,utils,app,resolver) {
                        return resolver(app,params,{
                            populate:sub_data.populate,
                            __count_only__:true
                        })
                    }]
                },
                data : {
                    //Title: model.Name+'s'
                    substates: {edit:state_pre+model.name+'.details',create:state_pre+model.name+'.create'}
                    ,form_type: 'user'
                    ,populate: sub_data.populate
                    ,model:model
                    ,filters:filters
                }

            })
            .state(state_pre+model.name+'.create', {
                url     : '/create/',
                views   : {
                    'content@app' : {
                        templateUrl:  'app/main/layouts/wt-wrapper.html',
                        controller : 'SharingCreateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    Form: [
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'user'})
                        }
                    ]
                },
                data: sub_data
            })
            .state(state_pre+model.name+'.edit', {
                url     : '/edit/:id',
                views   : {
                    'content@app' : {
                        templateUrl:  'app/main/layouts/wt-wrapper.html',
                        controller : 'SharingEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    Object:[
                        '$stateParams',model.model,'WooModelResolver',function(params,m,resolver) {
                                return resolver(m,params,{populate: sub_data.populate})
                        }
                    ],
                    Form: [
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'user'})
                        }
                    ]
                },
                data: sub_data
            })
            .state(state_pre+model.name+'.details', {
                url     : '/details/:id',
                views   : {
                    'content@app' : {
                        templateUrl:  'app/main/layouts/wt-wrapper.html',
                        controller : 'SharingDetailsController',
                        controllerAs:'vm'
                    }
                },
                resolve: {
                    HasUser:['AuthService',function(auth) {
                        var p=auth.getUser()
                        return p
                    }],
                    Object:[
                        '$stateParams',model.model,'WooModelResolver',function(params,m,resolver) {
                                return resolver(m,params,{populate:sub_data.populate})
                        }
                    ],
                    Form:[
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'user'})
                        }
                    ]
                },
                data: sub_data
            })
            .state('appf.'+model.name, {
                url    : '/'+model.name,
                redirectTo: 'appf.'+model.name+'.list'
            })
            .state('appf.'+model.name+'.accept', {
                url     : '/accept/:token',
                params  : { token:null },
                views   : {
                    'content@appf' : {
                        templateUrl:  'app/main/layouts/wt-wrapper.html',
                        controller : 'SharingAcceptController',
                        controllerAs:'vm'
                    }
                },
                resolve: {
                    Object:[
                        '$stateParams','WooSharing',function(params,m) {
                            return m.query({'request.token':params.token}).$promise
                        }
                    ]
                },
                data: sub_data
            })


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sharing');

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sharing')
        .controller('SharingAcceptController',AcceptController)
        .controller('SharingListController',ListController)
        .controller('SharingCreateController', SharingCreateController)
        .controller('SharingEditController', SharingEditController)
        .controller('SharingDetailsController',SharingDetailsController)
        .factory('SharingName',function() {
            return function(vm,obj) {
                var user=vm.user && vm.user.acctId||vm.user
                if(!user) { return "" }
                var req=obj.request
                var dir=req.direction
                obj.translate_values={
                    receiver_email:obj.request.receiver,
                    sender_email:obj.request.sender_email
                }
                if (obj.shared_by==user) {
                    obj.name='SHARING.SHARED_WITH'
                    obj.isOutgoing = true
                    obj.userEmail = obj.request.receiver
                } else {
                    obj.name='SHARING.SHARED_BY'
                    obj.isOutgoing = false
                    obj.userEmail = obj.request.sender_email
                }
            }
        })

    function SharingCreateController($scope, AppLoader, $state, wtUtils, WooModelEditController, WooSharing, Form) {
        var vm=this;
        var gotForm=Form
        Form={
            fields:[
                'email','message','share_all','websites' //,'role'
            ],
            type:{ email:'email',websites:'ui-select-multiple',role:'select',share_all:'checkbox'},
            values:{
                websites:gotForm.values && gotForm.values.websites || [],
                role:[
                    {name:'SHARING.ADMIN',value:'admin'},
                    {name:'SHARING.COLLABORATOR',value:'collaborator'}
                ],
            },
            optional:{websites:true},
            hidden:{websites:true},
            default:{
                message:wtUtils.translate('SHARING.DEFAULT_MESSGE'),
                share_all:true,
                role:'admin'
            }
        }
        wtUtils.addFormLabels('SHARING',Form)
        Form.refresh={websites:function (search,scrolling) {
            AppLoader(Form.values.websites,search,scrolling)
        }}
        //Form.type.key='file'
        Form.file_button={key:'Load From File'}
        vm.Form=Form
        vm.scope=$scope
        vm.api=WooSharing
        vm.state=$state
        vm.layout='app/main/layouts/wt-edit.html'
        vm.title="SHARING.CREATE_TITLE"

        WooModelEditController(vm,$state.current.data)

        vm.scope.$watch('vm.obj.share_all',function(newValue,oldValue) {
            if (newValue!=oldValue) {
                Form.hidden.websites=newValue&&true||false
                if( newValue === true ) {
                    Form.optional.websites = true
                } else {
                    Form.optional.websites = false
                }
            }
        })


        vm.continue=function(form) {
            vm.obj.request={
                //sender:vm.real_user,
                receiver:vm.obj.email,
                msg:vm.obj.message
            }
            vm.save(function(res) {
                if(res.errors) {
                    wtUtils.error(res.errors)
                } else {
                    wtUtils.alert({
                        title:'SHARING.REQUEST_SENT_TITLE',
                        body:'SHARING.REQUEST_SENT_BODY',
                        args:{obj:res}
                    },function() {
                        wtUtils.gotoState($state,'.list',{},{location:'replace'})()
                    })
                }
            })
        }
    }

    function SharingEditController($scope, $state, wtUtils, AppLoader, WooModelEditController, Object, Form, WooSharing) {
        var vm=this;
        var gotForm=Form
        if(!Object) return
        var req=Object&&Object.request
        vm.scope=$scope
        Form={
            type:{ websites:'ui-select-multiple',share_all:'checkbox'},
            disabled:{receiver:true},
            optional:{websites:true},
            values:{
                websites:gotForm.values&&gotForm.values.websites||[],
            },
            hidden:{},
        }
        if (req && req.shared_by==vm.user) {
            vm.title="SHARING.DETAILS_TITLE"
            Form.fields=['share_all','websites'],
            Object.websites=Object.docs&&Object.docs.filter(function(d) {return d.model=='WooApp'}).map(function(d) { return d.id })
            Form.hidden.websites=Object.share_all&&true||false
            //Object.receiver=req.receiver
            vm.scope.$watch('vm.Object.share_all',function(newValue,oldValue) {
                if (newValue!=oldValue) {
                    Form.hidden.websites=newValue&&true||false
                }
            })
        } else {
            vm.title="SHARING.BY_DETAILS_TITLE"
            //Form.fields=['sender_email'],
            //Object.sender_email=req.sender_email
        }


        wtUtils.addFormLabels('SHARING',Form)
        vm.Object=Object
        vm.Form=Form
        Form.refresh={websites:function (search,scrolling) {
            AppLoader(Form.values.websites,search,scrolling)
        }}
        vm.scope=$scope
        vm.api=WooSharing
        vm.state=$state
        vm.layout='app/main/layouts/wt-edit.html'

        WooModelEditController(vm,$state.current.data)
        vm.translate_values=vm.translate_values||{}
        vm.translate_values.receiver_email=req&&req.receiver
        vm.translate_values.sender_email=req&&req.sender_email
        vm.continue=vm.save
    }

    function SharingDetailsController($scope, $state, wtUtils, WooModelEditController, Object, Form, WooSharing, SharingName) {
        var vm=this;
        if(!Object) return
        vm.Form={
            type:{ websites:'multiselect',share_all:'checkbox'},
            values:{
                websites:Form.values&&Form.values.websites&&Form.values.websites.docs||[],
            },
            hidden:{}
        }
        wtUtils.addFormLabels('SHARING',vm.Form)
        vm.content='app/main/layouts/wt-details-content.html'
        vm.details_template='app/main/sharing/details.html'
        if(!Object.request) return
        vm.Object=Object.request
        vm.Object._id=vm.id=Object._id
        vm.scope=$scope
        vm.state=$state
        vm.api=WooSharing
        WooModelEditController(vm,$state.current.data)
        wtUtils.detailsController(vm,$state);
        if (Object && Object.shared_by==vm.user) {
            vm.title="SHARING.DETAILS_TITLE"
            vm.Form.fields=['receiver','state','share_all']
            vm.Object.share_all=Object.share_all
            if(!Object.share_all) {
                vm.Form.fields.push('websites')
                vm.Object.websites=Object.docs&&Object.docs.filter(function(d) {return d.model=='WooApp'}).map(function(d) { return d.id })
            }
        } else {
            vm.title="SHARING.BY_DETAILS_TITLE"
            vm.Form.fields=['sender_email','state']
            vm.no_edit=true
        }
        vm.translate_values=vm.translate_values||{}
        vm.translate_values.receiver_email=Object.request.receiver
        vm.translate_values.sender_email=Object.request.sender_email
        SharingName(vm, Object);
        vm.name = Object.name;
        console.log(vm.name);
        vm.breadcrumbs=[
            {label:"BREADCRUMBS.SHARING", url:"/sharing/list/"},
            {label:vm.name, url: '/sharing/details/'+vm.Object._id, translateValues: vm.translate_values}
        ]
    }


    function ListController(WooModelListController,$scope, $rootScope, $state, List, CountUnfiltered, SharingName, WooSharing, AuthService, wtUtils, WooApp) {
        var vm = this;
        vm.nof_objects_unfiltered=CountUnfiltered && CountUnfiltered.count||0
        vm.scope=$scope
        vm.rootScope=$rootScope
        vm.api=WooSharing; vm.res=List;
        vm.empty_title='SHARING.EMPTY_TITLE'
        vm.empty_text='SHARING.EMPTY_TEXT'
        vm.extra_buttons=[]
        if(AuthService.isAgency()) {
            // console.log('isAgency', AuthService.isAgency(), AuthService.user);
            var targetUrl = wtUtils.getRegisterAccountUrl();
            vm.extra_buttons.push({
                name: "CREATE_CUSTOMER_ACCOUNT",
                fun: function() {
                    window.open(targetUrl, '_blank');
                }
            })
        }
        vm.prefix='SHARING.'
        vm.Title='SHARING.SHARING_NAV'
        vm.helpUrl='https://docs.templ.site/account-billing/account/account-sharing'
        
        // Cache for website names - populated once, reused on filter changes
        var websiteNameCache = {};
        
        function loadWebsiteNames(objects) {
            var items = objects || List.docs || List;
            
            // Collect all unique WooApp IDs that aren't already cached
            var appIds = [];
            angular.forEach(items, function(obj) {
                if (!obj || !obj.docs) { return; }
                angular.forEach(obj.docs, function(doc) {
                    if (doc && doc.model === 'WooApp' && doc.id && !websiteNameCache[doc.id] && appIds.indexOf(doc.id) === -1) {
                        appIds.push(doc.id);
                    }
                });
            });

            // Apply cached names immediately
            applyWebsiteNames(items);

            // Fetch any missing names
            if (appIds.length === 0) {
                return;
            }

            var query = { select: 'name', _id: appIds, user: AuthService.isAdmin() ? 'all' : AuthService.selectedUser() };

            WooApp.query(query).$promise.then(function(res) {
                // Add to cache
                angular.forEach(res.docs || res, function(app) {
                    websiteNameCache[app._id] = app.name;
                });

                // Apply names to objects
                applyWebsiteNames(items);
            });
        }
        
        function applyWebsiteNames(objects) {
            angular.forEach(objects, function(obj) {
                if (!obj) { return; }
                obj.websiteNames = [];
                if (!obj.docs) { return; }
                angular.forEach(obj.docs, function(doc) {
                    if (doc && doc.model === 'WooApp' && doc.id && websiteNameCache[doc.id]) {
                        obj.websiteNames.push({
                            id: doc.id,
                            name: websiteNameCache[doc.id]
                        });
                    }
                });
            });
        }

        function get_sharing_name(obj) {
            obj=obj||this
            return SharingName(vm,obj)
        }
        vm.object_callback=function(obj) {
            SharingName(vm,obj)
        }
        angular.forEach(List.docs||List,function(obj) {
            vm.object_callback(obj)
        })
        loadWebsiteNames()
        WooModelListController(vm,$state.current.data)
        vm.list.item_template='app/main/sharing/list_item.html'
        vm.list.filter_template='app/main/sharing/list_filter.html'
        vm.list.filters=$state.current.data.filters
        vm.empty_animation_template='app/main/animations/empty-account-sharing.html'
        
        // Initialize direction filter
        var directionFilter = _.find(vm.list.filters, function(f) { return f.name === 'direction' })
        if (directionFilter && directionFilter.value === undefined) {
            directionFilter.value = ''
        }
        
        // Override filter_changed to transform direction filter to API query params
        var originalFilterChanged = vm.filter_changed
        var originalGetFilterValue = vm.get_filter_value
        
        // Override get_filter_value to handle custom-select kind
        vm.get_filter_value = function(f) {
            if (f.kind === 'custom-select') {
                return f.value
            }
            return originalGetFilterValue(f)
        }
        
        vm.filter_changed = function(f) {
            // Update query params based on direction filter
            vm.query = vm.query || {}
            delete vm.query.shared_by
            delete vm.query.shared_with
            
            if (directionFilter && directionFilter.value) {
                if (directionFilter.value === 'outgoing') {
                    vm.query.shared_by = vm.user
                } else if (directionFilter.value === 'incoming') {
                    vm.query.shared_with = vm.user
                }
            }
            
            // Call original filter_changed
            if (originalFilterChanged) {
                originalFilterChanged(f)
            }
        }
        
        vm.list.tableClass='share-list'
        vm.list.headers=[
                             {name:vm.translate('SHARING.LIST.USER'),class:'user'},
                             {name:vm.translate('SHARING.LIST.STATUS'),class:'status'},
                             {name:vm.translate('SHARING.LIST.WEBSITES'),class:'websites'},
                             {name:vm.translate('SHARING.LIST.DATE'),class:'date'},
                         ]

        // Hook into list reload to re-apply website names
        vm.loaded_callback = function(objects) {
            loadWebsiteNames(objects);
        };
    }

    function AcceptController($rootScope, $scope, AuthService, $state, wtUtils, SharingName, WooSharing,Object) {
        var vm=this
        vm.scope=$scope

        vm.title="SHARING.ACCEPT_TITLE"
        vm.layout='app/main/sharing/accept.html'
        vm.continue_button='SHARING.ACCEPT'
        vm.object=new WooSharing(Object && Object.docs && Object.docs[0])
        AuthService.getUser().then(function(user) {
            vm.isAdmin=AuthService.isAdmin()
        })
        vm.id=vm.object._id
        if (!vm.object || !vm.object.request || vm.object.request.state!='pending') {
            return wtUtils.error(
                "SHARING.REQUEST_NOT_PENDING",
                {state:vm.object&&vm.object.state||'deleted'},
                function() {$state.go('app.sharing.list')})
        }

        vm.accept=function() {
            /*
            if (vm.isAdmin) {
                return wtUtils.error("Admins can't accept sharing. Please edit the sharing via the WooAdmin instead!")
            }*/
            var obj=vm.object
            obj.request.state='accepted'
            vm.save(obj)
        }
        vm.reject=function() {
            var obj=vm.object
            obj.request.state='rejected'
            vm.save(obj)
        }
        vm.save=function(obj) {
            obj.$save({obj_id:obj._id},function (res) {
                if(res.errors) {
                    return wtUtils.error(res.errors)
                }
                $rootScope.$broadcast('sharing:changed')
                $state.go('app.sharing.list')
            })
        }
        vm.cancel=function() {
            $state.go('app.sharing.list')
        }
    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.utils',[])
        .factory('wtUtils', wtUtils)
        .controller('wtAlertCtrl',alertController)
        .controller('wtConfirmCtrl',confirmController)

    function alertController($uibModalInstance,data) {
        var vm=this
        modalController(vm,$uibModalInstance,data)
    }

    function confirmController($uibModalInstance,data) {
        var vm=this
        modalController(vm,$uibModalInstance,data)
    }
    function modalController(vm,instance, data) {
        vm.data=data
        //debugger
        vm.ok=function() {
            instance.close();
        }
        vm.cancel=function() {
            instance.dismiss('cancel');
        }
    }

    function wtUtils($filter,$translate,$uibModal){
        function alert(d,next) {

            var data = {
                title: $translate.instant(d.title,d.args),
                text: $translate.instant(d.body,d.args) || d.html,
                ok: $translate.instant(d.ok||"UTILS.OK",d.args),
            }

            var alert=$uibModal.open({
                backdrop: true,
                backdropClass: 'show',
                windowClass: 'd-flex justify-content-center align-items-center',
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/main/layouts/wt-alert.html',
                controller: 'wtAlertCtrl',
                controllerAs: 'vm',
                //size: size,
                //appendTo: parentElem,
                resolve: {
                    data: function () {
                        return data;
                    }
                }
            })

            alert.result.finally(function() {
                if(next) {next()}
            });

            //window.alert("wtutils: Alert Dialog not implemented")
            /*
            var confirm = $mdDialog.alert()
                 .title(Title)
                 .textContent(Body)
                 .ok(diagOK)
            return $mdDialog.show(confirm).finally(function() {
                if(next) {next()}
            });
            */
        }
        function error(errors,args,next) {
            return this.alert({
                title:"UTILS.ERROR_DIALOG_TITLE",
                body:errors,
                args:args
            },next)
        }
        function confirm(d,next,next2) {
            var data = {
                title: $translate.instant(d.title,d.args),
                text: $translate.instant(d.text,d.args),
                body: d.body,
                ok: $translate.instant(d.ok||"UTILS.OK",d.args),
                cancel: $translate.instant(d.cancel||"UTILS.CANCEL",d.args)
                ,focus:d.focus
            }

            //window.alert("wtutils: Confirm Dialog not implemented")
            //debugger
            var confirm=$uibModal.open({
                backdrop: true,
                backdropClass: 'show',
                windowClass: 'd-flex justify-content-center align-items-center',
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/main/layouts/wt-confirm.html',
                controller: 'wtConfirmCtrl',
                controllerAs: 'vm',
                //size: size,
                //appendTo: parentElem,
                resolve: {
                    data: function () {
                        return data;
                    }
                }
            })
            if (!next) return confirm.result;

            confirm.result.then(function() {
                if(next) {next()}
            },function() {
                if(next2) {next2()}
            });
            /*
            var confirm = $mdDialog.confirm().title(title).textContent(text).ok(ok).cancel(cancel)
            return $mdDialog.show(confirm).then(function() {
                if(next) {next()}
            },function() {
                if(next2) {next2()}
            });
            */

        }
        function siblingState(state,s) {
            var parent=state.$current.parent
            return parent.name+s
        }

        function gotoState(state,s,params,options) {
            return function() {
                var parent=state.$current.parent
                state.go(parent+s,params,options)
            }
        }
        function detailsController(vm,state) {
            vm.edit=gotoState(state,'.edit',{id:vm.Object._id})
        }

        function addFormLabels(prefix,form,exclude) {
            _.each(['label','description','note'],function (l) {
                if(exclude && exclude.includes(l)) return;
                form[l]={
                }
                _.each(form.fields,function(f) {
                    form[l][f]=prefix+'.'+l.toUpperCase()+'S.'+f.toUpperCase()
                })
            })
            form.help_text={}
            _.each(form.help_link,function(l,f) {
                form.help_text[f]=prefix+'.HELP_LINK_TEXT.'+f.toUpperCase()
            })
            form.element_label={}
            _.each(form.type,function(l,f) {
                if(l=='list') {
                    form.element_label[f]=prefix+'.ELEMENT_LABEL.'+f.toUpperCase()
                }
            })
        }
        function translate(label,args) {
            return $filter('translate')(label,args)
        }
        function daysInMonth(date) {
            return new Date(date.getYear(),date.getMonth()+1,0).getDate()
        }
        // Get the path to the flag image for a given location code
        function getFlag(locationCode) {
            // Only 1 flag for countries with multiple locations
            var flag = locationCode
            if( flag.includes('us') || flag.includes('au') ) {
                flag=flag.replace(/[0-9]/, '')
                flag=flag.split('-')[0]
            }
            if( flag == 'asia9' ) { flag='asia4' }
            if( flag == 'asia6' ) { flag='asia2' }
            if( flag == 'na2' ) { flag='na1' }
            flag='/assets/flags/'+flag+'.svg'
            return flag
            return flag
        }
        // Populate the flags for a list of locations
        function populateFlags(locations) {
            locations.forEach(function(l) {
                l.icon = getFlag(l.value)
            })
            return locations
        }
        function getRegisterAccountUrl() {
            var lang = $translate.use()
            var host='https://'+ (MAIN_HOST||'templ.io')
            var path = lang == 'sv' ? 'sv/mitt-konto/register-account/' : 'my-account/register-account/'
            return host+'/'+path
        }
        function getDomainRegistrationState(obj) {
            if (!obj.reg_state) {
                obj.reg_state=obj.zone && obj.zone.registration && obj.zone.registration.id && (obj.zone.registration.state||'REGISTERED') || 'UNREGISTERED'
            }
            return obj.reg_state
        }
        return {
            siblingState:siblingState
            ,gotoState:gotoState
            ,daysInMonth:daysInMonth
            ,getFlag:getFlag
            ,populateFlags:populateFlags
            ,getRegisterAccountUrl:getRegisterAccountUrl
            ,getDomainRegistrationState:getDomainRegistrationState
            ,detailsController:detailsController
            ,addFormLabels:addFormLabels
            ,translate:translate
            ,alert:alert
            ,error:error
            ,confirm:confirm
            ,getCached:function (key) {
                return this.cache && this.cache[key]
            }
            ,putCache:function(key,val) {
                this.cache=this.cache||{}
                this.cache[key]=val
            },
            processing_title:function(op){
                if(!op) return
                return op.type+' '+op.model;
            },
            add_listener:function(scope,l) {
                if(!scope.__listeners) {
                    scope.__listeners=[]
                    scope.$on('$destroy',function() { 
                        console.log('Destroying listeners',scope.__listeners.length);
                        for (var l in scope.__listeners||[]) { 
                            //console.log('cancel listener',l);
                            scope.__listeners[l]()
                        }
                        delete scope.__listeners
                    })
                }
                scope.__listeners.push(l)
            },
            MSG_LEVEL_ERROR:100,
            MSG_LEVEL_WARNING:80,
            MSG_LEVEL_WAITING:50,
            MSG_LEVEL_INFO:30,
            MSG_LEVEL_DEBUG:10
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('app.services',[])
        .config(function($translatePartialLoaderProvider) {
            $translatePartialLoaderProvider.addPart('app/main/services');
        })

})();

(function () {
    'use strict';

    angular
        .module('app.services')
        .factory('UserCommand', UserCommand);

    /**
     * UserCommand — reusable plumbing for exposing backend commands to users.
     *
     * Usage:
     *   UserCommand.run(vm, commandName, options)
     *     - Looks up the command by name via appcommands API
     *     - Sets vm.obj.run_commands payload on the WooApp object
     *     - Calls vm.save() then vm.update_object() to trigger polling
     *     - Returns a promise that resolves when the command has been dispatched
     *       (not when it completes — watch vm.obj.operation for completion)
     *
     * Adding a new user-facing command in the future:
     *   1. Call UserCommand.run(vm, 'your.command.name', {optKey: optVal})
     *   2. Watch vm.obj.operation for completion and parse operation.msgs
     */
    /** @ngInject */
    function UserCommand(msApi, $q) {
        var self = {
            run: run
        };
        return self;

        /**
         * Dispatch a named backend command on the given WooModelEditController vm.
         *
         * @param {object} vm      - controller instance with vm.obj, vm.save, vm.update_object
         * @param {string} name    - backend command name, e.g. 'utils.list.files'
         * @param {object} opts    - command options map (can be {})
         * @param {object} config  - optional run config:
         *                             verbose {boolean} - default false; set true to include
         *                                                 the raw "Running: ..." shell echo in
         *                                                 operation.msgs (admin-style output)
         * @returns {promise}   - resolves when save+dispatch completes, rejects on error
         */
        function run(vm, name, opts, config) {
            var cfg = config || {};
            var deferred = $q.defer();

            msApi.resolve('appcommands@get').then(function (result) {
                var commands = result.docs || result;
                var cmd = _.find(commands, function (c) { return c.name === name; });

                if (!cmd) {
                    deferred.reject('Command not found: ' + name);
                    return;
                }

                vm.obj.run_commands = {
                    verbose: cfg.verbose === true,
                    ignore_errors: true,
                    cmds: [{ id: cmd._id, options: opts || {} }]
                };

                vm.save(function () {
                    vm.update_object();
                    deferred.resolve();
                });
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }
    }
})();

(function(){
    'use strict';
    angular
        .module('app.mytranslations',[])
        .factory('MyTranslations', Service)


    function Service($translate,$q) {
        return function(tags) {
            var deferred=$q.defer()
            $translate(tags).then(function(t) {
                deferred.resolve(t)
            },function(err) {
                console.log(err);
                deferred.resolve({})
            })
            return deferred.promise
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.services')
        .factory('ChatService', ChatService)
        .directive('chatLauncher', chatLauncher);

    /**
     * chatLauncher — attribute directive that opens the Crisp chatbox on click.
     *
     * Usage: <a chat-launcher translate="CHAT_WITH_US"></a>
     */
    /** @ngInject */
    function chatLauncher(ChatService) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                element.on('click', function (evt) {
                    evt.preventDefault();
                    scope.$apply(function () {
                        ChatService.open();
                    });
                });
            }
        };
    }

    /**
     * ChatService — thin wrapper around the Crisp chatbox ($crisp) SDK.
     *
     * Centralises every $crisp.push() call so the rest of the app never touches
     * the vendor API directly. All methods are safe to call before the widget
     * script has loaded ($crisp.push queues), and are no-ops under __testing__.
     */
    /** @ngInject */
    function ChatService($window) {
        var self = {
            open: open,
            openWithMessage: openWithMessage,
            setUser: setUser,
            setData: setData,
            setLocale: setLocale,
            reset: reset
        };
        return self;

        function crisp() {
            if (typeof __testing__ !== 'undefined' && __testing__) {
                return null;
            }
            return $window.$crisp || null;
        }

        function open() {
            var c = crisp();
            if (c) {
                c.push(['do', 'chat:open']);
            }
        }

        function openWithMessage(message) {
            var c = crisp();
            if (c) {
                c.push(['set', 'message:text', [message]]);
                c.push(['do', 'chat:open']);
            }
        }

        function setUser(user) {
            var c = crisp();
            if (!c || !user) {
                return;
            }
            if (user.email) {
                if (user.crisp_signature) {
                    c.push(['set', 'user:email', [user.email, user.crisp_signature]]);
                } else {
                    c.push(['set', 'user:email', [user.email]]);
                }
            }
            if (user.name && user.name.first) {
                c.push(['set', 'user:nickname', [user.name.first]]);
            }
            c.push(['set', 'session:data', [buildSessionData(user)]]);
        }

        function buildSessionData(user) {
            var host = $window.MAIN_HOST || 'templ.io';
            var pairs = [];
            if (user.externalID) {
                pairs.push(['user_id', String(user.externalID)]);
                pairs.push(['orders', 'https://' + host + '/wp-admin/edit.php?s&post_status=all&post_type=shop_order&_customer_user=' + user.externalID]);
            }
            if (user.acctId) {
                pairs.push(['acct_id', String(user.acctId)]);
            }
            pairs.push(['agency', isAgency(user)]);
            return pairs;
        }

        function isAgency(user) {
            if (!user.meta_data) {
                return false;
            }
            var elem = user.meta_data.find(function (meta) {
                return meta.key === 'agency';
            });
            return !!(elem && elem.value === 'true');
        }

        function setData(pairs) {
            var c = crisp();
            if (c && pairs && pairs.length) {
                c.push(['set', 'session:data', [pairs]]);
            }
        }

        function setLocale(lang) {
            var c = crisp();
            if (c && lang) {
                c.push(['config', 'locale', [lang]]);
            }
        }

        function reset() {
            var c = crisp();
            if (c) {
                c.push(['do', 'session:reset']);
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.log', ['app.wooadmin'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,
        Models)
    {
        var model = Models['Log']
        var sub_data={
            //populate:['domain','operation']
        }
        var filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            },
            {
                name:'user',label:"User",field:'user',kind:'input'
            }
        ]
        // State
        $stateProvider
            .state('app.'+model.name, {
                url    : '/'+model.name,
                redirectTo: 'app.'+model.name+'.list'
            })
            .state('app.'+model.name+'.list', {
                url    : '/list/:page',
                params : {page: null},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'LogListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    List: ['$stateParams','wtUtils',model.model,'WooModelListResolver',function(params,utils,app,resolver) {
                        return resolver(app,params,{
                            user:'all',
                            populate:['operation'],
                            filters:filters
                        })
                    }],
                    CountUnfiltered: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{
                            __count_only__:true
                        })
                    }]
                },
                data : {
                    substates: {}, //{edit:'app.'+model.name+'.details'},
                    form_type: 'user'
                    ,model:model
                    ,user:'all',selected_user:'all'
                    ,populate:['operation']
                    ,filters:filters
                }

            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/log');

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.log')
        .controller('LogListController', list)
        .controller('LogDetailsController', details)


        function open_log_details(vm,item) {
            //window.alert("wtutils: Confirm Dialog not implemented")
            var edit=vm.modal.open({
                backdrop: true,
                backdropClass: 'show',
                windowClass: 'd-flex justify-content-center align-items-center',
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/main/log/log-details.html',
                //templateUrl: 'app/main/layouts/wt-edit.html',
                controller: 'LogDetailsController',
                controllerAs: 'vm',
                //size: size,
                //appendTo: parentElem,
                resolve: {
                    Log: function () {
                        return item;
                    },
                    Parent: function () {
                        return vm;
                    },
                    Form: [
                        'Log','WooFormResolver',function(m,resolver) {
                            return resolver(m,{},{form_type:'user'})
                        }
                    ]
                }
            })
            return edit.result
            //if (!next) return confirm.result;
        }

        function fixLog(item) {
            if(item.msg=='LOG.SUBSCRIPTION_CHANGED') {
                var old=item.data.old
                var sub=item.data.update
                item.data={}
                if(!old.cancelled && sub.cancelled) {
                    item.msg='LOG.SUBSCRIPTION_CANCELLED'
                } else if(old.status!='on-hold' && sub.status=='on-hold') {
                    item.msg='LOG.SUBSCRIPTION_ON_HOLD'
                } else if(old.total != sub.total) {
                    item.msg='LOG.SUBSCRIPTION_TOTAL_CHANGED'
                    item.data={old:old.total,new:sub.total}
                } else if(old.total_tax != sub.total_tax) {
                    item.msg='LOG.SUBSCRIPTION_TAX_CHANGED'
                    item.data={old:old.total_tax,new:sub.total_tax}
                } else if(old.status!='active' && sub.status=='active') {
                    if(old.status=='on-hold')
                        item.msg='LOG.SUBSCRIPTION_REACTIVATED';
                    else {
                        item.msg='LOG.SUBSCRIPTION_ACTIVATED';
                        item.data={total:sub.total,tax:sub.total_tax}
                    }
                } else {
                    item.data=sub
                }

                return item
            }
            return item
        }

        function list(
            $scope, $rootScope, $uibModal, $state, Log, WooModelListController, CountUnfiltered,
            $filter, List
        )
        {
            var vm = this;
            vm.modal=$uibModal
            vm.content='app/main/wooadmin/models/modellist.html'
            vm.no_create=true
            vm.scope=$scope
            vm.rootScope=$rootScope
            vm.nof_objects_unfiltered=CountUnfiltered && CountUnfiltered.count||0
            vm.api=Log; vm.res=List;
            vm.empty_title='LOG.EMPTY_TITLE'
            vm.empty_text='LOG.EMPTY_TEXT'
            vm.prefix='LOG.'
            vm.loaded_callback = function (objects) {
                vm.objects=_.map(objects, function(d) { return fixLog(new Log(d)) } )
            }
            WooModelListController(vm, $state.current.data)
            //vm.selected_user='all'
        vm.list.tableClass='log-list'
        vm.list.headers=[
            {name:vm.translate('LOG.LIST.USER'),class:'user'},
            {name:vm.translate('LOG.LIST.MSG'),class:'msg'},
            {name:vm.translate('LOG.LIST.DATE'),class:'date'},
            {name:vm.translate('LOG.LIST.DATA'),class:'data'},
        ]
        vm.list.item_template='app/main/log/log_list_item.html'
            //vm.create_button="DOMAINS.CREATE_BUTTON"
            vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
            vm.list.filters=$state.current.data.filters
            vm.Title='LOG.LOG_TITLE'
            vm.openEditView=function(event,item) {
                //alert('Log details')
                open_log_details(vm,item)
            }

        }
        function details(Log,Parent,Models) {
            var vm = this
            var item=Log
            vm.item=item
            if(item.operation && !item.doc){
                var op = item.operation
                item.doc={nid:op.doc, oid:op.doc_id}
            }
            if(item.model && Models[item.model]) {
                vm.state='app.wooadmin.'+Models[item.model].name+'-edit'
                vm.id=item.doc && (item.doc.nid||item.doc.oid)
            }
            vm.isAdmin=Parent.isAdmin
        }
})();

(function ()
{
    'use strict';

    angular
        .module('app.options', [])
        .config(config);
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.options', {
                url    : '/options',
                redirectTo: 'app.options.website'
            })
            .state('app.options.website', {
                url    : '/website/:id',
                params: {id:null,tab:0},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'OptionsController as vm'
                    }
                },
                resolve: {
                    Doc:[
                        '$stateParams','WooApp','WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation']})
                        }
                    ],
                    Options: function (msApi)
                    {
                        return msApi.resolve('appoptions@get');
                    },
                    OptionGroups: function (msApi)
                    {
                        return msApi.resolve('appoptiongroups@get');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/options');

        // Api
        msApiProvider.register('appoptions', ['api/woooption/?populate=overrides&model=WooApp&page_size=-1']);
        // Api
        msApiProvider.register('appoptiongroups', ['api/woooptiongroup/?model=WooApp&page_size=-1']);

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.options')
        .controller('OptionsController', OptionsController)
        .controller('AdvancedController', AdvancedController)
        .constant('OptionsController0', OptionsController0)

    function readVal(obj,path) {
        if (!obj) {return}

        path=path.split('.')
        while(path.length>1) {
            obj=obj[path.shift()]
            if (!obj) {return}
        }
        return obj[path.shift()]
    }
    function assignVal(obj,path,val) {
        obj=obj||{}
        path=path.split('.')
        while(path.length>1) {
            var p=path.shift()
            var d=obj[p]
            if (!d) {
                d=obj[p]={}
            }
            obj=d
        }
        obj[path.shift()]=val
    }


    function AdvancedController($scope, $state, Options, OptionGroups)
    {
        var vm=this
        var data=$state.current.data
        var details=data.details_controller
        vm.initial_tab=details.advanced_tab||0
        vm.isAdmin=details.isAdmin
        vm.tabClasses=function($access){
            if($access=='admin') {
                return 'admin-only'
            }
            return ''
        }
        OptionsController0.call(vm, details.obj, Options,OptionGroups)
        vm.details_save = function() {
            var d=details
            vm.isSaving=true
            d.advanced_tab=vm.selected_tab
            d.save(function () {
                d.update_object()
            })
        }
        vm.save=function(opt) {
            vm.update_settings(opt)
            vm.details_save()
        }

        vm.sync = function(group) {
            vm.obj.sync_settings=group._id
            vm.details_save()
        }
        vm.set_status=function() {
            vm.is_operating=details.status=='working'
        }
        // Links to docs.templ.site help pages
        vm.helpUrls = [
            {optPath: 'phpgeneral.version', url: 'https://docs.templ.site/platform/php-settings'},
            {optPath: 'phppool.memory_limit', url: 'https://docs.templ.site/platform/php-settings'},
            {optPath: 'phppool.upload_max_filesize', url: 'https://docs.templ.site/platform/php-settings'},
            {optPath: 'phppool.post_max_size', url: 'https://docs.templ.site/platform/php-settings'},
            {optPath: 'phppool.max_execution_time', url: 'https://docs.templ.site/platform/php-settings'},
            {optPath: 'phppool.max_input_vars', url: 'https://docs.templ.site/platform/php-settings'},
            {optPath: 'img_conversion.webp', url: 'https://docs.templ.site/performance/webp-support'},
            {optPath: 'wp.cron', url: 'https://docs.templ.site/platform/cron'},
            {optPath: 'wp.cron_frequency', url: 'https://docs.templ.site/platform/cron'},
            {optPath: 'app.cdn_enabled', url: 'https://docs.templ.site/performance/caching/templ-cdn'},
            {optPath: 'site.php_blocked', url: 'https://docs.templ.site/platform/blocked-on-templ'},
        ]
        vm.getHelpUrl=function(optPath) {
            var helpUrl = vm.helpUrls.find(function(obj) {
                return obj.optPath == optPath
            })
            if(helpUrl) {
                return helpUrl.url
            }
            return false
        }
        // TO DO: Get cdn domain from API?
        var cdn_domain = 'cdn' + vm.obj._id + '.templcdn.com' 
        // Show "wt-info" for different opt.path
        vm.wtInfos = [
            {
                optPath: 'img_conversion.webp',
                wtInfos: [
                    {content:'ADVANCED.IMG_CONVERSION.WEBP_ON_DEMAND.INFO.CONTENT', type: 'alert'}
                ]
            },
            {
                optPath: 'phppool.upload_max_filesize',
                wtInfos: [
                    {content:'ADVANCED.PHP_SETTINGS.PHP_UPLOAD_MAX_FILESIZE.INFO.CONTENT', type: 'alert'}
                ]
            },
            {
                optPath: 'wp.cron',
                wtInfos: [
                    {content:'ADVANCED.WP_SETTINGS.SERVER_CRON.INFO.CONTENT', type: 'alert'}
                ]
            },
            {
                optPath: 'wp.cron_frequency',
                wtInfos: [
                    {content:'ADVANCED.WP_SETTINGS.SERVER_CRON_INTERVAL.INFO.CONTENT', type: 'alert'}
                ]
            },
            {
                optPath: 'nginx.multisite2',
                wtInfos: [
                    {content:'ADVANCED.SITE_OPTIONS.MULTISITE.INFO.CONTENT', type: 'alert'}
                ]
            },
            {
                optPath: 'app.cdn_enabled',
                wtInfos: [
                    {content:'ADVANCED.SITE_OPTIONS.CDN.INFO.CONTENT', translateValues: {domain: cdn_domain}, type: 'alert'}
                ]
            },
            {
                optPath: 'site.user_agents.block',
                wtInfos: [
                    {content:'ADVANCED.SITE_OPTIONS.BLOCK_USER_AGENTS.INFO.CONTENT', type: 'alert'}
                ]
            },
            {
                optPath: 'cache.never_cache_urls',
                wtInfos: [
                    {content:'ADVANCED.CACHE.NEVER_CACHE_PATHS.INFO.CONTENT', type: 'alert'}
                ]
            }
        ]
        vm.getWtInfos=function(optPath) {
            var wtInfoObj = vm.wtInfos.find(function(obj) {
                return obj.optPath == optPath
            })
            if(wtInfoObj && wtInfoObj.wtInfos) {
                return wtInfoObj.wtInfos
            }
            return false
        }
        vm.set_status()
    }

    function check_tags(o,app) {
        var tags = o.tags || 'container-wp,container-bedrock,lemp-wp'
        tags=tags.split(',')
        if (_.find(tags, function(tag) {
            if(app.app_type.includes(tag)) return true
        })) return true
        return false
    }

    function OptionsController0(Doc, Options, OptionGroups)
    {
        var vm = this;
        vm.options=Options.docs
        vm.groups=OptionGroups.docs
        vm.onTabSelect=function(group){
            vm.selected_tab=vm.groups.indexOf(group)
        }
        vm.check_tags=vm.check_tags||check_tags
        vm.obj=Doc
        // Filter options (to make values translatable etc...)
        vm.filterOpt = function(opt) {
            if(opt.path == 'phpgeneral.version') {
                var newValues = []
                opt.values.forEach( function(val) {
                    if(typeof val!='string') {
                        return
                    }
                    var newValue = {
                        value: val,
                        name: 'ADVANCED.PHP_GENERAL.VALUES.'+val.replace('.', '')
                    }
                    // Hide very old versions that is not the current version...
                    if(val=='7.2'||val=='7.3') {
                        if(val!=opt.value) {
                            newValue.hidden=true
                        }
                    }
                    newValues.push(newValue)
                })
                if(newValues.length) {
                    // console.log(newValues)
                    opt.values = newValues
                }
            }
            return opt
        }
        vm.filterOptValues = function(opt, Doc) {
            // Filter available memory limits, based on plan
            if(opt.path == 'phppool.memory_limit') {
                if(Doc.app_class == 'staging') {
                    plan = 'STAGING'
                } else {
                    var plan = Doc.pcode.toUpperCase()
                }
                var allValues = [
                    {value: '128M', name: '128MB', disabled: false, disabledPlans: []},
                    {value: '256M', name: '256MB', disabled: false, disabledPlans: []},
                    {value: '512M', name: '512MB', disabled: false, disabledPlans: ['NANO-EZWEB', 'NANO-DI', 'MICRO', 'STAGING']},
                    {value: '1024M', name: '1024MB', disabled: false, disabledPlans: ['NANO-EZWEB', 'NANO-DI', 'MICRO', 'SM01', 'STAGING']},
                    {value: '1536M', name: '1536MB', disabled: false, disabledPlans: ['NANO-EZWEB', 'NANO-DI', 'MICRO', 'SM01', 'SM02', 'STAGING']},
                    {value: '2048M', name: '2048MB', disabled: false, disabledPlans: ['NANO-EZWEB', 'NANO-DI', 'MICRO', 'SM01', 'SM02', 'MED01', 'STAGING']},
                ]
                opt.values = []
                // Disable option if the site's plan is listed in disabledPlan
                allValues.forEach(function(value) {
                    if(value.disabledPlans.includes(plan)) {
                        value.disabled = true
                    }
                    opt.values.push(value)
                })
            }
            // Replace "M" with "MB"
            if(opt.path == 'phppool.upload_max_filesize' || opt.path == 'phppool.post_max_size') {
                var formattedValues = []
                opt.values.forEach(function(value) {
                    formattedValues.push({value: value.value||value, name: value.name||value.replace('M', 'MB')})
                })
                opt.values = formattedValues
            }
            // Add "seconds" postfix
            if(opt.path == 'phppool.max_execution_time') {
                var formattedValues = []
                opt.values.forEach(function(value) {
                    formattedValues.push({value: value.value||value, name: value.name||value+' seconds'})
                })
                opt.values = formattedValues
            }
            // Add "minutes" postfix
            if(opt.path == 'wp.cron_frequency') {
                var formattedValues = []
                opt.values.forEach(function(value) {
                    var postfix = ' minutes'
                    if(value == 1) {
                        postfix = ' minute'
                    }
                    formattedValues.push({value: value.value||value, name: value.name||value+postfix})
                })
                opt.values = formattedValues
            }
            return opt
        }
        vm.init_options=function(obj) {
            var group_map={}
            _.each(vm.groups,function(g) {
                if(!vm.check_tags(g,Doc)) return
                if (g.path) {
                    var msg=readVal(obj.settings_msgs,g.path)
                    if(msg && msg.class) { g.msg={class:msg.class,msg:msg.msg} }
                }
                group_map[g._id]=g
                g.options=[]
            })

            _.each(vm.options,function(opt) {
                if(opt.access=='admin' && !vm.isAdmin) return
                if(!vm.check_tags(opt,Doc)) return

                var g=group_map[opt.group]
                if(!g) return
                var val=readVal(obj.settings,opt.path)
                if(angular.isDefined(val)) { opt.value=val }
                var msg=readVal(obj.settings_msgs,opt.path)
                opt.msg=msg||null

                opt = vm.filterOpt(opt)

                opt = vm.filterOptValues(opt, Doc)

                g.options.push(opt)
            })
            vm.groups=_.filter(vm.groups,function(g) { return g.options && g.options.length>0; })
            _.each(vm.groups,function(g) {
                if(!g.options) return
                g.options.sort(function(a,b) { return (a.order||10000)-(b.order||10000) })
            })
            vm.groups.sort(function(a,b) { return (a.order||10000)-(b.order||10000) })
        }
        vm.init_options(Doc)

        vm.update_settings=function(opt) {
            var update={}
            _.each(vm.options,function(opt) {
                var val=readVal(vm.obj.settings,opt.path)
                if(val!=opt.value) {
                    update[opt.path]=opt.value
                    if (opt.overrides) {
                        var oopt=opt.overrides
                        if (typeof update[oopt.path] == 'undefined') {
                            if(opt.value) {
                                update[oopt.path]=''
                            } else {
                                update[oopt.path]=readVal(vm.obj.settings,oopt.path)
                            }
                        }
                    }
                }
            })
            if (opt) {
                // toggle value
                var val=readVal(vm.obj.settings,opt.path)
                update[opt.path] = !val && true || false
            }
            vm.obj.update_settings=update
        }
    }
    /** @ngInject */
    function OptionsController($state, $stateParams, $window, $scope, $rootScope, $translate,
        AuthService, PollOperation, Doc, Options,OptionGroups)
    {
        var vm = this;
        vm.content = 'app/main/options/options.html'
        vm.doc=Doc
        //debugger
        vm.initial_tab=$stateParams.tab||0
        vm.isAdmin=AuthService.isAdmin()
        OptionsController0.call(vm,Doc,Options,OptionGroups)
        vm.update_object=function() {
            $state.go($state.current.name,{id:Doc._id,tab:vm.selected_tab},{reload:true})
        }
        vm.set_status=function() {
            vm.is_operating=PollOperation && PollOperation(vm,vm.doc)
        }
        vm.set_status()
        vm.cancel=function() {
            $window.history.back()
        }
        vm.save=function(opt) {
            if (vm.is_operating ||  vm.isSaving) {
                return
            }
            vm.isSaving=true
            vm.update_settings(opt)
            Doc.$save({obj_id:Doc._id,populate:['operation']},function (res) {
                //debugger
                //$state.go('app.options.website',{id:Doc._id},{reload:true})
                vm.set_status()
                vm.isSaving=false
            })
        }
        vm.sync = function(group) {
            vm.isSaving=true
            Doc.sync_settings=group._id
            Doc.$save({obj_id:Doc._id,populate:['operation']},function (res) {
                vm.set_status()
                vm.isSaving=false
            })
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.menu_items', [])
        .config(config)

    function config(msNavigationServiceProvider, Models) {
        //Dashboard
        msNavigationServiceProvider.saveItem('dashboard', {
            title    : 'DASHBOARD'
            ,class   : 'dashboard'
            ,translate: 'DASHBOARD.DASHBOARD_NAV'
            ,state: 'app.dashboard'
            ,weight   : 0
        });
        // Navigation
        msNavigationServiceProvider.saveItem('websites', {
            title    : 'WEBSITES'
            ,class   : 'websites'
            ,translate: 'WEBSITE.WEBSITES_NAV'
            ,state: 'app.website'
            ,weight   : 5
        });

        // Navigation
        msNavigationServiceProvider.saveItem('domains', {
            title    : 'DOMAINS',
            class    : 'domains',
            state    : 'app.domain',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'DOMAINS.DOMAINS_NAV',
            weight   : 10
        });

        // Navigation
        msNavigationServiceProvider.saveItem('email', {
            title    : 'EMAIL',
            class    : 'email',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'EMAIL.EMAIL_NAV',
            weight   : 20
        });

        var model = Models['WooEmailAddress']

        msNavigationServiceProvider.saveItem('email.addresses', {
            title    : 'ADDRESSES',
            state    : 'app.'+model.name,
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'EMAIL.ADDRESSES_NAV',
            weight   : 10
        });
        msNavigationServiceProvider.saveItem('email.smtp', {
            title    : 'SMTP',
            state    : 'app.smtp',
            translate: 'EMAIL.SMTP_NAV',
            weight   : 20
        });

        //app.email.verifications
        msNavigationServiceProvider.saveItem('email.verifications', {
            title    : 'VERIFICATIONS',
            state    : 'app.email-verifications',
            translate: 'EMAIL.VERIFICATIONS_NAV',
            weight   : 20
        });

        model = Models['WooAccessKey']
        // Navigation
        msNavigationServiceProvider.saveItem('fileaccess', {
            title    : 'FILEACCESS',
            state    : 'app.'+model.name,
            class    : 'file-access',
            //state    : 'app.fileaccess',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'FILEACCESS.FILEACCESS_NAV',
            weight   : 30
        });
        /*
        msNavigationServiceProvider.saveItem('fileaccess.keys', {
            title    : 'KEYS',
            state    : 'app.'+model.name,
            translate: 'FILEACCESS.KEYS_NAV',
            weight   : 1
        });
        */

        // Navigation
        msNavigationServiceProvider.saveItem('backups', {
            title    : 'BACKUPS',
            class    : 'backups',
            state    : 'app.backup',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'BACKUPS.BACKUPS_NAV',
            weight   : 40
        });

        msNavigationServiceProvider.saveItem('usage', {
            title    : 'USAGE',
            class    : 'usage',
            state    : 'app.usage',
            translate: 'USAGE.USAGE_NAV',
            //group: true,
            weight   : 50
        });
        msNavigationServiceProvider.saveItem('sharing', {
            title    : 'SHARING',
            class    : 'sharing',
            translate: 'SHARING.SHARING_NAV',
            state: 'app.sharing',
            weight   : 55
        });
        /*
        msNavigationServiceProvider.saveItem('language', {
            title    : 'LANGOPTIONS',
            class    : 'language',
            //state    : 'app.langoptions',
            translate: 'LANGOPTIONS.LANGOPTIONS_NAV',
            weight   : 60
        });

        msNavigationServiceProvider.saveItem('language.en', {
            title    : 'EN',
            //state    : 'app.'+model.name,
            translate: 'LANGOPTIONS.EN',
            state: 'app.langoptions',
            stateParams: {'lang':'en'},
            weight   : 1
        });
        msNavigationServiceProvider.saveItem('language.sv', {
            title    : 'SV',
            //state    : 'app.'+model.name,
            translate: 'LANGOPTIONS.SV',
            state: 'app.langoptions',
            stateParams: {'lang':'sv'},
            weight   : 1
        });

        msNavigationServiceProvider.saveItem('myaccount', {
            title    : 'MY_ACCOUNT',
            class    : 'my-account',
            translate: 'WOOADMIN.MY_ACCOUNT',
            weight   : 70,
            href: 'https://templ.io/my-account/',
            target: 'wootemple.account'
        });
        */

        msNavigationServiceProvider.saveItem('user-guide', {
            title    : 'USER_GUIDE',
            class    : 'user-guide',
            translate: 'WOOADMIN.USER_GUIDE',
            weight   : 80,
            href: 'HELP_DOC_URL',
            target: 'wootemple.help'
        });

        /*
        msNavigationServiceProvider.saveItem('logout', {
            title    : 'LOGOUT',
            class    : 'logout',
            translate: 'WOOADMIN.LOGOUT',
            weight   : 90,
            state: 'app.auth.logout'
        });
        */

        msNavigationServiceProvider.saveItem('blueprints', {
             title    : 'BLUEPRINTS'
            ,class   : 'blueprints'
            ,translate: 'BLUEPRINTS.MENU_TITLE'
            ,state: 'app.blueprints'
            ,weight   : 25
        });

    }
})();

(function()
{
    angular
        .module('app.loaders',[])
        .factory('DomainLoader',domainLoader)
        .factory('AppLoader',appLoader)
        .factory('BackupLoader',backupLoader)
        .factory('SharingLoader',sharingLoader)
        .factory('ModelLoader',modelLoader)

//
function sharingLoader(WooSharing,ModelLoader) {
    return function (docs,search,scrolling) {
        return ModelLoader(WooSharing,docs,search,scrolling)
    }
}


function domainLoader(WooDomain,ModelLoader) {
    return function (docs,search,scrolling) {
        return ModelLoader(WooDomain,docs,search,scrolling)
    }
}
function backupLoader(WooBackup,ModelLoader) {
    return function (docs,search,scrolling) {
        //docs.options={select:}
        return ModelLoader(WooBackup,docs,search,scrolling)
    }
}

function appLoader(WooApp,ModelLoader) {
    return function (docs,search,scrolling) {
        return ModelLoader(WooApp,docs,search,scrolling)
    }
}

function modelLoader(AuthService) {
    return function (model,docs,search,scrolling) {
        docs.user=docs.user||AuthService.selectedUser()
        return loader(model,docs,search,scrolling)
    }
}

function loader(resource,docs,search,scrolling) {
    if(scrolling && docs.loading) return
    var args={user:docs.user,select:'name'}
    if(docs.args) args=Object.assign(args,docs.args)
    args.page=(docs.page||0)+1
    if(scrolling) {
        // Scrolling but no more pages to load
        if(docs.total_pages != undefined && args.page>docs.total_pages) return
    }
    if(docs.search==undefined) docs.search=''
    // Unless scrolling, don't load for same search term
    if(!scrolling && docs.page && search==docs.search) return
    if(search!=docs.search) {
        // New search contains previous search, and at most one page exist, no need to load again
        if(search.search(docs.search)>=0 && docs.total_pages<2) return
        // Restart pagination for new search
        args.page=1
    }

    docs.loading=true
    docs.search=search
    if(search) args.__search__=search
    args.page_size=docs.page_size||20
    if(docs.select) args.select=docs.select
    if(docs.populate) args.populate=docs.populate
    if(docs.current) {
        // TODO: Cancel current
        docs.current.$cancelRequest();
    }
    //console.log('Loading objects with search',search,scrolling?', scrolling':'',', and args:',args);
    docs.current = resource.query2(args)
    docs.current.$promise.then(function(res) {
        docs.loading=false; docs.current=null
        docs.page=args.page;
        docs.total_pages=res.pages
        docs.docs=docs.docs||[]
        if(docs.res) res.docs=docs.res(res.docs)
        else res.docs=res.docs.map(function(doc){ return {value:doc._id,name:doc.name}})
        if(scrolling) {
            // Append new result to previous
            docs.docs=docs.docs.concat(res.docs)
        } else {
            docs.docs=res.docs
            if(docs.extra_docs) docs.docs=docs.extra_docs.concat(docs.docs)
        }
    })
    return docs.current.$promise
}

})();

(function ()
{
    'use strict';

    angular
        .module('app.langoptions', [])
        .config(config)
        .constant('Languages',[
            {code:'sv',name:'Svenska'},
            {code:'en',name:'English'}
        ])

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.langoptions', {
                url    : '/langoptions/:lang',
                params: {lang:'en'},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'LangOptionsController as vm'
                    }
                },
                resolve: {
                    LangOptionsData: function (msApi)
                    {
                        return msApi.resolve('langoptions@get');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/langoptions');

        // Api
        msApiProvider.register('langoptions', ['app/data/langoptions/data.json']);

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.langoptions')
        .controller('LangOptionsController', LangOptionsController);

    /** @ngInject */
    function LangOptionsController($state, $stateParams, $window, $scope, $rootScope, $translate, AuthService)
    {
        var vm = this;
        vm.content = 'app/main/langoptions/langoptions.html'
        // Data
        //debugger;
        var lang = $stateParams.lang;
        // State
        // setTimeout(function(){ $window.history.back()}, 50)
        if (lang!=$translate.use()) {
            var l = $rootScope.$on('$translateChangeSuccess',function(e,a) {
                if (a.language==lang) {
                    setTimeout(function(){ $window.history.back()}, 50)
                }
            })
            AuthService.setUserLanguage(AuthService.user,lang)
            $scope.$on('$destroy', l);
            return
        }
        setTimeout(function(){ $window.history.back()}, 50)

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.incident', ['app.wooadmin'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,
        Models)
    {
        var model = Models['Incident']
        var sub_data={
            //populate:['domain','operation']
        }
        var filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            }
        ]
        // State
        $stateProvider
            .state('app.'+model.name, {
                url    : '/'+model.name,
                redirectTo: 'app.'+model.name+'.list'
            })
            .state('app.'+model.name+'.list', {
                url    : '/list/:page',
                params : {page: null},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/wooadmin/models/modellist.html',
                        controller : 'IncidentListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    /*List: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{populate:['operation','domain']})
                    }]*/
                    List: ['$stateParams','wtUtils',model.model,'WooModelListResolver',function(params,utils,app,resolver) {
                        return resolver(app,params,{
                            //populate:['operation','domain'],
                            filters:filters
                        })
                    }],
                    CountUnfiltered: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{
                            __count_only__:true
                        })
                    }]
                },
                data : {
                    //Title: model.Name+'s'
                    //substates: {create:'app.'+model.name+'.edit',edit:'app.'+model.name+'.details'}
                    form_type: 'user'
                    //,populate: ['operation','domain']
                    ,model:model
                    ,filters:filters
                }

            })/*
            .state('app.'+model.name+'.edit', {
                url     : '/edit/:id',
                params  : {id:null},
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'IncidentEditController',
                        controllerAs:'vm'
                    }
                },
                resolve: {
                    Object:[
                        '$stateParams',model.model,'WooModelResolver',function(params,m,resolver) {
                                return resolver(m,params,{populate:['operation','domain']})
                        }
                    ],
                    Form:[
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'user'})
                        }
                    ]
                },
                data: sub_data
            })*/
            .state('app.'+model.name+'.details', {
                url     : '/details/:id',
                params  : {id:null},
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'IncidentDetailsController',
                        controllerAs:'vm'
                    }
                },
                resolve: {
                    Object:[
                        '$stateParams',model.model,'WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{
                                //populate:['operation','domain']
                            })
                        }
                    ],
                    WPApp:[
                        'Object','WPApp','WooModelResolver',function(obj,m,resolver) {
                            //debugger
                            var r = obj.resources.find(function(r) {return r.name=='WPApp'})
                            var params={id:r && r.data.id}
                            return resolver(m,params,{fill:'vulnerable_objects'})
                        }
                    ],
                    App:[
                        'Object','WooApp','WooModelResolver',function(obj,m,resolver) {
                            //debugger
                            var r = obj.resources.find(function(r) {return r.name=='sref' && r.model=='WooApp'})
                            var params={id:r && r.id}
                            return resolver(m,params,{populate:'operation'})
                        }
                    ],
                    Form:[
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'user'})
                        }
                    ]
                },
                data: sub_data
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/incident');

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.incident')
        .controller('IncidentListController',  [
            'WooModelListController','$scope', '$scope', '$state',  'List', 'Incident','CountUnfiltered',
            ListController])
        //.controller('IncidentEditController', EditController)
        .controller('IncidentDetailsController', DetailsController)

    /** @ngInject */
    function ListController(ctrl,scope,rootScope,state,res,m,count) {
        var vm = this;
        vm.scope=scope
        vm.rootScope=rootScope
        vm.nof_objects_unfiltered=count && count.count||0
        vm.api=m; vm.res=res;
        vm.empty_title='INCIDENT.EMPTY_TITLE'
        vm.empty_text='INCIDENT.EMPTY_TEXT'
        vm.prefix='INCIDENT.'
        ctrl(vm,state.current.data)

        vm.Title=vm.translate('INCIDENT.ADDRESSES_NAV')

        vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
        vm.list.filters=state.current.data.filters

    }

    function DetailsController($scope, $state, wtUtils, WooApp, App, WooModelEditController, GetAPs, Object, WPApp, Form, Incident) {
        var vm=this;
        vm.content='app/main/layouts/wt-details-content.html'
        vm.no_edit=true; vm.no_delete=true
        vm.model='incident'
        vm.Object=Object
        Object.accessPoints={name:'WORDPRESS.PLUGINS_ADMIN_PAGE',type:'plugin-admin',path:'wp-admin/',auth:1}
        vm.aps=GetAPs(vm,Object)
        if(WPApp) {
            debugger
            vm.vulns=WPApp.vulnerable_objects //WPApp.full_vulnerabilities
            vm.details_template='app/main/incident/incident-details.html'
        } else if (App) {
            vm.app=App
            if (Object.kind=='wcheck') {
                vm.details_template='app/main/incident/upcheck.html'
            } else if(Object.kind=='scanerr') {
                vm.details_template='app/main/incident/scancheck.html'
            } else {
                vm.details_template='app/main/incident/otherincident.html'
            }
        }
        wtUtils.addFormLabels('INCIDENT',Form)
        vm.Form=Form
        vm.title="INCIDENT.DETAILS_TITLE"
        vm.scope=$scope
        vm.api=Incident
        WooModelEditController(vm,$state.current.data.back_state)
        vm.update_object=function(obj) {
            vm.errors=vm.obj.resources.filter(function(r) {return r.model=='error'}).map(function (e) {return e.value})
            vm.website=vm.obj.resources.find(function(r) {return r.model=='WooApp' && r.name!='sref'})
        }
        vm.update_object(vm.obj)
        wtUtils.detailsController(vm,$state)
        vm.close=function() {
            vm.obj.open=false
            vm.save(function() {
            })
        }
        vm.reopen=function() {
            vm.obj.open=true
            vm.obj.acknowledged=0
            vm.obj.responding=0
            vm.save(function() {
            })
        }
        vm.fix=function() {
            $state.go('app.wordpress.update',{id:WPApp._id})
        }
        vm.check_again=function() {
            var id=WPApp.app
            WooApp.get({obj_id:id,select:['__version__']},function(site) {
                site['check-vulnerabilities']=1
                vm.saving=true
                site.$save({obj_id:id},function() {
                    $state.go('app.website.details',{id:id})
                })
            })
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module("app.graphs", ['app.wooadmin'])
        .config(config)

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,
        Models)
    {
        var filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            }
        ]
        // State
        $stateProvider
            .state('app.graphs', {
                url     : '/graphs/',
                //params  : {id:null},
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        //templateUrl:
                        controller : 'GraphController',
                        controllerAs:'vm'
                    }
                }
                ,resolve:{
                    Apps: ['$stateParams','WooApp','WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,{
                            query:{app_class:'live',app_type:'u18-container-wp'}
                        },{
                            populate:['location','plan','container.manager.domainn']
                            ,filters:filters
                            ,select:['name','location','plan','container']
                        })
                    }]
                    ,Config:function() { return null }
                }
            })
    }

    function controller() {
        var vm=this
        this.layout='app/main/graphs/example.html'
        var myChartObject=this.myAnnotations={}


        var secondRow = [
            {v: new Date(2314, 2, 16)},
            {v: 13},
            {v: 'Lalibertines'},
            {v: 'They are very tall'},
            {v: 25},
            {v: 'Gallantors'},
            {v: 'First Encounter'}
        ];


        myChartObject.type = "AnnotationChart";

        myChartObject.data = {"cols": [
            {id: "month", label: "Month", type: "date"},
            {id: "kepler-data", label: "Kepler-22b mission", type: "number"},
            {id: "kepler-annot", label: "Kepler-22b Annotation Title", type: "string"},
            {id: "kepler-annot-body", label: "Kepler-22b Annotation Text", type: "string"},
            {id: "desktop-data", label: "Gliese mission", type: "number"},
            {id: "desktop-annot", label: "Gliese Annotation Title", type: "string"},
            {id: "desktop-annot-body", label: "Gliese Annotaioon Text", type: "string"}
        ], "rows": [
            {c: [
                {v: new Date(2314, 2, 15)},
                {v: 19 },
                {v: 'Lalibertines'},
                {v: 'First encounter'},
                {v: 7},
                {v: undefined},
                {v: undefined}
            ]},
            {c: secondRow},
            {c: [
                {v: new Date(2314, 2, 17)},
                {v: 0},
                {v: 'Lalibertines'},
                {v: 'All crew lost'},
                {v: 28},
                {v: 'Gallantors'},
                {v: 'Omniscience achieved'}

            ]}
        ]};

        myChartObject.options = {
            displayAnnotations: true
        };

        var myGauge = this.myGauge = {};
        myGauge.type = "Gauge";

        myGauge.options = {
          width: 400,
          height: 120,
          redFrom: 90,
          redTo: 100,
          yellowFrom: 75,
          yellowTo: 90,
          minorTicks: 5
        };

        myGauge.data = [
          ['Label', 'Value'],
          ['Memory', 80],
          ['CPU', 55],
          ['Network', 68]
        ];

        vm.myChartObject=vm.myGraph={}
        init(vm)
    }

    function hideSeries(selectedItem) {
        var $scope=this
        var col = selectedItem.column;
        if (selectedItem.row === null) {
            if ($scope.myChartObject.view.columns[col] == col) {
                $scope.myChartObject.view.columns[col] = {
                    label: $scope.myChartObject.data.cols[col].label,
                    type: $scope.myChartObject.data.cols[col].type,
                    calc: function() {
                        return null;
                    }
                };
                $scope.myChartObject.options.colors[col - 1] = '#CCCCCC';
            }
            else {
                $scope.myChartObject.view.columns[col] = col;
                $scope.myChartObject.options.colors[col - 1] = $scope.myChartObject.options.defaultColors[col - 1];
            }
        }
    }

    function init($scope) {
        $scope.hideSeries = hideSeries;
        $scope.myChartObject.type = "LineChart";
        $scope.myChartObject.displayed = false;
        $scope.myChartObject.data = {
            "cols": [{
                id: "month",
                label: "Month",
                type: "string"
            }, {
                id: "laptop-id",
                label: "Laptop",
                type: "number"
            }, {
                id: "desktop-id",
                label: "Desktop",
                type: "number"
            }, {
                id: "server-id",
                label: "Server",
                type: "number"
            }, {
                id: "cost-id",
                label: "Shipping",
                type: "number"
            }],
            "rows": [{
                c: [{
                    v: "January"
                }, {
                    v: 19,
                    f: "42 items"
                }, {
                    v: 12,
                    f: "Ony 12 items"
                }, {
                    v: 7,
                    f: "7 servers"
                }, {
                    v: 4
                }]
            }, {
                c: [{
                    v: "February"
                }, {
                    v: 13
                }, {
                    v: 1,
                    f: "1 unit (Out of stock this month)"
                }, {
                    v: 12
                }, {
                    v: 2
                }]

            }, {
                c: [{
                    v: "March"
                }, {
                    v: 24
                }, {
                    v: 5
                }, {
                    v: 11
                }, {
                    v: 6
                }]
            },{
                c: [{
                    v: "April"
                }, {
                    v: 19
                }, {
                    v: 8
                }, {
                    v: 16
                }, {
                    v: 4
                }]
            },{
                c: [{
                    v: "May"
                }, {
                    v: 24
                }, {
                    v: 5
                }, {
                    v: 11
                }, {
                    v: 6
                }]
            },{
                c: [{
                    v: "June"
                }, {
                    v: 19
                }, {
                    v: 8
                }, {
                    v: 16
                }, {
                    v: 4
                }]
            }]
        };
        $scope.myChartObject.options = {
            "title": "Sales per month",
            "colors": ['#0000FF', '#009900', '#CC0000', '#DD9900'],
            "defaultColors": ['#0000FF', '#009900', '#CC0000', '#DD9900'],
            "isStacked": "true",
            "fill": 20,
            "displayExactValues": true,
            "vAxis": {
                "title": "Sales unit",
                "gridlines": {
                    "count": 10
                }
            },
            "hAxis": {
                "title": "Date"
            }
        };

        $scope.myChartObject.view = {
            columns: [0, 1, 2, 3, 4]
        };
    }
})();

(function ()
{
    'use strict';
    // Test by fetching live data from server
    var testing_live = false;
    var testing_live_panel = false;
    var testing_live_host='https://othilia.templweb.com'
    var testing_live_obj='3599'
    testing_live_obj='3598'
    // If token expired, generate new at: https://panel.templ.io/auth/graph/22
    var testing_live_token='0S7rsUhStY1n0Mf31w47GhWJiMG50XM'
    //testing_live_token='Gyvrme6pDDKkrhqRLq1LygSc8bn6VPr'
    var testing_options = false;
    var testing_local = false;
    //testing_local=true;

    var materialType={
        LineChart:'Line'
    }
    angular
        .module("app.graphs")
        .controller("GraphController",controller)
        .constant("GraphController0",controller0)
        .directive('myGooglechart',my_googlechart)

        function my_googlechart() {
            return {
                require: '?ngModel',
                link: function(scope,element,attr,controller) {
                    function draw() {
                        var g=scope.g
                        if(g.draw==1) {
                            //console.log('draw '+g.name);
                            g.drawChart(element[0])
                            g.draw=0
                        }
                    }
                    scope.$watch('g.draw',draw)
                }
             }
        }

        function callApi(api,path,args) {
            var vm=this
            var http=vm.http
            var cookies=vm.cookies
            var p = vm.q.defer()
            //api='http://test.templ.io:19998/'
            args.token=vm.graph_token.token; args.user=vm.selected_user
            args=Object.entries(args).map(function(e) {return e[0]+'='+e[1]}).join('&')
            var url=api+path+'?'+args
            http.get(url,{ignore_auth_failure:true}).then(
                function (res) { p.resolve(res.data) },function(err) {
                    if(err.status == 401) vm.loadToken()
                    p.reject(err)
                }
            )
            return p.promise
        }

        function Graph (vm,settings,options) {
            //constructor(type,options,data){
                this.type=settings.type;this.ctype=settings.ctype;
                this.options=Object.assign({title:settings.name},options)
                this.vm=vm; this.name=settings.name
                this.draw=0
                this.api=settings.api,this.disabled=settings.disabled
                this.admin=settings.admin
                this.process=settings.process
                this.chart_options=settings.chart_options
                this.title=settings.title
                this.titletooltip=settings.titletooltip
                var self=this
            //}
            this.drawChart=function(elem) {
                var chart, options=Object.assign({},this.options)
                options.curveType= vm.curve && 'function' || null
                options.isStacked = this.options.isStacked || vm.stacked
                var type=vm.chartType || this.type
                if(vm.material) {
                    chart = new google.charts.Line(elem);
                    options=google.charts.Line.convertOptions(options);
                } else chart = new google.visualization[type](elem);

                chart.draw(this.table,options)
                this.chart=chart
            }
            this.clearChart=function() {
                if(this.chart) this.chart.clearChart()
                this.chart=null
            }
        }


        function loadData() {
            var vm=this
            vm.loading=vm.q.defer()
            vm.loading.promise.then(function() {
                vm.loading=null
            })
            var c=vm.app.id
            if (testing_live) c=testing_live_obj // TESTING
            if(vm._testData) {
                addData(JSON.parse(JSON.stringify(vm._testData)),vm.graphs)
                if(vm.loading) vm.loading.resolve()
                return
            }
            var server_host=vm.app && vm.app.container && vm.app.container.manager && vm.app.container.manager.domainn
            var server_api = 'https://' + server_host
            if (testing_live) server_api=testing_live_host  // TESTING
            if (testing_local) server_api='http://test.templ.io:19998' // TESTING
            server_api=server_api+'/graph-api/'
            var graphByApi={}
            this.graphs.forEach(function(g) {
                if(g.disabled) return
                var api=g.api||server_api
                graphByApi[api]=graphByApi[api]||[]
                graphByApi[api].push(g)
            })
            var apis=Object.entries(graphByApi)
            var count=0
            apis.forEach(function (item) {
                var api=item[0]; var graphs=item[1]
                var charts=graphs.map(function(c) {return c.ctype})
                charts=charts.join(',')
                vm.callApi(api,'data',{group:vm.group,after:vm.after,before:-vm.before,points:vm.points,c:c,chart:charts}).then(function(data) {
                    //var labels = data.data.unshift(data.labels)
                    addData(data,graphs)
                    count += 1
                    if(count==apis.length && vm.loading) {
                        vm.loading.resolve()
                    }
                })
            });
            function addData(data,graphs) {
                if(data && !data.data) data=data[0]
                graphs.forEach(function (graph) {
                    var cdata=data && data[graph.ctype]
                    if(!cdata || !cdata.data|| !cdata.labels) {
                        graph.clearChart(); return
                    }
                    if (graph.process) graph.process(cdata)
                    var table = new google.visualization.DataTable();
                    table.addColumn('datetime', 'Time');
                    var labels=cdata.labels.splice(1)
                    _.each(labels, function(l) {table.addColumn('number', l)});
                    if(cdata.data[0] && _.isNumber(cdata.data[0][0]))
                        _.each(cdata.data,function(r) {r[0]=new Date(1000*parseInt(r[0]))})
                    table.addRows(cdata.data)
                    graph.table=table
                    //data.unshift(labels)
                    graph.draw=1
                })
            }
        }
        // var LCOptions={
            //"colors": ['#0000FF', '#009900', '#CC0000', '#DD9900'],
            //"defaultColors": ['#0000FF', '#009900', '#CC0000', '#DD9900'],
            //"fill": 20,
            // "displayExactValues": true,
            // "hAxis": {
            //     "title": "Time"
            // },
            // interpolateNulls:true,
            // explorer:{
            //     actions:['dragToZoom','rightClickToReset']
            //     ,axis: 'horizontal'
            //     ,maxZoomIn:0.01
            //     //,keepInBounds:true
            // }
        // }
        var LCOptions={

            colors: ['#2b88e4', '#f36d72', '#55D09B', '#f49980', '#8c8366', '#6F7780', '#fdeba2'],
            font: 'Roboto',
            fontSize: '12',

            // curveType: 'function',
            legend: { position: 'bottom' },
            chartArea: {width: '100%', height: '75%'},
            titlePosition: 'out',
            titleTextStyle: {
                color: '#5E656D',
                //fontName: 'Roboto',
                fontSize: '16',
                bold: true,
                italic: false
            },
            axisTitlesPosition: 'in',

            interpolateNulls:true,

            "hAxis": {
                textPosition: 'out',
                baselineColor: 'transparent',
                gridlines: {
                    color: 'none'
                },
                minorGridlines: {
                    count: 0,
                    color: 'none'
                },
                // viewWindowMode: 'maximized'
            },
            tooltip: {
                textStyle: {
                    color: '#5E656D',
                    //fontName: 'Roboto',
                }
            }
        }
        var LCData=[]
        function loadToken(initial) {
            var vm=this
            vm.http.get(API_HOST+'/auth/graph/'+vm.selected_user).then(function(res) {
                vm.graph_token=res.data
                if (testing_live) vm.graph_token.token=testing_live_token //TESTING
                //if (testing_local) vm.graph_token.token='6gVsjgezWXrsO90TTaxynoH7ZLmizEF' //TESTING
                if(initial)vm.scope.$watch('vm.chartsReady',function(){
                    vm.start(true)
                })
            })
        }

        function controller($scope,$q,$http,$cookies,Apps,AuthService,UserInfo,Config) {
            controller0.call(this,$scope,$q,$http,$cookies,Apps,AuthService,UserInfo,Config)
        }
        function controller0($scope,$q,$http,$cookies,Apps,AuthService,UserInfo,Config) {
            google.charts.load('current', {'packages':['corechart','line']});
            var vm=this
            if(!vm.ranges) {
                vm.ranges=[
                    {value:-300,name:'GRAPHS.5M'},
                    {value:-3600,name:'GRAPHS.1H'},
                    {value:-21600,name:'GRAPHS.6H'},
                    {value:-43200,name:'GRAPHS.12H'},
                    {value:-86400,name:'GRAPHS.24H'}
                ]
            }
            vm.isAdmin=AuthService.isAdmin()
            vm.after=-300; vm.points=300; vm.group='average'
            vm.before=0
            vm.scope=$scope
            vm.apps=Apps&&Apps.docs||Apps
            vm.app=vm.apps&&vm.apps[0]
            if(!vm.app||!vm.app.id) return
            vm.select_app=function(app){
                if(app.id==vm.app.id) return
                vm.app=app
                vm.start()
            }
            vm.q=$q
            this.layout= Config && Config.layout || 'app/main/graphs/graphs.html'
            this.http=$http; this.cookies=$cookies
            if(!this.selected_user)
                this.selected_user=AuthService.selectedUser() || AuthService.user && AuthService.user.acctId

            var panel_api=API_HOST+'/api/graphs/chart/'
            if(testing_live_panel) panel_api='https://panel.templ.io'+panel_api
            if(vm.app && vm.app.app_type.endsWith('container-server')) {
                vm.graphs=[
                    new Graph(this,{
                        name:"CPU",
                        type:"AreaChart",
                        ctype:"system.cpu"
                    },Object.assign({
                        "vAxis": {
                            title: "%",
                            textPosition: 'in',
                            baselineColor: 'transparent',
                            gridlines: {
                                color: '#E7E9EC'
                            },
                            minorGridlines: {
                                color: 'none'
                            },
                            viewWindow: {
                                min: 0
                            },
                            maxValue: 1
                        },
                        isStacked:true
                    },LCOptions),LCData)
                    ,new Graph(this,{
                        name:"Memory Available",
                        type:"LineChart",
                        ctype:"mem.available"
                    },Object.assign({
                        "vAxis": {
                            title: "MiB",
                            textPosition: 'in',
                            baselineColor: 'transparent',
                            gridlines: {
                                color: '#E7E9EC'
                            },
                            minorGridlines: {
                                color: 'none'
                            },
                            viewWindow: {
                                min: 0
                            },
                            maxValue: 1
                        }
                    },LCOptions),LCData)
                ]
            } else {
                vm.graphs=[

                    // CPU Graph
                    new Graph(this,{
                        name:"",
                        type:"LineChart",
                        ctype:"cpu",
                        title:"GRAPHS.CPU_TITLE",
                        titletooltip:"GRAPHS.CPU_TOOLTIP"
                        ,process:function (data) {
                            data.labels=[data.labels[0],'used']
                            data.data=_.map(data.data,function (d) {
                                return [d[0],d[1]+d[2]]
                            })
                        }
                    },Object.assign({
                        "vAxis": {
                            title: "%",
                            textPosition: 'in',
                            baselineColor: 'transparent',
                            gridlines: {
                                color: '#E7E9EC'
                            },
                            minorGridlines: {
                                color: 'none'
                            },
                            viewWindow: {
                                min: 0
                            },
                            maxValue: 1
                        }
                    },LCOptions),LCData)

                    // Memory Graph
                    ,new Graph(this,{
                        name:"",
                        type:"LineChart",
                        ctype:"mem_usage",
                        title:"GRAPHS.MEMORY_TITLE",
                        titletooltip:"GRAPHS.MEMORY_TOOLTIP"
                    },Object.assign({
                        "vAxis": {
                            title: "MiB",
                            textPosition: 'in',
                            baselineColor: 'transparent',
                            gridlines: {
                                color: '#E7E9EC'
                            },
                            minorGridlines: {
                                color: 'none'
                            },
                            viewWindow: {
                                min: 0
                            },
                            maxValue: 1
                        }
                    },LCOptions),LCData)

                    // Disk chart
                    ,new Graph(this,{
                        // disabled:true,
                        name:"",
                        type:"LineChart",
                        ctype:"disk",
                        title:"GRAPHS.DISK_TITLE",
                        titletooltip:"GRAPHS.DISK_TOOLTIP",
                        api:panel_api
                    },Object.assign({
                        "vAxis": {
                            title: "GiB",
                            textPosition: 'in',
                            baselineColor: 'transparent',
                            gridlines: {
                                color: '#E7E9EC'
                            },
                            minorGridlines: {
                                color: 'none'
                            },
                            viewWindow: {
                                min: 0
                            },
                            maxValue: 1
                        }
                    },LCOptions),LCData)

                    // BW/data chart
                    ,new Graph(this,{
                        // disabled:true,
                        name:"",
                        type:"LineChart",
                        ctype:"data",
                        title:"GRAPHS.BW_TITLE",
                        titletooltip:"GRAPHS.BW_TOOLTIP",
                        api:panel_api
                    },Object.assign({
                        "vAxis": {
                            title: "MiB",
                            textPosition: 'in',
                            baselineColor: 'transparent',
                            gridlines: {
                                color: '#E7E9EC'
                            },
                            minorGridlines: {
                                color: 'none'
                            },
                            viewWindow: {
                                min: 0
                            },
                            maxValue: 1
                        }
                    },LCOptions),LCData)
                ]

                if (vm.isAdmin) {
                    // Memory Detailed Graph
                    vm.graphs.push(new Graph(this,{
                        disabled:true,admin:true,
                        name:"Memory Detailed",type:"LineChart",ctype:"mem"
                    },Object.assign({
                        "vAxis": {
                            title: "MiB",
                            textPosition: 'in',
                            baselineColor: 'transparent',
                            gridlines: {
                                color: '#E7E9EC'
                            },
                            minorGridlines: {
                                color: 'none'
                            },
                            viewWindow: {
                                min: 0
                            },
                            maxValue: 1
                        }
                    },LCOptions),LCData))
                    vm.graphs.push(new Graph(this,{
                        disabled:true,admin:true,
                        name:"Generic",type:"LineChart",ctype:'',
                        chart_options:[
                            'php.slice.cpu','mariadb.service.cpu','app-cron.service.cpu',
                            'php.slice.mem_pressure','mariadb.service.mem_pressure','app-cron.service.mem_pressure'
                        ]
                    },Object.assign({
                        "vAxis": {
                            title: "MiB",
                            textPosition: 'in',
                            baselineColor: 'transparent',
                            gridlines: {
                                color: '#E7E9EC'
                            },
                            minorGridlines: {
                                color: 'none'
                            },
                            viewWindow: {
                                min: 0
                            },
                            maxValue: 1
                        }
                    },LCOptions),LCData))
                }
            }
            vm.loadToken=loadToken
            vm.loadData=loadData
            vm.callApi=callApi
            vm.start=function(initial) {
                if(!vm.chartsReady) return
                if (testing_options||vm.testing_options) vm._testData=vm.testData
                if(initial && Config && Config.skip_initial_load) return
                vm.loadData()
            }
            vm.loadToken(true)
            function ready() {
                vm.chartsReady=1
                $scope.$digest();
            }
            google.charts.setOnLoadCallback(ready);
        }
})();

(function ()
{
    'use strict';

    angular
        .module('app.help', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.help', {
                url    : '/help',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/help/help.html',
                        controller : 'HelpController as vm'
                    }
                },
                resolve: {
                    HelpData: function (msApi)
                    {
                        return msApi.resolve('help@get');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/help');

        // Api
        msApiProvider.register('help', ['app/data/help/help.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('help', {
            title    : 'HELP',
            icon     : 'icon-help',
            state    : 'app.help',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'HELP.HELP_NAV',
            weight   : 1
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.help')
        .controller('HelpController', HelpController);

    /** @ngInject */
    function HelpController(HelpData)
    {
        var vm = this;

        // Data
        vm.helloText = HelpData.data.helloText;

        vm.openQuick = function() {
        }
        vm.openChat = function() {
            if(typeof $zopim !== 'undefined' ) {
                $zopim.livechat.window.show()
            }
        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.host', ['app.wooadmin'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,
        Models)
    {
        var model = Models['TemplHost']
        var sub_data={
            //populate:['domain','operation']
        }
        var filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            }
        ]
        // State
        $stateProvider
            .state('app.'+model.name, {
                url    : '/'+model.name,
                redirectTo: 'app.'+model.name+'.list'
            })
            .state('app.'+model.name+'.list', {
                url    : '/list/:page',
                params : {page: null},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/wooadmin/models/modellist.html',
                        controller : 'HostListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    List: ['$stateParams','wtUtils',model.model,'WooModelListResolver',function(params,utils,app,resolver) {
                        //return [{app:{name:'hej'},_id:1}]
                        return resolver(app,params,{
                            populate:['operation','app.name'],
                            filters:filters
                        })
                    }],
                    Count: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        //return {count:1}
                        return resolver(app,params,{
                            __count_only__:true
                        })
                    }]
                },
                data : {
                    form_type: 'user'
                    ,model:model
                    ,populate:['operation','app.name']
                    ,filters:filters
                }

            })
            .state('app.'+model.name+'.processing', {
                url     : '/updating/:id',
                params  : {id:null},
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'HostProcessingController',
                        controllerAs:'vm'
                    }
                },
                resolve: {
                    Obj:[
                        '$stateParams',model.model,'WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{
                                //populate:['operation','domain']
                            })
                        }
                    ]
                },
                data: sub_data
            })
            .state('app.'+model.name+'.details', {
                url     : '/details/:id',
                params  : {id:null},
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'HostDetailsController',
                        controllerAs:'vm'
                    }
                },
                resolve: {
                    Obj:[
                        '$stateParams',model.model,'WooModelResolver',
                        function(params,m,resolver) {
                            //return {}
                            return resolver(m,params,{
                                populate:['operation','app'],
                                fill:'capps'
                            })
                        }
                    ]
                },
                data: sub_data
            })
            .state('app.'+model.name+'.test', {
                url     : '/test/',
                params  : {id:null},
                views   : {
                    'content@app' : {

                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'HostTestController',
                        controllerAs:'vm'
                    }
                },
                data: sub_data
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/host');

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.host')
        .controller('HostListController',ListController)
        //.controller('IncidentEditController', EditController)
        .controller('HostTestController', TestController)
        .controller('HostDetailsController', DetailsController)
        .controller('HostProcessingController', ProcessingController)

    function ListController($state,$scope,$rootScope,Count,List,TemplHost,WooModelListController) {
        var vm = this;
        vm.scope=$scope
        vm.rootScope=$rootScope
        vm.extra_buttons=[{name:"test",fun:function() { $state.go('app.host.test')}}]
        vm.nof_objects_unfiltered=Count && Count.count||0
        vm.api=TemplHost; vm.res=List;
        vm.no_create=1
        vm.prefix='TEMPLHOST.'
        vm.empty_title=vm.prefix+'EMPTY_TITLE'
        vm.empty_text=vm.prefix+'EMPTY_TEXT'
        var data=$state.current.data
        data.substates = {edit:'app.host.details'}
        WooModelListController(vm,data)

        vm.Title=vm.translate(vm.prefix+'LIST_TITLE')

        vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
        vm.list.filters=$state.current.data.filters
    }

    function refresh_netdata(vm){
        if(typeof NETDATA == 'undefined' ) return setTimeout(function(){ refresh_netdata()},2000)
        if(!NETDATA.started) {
            NETDATA.start()
        }
        NETDATA.pause(function() {
            NETDATA.unpause()
        })
        NETDATA.options.page_is_visible=true

        vm.scope.$on('$destroy',function() {
            NETDATA.options.page_is_visible=true
            NETDATA.pause(function () {
                NETDATA.options.page_is_visible=false
            })
        })
    }
    function refresh(vm) {
        vm.http.get(vm.data_host+'ping.html',{headers:{Authorization:vm.auth}}).then(function(response) {
            refresh_netdata(vm)
        },function (response) {
            if(!__testing__) alert('Authorization failed')
        })
    }

    var plan={
        addon:{cpu:0.125,ram:0.5},
        sm01:{cpu:0.25,ram:1},
        sm02:{cpu:0.5,ram:2},
        med01:{cpu:1,ram:4},
        lar01:{cpu:2,ram:8}
    }
    function getCPU(pcode) {
        return plan[pcode] && plan[pcode].cpu || 0.25
    }
    function getRAM(pcode) {
        return plan[pcode] && plan[pcode].ram || 1
    }

    function container (app,c) {
        var user=app.fileowner
        var user_id='001'
        var cslice='cgroup_containers.slice_containers-'+user+'.slice'
        var uslice='cgroup_user.slice_user-'+user_id+'.slice'
        var ram_title='RAM Usage'
        var ram_tag=cslice+'.mem'
        var cpu=app.cpu || getCPU(app.pcode)
        var ram=app.ram || getRAM(app.pcode)
        if(app._id==app.container.manager) {
            cslice='system'
            ram_title='RAM Available'
            ram_tag='mem.available'
            cpu=1
        }
        return {
            app:app._id,
            name:app.name,
            properties:c&&c.properties,
            cpu_graph:{
                title:'CPU Usage',
                tag:cslice+'.cpu',
                min:cpu*100
            },
            ram_graph:{
                title:ram_title,
                tag:ram_tag,
                max:ram*1024
            },
            io_graph:{
                title:'IO',
                tag:cslice+'.io',
                min:1024
            },
            cpu:c && c.cpu,
            cpuQ: c && c.cpuQ,
            ram: c && c.ram/1024,
            has_staging: c&&c.has_staging
        }
    }

    function getTimers(cpu, ram) {
        return {
            name:'System Timers',
            cpu_graph:{
                title:'CPU Usage',
                tag:'cgroup_timers.slice.cpu',
                min:cpu*100
            },
            ram_graph:{
                title:"RAM Usage",
                tag:'cgroup_timers.slice.mem',
                max:ram*1024
            }
        }
    }

    function DetailsController($scope, $state, $base64, $http, wtUtils, TemplHost,
        WooModelEditController, Obj) {
        var vm=this;
        vm.http=$http
        vm.data_host='https://'+Obj.app.domainn+'/netdata-live/'
        // TODO: Fix these
        vm.auth='Basic ' + $base64.encode("frog:grof");

        vm.prefix='HOST'
        vm.content='app/main/layouts/wt-details-content.html'
        vm.details_template='app/main/host/details.html'
        vm.no_buttons=true
        vm.no_edit=true; vm.no_delete=true
        vm.Object=Obj
        vm.id=Obj._id
        vm.version=Obj.version
        vm.title=vm.prefix+".DETAILS_TITLE"
        vm.cpu_graph='google'
        var app=container(Obj.app)
        app.cslice='system'
        vm.app=app
        vm.timers=getTimers(0.25,1)
        vm.ram_graph='easypiechart'
        vm.args={name:Obj.app.name}
        vm.scope=$scope
        vm.api=TemplHost
        vm.containers=_.map(Obj.capps,function (app) {
            return container(app,Obj.containers[app.container.N-1])
        })
        if(false && __testing__) {
            vm.data_host='https://ken.templweb.com/netdata/'
            vm.containers=[container({
                _id:1504,name:"Stålbambu.se",fileowner:'user_1504',container:{N:1504,manager:Obj.app._id},pcode:'sm01'
            })]
        }

        WooModelEditController(vm,$state.current.data.back_state)
        wtUtils.detailsController(vm,$state)
        vm.refresh=function() { refresh(vm) }
        vm.show_netdata={}
        //setTimeout(function() { vm.refresh() },1000)
        $scope.$watch("vm.show_netdata",function () {
            if(!vm.show_netdata) {
                return
            }
            var show
            angular.forEach(vm.show_netdata, function(item, i) {
                if(item) show = true;
            });
            if(show) {
                vm.refresh()
            }
        },true)
        var used=_.reduce(Obj.containers,function (m,c) {
            if(!c.free) return {cpu:m.cpu+c.cpu,ram:m.ram+c.ram}
            return m
        },{cpu:0,ram:0})
        vm.cpu_available=Obj.cpu
        vm.cpu_total=vm.cpu_available+used.cpu
        vm.ram_available=Obj.ram/1024
        vm.ram_total=vm.ram_available+used.ram/1024
    }

    function TestController($http,$scope,$base64) {
        var vm=this
        vm.http=$http
        vm.scope=$scope
        vm.refresh=function() { refresh(vm) }
        vm.containers=[
            {name:"Timers",slice:"cgroup_timers.slice"},
            {name:"Containers total",slice:"cgroup_containers.slice"},
            {name:"Templ 1504",slice:"cgroup_containers.slice_containers-user_1504.slice",cpu_max:12.5,ram_max:512},
            //{name:"Templ 2546",slice:"cgroup_containers.slice_containers-user2546.slice"},
            {name:"Templ 2601",slice:"cgroup_containers.slice_containers-user_2601.slice"},
            //{name:"Templ 2602",slice:"cgroup_containers.slice_containers-user_2602.slice"}
        ]
        //vm.dashboard_src='https://ken.templweb.com/foo-bar/dashboard.js'
        //vm.dashboard_src='../bower_components/netdata/web/dashboard.js'
        vm.data_host='https://ken.templweb.com/netdata-test/'
        vm.title='Hello there!'
        vm.content='app/main/host/netdata.html'
        vm.auth='Basic ' + $base64.encode("frog:grof");
        //auth='Basic frog:grof';
        setTimeout(function() { vm.refresh() },1000)
    }
    function ProcessingController() {

    }

})();

var mod;

mod = angular.module('infinite-scroll', []);

mod.directive('infiniteScroll', ['$rootScope', '$window', '$timeout', function($rootScope, $window, $timeout) {
        return {
            link: function(scope, elem, attrs) {
                var checkWhenEnabled, handler, scrollDistance, scrollEnabled;
                $window = angular.element($window);
                elem.css('overflow-y', 'auto');
                elem.css('overflow-x', 'hidden');
                elem.css('height', 'inherit');
                scrollDistance = 0;
                if (attrs.infiniteScrollDistance != null) {
                    scope.$watch(attrs.infiniteScrollDistance, function(value) {
                        return (scrollDistance = parseInt(value, 10));
                    });
                }
                scrollEnabled = true;
                checkWhenEnabled = false;
                if (attrs.infiniteScrollDisabled != null) {
                    scope.$watch(attrs.infiniteScrollDisabled, function(value) {
                        scrollEnabled = !value;
                        if (scrollEnabled && checkWhenEnabled) {
                            checkWhenEnabled = false;
                            return handler();
                        }
                    });
                }
                $rootScope.$on('refreshStart', function(){
                    elem.animate({ scrollTop: "0" });
                });
                handler = function() {
                    var container, elementBottom, remaining, shouldScroll, containerBottom;
                    container = $(elem.children()[0]);
                    elementBottom = elem.offset().top + elem.height();
                    containerBottom = container.offset().top + container.height();
                    remaining = containerBottom - elementBottom ;
                    shouldScroll = remaining <= elem.height() * scrollDistance;
                    if (shouldScroll && scrollEnabled) {
                        if ($rootScope.$$phase) {
                            return scope.$eval(attrs.infiniteScroll);
                        } else {
                            return scope.$apply(attrs.infiniteScroll);
                        }
                    } else if (shouldScroll) {
                        return (checkWhenEnabled = true);
                    }
                };
                elem.on('scroll', handler);
                scope.$on('$destroy', function() {
                    return $window.off('scroll', handler);
                });
                return $timeout((function() {
                    if (attrs.infiniteScrollImmediateCheck) {
                        if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
                            return handler();
                        }
                    } else {
                        return handler();
                    }
                }), 0);
            }
        };
    }
]);

/*!
 * ng - password - generator - AngularJS directive to generate a password
 * Author: Aitor Rodríguez - http://www.frontendfactory.es/
 * Version: 1.1.2
 * License: MIT
 */

'use strict';

angular
	.module('ngMyPasswordGenerator', [])
	.controller('myPasswordGeneratorController', ['$scope', function($scope) {

		$scope.passwordField = '';

		$scope.options = {
			passwordLength: 8,
			uppercase: true,
			numbers: true,
			specials: true
		};

	}])
	.directive('myPasswordGenerator', function() {

		return {
			restrict: 'AE',
			replace: true,
			scope: {
				field: '=field',
				passwordLength: '=?passwordLength',
				uppercase: '=?uppercase',
				numbers: '=?numbers',
				specials: '=?specials',
				buttonText: '@?buttonText'
			},
			template: '<a class="generate-password" data-ng-click="generatePassword()">{{ buttonText |translate }}</a>',
			link: function(scope) {

				// Initialize the default values
				scope.passwordLength = (scope.passwordLength) ? scope.passwordLength : 8;
				scope.uppercase = (scope.uppercase) ? scope.uppercase : false;
				scope.numbers = (scope.numbers) ? scope.numbers : false;
				scope.specials = (scope.specials) ? scope.specials : false;
				scope.buttonText = (scope.buttonText !== undefined) ? scope.buttonText : 'Generate password';

				// Enable password generation
				scope.generatePassword = function() {

					// Create variables with characters, numbers and special
					var lowerCharacters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
						upperCharacters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
						numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
						specials = ['+', ',', '-', '.', ':', ';', '[', ']', '{', '}'];

					// Concatenate the differents variables according to true/false
					var finalCharacters = lowerCharacters;

					if (scope.uppercase) {
						finalCharacters = finalCharacters.concat(upperCharacters);
					}

					if (scope.numbers) {
						finalCharacters = finalCharacters.concat(numbers);
					}

					if (scope.specials) {
						finalCharacters = finalCharacters.concat(specials);
					}

					// Iterate while the number is less than passwordLength
					var finalPassword = [];

					for (var i = 0; i < scope.passwordLength; i++) {
						finalPassword.push(finalCharacters[Math.floor(Math.random() * finalCharacters.length)]);
					}

					// Save the result on field
					scope.field = finalPassword.join('');

				};

			}

		};

	});

(function ()
{
    'use strict';

    angular
        .module('app.fileaccess', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $urlRouterProvider, $translatePartialLoaderProvider,
         msNavigationServiceProvider,Models)
    {
        var state_pre='app.'
        var model = Models['WooAccessKey']
        var sub_data={
            populate:['operation']
            ,next_state:{save:state_pre+model.name+'.details'}
        }
        var filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            }
        ]
        // State
        $stateProvider
            .state('app.fileaccess', {
                url    : '/fileaccess',
                redirectTo: state_pre+model.name+'.list'
            })
            .state(state_pre+model.name, {
                url    : '/'+model.name,
                redirectTo: state_pre+model.name+'.list'
            })
            .state(state_pre+model.name+'.list', {
                url    : '/list/:page',
                params : {page: null},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/wooadmin/models/modellist.html',
                        controller : [
                            'WooModelListController','$scope','$rootScope', '$state', 'List', 'CountUnfiltered',
                            model.model,
                            function(ctrl,scope,rootScope,state,res,count,m) {
                                var vm = this;
                                vm.scope=scope
                                vm.rootScope=rootScope
                                vm.nof_objects_unfiltered=count && count.count||0
                                vm.api=m; vm.res=res;
                                vm.Title='ACCESSKEY.LIST_TITLE'
                                vm.empty_title='ACCESSKEY.EMPTY_TITLE'
                                vm.empty_text='ACCESSKEY.EMPTY_TEXT'
                                vm.prefix='ACCESSKEY.'
                                ctrl(vm,state.current.data)
                                vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
                                vm.list.filters=state.current.data.filters
                                vm.empty_animation_template='app/main/animations/empty-file-access.html'
                                vm.helpUrl='https://docs.templ.site/websites/file-access'
                            }
                        ],
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    /*List: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{populate:'operation'})
                    }],*/
                    List: ['$stateParams','wtUtils',model.model,'WooModelListResolver',function(params,utils,app,resolver) {
                        var f = utils.getCached('app.accesskey.list')||filters
                        return resolver(app,params,{
                            populate:'operation'
                            ,filters:f
                        })
                    }],
                    CountUnfiltered: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{
                            __count_only__:true
                        })
                    }]
                },
                data : {
                    //Title: model.Name+'s'
                    substates: {edit:state_pre+model.name+'.details',create:state_pre+model.name+'.create'}
                    ,form_type: 'user'
                    ,populate: 'operation'
                    ,model:model
                    ,filters:filters
                }

            })
            .state(state_pre+model.name+'.create', {
                url     : '/create/',
                views   : {
                    'content@app' : {
                        templateUrl:  'app/main/layouts/wt-wrapper.html',
                        controller : 'KeyCreateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    Form: [
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'user',paginate_values:20})
                        }
                    ]
                },
                data: sub_data
            })
            .state(state_pre+model.name+'.edit', {
                url     : '/edit/:id',
                views   : {
                    'content@app' : {
                        templateUrl:  'app/main/layouts/wt-wrapper.html',
                        controller : 'KeyEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    Object:[
                        '$stateParams',model.model,'WooModelResolver',function(params,m,resolver) {
                                return resolver(m,params,{populate:['operation']})
                        }
                    ],
                    Form: [
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'user',paginate_values:20})
                        }
                    ]
                },
                data: sub_data
            })
            .state(state_pre+model.name+'.details', {
                url     : '/details/:id',
                views   : {
                    'content@app' : {
                        templateUrl:  'app/main/layouts/wt-wrapper.html',
                        controller : 'KeyDetailsController',
                        controllerAs:'vm'
                    }
                },
                resolve: {
                    Object:[
                        '$stateParams',model.model,'WooModelResolver',function(params,m,resolver) {
                                return resolver(m,params,{populate:['operation']})
                        }
                    ],
                    Form:[
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'details'})
                        }
                    ]
                },
                data: sub_data
            })


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/fileaccess');

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.fileaccess')
        .controller('KeyController', KeyController)
        .controller('KeyCreateController', KeyCreateController)
        .controller('KeyEditController', KeyEditController)
        .controller('KeyDetailsController',KeyDetailsController)

    function KeyCreateController($scope, $state, AppLoader, wtUtils, WooModelEditController, Form, WooAccessKey) {
        var vm=this;
        wtUtils.addFormLabels('ACCESSKEY',Form)
        Form.type=Form.type||{}
        //Form.type.key='file'
        Form.file_button={key:'Load From File'}
        Form.type.apps='ui-select-multiple'
        Form.refresh={apps:function (search,scrolling) {
            AppLoader(Form.values.apps,search,scrolling)
        }}
        // Emaneul note to self: vm.obj.add_to_all
        vm.Form=Form
        vm.scope=$scope
        vm.api=WooAccessKey
        vm.state=$state
        vm.layout='app/main/layouts/wt-edit.html'
        vm.title="ACCESSKEY.CREATE_TITLE"

        WooModelEditController(vm,$state.current.data)

        vm.continue=vm.save
    }

    function KeyEditController($scope, $state, AppLoader, wtUtils, WooModelEditController, Object, Form, WooAccessKey) {
        var vm=this;
        wtUtils.addFormLabels('ACCESSKEY',Form)
        Form.type.apps='ui-select-multiple'
        Form.refresh={apps:function (search,scrolling) {
            AppLoader(Form.values.apps,search,scrolling)
        }}
        vm.Form=Form
        vm.Object=Object
        vm.scope=$scope
        vm.api=WooAccessKey
        vm.state=$state
        vm.layout='app/main/layouts/wt-edit.html'
        vm.title="ACCESSKEY.EDIT_TITLE"
        vm.breadcrumbs=[
            {label:"BREADCRUMBS.FILE_ACCESS", url:"/accesskey/list/"},
            {label:Object.name, url: '/accesskey/details/'+vm.Object._id},
            {label:"BREADCRUMBS.EDIT"}
        ]
        WooModelEditController(vm,$state.current.data)
        vm.continue=vm.save
    }

    function KeyDetailsController($scope, $state, wtUtils, WooModelEditController, Object, Form, WooAccessKey) {
        var vm=this;
        wtUtils.addFormLabels('ACCESSKEY',Form)
        vm.content='app/main/layouts/wt-details-content.html'
        vm.details_template='app/main/fileaccess/accesskey-details.html'
        vm.Object=Object
        vm.id=Object._id
        vm.Form=Form
        vm.scope=$scope
        vm.state=$state
        vm.api=WooAccessKey
        vm.title="ACCESSKEY.DETAILS_TITLE"
        vm.breadcrumbs=[
            {label:"BREADCRUMBS.FILE_ACCESS", url:"/accesskey/list/"},
            {label:Object.name}
        ]
        WooModelEditController(vm,$state.current.data)
        wtUtils.detailsController(vm,$state)
    }

    /** @ngInject */
    function KeyController($scope, WooAccessKey, WooAccessKeyModel, WooModelListCtrl)
    {
        var vm = this;
        vm.Title="ACCESSKEY.LIST_TITLE"
        vm.scope=$scope
        vm.model=WooAccessKeyModel

        WooModelListCtrl(vm, WooAccessKey, {create:'app.fileaccess_keys.create',edit:'app.fileaccess_keys.edit'})
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dnszone', ['app.wooadmin'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,
        Models)
    {
        var model = Models['WooDnsZone']
        var sub_data={
            //populate:['domain','operation']
        }
        var filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            }
        ]
        // State
        $stateProvider
            .state('app.'+model.name, {
                url    : '/'+model.name,
                redirectTo: 'app.'+model.name+'.list'
            })
            .state('app.'+model.name+'.list', {
                url    : '/list/:page',
                params : {page: null},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/wooadmin/models/modellist.html',
                        controller : 'DnszoneListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    List: ['$stateParams','wtUtils',model.model,'WooModelListResolver',function(params,utils,app,resolver) {
                        return resolver(app,params,{
                            populate:['operation'],
                            filters:filters
                        })
                    }],
                    CountUnfiltered: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{
                            __count_only__:true
                        })
                    }]
                },
                data : {
                    substates: {edit:'app.'+model.name+'.details'},
                    form_type: 'user'
                    ,model:model
                    ,populate:['operation']
                    ,filters:filters
                }

            })
            .state('app.'+model.name+'.details', {
                url     : '/details/:id/:page',
                params  : {id:null,page:'1'},
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/dnszone/details.html',
                        controller : 'DnszoneDetailsController',
                        controllerAs:'vm'
                    },
                    'dns_record_list@app.dnszone.details': {
                        templateUrl: 'app/main/wooadmin/models/modellist.html',
                        //templateUrl: 'app/main/dnszone/records.html',
                        controller : 'DnsRecordsController as vm'
                    }
                },
                resolve: {
                    Obj:[
                        '$stateParams','WooDnsZone','WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation']})
                        }
                    ],
                    List: ['$stateParams','wtUtils','DnsRecord','WooModelListResolver',function(params,utils,app,resolver) {
                        return resolver(app,{
                            page:params.page,
                            query:{zone:params&&params.id}
                        },{
                            filters:filters
                        })
                    }],
                    CountUnfiltered: ['$stateParams','DnsRecord','WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,{
                            query:{zone:params.id}
                        },{
                            zone:params.id,
                            __count_only__:true
                        })
                    }]
                },
                data: {
                    substates: {},
                    form_type: 'user'
                    ,model:'DnsRecord'
                    ,filters:filters
                }
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dnszone');

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dnszone')
        .controller('DnszoneListController', list)
        .controller('DnszoneDetailsController', details)
        .controller('DnsRecordsController',record_list)
        .controller('DnsRecordEdit',record_edit)
        .controller('VerificationRecordModalController', verificationRecordModal)

        function list($scope, $rootScope, $state, WooDnsZone, WooModelListController, CountUnfiltered, $filter, List)
        {
            var vm = this;
            vm.scope=$scope
            vm.rootScope=$rootScope
            vm.nof_objects_unfiltered=CountUnfiltered && CountUnfiltered.count||0
            vm.api=WooDnsZone; vm.res=List;
            vm.empty_title='DNSZONE.EMPTY_TITLE'
            vm.empty_text='DNSZONE.EMPTY_TEXT'
            vm.prefix='DNSZONE.'
            WooModelListController(vm, $state.current.data)
            //vm.create_button="DOMAINS.CREATE_BUTTON"
            vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
            vm.list.filters=$state.current.data.filters
            vm.Title='DNSZONE.DNSZONE_TITLE'
        }

        function details(WooModelEditController,$scope, $state, wtUtils, Obj, WooDnsZone) {
            var vm=this
            vm.scope=$scope
            vm.Object=Obj
            vm.Form={}
            vm.no_edit=true
            vm.no_delete=true
            //wtUtils.addFormLabels('DOMAINS',Form)

            //vm.zone=Obj.zone
            //vm.app=Obj.app
            vm.content='app/main/layouts/wt-details-content.html'
            //vm.layout='app/main/layouts/wt-details.html'
            vm.details_template='app/main/dnszone/details.html'
            vm.api=WooDnsZone
            vm.title="DNSZONE.DETAILS_TITLE"
            WooModelEditController(vm,{} )
        }


        function recordEdit(vm,record) {
            //window.alert("wtutils: Confirm Dialog not implemented")
            var edit=vm.modal.open({
                backdrop: true,
                backdropClass: 'show',
                windowClass: 'd-flex justify-content-center align-items-center dns-editor',
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/main/dnszone/record-edit.html',
                //templateUrl: 'app/main/layouts/wt-edit.html',
                controller: 'DnsRecordEdit',
                controllerAs: 'vm',
                //size: size,
                //appendTo: parentElem,
                resolve: {
                    Record: function () {
                        return record;
                    },
                    Parent: function () {
                        return vm;
                    },
                    Form: [
                        'DnsRecord','WooFormResolver',function(m,resolver) {
                            return resolver(m,{},{form_type:'user'})
                        }
                    ]
                }
            })
            return edit.result
            //if (!next) return confirm.result;
        }

        function record_list($scope, $rootScope, $state, DnsRecord, wtUtils,Obj,
            WooModelListController, CountUnfiltered, $uibModal, $filter, List)
        {
            var vm = this;
            vm.zone=Obj
            vm.modal=$uibModal
            vm.scope=$scope
            vm.rootScope=$rootScope
            vm.nof_objects_unfiltered=CountUnfiltered && CountUnfiltered.count||0
            List.docs=_.map(List.docs, function(d) { return new DnsRecord(d)} )
            vm.api=DnsRecord; vm.res=List;
            vm.empty_title='DNSRECORD.EMPTY_TITLE'
            vm.empty_text='DNSRECORD.EMPTY_TEXT'
            vm.prefix='DNSRECORD.'
            WooModelListController(vm, $state.current.data)
            vm.list.headers=[
                {name:vm.translate('DNSRECORD.LIST.NAME'),class:'name'},
                {name:vm.translate('DNSRECORD.LIST.TYPE'),class:'type'},
                {name:vm.translate('DNSRECORD.LIST.TTL'),class:'ttl'},
                {name:vm.translate('DNSRECORD.LIST.VALUE'),class:'value'}
            ]
            vm.list.item_template='app/main/dnszone/record_list_item.html'
            //vm.create_button="DOMAINS.CREATE_BUTTON"
            vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
            vm.list.filters=$state.current.data.filters
            vm.Title='DNSRECORD.DNSRECORD_TITLE'
            vm.TranslateValues={domain:vm.zone.domain}
            vm.extra_buttons=[
                {
                    name:'DNSRECORD.VERIFICATION_RECORD.ADD_BTN',
                    fun:function() {
                        vm.openAddVerificationRecord()
                    },
                    class:'wt-secondbtn',
                    disabled:vm.sharing && !vm.sharing.share_all,
                    skip_on_empty:1,
                    adminOnly:1,
                },
            ]
            vm.openEditView=function(event,item) {
                item.id=1
                recordEdit(vm,item)
            }
            vm.openCreateView=function(event) {
                var rec=new DnsRecord({kind:'A',ttl:300})
                rec.zone=vm.zone._id
                recordEdit(vm,rec).then(function(res) {
                    console.log('Create OK',res);
                    vm.items.push(rec)
                },function(res) {
                    console.log('Create Cancel',res);
                })
            }
            vm.openAddVerificationRecord=function(event) {
                var modalInstance = $uibModal.open({
                    backdrop: true,
                    backdropClass: 'show',
                    windowClass: 'd-flex justify-content-center align-items-center dns-editor',
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'app/main/dnszone/verification-record-modal.html',
                    controller: 'VerificationRecordModalController',
                    controllerAs: 'vm',
                    resolve: {
                        zone: function() {
                            return vm.zone;
                        }
                    }
                });
                modalInstance.result.then(function(verificationValue) {
                    if (verificationValue) {
                        vm.addVerificationRecord(verificationValue);
                    }
                });
            }
            vm.addVerificationRecord = function(verificationValue) {
                // console.log('vm.items', vm.items);
                vm.isSaving=true
                var existingRecord = vm.items.find(function(record) {
                    return record.name === vm.zone.domain + '.' && record.kind === 'TXT';
                });

                console.log('existingRecord', existingRecord);

                var obj = existingRecord || new DnsRecord({
                    name: vm.zone.domain + '.',
                    kind: 'TXT',
                    zone: vm.zone._id,
                    user: vm.user ? vm.user._id : undefined,
                    data: []
                });

                var txtValue = verificationValue
                // Wrap the value in quotes if it's not already
                if (!txtValue.startsWith('"')) {
                    txtValue = '"' + txtValue + '"';
                }

                obj.data.push(txtValue);

                var saveParams = {
                    kind: 'TXT',
                    name: vm.zone.domain + '.',
                    zone: vm.zone._id,
                    user: vm.user ? vm.user._id : undefined
                };

                if (existingRecord) {
                    // saveParams.obj_id = existingRecord.id; // Use the existing record's ID
                    saveParams.obj_id = 1
                }

                obj.$save(saveParams, function(success) {
                    // console.log('Record ' + (existingRecord ? 'updated' : 'created') + ' successfully', success);
                    if (!existingRecord) {
                        vm.items.push(obj); // Add the new record to the list
                    }
                }, function(error) {
                    console.error('Error ' + (existingRecord ? 'updating' : 'creating') + ' record', error);
                });
                vm.isSaving=false
            };  
            vm.deleteItem = function (event,item) {
                if (item.zone) {
                    var args={obj_id:1,name:item.name,zone:item.zone,kind:item.kind}
                    if(vm.user) args.user=vm.user
                    var title="WOOADMIN.CONFIRM_DELETE_TITLE"
                    var msg="WOOADMIN.CONFIRM_DELETE_MSG"
                    if(vm.delete_title) {
                        msg=vm.delete_title
                    }
                    if(vm.delete_msg) {
                        msg=vm.delete_msg
                    }
                    vm.confirm(title,msg).then(function() {
                        vm.api.delete(( args ), function (res) {
                            debugger
                            vm.objects=_.filter(vm.objects,function(i) {
                                return !(i.name==item.name&&i.kind==item.kind)
                            })
                        });
                    })
                }
            }

            vm.reload = function (resolver) {
                vm.rootScope.loadingProgress=true
                resolver(vm.api,{
                    page:vm.state.params.page,query:{zone:vm.zone._id}
                },{
                    populate:vm.populate,
                    filters:vm.filters,
                    selected_user:vm.selected_user
                }).then(function(res) {
                    vm.rootScope.loadingProgress=false
                    res.docs=_.map(res.docs, function(d) { return new DnsRecord(d)} )
                    vm.res=res
                    vm.init_list()
                })
            }
        }
        function record_edit($uibModalInstance,$scope,Record,Form,Parent,wtUtils) {
            var vm=this
            vm.diag=$uibModalInstance
            vm.form=Form
            vm.obj=Record
            vm.obj.dataTxt=vm.obj && vm.obj.data && vm.obj.data.join('\n')
            vm.form.type['dataTxt']='text'
            vm.form.fields=['name','kind','ttl','dataTxt']
            Form.disabled = Form.disabled||{}
            vm.user=Parent.user
            vm.zone=Parent.zone
            vm.disable_all=function () {
                angular.forEach(Form.fields,function(f) {
                    Form.disabled[f]=true
                })
            }
            if(Record.name) {
                Form.type.kind='string'; Form.disabled.kind=true
                Form.disabled.name=true
                //if(Form.values.kind.indexOf(Record.kind)<0) vm.disable_all()
                if(Record.kind === 'SOA') {
                    vm.no_delete=true
                    vm.disable_all()
                } else if(Record.kind === 'NS') {
                    var apexName = vm.zone.domain + '.'
                    var isApex = Record.name === apexName || Record.name === vm.zone.domain
                    if(isApex) {
                        vm.no_delete=true
                        vm.disable_all()
                    }
                }
            } else {
                Form.fields=['subdomain','kind','ttl','dataTxt']
                Form.values.kind=Form.values.kind.filter(function(k) {return k!=='SOA'})
                Form.note={subdomain:"DNSRECORD.SUBDOMAIN_NOTE"}
                vm.no_delete=true
                Form.translate_values={subdomain:{domain:'.'+vm.zone.domain+'.'}}
                Form.optional={subdomain:true}
            }
            Form.description={dataTxt:"DNSRECORD.VALUE_NOTE"}
            wtUtils.addFormLabels('DNSRECORD',Form,['description','note'])

            vm.cancel=function() {
                vm.diag.dismiss()
            }
            vm.continue=function() {
                vm.isSaving=true
                var obj=vm.obj

                // Handle @ as subdomain (handles users entering @ as subdomain, and treat their entry as a blank subdomain)
                if(obj.subdomain == '@') {
                    delete obj.subdomain
                }

                if(!obj.name) {
                    obj.name=vm.zone.domain+'.'
                    if(obj.subdomain) obj.name=obj.subdomain+'.'+obj.name
                }
                var args={ name: obj.name, kind:obj.kind, zone:obj.zone}
                if (obj.id) args.obj_id=obj.id
                if(vm.user)args.user=vm.user

                // Add a dot to end of CNAME and NS values (FQDNs require trailing dot)
                if( obj.kind === 'CNAME' || obj.kind === 'NS' ) {
                    if( ! obj.dataTxt.match(/.*\.$/)  ) {
                        obj.dataTxt = obj.dataTxt+'.'
                    }
                }

                
                obj.data=obj.dataTxt.split('\n')

                // If TXT, wrap each entry in quotes if not already
                // if (obj.kind == 'TXT') {
                //     obj.data = obj.data.map(value => {
                //         return value.startsWith('"') && value.endsWith('"') ? value : '"' + value + '"'
                //     });
                // }
                
                obj.$save(args,function() {
                    vm.isSaving=false
                    vm.diag.close()
                },function(res) {
                    vm.isSaving=false
                    //alert(res);
                })
            }
            // Do stuff when DNS record type is changed
            // $scope.$watch('vm.obj.kind',function(oldval,newval) {
            //     console.log(oldval+newval)
            // })
            vm.delete=function(event) {
                Parent.deleteItem(event,Record)
                vm.diag.dismiss()
            }
        }
        function verificationRecordModal($uibModalInstance, zone) {
            var vm = this;
            vm.zone = zone;
            vm.verificationValue = '';
        
            vm.ok = function() {
                $uibModalInstance.close(vm.verificationValue);
            };
        
            vm.cancel = function() {
                $uibModalInstance.dismiss('cancel');
            };
        }
})();

(function ()
{
    'use strict';

    angular
        .module('app.email', ['app.wooadmin'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,
        Models)
    {
        var model = Models['WooEmailAddress']
        var sub_data={
            populate:['domain','operation']
        }
        var filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            }
        ]
        // State
        $stateProvider
            .state('app.'+model.name, {
                url    : '/'+model.name,
                redirectTo: 'app.'+model.name+'.list'
            })
            .state('app.'+model.name+'.list', {
                url    : '/list/:page',
                params : {page: null},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/wooadmin/models/modellist.html',
                        controller : 'EmailListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    /*List: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{populate:['operation','domain']})
                    }]*/
                    List: ['$stateParams','wtUtils',model.model,'WooModelListResolver',function(params,utils,app,resolver) {
                        var f = utils.getCached('app.email.list')||filters
                        return resolver(app,params,{
                            populate:['operation','domain']
                            ,filters:f
                        })
                    }],
                    CountUnfiltered: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{
                            __count_only__:true
                        })
                    }]
                },
                data : {
                    //Title: model.Name+'s'
                    substates: {create:'app.'+model.name+'.edit',edit:'app.'+model.name+'.details'}
                    ,form_type: 'user'
                    ,populate: ['operation','domain']
                    ,model:model
                    ,filters:filters
                }

            })
            .state('app.'+model.name+'.edit', {
                url     : '/edit/:id',
                params  : {id:null},
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'EmailEditController',
                        controllerAs:'vm'
                    }
                },
                resolve: {
                    Object:[
                        '$stateParams',model.model,'WooModelResolver',function(params,m,resolver) {
                                return resolver(m,params,{populate:['operation','domain']})
                        }
                    ],
                    Form:[
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'user',paginate_values:20})
                        }
                    ]
                },
                data: sub_data
            })
            .state('app.'+model.name+'.details', {
                url     : '/details/:id',
                params  : {id:null},
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'EmailDetailsController',
                        controllerAs:'vm'
                    }
                },
                resolve: {
                    Object:[
                        '$stateParams',model.model,'WooModelResolver',function(params,m,resolver) {
                                return resolver(m,params,{populate:['operation','domain']})
                        }
                    ],
                    Form:[
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'details'})
                        }
                    ]
                },
                data: sub_data
            })

        var afilters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            }
        ]

        $stateProvider
            .state('app.smtp', {
                url    : '/smtp/:page',
                params : {page: null},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'SmtpController',
                        controllerAs: 'vm'
                    },
                    'account_list@app.smtp': {
                        templateUrl: 'app/main/wooadmin/models/modellist.html',
                        //templateUrl: 'app/main/dnszone/records.html',
                        controller : 'AccountListController as vm'
                    }
                },
                resolve: {
                    List: ['$stateParams','wtUtils','WooEmailAccount','WooModelListResolver',function(params,utils,app,resolver) {
                        var f = utils.getCached('app.smtp')||afilters
                        return resolver(app,params,{
                            populate:['operation']
                            ,filters:f
                        })
                    }],

                    SmtpAccount:[
                        'List',function(accounts) {
                            accounts=accounts && accounts.docs||accounts
                            if(accounts) {
                                var a = accounts.find(function(a) {
                                    return a.is_default
                                })
                                if(!a) {
                                    a=accounts.find(function(a) {
                                        return a.name.endsWith(' default')
                                    })
                                }
                                return a
                            }
                        }
                    ],
                    CountUnfiltered: ['$stateParams','WooEmailAccount','WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{
                            __count_only__:true
                        })
                    }]
                },
                data : {
                    substates:{}
                    ,form_type: 'user'
                    ,populate: ['operation']
                    ,model:'WooEmailAccount'
                    //,filters:afilters
                }
            })
        var vfilters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            }
        ]
        $stateProvider
            .state('app.email-verifications', {
                url    : '/email-verifications/:page',
                params : {page: null},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        //templateUrl: 'app/main/wooadmin/models/modellist.html',
                        controller : 'VerificationsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    /*
                    List: ['$stateParams',function(params) {
                        var list = [{
                            name:'verification1', kind:'email', domain:'domain.com',
                            records:[
                                {kind:'cname',subdomain:'sendgrid',data:['a.b.c.']},
                                {kind:'cname',subdomain:'s1._domainkey',data:'a.b.c.'}
                            ]
                        },{
                            name:'verification2', kind:'email', domain:'domain2.com',
                            records:[
                                {kind:'cname',subdomain:'sendgrid',data:'a.b.c.'},
                                {kind:'cname',subdomain:'s1._domainkey',data:'a.b.c.'}
                            ]
                        }]
                        return {docs:list}
                    }]*/

                    List: ['$stateParams','wtUtils','DnsVerification','WooModelListResolver',function(params,utils,app,resolver) {
                        var f = utils.getCached('app.email.verifications')||vfilters

                        return resolver(app,{
                            page:params.page,query:{kind:'email'}
                        },{
                            populate:['operation']
                            ,filters:f
                        })
                    }]
                    ,CountUnfiltered: ['$stateParams',function(params,app,resolver) {
                    //,CountUnfiltered: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return 10
                    }]
                },
                data : {
                    //Title: model.Name+'s'
                    substates: {}
                    ,form_type: 'user'
                    ,populate: ['operation']
                    ,model:'EmailVerifications'
                    ,filters:vfilters
                }

            })

            $stateProvider
                .state('app.dns-verifications', {
                    url    : '/dns-verification/:id',
                    params : {id: null},
                    views  : {
                        'content@app': {
                            templateUrl: 'app/main/layouts/wt-wrapper.html',
                            //templateUrl: 'app/main/wooadmin/models/modellist.html',
                            controller : 'VerificationController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        Object:[
                            '$stateParams','DnsVerification','WooModelResolver',function(params,m,resolver) {
                                    return resolver(m,params,{populate:['operation']})
                            }
                        ]
                    },
                })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/email');

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.email')
        .controller('VerificationsController',verifications)
        .controller('VerificationController',verification_controller)




        function verifications(
            WooModelListController, WooModelEditController, $scope,  $rootScope, $location,
            DnsVerification, $state,  List, CountUnfiltered, wtUtils
        ) {
            var vm = this;
            vm.layout='app/main/email/verifications.html'
            vm.id_attr='email-verifications'
            vm.no_create=true
            vm.scope=$scope
            vm.rootScope=$rootScope
            vm.nof_objects_unfiltered=CountUnfiltered && CountUnfiltered.count||0
            vm.api=DnsVerification; vm.res=List;
            vm.empty_title='EMAIL.VERIFICATIONS.EMPTY_TITLE'
            vm.empty_text='EMAIL.VERIFICATIONS.EMPTY_TEXT'
            vm.prefix='EMAIL.VERIFICATIONS'
            vm.loaded_callback=function() {
                for(var i in vm.items) {
                    vm.items[i]=new DnsVerification(vm.items[i])
                }
                vm.class_attr=vm.items.length == 0 ? 'is-empty' : '';
            }
            WooModelListController(vm,$state.current.data)
            vm.list.headers=[
                {name:vm.translate('EMAIL.VERIFICATIONS.DOMAIN'),class:'domain'},
                //{name:vm.translate('EMAIL.VERIFICATION.TYPE'),class:'type'},
                {name:vm.translate('EMAIL.VERIFICATIONS.STATUS'),class:'status'}
            ]
            // vm.list.head_template='app/main/layouts/empty.html'

            vm.list.item_template='app/main/email/verification_list_item.html'

            vm.Title=vm.translate('EMAIL.VERIFICATIONS_NAV')
            vm.helpUrl='https://docs.templ.site/email/email-deliverability-domain-verification'

            vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
            vm.list.filters=$state.current.data.filters
            vm.openEditView=function(e,obj) {
                vm.select_object(obj)
            }
            vm.select_object=function(obj) {
                $location.hash(obj && obj._id||"")
            }
            vm.object_selected=function(obj) {
                if(!obj) {
                    vm.obj=null;vm.object_controller=null;
                    vm.operation=null; return
                }
                vm.obj=obj;
            }
            vm.scope.$watch(function() {
                return $location.hash()
            }, function () {
                console.log('hash changed',$location.hash());
                var hash=$location.hash()
                var obj
                if(hash) {
                    obj=vm.items.find(function(i) { return i._id == hash})
                }
                vm.object_selected(obj)
            })

            vm.update_items=function(obj) {
                for (var i in vm.items) {
                    if (vm.items[i]._id == obj._id) {
                        vm.items[i]=obj; break
                    }
                }
            }

            vm.check = function() {
                vm.status='working'
                if(vm.obj && !vm.object_controller) {
                    vm.object_controller={}
                    verification_controller.call(vm.object_controller,vm.obj,WooModelEditController,DnsVerification,$scope)
                }
                var controller=vm.object_controller
                if(!controller) {
                    vm.status='ok'
                    return
                }
                vm.show_op=controller.show_op
                vm.show_msg=controller.show_msg
                controller.obj.check=true
                controller.object_callback=function(res) {
                    vm.obj=controller.obj
                    vm.update_items(vm.obj)
                    var op=res&&res.operation
                    if(op && op.msgs.length==0) {
                        op.msgs[0]=vm.obj.name.toUpperCase()+'_VERIFICATION.CHECKING'
                    }
                    vm.operation=op
                    vm.status=controller.status
                    vm.msg_level=wtUtils.MSG_LEVEL_INFO
                }
                controller.status=null
                vm.object_controller.save(function(res) {
                    controller.init_object(res)
                    console.log('Object saved');
                })
            }
            vm.object_status=function (obj) {
                if(vm.object_controller && vm.operation) {
                    return vm.object_controller.object_status(obj)
                }
                if(obj.verified) return "ok"
                return "waiting"
            }
        }

        function verification_controller(Object,WooModelEditController,DnsVerification,$scope) {
            var vm=this
            vm.layout='app/main/email/verifications.html'
            if(Object) {
                vm.Object=Object
                vm.id=Object._id
            }
            vm.scope=$scope
            vm.api=DnsVerification
            WooModelEditController(vm,{})
            vm.check = function() {
                vm.status='working'
                vm.obj.check=true
                vm.save(function(res) {
                    vm.init_object(res)
                    //console.log('Object saved');
                })
            }
            vm.object_callback=function(res) {
                var op=res&&res.operation
                if(op && op.msgs.length==0) {
                    op.msgs[0]=vm.obj.name.toUpperCase()+'_VERIFICATION.CHECKING'
                }
                vm.operation=op
            }
            vm.old_object_status=vm.object_status
            vm.object_status=function (obj) {
                if(vm.operation) {
                    return vm.old_object_status(obj)
                }
                if(obj.verified) return "ok"
                return "waiting"
            }
        }
})();

(function ()
{
    'use strict';

    angular
        .module('app.email')
        .controller('EmailListController',  [
            'WooModelListController','$scope', '$scope', '$state',  'List', 'WooEmailAddress','CountUnfiltered',
            ListController])
        .controller('EmailEditController', EditController)
        .controller('EmailDetailsController', DetailsController)
        .controller('SmtpController',smtp)
        .controller('SmtpEdit',smtpEdit)
        .controller('AccountListController',[
            'WooModelListController','$scope', '$scope', '$state',  'List', 'WooEmailAccount','CountUnfiltered',
            smtp_list])

    /** @ngInject */
    function ListController(ctrl,scope,rootScope,state,res,m,count) {
        var vm = this;
        vm.scope=scope
        vm.rootScope=rootScope
        vm.nof_objects_unfiltered=count && count.count||0
        vm.api=m; vm.res=res;
        vm.empty_title='EMAIL.EMPTY_TITLE'
        vm.empty_text='EMAIL.EMPTY_TEXT'
        vm.prefix='EMAIL.'
        ctrl(vm,state.current.data)
        vm.empty_animation_template='app/main/animations/empty-emails.html'

        vm.Title=vm.translate('EMAIL.LIST_TITLE')
        vm.helpUrl='https://docs.templ.site/email/email-on-templ'

        vm.list.headers=[
            {name:vm.translate('EMAIL.LIST.NAME'),class:'name'},
            {name:vm.translate('EMAIL.LIST.FORWARDS'),class:'forwards'},
        ]
        vm.list.tableClass='email-list'
        vm.list.item_template='app/main/email/list_item.html'
        vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
        vm.list.filters=state.current.data.filters

    }

    function EditController($scope, $state, DomainLoader, wtUtils, WooModelEditController, Object, Form, WooEmailAddress, $translate) {
        var vm=this;
        vm.Object=Object
        wtUtils.addFormLabels('EMAIL',Form)
        vm.scope=$scope
        vm.Form=Form

        // TESTING:
        var loader=DomainLoader
        var docs = Form.values && Form.values.domain
        if(!docs.page) docs={docs:docs,search:''}
        else {
            docs.search='';
        }
        docs.res=function(res) {
            var l=[]
            angular.forEach(res,function(d) {
                l.push({name:d.name,value:d._id})
            })
            return l
        }
        Form.values.domain=docs
        Form.refresh={domain:function refresh_domains(search,scrolling) {
            loader(docs,search,scrolling)
        }}
        Form.type.domain='ui-select'

        vm.Form.optional=vm.Form.optional||{}
        vm.Form.optional.name=1
        vm.layout='app/main/layouts/wt-edit.html'
        if($state.params.id) {
            vm.title="EMAIL.EDIT_TITLE"
            console.log('url', $state.href('app.email.details', {id: vm.Object._id}))
            vm.breadcrumbs=[
                {label:"BREADCRUMBS.EMAIL", url:"/emailaddress/list/"},
                {label:vm.Object.name+'@'+vm.Object.domain.name, url: '/emailaddress/details/'+vm.Object._id},
                {label:"BREADCRUMBS.EDIT"}
            ]
        } else {
            vm.title="EMAIL.CREATE_TITLE"
            vm.breadcrumbs=[
                {label:"BREADCRUMBS.EMAIL", url:"/emailaddress/list/"},
                {label:"BREADCRUMBS.CREATE"}
            ]
            // ...
            vm.Form.info = {
                "title": {
                    "name": "EMAIL.CATCH_ALL_INFO.TITLE"
                },
                "content": {
                    "name": "EMAIL.CATCH_ALL_INFO.CONTENT"
                },
            }
            vm.Form.note.domain = $translate.instant('EMAIL.NOTES.DOMAIN', {link: '/domain/list/'})
        }
        //vm.Form.subforms['forwards'].no_labels=true
        vm.scope=$scope
        vm.api=WooEmailAddress
        WooModelEditController(vm,{next_state:{save:wtUtils.siblingState($state,'.details')}})
        vm.continue=function() {
            if(!vm.obj.name) vm.obj.name=''
            vm.save()
        }
    }

    function DetailsController($scope, $state, wtUtils, WooModelEditController, Object, Form, WooEmailAddress) {
        var vm=this;
        vm.content='app/main/layouts/wt-details-content.html'
        vm.details_template='app/main/email/email-details.html'
        vm.Object=Object
        wtUtils.addFormLabels('EMAIL',Form)
        vm.Form=Form
        vm.title="EMAIL.DETAILS_TITLE"
        console.log(vm.Object)
        vm.breadcrumbs=[
            {label:"BREADCRUMBS.EMAIL", url:"/emailaddress/list/"},
            {label:vm.Object.name+'@'+vm.Object.domain.name}
        ]
        vm.scope=$scope
        vm.api=WooEmailAddress
        WooModelEditController(vm,$state.current.data)
        wtUtils.detailsController(vm,$state)
    }

    function smtp(SmtpAccount,AuthService,wtUtils,$uibModal) {
        var vm=this
        vm.modal=$uibModal
        vm.no_buttons=true
        vm.title='EMAIL.SMTP_NAV'
        vm.form={
            fields:['server','ports','username','password']
            ,disabled:{'password':1}
        }
        wtUtils.addFormLabels('EMAIL.SMTP',vm.form)
        vm.form.description=null
        vm.form.note=null
        vm.layout='app/main/layouts/wt-details.html'
        vm.details_template='app/main/email/smtp.html'
        vm.helpUrl='https://docs.templ.site/platform/templ-smtp'
        if(!SmtpAccount._id && SmtpAccount.docs) {
            SmtpAccount=_.find(SmtpAccount.docs, function (a) {
                return a.name.endsWith(' default')
            })
        }
        vm.isAdmin=AuthService.isAdmin()
        vm.id=SmtpAccount._id
        vm.status='ok'
        vm.acct=SmtpAccount
        vm.openEditView=function(e,obj) {
            smtp_edit(vm, vm.acct)
        }
    }
    function smtp_list(ctrl,scope,rootScope,state,res,m,count) {
        var vm = this;
        vm.scope=scope
        vm.parent=scope.vm
        vm.modal=vm.parent.modal
        vm.rootScope=rootScope
        vm.nof_objects_unfiltered=count && count.count||0
        vm.api=m; vm.res=res;
        vm.init_list=function(vm) {
            if(vm.res && vm.res.docs)
                vm.res.docs=_.map(vm.res.docs, function(d) { return new m(d)} )
        }
        vm.init_list(vm)
        vm.empty_title='SMTP.EMPTY_TITLE'
        vm.empty_text='SMTPL.EMPTY_TEXT'
        vm.prefix='SMTP.'
        ctrl(vm,state.current.data)

        vm.Title=vm.translate('SMTP.LIST_TITLE')
        vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
        vm.list.filters=state.current.data.filters
        vm.openEditView=function(e,obj) {
            vm.parent.acct=obj
        }
        vm.openCreateView=function(e) {
            //state.go('app.wooadmin.emailaccount-edit')
            smtp_edit(vm, new m())
        }
    }
    function smtp_edit(vm,account) {
        //window.alert("wtutils: Confirm Dialog not implemented")
        var edit=vm.modal.open({
            backdrop: true,
            backdropClass: 'show',
            windowClass: 'd-flex justify-content-center align-items-center',
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'app/main/email/account-edit.html',
            //templateUrl: 'app/main/layouts/wt-edit.html',
            controller: 'SmtpEdit',
            controllerAs: 'vm',
            //size: size,
            //appendTo: parentElem,
            resolve: {
                Object: function () {
                    return account;
                },
                Parent: function () {
                    return vm;
                },
                Form: [
                    'WooEmailAccount','WooFormResolver',function(m,resolver) {
                        return resolver(m,{},{form_type:'user'})
                    }
                ]
            }
        })
        return edit.result
        //if (!next) return confirm.result;
    }

    function smtpEdit($uibModalInstance,Object,Form,Parent) {
        var vm=this
        vm.diag=$uibModalInstance
        vm.form=Form
        Form.fields=["server","username","password","is_default"]
        vm.obj=Object
        if(Object && Object.server && Object.ports && Object.ports.length>0) {
            Object.server=Object.server+':'+Object.ports[0]
        }

        vm.user=Parent.user
        vm.cancel=function() {
            vm.diag.dismiss()
        }
        vm.continue=function() {
            vm.isSaving=true
            var obj=vm.obj
            var server = obj.server
            var ports=server.split(':')
            obj.server=ports&&ports[0]
            ports.shift()
            obj.ports=ports
            var name=obj.name
            if(!name) name=server+' '+(obj.username||'')
            obj.name=name
            obj.external=true
            var args={}
            if (obj._id) args.obj_id=obj._id
            if(vm.user)args.user=vm.user
            obj.$save(args,function() {
                vm.isSaving=false
                vm.diag.close()
            },function(res) {
                vm.isSaving=false
                //alert(res);
            })
        }
        vm.delete=function(event) {
            Parent.deleteItem(event,Object)
            vm.diag.dismiss()
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.domains', [])
        .config(config);

    function config($stateProvider, $urlRouterProvider, $translatePartialLoaderProvider,
         msNavigationServiceProvider,Models)
    {
        var model = Models['WooDomain']
        var filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            }
        ]
        var sub_data={
            populate:['zone','operation','app']
        }
        // State
        var subs={
            list:{
                url    : '/list/:page',
                params : {page: null},
                view  : {
                    templateUrl: 'app/main/wooadmin/models/modellist.html',
                    controller : 'DomainsListControlller',
                    controllerAs: 'vm'
                },
                resolve: {
                    /*List: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{populate:'operation'})
                    }]*/
                    List: ['$stateParams','wtUtils',model.model,'WooModelListResolver',function(params,utils,app,resolver) {
                        var f = utils.getCached('app.domain.list')||filters
                        return resolver(app,params,{
                            populate:['zone','operation','app.name']
                            ,filters:f
                        })
                    }],
                    CountUnfiltered: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{
                            __count_only__:true
                        })
                    }]
                },
                data : {
                    //Title: model.Name+'s'
                    substates: {edit:'app.'+model.name+'.details',create:'app.'+model.name+'.create'}
                    ,form_type: 'user'
                    ,populate: ['operation','zone']
                    ,filters:filters
                }
            },
            create: {
                url     : '/create/',
                view   : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'DomainsCreateController',
                    controllerAs: 'vm'
                },
                resolve: {
                    Form: [
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'user',paginate_values:10})
                        }
                    ],
                    UserInfo: [
                        'UserInfo', function (info) {
                            return info();
                        }
                    ]
                },
                data: sub_data
            },
            processing: {
                url    : '/processing/:id',
                view  : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'DomainsProcessingController',
                    controllerAs: 'vm'
                },
                resolve: {
                    Obj:[
                        '$stateParams','WooDomain','WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation','zone','app']})
                        }
                    ]
                },
                data: sub_data
            },
            details: {
                url    : '/details/:id',
                view  : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'DomainsDetailsController',
                    controllerAs: 'vm'
                },
                resolve: {
                    Obj:[
                        '$stateParams','WooDomain','WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation','zone','app']})
                        }
                    ],
                    Form: [
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'details'})
                        }
                    ]
                },
                data: sub_data
            },
            edit: {
                url     : '/edit/:id',
                view   : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : 'DomainsEditController',
                    controllerAs:'vm'
                },
                resolve: {
                    Object:[
                        '$stateParams',model.model,'WooModelResolver',function(params,m,resolver) {
                                return resolver(m,params,{populate:['operation','zone','app']})
                        }
                    ],
                    Form:[
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'user',paginate_values:20})
                        }
                    ]
                },
                data: sub_data
            }
        }


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/domains');

        var top = 'app'//tops[top]
        var name= top +'.domain'
        var prefix=name+'.'

        $stateProvider
            .state(name, {
                url        :  '/domain',
                redirectAfter :  prefix+'list',
                redirectAlwaysEnter: true,
            })

        for (var sub in subs) {
            var subdef=subs[sub]
            var views={}
            views['content@'+top]=subdef.view
            $stateProvider
                .state(prefix+sub, {
                    url    : subdef.url,
                    views  : views,
                    resolve: subdef.resolve,
                    data   : subdef.data
                })
        }

        $stateProvider.state(prefix+'registration',{
            url:'/registrations/',
            //params:state.params,
            views:{
                'content@app':{
                    template:'<div id="registrations"></div>',
                    controller:['$scope','$rootScope','$state','$location','$translate','UserInfo',
                    function controller($scope,$rootScope,$state,$location,$translate, userInfo) {
                        console.log('Creating registrations',$location.url(),window.location.href);
                        var app
                        var destroyed
                        var mounted
                        function popStateHandler(evt) {
                            // Prevent vue-router to handle back-navigation out of the vue-app
                            //console.log('Pop state',evt.state);
                            var href=evt.currentTarget&&evt.currentTarget.location&&evt.currentTarget.location.href
                            if(evt.state==null && href&&!href.match("/domain/registrations/#")) {
                                if(app) domainsModule.destroy(app)
                                evt.preventDefault();
                            }
                        }
                        var mount=function () {
                            window.addEventListener('popstate', popStateHandler);
                            if(!domainsModule.onstart) {
                                domainsModule.onstart=$rootScope.$on('$locationChangeStart',function(evt, newUrl, oldUrl){
                                    console.log('locationChangeStart called',newUrl,oldUrl);
                                    if(newUrl.match("/domain/registrations/#") && !oldUrl.match("/domain/registrations/#")) {
                                        evt.preventDefault()
                                    }
                                    if (domainsModule.onstart) {
                                        domainsModule.onstart()
                                        domainsModule.onstart=undefined
                                    }
                                })
                            }
                            domainsModule.init('#registrations',{
                                lang:$translate.use() || 'en',
                                userInfo:userInfo,
                                rootScope:$rootScope,
                                state:$state,
                            }).then(function (res) {
                                app=res
                                if(destroyed) {
                                    console.log('Destroying registrations');
                                    domainsModule.destroy(app)
                                }
                            })
                        }
                        $scope.$on('$destroy',function() {
                            if(app) {
                                console.log('Destroying registrations');
                                domainsModule.destroy(app)
                            }
                            destroyed=true
                            window.removeEventListener('popstate', popStateHandler);
                        })
                        if($location.path()==window.location.pathname) {
                            mount()
                        } else {
                            var listener = $rootScope.$on("$locationChangeSuccess",function (evt) {
                                // Mount app only after location change is complete
                                console.log('LocationChangeSuccess',evt);
                                listener()
                                if (!mounted) {
                                    mounted=true
                                    mount()
                                }
                            })
                        }
                    }]
                }
            },
            resolve:{
                UserInfo: [
                    'UserInfo', function (info) {
                        return info();
                    }
                ]
            }
        })
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.domains')
        .controller('DomainsListControlller',list)
        .controller('DomainsCreateController',create)
        .controller('DomainsProcessingController',processing)
        .controller('DomainsDetailsController',details)
        .controller('DomainsEditController', edit)
        .factory('DomainsData', function ($state,wtUtils) {
            return function () {
                return {
                    populate:$state.current.data,
                    next_state: {
                        save:wtUtils.siblingState($state,'.processing')
                    }
                }
            }
        })

    function list($scope, $rootScope, $state, WooDomain, WooModelListController, CountUnfiltered, $filter, List, wtUtils)
    {
        var vm = this;
        vm.scope=$scope
        vm.rootScope=$rootScope
        vm.nof_objects_unfiltered=CountUnfiltered && CountUnfiltered.count||0
        vm.api=WooDomain; vm.res=List;
        vm.empty_title='DOMAINS.EMPTY_TITLE'
        vm.empty_text='DOMAINS.EMPTY_TEXT'
        vm.empty_animation_template='app/main/animations/empty-domains.html'
        vm.helpUrl='https://docs.templ.site/domains/registration/domain-management'
        vm.no_create=true // Disable default button
        vm.extra_buttons=[
            {
                name:'DOMAINS.REGISTER_BUTTON'
                ,fun:function() {
                    $state.go('app.domain.registration',{'#':'/register/search'})
                },
                class:"btn-primary",
                disabled:vm.sharing&&!vm.sharing.share_all
            },
            {
                name:"DOMAINS.TRANSFER_BUTTON",
                fun:function() {
                    $state.go('app.domain.registration',{'#':'/transfer/add'})
                },
                class:"btn-primary",
                disabled:vm.sharing&&!vm.sharing.share_all
            },
            // Default button replacement...
            {
                name:"DOMAINS.ADD_EXTERNAL_BUTTON",
                fun:function(){vm.openCreateView()}
            },
        ]
        // Only add "add subdomain" button if there are domains
        if(List.docs.length > 0) {
            vm.extra_buttons.push({
                name:"DOMAINS.ADD_SUBDOMAIN_BUTTON",
                fun:function(){vm.openCreateView()}
            })
        }
        vm.prefix='DOMAINS.'
        WooModelListController(vm, $state.current.data)
        vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
        vm.list.filters=$state.current.data.filters
        vm.Title='DOMAINS.DOMAINS_TITLE'
        vm.list.tableClass='domain-list'
        vm.list.headers=[
            {name:vm.translate('DOMAINS.LIST.NAME'),class:'name'},
            {name:vm.translate('DOMAINS.LIST.WEBSITE'),class:'website'},
            // {name:vm.translate('DOMAINS.LIST.REGISTRAR'),class:'registrar'},
            {name:vm.translate('DOMAINS.LIST.RENEWAL_DATE'),class:'renewal-date'},
            {name:vm.translate('DOMAINS.LIST.AUTO_RENEW'),class:'auto-renew'},
            {name:vm.translate('STATUS'),class:'status'}
        ]
        vm.get_reg_state=wtUtils.getDomainRegistrationState
        vm.list.item_template='app/main/domains/list_item.html'
        vm.has_site=function(obj) {return obj.app}
        vm.editRegistration=function(registrationId) {
            $state.go('app.domain.registration', { '#': '/details/'+registrationId })
        }
    }

    function initForm(vm,form,utils) {
        form.fields=['name','external']
        utils.addFormLabels('DOMAINS',form)
    }
    function create(wtUtils, WooModelEditController, DomainsData, $scope, $state, Form, WooDomain) {
        var vm=this;
        vm.layout='app/main/layouts/wt-edit.html'
        initForm(vm,Form,wtUtils)
        vm.Form=Form
        vm.scope=$scope
        vm.api=WooDomain
        vm.title="DOMAINS.CREATE_TITLE"
        WooModelEditController(vm,DomainsData())
        vm.continue=vm.save
    }

    function operation_type(type) {
        switch(type) {
            case 'initialize':return 'create';
            case 'add_cert':return 'cert';
            case 'updating-add_cert':return 'cert';
            case 'updating-app':return 'update'
            default: return 'update'
        }
    }

    function processing($scope,$state,WooModelEditController, WooDomain, Obj) {
        var vm = this;
        var op_type=operation_type(Obj.operation && Obj.operation.type).toUpperCase()

        vm.layout='app/main/website/website-processing.html'
        vm.processing_title='DOMAINS.PROCESSING.'+op_type+'_PROCESSING_TITLE'
        vm.complete_title='DOMAINS.PROCESSING.'+op_type+'_COMPLETE_TITLE'
        vm.complete_text='DOMAINS.PROCESSING.'+op_type+'_COMPLETE_TEXT'

        vm.scope=$scope
        vm.api=WooDomain
        vm.Object=Obj
        vm.continue=function() {
            $state.go('app.domain.details',{id:vm.Object._id},{location:'replace'})
        }
        WooModelEditController(vm,$state.current.data)
    }

    function details(WooModelEditController,$scope, $state, wtUtils, Obj, Form, WooDomain) {
        var vm=this
        vm.scope=$scope
        vm.Object=Obj
        vm.Form=Form
        vm.no_edit=true
        vm.no_buttons=true
        wtUtils.addFormLabels('DOMAINS',Form)

        vm.zone=Obj.zone
        vm.app=Obj.app
        vm.content='app/main/layouts/wt-domain-details-content.html'
        vm.details_template='app/main/domains/domain-details.html'
        vm.api=WooDomain
        vm.title="DOMAINS.DETAILS_TITLE"
        vm.breadcrumbs=[
            {label:"BREADCRUMBS.DOMAINS", url: '/domain/list/'},
            {label:Obj.name, url: $state.href('app.domain.details', {id: Obj._id})},
        ]
        vm.managed_description=vm.zone.managed?"DOMAINS.MANAGED_DESCRIPTION":"DOMAINS.UNMANAGED_DESCRIPTION"
        vm.edit=wtUtils.gotoState($state,'.edit',{id:vm.Object._id})
        vm.isTransferable = function (domain) {
            var tld = domain.split('.').pop()
            return ['agency', 'be', 'biz', 'blog', 'cloud', 'co', 'com', 'de', 'dev', 'dk', 'es', 'eu', 'fi', 'fr', 'info', 'io', 'net', 'nl', 'no', 'nu', 'nz', 'one', 'online', 'org', 'se', 'shop', 'site', 'store', 'uk'].indexOf(tld) >= 0
        }
        vm.transferToTempl = function (domain) {
            $state.go('app.domain.registration', { '#': '/transfer/add/'+domain })
        }
        vm.add_certificate = function() {
            vm.obj.add_cert=true
            vm.save()
        }
        vm.make_managed=function(val) {
            wtUtils.confirm({
                title:"UTILS.CONFIRM_TITLE"
            },function() {
                vm.obj.make_managed=val
                vm.save()
            })
        }
        vm.get_reg_state=wtUtils.getDomainRegistrationState
        vm.editRegistration=function(registrationId) {
            $state.go('app.domain.registration', { '#': '/details/'+registrationId })
        }
        WooModelEditController(vm,{cancel:'app.domains', save:'app.domains.edit'} )
        vm.can_be_deleted=function(obj) {
            if(vm.no_delete) {
                return false;
            }
            // Allow all subdomains to be deleted
            if(obj.name.split('.').length > 2) {
                return true;
            }
            if(obj.zone.registration) {
                console.log('registration', obj.zone.registration)
                // Allow deletion if the domain has been transferred out
                if(obj.zone.registration.state=='TRANSFERRED_OUT') {
                    return true;
                }
                // Allow deletion if there is a deleteDate and it has passed
                if(obj.zone.registration.details && obj.zone.registration.details.deleteDate) {
                    var deleteDate = new Date(obj.zone.registration.details.deleteDate);
                    var currentDate = new Date();
                    if(deleteDate < currentDate) {
                        return true;
                    }
                }
                // Otherwise do not allow deletion of registered domains
                return false;
            }
            return true;
        }
        vm.has_expired=function(obj) {
            // Compare obj.zone.registration.details.renewalDate with current date
            if (obj.zone && obj.zone.registration && obj.zone.registration.details && obj.zone.registration.details.renewalDate) {
                var renewalDate = new Date(obj.zone.registration.details.renewalDate);
                var currentDate = new Date();
                return renewalDate < currentDate;
            }
            return false;
        }
    }


    function edit(wtUtils,AppLoader,WooModelEditController,$scope,$state,DomainsData,Object,Form, WooDomain)
    {
        var vm=this;
        vm.layout='app/main/layouts/wt-edit.html'
        vm.Object=Object
        vm.Form=Form
        Form.disabled={
            name:true
        }
        vm.scope=$scope
        vm.api=WooDomain
        var fields=Form.fields
        initForm(vm,Form,wtUtils)
        WooModelEditController(vm,DomainsData())
        if(vm.isAdmin) {
            var form=vm.form
            form.fields=form.fields.concat(['app','config_type'])
            wtUtils.addFormLabels('DOMAINS',vm.form)
            form.refresh={app:function (search,scrolling) {
                AppLoader(form.values.app,search,scrolling)
            }}
            form.type.app='ui-select'
            form.type.config_type='ui-select'
        }
        vm.continue=vm.save
        vm.title="DOMAINS.EDIT_TITLE"
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard', ['app.wooadmin'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,
        Models)
    {
        var model = Models['WooEmailAddress']
        var sub_data={
            populate:['domain','operation']
        }
        var post_cache={};
        // State
        $stateProvider
            .state('app.dashboard', {
                url        :  '/dashboard',
                redirectAfter :  'app.dashboard.main',
                redirectAlwaysEnter: true,
                data:{
                    //Title: "Website"
                }
            })
            .state('app.dashboard.main', {
                url    : '/main',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/dashboard.html',
                        controller : 'DashboardController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    Apps: ['$stateParams','WooApp','WooModelListResolver',function(params,app,resolver) {
                        var args={
                            page:1,
                            page_size:5,
                            sort:'-_id'
                        }
                        var options={
                            populate:['operation','location','plan'],
                        }
                        return resolver(app,args,options)
                    }],
                    Billing: ['msApi','AuthService', function (msApi,auth)
                    {
                        return  msApi.resolve('userBilling@get',{create_missing:1,user:auth.selectedUser()})
                    }],
                    Posts:['$http','$translate',function($http,$translate) {
                        var used=$translate.use() ||'en'
                        var tag=91
                        var lang=""
                        if(used=='sv') {tag=90; lang='/sv'}
                        if (!post_cache[used]) {
                            post_cache[used]=$http({
                                method:'GET',
                                url:"https://templ.io"+lang+"/wp-json/wp/v2/posts?orderby=date&per_page=4&_embed&tags="+tag
                            })
                        }
                        return post_cache[used]
                    }],
                    Quota: function (WooQuota,AuthService)
                    {
                        var args={user:AuthService.selectedUser(),fill:'templstatsData',page_size:-1}
                        return WooQuota.query(args).$promise
                    }

                },
                data : {
                    //Title: model.Name+'s'
                }

            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dashboard');

    }
})();

(function()
{
    angular
        .module('app.dashboard')
        .controller('DashboardController',dashboard);

        function dashboard($state,$scope,$rootScope,$translate,Posts,$sanitize,WooApp,Apps,Billing,WooModelListController,Quota,AuthService,wtUtils,ChatService)
        {
            var vm=this
            vm.isAdmin=AuthService.isAdmin()
            vm.scope=$scope
            vm.rootScope=$rootScope
            vm.set_billing_url=function() {
                var host=MAIN_HOST||'templ.io'
                var lang = $translate.use()
                if( lang == "sv" ) {
                    vm.billing_url='https://'+host+'/sv/mitt-konto/orders/'
                } else {
                    vm.billing_url='https://'+host+'/my-account/orders/'
                }
            }
            vm.set_billing_url()
            wtUtils.add_listener($scope,$rootScope.$on('$translateChangeSuccess', function () {
                vm.set_billing_url()
            }))
            vm.posts=Posts.data
            angular.forEach(vm.posts,function(p) {
                p.title=p.title.rendered||p.title
                p.date=moment(p.date).format("MMM DD, YYYY")
            })
            Billing=Billing.docs && Billing.docs[0] || Billing
            vm.orders=Billing.latest_orders && Billing.latest_orders.slice(0,3)

            angular.forEach(vm.orders,function(p) {
                p.date=moment(p.date_created).format("MMM DD, YYYY")
            })

            // Get the websites
            getApps(vm,WooApp,Apps,WooModelListController)
            vm.objects=Apps.docs
            vm.list={}
            vm.list.headers=[
                {name:$translate.instant('WEBSITE.LIST.NAME'),class:'name'},
                {name:$translate.instant('WEBSITE.LIST.LOCATION'),class:'location'},
                {name:$translate.instant('WEBSITE.LIST.DISK'),class:'disk',tooltip:'WEBSITE.TOOLTIPS.DISK_USAGE'},
                {name:$translate.instant('WEBSITE.LIST.VERSION'),class:'version',tooltip:'WEBSITE.TOOLTIPS.WP_VERSION'},
                {name:$translate.instant('WEBSITE.LIST.STATUS'),class:'status'}
            ]
            vm.list.item_template='app/main/website/list_item_dashboard.html'
            vm.openEditView=function(event,obj) {
                if(event.target.classList.contains('btn-quick-actions') || event.target.classList.contains('wt-dropdown-item')) {
                    return
                }
                $state.go('app.website.details',{id:obj._id})
            }
            vm.getFlag=wtUtils.getFlag

            Quota = Quota && Quota.docs && Quota.docs[0]||Quota

            getBW(vm,Quota,wtUtils)
            vm.gotoSite=function(obj) {
                $state.go('app.website.details',{id:obj._id})
            }

            // Check if the user is currently using a shared account
            vm.isAccountSharing = AuthService.selected_user !== null && AuthService.selected_user !== undefined;

            vm.gotoInvoice = function(o) {
                // If the user is using a shared account, do not allow them to access the invoices
                if (vm.isAccountSharing) {
                    return;
                }
                var host = MAIN_HOST || 'templ.io';
                var url = 'https://' + host + '/my-account/invoices/';
                var lang = $translate.use() || 'en';
                // If the invoice is completed, open the pdf in a new tab
                if (o.status === 'completed') {
                    url += '?pdfid=' + o.id;
                } else if (lang === 'sv') {
                    url = 'https://' + host + '/sv/mitt-konto/invoices/';
                }
                window.open(url, '_blank');
            };

            // Get the subscription currency from the highest id subscription
            vm.subscriptionCurrency = 'USD'; // Default currency
            if (Billing.subscriptions && Billing.subscriptions.length > 0) {
                var highestIdSubscription = Billing.subscriptions.reduce(function(prev, current) {
                    return (prev._id > current._id) ? prev : current;
                });
                vm.subscriptionCurrency = highestIdSubscription.data.currency || 'USD';
            }

            // Format the total to always have 2 decimals etc.
            vm.orderTotal = function(o) {
                var total = parseFloat(o.total).toFixed(2);
                // If the currency is USD, return the total as string
                if (vm.subscriptionCurrency === 'USD') {
                    return total;
                }
                // If the currency is SEK, return the total as string, replace . with ,
                return total.replace('.', ',');
            };
            vm.chat = function() {
                ChatService.open();
            }

            // To be used in the support section
            vm.lang = $translate.use();

            vm.get_time_of_day = function() {
                var hour = new Date().getHours();
                if (hour >= 4 && hour < 9) {
                    return "MORNING";
                } else if (hour >= 9 && hour < 13) {
                    return "DAY";
                } else if (hour >= 13 && hour < 18) {
                    return "AFTERNOON";
                } else {
                    return "EVENING";
                }
            }
            vm.time_of_day = $translate.instant('DASHBOARD.TIME_OF_DAY.'+vm.get_time_of_day());

            AuthService.getUser().then(function(user) {
                vm.user_first_name = user.name.first;
            })

            vm.createWebsite = function() {
                $state.go('app.website.create');
            }

            vm.transferWebsite = function() {
                $state.go('app.website.migrate');
            }

            vm.registerDomain = function() {
                $state.go('app.domain.registration',{'#':'/register/search'})
            }

            vm.todays_staff_image = function() {
                var staff_images = [
                    '/assets/images/staff/mattias.png', // Sunday
                    '/assets/images/staff/erik.png', // Monday
                    '/assets/images/staff/alisia.png', // Tuesday
                    '/assets/images/staff/karl.png', // Wednesday
                    '/assets/images/staff/oskar.png', // Thursday
                    '/assets/images/staff/emanuel.png', // Friday
                    '/assets/images/staff/sophia.png', // Saturday
                    '/assets/images/staff/herman.png', // ...
                ]
                var today = new Date();
                var dayOfWeek = today.getDay();
                return staff_images[dayOfWeek];
            }

            vm.isAgency = function() {
                var isAgency = AuthService.isAgency();
                // console.log('isAgency', isAgency, AuthService.user);
                return isAgency;
            }
            vm.registerAccountUrl = wtUtils.getRegisterAccountUrl();

        }

        function getApps(parent,WooApp,Apps,WooModelListController) {
            var vm={}
            vm.scope=parent.scope
            vm.rootScope=parent.rootScope
            vm.api=WooApp; vm.res=Apps;
            vm.empty_title='DASHBOARD.NO_SITES_TITLE'
            vm.empty_text='DASHBOARD.NO_SITES_TEXT'
            vm.prefix='SHARING.'
            var data={
                substates: {edit:'app.wooapp.details'}
            }
            WooModelListController(vm,data)
            parent.object_status=function(obj) {
                return vm.object_status(obj)
            }
        }

        function getBW(vm,Quota,utils) {
            var quota = Quota.quota;
            var bw=_.find(quota,function(q){ return q.label=='bw'}) || {
                label:"bw",usage:0,current:0,max:0
            }
            if(Quota && Quota.templstatsData) bw.usage += (Quota.templstatsData.data||0)
            bw.date=new Date(bw.date)
            bw.overage_rate=0.20
            bw.current=Math.floor(bw.usage/(1024*1024))
            // Test
            //bw.current=1789
            bw.projected=Math.floor(bw.current/(bw.date.getDate())*utils.daysInMonth(bw.date))
            bw.month=moment(bw.date).format("MMM, YYYY")
            bw.unit='MB'
            bw.overage=bw.projected>bw.max
            if (bw.current>5120) {

                bw.current=bw.current/1024
                bw.projected=bw.projected/1024
                bw.max=bw.max/1024
                bw.unit='GB'

                bw.current=bw.current.toFixed(2)
                bw.projected=bw.projected.toFixed(2)
                bw.max=bw.max.toFixed(0)
            }
            //bw.start_date=
            vm.bw=bw

        }


})();

(function ()
{
    'use strict';

    angular
        .module('app.commands', [])
        .config(config);
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.commands', {
                url    : '/commands',
                redirectTo: 'app.commands.website'
            })
            .state('app.commands.website', {
                url    : '/website/:id',
                params: {id:null,tab:0},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'CommandController as vm'
                    }
                },
                resolve: {
                    Doc:[
                        '$stateParams','WooApp','WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation']})
                        }
                    ],
                    Commands: function (msApi)
                    {
                        return msApi.resolve('appcommands@get');
                    },
                    CommandGroups: function (msApi)
                    {
                        return msApi.resolve('appcommandgroups@get');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/commands');

        // Api
        msApiProvider.register('appcommands', ['api/command/?populate=overrides&page_size=-1']);
        // Api
        msApiProvider.register('appcommandgroups', ['api/commandgroup/?model=WooApp&page_size=-1']);

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.commands')
        .controller('CommandController', CommandController)
        //.controller('AdvancedController', AdvancedController)
        .constant('CommandController0', CommandController0)


    function check_tags(o,app,tags) {
        tags = tags || o.tags || 'container-wp,container-bedrock,lemp-wp'
        tags=tags.split(',')
        if (_.find(tags, function(tag) {
            if(app.app_type.includes(tag)) return true
            if( app.data && app.data.find(function(d) { return d.tag=='command_tags' && d.value.split(',').includes(tag) }) ) return true
        })) return true
        return false
    }

    function CommandController0(Doc, Commands, CommandGroups)
    {
        var vm = this;
        vm.commands=Commands.docs
        vm.groups=CommandGroups.docs
        vm.onTabSelect=function(group){
            vm.selected_tab=vm.groups.indexOf(group)
        }
        vm.check_tags=vm.check_tags||check_tags
        vm.obj=Doc
        vm.init_commands=function(obj) {
            var group_map={}
            _.each(vm.groups,function(g) {
                if(!vm.check_tags(g,Doc)) return
                if (g.path) {
                    var msg=readVal(obj.settings_msgs,g.path)
                    if(msg && msg.class) { g.msg={class:msg.class,msg:msg.msg} }
                }
                group_map[g._id]=g
                g.commands=[]
            })

            _.each(vm.commands,function(opt) {
                if(opt.access=='admin' && !vm.isAdmin) return
                var g=group_map[opt.group]
                if(!g) return

                if(!vm.check_tags(opt,Doc,g.tags)) return

                g.commands.push(opt)
                angular.forEach(opt.options,function (opt) {
                    if(opt.default) opt.value=opt.default
                });
            })
            vm.groups=_.filter(vm.groups,function(g) { return g.commands && g.commands.length>0; })
            _.each(vm.groups,function(g) {
                if(!g.commands) return
                g.commands.sort(function(a,b) { return (a.order||10000)-(b.order||10000) })
            })
            vm.groups.sort(function(a,b) { return (a.order||10000)-(b.order||10000) })
        }
        vm.init_commands(Doc)

        vm.update_commands=function(cmd) {
            var options={}
            angular.forEach(cmd.options,function (opt) {
                if(opt.value) {
                    options[opt.name]=opt.value
                }
            });
            vm.obj.run_commands={
                verbose:true,
                ignore_errors:true,
                cmds:[{id:cmd._id,options:options}]
            }
            //vm.obj.run_commands=[{id:123}] //Testing
            vm.running_cmd=cmd
        }
    }
    /** @ngInject */
    function CommandController($state, $stateParams, $window, $scope, $rootScope, $translate,
        AuthService, WooModelEditController, PollOperation, WooApp,Doc, Commands,CommandGroups)
    {
        var vm = this;
        vm.content = 'app/main/commands/commands.html'
        vm.Object=vm.doc=Doc
        vm.api=WooApp
        //debugger
        vm.initial_tab=$stateParams.tab||0
        vm.isAdmin=AuthService.isAdmin()
        CommandController0.call(vm,Doc,Commands,CommandGroups)
        WooModelEditController(vm,{})
        vm.run=function(cmd) {
            if (vm.is_operating) {
                return
            }
            vm.is_operating=true
            vm.update_commands(cmd)
            vm.save(function() {
                vm.update_object()
            })
        }
        $scope.$watch("vm.obj",function() {
            if(vm.is_operating) {
                vm.is_operating = vm.obj && vm.obj.operation && !vm.obj.operation.complete
                if(vm.running_cmd && vm.obj.operation) {
                    vm.running_cmd.log=vm.obj.operation.msgs
                }
            }
        })
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.backups', ['app.wooadmin'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,
        Models)
    {
        var model = Models['WooBackup']
        var sub_data={
            populate:['operation','app']
            ,next_state:{save:'app.'+model.name+'.details'}
        }
        var filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            }
        ]
        // State
        $stateProvider
            .state('app.'+model.name, {
                url    : '/'+model.name,
                redirectTo: 'app.'+model.name+'.list'
            })
            .state('app.'+model.name+'.list', {
                url    : '/list/:page',
                params : {page: null},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/wooadmin/models/modellist.html',
                        controller : [
                            'WooModelListController','$scope', '$rootScope', '$state', 'List',
                            'CountUnfiltered', model.model,
                            function(ctrl,scope,rootScope,state,res,count,m) {
                                var vm = this;
                                vm.scope=scope
                                vm.rootScope=rootScope
                                vm.nof_objects_unfiltered=count && count.count||0
                                vm.api=m; vm.res=res;
                                vm.empty_title='BACKUPS.EMPTY_TITLE'
                                vm.empty_text='BACKUPS.EMPTY_TEXT'
                                vm.prefix='BACKUPS.'
                                ctrl(vm,state.current.data)
                                vm.list.filter_template='app/main/wooadmin/models/modellistfilter.html'
                                vm.list.filters=state.current.data.filters
                                vm.empty_animation_template='app/main/animations/empty-backups.html'
                            }
                        ],
                        controllerAs: 'vm'
                    }
                },
                data: {
                    Title:'BACKUPS.LIST_TITLE'
                    ,populate:['operation','app']
                    ,no_create:true
                    ,substates:{create:'app.website.create',edit:'app.'+model.name+'.details'}
                    ,model:model
                    ,filters:filters
                },
                resolve: {
                    /*List: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{populate:['app','operation']})
                    }],*/
                    List: ['$stateParams','wtUtils',model.model,'WooModelListResolver',function(params,utils,app,resolver) {
                        var f = utils.getCached('app.backup.list')||filters
                        return resolver(app,params,{
                            populate:['app','operation']
                            ,filters:f
                        })
                    }],
                    CountUnfiltered: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{
                            __count_only__:true
                        })
                    }]
                },
            })
            .state('app.'+model.name+'.details', {
                url     : '/details/:id',
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : [
                            'WooModelEditController','$scope', '$state', 'wtUtils','Object', 'Form', model.model,
                            function(ctrl,scope,state,utils,obj,form,m) {
                                var vm=this;
                                vm.content='app/main/layouts/wt-details-content.html'
                                vm.Object=obj
                                vm.Form=form
                                vm.scope=scope
                                vm.api=m
                                vm.time=function(item) {
                                    if(!item.moment) {
                                        var m=moment(item.time)
                                        var f=m.format('MMMM Do YYYY, h:mm:ss A');
                                        item.moment=f
                                    }
                                    return item.moment
                                }
                                vm.details_template='app/main/backups/details.html'
                                vm.edit_template='app/main/backups/edit.html'
                                vm.title="BACKUPS.LIST_TITLE"
                                vm.breadcrumbs=[
                                    {label:"BREADCRUMBS.BACKUPS", url:"/backup/list/"},
                                ]
                                if(obj.app) {
                                    vm.breadcrumbs.push({label:obj.app.name})
                                } else {
                                    vm.breadcrumbs.push({label:"BREADCRUMBS.DELETED_WEBSITE", translateValues:{name:obj.name}})
                                }
                                vm.extra_buttons_before=[{
                                    label:'BACKUPS.CREATE_BACKUP'
                                    ,action:function() {
                                        state.go('app.website.backup',{id:obj.app.id})
                                    }
                                    ,hidden:!obj.app
                                }]
                                vm.get_name = function() {
                                    if (obj.app) {
                                        return obj.app.name
                                    }
                                    return obj.name
                                }
                                vm.is_deleted = !obj.app
                                vm.app_name=vm.get_name()
                                vm.remove_local=function(local) {
                                    var list = vm.obj.locals
                                    var ix = list.indexOf(local)
                                    vm.remove_list_element(list,ix)
                                }
                                vm.remove_remote=function(local) {
                                    var list = vm.obj.remotes
                                    var ix = list.indexOf(local)
                                    vm.remove_list_element(list,ix)
                                }
                                vm.object_callback=function(obj) {
                                    obj.locals.sort(function(a,b) {return moment(b.time)-moment(a.time);})
                                    obj.remotes.sort(function(a,b) {return moment(b.time)-moment(a.time);})
                                }
                                ctrl(vm,state.current.data)
                                utils.detailsController(vm,state)
                                vm.get_download_link=function(bu,remote) {
                                    vm.obj.get_download_link={bu:bu,remote:remote}
                                    vm.status='working'
                                    vm.save(function (res) {
                                        vm.init_object(res)
                                    })
                                }
                            }
                        ],
                        controllerAs:'vm'
                    }
                },
                resolve: {
                    Object:[
                        '$stateParams',model.model,'WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation','app']})
                        }
                    ],
                    Form:[
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'user'})
                        }
                    ]
                },
                data: sub_data
            })
            .state('app.'+model.name+'.edit', {
                url     : '/edit/:id',
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : [
                            'WooModelEditController','$scope', '$state', 'wtUtils','Object', 'Form', model.model,
                            function(ctrl,scope,state,utils,obj,form,m) {
                                var vm=this;
                                vm.layout='app/main/layouts/wt-edit.html'
                                vm.Object=obj
                                vm.Form=form
                                vm.scope=scope
                                vm.api=m
                                vm.edit_template='app/main/backups/edit.html'
                                vm.local_schedule=obj.schedules[0]
                                vm.remote_schedule=obj.schedules[1]
                                vm.schedule_form=form.subforms.schedules

                                vm.get_name = function() {
                                    if (vm.obj.app) {
                                        return vm.obj.app.name
                                    }
                                    return "Deleted app (" + vm.obj.name + ")"
                                }
                                vm.remove_local=function(local) {
                                    var list = vm.obj.locals
                                    var ix = list.indexOf(local)
                                    vm.remove_list_element(list,ix)
                                }
                                vm.remove_remote=function(local) {
                                    var list = vm.obj.remotes
                                    var ix = list.indexOf(local)
                                    vm.remove_list_element(list,ix)
                                }
                                vm.object_callback=function(obj) {
                                    obj.locals.sort(function(a,b) {return moment(b.time)-moment(a.time);})
                                    obj.remotes.sort(function(a,b) {return moment(b.time)-moment(a.time);})
                                }
                                ctrl(vm,state.current.data)
                                vm.continue=vm.save
                            }
                        ],
                        controllerAs:'vm'
                    }
                },
                resolve: {
                    Object:[
                        '$stateParams',model.model,'WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{populate:['operation','app']})
                        }
                    ],
                    Form:[
                        '$stateParams',model.model,'WooFormResolver',function(params,m,resolver) {
                            return resolver(m,params,{form_type:'user'})
                        }
                    ]
                },
                data: sub_data
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/backups');

        // Api
        msApiProvider.register('backups', ['app/data/backups/backups.json']);

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.backups')
        .controller('BackupsController',  ['$scope','WooModelListCtrl','WooBackup','WooBackupModel', BackupsController])
        .controller('BackupDetailsController', ['$scope','WooModelEditCtrl','WooBackup', BackupDetailsController]);

    /** @ngInject */
    function BackupsController($scope,cntrl,api,model)
    {
        var vm = this;
        vm.no_create=true
        vm.substates={edit:'app.backups.details'}
        vm.model=model
        vm.scope=$scope
        vm.populate='app' //[['app','name']]
        vm.populate=['app']
        cntrl(vm,api)
    }

    function BackupDetailsController(scope,cntrl, model)
    {
        var vm = this;
        vm.scope=scope
        vm.populate='app'
        vm.populate=['app']
        vm.details_template='app/main/backups/details.html'
        vm.edit_template='app/main/backups/edit.html'
        vm.title="HELLO WORLD"
        cntrl(vm,model,'user','app.backups')
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.billing', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.billing', {
                url    : '/billing',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/billing/billing.html',
                        controller : 'BillingController as vm'
                    }
                },
                resolve: {
                    BillingData: function (msApi)
                    {
                        return msApi.resolve('billing@get');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/billing');

        // Api
        msApiProvider.register('billing', ['app/data/billing/billing.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('billing', {
            title    : 'BILLING',
            icon     : 'icon-tile-four',
            state    : 'app.billing',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'BILLING.BILLING_NAV',
            weight   : 1
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.billing')
        .controller('BillingController', BillingController);

    /** @ngInject */
    function BillingController(BillingData)
    {
        var vm = this;

        // Data
        vm.helloText = BillingData.data.helloText;

        // Methods

        //////////
    }
})();


(function ()
{
    'use strict';
    angular
        .module('app.auth', [])
        .config(config)
        .factory('Account', ['$resource',
           function($resource) {
             return $resource('/auth/user/:user_id',
                    {},
                    {update: {method:'POST'}});
           }
         ])
        .factory('AuthService', [
            '$q','$window','$http','$location','$rootScope','$translate','msNavigationService',
            'MainHost','LoginUrl','LogoutUrl','WooAdminNavigation','$cookies', 'Account', 'ChatService',
            function($q,$window,$http,$location,$rootScope,$translate,msNavigationService,
                MainHost,LoginUrl,LogoutUrl,WooAdminNavigation,$cookies,Account,ChatService) {
               var self = {
                   set_user: function (user,next) {
                       var lang = $cookies.get('templio_lang') || user.language;
                       self.setUserLanguage(user,lang, function() {
                           self.user=user
                           $rootScope.$broadcast('userSetEvent');
                        next && next()
                        })
                        ChatService.setUser(user)
                    },
                   login:function (user, pass, next) {
                       //console.log("Login user " + vm.email +" password "+vm.password);

                       $http.post(AUTH_HOST+'/auth/login',{username:user,password:pass}).then(function (user) {
                           user=user&&user.data
                           if (user) {
                               self.set_user(user)
                               next(null,user)
                           } else {
                               next('Auth Failure', user)
                               //console.log("Auth failed");
                           }
                       },function() {
                           next()
                       })
                   },
                   logout:function(next) {
                        $cookies.remove('templio_selected_user')
                        $cookies.remove('templio_selected_user',{domain:'.templ.io'})
                        $cookies.remove('woopanel_url_after_login')
                        $cookies.remove('templ_sharing_invite',{domain:'.templ.io'})
                         $rootScope.$broadcast('logout')
                         ChatService.reset()
                         $http.get(AUTH_HOST+'/auth/logout').then(function(res) {
                            $window.location.href=LogoutUrl
                            next();
                            self.user=null
                        },function() {
                            next()
                        })
                   },
                   selectedUser: function () {
                       if (this.isAdmin()) {
                           return $location.search().user || this.selected_user
                       } else {
                           return this.selected_user
                       }
                   },
                   selectedUserData: function () {
                       if (this.isAdmin()) {
                           return this.selected_user_data
                       }
                   },
                   selectUser: function (user,next) {
                        var self=this
                        console.log('Selecting user',user);
                        if(!user) return self.selectUser0(user,next)
                        this.getUser().then(function(main_user) {
                            if(main_user && main_user.acctId==user) user=null
                            self.selectUser0(user,next)
                        })
                    },
                    selectUser0: function (user,next) {
                        if (this.selected_user!=user) {
                           this.selected_user=user
                           if (user) {
                               return $http.get(AUTH_HOST+'/auth/user/'+this.selected_user).then(function(data) {
                                   data=data.data
                                   if (data && data._id) {
                                       self.selected_user_data=data
                                       $rootScope.$broadcast('user:changed')
                                       return next&&next(null,user)
                                   }
                                   //self.selected_user=null;
                                   $rootScope.$broadcast('user:changed')
                                   return next&&next(null,user)
                               },function(err) {
                                   //self.selected_user=null;
                                   return next&&next(err,user)
                               })
                           }
                           this.selected_user=null;
                           $rootScope.$broadcast('user:changed')
                           return next&&next(null,user)
                       }
                       return next&&next(null,user)
                   },
                   getUser: function (next) {
                       if(!self.deferred_user) {
                           self.deferred_user=$q.defer()
                           $http.get(AUTH_HOST+'/auth/loggedin').then(
                               function (user) {
                                   user=user && user.data
                                   if (!user) {
                                       $location.url(LoginUrl)
                                       return
                                   }
                                   self.set_user(user,function () {
                                       self.deferred_user.resolve(self.user)
                                   })
                               },function(err) {
                                   self.deferred_user.reject(err)
                               }
                           )
                       }
                       return self.deferred_user.promise
                   }
                   ,getSelectedOrCurrentUser:function() {
                       if (this.isAdmin() && this.selected_user_data) {
                           return self.selected_user_data
                       }
                       return this.user
                   }
                   ,isAdmin: function() {
                       return self.user && self.user.role=='admin'
                   }
                   ,setUserLanguage: function (user,lang,next) {
                       if (user && user.language!=lang) {
                           user.language=lang
                           $http.post(AUTH_HOST+'/auth/user/'+user._id,{language:lang}).then(function (user) {
                           })
                       }
                       self.setLang(lang,next)
                   }
                   ,getAccount : function (next) {
                       self.getUser().then(function(user) {
                           if (user && user.acctId) {
                               return Account.get({user_id:user._id},function(acct) {
                                   next && next(acct)
                               })
                           }
                           next&& next()
                       })
                   }
                   ,setLang:function(lang,next) {
                       var tlang=$translate.use()
                       if( lang && lang!=tlang) {
                           if (next) {
                               var l = $rootScope.$on('$translateChangeSuccess', function () {
                                   //debugger
                                   next()
                                   l()
                               })
                           }
                           $translate.use(lang)
                           $cookies.put('templio_lang',lang, {domain:'.templ.io'})
                       } else {
                           lang=tlang
                           if (next) {
                               $translate.onReady(next)
                           }
                       }
                        ChatService.setLocale(lang)
                        moment.locale(lang)
                   },
                   isAgency: function() {
                        var isAgency = false
                        if (!self.user || !self.user.meta_data) return isAgency
                        self.user.meta_data.forEach(function(item) {
                            if(item.key == "agency" && item.value == "true") {
                                isAgency = true
                            }
                        })
                        return isAgency
                   }
               }

               $rootScope.$on('upgrade:complete',function () {
                   //alert('user changed')
                   cachedInfo=null
               })
               $rootScope.$on('$translateChangeSuccess', function () {
                   var lang = $translate.use()
                   var help=$translate.instant('LANGOPTIONS.HELP_PATH')
                   var account = (lang=="en"?"":lang+"/")+'my-account/'
                   //var help=$translate.instant('WOOADMIN.USER_GUIDE')
                   //debugger
                   /*
                   msNavigationService.saveItem('user-guide', {
                       title    : 'USER_GUIDE',
                       icon     : 'icon-help',
                       translate: 'WOOADMIN.USER_GUIDE',
                       weight   : 80,
                       href: 'https://help.templ.io/' + help,
                       target: 'wootemple.help'
                   });
                   msNavigationService.saveItem('myaccount', {
                       title    : 'MY_ACCOUNT',
                       icon     : 'icon-account',
                       translate: 'WOOADMIN.MY_ACCOUNT',
                       weight   : 70,
                       href: 'https://templ.io/'+account,
                       target: 'wootemple.account'
                   });
                   */
               })
               WooAdminNavigation(self)
               return self;
           }
         ]);
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)//, msNavigationServiceProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth');
        $stateProvider.state('app.auth', {
            url      : '/user',

        })
        $stateProvider.state('appf.auth', {
            url      : '/user',

        })
        .state('app.auth.login', {
            url      : '/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth.login': {
                    templateUrl: 'app/main/auth/views/login2.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        })
        .state('app.auth.logout', {
            url      : '/logout',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth.logout': {
                    templateUrl: 'app/main/auth/views/logout.html',
                    controller : 'LogoutController as vm'
                }
            },
            resolve:{
                Translate:['$translate',function(t) {
                    return t.onReady()
                }]
            },
            bodyClass: 'login'
        })
        .state('appf.auth.logout', {
            url      : '/logout',
            views    : {
                'content@appf': {
                    templateUrl: 'app/main/auth/views/logout.html',
                    controller : 'LogoutController as vm'
                }
            },
            bodyClass: 'login'
        })
        .state('app.auth.edit', {
            url      : '/edit',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/auth/views/edit.html',
                    controller : 'EditUserController as vm'
                }
            },
            bodyClass: 'login'
        });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.auth')
        .controller('LoginController', LoginController)
        .controller('LogoutController', LogoutController)
        .controller('EditUserController', EditUserController);

    /** @ngInject */
    function LoginController($location,LoginUrl, $window, $scope,$timeout, AuthService, UrlAfterLogin)
    {
        var vm=this;
        $window.location.href=LoginUrl
        return
    }

    /** @ngInject */
    function EditUserController($state, Account, AuthService)
    {
        var vm=this;
        AuthService.getUser().then(
            function (user) {
                var id = user._id
                if ($state.params.user_id)
                    id = $state.params.user_id
                console.log("Fetching user id: "+id)
                vm.user = Account.get({user_id:id})
            })
        vm.save = function () {
            vm.user.$save({user_id:vm.user._id},
                function () {
                    vm.passwordRepeat=null
                }
            )
        }
    }

    /** @ngInject */
    function LogoutController($state, $window, wtUtils, AuthService, $translate)
    {
        var vm=this;
        show()//$translate.onReady().then(show)
        function show() {
            vm.title=$translate.instant('LOGOUT.CONFIRM_TITLE')
            vm.text=$translate.instant('LOGOUT.CONFIRM')
            vm.ok=$translate.instant('WOOADMIN.OK')
            vm.cancel=$translate.instant('WOOADMIN.CANCEL')

            wtUtils.confirm({title:vm.title,body:vm.text,ok:vm.ok,cancel:vm.cancel},function(){
                    vm.logging_out=true
                    AuthService.logout(
                        function () {
                        }
                    )
                },
                function() {
                    //alert("Cancelled")
                    $window.history.back();
                }
            )
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('relativeDate', relativeDate)
        .filter('objectIdToDate', objectIdToDate);

    /**
     * Relative date filter for displaying human-friendly dates.
     * 
     * Usage: {{ dateValue | relativeDate }}
     *        {{ mongoObjectId | relativeDate:'objectId' }}
     * 
     * Output examples for past dates:
     * - "Today" / "Yesterday" for recent dates
     * - "3 days ago" for dates within 2 weeks
     * - "Jan 15" for dates within current year
     * - "Jan 15, 2024" for older dates
     * 
     * Output examples for future dates:
     * - "Today" / "Tomorrow" for near future
     * - "in 3 days" for dates within 2 weeks
     * - "Apr 15" for dates within current year
     * - "Apr 15, 2027" for dates in future years
     * 
     * @ngInject
     */
    function relativeDate()
    {
        return function (value, type)
        {
            if (!value) {
                return '-';
            }

            var date;

            // Handle MongoDB ObjectId - extract timestamp from first 8 hex chars
            if (type === 'objectId') {
                var timestamp = parseInt(value.substring(0, 8), 16);
                date = moment(timestamp * 1000);
            } else {
                date = moment(value);
            }

            if (!date.isValid()) {
                return '-';
            }

            var now = moment();
            var diffDays = now.diff(date, 'days');
            var diffWeeks = now.diff(date, 'weeks');
            
            // Future dates (negative diff means date is in the future)
            if (diffDays < 0) {
                var futureDays = Math.abs(diffDays);
                var futureWeeks = Math.abs(diffWeeks);
                
                // Today (same calendar day)
                if (futureDays === 0) {
                    return 'Today';
                }
                
                // Tomorrow
                if (futureDays === 1) {
                    return 'Tomorrow';
                }
                
                // Within 2 weeks - show "in X days"
                if (futureDays < 14) {
                    return 'in ' + futureDays + ' days';
                }
                
                // Within 8 weeks - show "in X weeks"
                if (futureWeeks < 8) {
                    return 'in ' + futureWeeks + ' weeks';
                }
                
                // Same year - show "Apr 15"
                if (date.year() === now.year()) {
                    return date.format('MMM D');
                }
                
                // Future year - show "Apr 15, 2027"
                return date.format('MMM D, YYYY');
            }

            // Today
            if (diffDays === 0) {
                return 'Today';
            }

            // Yesterday
            if (diffDays === 1) {
                return 'Yesterday';
            }

            // Within 2 weeks - show "X days ago"
            if (diffDays < 14) {
                return diffDays + ' days ago';
            }

            // Within 8 weeks - show "X weeks ago"
            if (diffWeeks < 8) {
                return diffWeeks + ' weeks ago';
            }

            // Same year - show "Jan 15"
            if (date.year() === now.year()) {
                return date.format('MMM D');
            }

            // Older - show "Jan 15, 2024"
            return date.format('MMM D, YYYY');
        };
    }

    /**
     * Convert MongoDB ObjectId to JavaScript Date.
     * 
     * Usage: {{ mongoObjectId | objectIdToDate }}
     *        {{ mongoObjectId | objectIdToDate | date:'yyyy-MM-dd HH:mm:ss' }}
     * 
     * @ngInject
     */
    function objectIdToDate()
    {
        return function (value)
        {
            if (!value) {
                return null;
            }

            var timestamp = parseInt(value.substring(0, 8), 16);
            return new Date(timestamp * 1000);
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    //function fuseThemingService($cookies, $log, $mdTheming)
    function fuseThemingService($cookies, $log)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return {};//$mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return {}; //$mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    //$log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    //function config($mdThemingProvider, fusePalettes, fuseThemes)
    function config( fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

/*
        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
        */
    }

})();

(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'wt-blue',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : '700'
                }
            },
            accent    : {
                name: 'indigo',
                hues: {
                    'default': '400',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();

(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'wt-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#2b88e4',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        //$mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider)
        .provider('msCache',msCacheProvider);

        var baseUrl = (API_HOST && API_HOST+'/' || '');
        var api = [];

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register0(key, resource, $log)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = function (key,resource) {register0(key,resource,$log)};

        //////////
        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : provider.register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');

                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');

                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }

    function msCacheProvider() {
        var provider = this
        var cache=[]
        var validity=[]

        var $log = angular.injector(['ng']).get('$log');

        // Data

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.setOpts = function(key,opts) {
            opts=opts||{}
            validity[key+'@get'] = opts.validity || validity[key+'@get']
        }
        provider.getApiObject = getApiObject;
        provider.register = function (key,resource,cacheOpts) {
            provider.setOpts(key,cacheOpts)
            register0(key,resource,$log)
        };

        function expired(action) {
            var old=cache[action] || {added:0}
            var valid = validity[action] || 0
            console.log("Checking expiration");
            return old.added + valid < Date.now()
        }

        this.$get = function (msApi) {
            // Methods
            var service = {
/*                setBaseUrl: msApi.setBaseUrl,
                getBaseUrl: msApi.getBaseUrl,
                register  : msApi.register,
                resolve   : msApi.resolve,
                request   : msApi.request*/
            };

            service = {
               setBaseUrl: setBaseUrl,
               getBaseUrl: getBaseUrl,
               register  : provider.register,
               request   : msApi.request,
               resolve   : cached_resolve
           };
            return service;

            function cached_resolve(action,parameters) {
                if ( expired(action) ) {
                    cache[action] = {
                        res:msApi.resolve(action,parameters),
                        added:Date.now()
                    }
                }
                return cache[action].res
            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $translate, msNavigationService,AuthService)
    {
        var vm = this;
        function getCrumbs() {
            var state = $state.$current
            var crumbs=[]
            while (state ) {
                var title=state.data && state.data.Title
                if(title) {
                    crumbs.unshift({Title:title,state:state.name})
                } else {
                    var name = state.name.split('.')
                    if(name.length>1) {
                        name=name[name.length-1]
                        if(name && name != 'f') {
                            crumbs.unshift({Title:name.capitalize(),state:state.name})
                        }
                    }
                }
                state=state.parent
            }
            return crumbs
        }
        vm.crumbs=getCrumbs()
        $rootScope.$on('$stateChangeSuccess',function() {
            vm.crumbs=getCrumbs()
        })
        // Data
        $rootScope.global = {
            search: ''
        };
        AuthService.getUser().then(function(user) {
            vm.user=user
        })
        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.isAdmin = function() { return AuthService.isAdmin() }
        vm.selectUser=function() {
            var  user = parseInt(vm.selected_user)
            if (isNaN(user)) { return AuthService.selectUser() }
            return AuthService.selectUser(user)
        }
        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            //$mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            AuthService.logout(function () { } )
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';
                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
    }

})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',
            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Info
            'app.info',

            // admin
            'app.admin',

            // admin
            'app.search',

            // Quick Panel
            'app.quick-panel'


            ,'app.auth',

            // start
            'app.start',

            // start
            'app.campaign',

            // dashboard
            'app.dashboard',

            // websites
            'app.website',

            // upgrades
            'app.upgrade',

            // Services
            // WooAdmin
            ,'app.services'

            // messages
            ,'app.messages'

            // Userinfo
            ,'app.userinfo'

            // Userinfo
            ,'app.woolinks'

            // Translations
            ,'app.mytranslations'

            // Wooapps
            ,'app.wooapps'

            // Domains
            ,'app.domains'

            // Domains
            ,'app.dnszone'

            // Email
            ,'app.email'

            // File access
            ,'app.fileaccess'

            // File access
            ,'app.backups'

            // Usage
            ,'app.usage'

            // Speedtest
            ,'app.speedtest'
            
            // Blueprints, disable for now
            ,'app.blueprints'

            // Log
            ,'app.log'

            // Language Options
            ,'app.langoptions'

            // sharing
            ,'app.sharing'

            // Options
            ,'app.options'
            // Commands
            ,'app.commands'

            // Incidents
            ,'app.incident'

            // Wordpress
            ,'app.wordpress'
            ,'app.wpobject'

            // Servers
            ,'app.host'

            // vulnerabilities
            ,'app.vuln'

            // Version check
            ,'app.vcheck'

            // Woo
            //,'app.help'

            // Woo
            ,'app.menu_items'

            // Woo
            ,'app.utils'
            // WooAdmin
            ,'app.wooadmin'


            ,'app.graphs'

            ,'app.settings'

            // Directives
            ,'app.wtMessage'
            ,'app.wtField'
            ,'app.wtForm'
            ,'app.wtText'
            ,'app.wtInfo'
            ,'app.wtIcon'
            ,'app.wtTooltip'
            ,'app.wtRenewalDate'
            ,'app.wtHelpButton'
            ,'app.wtPlanQuiz'
            ,'app.wtDropdownButton'
            ,'app.wtColumnConfig'
            ,'app.wtWhois'
            ,'app.wtBreadcrumbs'
            ,'app.wtDomainStatusBadge'
            // Woo
            ,'app.helpPage'

            // Authentication
            ,'ngPassword'
            ,'ngMyPasswordGenerator'

            // Other
            ,'angular-blocks'
            ,'angularjs-datetime-picker'

            //,'material.components.expansionPanels'
            ,'ngOnload'

            ,'ngclipboard'
            ,'app.loaders'
            ,'ui.select','infinite-scroll',
            ,'ui.bootstrap'
            ,'ui.gravatar'
            //,'rzSlider'
            ,'base64'
            //,'googlechart'//,'googlechart-docs'
            /**/
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('TrackingController', controller);

    /** @ngInject */
    function controller($cookies,$scope,$sce,AuthService,UserInfo)
    {
        var vm = $scope;
        vm.hello='Hello'
        vm.trackers=[]
        AuthService.getAccount(function(user) {
            var tduid=$cookies.get('tduid')
            if (tduid && user && (!user.tracked || user.tracked.indexOf('tradedoubler='+tduid)<0)) {
                vm.user=user
                if (tduid) {
                    //debugger
                    var url='https://tbl.tradedoubler.com/report?organization=2199777&event=387067&leadNumber='
                    url += vm.user.externalID+'&tduid='+tduid+'&type=iframe'
                    var tracker={
                        name:'tradedoubler',
                        src:'app/tracking/tradedoubler.html',
                        url:$sce.trustAsResourceUrl(url)
                    }

                    vm.tradeDoublerLoaded=function() {
                        //alert('tracked')
                        // Save tracked status
                        user.tracked = user.tracked || []
                        user.tracked.push('tradedoubler='+tduid)
                        vm.user.$save({user_id:vm.user._id},function() {})
                    }

                    vm.trackers.push(tracker)
                }
            }
            var signup='AW-740181756/B3ntCJ_s5J8BEPyN-eAC'
            if (user && (!user.tracked || user.tracked.indexOf(signup)<0)) {
                gtag('event', 'conversion', {
                  'send_to': signup,
                  'event_callback': function() {
                      user.tracked = user.tracked || []
                      user.tracked.push(signup)
                      user.$save({user_id:user._id},function() {
                          console.log('tracked signup',signup);
                      })
                  }
                });
            }
            UserInfo().then(function(ui) {
                var purchase='AW-740181756/AIkPCND9758BEPyN-eAC'
                /*debugger
                console.log('UserInfo',ui.data);*/
                if (ui && ui.data && ui.events && ui.events['order:complete'] && user &&  (!user.tracked || user.tracked.indexOf(purchase)<0)) {
                    gtag('event', 'conversion', {
                        'send_to': purchase,
                        'value': 100.0,
                        'currency': 'SEK',
                        'transaction_id': '',
                        'event_callback': function() {
                            user.tracked = user.tracked || []
                            user.tracked.push(purchase)
                            user.$save({user_id:user._id},function() {
                                console.log('tracked purchase',signup);
                            })
                        }
                    });
                }
            })
        })
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);


    /** @ngInject */
    function MainController($scope, $rootScope, AuthService)
    {
        var vm=this
        // Data
        AuthService.getUser().then(function(u) {
            vm.isAdmin = AuthService.isAdmin()
        })
        //////////
        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
            /*
            WebFont.load({
                google: {
                    families: ['Material Icons']
                        //https://fonts.googleapis.com/icon?family=Material+Icons
                }
            });
            */
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.search', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        //$translatePartialLoaderProvider.addPart('app/toolbar');
        return
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.search')
        .controller('SearchController', Controller);


    /** @ngInject */
    function Controller($http,$state,$document,$scope,$q,AuthService)
    {
        var vm=this
        vm.isAdmin = AuthService.isAdmin()
        vm.search=function( q ) {
            var deferred=$q.defer()
            if (!q) {
                return null
            }
            $http({url:API_HOST+'/api/search?q='+window.encodeURIComponent(q)})
            .then(
                function(response) {
                    deferred.resolve(response.data)
                },
                function(err) {
                    deferred.reject(err)
                }
            )
            return deferred.promise
        }
        vm.searchResultClick=function(arg) {
            if (arg && arg.id) {
                var state="app." + (arg.type||'website')+ ".details"
                // debugger
                if (arg.type && ['website','domain','emailaddress','accesskey','backup'].indexOf(arg.type)<0) {
                    state="app.wooadmin." + arg.type + "-edit"
                }
                if(arg.user != AuthService.selectedUser()) {
                    AuthService.selectUser(arg.user,function() {
                        setTimeout(function () { $state.go(state,{id:arg.id}) },1)
                    })
                    return
                }
                setTimeout(function () { $state.go(state,{id:arg.id}) },1)
            }
            //alert("Result clicked: "+arg.title)
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi,$rootScope)
    {
        var vm = this;

        vm.toggleLocked = function () {
            //console.log('toggleLocked',$rootScope.lockHelpOpen);
            if ($rootScope.lockHelpOpen) {
                $rootScope.lockHelpOpen=false
                //$('#quick-panel').removeClass('quick-panel-locked')
            } else {
                //$('#quick-panel').addClass('quick-panel-locked')
                $rootScope.lockHelpOpen=true
            }
        }
        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

/*
        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );
*/
        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope,$rootScope,$translate,$state,Languages,AuthService,UserInfo)
    {
        var vm = this;

        vm.isAdmin = AuthService.isAdmin();
        vm.logo='/assets/logos/templ-logo-white.svg?v=2021'
        UserInfo().then(function (info) {
            var custom_panel=info.getCustomPanel()
            var logo = custom_panel&&custom_panel.icons&&custom_panel.icons.find(function(icon){return icon.name='main'})
            if(logo) {
                vm.logo=logo.url
                vm.custom_logo=true
            }
        })
        vm.betaPanel = window.location.href && window.location.href.match(/betapanel.templ.io|test.templ.io/) ? true : false
        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        var host='https://'+ (MAIN_HOST||'templ.io')
        vm.main_site=host
        var lang=$translate.use()
        if(lang!='en') {
            vm.main_site=host+'/'+lang
        }
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        vm.set_account_url=function() {
            var lang = $translate.use()
            var account = (lang=="en"?"":lang+"/")+'my-account/'
            vm.my_account_url=host+'/'+account
        }
        vm.set_account_url()
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.set_account_url()
        })
        vm.user_name='John Doe'
        AuthService.getUser().then(function(user) {
            vm.user_name=user.name.first+' '+user.name.last
            vm.user_email=user.email
            vm.user_initials=user.name.first.charAt(0)+user.name.last.charAt(0)
            vm.user_first_name=user.name.first
        })
        vm.switch_language=function(to) {
            console.log('navigation.switch_language',to);
            var used=$translate.use()
            to=to||used
            vm.languages=[]
            angular.forEach(Languages,function(l){
                //console.log(l);}
                if(l.code!=to) {
                    vm.languages.push(l)
                }
            })
            if(to!=used) {
                $state.go('app.langoptions',{lang:to})
                var event = new Event('switch_language')
                event.to=to
                document.body.dispatchEvent(event)
            }
        }
        vm.switch_language()
        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
        var l = $rootScope.$on('$translateChangeSuccess', function (event,args) {
            var lang=args.language
            if(lang!='en') {
                vm.main_site=host+'/'+lang
                return
            }
            vm.main_site=host
        })
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.info', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/info');
        return
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.info')
        .controller('InfoController', Controller);


    /** @ngInject */
    function Controller($state,$document,$interval,$scope,$rootScope,wtUtils,cachedMessages)
    {
        var vm=this
        var body = $document.find('body'),
            bodyClass = 'info-active';
        vm.action=function(a) {
            $state.go(a.state)
        }
        vm.get_messages=function() {
            vm.messages=vm.res && vm.res.getPosition('info-bar')
            vm.popups=vm.res && vm.res.getPosition('popup')
            vm.show_popup()
        }
        vm.show_popup=function(){
            if (vm.popups && vm.popups.length>0) {
                var p=vm.popups.shift()
                wtUtils.alert({title:p.title,body:p.body},function() {
                    vm.show_popup()
                })
            }
        }
        vm.load=function() {
            var p=cachedMessages();
            p.then(function(res){
                vm.res=res
                vm.get_messages()
            })
        }
        vm.load()
        $rootScope.$on('$messagesChangeEvent', function (event)
        {
            vm.load()
        })
        vm.message_color=function(m) {
            if (m.type=='warning') {
                return 'default-warn-400'
            }
            if (m.type=='info') {
                return 'default-accent-400'
            }
            return 'default-primary-600'
        }
        return
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.help-panel', ['app.auth'])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/help-panel');

        msApiProvider.register('helpPanel.notes', ['app/data/help-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.help-panel')
        .controller('HelpPanelController', HelpPanelController);

    /** @ngInject */
    function HelpPanelController(msApi,$location,$rootScope,$scope,$timeout,$http,AuthService)
    {
        var vm = this;
        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        vm.global=$rootScope
        vm.chat_frame = {
            id:'help-chat-frame'
            //,initial:"/assets/chat/index.html"
            ,history:[]
            ,loading:true
        }
        vm.help_frame = {
            id:'help-page-frame'
            //,initial:'wootemple-initial-setup-guide'
            //,initial:"/assets/test.html"
            ,posts:{}
            ,history:[]
            //,loading:true
        }
        vm.frames=[vm.chat_frame,vm.help_frame]

        vm.initFrames = function () {
            for (var i=0; i<vm.frames.length; i++) {
                var frame=vm.frames[i]
                if (!frame.container) {
                    frame.container=$(document.getElementById(frame.id))
                    if(frame.initial) {
                        vm.loadPost(frame,frame.initial)
                        frame.history.push({slug:frame.initial})
                        frame.history_ix=0
                    }
                }
            }
        }
        $timeout(function () {
            vm.initFrames()
        },500);

        vm.wp_post_api='https://wootemple.com/wp-json/wp/v2/posts?slug='
        vm.loadPost=function(frame,slug,hash) {
            if(!slug) { return }
            if (frame.posts[slug]) {
                return vm.display_post(frame,slug,hash)
            }
            frame.loading=true
            $http.get(vm.wp_post_api+slug).then(function(res) {
                var post=res.data[0]
                frame.posts[slug]=post;
                vm.display_post(frame,slug,hash)
            })
        }

        vm.push_history = function(frame,slug,hash) {
            frame.history_ix += 1
            while(frame.history.length>frame.history_ix) {
                frame.history.pop()
            }
            frame.history.push({slug:slug,hash:hash})
            console.log(frame.history[frame.history_ix]);
        }
        vm.scroll_to_hash=function(frame,hash) {
            var container=frame.container
            var scrollTop=0
            if(hash) {
                var elem=container.find(hash)
                scrollTop = elem.offset().top-container.offset().top+container.scrollTop()
            }
            container.animate({
                scrollTop: scrollTop
            })
            frame.current_hash=hash
        }
        vm.display_post=function(frame,slug,hash) {
            var post=frame.posts[slug]
            frame.container.html($('<h1 class="wp-post-title">').html(post.title.rendered))
            var content=$('<div class="wp-post-content">').html(post.content.rendered)
            $('a',content).click(function(ev) {
                //alert("clicked "+this)
                if(this.hostname!=$location.host()) {
                    window.open(this.href, '_blank');
                } else {
                    var slug=this.pathname.replace(/^\/+|\/+$/g, '');
                    if (slug && slug.length && slug!=frame.current) {
                        vm.loadPost(frame,slug,this.hash)
                        vm.push_history(frame,slug,this.hash)
                    } else if (this.hash) {
                        if(this.hash!=frame.current_hash) {
                            vm.push_history(frame,frame.current,this.hash)
                        }
                        vm.scroll_to_hash(frame,this.hash)
                    }
                }
                ev.preventDefault()
                return false
            })
            frame.container.append(content)
            if (slug && slug.length) {
                frame.current=slug
            }
            vm.scroll_to_hash(frame,hash)
            frame.loading=false
        }

        vm.chat_tab_changed=function(selected) {
        }

        vm.load_history=function(frame) {
            var hitem=frame.history[frame.history_ix]
            console.log(hitem);
            if (hitem.slug && hitem.slug.length) {
                vm.loadPost(frame,hitem.slug,hitem.hash)
            } else if (hitem.hash) {
                vm.scroll_to_hash(frame,hitem.hash)
            } else {
                return
            }
        }
        vm.frame_back=function(frame) {
            if (!frame.loading && frame.history_ix>0) {
                frame.history_ix -= 1
                vm.load_history(frame)
            }
        }
        vm.frame_forward=function(frame) {
            if (!frame.loading && frame.history_ix<frame.history.length-1) {
                frame.history_ix += 1
                vm.load_history(frame)
            }
        }
        vm.frame_reload=function(frame) {
            if(!frame.current) {return}
            if (vm.posts[frame.current]) {
                delete vm.posts[frame.current]
            }
            vm.loadPost(frame,frame.current,frame.current_hash)
        }
        vm.close=function() {
            $rootScope.lockHelpOpen=false;
            //$mdSidenav('help-panel').toggle();
        }
        vm.toggle=function() {
            $rootScope.lockHelpOpen=!$rootScope.lockHelpOpen;
            if(!$rootScope.lockHelpOpen) {
                // $mdSidenav('help-panel').toggle();
            }
        }
        msApi.request('helpPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/admin');
        return
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('AdminController', Controller)
        .factory('SharingService', Service)
        .constant('AdminCache', {sharings:null});

    function Service(AdminCache,AuthService) {
        return {
            getSharing: function (user) {
                return user && AdminCache.sharing_docs && AdminCache.sharing_docs.sharings && AdminCache.sharing_docs.sharings[user]
            }
        }
    }

    /** @ngInject */
    function Controller($rootScope,$state,$cookies,$scope,SharingLoader,wtUtils,AdminCache,WooSharing,SharingName,AuthService,CachedUserInfo,$translate)
    {
        var vm=this
        vm.selected_user=AuthService.selectedUser()
        vm.isAdmin = function() { return AuthService.isAdmin() }
        //vm.user=AdminCache.user
        //vm.sharings=AdminCache.sharings

        vm.get_sharing_name=function(obj) {
            return SharingName(vm,obj)
        }
        // Old function, only for reference, no longer used
        vm.load_shares=function() {
            var user=vm.user
            if(!user) { return }
            WooSharing.query({transitive_shared_with:user.acctId},function (res) {
                res=res&&res.docs || res
                if (res && res.length==0) {
                    res=null
                }
                AdminCache.sharings=vm.sharings=res && res.docs || res
                _.each(vm.sharings,function(obj){
                    SharingName(vm,obj)
                })
            })
        }
        vm.sharing_docs= AdminCache.sharing_docs || {
            sharings:{},
            docs:[],
            select:['shared_by','request','share_all'],
            res:function(res) {
                if(!vm.sharing_docs.initial_length) vm.sharing_docs.initial_length=res&&res.length
                res= _.map(res,function(obj){
                    SharingName(vm,obj)
                    vm.sharing_docs.sharings[obj.shared_by]=obj
                    return {
                        name: obj.translate_values.sender_email,//$translate.instant(obj.name,obj.translate_values),
                        value: obj.shared_by
                    }
                })
                return res
            }
        }
        vm.refresh_select=function(search,scrolling) {
            vm.get_user(function(user) {
                //debugger
                var docs=vm.sharing_docs
                docs.user=docs.user||user.acctId||user
                docs.args=docs.args||{transitive_shared_with:user.acctId}
                AdminCache.sharing_docs = docs
                SharingLoader(docs,search,scrolling)
            })
        }
        vm.get_user=function(next) {
            if (vm.user) return next && next(vm.user)
            vm.setup_user(next)
        }
        vm.check_sharing=function(c) {
            // Ensure selected user is among the options
            if(!vm.sharing_docs.docs.find(function(s) { return s.value == c })) {
                // Load the sharing, if it exists
                WooSharing.query({shared_by:c}).$promise.then(function(res) {
                    var doc = res && res.docs && res.docs[0]
                    var sender = doc && doc.request && doc.request.sender_email
                    //console.log('hello',sender);
                    var docs=vm.sharing_docs.docs
                    var opt={value:parseInt(c),name:sender}
                    if(!docs.length || docs[0].value)
                        docs.unshift(opt)
                    else // The first option is My Account which should stay
                        docs.splice(1,0,opt)
                })
            }
        }
        vm.setup_user = function (next) {
            AuthService.getUser().then(function(user) {
                AdminCache.user=vm.user=user
                if(!vm.sharing_docs.extra_docs&&false) {
                    var name = "ADMIN.MY_ACCOUNT"//wtUtils.translate("ADMIN.MY_ACCOUNT")
                    var me={value:0,name:name}
                    vm.sharing_docs.extra_docs=[me]
                    if(!vm.selected_user) vm.selected_user=0
                    if(vm.sharing_docs.docs && vm.sharing_docs.docs.length>0)
                        vm.sharing_docs.docs.unshift(me)
                }

                if(next) next(user)
                if (!vm.selected_user) {
                    var c=$cookies.get('templio_selected_user')
                    if (c) {
                        vm.selected_user=c
                        vm.selectUser(function() {
                            vm.watch_selected()
                        })
                    } else {
                        vm.watch_selected()
                    }
                } else {
                    vm.watch_selected()
                }

                //vm.load_shares()
                CachedUserInfo().then(function(info) {
                    vm.user_info=info.data._id
                })
            })
        }
        if(vm.isAdmin()) vm.get_user()
        vm.update_cookie=function(user) {
            if(user) {
                $cookies.remove('templio_selected_user')
                $cookies.put('templio_selected_user',user,{domain:'.templ.io'})
            } else {
                $cookies.remove('templio_selected_user')
                $cookies.remove('templio_selected_user',{domain:'.templ.io'})
            }
        }
        vm.selectUser=function(next) {
            var  user = parseInt(vm.selected_user)
            if (isNaN(user)) {
                user=null
            }
            AuthService.selectUser(user,function(err,user) {
                if(!err) vm.update_cookie(user)
                if(user) vm.check_sharing(user)
                $state.reload()//($state.current.name,$state.params,{reload:true})
                if(next) next()
            })
        }
        wtUtils.add_listener($scope,$rootScope.$on('user:changed', function (event)
        {
            var user=AuthService.selected_user
            if(vm.selected_user!=user) {
                console.log('selected user changed');
                vm.selected_user=user
                if(vm.isAdmin()) {
                    vm.update_cookie(user)
                    $state.transitionTo($state.current.name,$state.params,{reload:true})
                }
            }
        }))
        vm.confirm=function(title,text) {
            return wtUtils.confirm({title:title,text:text})
        }

        vm.watch_selected=function() {
            if (!vm.isAdmin()) {
                $scope.$watch('vm.selected_user',function(newval,oldval){
                    //debugger
                    oldval=oldval||null
                    newval=newval||null
                    if ((newval!=oldval) && !vm.cancelled) {
                        // vm.confirm("ADMIN.CONFIRM_TITLE","ADMIN.CONFIRM_MESSAGE").then(function() {
                        //     setTimeout(function() {vm.selectUser()},100)
                        // },function() {
                        //     //alert('cancelled')
                        //     vm.selected_user=oldval
                        //     vm.cancelled=true
                        // })
                        vm.selectUser()
                    } else {
                        vm.cancelled=false
                    }
                })
            }
        }
        vm.isAgency = AuthService.isAgency()
        vm.getRegisterAccountUrl = function() {
            return wtUtils.getRegisterAccountUrl()
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock)
        //.run($trace => $trace.enable("TRANSITION"))

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $location, LoginUrl, ChatService)
    {
        // Chat launchers embedded inside translated i18n strings can't use the
        // chat-launcher directive ($compile doesn't run on ng-bind-html output),
        // so they carry the .chat-launcher class and rely on this delegated click.
        $(document).on('click', '.chat-launcher', function (evt)
        {
            evt.preventDefault();
            ChatService.open();
        });

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (evt, to, params)
        {
            if (to.redirectTo) {
              evt.preventDefault();
              if (to.redirectTo!=$state.current.name || to.redirectAlwaysEnter ) {
                  $state.go(to.redirectTo, params)
              }
              return
            }
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (evt)
        {
            var to = $state.current
            if (to.redirectAfter) {
                evt.preventDefault();
                $state.go(to.redirectAfter, to.params, {location:'replace'})
                return
            }
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        $rootScope.$on('$stateChangeError',
        function(event, toState, toParams, fromState, fromParams, error){
                // this is required if you want to prevent the $UrlRouter reverting the URL to the previous valid location
                event.preventDefault();
                console.log("stateChangeError");

                //if ()$location.url(LoginUrl);
        })
    }
})();

(function ()
{
    'use strict';

    var MainHost = MAIN_HOST || 'templ.io';
    var LoginUrl = "https://"+MainHost+"/oauth/";
    var LogoutUrl = "https://"+MainHost+"/htuao/";

    angular
        .module('fuse')
        .config(routeConfig)
        .constant('MainHost',MainHost)
        .constant('LogoutUrl',LogoutUrl)
        .constant('LoginUrl',LoginUrl)
        .constant('GlobalCache',{})
        .constant('UrlAfterLogin',{});

    var startUrl='/start'

    //app.run($trace => $trace.enable())
    /** @ngInject */
    function routeConfig($stateProvider, $cookiesProvider, $urlRouterProvider, $locationProvider,$httpProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise(startUrl);

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';
        layoutStyle = 'verticalNavigation';
        //layoutStyle = 'horizontalNavigation'
        //layoutStyle = 'verticalNavigationFullwidthToolbar'

        var layouts = {
            verticalNavigation  : {
                info      : 'app/info/info.html',
                admin      : 'app/admin/bar.html',
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                admin     : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'mobile-header@app': {
                        templateUrl: 'app/core/layouts/mobile-header.html',
                        controller : 'NavigationController as vm'
                    },
                    'search@app':{
                        templateUrl: 'app/search/search.html',
                        controller : 'SearchController as vm'
                    },/**/

                    'info@': {
                        templateUrl: layouts[layoutStyle].info,
                        controller : 'InfoController as vm'
                    },/**/
                    'admin@': {
                        templateUrl: layouts[layoutStyle].admin,
                        controller : 'AdminController as vm'
                    },/**/
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    },
                },/**/
                resolve: {
                    UserReady: ['AuthService','$q', '$location','GlobalCache', function (Auth,$q,location,cache)
                    {
                        if(!cache.initial_url) {cache.initial_url=location.url()}
                        var deferred=$q.defer()
                        Auth.getUser().then(function() {
                            //alert("Translations ready")
                            $q.resolve(true)
                        })
                        return $q.promise
                    }]
                }/**/
            })
            .state('appf', {
                url: '/f',
                abstract: true,
                views  : {
                    'main@'                       : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'admin@': {
                        templateUrl: layouts[layoutStyle].admin,
                        controller : 'AdminController as vm'
                    },/**/
                },/**/
                resolve: {
                    UserReady: ['AuthService','$q', '$location','GlobalCache', function (Auth,$q,location,cache)
                    {
                        var deferred=$q.defer()
                        if(!cache.initial_url) {cache.initial_url=location.url()}
                        Auth.getUser().then(function() {
                            //alert("Translations ready")
                            $q.resolve(true)
                        })
                        return $q.promise
                    }]
                }/**/
            });

            $httpProvider.defaults.withCredentials = true;

            $httpProvider.interceptors.push(function($q, $window, $cookies, $location, UrlAfterLogin,GlobalCache) {
                  return {
                    response: function(response) {
                        // do something on success
                        return response;
                    },
                    responseError: function(response) {
                        ///http://test.templ.io:3000/f/sharing/accept/2jGsLToMoLkeYnb3ueJVsdVdQmwHDTVCRtlWqFuJLt7?dir=share_with
                        if (response.status === 401 && !(
                            response.config && response.config.ignore_auth_failure
                        )) {
                            console.log("Auth failure")
                            //UrlAfterLogin.url=$location.url()
                            // Expire after 1 hour
                            var current=$location.url()
                            if (current==startUrl && GlobalCache.initial_url) current=GlobalCache.initial_url
                            if (current!=startUrl && current!='/') {
                                var expires=new Date(Date.now()+3600000)
                                $cookies.put('woopanel_url_after_login',current,expires)
                            }
                            $window.location.href=LoginUrl
                            //$location.url(LoginUrl);
                        }
                        return $q.reject(response);
                    }
                  };
              })


    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming,AuthService)
    {
        var vm = this;
        vm.lightSplash=window.location.hash && window.location.hash.match("^#(/register/thankyou|/transfer/thankyou)")?true:false
        // Data
        vm.themes = fuseTheming.themes;
        vm.logout=function(){
            AuthService.logout(function () { } )
        }
    
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config)
        .filter('truncate', function () {
            return function (value, max, tail) {
                var wordwise=true
                if (!value) return '';
                max = parseInt(max, 10);
                if (!max) return value;
                if (value.length <= max) return value;

                value = value.substr(0, max);
                if (wordwise) {
                    var lastspace = value.lastIndexOf(' ');
                    if (lastspace != -1) {
                        value = value.substr(0, lastspace);
                    }
                }
                return value + (tail || ' …');
            };
        });

    /** @ngInject */
    function config($compileProvider, $translateProvider,$translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|ssh|sftp):/);
        // Angular before v1.2 uses $compileProvider.urlSanitizationWhitelist(...)

        // Put your common app configurations here
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get language layout
        var lang = $cookies.get('tepmlio_language') || 'en';
        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json?version=20260904'
        });
        $translateProvider.preferredLanguage(lang).fallbackLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
        $translatePartialLoaderProvider.addPart('app/main');
    }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource) {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

}());
(function ()
{
    'use strict';

    angular
        .module('app.wpobject', ['app.wooadmin'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,
        Models)
    {
        var model = Models['WPObject']
        var sub_data={
            //populate:['domain','operation']
        }
        var filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            },
            { name:"Plugin", label: "Plugins", field:'kind', kind:'checkbox',multi:true, checked:true},
            { name:"Theme", label: "Themes", field:'kind', kind:'checkbox',multi:true, checked:true},
            { name:"WPVersion", label: "WP Versions", field:'kind', kind:'checkbox',multi:true, checked:true},
        ]
        var site_filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            }
        ]
        // State
        $stateProvider
            .state('app.'+model.name, {
                url    : '/'+model.name,
                redirectTo: 'app.'+model.name+'.list'
            })
            .state('app.'+model.name+'.list', {
                url    : '/list/:page',
                params : {page: null},
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/wooadmin/models/modellist.html',
                        controller : 'WPObjectListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    List: ['$stateParams','wtUtils',model.model,'WooModelListResolver',function(params,utils,app,resolver) {
                        return resolver(app,params,{
                            query:{user:'all'},
                            filters:filters
                        })
                    }],
                    CountUnfiltered: ['$stateParams',model.model,'WooModelListResolver',function(params,app,resolver) {
                        return resolver(app,params,{
                            __count_only__:true
                        })
                    }]
                },
                data : {
                    form_type: 'user'
                    ,model:model
                    ,filters:filters
                }

            })
            .state('app.'+model.name+'.details', {
                url     : '/details/:id/:page',
                params  : {id:null,page:'1'},
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : 'WPObjectController',
                        controllerAs:'vm'
                    },
                    'website_list@app.wpobject.details': {
                        templateUrl: 'app/main/wooadmin/models/modellist.html',
                        //templateUrl: 'app/main/dnszone/records.html',
                        controller : 'WPSitesController as vm'
                    },
                },
                resolve: {
                    Object:[
                        '$stateParams',model.model,'WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{
                                //populate:['operation','domain']
                            })
                        }
                    ],
                    List: ['$stateParams','wtUtils','Object','WPApp','WooModelListResolver',function(params,utils,obj,app,resolver) {
                        var q={user:"all"}
                        if(obj&&obj.kind=='Plugin') {
                            q['plugs.name']=obj&&obj.name
                        } else if(obj&&obj.kind=='Theme') {
                            q['themes.name']=obj&&obj.name
                        } else if(obj&&obj.kind=='WPVersion') {
                            q['version']=obj&&obj.name
                        }
                        return resolver(app,{
                            page:params.page,
                            query:q,
                        },{
                            populate:['app.name'],
                            filters:site_filters
                        })
                    }],
                    Count: ['$stateParams','Object','WPApp','WooModelListResolver',function(params,obj,app,resolver) {
                        var q={user:"all"}
                        if(obj&&obj.kind=='Plugin') {
                            q['plugs.name']=obj&&obj.name
                        } else if(obj&&obj.kind=='Theme') {
                            q['themes.name']=obj&&obj.name
                        } else if(obj&&obj.kind=='WPVersion') {
                            q['version']=obj&&obj.name
                        }
                        return resolver(app,{
                            query:q
                        },{
                            __count_only__:true,select:'_id'
                        })
                    }],
                },
                data: sub_data
            })

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.website')
        .service('WebsiteCopyFrom',copy_from)

        function copy_from(wtUtils, $state) {
            return function (vm) {
                vm.partial_title="WEBSITE.PARTIAL_COPY.TITLE"
                vm.partial_description="WEBSITE.PARTIAL_COPY.DESCRIPTION"
                vm.partial_label="WEBSITE.PARTIAL_COPY.LABEL"
                vm.partial_db_description="WEBSITE.PARTIAL_COPY.DB_DESCRIPTION"
                vm.partial_files_exclude="WEBSITE.PARTIAL_COPY.FILES_EXCLUDE"
                vm.partial_files_include="WEBSITE.PARTIAL_COPY.FILES_INCLUDE"
                vm.partial_files_note="WEBSITE.PARTIAL_COPY.FILES_NOTE"

                vm.copy_continue=function(obj) {
                    obj=obj||vm.obj.copy_from
                    obj.completed=false
                    delete obj.files
                    delete obj.tables
                    if (!obj.partial) {
                        delete obj.exclude_files
                        delete obj.exclude_db
                    } else {
                        if (obj.files_text && obj.files_text.trim()) {
                            obj.files=obj.files_text.split(/\r?\n/)
                        } else {
                            obj.files=[]
                        }
                    }
                }
            }
        }
})();

(function ()
{
    'use strict';

    var default_list_form =  {
        nocheckbox:0
        ,name_field: 'name'
        ,get_name: function (obj) { return obj[this.name_field] }
        ,menu:[]
    }
    function trunc(key,len) {
        return (key.length > len) ? key.substr(0, len) + '...' : key;
    }

    var woo_models={
        WooUser:{model:'WooUser',name:'user',url:'woouser'
            ,list:  {
                name_field:'username',
                filters:[
                    {
                        name:'search',label:'SEARCH',field:'__search__',kind:'search'
                    }
                ]
            }
        }
        ,WooApp:{model:'WooApp',name:'app', url:'wooapp',
            functions:{
                is_container_app:function() {
                    return this.app_type && this.app_type.match('-container-') && !this.is_container_server() && true || false
                },
                is_container_server:function() {
                    return this.app_type && this.app_type.match('-container-server') && true || false
                }
            },
            list:{
                filters:[
                    {
                        name:'search',label:'SEARCH',field:'__search__',kind:'search'
                    }
                ]
            }
        },
        WPApp:{model:'WPApp',name:'wordpress', url:'wpapp',
            functions:{
                get_name:function () {
                    return this.app && this.app.name || this._id
                }
            }
            ,list:{
                get_name:function (obj) {
                    if(obj.get_name) {
                        return obj.get_name()
                    }
                    return woo_models.WPApp.functions.get_name.apply(obj)
                }
                ,filters:[
                    {
                        name:'search',label:'SEARCH',field:'__search__',kind:'search'
                    }
                ]
                ,populate:['app.name']
            }
        },
        WPObject:{model:'WPObject',name:'wpobject', url:'wpobject',
            functions:{
                get_name:function () {
                    return this.title || this.name
                }
            }
            ,list:{
                get_name:function (obj) {
                    if(obj.get_name) {
                        return obj.get_name()
                    }
                    return woo_models.WPObject.functions.get_name.apply(obj)
                }
                ,filters:[
                    {
                        name:'search',label:'SEARCH',field:'__search__',kind:'search'
                    }
                ]
            }
        },
        WPUpdate:{model:'WPUpdate',name:'wpupdate', url:'wpupdate',
            functions:{
                get_name:function () {
                    return this.app.name
                }
            }
            ,list:{
                get_name:function (obj) {
                    if(obj.get_name) {
                        return obj.get_name()
                    }
                    return woo_models.WPUpdate.functions.get_name.apply(obj)
                }
                ,filters:[
                    {
                        name:'search',label:'SEARCH',field:'__search__',kind:'search'
                    },
                    {
                        name:'site',label:"Site",field:'app',kind:'input'
                    }
                ],
                items:['date'],
                item_template:'app/main/wooadmin/models/multilistitem.html',
                populate:['app.name']
            }
        },
        WPVuln:{model:'WPVuln',name:'vuln', url:'wpvuln',
            functions:{
                get_name:function () {
                    return this.title // && this.app.title || this._id
                }
            }
            ,list:{
                get_name:function (obj) {
                    if(obj.get_name) {
                        return obj.get_name()
                    }
                    return woo_models.WooApp.functions.get_name.apply(obj)
                }
                ,filters:[
                    {
                        name:'search',label:'SEARCH',field:'__search__',kind:'search'
                    }
                ]
            }
        },
        TemplHost:{model:'TemplHost',name:'host', url:'containerserver',
            functions:{
                get_name:function () {
                    return this.app && this.app.name || this._id
                }
            }
            ,list:{
                get_name:function (obj) {
                    if(obj.get_name) {
                        return obj.get_name()
                    }
                    return woo_models.WooApp.functions.get_name.apply(obj)
                }
                ,filters:[
                    {
                        name:'search',label:'SEARCH',field:'__search__',kind:'search'
                    }
                ]
                ,populate:['app.name']
            }
        }
        ,WooUpgrade:{model:'WooUpgrade',name:'upgrade',url:'wooupgrade'}
        ,WooBilling:{model:'WooBilling',name:'billing',url:'woobilling'}
        ,WooPricing:{
            model:'WooPricing',name:'pricing',url:'woopricing'
            ,edit_template:'app/main/billing/pricing-template.html'
        }
        ,Discount:{model:'discount',name:'discount',url:'discount'}
        ,Pricing:{model:'WooPricing',name:'pricing',url:'woopricing',is_alias:true}
        ,WooCampaign:{model:'WooCampaign',name:'campaign',url:'woocampaign'}
        ,WooPlan:{name:'plan',url:'wooplan'}
        ,CustomPanel:{model:'custompanel',name:'custompanel',url:'custompanel'}
        ,WooAddon:{name:'addon',url:'wooaddon'}
        ,WooLocation:{name:'location',url:'woolocation'}
        ,WooOperation:{name:'operation',url:'woooperation',form:{fields:['type','model']}}
        ,WooServer:{name:'server',url:'wooserver'}
        ,WooDomain:{model:'WooDomain',name:'domain',url:'woodomain'}
        ,WooDnsZone:{
            model:'WooDnsZone', name:'dnszone',url:'woodnszone',
            functions:{
                get_name:function () {
                    return this.domain
                }
            }
            ,list:{
                get_name:function (obj) {
                    if(obj.get_name) {
                        return obj.get_name()
                    }
                    var by = woo_models.WooDnsZone.functions.get_name.apply(obj)
                    return by;
                }
            }
        }
        ,WooSharing:{
            model:'WooSharing',name:'sharing',url:'woosharing',
            functions:{
                get_name:function () {
                    return 'Shared by: ' + this.shared_by + ' with: ' +this.shared_with
                }
            }
            ,list:{
                get_name:function (obj) {
                    if(obj.get_name) {
                        return obj.get_name()
                    }
                    var by = woo_models.WooSharing.functions.get_name.apply(obj)
                    return by;
                }
            }
        }
        ,Incident:{model:'Incident',name:'incident',url:'incident',
            functions:{
                get_name:function () {
                    return 'INCIDENTS.ADMIN_NAME'
                },
                get_values:function () {
                    var values=this.args ||{}
                    values.user=this.user
                    values.kind=this.kind
                    values.status=this.open?"OPEN":"CLOSED"
                    values.date=this.started
                    return values
                }
            }
            ,list:{
                get_name:function (obj) {
                    if(obj.get_name) {
                        return obj.get_name()
                    }
                    return woo_models.Incident.functions.get_name.apply(obj)
                }
                ,get_values:function (obj) {
                    return woo_models.Incident.functions.get_values.apply(obj)
                }
                ,filters:[
                    {name:'wcheck',label:'Up-check',field:'kind',kind:'checkbox', multi:true, checked:true}
                    ,{name:'website:upcheck',label:'Up-check (new servers)',field:'kind',kind:'checkbox', multi:true, checked:true}
                    ,{name:'checksum:core',label:'Checksum Core',field:'kind',kind:'checkbox', multi:true, checked:true}
                    ,{name:'website:headercheck',label:'Header-check',field:'kind',kind:'checkbox', multi:true, checked:true}
                    ,{name:'website:scantrial',label:'Trial scans',field:'kind',kind:'checkbox', multi:true,checked:true}
                    ,{name:'scheck',label:'Website scan',field:'kind',kind:'checkbox', multi:true, checked:true}
                    ,{name:'scanerr',label:'Website scan',field:'kind',kind:'checkbox', multi:true, checked:true}
                    ,{name:'disk_check',label:'Disk usage',field:'kind',kind:'checkbox', multi:true,checked:true}
                    ,{name:'wp_blog_public',label:'Blog Public',field:'kind',kind:'checkbox', multi:true,checked:true}
                    ,{name:'sslcert:renew',label:'SSL Renewals',field:'kind',kind:'checkbox', multi:true,checked:true}
                    ,{name:'website:emailfail',label:'Email failures',field:'kind',kind:'checkbox', multi:true,checked:true}
                    ,{name:'website:linkcheck',label:'Link checking',field:'kind',kind:'checkbox', multi:true,checked:true}
                    ,{name:'wpvulndb',label:'Vulnerabilities',field:'kind',kind:'checkbox', multi:true}
                    ,{name:'sendgrid_verification',label:'Sengrid verifications',field:'kind',kind:'checkbox', multi:true}
                    ,{name:'dnszone:check',label:'DNS Zone Checks',field:'kind',kind:'checkbox', multi:true}
                    ,{name:'search',label:'SEARCH',field:'__search__',kind:'search'}
                ]
            }
        }
        ,WooEmailAddress: {model:'WooEmailAddress',name:'emailaddress',url:'wooemailaddress'
            ,functions:{
                get_name: function() {
                    var obj=this
                    return obj.name+'@'+obj.domain.name
                }
            }
            ,list: { get_name: function(obj) {
                return obj.name+'@'+obj.domain.name
            } }
        }
        ,WooEmailAccount: {model:'WooEmailAccount',name:'emailaccount',url:'wooemailaccount'}
        ,WooFollowupRule: {
            model:'WooFollowupRule',name:'followuprule',url:'woofollowuprule',
            list:{
                filters:[
                    {
                        name:'search',label:'SEARCH',field:'__search__',kind:'search'
                    }
                ]
            }
        }
        ,WooFollowupEvent: {
            model:'WooFollowupEvent',name:'followupevent',url:'woofollowupevent',
            list:{
                filters:[
                    {
                        name:'search',label:'SEARCH',field:'__search__',kind:'search'
                    }
                ]
            }
        }
        ,WooFollowupCondition: {
            model:'WooFollowupCondition',name:'followupcondition',url:'woofollowupcondition',
            list:{
                filters:[
                    {
                        name:'search',label:'SEARCH',field:'__search__',kind:'search'
                    }
                ]
            }
        }
        ,WooFollowupAction: {
            model:'WooFollowupAction',name:'followupaction',url:'woofollowupaction',
            list:{
                filters:[{
                    name:'search',label:'SEARCH',field:'__search__',kind:'search'
                }]
            }
        }
        ,WooFollowupItem: {model:'WooFollowupItem',name:'followupitem',url:'woofollowupitem'}
        ,WooSSLCert:{name:'ssl-cert',url:'woosslcert'}
        ,WooQuota:{name:'quota',url:'wooquota'}
        ,Option:{
            name:'option',url:'woooption'
            ,list:  {
                filters:[
                    {name:'search',label:'SEARCH',field:'__search__',kind:'search'}
                    ,{name:'WooApp',label:'Websites',field:'model',kind:'checkbox', multi:true, checked:true}
                    ,{name:'WooUInfo',label:'Users',field:'model',kind:'checkbox', multi:true, checked:true}
                ]
            }
        }
        ,OptionGroup:{
            name:'optiongroup',url:'woooptiongroup'
            ,list:  {
                filters:[
                    {name:'search',label:'SEARCH',field:'__search__',kind:'search'}
                    ,{name:'WooApp',label:'Websites',field:'model',kind:'checkbox', multi:true, checked:true}
                    ,{name:'WooUInfo',label:'Users',field:'model',kind:'checkbox', multi:true, checked:true}
                ]
            }
        }
        ,Command:{
            name:'command',url:'command'
            ,list:  {
                filters:[
                    {name:'search',label:'SEARCH',field:'__search__',kind:'search'}
                ]
            }
            ,edit_template:'app/main/commands/admin-template.html'
        }
        ,CommandGroup:{
            name:'commandgroup',url:'commandgroup'
            ,list:  {
                filters:[
                    {name:'search',label:'SEARCH',field:'__search__',kind:'search'}
                ]
            }
        }
        ,WooUInfo:{name:'userinfo',url:'woouinfo'}
        ,WooMessage:{name:'message',url:'woomessage'}
        ,WooAccessKey: {
            model:'WooAccessKey'
            ,name:'accesskey',url:'wooaccesskey'
        }
        ,WooBackup: {
            model:'WooBackup'
            ,name:'backup',url:'woobackup'
            ,functions: {
                get_name: function() {
                    var obj=this
                    if (obj.app) {
                        return obj.app.name
                    }
                    return "Deleted Website (" + obj.name + ")"
                }
            }
            ,list: {
                get_name: function(obj) {
                    //return obj.get_name
                    if (obj.app) {
                        return obj.app.name || obj.name
                    }
                    return "Deleted Website (" + obj.name + ")"
                }
            }
        }
        ,DnsRecord:{
            model:'DnsRecord',name:'dnsrecord',url:'dnsrecord'
        }
        ,Disk:{
            model:'Disk',name:'disk',url:'disk'
        }
        ,Log:{
            model:'Log',name:'log',url:'log'
        }
        ,Migration:{
            model:'Migration',name:'migration',url:'migration'
            ,functions:{
                get_name:function () {
                    return this.src && this.src.name || this._id
                }
            }
            ,list:{
                get_name:function (obj) {
                    if(obj.get_name) {
                        return obj.get_name()
                    }
                    return woo_models.Migration.functions.get_name.apply(obj)
                }
                ,filters:[
                    {name:'completed',label:'Completed',field:'state',kind:'checkbox', multi:true, checked:true},
                    {name:'accepted',label:'Accepted',field:'state',kind:'checkbox', multi:true, checked:true},
                    {
                        name:'search',label:'SEARCH',field:'__search__',kind:'search'
                    }
                ]
                ,populate:['src.name']
            }
        }
        ,DnsVerification:{
            model:'DnsVerification',name:'dnsverification',url:'dnsverification'
        }
    }

    var woo_admin_groups = {
        Hosting: ['WooApp','WooUser','WooDomain','WooEmailAddress','WooEmailAccount','WooQuota','WooAccessKey','WooBackup','WooSharing','Disk']
        ,Followup: ['WooFollowupRule','WooFollowupEvent','WooFollowupAction','WooFollowupCondition','WooFollowupItem','WooMessage']
        ,Other : ['WooOperation','WooUpgrade','WooServer','WooUInfo','WooDnsZone','WooSSLCert','Migration','CustomPanel']
        ,Options : ['Option','OptionGroup']
        ,Commands : ['Command','CommandGroup']
        ,Servers : [{model:'TemplHost',state:'app.host.list'}]
        ,Incidents :['Incident',{model:'WPVuln',state:'app.vuln.list'}]
        ,Billing: ['WooBilling','WooPricing','Discount','WooCampaign','WooPlan','WooLocation','WooAddon']
        ,Wordpress: ['WPApp',{model:'WPObject',state:'app.wpobject.list'},'WPUpdate']
    }

    var deps = []
    for (var l in woo_models) {
        var model=woo_models[l]
        if (!model.name || model.is_alias) {
            continue
        }
        var mod='app.wooadmin.'+model.name
        model.Name = model.name.capitalize()
        model.ModelName=l
        deps.push(mod)
        angular
            .module(mod,[])
            .config(function() {});

    }
    deps.push('app.auth')
    deps.push('bw.paging')
    var module = angular.module('app.wooadmin', deps);

    module.config(['$stateProvider', '$translatePartialLoaderProvider',
        'msApiProvider', 'msNavigationServiceProvider', 'AuthServiceProvider',config])
    .constant('Models',woo_models)
    .constant('DefaultListForm',default_list_form)

    function getUser(vm,args) {
        if (vm.user) {
            args.user=vm.user
        }
        return args
    }

    function op_status(object) {
        if (object && object.operation && object.operation.status=='error' && object.operation.non_fatal) return "error"
        return object_status(object)
    }

    function object_status(object) {
        if (object && object.operation) {
            if(object.operation.complete) {
                if(object.operation.status=='error' && object.operation.non_fatal) return "ok"
                return object.operation.status||"ok"
            } else if (object.operation.type){
                return object.operation.status||"working"
            } else {
                return "unknown"
            }
        }
        return "ok"
    }
    function getArgs(vm,args) {
        if (vm.populate) {
            args.populate=vm.populate
        }
        if (vm.fill) {
            args.fill=vm.fill
        }
        return args
    }

    module.factory('PollOperation',['WaitForOp', 'ErrorDialog', function(WaitForOp,ErrorDialog) {
        return function (vm,obj,next) {
            if (object_status(obj) == "working") {
                console.log('Start polling: '+obj.operation.msgs)
                var waitP = WaitForOp(obj.operation._id|| obj.operation)
                waitP.p.then(function(op) {
                        if (waitP.cancelled) {
                            console.log("Ignoring cancelled poll");
                        } else {
                            console.log("Poll complete");
                            vm.update_object(obj)
                        }
                    },
                    function(err){
                        if (waitP.cancelled) {
                            console.log("Ignoring cancelled poll");
                        } else {
                            if(next) {
                                next("Operation could not complete: " +err)
                            } else {
                                ErrorDialog("Operation could not complete: "+err)
                                obj.operation.type=null
                            }
                        }
                    }
                )
                return waitP
            }
            if(next) {
                next(null,obj)
            }
        }
    }])


    function ListController0(vm)
    {
        var api=vm.api
        var substates=vm.substates
        var state=vm.state
        var poll=vm.poll

        if (!vm.object_callback) {
            vm.object_callback=function(){}
        }

        vm.current_poll={}
        vm.page=state.params.page || 1

        if (vm.scope) {
            vm.scope.$on('$destroy',function() {
                console.log("destroy called");
                for (var i=0; i<vm.objects.length; i++) {
                    var obj=vm.objects[i]
                    if (vm.current_poll[obj._id]) {
                        vm.current_poll[obj._id].cancel()
                    }
                }
            })
        }
        vm.selectedItems = [];
        vm.update_object = function(old) {
            api.get(getUser(vm,getArgs(vm,{obj_id:old._id})), function(obj) {
                var i=vm.objects.indexOf(old)
                if (i>=0) {
                    if (vm.current_poll[old._id]) {
                        vm.current_poll[old._id].cancel()
                    }
                    if(!obj._id) {
                        //object deleted
                        return vm.removeObject(old)
                    }
                    vm.objects[i]=obj
                    vm.object_callback(obj)
                    vm.current_poll[obj._id]=poll(vm,obj)
                }
            })
        }

        if (substates.edit) {
            vm.openEditView = function(event,item) {
                if(event.target.classList.contains('btn-quick-actions') || event.target.classList.contains('wt-dropdown-item')) {
                    return
                }
                state.go(substates.edit,{id:item._id});
            }
        }

        if (substates.create) {
            vm.openCreateView=function (event) {
                state.go(substates.create,{});
            }
        } else {
            vm.openCreateView=function (event) {
                state.go(substates.edit,{});
            }
        }
        vm.deleteItem = function (event,item,force) {
            if (item._id) {
                var name = vm.list.get_name(item)
                if (force) {
                    return api.delete( getUser(vm,{obj_id:item._id}), function (res) {
                        vm.update_object(item)
                    });
                }
                var title="WOOADMIN.CONFIRM_DELETE_TITLE"
                var msg="WOOADMIN.CONFIRM_DELETE_MSG"
                if(vm.delete_title) {
                    msg=vm.delete_title
                }
                if(vm.delete_msg) {
                    msg=vm.delete_msg
                }
                vm.confirm(title,msg).then(function() {
                    api.delete( getUser(vm,{obj_id:item._id}), function (res) {
                        vm.update_object(item)
                    });
                })
            }
        }
        vm.deleteSelectedItems = function (event) {
            vm.confirm("WOOADMIN.CONFIRM_DELETE_TITLE","WOOADMIN.CONFIRM_DELETE_MSG").then(
                function() {
                    for (var i in vm.selectedItems) {
                        vm.deleteItem(event,vm.selectedItems[i],true)
                    }
                }
            )
        }
        vm.toggleSelectItem = function (item,event) {
            if ( vm.selectedItems.indexOf(item) > -1 )
            {
                vm.selectedItems.splice(vm.selectedItems.indexOf(item), 1);
            }
            else
            {
                vm.selectedItems.push(item);
            }
        }
        vm.removeObject = function (obj) {
            // Remove from objects and selectedItems
            vm.remove_item(obj,vm.selectedItems)
            vm.remove_item(obj,vm.objects)
        }
        vm.gotoPage = function(page) {
            state.go(state.current,{page:page})
        }

        vm.exists =  function(item, items) {
            return items.indexOf(item) > -1;
        }
        vm.remove_item =  function(item, items) {
            var ix = items.indexOf(item)
            if (ix > -1) {
                items.splice(ix, 1);
            }
        }

        if (vm.prefix) {
            angular.forEach(['create_button','delete_button'],function(b) {
                if (!vm[b]) {
                    var l=vm.prefix+b.toUpperCase()
                    var t=vm.translate(l)
                    if (t!=l) {
                        vm[b]=l
                    }
                }
            })
        }
        if (vm.res.empty_link) {
            var model=vm.api.prototype.$model()
            vm.empty_link=vm.res.empty_link
            vm.empty_link_text = (vm.prefix || model.name.toUpperCase())+'EMPTY_LINK_TEXT'

        }

        vm.object_status = object_status
        vm.op_status = op_status
    }

    function ListController2(vm) {
        var data=vm.data
        if (data) {
            vm.model=data.model || vm.model
            vm.substates=data.substates || vm.substates
            vm.user=data.user || vm.user
        }

        ListController0(vm)

        if (!vm.list) {
            vm.list={}
            for (var l in default_list_form) {
                vm.list[l]=default_list_form[l]
            }
            if (vm.model) {
                for (var l in vm.model.list) {
                    vm.list[l]=vm.model.list[l]
                }
            }
        }
        vm.init_list=function() {
            var res=vm.res
            vm.items = vm.objects=res.docs
            for (var obj in vm.objects) {
                obj=vm.objects[obj]
                if (!obj._id) { continue }
                if (vm.current_poll[obj._id]) {
                    vm.current_poll[obj._id].cancel()
                }
                vm.current_poll[obj._id]=vm.poll(vm, obj)
                vm.object_callback(obj)
            }
            if (vm.loaded_callback) {
                vm.loaded_callback(vm.objects)
            }
            vm.page_size=res.limit
            vm.total_size=res.total
            vm.total_pages=res.pages
            vm.has_loaded=true
        }
        vm.reload = function (resolver) {
            vm.rootScope.loadingProgress=true
            resolver(vm.api,vm.state.params,{
                populate:vm.populate,
                filters:vm.filters,
                selected_user:vm.selected_user,
                query:vm.query
            }).then(function(res) {
                vm.rootScope.loadingProgress=false
                vm.res=res
                vm.init_list()
            })
        }
        vm.init_list()
    }

    module.factory('WooModelListController',['$state', 'WooModelListResolver', 'PollOperation', 'AuthService', 'wtUtils','$translate', 'SharingService',
        function(state,resolver,poll,auth,utils,$translate,SharingService) {
        return function( vm, data ) {
            vm.translate=utils.translate
            vm.state = state; vm.poll=poll
            vm.user=auth.selectedUser()||auth.user && auth.user.acctId
            vm.real_user=auth.user
            if(vm.user!=vm.real_user) {
                vm.sharing=SharingService.getSharing(vm.user)
                if(vm.sharing && !vm.sharing.share_all) {
                    vm.disable_create=true
                }
            }

            vm.isAdmin=auth.isAdmin()
            for (var l in data) {
                vm[l]=data[l]
            }
            vm.confirm=function(title,text) {
                title = $translate.instant(title)
                text = $translate.instant(text)
                return dialog.show(dialog.confirm().title(title).textContent(text).ok("OK").cancel("Cancel"))
            }
            vm.confirm=function(title,text) {
                title = $translate.instant(title)
                text = $translate.instant(text)
                var ok= $translate.instant("WOOADMIN.OK")
                var cancel= $translate.instant("WOOADMIN.CANCEL")
                //text = '<p class="wt-dialog-text">'+text+'</p>'
                var dafun1,dafun2
                var d=utils.confirm({title:title,text:text,ok:ok,cancel:cancel},function() {
                    dafun1&&dafun1()
                },function () {
                    dafun2 && dafun2()
                })
                return {
                    then:function(f1,f2) {
                        dafun1=f1; dafun2=f2
                    }
                }
            }
            ListController2(vm)
            vm.has_objects=vm.objects&&vm.objects.length>0
            if((vm.filters||vm.list && vm.list.filters) && vm.scope) {
                if (vm.list && vm.list.filters && !vm.filters) {
                    vm.filters=vm.list.filters
                } else if (vm.list && vm.filters) {
                    vm.list.filters=vm.filters
                }
                vm.get_filters=function(kind) {
                    return _.filter(vm.list.filters,function(f){return kind==f.kind})
                }
                if(vm.nof_objects_unfiltered) {
                    vm.has_objects=true
                }
                vm.get_filter_value=function(f) {
                    if (vm.filter_value) {
                        return vm.filter_value(f)
                    }
                    if(f.kind=='input' || f.kind=='select') return f.value
                    return f.name
                }
                // Caching not always useful, since the filter object may be persistent by virtue
                // if it being defined in a module config function.
                //vm.list.filters=utils.getCached(state.current.name) || vm.filters
                //vm.list.filters=utils.getCached(state.current.name) || vm.filters
                var i=0
                var search=_.find(vm.list.filters,function(f) { if (f.kind=='search') return true})
                if(search) {
                    vm.handleKeydown=function(event) {
                        var keyCode = event.keyCode;
                        if ( keyCode == 27 ) {
                            event.preventDefault();
                            search.query=''
                        }
                    }
                }
                vm.filter_changed=function(f) {
                    f.value=vm.get_filter_value(f)
                    if (!f.value && f.kind=='search') f.value=f.query
                    utils.putCache(state.current.name,vm.filters)
                    vm.reload(resolver)
                }
                angular.forEach(vm.filters,function(f){
                    var w='vm.list.filters['+i+'].checked'
                    if (f.kind=='search') w='vm.list.filters['+i+'].query'
                    if (f.kind=='select' || f.kind=='input') w='vm.list.filters['+i+'].value'
                    i += 1
                    vm.scope.$watch(w,function(newval,oldval) {
                        if(newval!=oldval) {
                            vm.filter_changed(f)
                        }
                    })
                })
            }
        }
    }])

    module.factory('WooModelListResolver',['AuthService', 'WooLinks','$q','$rootScope','$translate',
        function(auth,links,$q,$rootScope,$translate) {
            return function(resource,params,data) {
                var args={
                    page:params.page || 1
                    ,page_size:params.page_size||20
                    ,user:data.selected_user||auth.selectedUser()
                }
                if(params.sort) {
                    args.sort=params.sort
                }
                if (params.query || data.query) {
                    angular.forEach(params.query||data.query,function(v,k) {
                        //console.log(v,k);
                        args[k]=v
                    })
                    if(params.query && data.query) {
                        angular.forEach(data.query,function(v,k) {
                            //console.log(v,k);
                            args[k]=v
                        })
                    }
                }
                if (data) {
                    angular.forEach(['user','populate','__count_only__','select'],function(v) {
                        args[v] = data[v] || args[v]
                    })
                    angular.forEach(data.filters,function(f) {
                        if(f.kind=='search' && f.query && f.query.length ) { args[f.field]=f.query}
                        else if(f.kind=='input' && f.value && f.value.length ) { args[f.field]=f.value}
                        else if(f.kind=='select' && f.value) { args[f.field]=f.value}
                        else if(f.checked) {
                            var value=f.value||f.name
                            if (f.multi) {
                                args[f.field]=args[f.field]||[]
                                args[f.field].push(value)
                                return
                            }
                            args[f.field]=value
                        }
                    })
                }
                var deferred=$q.defer()

                var p = resource.query(args).$promise
                links().then(function(data) {
                    p.then(function(res) {
                        var model=resource.prototype.$model()
                        data=data && data[model && model.name]
                        if (data && data.empty_link) {
                            res.empty_link = data.empty_link
                        }
                        deferred.resolve(res)
                    })
                })
                return deferred.promise
            }
        }]
    )
    module.factory('WooModelResolver',[ 'AuthService', function(auth) {
        return function(resource,params,data) {
            if(!params.id) {
                return null
            }
            var args={obj_id:params.id,user:auth.selectedUser()}
            if (data) {
                angular.forEach(['user','populate','fill','select'], function(v) {
                    args[v] = data[v] || args[v]
                })
            }
            return resource.get(args).$promise
        }
    }])
    module.factory('WooFormResolver',['AuthService', 'WooLinks', '$q','$rootScope','$translate', function(auth, links,$q,$rootScope,$translate) {
        return function(resource,params,data) {
            var args={obj_id:params.id,user:auth.selectedUser()}
            if (data) {
                angular.forEach(['user','form_type','paginate_values'], function(v) {
                    args[v] = data[v]||args[v]
                })
            }
            var deferred=$q.defer()
            var p = resource.form(args).$promise
            links().then(function(data) {
                p.then(function(res) {
                    var model=resource.prototype.$model()
                    data=data && data[model && model.name]
                    if (data && data.help_link) {
                        res.help_link = data.help_link
                    }
                    deferred.resolve(res)
                })
            })
            return deferred.promise
        }
    }])
    module.factory('WooResourceResolver',[
        '$state','WooResourceResolvers', function(state,resolvers) {
            return function  (resource,resolver) {
                return resolvers[resolver](resource,state.current.data)
            }
        }]
    )
    module.factory('WooResourceResolvers',[
        'WooModelListResolver','WooModelResolver','WooFormResolver',
        function(list,model,form) {
            return function  () {
                return {
                    list:list,model:model,form:form
                }
            }
        }]
    )

    module.factory('WooModelEditController',[
        '$state','$window','PollOperation','AuthService', 'WooLinks', '$translate','wtUtils','SharingService',
        function(state,win,poll,auth,links,$translate,utils,SharingService) {
            return function(vm,data) {
                links().then(function(data) {
                    vm.links=data
                })
                vm.auth=auth
                vm.msg_level=vm.msg_level||data&&data.msg_level||utils.MSG_LEVEL_INFO;
                vm.show_op=function(op){
                    if(!op) return false
                    op.msg_level=(
                        op.msg_level||
                        op.status=='error'&&utils.MSG_LEVEL_ERROR||
                        op.status=='waiting'&&utils.MSG_LEVEL_WAITING
                    )
                    return op.msg_level>=vm.msg_level
                }
                vm.show_msg=function(msg){
                    return msg.level>=vm.msg_level
                }
                vm.lang=$translate.use() || 'en'
                vm.state=state
                vm.poll=poll
                vm.win=win
                vm.isAdmin=auth.isAdmin()
                vm.user=auth.selectedUser() || auth.user && auth.user.acctId
                vm.real_user=auth.user&&auth.user.acctId
                if (!vm.real_user) {
                    auth.getUser().then(function(u) {
                        vm.real_user=u&&u.acctId
                    })
                }
                if(vm.user!=vm.real_user) {
                    vm.sharing=SharingService.getSharing(vm.user)
                    if(vm.sharing && !vm.sharing.share_all) {
                        vm.disable_delete=true
                    }
                }
                for (l in data) {
                    vm[l]=data[l]
                }
                vm.confirm=function(title,text) {
                    title = $translate.instant(title)
                    text = $translate.instant(text)
                    var ok= $translate.instant("WOOADMIN.OK")
                    var cancel= $translate.instant("WOOADMIN.CANCEL")
                    //text = '<p class="wt-dialog-text">'+text+'</p>'
                    var dafun1,dafun2
                    var d=utils.confirm({title:title,text:text,ok:ok,cancel:cancel},function() {
                        dafun1&&dafun1()
                    },function () {
                        dafun2 && dafun2()
                    })
                    return {
                        then:function(f1,f2) {
                            dafun1=f1; dafun2=f2
                        }
                    }
                }
                return EditController2(vm)
            }
        }]
    )
    function EditController2(vm) {
        var data=vm.data
        if (data) {
            vm.model=data.model||vm.model
            vm.next_state=data.next_state||vm.next_state
            vm.user=data.user||vm.user
            vm.static_form=data.form||vm.static_form
        }
        EditController0(vm)
    }

    function EditController0(vm) {
        var state=vm.state
        var poll=vm.poll
        var api=vm.api
        var next_state=vm.next_state
        if(state&&state.current) {
            var list=state.current.name.split('.')
            if(list.length>2) {
                list=list.slice(list.length-2,list.length)
            }
            vm.id_attr=list.join('-')
        }
        if (!next_state) {
            next_state=function () {
                if (vm.win.history.length>1) {
                    return vm.win.history.back()
                }
                if (state && state.current) {
                    state.go(state.current,{id:state.params.id},{reload:true,location:'replace'})
                }
            }
        } else if (next_state.save && !next_state.cancel) {
            next_state.cancel=function () {
                vm.win.history.back()
            }
        }
        vm.id=vm.id||state.params.id
        vm.show_password={}

        if (vm.scope) {
            vm.scope.$on('$destroy',function() {
                console.log("destroy called");
                if (vm.current_poll) {
                    vm.current_poll.cancel()
                }
            })
        }

        vm.update_object=function () {
            var args=getUser(vm,getArgs(vm,{obj_id:vm.id}))
            api.get(args,function(obj) {
                vm.obj=obj
                vm.init_object(obj)
            })
        }
        vm.init_object=function(obj) {
            vm.status=object_status(obj)
            vm.non_fatal=vm.status=='ok' && op_status(obj)=='error'
            if (vm.current_poll) {
                vm.current_poll.cancel()
            }
            vm.current_poll=poll(vm,obj)
            if (vm.object_callback) {
                vm.object_callback(obj)
            }
            if(vm.form.jsonblob) {
                obj.jsonblob={}
                _.each(form.jsonblob,function(t) {
                    obj.jsonblob[t]=JSON.stringify(obj[t],undefined,2)
                })
            }
        }

        var form=vm.static_form||{}
        if (vm.Form) {
            for (var l in vm.Form) {
                form[l]=vm.Form[l]
            }
        }
        vm.form=form
        vm.form_loaded=true
        if (vm.id) {
            vm.obj=vm.Object
            vm.editing=true;
            vm.save_button= vm.save_button || 'WOOADMIN.SAVE'
            vm.init_object(vm.obj)
        } else {
            vm.obj=new api();
            vm.save_button=vm.save_button || 'WOOADMIN.CREATE'
            for (var l in vm.form.default) {
                vm.obj[l]=vm.form.default[l]
            }
            if (vm.form.alternatives) {
                for (var k in vm.form.alternatives) {
                    k=vm.form.alternatives[k]
                    for (var alt in k) {
                        alt=k[alt]
                        if (alt.default) {
                            for (var d in alt.default) {
                                vm.obj[d]=alt.default[d]
                            }
                        }
                    }
                }
            }
        }

        vm.add_list_element = function(form, obj, field) {
            if (!obj[field]) {
                obj[field]=[]
            }
            if (vm.list_elem_type(form,field) == 'compound') {
                obj[field].push( {} )
            } else {
                obj[field].push( "" )
            }
        }

        vm.init_compound = function(obj,field) {
            if (!obj[field]) {
                obj[field]={}
            }
            return obj[field]
        }
        vm.remove_list_element = function(list,index) {
            if (vm.scope && vm.scope.modelForm) {
                vm.scope.modelForm.$setDirty()
            }
            list.splice(index,1)
        }

        vm.list_elem_type = function(form,field) {
            if (form.subforms && form.subforms[field]) {
                return 'compound'
            }
            return 'simple'
        }

        vm.isValid=false;
        vm.isSaving=false;
        vm.canSave = function () {
            return vm.isValid && !vm.isSaving;
        }

        vm.goto=function(stateOrFun, args) {
            if (angular.isFunction(stateOrFun)) {
                stateOrFun(args)
            } else {
                if (stateOrFun.options) {
                    state.go(stateOrFun.name,args,stateOrFun.options)
                } else {
                    state.go(stateOrFun,args)
                }
            }
        }

        vm.save_as_new = function (next) {
            delete vm.obj._id
            delete vm.id
            vm.save(next)
        }

        vm.save = function (next) {
            vm.isSaving=true;
            var args={}
            var copy=vm.obj
            if (vm.id) {
                args=getArgs(vm,{obj_id:vm.id})
            } else {
                copy=angular.copy(vm.obj)
            }
            copy.$save(getUser(vm,args), function (res) {
                vm.isSaving=false
                if (next) {
                    vm.obj=copy
                    return next(res)
                }
                vm.obj=copy
                if (next_state.save) {
                    vm.goto({name:next_state.save,options:{location:'replace'}}, {id:vm.obj._id});
                } else {
                    vm.goto(next_state)
                }
            },function(err) {
                vm.isSaving=false
                //vm.obj=copy
            });
        }

        vm.cancel = function () {
            vm.goto(next_state.cancel||next_state);
        };
        vm.delete = function (event) {
            if (vm.obj && vm.obj._id) {
                vm.confirm(vm.delete_title||"WOOADMIN.CONFIRM_DELETE_TITLE",vm.delete_text || "WOOADMIN.CONFIRM_DELETE_MSG").then(function() {
                    api.delete( getUser(vm,{obj_id:vm.obj._id}), function (res) {
                        vm.goto(next_state.cancel||next_state);
                    });
                })
            }
        }
        vm.do_action = function(event,action,next) {
            vm.obj[action.value||action.name] = 1
            vm.save(next)
            //alert(action.name)
        }
        vm.includes_option = function(val,options) {
            if (!val) {
                return true
            }
            for(var v in options) {
                v=options[v]
                if ((v.value||v)==(val._id||val)) {
                    return true
                }
            }
            return false
        }
        vm.object_status = object_status
        vm.op_status = op_status
        if(!vm.obj.get_name) {
            vm.obj.get_name=function() {
                if (vm.model && vm.model.list) {
                    if (!vm.model.list.get_name) {
                        vm.model.list.get_name=default_list_form.get_name
                    }
                    return vm.model.list.get_name(this)
                }
                return this.name || this._id
            }
        }
        vm.translate_values= {
            //obj:vm.obj,
            obj_name:vm.obj.get_name()
        }
    }

    for (l in woo_models) {
        var model=woo_models[l];
        module.constant(l+'Model',model)
        if(model.is_alias) continue
        if (model.url) {
            module.factory(l, ['$q', 'wtUtils','$resource','$location','$filter','LoginUrl',l+'Model',
               function($q, wtUtils,$resource,$location,$filter,LoginUrl,model) {
                   function resourceErrorHandler(res) {
                       if(res.data=="Unauthorized") {
                           $location.url(LoginUrl)
                           return $q.reject(res)
                       }
                       var $translate=$filter('translate')
                       var err_title=$translate('ERRORS.ERROR_TITLE')
                       var err_data=$translate(res.data)
                       var ok=$translate('WOOADMIN.OK')
                       wtUtils.alert({title:err_title,body:err_data,ok:ok})
                       return $q.reject(res)
                   }
                   function resourceResponseHandler(res) {
                       //console.log('id:',res.resource._id, 'model:',model);
                       var o=res.resource
                       angular.forEach(model.functions,function(f,key) {
                           o[key]=f
                       })
                       return res.resource
                   }
                   function resourceListResponseHandler(res) {
                       //console.log('id:',res.resource._id, 'model:',model);
                       angular.forEach(res.resource.docs,function(o,ix) {
                           angular.forEach(model.functions,function(f,key) {
                               o[key]=f
                           })
                       })
                       return res.resource
                   }
                   function resourceFormResponseHandler(res) {
                       //res.resource.links
                       return res.resource
                   }
                   var icpts={
                       responseError : resourceErrorHandler
                       , response: resourceResponseHandler
                   }
                   var icpts_list={
                       responseError : resourceErrorHandler
                       , response: resourceListResponseHandler
                   }
                   var r=$resource(API_HOST+'/api/'+model.url+'/:obj_id',
                        {},
                        {
                            get: {method:'GET', interceptor : icpts}
                            ,query: {method:'GET', interceptor : icpts_list,
                                /*,transformRequest:function(a) {
                                    console.log('hello');
                                }*/
                            }
                            ,query2: {
                                method:'GET',
                                interceptor : {
                                    response:resourceListResponseHandler
                                },
                                cancellable:true,
                            }
                            ,save: {method:'POST', interceptor : icpts}
                            ,delete: {method:'DELETE', interceptor : icpts}
                            ,form: {
                                method:'GET', params:{query_type:'form'},
                                interceptor: {
                                    responseError : resourceErrorHandler,
                                    response: resourceFormResponseHandler
                                }
                            },
                            update: { method: 'PUT' },   // add this

                        }
                    );
                    r.prototype.$model=function(){
                        return model
                    }
                    return r
               }
             ])
         }
     }

     function add_refs(form) {
         form.edit_ref=form.edit_ref||{}
         _.each(form.ref_model,function (t,k) {
             if(woo_models[t])
                form.edit_ref[k]='app.wooadmin.'+woo_models[t].name+'-edit'
         })
         _.each(form.subforms,function(f,k) {
             add_refs(f)
         })
     }
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,
        msApiProvider, msNavigationServiceProvider,AuthServiceProvider)
    {
        // State
        $stateProvider
            .state('app.wooadmin', {
                url    : '/wooadmin',
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/wooadmin');

        var state_data={}
        for (var m in woo_models) {
            var model=woo_models[m]
            if (!model.name || model.is_alias) {
                continue
            }
            var label='app.wooadmin.'+model.name
            var list_label=label+'-list'
            var edit_label=label+'-edit'

            $stateProvider.state(list_label, {
                url      : '/'+model.name+'-list/:page',
                params : {page: null},
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/wooadmin/models/modellist.html',
                        controller :   ['$state','$scope','$rootScope','WooModelListController', m, 'List',
                            function(state, scope,rootScope,ctrl, api, res) {
                                var vm=this;
                                vm.scope=scope;
                                vm.rootScope=rootScope;
                                vm.api=api; vm.res=res;
                                var data=state.current.data||{}
                                vm.selected_user='all'
                                ctrl(vm,state.current.data)
                        }],
                        controllerAs: 'vm'
                    }
                },
                data    : {
                    title: m + 's'
                    ,model: model
                    ,user : 'all'
                    ,substates: {edit: edit_label}
                    ,form_type: 'admin'
                    ,populate:model.list && model.list.populate
                },
                resolve : {
                    List:[
                        '$stateParams', m, m+'Model', 'WooModelListResolver', function (params,model,m,resolver) {
                            var filters=this.data.model.list && this.data.model.list.filters
                            return resolver(model,params,{
                                user:'all',filters:filters
                                ,populate: m&&m.list&&m.list.populate
                            })
                        }
                    ]
                }
            })

            $stateProvider.state(edit_label, {
                url      : '/'+model.name+'-edit/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        controller : [
                            '$scope','$state', '$window','WooModelEditController', 'Object','Form',m,
                            function(scope,state, win, ctrl, obj, form, api) {
                                var vm=this;
                                vm.layout='app/main/wooadmin/models/modeledit.html'
                                vm.edit_template=state.current.data.template
                                vm.scope=scope
                                vm.api=api
                                vm.Object=obj
                                add_refs(form)
                                vm.Form=form
                                ctrl(vm,state.current.data)
                                vm.continue=vm.save
                            }
                        ],
                        controllerAs:'vm'
                    }
                },
                data : {
                    titel: m
                    ,model: model
                    ,template:model.edit_template
                    ,user : 'all'
                    ,form_type: 'admin'
                },
                resolve: {
                    Object:[
                        '$stateParams',m,'WooModelResolver',function(params,m,resolver) {
                            return resolver(m,params,{user:'all'})
                        }
                    ],
                    Form:[
                        '$stateParams',m,'WooFormResolver','AuthService',function(params,m,resolver,auth) {
                            var type='admin'
                            if( !auth.isAdmin() ) type='user'

                            return resolver(m,params,{user:'all',form_type:type})
                        }
                    ]
                }
            })

        }
        // TODO: disable this when live
        //addNavigation(msNavigationServiceProvider,AuthServiceProvider)
    }

    function addNavigation(msNavigationService,auth) {

        // Navigation
        msNavigationService.saveItem('wooadmin', {
            title    : 'WOOADMIN',
            class    : 'wooadmin',
            //state    : 'app.wooadmin.users',
            translate: 'WOOADMIN.WOOADMIN_NAV',
            weight   : 100
            ,hidden: function() {
                return !auth.isAdmin();
            }
        });

        for (var ag in woo_admin_groups) {
            var ag_list=woo_admin_groups[ag]
            var group = 'wooadmin.'+ag
            msNavigationService.saveItem(group, {
                title: ag.capitalize()
                //,state: 'app.'+label
                ,hidden: function() {
                    return !auth.isAdmin();
                }
            });

            for (var i=0; i< ag_list.length; i++) {
                var e=ag_list[i]
                var m=e.model||e
                var model=woo_models[m]
                if (!model.name) {
                    continue
                }
                var state = e.state || 'app.wooadmin.'+model.name+'-list'
                //alert("Model: "+model.name)
                var label=group+'.'+model.name+'-list'
                msNavigationService.saveItem(label, {
                    title: model.name.capitalize() + 's'
                    ,state: state
                    ,hidden: function() {
                        return !auth.isAdmin();
                    }
                });
            }
        }

    }

    module.factory('WooAdminNavigation',['msNavigationService', function(service) {
        return function(auth) {
            addNavigation(service,auth)
        }
    }])

    module.factory('WaitForOp', function ($http,$q) {
        return function(op_id,timeout) {
            if (!timeout || timeout<0) {
                timeout=300
            }

            var deferred=$q.defer()
            var waitP = {
                p: deferred.promise,
                poll_once: function () {
                    $http({url:API_HOST+'/api/poll_operation/'+op_id+'?_v='+Date.now()}).then(
                        function(response) {
                            if (waitP.cancelled) {
                                return deferred.reject('cancelled')
                            }
                            var data=response.data
                            if (data.error) {
                                if(data.error=='timeout') {
                                    return waitP.poll_once()
                                }
                                return deferred.reject(data.error)
                            }
                            deferred.resolve(data.op)
                        },
                        function(err) {
                            deferred.reject(err)
                        }
                    )
                },
                /*
                p: new Promise(function(resolve,reject) {
                    function poll_once(iterations) {
                        $http({url:'/api/poll_operation/'+op_id}).then(
                            function(response) {
                                if (waitP.cancelled) {
                                    return reject('cancelled')
                                }
                                var data=response.data
                                if (data.error) {
                                    if(data.error=='timeout') {
                                        return poll_once()
                                    }
                                    return reject(data.error)
                                }
                                resolve(data.op)
                            },
                            function(err) {
                                reject(err)
                            }
                        )
                    }
                    poll_once(timeout/10)
                }),
                */
                cancel: function() {
                    console.log("WaitForOp cancelled");
                    waitP.cancelled=true
                }
            }
            waitP.poll_once()

            return waitP
        }
    })

    module.factory('ErrorDialog', function ErrorDialog(wtUtils,$translate) {
        var res = function (msg,msgs) {
            if (msg.translate){
                return $translate([msg.translate]).then(function(t) {
                    msg=t[msg.translate] || msg.translate
                    res(msg)
                })
            }
            _.each(msgs,function(m){
                msg += "<p>"+m+"</p>"
            })
            wtUtils.alert({title:'Oups, something went wrong!',html:msg,ok:'OK'})
       }
       return res
   })

})();

(function ()
{
    'use strict';

    angular
        .module('app.start', [])
        .config(config)

    /** @ngInject */

    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
        .state('app.start', {
            url    : '/start',
            params : {page: null},
            views  : {
                /*
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'info@':{
                },
                'admin@':{
                },*/
                'content@app': {
                    templateUrl: 'app/main/start/start.html',
                    //templateUrl: 'app/main/auth/views/login2.html',
                    controller : [
                        '$scope', '$rootScope', '$cookies', '$location', '$state', 'Messages','AuthService','UserInfo',
                        function(scope, $rootScope, $cookies, $location, state, Messages, AuthService,UserInfo) {
                            var redirect=UserInfo.get_start_state()
                            if (redirect) {
                                return state.go(redirect,{},{location:'replace'})
                            }
                            /**@type {string} */
                            var start=$cookies.get('woopanel_url_after_login')
                            $rootScope.$broadcast('user:changed')
                            if(start && start!=$location.url()) {
                                $cookies.remove('woopanel_url_after_login')
                                if(start.startsWith('http')) {
                                    window.location.href=start
                                    return
                                }
                                return $location.url(start)
                            }
                            var invite=$cookies.get('templ_sharing_invite')||$location.search()['templ_sharing_invite']
                            if(invite) {
                                $cookies.remove('templ_sharing_invite',{domain:'.templ.io'})
                                return $location.url('/f/sharing/accept/'+invite)
                            }

                            var vm = this;
                            vm.scope=scope
                            var messages = Messages.getPosition('start')
                            vm.message = messages && messages[0]
                            if(vm.message) {
                                if ( vm.message.image!='none') {
                                    vm.image='/assets/images/take-off.svg'
                                } else {
                                    vm.image=vm.message.image
                                }
                            }
                            if (!vm.message) {
                                return state.go('app.dashboard',{},{location:'replace'})
                            }
                            vm.action=function(action) {
                                if (action.state) {
                                    state.go(action.state)
                                }
                            }
                        }
                    ],
                    controllerAs: 'vm'
                }
            },
            resolve: {
                Messages: function(myMessages) {
                    return myMessages()
                },
                UserInfo: function(Messages,CachedUserInfo) {
                    return CachedUserInfo()
                }
            }
        })
        /*
        */
        $translatePartialLoaderProvider.addPart('app/main/start');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.speedtest',[])
        .config(config)
    function config($stateProvider)
    {
        $stateProvider
        .state('app.speedtest', {
            url    : '/speedtest',
            views: {
                'content@app' : {
                    template:'<div id="speedtest-vue"></div>',
                    controller:['$scope',function($scope) {
                        var vm=this
                        console.log('Mounting speed test');
                        vm.app = SpeedTest.app()
                        vm.app.mount('#speedtest-vue')
                        $scope.$on('$destroy',function() {
                            //debugger
                            console.log('Unmounting speed test');
                            vm.app.unmount()
                        })
                    }]
                }
            }
        })

    }
})();
(function () {
    'use strict';
    angular
        .module('app.woolinks',[])
        .config(config)
        .factory('WooLinks', links)
        .factory('WooLinkData',function($resource) {
            var r=$resource(
                'app/data/woolinks/data.json',
                {},
                {
                    get: {
                       method: 'GET',
                       isArray: false,
                       interceptor: {
                         response: function(response) {
                             return response.data;
                         }
                       }
                    }
                }
            )
            return r
        })
        //.factory('UserInfo', Service)
        //.factory('CachedUserInfo', Cached)

    function config() {
    }
    function translate($t,d,res,next) {
        var lang=$t.use()
        if (lang==cachedLang) {
            next && next(res)
            return
        }
        cachedLang=lang
        translate_recursive($t,d,res)
        next && next(res)
    }
    function translate_recursive($t,d,res) {
        angular.forEach(d,function (v,k) {
            if (!v) {
                return
            }
            if (typeof(v) === 'object') {
                var r=res[k]
                if(!r) {
                    r=res[k]={}
                }
                return translate_recursive($t,v,r)
            }
            var trans=$t.instant(v)
            res[k]=trans || v
        })
    }
    var cachedPromise
    var cachedData
    var cachedLang
    function links(msApi, $rootScope,$translate, $q, WooLinkData) {
        return function() {
            if (!cachedPromise) {
                var deferred=$q.defer()
                cachedPromise=deferred.promise
                WooLinkData.get({version:11}).$promise.then( function (res) {
                    cachedData={}
                    $rootScope.$on('$translateChangeSuccess', function () {
                        translate($translate,res,cachedData)
                    })
                    $translate.onReady(function() {
                        translate($translate,res,cachedData,function(data) {
                            deferred.resolve(data)
                        })
                    })
                })
            }
            return cachedPromise
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.vcheck',[])
        .config(config)
        .factory('myVCheck', vcheckService)
        .run(['myVCheck','$translate','$rootScope',function(vcheck,$translate,$rootScope) {
            $translate.onReady(function () {
                $rootScope.$on('userSetEvent',vcheck.check)
            });
        }])
    function config(msApiProvider) {
        msApiProvider.register('myMessages', ['api/woomessage']);
        // TODO: listen to message changes and emit message change event
    }

    /** @ngInject **/
    function vcheckService(wtUtils,$window, $http)
    {
        var self= {
            interval:30*60,
            url:'version.json',
            //hash:'test',
            reload:function() {
                wtUtils.alert({
                    title:'VCHECK.RELOAD_TITLE'
                    ,body:'VCHECK.RELOAD_BODY'
                    ,ok:"VCHECK.RELOAD_OK"
                },function() {
                    $window.location.reload()
                })
            },
            check:function() {
                $http({
                    method:'GET',
                    url:self.url,
                }).then(function(res) {
                    var h=res.data.hash
                    console.log('Check version',h);
                    if(self.hash && self.hash!=h) {
                        self.reload()
                    }
                    self.hash=h||self.hash
                }).finally(function () {
                    setTimeout(self.check,self.interval*1000)
                })
            }
        }
        return self
    }
})();

(function () {
    'use strict';
    angular
        .module('app.userinfo',[])
        .config(config)
        .factory('UserData', Data)
        .factory('UserInfo', Service)
        .factory('CachedUserInfo', Cached)

    var cachedInfo
    function config(msApiProvider,$rootScopeProvider) {
        msApiProvider.register('userData', ['api/woouinfo']);
    }
    function Cached(UserInfo) {
        return function() {
            if (!cachedInfo) {
                cachedInfo=UserInfo()
            }
            return cachedInfo
        }
    }

    function Service($rootScope,$q,$window,$translate,UserData,AuthService,ChatService) {
        $rootScope.$on('user:changed',function () {
            //alert('user changed')
            cachedInfo=null
        })
        var self= {
            getQuota:function(quota,tag) {
                for (var q in quota) {
                    q=quota[q]
                    if (q.label==tag) {
                        return q
                    }
                }
            },
            hasQuota:function(tag) {
                if (AuthService.isAdmin()) {
                    return true
                }
                var data=self.data
                var q=data && data.quota && self.getQuota(data.quota.quota,tag)

                return q && q.usage<q.max
            },
            setData:function(data) {
                var old_data=self.data
                self.data=data
                self.is_trial=data && data.is_trial && data.is_trial.expires&&true
                var old_trial=old_data && old_data.is_trial && old_data.is_trial.expires&&true
                if (!old_data || old_trial!=self.is_trial) {
                    AuthService.getUser().then(function(user) {
                        if (user.acctId && user.acctId == data.user) {
                            var pairs=[['is_trial', self.is_trial && true || false]]
                            if (self.is_trial && data.is_trial.expires) {
                                pairs.push(['trial_expires', String(data.is_trial.expires)])
                            }
                            ChatService.setData(pairs)
                        }
                    })
                }
            },
            stateLt:function(s) {
                var data=self.data
                return data.$resolved && self.data.state<self.data.states[s]
            },
            getCustomPanel:function() {
                return self.data&&self.data.custom_panel
            },
            getSelectedCurrency:function(pricing) {
                if (self.selected_currency) {
                    return self.selected_currency
                }
                var lang=$translate.use()
                var res=_.find(pricing.currencies,function(p) { return p.lang == lang})
                if(res) {
                    return res.code.toUpperCase()
                }
                return pricing.default_currency
            },
            getCurrency:function(pricing) {
                if (self.data && self.data.currency) {
                    return {selected:self.data.currency}
                }
                var options=_.map(pricing.currencies,function(c) {return c.code.toUpperCase();})
                return {selected:self.getSelectedCurrency(pricing),options:options}
            }
            ,selectCurrency: function (c) {
                self.selected_currency=c
            }
            ,get_start_state:function() {
                var data=self.data
                if (data && data.campaign && data.campaign.state == 'initial' ) {
                    return data.campaign_params && data.campaign_params.start_state
                }
            }
            ,campaign:function() {
                var c = self.data && self.data.campaign
                if (c) {
                    c.params=self.data.campaign_params
                }
                return c
            }
        }
        var deferred
        return function() {
            if (!deferred) {
                deferred=$q.defer()
                UserData().then(function(data) {
                    if(data.docs[0]) {
                        self.setData(data.docs[0])
                        return AuthService.getUser().then(function(user) {
                            self.user=user
                            deferred.resolve(self)
                            deferred=null
                        })
                    }
                    deferred.reject('failed to fetch User Data')
                    deferred=null
                }).catch(function() {
                    deferred.reject('failed to fetch User Data')
                    deferred=null
                })
            }
            return deferred.promise
        }
    }
    /** @ngInject **/
    function Data(AuthService,msApi)
    {
        return function() {
            var args={populate:['quota','campaign_params','custom_panel'],create_missing:1,user:AuthService.selectedUser()}
            return msApi.resolve('userData@get',args)
        }
    }
})();

(function(){
    'use strict';
    angular
        .module('app.mytranslations',[])
        .factory('MyTranslations', Service)


    function Service($translate,$q) {
        return function(tags) {
            var deferred=$q.defer()
            $translate(tags).then(function(t) {
                deferred.resolve(t)
            },function(err) {
                console.log(err);
                deferred.resolve({})
            })
            return deferred.promise
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('app.messages',[])
        .config(config)
        .factory('myMessages', messagesService)
        .factory('myMessageList', messagesData)
        .factory('cachedMessages',cached)

    var MSG_UPDATE_FREQ=1000
    //MSG_UPDATE_FREQ=10 //TEST_SETTING
    var cachedMessages
    function config(msApiProvider) {
        msApiProvider.register('myMessages', ['api/woomessage']);
        // TODO: listen to message changes and emit message change event
    }

    function cached(myMessages) {
        return function () {
            if (cachedMessages) { return cachedMessages }
            //console.log('Cached message miss');
            return myMessages()
        }
    }

    /** @ngInject **/
    function messagesService($q,$rootScope,myMessageList,CachedUserInfo)
    {
        var self= {
            getTopMessage:getTopMessage
            ,getPosition:function(pos) {
                return self.positions[pos]
            }
            ,sorted:{}
            ,positions:{}
        }
        function getTopMessage(pos) {
            if (self[pos] && !self.sorted[pos]) {
                self.positions[pos].sort(function(m1,m2) {
                    var prio=checkPrio(m1,m2)
                    if(typeof prio == 'undefined') {
                        return m1.added-m2.added
                    }
                })
                self.sorted[pos]=true
            }
            return self.positions[pos] && self.positions[pos][0]
        }
        function addMessages(messages) {
            self.sorted={}
            self.positions={}
            _.map(messages,function(m){
                if (!self.positions[m.position]) {
                    self.positions[m.position]=[]
                }
                self.positions[m.position].push(m)
                m.body=m.rendered_body
            })
            //self=next
            if (self.timer) {
                clearTimeout(self.timer)
            }

            $rootScope.$broadcast('$messagesChangeEvent')
            self.timer=setTimeout(function () {
                myMessageList().then(function(data) {
                    addMessages(data.docs)
                })
            },MSG_UPDATE_FREQ*1000)
        }
        $rootScope.$on('user:changed',function () {
            //alert('user changed')
            //console.log('User chaged: reloading messages');
            myMessageList().then(function(data) {
                addMessages(data.docs)
            })
        })

        return function() {
            var deferred=$q.defer()
            //console.log('Message service called');

            CachedUserInfo().then(function(info) {
                myMessageList().then(function(data) {
                    addMessages(data.docs)
                    deferred.resolve(self)
                    cachedMessages=deferred.promise
                }).catch(function() {
                    deferred.reject('failed to fetch Messages')
                })
            })
            return deferred.promise
        }
    }

    function messagesData(msApi,AuthService)
    {
        return function() {
            return msApi.resolve('myMessages@get',{user:AuthService.selectedUser()})
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module("app.settings", ['app.wooadmin','app.options'])
        .config(config)
        .controller('SettingsController',controller)

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider,
        Models)
    {
        // State
        $stateProvider
            .state('app.settings', {
                url     : '/settings/',
                //params  : {id:null},
                views   : {
                    'content@app' : {
                        templateUrl: 'app/main/layouts/wt-wrapper.html',
                        //templateUrl:
                        controller : 'SettingsController',
                        controllerAs:'vm'
                    }
                },
                resolve: {
                    Obj:[
                        '$q','$stateParams','WooUInfo','WooModelListResolver','AuthService',
                        function(q,params,m,resolver,auth) {
                            var d = q.defer()
                            auth.getUser().then(function(user) {
                                resolver(m,params,{
                                    populate:['operation'],
                                    user:auth.selectedUser()||user.acctId,
                                }).then(function(o) {
                                    o=o&&o.docs&&o.docs[0]
                                    d.resolve(new m(o))
                                })
                            })
                            return d.promise
                        }
                    ],
                    Options: function (msApi)
                    {
                        return msApi.resolve('useroptions@get');
                    },
                    OptionGroups: function (msApi)
                    {
                        return msApi.resolve('useroptiongroups@get');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/settings');

        // Api
        msApiProvider.register('useroptions', ['api/woooption/?populate=overrides&model=WooUInfo&page_size=-1']);
        // Api
        msApiProvider.register('useroptiongroups', ['api/woooptiongroup/?model=WooUInfo&page_size=-1']);
    }

    function controller(WooModelEditController,Obj,OptionsController0,Options,OptionGroups,AuthService) {
        var vm=this
        if(!Obj) return
        Options=Options&&Options.docs||Options
        OptionGroups=OptionGroups&&OptionGroups.docs||OptionGroups
        if(!Obj) return
        vm.isAdmin=AuthService.isAdmin()
        vm.layout='app/main/settings/settings.html'
        if (!Options||Options.length==0) {
            var OptionGroups=[
                {
                    _id:1,
                    name:'SETTINGS.VULNERABILITIES.NAME',
                    description:'SETTINGS.VULNERABILITIES.DESCRIPTION'
                },{
                    _id:2,name:"Other group"
                }
            ]
            //Obj.settings=Obj.settings||{}
            Options=[{
                _id:1,
                name:"SETTINGS.VULNERABILITIES.SEND_MAIL",group:1,path:'vulns.send_mail',
                kind:'checkbox'
            },{
                _id:2,
                name:'SETTINGS.VULNERABILITIES.MAIL_RECIPIENTS',group:1,path:'vulns.mail_addresses',
                kind:'text'
            },{
                _id:3,
                name:"Other option",group:2,path:'other'
            }]
        }
        vm.check_tags=function(){return true}
        OptionsController0.call(vm,Obj,{docs:Options},{docs:OptionGroups})
        vm.cancel=function() {
            $window.history.back()
        }
        vm.save=function(opt) {
            if (vm.is_operating ||  vm.isSaving) {
                return
            }
            vm.isSaving=true
            vm.update_settings(opt)
            Obj.$save({obj_id:Obj._id,populate:['operation']},function (res) {
                //debugger
                //$state.go('app.options.website',{id:Doc._id},{reload:true})
                //vm.set_status()
                vm.isSaving=false
            })
        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.campaign', [])
        .config(config)

    /** @ngInject */
    function update_object(WooUpgrade,Upgrade,next) {
        WooUpgrade.get({obj_id:Upgrade._id,user:Upgrade.user},{populate:'operation'},function (res) {
            var err,op=res.operation
            if(op && op.status=='error') {
                err=op.msgs[0]
            }
            next(err,res)
        })
    }

    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
        .state('appf.campaign', {
            url    : '/campaign',
        })
        .state('appf.campaign.start', {
            url    : '/start/',
            views  : {
                'content@appf': {
                    templateUrl: 'app/main/campaign/loading.html',
                    //templateUrl: 'app/main/campaign/blank.html',
                    //templateUrl: 'app/main/auth/views/login2.html',
                    controller : [
                        'UserInfo','Upgrade','WooUpgrade','Pricing','$state','$window','PollOperation',
                        function(UserInfo,Upgrade,WooUpgrade,Pricing,$state,$window,PollOperation) {
                            var vm=this
                            var campaign=UserInfo.campaign()
                            var params=campaign.params

                            function check(err,obj) {
                                if (obj.state=='placed') {
                                    $window.location.href=obj.subscription.order_url
                                    return true

                                }
                                if(obj.state!='new') {
                                    // Order is paid or complete
                                    $state.go(params.next_state||'app.website.list',{id:obj._id})
                                    return true
                                }
                            }
                            if(Upgrade && check(null,Upgrade)) {
                                return
                            }

                            var obj=Upgrade
                            if(!obj) {
                                obj=new WooUpgrade()
                                obj.kind='CampaignUpgrade'
                                obj.campaign=campaign.name
                                obj.state='new'
                            }
                            vm.update_object=function(){ update_object(WooUpgrade,obj,check) }
                            var args={}
                            if (obj._id) {
                                args.obj_id=obj._id
                            }
                            obj.$save(args,function(res) {
                                obj.add_billing={
                                    currency:params && params.currency || UserInfo.getSelectedCurrency(Pricing)
                                }
                                args.obj_id=res._id
                                obj.$save(args,function(res) {
                                    vm.poll=PollOperation(vm,res,check)
                                })
                            })
                        }
                    ],
                    controllerAs: 'vm'
                }
            },
            resolve: {
                UserInfo: ['UserInfo',function(UserInfo) {
                    return UserInfo()
                }],
                Pricing: ['msApi', function (msApi) {
                    return msApi.resolve('pricing@get')
                }],
                Billing: ['msApi', function (msApi)
                {
                    return  msApi.resolve('userBilling@get',{create_missing:1})
                }],
                Upgrade:[
                    'UserInfo','Billing','WooUpgrade','AuthService','$q',
                    function(UserInfo,Billing,WooUpgrade,AuthService,$q) {
                        var user=AuthService.user
                        var campaign=UserInfo.campaign()
                        var deferred=$q.defer()
                        if (Billing && Billing.docs) {
                            Billing=Billing.docs[0]
                        }
                        var default_id=Billing && Billing.default_subscription &&  Billing.default_subscription.id || 0
                        if (user.acctId && campaign && campaign.name) {
                            WooUpgrade.query({"user":user.acctId,"campaign":campaign.name}).$promise.then(
                                function(data) {
                                    if(data.docs && data.docs.length>0) {
                                        var up=_.find(data.docs,function(doc) {
                                            if (doc.subscription && doc.subscription.id==default_id) {
                                                return doc
                                            }
                                        }) || _.find(data.docs,function(doc) {
                                            if (doc.state=='paid') {
                                                return doc
                                            }
                                        });
                                        return deferred.resolve(up || data.docs[0])
                                    }
                                    deferred.resolve(null)
                                },
                                function() {
                                    deferred.reject()
                                }
                            )
                        } else {
                            deferred.resolve(null)
                        }
                        return deferred.promise
                    }
                ]
            }
        })
        .state('appf.campaign.payment_complete', {
            url    : '/thankyou/:uid/:oid',
            params : {uid: null,oid:null},
            views  : {
                'content@appf': {
                    templateUrl: 'app/main/campaign/loading.html',
                    //templateUrl: 'app/main/campaign/blank.html',
                    //templateUrl: 'app/main/auth/views/login2.html',
                    controller : [
                        'Upgrade','WooUpgrade','$state','$stateParams','PollOperation','$rootScope',
                        function(Upgrade,WooUpgrade,$state,$stateParams,PollOperation,$rootScope) {
                            var vm=this
                            function next(err,res) {
                                $rootScope.$broadcast('user:changed')
                                $state.go('app.start')
                            }
                            vm.update_object=function(){
                                update_object(WooUpgrade,Upgrade,next)
                            }
                            if (Upgrade.operation && !Upgrade.operation.complete) {
                                return vm.poll=PollOperation(vm,Upgrade,next)
                            }
                            if (Upgrade.state=='paid' || Upgrade.state=='complete') {
                                return next()
                            }

                            Upgrade.wait_for_payment=true
                            Upgrade.subscription.order_id = $stateParams.oid

                            return Upgrade.$save({obj_id:Upgrade._id},function(res) {
                                //Upgrade=res
                                if(vm.poll) {
                                    vm.poll.cancel()
                                }
                                vm.poll=PollOperation(vm,res,next)
                            })
                        }
                    ]
                }
            },
            resolve: {
                UserInfo: ['UserInfo',function(UserInfo) {
                    return UserInfo()
                }],
                Upgrade: [
                    '$stateParams','WooUpgrade','WooModelResolver',
                    function(params,model,resolver) {
                        return resolver(model,{id:params.uid})
                    }
                ]
            }
        })
        /*
        */
        $translatePartialLoaderProvider.addPart('app/main/start');
    }
})();

(function ()
{
    'use strict';
    var prefix='app.blueprints'
    var module='blueprint'
    // State shared between vue-app instantiations
    var shared = {
    }
    function controller(vm, backup, auth, wtUtils, WooBackup, WaitForOp) {
        vm.isAdmin=auth.isAdmin()
        vm.user=auth.selectedUser() || auth.user && auth.user.acctId
        vm.layout='app/main/blueprints/list.html'
        vm.obj=backup
        vm.list=backup && backup.locals
        vm.has_blueprints = (Array.isArray(vm.list) && vm.list.length > 0)
        // console.log('Blueprints list, has_blueprints=',vm.has_blueprints, vm.list)
        vm.class_attr = vm.has_blueprints ? 'blueprints-list-wrapper' : 'blueprints-list-wrapper empty';
        vm.empty_title='BLUEPRINTS.EMPTY_TITLE'
        vm.empty_text='BLUEPRINTS.EMPTY_TEXT'
        vm.no_create=true
        vm.empty_animation_template='app/main/animations/empty-blueprints.html'
        vm.helpUrl='https://docs.templ.site/development/blueprints'
        vm.format_date=function(time) {
            var date=new Date(time)
            var options = {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            }
            var locale=window.navigator.language == 'sv-SE' ? 'sv-SE' : 'en-US'
            return date.toLocaleDateString(locale, options)
        }
        vm.remove=function(bp) {
            //console.log('removing...')
            if(!bp || !bp._id) return
            wtUtils.confirm({
                title:"BLUEPRINTS.DELETE.CONFIRM_TITLE",
                text:"BLUEPRINTS.DELETE.CONFIRM_TEXT",
                ok:"UTILS.CONTINUE"
            },function() {
                vm.updating=true
                var idx=vm.list.indexOf(bp)
                if(idx<0) return;
                var copy=angular.copy(backup)
                copy.locals.splice(idx,1)
                WooBackup.update({obj_id:backup._id,user:vm.user},copy,function(res) {
                    if (res && res.operation && !res.operation.completed) {
                        return WaitForOp(res.operation._id).p.then(function (op) {
                            // Refetch
                            return WooBackup.get({obj_id: backup._id, user: vm.user}).$promise.then(function (res) {
                                vm.updating = false
                                vm.obj = res//new WooBackup(res)
                                vm.list = res && res.locals
                            })
                        })
                    }
                    vm.updating=false
                    vm.obj=res//new WooBackup(res)
                    vm.list=res&&res.locals
                },function(err) {
                    vm.updating=false
                    console.error('Error deleting blueprint',err)
                    alert(vm.translate('BLUEPRINTS.ERRORS.DELETE'))
                })
            })
        }
    }
    angular
        .module('app.blueprints',[])
        .config(config)
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        var model = {name:'blueprint'}
        //Models['Blueprint']
        var filters=[
            {
                name:'search',label:'SEARCH',field:'__search__',kind:'search'
            }
        ]
        var subs={
            list:{
                url    : '/list/:page',
                params : {page: null},
                view  : {
                    templateUrl: 'app/main/layouts/wt-wrapper.html',
                    controller : ['Obj','AuthService','wtUtils','WooBackup','WaitForOp',function(Obj,AuthService,wtUtils, WooBackup, WaitForOp) {
                        return controller(this,Obj,AuthService,wtUtils,WooBackup, WaitForOp)
                    }],
                    controllerAs: 'vm'
                },
                resolve: {
                    Obj:[
                        'WooBackup','$q','AuthService',function(WooBackup,$q,AuthService) {
                            var deferred=$q.defer()
                            WooBackup.query({user:AuthService && AuthService.selectedUser(),name:'My Blueprints',populate:'app'}).$promise.then(function(res) {
                                res=res&&res.docs
                                if(res) {
                                    res=_.find(res,function(d) { 
                                        return d.name=='My Blueprints' && d.app && d.app.pcode=='blueprint'
                                    })
                                    //res=res && res.locals
                                }
                                deferred.resolve(res)//new WooBackup(res))
                            },function() {
                                deferred.reject()
                            })
                            return deferred.promise
                        }
                    ],
                },

            },
        }

        $stateProvider
        .state(prefix, {
            url        :  '/blueprint',
            redirectAfter :  prefix+'.list',
            redirectAlwaysEnter: true,
        })
        for (var sub in subs) {
            var subdef=subs[sub]
            var views={}
            views['content@app']=subdef.view
            $stateProvider
                .state(prefix+'.'+sub, {
                    url    : subdef.url,
                    views  : views,
                    resolve: subdef.resolve,
                    data   : subdef.data
                })
        }
        $translatePartialLoaderProvider.addPart('app/main/blueprints');
    }
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin/bar.html","<div class=\"wt-top-bar\" ng-if=\"vm.isAdmin()\" ng-class=\"{\'is-admin\': vm.isAdmin()}\" layout=\"row\" layout-fill><div \nclass=\"wt-top-bar-container\"><form layout=\"row\" id=\"user_select_form\" ng-submit=\"vm.selectUser()\"><input \nng-model=\"vm.selected_user\" pattern=\"[0-9]*\" type=\"text\" class=\"selected-user form-control\" name=\"user\" \nplaceholder=\"User\" data-1p-ignore><button ng-click=\"vm.selectUser()\" type=\"submit\" class=\"btn btn-primary\" \ntranslate=\"WOOADMIN.GO\">Go</button> <a class=\"btn btn-primary user-info\" \nui-sref=\"app.wooadmin.userinfo-edit({id:vm.user_info})\" tabindex=\"0\">User Info</a><div ng-if=\"vm.isAdmin\" id=\"search\" \nui-view=\"search\" layout=\"column\"></div></form></div></div><div class=\"wt-top-bar\" ng-if=\"!vm.isAdmin()\" \nng-show=\"vm.sharing_docs.initial_length\" layout=\"row\" layout-fill><div class=\"wt-top-bar-container user\"><ng-include \nsrc=\"\'app/admin/userbar.html\'\"></ng-include></div></div>");
$templateCache.put("app/admin/userbar.html","<div id=\"user_select_form\"><label class=\"admin-bar-user\" translate=\"ADMIN.SWITCH_ACCOUNT\"></label><ui-select \nng-model=\"vm.selected_user\"><ui-select-match allow-clear=\"false\" placeholder=\"{{\'ADMIN.SELECT_ACCOUNT\' | translate}}\">\n{{$select.selected.name|translate}}</ui-select-match><ui-select-choices \nrepeat=\"item.value as item in vm.sharing_docs.docs | filter: {name: $select.search}\" \nrefresh=\"vm.refresh_select($select.search)\" refresh-delay=\"0\" infinite-scroll=\"vm.refresh_select($select.search,true)\" \ninfinite-scroll-distance=\"1\"><div ng-bind-html=\"(item.name |translate)| highlight: $select.search\"></div>\n</ui-select-choices></ui-select><button ng-if=\"vm.selected_user\" ng-click=\"vm.selected_user=null\" \nclass=\"btn btn-primary clear-button\"><span translate=\"ADMIN.SEARCH.CLEAR\"></span></button><div id=\"search\" \nui-view=\"search\" layout=\"column\"></div><a ng-if=\"vm.isAgency\" ng-href=\"{{vm.getRegisterAccountUrl()}}\" target=\"_blank\" \nclass=\"btn btn-link create-customer-account\" translate=\"CREATE_CUSTOMER_ACCOUNT\"></a></div>");
$templateCache.put("app/help-panel/chat-tab.html","<div flex id=\"help-chat-frame\" class=\"help-panel-frame\"></div>");
$templateCache.put("app/help-panel/help-page-tab.html","<div layout=\"column\" flex layout-fill><div layout=\"row\" style=\"height:64px\" layout-align=\"start center\"><md-icon \nclass=\"frame-control s18\" md-font-icon=\"icon-arrow-left\" ng-click=\"vm.frame_back(vm.help_frame)\"></md-icon><md-icon \nclass=\"frame-control s18\" md-font-icon=\"icon-arrow-right\" ng-click=\"vm.frame_forward(vm.help_frame)\"></md-icon><md-icon\n class=\"frame-control s18\" md-font-icon=\"icon-reload\" ng-click=\"vm.frame_reload(vm.help_frame)\"></md-icon>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-progress-circular id=\"help-frame-progress\" ng-disabled=\"!vm.help_frame.loading\" class=\"md-accent\" \nmd-diameter=\"16\"></md-progress-circular></div><div layout=\"column\" layout-fill layout-padding flex \nid=\"help-page-frame\" class=\"help-panel-frame\"></div></div>");
$templateCache.put("app/help-panel/help-panel.html","<div layout=\"column\" flex layout-fill><md-toolbar class=\"panel-header\" layout=\"row\" layout-align=\"start center\">\n<md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" ng-click=\"vm.close()\"></md-icon>Help</md-toolbar>\n<md-content layout=\"column\" flex layout-fill><md-tabs layout=\"column\" flex layout-fill><md-tab label=\"Help Pages\" \nstyle=\"background:green\" layout=\"column\" flex layout-fill><md-tab-content layout=\"column\" flex layout-fill \nlayout-padding><ng-include src=\"\'app/help-panel/help-page-tab.html\'\" layout=\"column\" flex layout-fill></ng-include>\n</md-tab-content></md-tab><md-tab label=\"Chat\" layout=\"column\" flex layout-fill><md-tab-content layout=\"column\" flex \nlayout-fill layout-padding><ng-include src=\"\'app/help-panel/chat-tab.html\'\" layout=\"column\" flex layout-fill>\n</ng-include></md-tab-content></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/help-panel/test.html","<md-toolbar class=\"panel-header\" style=\"\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"fold-toggle s18\" \nmd-font-icon=\"icon-backburger\" ng-click=\"vm.toggle()\"></md-icon>Help</md-toolbar><md-content layout-fill \nstyle=\"background-color:black\"><md-tabs flex style=\"background-color:darkgrey\" layout-fill><md-tab flex label=\"A\" \nstyle=\"background:green\" layout-fill><md-tab-content flex style=\"background:blue\" layout-fill><iframe ms-scroll \nstyle=\"height:100%;width:100%\" ng-src=\"/help/\"></iframe></md-tab-content></md-tab><md-tab flex label=\"B\" layout-fill>\n<md-tab-content flex style=\"background:cyan\" layout-fill>B</md-tab-content></md-tab></md-tabs></md-content>");
$templateCache.put("app/info/info.html","<div ng-if=\"vm.messages\" class=\"message-container\"><div ng-repeat=\"m in vm.messages\" class=\"message\"><span \ntranslate=\"{{m.body}}\" translate-values=\"{{m.values}}\"></span> <button class=\"btn btn-success btn-sm\" \nng-repeat=\"a in m.actions\" ng-click=\"vm.action(a)\" translate=\"{{a.name}}\"></button></div></div>");
$templateCache.put("app/quick-panel/messages.html","<md-list><md-list-item class=\"md-2-line\" ng-repeat-start=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h2>{{note.title}}</h2><p>{{note.body}}</p></div></md-list-item><md-divider ng-repeat-end>\n</md-divider></md-list>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-toolbar class=\"panel-header\" layout=\"row\" layout-align=\"start center\"></md-toolbar><md-content layout=\"column\" \nflex layout-fill><md-tabs layout=\"column\" flex layout-fill><md-tab label=\"User Guide\" layout=\"column\" flex layout-fill>\n<md-tab-content layout=\"column\" flex layout-fill><my-help-page layout=\"column\" layout-fill flex host=\"wootemple.com\" \ninitial=\"wootemple-initial-setup-guide\"></my-help-page></md-tab-content></md-tab><md-tab label=\"Messages\" \nlayout=\"column\" flex layout-fill><md-tab-content layout=\"column\" flex layout-fill><ng-include \nsrc=\"\'app/quick-panel/messages.html\'\" layout=\"column\" flex layout-fill></ng-include></md-tab-content></md-tab><md-tabs>\n</md-tabs></md-tabs></md-content>");
$templateCache.put("app/tracking/tracking.html","<div ng-repeat=\"tracker in trackers\" style=\"display:none\"><ng-include src=\"tracker.src\"></ng-include></div>");
$templateCache.put("app/tracking/tradedoubler.html","<iframe ng-onload=\"tradeDoublerLoaded()\" id=\"tradedoubler-iframe\" ng-src=\"{{tracker.url}}\" frameborder=\"0\" width=\"1\" \nheight=\"1\"></iframe>");
$templateCache.put("app/search/search.html","<div id=\"search-box\"><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar></div>");
$templateCache.put("app/core/layouts/content-only.html","<div class=\"layout-content-only\"><div id=\"content\" ui-view=\"content\" flex></div></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/mobile-header.html","<div class=\"logo-wrapper\"><a ng-if=\"!vm.custom_logo\" href=\"/\"><img class=\"logo-img\" ng-src=\"{{vm.logo}}\" \nalt=\"Templ logo\"> </a><a ng-if=\"vm.custom_logo\" href=\"/\"><img class=\"logo-img custom-logo\" ng-src=\"{{vm.logo}}\" \nalt=\"Agency logo\"> <img class=\"powered-by\" src=\"/assets/logos/by-templ-1.svg\" alt=\"Powered by Templ\"> </a><span \nng-if=\"vm.betaPanel\" class=\"templ-badge small pink beta-badge\">BETA</span></div><label for=\"main-menu-toggle\" \nclass=\"hamburger\"><span></span> <span></span> <span></span> <span></span></label>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<input type=\"checkbox\" id=\"main-menu-toggle\"><div id=\"mobile-header\" ui-view=\"mobile-header\"></div><label \nfor=\"main-menu-toggle\" class=\"backdrop\" tabindex=\"-1\" aria-hidden=\"true\" hidden></label><div \nclass=\"layout-vertical-navigation\"><aside id=\"vertical-navigation\" ui-view=\"navigation\"></aside><div id=\"content\" \nui-view=\"content\"><div ng-hide=\"!$root.loadingProgress\" class=\"spinner-border text-primary loading-spinner\" \nrole=\"status\"><span class=\"sr-only\">Loading...</span></div></div></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div class=\"ms-theme-options-list\" \nlayout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">Layout Style:</div><md-radio-group \nlayout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\">\n<md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" ng-value=\"layoutStyle.value\"><div layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> <span class=\"text-center font-size-12 mt-8\">\n{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div><md-divider></md-divider><div \nclass=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/animations/confetti.html","<div id=\"confetti-animation\" class=\"confetti-animation\"></div><script>\nlottie.loadAnimation({\n    container: document.querySelector(\'#confetti-animation\'), // the dom element that will contain the animation\n    renderer: \'svg\',\n    loop: true,\n    autoplay: true,\n    path: \'/assets/animations/confetti.json\' // the path to the animation json\n});\n</script>");
$templateCache.put("app/main/animations/empty-account-sharing.html","<div id=\"empty-account-sharing-animation\" class=\"empty-animation\"></div><script>\nlottie.loadAnimation({\n    container: document.querySelector(\'#empty-account-sharing-animation\'), // the dom element that will contain the animation\n    renderer: \'svg\',\n    loop: true,\n    autoplay: true,\n    path: \'/assets/animations/account-sharing.json\' // the path to the animation json\n});\n</script>");
$templateCache.put("app/main/animations/empty-backups.html","<div id=\"empty-backups-animation\" class=\"empty-animation\"></div><script>\nlottie.loadAnimation({\n    container: document.querySelector(\'#empty-backups-animation\'), // the dom element that will contain the animation\n    renderer: \'svg\',\n    loop: true,\n    autoplay: true,\n    path: \'/assets/animations/backup.json\' // the path to the animation json\n});\n</script>");
$templateCache.put("app/main/animations/empty-blueprints.html","<div id=\"empty-blueprints-animation\" class=\"empty-animation\"></div><script>\nlottie.loadAnimation({\n    container: document.querySelector(\'#empty-blueprints-animation\'), // the dom element that will contain the animation\n    renderer: \'svg\',\n    loop: true,\n    autoplay: true,\n    path: \'/assets/animations/blueprint.json\' // the path to the animation json\n});\n</script>");
$templateCache.put("app/main/animations/empty-domains.html","<div id=\"empty-domains-animation\" class=\"empty-animation\"></div><script>\nlottie.loadAnimation({\n    container: document.querySelector(\'#empty-domains-animation\'), // the dom element that will contain the animation\n    renderer: \'svg\',\n    loop: true,\n    autoplay: true,\n    path: \'/assets/animations/add-domain.json\' // the path to the animation json\n});\n</script>");
$templateCache.put("app/main/animations/empty-emails.html","<div id=\"empty-emails-animation\" class=\"empty-animation\"></div><script>\nlottie.loadAnimation({\n    container: document.querySelector(\'#empty-emails-animation\'), // the dom element that will contain the animation\n    renderer: \'svg\',\n    loop: true,\n    autoplay: true,\n    path: \'/assets/animations/email.json\' // the path to the animation json\n});\n</script>");
$templateCache.put("app/main/animations/empty-file-access.html","<div id=\"empty-file-access-animation\" class=\"empty-animation\"></div><script>\nlottie.loadAnimation({\n    container: document.querySelector(\'#empty-file-access-animation\'), // the dom element that will contain the animation\n    renderer: \'svg\',\n    loop: true,\n    autoplay: true,\n    path: \'/assets/animations/file-access.json\' // the path to the animation json\n});\n</script>");
$templateCache.put("app/main/animations/empty-websites.html","<div id=\"empty-websites-animation\" class=\"empty-animation\"></div><script>\nlottie.loadAnimation({\n    container: document.querySelector(\'#empty-websites-animation\'), // the dom element that will contain the animation\n    renderer: \'svg\',\n    loop: true,\n    autoplay: true,\n    path: \'/assets/animations/migration.json\' // the path to the animation json\n});\n</script>");
$templateCache.put("app/main/backups/backups.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/main/backups/details.html","<div class=\"detail-list backup-details\"><div ng-if=\"vm.isAdmin\"><section class=\"edit-website\"><h3>Admin Settings</h3>\n<div class=\"row\"><div class=\"col-12\"><div class=\"button-container\"><a ng-if=\"vm.isAdmin\" \nui-sref=\"app.wooadmin.backup-edit({id:vm.id})\" class=\"btn btn-success\" translate=\"WOOADMIN.ADMIN\"></a></div></div>\n</div></section><hr class=\"section-divider\"></div><section><div class=\"row\"><div class=\"col-12\"><h1 \nng-if=\"vm.is_deleted\" translate=\"BACKUPS.DELETED_TITLE\" translate-values=\"{name:vm.app_name}\"></h1><h1 \nng-if=\"!vm.is_deleted\" translate=\"BACKUPS.TITLE\" translate-values=\"{name:vm.app_name}\"></h1></div></div></section><hr \nclass=\"section-divider\"><section><h3 translate=\"BACKUPS.LOCAL_TITLE\">Local Backups</h3><p \nclass=\"backup-type-description\" translate=\"BACKUPS.LOCAL_DESCRIPTION\"></p><div class=\"table backup-list\"><div \nclass=\"table-head row no-gutters\"><div class=\"name\"><span translate=\"BACKUPS.BACKUP_NAME\">Name</span></div><div \nclass=\"time\"><span translate=\"BACKUPS.BACKUP_TIME\">Time</span></div><div class=\"download\"><span \ntranslate=\"BACKUPS.DOWNLOAD\">Download</span></div></div><div ng-repeat=\"item in obj.locals\"><ng-include \nsrc=\"\'app/main/backups/listitem.html\'\"></ng-include></div></div></section><hr class=\"section-divider\"><section><h3 \ntranslate=\"BACKUPS.REMOTE_TITLE\">Remote Backups</h3><p class=\"backup-type-description\" \ntranslate=\"BACKUPS.REMOTE_DESCRIPTION\"></p><div class=\"table backup-list\"><div class=\"table-head row no-gutters\"><div \nclass=\"name\"><span translate=\"BACKUPS.BACKUP_NAME\">Name</span></div><div class=\"time\"><span \ntranslate=\"BACKUPS.BACKUP_TIME\">Time</span></div><div class=\"download\"><span translate=\"BACKUPS.DOWNLOAD\">Download\n</span></div></div><div ng-repeat=\"item in obj.remotes\"><ng-include ng-repeat=\"remote in [1]\" \nsrc=\"\'app/main/backups/listitem.html\'\"></ng-include></div></div></section></div>");
$templateCache.put("app/main/backups/edit.html","<div class=\"detail-list backup-details\"><section><div class=\"row\"><div class=\"col-12\"><h1 \ntranslate=\"BACKUPS.EDIT_BACKUPS_TITLE\"></h1></div></div></section><hr class=\"section-divider\"><section><h3 \ntranslate=\"BACKUPS.LOCAL_TITLE\"></h3><p translate=\"BACKUPS.EDIT_LOCAL_DESCRIPTION\"></p><div class=\"table backup-list\">\n<div class=\"table-head row no-gutters\"><div class=\"name\"><span translate=\"BACKUPS.BACKUP_NAME\">Name</span></div><div \nclass=\"time\"><span translate=\"BACKUPS.BACKUP_TIME\">Time</span></div><div class=\"delete\"><span \ntranslate=\"BACKUPS.DELETE\">Delete</span></div></div><div ng-repeat=\"local in vm.obj.locals\" \nclass=\"table-row no-gutters row\"><div class=\"name\">{{local.name}}</div><div class=\"time\">{{local.time}}</div><div \nclass=\"delete\"><a ng-if=\"local.manual\" ng-click=\"vm.remove_local(local)\" translate=\"BACKUPS.DELETE\">Delete</a></div>\n</div></div></section><hr class=\"section-divider\"><section><h3 translate=\"BACKUPS.REMOTE_TITLE\"></h3><p \ntranslate=\"BACKUPS.EDIT_REMOTE_DESCRIPTION\"></p><div class=\"table backup-list\"><div class=\"table-head row no-gutters\">\n<div class=\"name\"><span translate=\"BACKUPS.BACKUP_NAME\">Name</span></div><div class=\"time\"><span \ntranslate=\"BACKUPS.BACKUP_TIME\">Time</span></div><div class=\"delete\"><span translate=\"BACKUPS.DELETE\">Delete</span>\n</div></div><div ng-repeat=\"local in vm.obj.remotes\" class=\"table-row no-gutters row\"><div class=\"name\">{{local.name}}\n</div><div class=\"time\">{{local.time}}</div><div class=\"delete\"><a ng-if=\"local.manual\" \nng-click=\"vm.remove_remote(local)\" translate=\"BACKUPS.DELETE\">Delete</a></div></div></div></section></div>");
$templateCache.put("app/main/backups/listitem.html","<div class=\"table-row no-gutters row\"><div class=\"name\">{{item.name}}</div><div class=\"time\">{{vm.time(item)}}</div>\n<div class=\"download\"><button ng-if=\"!item.link.link\" class=\"btn btn-link\" \nng-click=\"vm.get_download_link(item,remote)\" translate=\"BACKUPS.GET_DOWNLOAD_LINK\"></button> <a ng-if=\"item.link.link\" \nhref=\"{{item.link.link}}\" translate=\"BACKUPS.DOWNLOAD\"></a></div></div>");
$templateCache.put("app/main/billing/billing.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/main/billing/pricing-template.html","<a ng-click=\"vm.hideHelp = !vm.hideHelp\">Toggle help</a><div class=\"admin-help\" ng-if=\"!vm.hideHelp\"><p>\nA price list is defined in terms of a parent, typically the default price list, and one or more modifications. The price list will \"inherit\" all normal prices from its parent.\n</p><p>\nA pricelist can have one or more discounts. If multiple discounts are added they are applied in decreasing value order. Discounts are separate objects created under the Admin - Pricing - Discount.\n</p><p>A price list can also define specific prices for specific plans, or addon products.</p><p>\nTo add a new price for a plan one does as follows:</p><ol><li>Select the <b>Plans</b> tab</li><li>Click the <b>Add</b>\n button and enter the plan code. One of: micro, sm01, sm02, med01, lar01, custom</li><li>Click the <b>Add</b>\n under Products (it doesn\'t look like a button, but it is...)</li><li>\nSelect the pricegroup. If you only add a product for the <b>low</b> price group, it will be used for all price groups.\n</li><li>Enter the price in USD (or whatever the default currency is set to)</li></ol><p>\nFor addons the process is similar, but under the <b>Addons</b> tab. Addon codes are one of: disk, cpu, ram</p><p>\nWhen the you hit save, a new product will be created automatically in Woocommerce with the appropriate price(s). The currency will be automatically converted, but can be adjusted.\n</p><p>It\'s also possble to create plans that are specific to a user, more on that to come...</p></div><uib-tabset>\n<uib-tab index=\"1\" heading=\"General\"><wt-form wt-form=\"form\" wt-obj=\"obj\" wt-tab=\"Other\"></wt-form></uib-tab><uib-tab \nindex=\"2\" heading=\"Plans\"><wt-form wt-form=\"form\" wt-obj=\"obj\" wt-tab=\"Plans\"></wt-form></uib-tab><uib-tab index=\"3\" \nheading=\"Locations\"><wt-form wt-form=\"form\" wt-obj=\"obj\" wt-tab=\"Locations\"></wt-form></uib-tab><uib-tab index=\"4\" \nheading=\"Addons\"><wt-form wt-form=\"form\" wt-obj=\"obj\" wt-tab=\"Addons\"></wt-form></uib-tab><uib-tab index=\"5\" \nheading=\"Conversions\"><wt-form wt-form=\"form\" wt-obj=\"obj\" wt-tab=\"Conversions\"></wt-form></uib-tab></uib-tabset>");
$templateCache.put("app/main/blueprints/list.html","<ng-include ng-if=\"!vm.has_blueprints\" src=\"\'app/main/wooadmin/models/modellistempty.html\'\"></ng-include><div \nng-if=\"vm.has_blueprints\" class=\"blueprints-list\"><div class=\"title-with-buttons\"><div class=\"title\"><h1 \ntranslate=\"BLUEPRINTS.LIST_TITLE\"></h1><wt-help-button ng-if=\"vm.helpUrl\" wt-help-url=\"{{vm.helpUrl}}\" \nwt-color=\"white\"></wt-help-button><div ng-if=\"vm.updating\" class=\"spinner-border\" role=\"status\"><span class=\"sr-only\">\nLoading...</span></div></div></div><div class=\"card\"><div class=\"table\"><div class=\"table-head row no-gutters\"><div \nclass=\"table-head-column-header name\" translate=\"BLUEPRINTS.TABLE.NAME\"></div><div \nclass=\"table-head-column-header time\" translate=\"BLUEPRINTS.TABLE.TIME\"></div><div \nclass=\"table-head-column-header actions\"></div></div><div ng-repeat=\"bp in vm.list\" class=\"table-row no-gutters row\">\n<div class=\"name\">{{bp.name}}</div><div class=\"time\">{{vm.format_date(bp.time)}}</div><div class=\"actions\">\n<wt-dropdown-button wt-button-text=\"QUICK_ACTIONS\" wt-button-class=\"btn btn-quick-actions\"><a class=\"wt-dropdown-item\" \nng-class=\"{\'disabled\': vm.updating}\" ng-click=\"vm.remove(bp)\" translate=\"BLUEPRINTS.DELETE.BTN\"></a>\n</wt-dropdown-button></div></div></div></div></div>");
$templateCache.put("app/main/campaign/loading.html","<div id=\"splash-screen\"><div class=\"splash-screen-content\"><div class=\"col-12\"><img class=\"logo-img\" \nsrc=\"/assets/logos/templ-tempel-white.svg?v=2021\"></div><div class=\"col-12\"><div class=\"spinner-border text-light\" \nrole=\"status\"><span class=\"sr-only\">Loading...</span></div></div></div></div>");
$templateCache.put("app/main/commands/admin-template.html","<a ng-click=\"vm.hideHelp = !vm.hideHelp\">Toggle help</a><div class=\"admin-help\" ng-if=\"!vm.hideHelp\"><p>\nCommands are specified as templates. The templates uses double curly brackets to denote a \"variable\" to be substituted for a value depending on what site the command is applied to. The following predefined variables exist:\n<ul><li><em>app</em> - the app (website) numeric id</li><li><em>c</em>\n - the container id. This is the same as app id for live sites, but not for staging sites</li><li><em>user</em>\n - the container user</li><li><em>admin</em> - the admin user (i.e. <em>herman</em>)</li><li><em>jail</em>\n - the jail directory</li><li><em>container</em> - the container directory</li><li><em>webroot</em>\n - the webroot directory, i.e. only the directory name not the path</li><li><em>domain</em> - the main domain</li><li>\n<em>home</em> - the home directory, i.e. /home/{{user}}</li></ul></p><p>Commands has a few additional parameters:<ul>\n<li><em>runAs</em> - specifies whether the command is run as the admin or container user</li><li><em>root</em>\n - specifies whether the command is run with the container, or the jail as root.</li></ul></p></div><wt-form \nwt-form=\"form\" wt-obj=\"obj\"></wt-form>");
$templateCache.put("app/main/commands/commandgroup.html","<h1>{{group.title}}</h1><p class=\"option-group-description\">{{group.description}}</p><div ng-if=\"group.msg\"><p \nng-class=\"group.msg.class\" translate=\"{{group.msg.msg}}\"></p></div><div ng-if=\"!cmd.disabled\" \nng-repeat=\"cmd in group.commands\" class=\"setting-container\" ng-class=\"{\'admin-only\': cmd.access == \'admin\'}\"><a \nui-sref=\"app.wooadmin.command-edit({id:cmd._id})\" class=\"admin-only\">Edit</a><div ng-if=\"cmd.msg\" \nclass=\"setting message-setting\"><p ng-class=\"cmd.msg.class\" translate=\"{{cmd.msg.msg}}\"></p></div><div \nclass=\"command-result\" ng-if=\"cmd.log\"><h3>Log</h3><pre ng-repeat=\"log in cmd.log\">{{log.msg||log}}</pre></div><h3>\n{{cmd.title}}</h3><p class=\"setting-description\">{{cmd.description}}</p><form name=\"{{cmd.name}}\" class=\"\"><div \nclass=\"input-container\" ng-repeat=\"option in cmd.options\"><label for=\"{{cmd.name}}.{{option.name}}\">{{option.name}}\n</label><select ng-if=\"option.values\" name=\"{{cmd.name}}.{{option.name}}\" class=\"form-control\" ng-model=\"option.value\" \nng-options=\"val.trim() for val in option.values.split(\',\')\" ng-required=\"!option.optional\"><option \nng-repeat=\"option in opt.values\" value=\"{{option.value||option}}\" translate=\"{{option.name||option}}\"></option>\n</select><input ng-if=\"!option.values\" name=\"{{cmd.name}}.{{option.name}}\" ng-model=\"option.value\" \nng-required=\"!option.optional\"></div><div class=\"setting button-setting\"><button type=\"button\" \nng-disabled=\"{{cmd.name}}.$invalid || vm.is_operating\" class=\"btn btn-outline-primary\" ng-click=\"vm.run(cmd)\" \ntranslate=\"{{cmd.name}}\"></button></div></form></div>");
$templateCache.put("app/main/commands/commands.html","<h1>Commands for {{vm.doc.name}}</h1><a ui-sref=\"app.website.details({id:vm.doc._id})\">Back</a><div \nclass=\"alert alert-warning\"><strong>Important:</strong><ul><li>\nThis page is very much work in progress, only intended for Admins who know what they are doing...</li></ul></div><div \nng-if=\"vm.status!=\'ok\'\" ng-repeat=\"obj in [vm.obj]\"><ng-include src=\"\'app/main/wooadmin/models/modelstatus.html\'\">\n</ng-include></div><div class=\"form card settings\"><uib-tabset active=\"vm.initial_tab\"><uib-tab \nng-repeat=\"group in vm.groups\" heading=\"{{group.name}}\" select=\"vm.onTabSelect(group)\"><ng-include \nsrc=\"\'app/main/commands/commandgroup.html\'\"></ng-include></uib-tab></uib-tabset></div>");
$templateCache.put("app/main/dashboard/dashboard.html","<div class=\"dashboard\"><header class=\"dashboard-header\"><div class=\"title-with-buttons\"><div class=\"title\"><h1 \ntranslate=\"DASHBOARD.HELLO\" translate-values=\"{time_of_day: vm.time_of_day, name: vm.user_first_name}\"></h1></div><div \nclass=\"button-container\"><wt-dropdown-button wt-button-text=\"DASHBOARD.QUICK_ACTIONS\" \nwt-button-class=\"btn btn-outline-primary\"><a class=\"wt-dropdown-item\" ng-click=\"vm.createWebsite()\" \ntranslate=\"WEBSITE.CREATE_BUTTON\" translate-values=\"{domain: obj.domainn}\"></a> <a class=\"wt-dropdown-item\" \nng-click=\"vm.transferWebsite()\" translate=\"WEBSITE.MIGRATE_BUTTON\"></a> <a class=\"wt-dropdown-item\" \nng-click=\"vm.registerDomain()\" translate=\"DOMAINS.REGISTER_BUTTON\"></a> <a ng-if=\"vm.isAgency()\" \nclass=\"wt-dropdown-item\" ng-href=\"{{vm.registerAccountUrl}}\" target=\"_blank\" translate=\"CREATE_CUSTOMER_ACCOUNT\"></a>\n</wt-dropdown-button></div></div></header><div class=\"dashboard-items\"><div \nclass=\"card dashboard-item website-list-mini\"><header><div class=\"row\"><div class=\"col-8\"><h4 \ntranslate=\"DASHBOARD.WEBSITES.HEADING\"></h4></div><div ng-if=\"vm.objects.length > 0\" class=\"col-4 right\"><a \nhref=\"/website/list/\" translate=\"DASHBOARD.VIEW_ALL\"></a></div></div></header><hr class=\"section-divider\"><div \nclass=\"body\"><div ng-if=\"vm.objects.length > 0\" class=\"table website-list\"><ng-include \nsrc=\"\'app/main/wooadmin/models/modellistheaders.html\'\"></ng-include><ng-include \nsrc=\"\'app/main/wooadmin/models/modellistitems.html\'\"></ng-include></div><p ng-if=\"vm.objects.length == 0\" \ntranslate=\"DASHBOARD.WEBSITES.EMPTY\"></p></div></div><div class=\"card dashboard-item bandwidth\" \nng-repeat=\"bw in [vm.bw]\"><header><div class=\"row\"><div class=\"col-6\"><h4 translate=\"DASHBOARD.BANDWIDTH.HEADING\"></h4>\n</div><div class=\"col-6 right date\">{{bw.month}}</div></div></header><hr class=\"section-divider\"><div class=\"body\"><div\n class=\"donut-chart\"><svg viewBox=\"0 0 32 32\"><circle ng-if=\"bw.current\" r=\"16\" cx=\"16\" cy=\"16\" \nstyle=\"stroke-dasharray: {{ bw.current / bw.max * 100 }} 100\"/></svg><div class=\"donut-center\"></div></div><div \nclass=\"numbers\"><p class=\"title\" translate=\"DASHBOARD.BANDWIDTH.USED\"></p><p class=\"data\">{{bw.current}} <span \ntranslate=\"DASHBOARD.BANDWIDTH.OF\"></span> {{bw.max}}{{bw.unit}}</p></div></div></div><div \nclass=\"card dashboard-item billing\"><header><div class=\"row\"><div class=\"col-8\"><h4 \ntranslate=\"DASHBOARD.BILLING.HEADING\"></h4></div><div class=\"col-4 right\"><a ng-if=\"!vm.isAccountSharing\" \nng-href=\"{{vm.billing_url}}\" target=\"templio-account\" translate=\"DASHBOARD.VIEW_ALL\"></a></div></div></header><hr \nclass=\"section-divider\"><div class=\"body\"><div ng-if=\"vm.orders.length > 0\" class=\"table\" \nng-class=\"{\'is-account-sharing\': vm.isAccountSharing}\"><div class=\"row no-gutters table-head\"><div class=\"date\" \ntranslate=\"DASHBOARD.BILLING.DATE\"></div><div class=\"amount\" translate=\"DASHBOARD.BILLING.AMOUNT\"></div></div><div \nclass=\"row no-gutters table-row\" ng-repeat=\"o in vm.orders\" ng-click=\"vm.gotoInvoice(o)\"><div class=\"date\">{{o.date}} \n<span ng-if=\"o.status == \'completed\'\" class=\"templ-badge small green\" translate=\"DASHBOARD.BILLING.PAID\"></span> <span \nng-if=\"o.status == \'pending\'\" class=\"templ-badge small gray\" translate=\"DASHBOARD.BILLING.PENDING\"></span> <span \nng-if=\"o.status == \'awaiting-renewal\'\" class=\"templ-badge small gray\" translate=\"DASHBOARD.BILLING.AWAITING_RENEWAL\">\n</span> <span ng-if=\"o.status == \'cancelled\'\" class=\"templ-badge small red\" translate=\"DASHBOARD.BILLING.CANCELLED\">\n</span></div><div class=\"amount\"><span ng-if=\"vm.subscriptionCurrency == \'USD\'\">$</span>{{vm.orderTotal(o)}}<span \nng-if=\"vm.subscriptionCurrency == \'SEK\'\">kr</span></div></div></div><p ng-if=\"vm.orders.length == 0\" \ntranslate=\"DASHBOARD.BILLING.EMPTY\"></p></div></div><div class=\"dashboard-item support\" \nng-style=\"{\'background-image\': \'url(\'+vm.todays_staff_image()+\')\'}\"><img ng-if=\"vm.lang == \'sv\'\" \nsrc=\"/assets/images/support-text-sv.svg\" alt=\"En hjälpande hand.\" width=\"280\" height=\"31\"> <img \nng-if=\"vm.lang == \'en\'\" src=\"/assets/images/support-text-en.svg\" alt=\"A helping hand.\" width=\"222\" height=\"31\"><p \ntranslate=\"DASHBOARD.SUPPORT.TEXT\"></p><button class=\"btn btn-outline-primary\" ng-click=\"vm.chat()\" \ntranslate=\"DASHBOARD.SUPPORT.BUTTON\"></button></div></div></div>");
$templateCache.put("app/main/dnszone/details.html","<div id=\"dns_record_list\" ui-view=\"dns_record_list\"></div>");
$templateCache.put("app/main/dnszone/dns-presets.html","<div ng-controller=\"DnsPresets as vm\"><p>hello</p></div>");
$templateCache.put("app/main/dnszone/record-edit.html","<h1 ng-if=\"!vm.obj.name\" translate=\"DOMAINS.ADD_DNS_RECORD\">Add DNS record</h1><h1 ng-if=\"vm.obj.name\" \ntranslate=\"DOMAINS.EDIT_DNS_RECORD\">Edit DNS record</h1><form name=\"modelForm\" layout=\"column\" \nng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.continue()\" novalidate=\"novalidate\"><input type=\"submit\" \nstyle=\"position: absolute; left: -9999px; width: 1px; height: 1px\"><wt-form class=\"wt-form\" wt-form=\"form\" \nwt-obj=\"obj\"></wt-form><div class=\"buttons\"><div class=\"button-container delete\"><button ng-if=\"!vm.no_delete\" \ntype=\"button\" ng-click=\"vm.delete()\" class=\"btn btn-danger\" translate=\"WOOADMIN.DELETE\">Delete</button></div><div \nclass=\"button-container cancel\"><button ng-click=\"vm.cancel()\" type=\"button\" class=\"btn btn-outline-primary\" \ntranslate=\"WEBSITE.CANCEL\">Cancel</button></div><div class=\"button-container save\"><button ng-click=\"vm.continue()\" \ntype=\"submit\" ng-disabled=\"modelForm.$invalid || vm.isSaving\" class=\"btn btn-primary\" translate=\"WEBSITE.SAVE\">Save\n</button></div></div></form>");
$templateCache.put("app/main/dnszone/record_list_item.html","<div class=\"table-row no-gutters row\"><div class=\"name\">{{vm.list.get_name(obj) || obj._id}}</div><div class=\"type\">\n{{obj.kind}}</div><div class=\"ttl\">{{obj.ttl}}</div><div class=\"value\">{{obj.data.toString().replaceAll(\",\", \"\\n\")}}\n</div></div>");
$templateCache.put("app/main/dnszone/records.html","<h2>Hello records</h2><ng-include src=\"app/main/wooadmin/models/modellist.html\"><ng-include></ng-include></ng-include>");
$templateCache.put("app/main/dnszone/verification-record-modal.html","<h1 translate=\"DNSRECORD.VERIFICATION_RECORD.MODAL.TITLE\"></h1><form name=\"verificationForm\" layout=\"column\" \nng-submit=\"!verificationForm.$invalid && !vm.isSaving && vm.ok()\" novalidate=\"novalidate\"><input type=\"submit\" \nstyle=\"position: absolute; left: -9999px; width: 1px; height: 1px\"><wt-form class=\"wt-form\" wt-form=\"form\" \nwt-obj=\"obj\"></wt-form><p translate=\"DNSRECORD.VERIFICATION_RECORD.MODAL.DESC\"></p><div class=\"form-group\"><label \nfor=\"verificationValue\" translate=\"DNSRECORD.VERIFICATION_RECORD.MODAL.TXT_VALUE_LABEL\"></label><input type=\"text\" \nclass=\"form-control\" id=\"verificationValue\" ng-model=\"vm.verificationValue\" required></div><div \nclass=\"button-container\"><button ng-click=\"vm.cancel()\" type=\"button\" class=\"btn btn-outline-primary\" \ntranslate=\"WEBSITE.CANCEL\"></button> <button ng-click=\"vm.ok()\" type=\"submit\" \nng-disabled=\"verificationForm.$invalid || vm.isSaving\" class=\"btn btn-primary\" \ntranslate=\"DNSRECORD.VERIFICATION_RECORD.MODAL.SAVE_BTN\"></button></div></form>");
$templateCache.put("app/main/domains/domain-details.html","<div class=\"detail-list domain-details\"><div ng-if=\"vm.isAdmin\"><section class=\"edit-website\"><h3>Admin Settings</h3>\n<div class=\"row\"><div class=\"col-12\"><div class=\"button-container\"><a class=\"btn btn-success\" \nui-sref=\"app.wooadmin.domain-edit({id:vm.id})\" translate=\"WOOADMIN.ADMIN\"></a> <a class=\"btn btn-success\" \nui-sref=\"app.domain.edit({id:vm.id})\" translate=\"WOOADMIN.EDIT\"></a></div></div></div></section><hr \nclass=\"section-divider\"></div><div ng-if=\"obj.zone.registration.id\"><section \nclass=\"restart-server button-with-description\"><h3 data-block=\"title\" translate=\"DOMAINS.REGISTRATION.TITLE\"></h3><p \nng-if=\"!vm.has_expired(obj)\" data-block=\"description\" translate=\"DOMAINS.REGISTRATION.DESC\"></p><p \nng-if=\"vm.has_expired(obj)\" data-block=\"description\" translate=\"DOMAINS.REGISTRATION.DESC_EXPIRED\"></p><p><span \nclass=\"renewal-date-label\" translate=\"DOMAINS.LIST.RENEWAL_DATE\"></span><wt-renewal-date \nwt-time=\"{{obj.zone.registration.details.renewalDate}}\" \nwt-auto-renewal=\"{{obj.zone.registration && obj.zone.registration.details.autoRenewal}}\"></wt-renewal-date></p><button \nng-click=\"vm.editRegistration(obj.zone.registration.id)\" class=\"btn btn-primary\" \nng-disabled=\"!vm.isAdmin && (vm.get_reg_state(obj) == \'REGISTERING\' || vm.get_reg_state(obj) == \'TRANSFERING\')\" \ntranslate=\"DOMAINS.REGISTRATION.EDIT_BTN\"></button></section><hr class=\"section-divider\"></div><section class=\"basics\">\n<h3 translate=\"DOMAINS.SECTION_BASICS\">Basics</h3><div class=\"row\"><div class=\"col-12 col-sm-6 col-xl-4\"><wt-field \nwt-obj=\"obj\" wt-form=\"form\" wt-field=\"name\" wt-details=\"true\"></wt-field><a ng-href=\"https://{{obj.name}}\" \ntarget=\"_blank\" class=\"arrow-icon arrow-right visit-domain\" translate=\"DOMAINS.VISIT_DOMAIN\"></a></div><div \nclass=\"col-12 col-sm-6 col-xl-4\"><wt-field ng-if=\"obj.app\" wt-obj=\"obj\" wt-form=\"form\" wt-field=\"app\" \nwt-details=\"true\"></wt-field><div ng-if=\"!obj.app\"><label for=\"domain-app\" translate=\"DOMAINS.WEBSITE\">Website</label>\n<input type=\"text\" class=\"form-control monospace disabled\" id=\"domain-app\" \nvalue=\"{{\'DOMAINS.NO_WEBSITE_SELECTED\' | translate}}\" disabled=\"disabled\"></div><a ng-if=\"obj.app\" \nui-sref=\"app.website.details({id:obj.app._id})\" class=\"arrow-icon arrow-right\" translate=\"DOMAINS.GO_TO_WEBSITE\"></a>\n</div><div class=\"col-12 col-sm-6 col-xl-4 managed\"><a ng-if=\"vm.zone.managed\" class=\"tooltip\" \nng-attr-data-tooltip=\"{{\'DOMAINS.TOOLTIPS.MANAGED_YES\' | translate}}\" tabindex=\"0\"><span>i</span> </a><a \nng-if=\"!vm.zone.managed\" class=\"tooltip\" ng-attr-data-tooltip=\"{{\'DOMAINS.TOOLTIPS.MANAGED_NO\' | translate}}\" \ntabindex=\"0\"><span>i</span></a><wt-field wt-obj=\"zone\" wt-label=\"DOMAINS.MANAGED\" wt-field=\"managed\" \nwt-type=\"checkbox\" wt-details=\"true\"></wt-field></div><div ng-if=\"vm.zone.managed && vm.zone.name_servers.length>0\" \nclass=\"col-12 col-sm-6 col-xl-4\"><wt-field wt-obj=\"zone\" wt-label=\"DOMAINS.NAMESERVERS\" wt-field=\"name_servers\" \nwt-type=\"list\" wt-details=\"true\"></wt-field></div></div></section><hr class=\"section-divider\"><section \nclass=\"advanced\"><h3 translate=\"DOMAINS.SECTION_ADVANCED\">Advanced</h3><div class=\"row\"><div \nclass=\"col-12 col-sm-6 col-xl-4\"><wt-field wt-obj=\"zone\" wt-label=\"Zone\" wt-field=\"domain\" wt-details=\"true\">\n</wt-field></div><div class=\"col-12 col-sm-6 col-xl-4\"><wt-field wt-obj=\"obj\" wt-field=\"ssl\" wt-details=\"true\">\n</wt-field></div></div></section><div ng-if=\"!obj.zone.registration\"><hr class=\"section-divider\"><section \nclass=\"whois\"><h3 translate=\"DOMAINS.WHOIS.TITLE\"></h3><div class=\"row\"><div class=\"col-12\"><wt-whois \nwt-domain-name=\"obj.zone.domain\"></wt-whois></div></div><a ng-if=\"vm.isTransferable(obj.zone.domain)\" \nng-click=\"vm.transferToTempl(obj.zone.domain)\" class=\"btn btn-primary\" translate=\"DOMAINS.WHOIS.TRANSFER_TO_TEMPL\"></a>\n</section></div><div ng-if=\"!obj.ssl && vm.status!=\'working\'\"><hr class=\"section-divider\"><section \nclass=\"button-with-description\"><h3 translate=\"DOMAINS.ADD_SSL_TITLE\">Add SSL</h3><p translate=\"DOMAINS.ADD_SSL_DESC\">\nAdd SSL certificate.</p><button class=\"btn btn-primary\" ng-click=\"vm.add_certificate()\" \ntranslate=\"DOMAINS.ADD_SSL_BTN\"></button></section></div><div ng-if=\"obj.zone.managed\"><hr class=\"section-divider\">\n<section class=\"restart-server button-with-description\"><h3 data-block=\"title\" translate=\"DOMAINS.DNS_SETTINGS\">\nDNS Records</h3><p data-block=\"description\" translate=\"DOMAINS.DNS_SETTINGS_DESC\">DNS Settings</p><a \nui-sref=\"app.dnszone.details({id:obj.zone._id})\" data-block=\"button\" class=\"btn btn-primary\" \ntranslate=\"DOMAINS.EDIT_DNS_SETTINGS\">Edit DNS Settings</a></section></div><div><hr class=\"section-divider\"><section \nclass=\"restart-server button-with-description\"><h3 data-block=\"title\" translate=\"DOMAINS.DELETE_DOMAIN\">Delete Domain\n</h3><p data-block=\"description\" translate=\"DOMAINS.DELETE_DOMAIN_DESC\">Lorem ipsum.</p><button ng-click=\"vm.delete()\" \nng-disabled=\"vm.status==\'working\' || !vm.can_be_deleted(obj)\" data-block=\"button\" class=\"btn btn-danger\" \ntranslate=\"WOOADMIN.DELETE\">Delete</button></section></div></div>");
$templateCache.put("app/main/domains/domains.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/main/domains/list_item.html","<div class=\"table-row no-gutters row\"><div class=\"name\">{{vm.list.get_name(obj) || obj._id}}<wt-domain-status-badge \nwt-domain-obj=\"{{obj}}\"></wt-domain-status-badge></div><div class=\"website\"><a ng-if=\"obj.app\" \nui-sref=\"app.website.details({id: obj.app._id || obj.app})\">{{obj.app.name || \'-\'}} </a><span ng-if=\"!obj.app\" \nclass=\"text-muted\">-</span></div><div class=\"renewal-date\"><span ng-if=\"vm.get_reg_state(obj) != \'REGISTERED\'\" \nclass=\"no-renewal-date\">-</span><wt-renewal-date ng-if=\"vm.get_reg_state(obj) == \'REGISTERED\'\" \nwt-time=\"{{obj.zone.registration.details.renewalDate}}\" \nwt-auto-renewal=\"{{obj.zone.registration && obj.zone.registration.details.autoRenewal}}\"></wt-renewal-date></div><div \nclass=\"auto-renew\"><span ng-if=\"vm.get_reg_state(obj) == \'REGISTERED\' && obj.zone.registration.details.autoRenewal\" \nclass=\"templ-badge small green\" translate=\"ON\"></span> <span \nng-if=\"vm.get_reg_state(obj) == \'REGISTERED\' && !obj.zone.registration.details.autoRenewal\" \nclass=\"templ-badge small red\" translate=\"OFF\"></span></div><div class=\"status\"><ng-include \nsrc=\"\'app/main/wooadmin/models/modelstatusicon.html\'\"></ng-include><wt-dropdown-button wt-button-text=\"QUICK_ACTIONS\" \nwt-button-class=\"btn btn-quick-actions\"><a class=\"wt-dropdown-item\" ng-href=\"https://{{obj.zone.domain}}\" \ntarget=\"_blank\" translate=\"DOMAINS.VISIT_DOMAIN\"></a> <a ng-if=\"vm.has_site(obj)\" class=\"wt-dropdown-item\" \nui-sref=\"app.website.details({id:obj.app._id || obj.app})\" translate=\"DOMAINS.GO_TO_WEBSITE\"></a> <a \nng-if=\"obj.zone.registration.id\" class=\"wt-dropdown-item\" ng-click=\"vm.editRegistration(obj.zone.registration.id)\" \ntranslate=\"DOMAINS.REGISTRATION.EDIT_BTN\"></a> <a ng-if=\"obj.zone.managed\" class=\"wt-dropdown-item\" \nui-sref=\"app.dnszone.details({id:obj.zone._id})\" translate=\"DOMAINS.EDIT_DNS_SETTINGS\"></a></wt-dropdown-button></div>\n</div>");
$templateCache.put("app/main/extended-support/extended-support-horizontal.html","<div class=\"extended-support horizontal row\"><div class=\"support-task col-xl-3 col-lg-6\"><ng-include \nsrc=\"\'app/main/extended-support/tasks/wordpress-updates.html\'\"></ng-include></div><div \nclass=\"support-task col-xl-3 col-lg-6\"><ng-include src=\"\'app/main/extended-support/tasks/debugging.html\'\"></ng-include>\n</div><div class=\"support-task col-xl-3 col-lg-6\"><ng-include src=\"\'app/main/extended-support/tasks/stress-test.html\'\">\n</ng-include></div><div class=\"support-task col-xl-3 col-lg-6\"><ng-include \nsrc=\"\'app/main/extended-support/tasks/coding.html\'\"></ng-include></div><div class=\"support-task col-xl-3 col-lg-6\">\n<ng-include src=\"\'app/main/extended-support/tasks/speed-optimization.html\'\"></ng-include></div><div \nclass=\"support-task col-xl-3 col-lg-6\"><ng-include src=\"\'app/main/extended-support/tasks/html-css.html\'\"></ng-include>\n</div></div>");
$templateCache.put("app/main/extended-support/extended-support-vertical.html","<div class=\"extended-support vertical\"><div class=\"support-task\"><ng-include \nsrc=\"\'app/main/extended-support/tasks/wordpress-updates.html\'\"></ng-include></div><hr class=\"section-divider\"><div \nclass=\"support-task\"><ng-include src=\"\'app/main/extended-support/tasks/debugging.html\'\"></ng-include></div><hr \nclass=\"section-divider\"><div class=\"support-task\"><ng-include src=\"\'app/main/extended-support/tasks/stress-test.html\'\">\n</ng-include></div><hr class=\"section-divider\"><div class=\"support-task\"><ng-include \nsrc=\"\'app/main/extended-support/tasks/coding.html\'\"></ng-include></div><hr class=\"section-divider\"><div \nclass=\"support-task\"><ng-include src=\"\'app/main/extended-support/tasks/speed-optimization.html\'\"></ng-include></div><hr\n class=\"section-divider\"><div class=\"support-task\"><ng-include src=\"\'app/main/extended-support/tasks/html-css.html\'\">\n</ng-include></div></div>");
$templateCache.put("app/main/fileaccess/accesskey-details.html","<div class=\"detail-list accesskey-details\"><section class=\"basics\"><div class=\"row\"><div \nclass=\"col-12 col-sm-6 col-xl-4\"><wt-field wt-obj=\"obj\" wt-field=\"name\" wt-form=\"form\" wt-details=\"true\"></wt-field>\n</div><div class=\"col-12 col-sm-6 col-xl-4\"><wt-field wt-obj=\"obj\" wt-form=\"form\" wt-field=\"add_to_all\" \nwt-type=\"checkbox\" wt-details=\"true\"></wt-field></div><div class=\"col-12 col-sm-6 col-xl-4\"><wt-field wt-obj=\"obj\" \nwt-form=\"form\" wt-field=\"apps\" wt-type=\"multiselect\" wt-details=\"true\"></wt-field></div></div></section></div>");
$templateCache.put("app/main/fileaccess/fileaccess.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/main/graphs/example.html","<h1>Examples</h1><uib-tabset active=\"vm.initial_tab\"><uib-tab heading=\"Gauge\"><div google-chart chart=\"vm.myGraph\" \nagc-on-select=\"vm.hideSeries(selectedItem)\" style=\"height:430px\"></div></uib-tab><uib-tab heading=\"Graph\"><div \ngoogle-chart chart=\"vm.myGauge\" style=\"height:130px\"></div></uib-tab><uib-tab heading=\"Annotations\"><div google-chart \nchart=\"vm.myAnnotations\" style=\"height:400px\"></div></uib-tab></uib-tabset>");
$templateCache.put("app/main/graphs/graphs.html","<h1>Graphs for {{vm.app.name}}</h1><div \nng-init=\"vm.testData=[\n{cpu_limit:{ labels:[\'time\',\'used\'],data:[\n[1,1],[2,2]\n]}}\n]\"></div><input name=\"after\" \nid=\"after_300\" type=\"radio\" value=\"-300\" ng-model=\"vm.after\" checked=\"true\"><label for=\"after_300\">5 Minutes</label>\n<input name=\"after\" id=\"after_3600\" type=\"radio\" value=\"-3600\" ng-model=\"vm.after\"><label for=\"after_3600\">1 Hour\n</label><input name=\"after\" id=\"after_21600\" type=\"radio\" value=\"-21600\" ng-model=\"vm.after\"><label for=\"after_21600\">\n6 Hours</label><input name=\"after\" id=\"after_43200\" type=\"radio\" value=\"-43200\" ng-model=\"vm.after\"><label \nfor=\"after_43200\">12 Hours</label><input name=\"after\" id=\"after_86400\" type=\"radio\" value=\"-86400\" ng-model=\"vm.after\">\n<label for=\"after_86400\">24 Hours</label><label for=\"points\">points</label><input name=\"points\" type=\"text\" \nng-model=\"vm.points\"><label for=\"group\">group</label><select name=\"group\" ng-model=\"vm.group\"><option value=\"max\" \ntranslate=\"max\"></option><option value=\"min\" translate=\"min\"></option><option value=\"average\" translate=\"average\">\n</option><option value=\"median\" translate=\"median\"></option><option value=\"sum\" translate=\"sum\"></option><option \nvalue=\"incremental-sum\" translate=\"incremental-sum\"></option></select><button ng-click=\"vm.loadData()\">Load</button>\n<label for=\"curve\">Curve</label><input name=\"curve\" type=\"checkbox\" ng-model=\"vm.curve\"><label for=\"material\">Material\n</label><input name=\"material\" type=\"checkbox\" ng-model=\"vm.material\"><label for=\"chartType\">Chart Type</label><select \nname=\"chartType\" ng-model=\"vm.chartType\"><option value=\"LineChart\" translate=\"Line Chart\"></option><option \nvalue=\"AreaChart\" translate=\"Area Chart\"></option></select><div class=\"\" ng-if=\"vm.chartType==\'AreaChart\'\"><label \nfor=\"stacked\">Stacked</label><input name=\"stacked\" type=\"checkbox\" ng-model=\"vm.stacked\"></div><div \nng-repeat=\"g in vm.graphs\"><label for=\"{{g.name}}\">Hide {{g.name}}</label><input name=\"{{g.name}}\" type=\"checkbox\" \nng-model=\"g.disabled\"><div ng-show=\"!g.disabled\" my-googlechart chart=\"g.obj\" ng-class=\"g.class\"></div><label \nng-if=\"g.chart_options\" for=\"generic_ctype\"><select class=\"\" ng-model=\"g.ctype\" name=\"generic_ctype\"><option \nng-repeat=\"opt in g.chart_options\" value=\"{{opt.value||opt}}\">{{opt.name||opt}}</option></select></label></div><ul><li \nng-repeat=\"app in vm.apps\"><div ng-class=\"{\'selected\':app.id==vm.app.id}\"><a ng-click=\"vm.select_app(app)\">{{app.name}}\n</a></div></li></ul>");
$templateCache.put("app/main/help/help.html","<div class=\"details_template\" layout=\"column\" flex layout-fill layout-padding><div class=\"details_template\" \nlayout=\"column\"><h1>Need help?</h1><p>Checkout the<md-button ng-click=\"vm.openQuick()\">USER GUIDE</md-button>\n(can also be opened via<md-icon md-font-icon=\"icon-format-list-bulleted\" ng-click=\"vm.openQuick()\"></md-icon>\nin top right). You can also find the user guide here: <a href=\"https://wootemple.com/wootemple-initial-setup-guide/\" \ntarget=\"_blank\">User Guide</a></p><p>\nIf you\'ve encountered a bug or other issue, please check the list of known issues, or report a new one here: <a \nhref=\"https://wootemple.com/known-issues/\" target=\"_blank\">Known Issues/Report New Issue</a></p><p>\nIf you need further assistance or have other questions, please<md-button ng-click=\"vm.openChat()\">Open the Chat\n</md-button>and let us know.</p></div></div>");
$templateCache.put("app/main/host/details.html","<div class=\"\"><a ui-sref=\"app.website.details({id:vm.Object.app._id})\">Back</a></div><h3><a ng-href=\"{{vm.data_host}}\">\nNetdata: {{vm.data_host}}</a></h3><script type=\"text/ng-template\" id=\"google-graph.html\">\n<button ng-click=\"vm.show_netdata[n.tag]=!vm.show_netdata[n.tag]\">{{n.title}}</button>\n<div ng-if=\"vm.show_netdata[n.tag]\" data-netdata=\"{{n.tag}}\"\n    data-host=\"{{vm.data_host}}\"\n    data-title=\"{{n.title}}\"\n    data-units=\"{{n.units||\'%\'}}\"\n    data-chart-library=\"google\"\n    data-google-min-value=\"{{n.min}}\"\n    data-width=\"{{n.width||vm.graph_height||600}}\"\n    data-legend=\"no\"\n    data-height=\"{{n.height||vm.graph_height||120}}\"\n    data-after=\"-600\"\n    >\n</div>\n</script><script type=\"text/ng-template\" id=\"easypie.html\">\n<button ng-click=\"vm.show_netdata[n.tag]=!vm.show_netdata[n.tag]\">{{n.title}}</button>\n    <div ng-if=\"vm.show_netdata[n.tag]\" data-netdata=\"{{n.tag}}\"\n        data-host=\"{{vm.data_host}}\"\n        data-title=\"{{n.title}}\"\n        data-chart-library=\"easypiechart\"\n        data-width=\"{{n.height||vm.graph_height||120}}\"\n        data-height=\"{{n.height||vm.graph_height||120}}\"\n        data-easypiechart-max-value={{m.max}}\n        data-after=\"-600\">\n    </div>\n</script><div class=\"\"><h2>System</h2><ul><li>CPU Shares: {{vm.cpu_total}} ({{vm.cpu_available}})<wt-tooltip \nwt-text=\"Total CPU shares (CPU shares available). One CPU share is 1/64th of a full CPU.\"></wt-tooltip></li><li>\nRAM: {{vm.ram_total}} ({{vm.ram_available}})<wt-tooltip wt-text=\"Total RAM (RAM available) in Gb..\"></wt-tooltip></li>\n</ul><ng-include src=\"\'google-graph.html\'\" ng-repeat=\"n in [vm.app.cpu_graph]\"></ng-include><ng-include \nsrc=\"\'easypie.html\'\" ng-repeat=\"n in [vm.app.ram_graph]\"></ng-include><h2>Timers</h2><ng-include \nsrc=\"\'google-graph.html\'\" ng-repeat=\"n in [vm.timers.cpu_graph]\"></ng-include><ng-include src=\"\'easypie.html\'\" \nng-repeat=\"n in [vm.timers.ram_graph]\"></ng-include></div><div class=\"\" ng-repeat=\"c in vm.containers\"><h2>{{c.name}}\n</h2><div class=\"\"><ul><li>CPU Shares: {{c.cpu}}, Quota: {{c.cpuQ}}<wt-tooltip \nwt-text=\"CPU Shares of this container. Quota is maximum % of CPU allowed.\"></wt-tooltip></li><li>RAM: {{c.ram}}</li><li\n ng-if=\"c.has_staging\">Has staging</li><li ng-if=\"c.properties.length>0\">Properties:<ul><li \nng-repeat=\"prop in c.properties\">{{prop.name}} = {{prop.value}}</li></ul></li></ul><a \nui-sref=\"app.website.details({id:c.app})\">Site details</a></div><ng-include src=\"\'google-graph.html\'\" \nng-repeat=\"n in [c.cpu_graph]\"></ng-include><ng-include src=\"\'easypie.html\'\" ng-repeat=\"n in [c.ram_graph]\">\n</ng-include><ng-include src=\"\'google-graph.html\'\" ng-repeat=\"n in [c.io_graph]\"></ng-include></div>");
$templateCache.put("app/main/host/netdata.html","<h2 translate=\"{{vm.title}}\"></h2><div \nng-init=\"vm.cpu_graph=\'google\'; vm.graph_height=120; vm.ram_graph=\'easypiechart\'; vm.ram_max=8192\"><input \ndisabled=\"true\" ng-model=\"vm.cpu_graph\"><input disabled=\"true\" ng-model=\"vm.ram_graph\"></div><button \nng-click=\"vm.refresh()\">Refresh</button><div class=\"\"><h3>System CPU Usage</h3><div data-netdata=\"system.cpu\" \ndata-host=\"{{vm.data_host}}\" data-title=\"System CPU usage\" data-units=\"%\" data-chart-library=\"{{vm.cpu_graph}}\" \ndata-google-min-value=\"{{vm.cpu_max||200}}\" data-width=\"600\" data-legend=\"no\" data-height=\"{{vm.graph_height}}\" \ndata-after=\"-600\"></div><div data-netdata=\"mem.available\" data-host=\"{{vm.data_host}}\" \ndata-title=\"System RAM available\" data-chart-library=\"easypiechart\" data-width=\"{{vm.graph_height}}\" \ndata-height=\"{{vm.graph_height}}\" data-easypiechart-max-value=\"{{vm.ram_max}}\" data-after=\"-600\"></div></div><div \nclass=\"\" ng-repeat=\" c in vm.containers\"><h3>{{c.name}} CPU Usage</h3><div data-netdata=\"{{c.slice}}.cpu\" \ndata-host=\"{{vm.data_host}}\" data-title=\"{{c.name}} CPU\" data-units=\"%\" data-chart-library=\"{{vm.cpu_graph}}\" \ndata-google-min-value=\"{{c.cpu_min||25}}\" data-legend=\"no\" data-width=\"600\" data-height=\"{{vm.graph_height}}\" \ndata-after=\"-600\"></div><div data-netdata=\"{{c.slice}}.mem\" data-host=\"{{vm.data_host}}\" \ndata-title=\"{{c.name}} RAM used\" data-chart-library=\"{{vm.ram_graph}}\" data-width=\"{{vm.graph_height}}\" \ndata-height=\"{{vm.graph_height}}\" data-easypiechart-max-value=\"{{c.ram_max||1024}}\" data-after=\"-600\"></div></div>");
$templateCache.put("app/main/incident/incident-details.html","<div ng-if=\"vm.isAdmin\"><section class=\"edit-website\"><h3>Admin Settings</h3><div class=\"row\"><div class=\"col-12\"><div \nclass=\"button-container\"><a ng-if=\"vm.isAdmin\" ui-sref=\"app.wooadmin.incident-edit({id:vm.id})\" \nclass=\"btn btn-success\" translate=\"WOOADMIN.ADMIN\"></a></div></div></div></section><hr class=\"section-divider\"></div>\n<section class=\"incidents about\"><h3 translate=\"INCIDENT.ABOUT_VULN_TITLE\"></h3><p \ntranslate=\"INCIDENT.VULN_REPORT_INTRO\"></p><a chat-launcher href=\"#\" class=\"btn btn-primary\" translate=\"CHAT_WITH_US\">\n</a></section><section class=\"incidents actions admin-only\" ng-if=\"vm.isAdmin\"><h3 \ntranslate=\"INCIDENT.RESOLVE_VULN_TITLE\">Resolve Vulnerabilities</h3><p translate=\"INCIDENT.RESOLVE_VULN_DESC\">\nYou can ...</p><div class=\"button-container\"><button class=\"btn btn-primary\" ng-click=\"vm.fix()\" \ntranslate=\"INCIDENT.FIX_BUTTON\"></button> <button class=\"btn btn-outline-primary reload\" ng-click=\"vm.check_again()\" \ntranslate=\"INCIDENT.RECHECK_BUTTON\"></button></div></section><hr class=\"section-divider\"><section \nclass=\"incidents core-incidents\" ng-repeat=\"opts in [{section:\'core\'}]\"><div class=\"incident\" \nng-repeat=\"vuln in vm.vulns.wpversion\"><h4 translate=\"INCIDENT.WORDPRESS_CORE_VULN_TITLE\" \ntranslate-values=\"{version:vuln.my_version}\"></h4><p ng-if=\"vuln.fixed_in\" class=\"fixed-in\" translate=\"VULN_FIXED_IN\" \ntranslate-values=\"{fixed_in:\'{{vuln.fixed_in}}\'}\"></p><p ng-if=\"!vuln.fixed_in\" class=\"fixed-in\" \ntranslate=\"VULN_FIX_UNKNOWN\"></p><div class=\"wrap-collabsible reference-links\"><input id=\"core-vuln-references\" \ntype=\"checkbox\" class=\"collapsible-checkbox\"><label for=\"core-vuln-references\" class=\"collapsible-label\" \ntranslate=\"INCIDENT.VULN_REFERENCE_LINKS\"></label><div class=\"collapsible-content\"><a \nng-repeat=\"url in vuln.references\" target=\"_blank\" class=\"target-blank\" ng-href=\"{{url}}\">{{url}}</a></div></div></div>\n</section><hr ng-if=\"(vm.vulns.plugs).length > 0\" class=\"section-divider\"><section ng-if=\"(vm.vulns.plugs).length > 0\" \nclass=\"incidents plugin-incidents\" ng-repeat=\"opts in [{section:\'plugin\'}]\"><h3 translate=\"INCIDENT.PLUGIN_VULN_TITLE\">\nPlugin Vulnerabilities</h3><div class=\"incident\" ng-repeat=\"vuln in vm.vulns.plugins || vm.vulns.plugs\"><ng-include \nsrc=\"\'vulnerability-detail.htm\'\"></ng-include></div></section><hr ng-if=\"(vm.vulns.themes).length > 0\" \nclass=\"section-divider\"><section ng-if=\"(vm.vulns.themes).length > 0\" class=\"incidents theme-incidents\" \nng-repeat=\"opts in [{section:\'theme\'}]\"><h3 translate=\"INCIDENT.THEME_VULN_TITLE\">Theme Vulnerabilities</h3><div \nclass=\"incident\" ng-repeat=\"vuln in vm.vulns.themes\"><ng-include src=\"\'vulnerability-detail.htm\'\"></ng-include></div>\n</section><script type=\"text/ng-template\" id=\"vulnerability-detail.htm\">\n<h4>{{vuln.obj_name}} {{vuln.my_version}} <span translate=\"VULN_IS_VULNERABLE\"></span></h4>\n      \n      <p ng-if=\"vuln.fixed_in\" class=\"fixed-in\" translate=\"VULN_FIXED_IN\" translate-values=\"{fixed_in:\'{{vuln.fixed_in}}\'}\"></p>\n      <p ng-if=\"!vuln.fixed_in\" class=\"fixed-in\" translate=\"VULN_FIX_UNKNOWN\"></p>\n\n      <div class=\"wrap-collabsible reference-links\">\n        <input id=\"{{opts.section}}-incident-{{$index}}\" type=\"checkbox\" class=\"collapsible-checkbox\">\n        <label for=\"{{opts.section}}-incident-{{$index}}\" class=\"collapsible-label\" translate=\"INCIDENT.VULN_REFERENCE_LINKS\"></label>\n        <div class=\"collapsible-content\">\n          <a ng-repeat=\"url in vuln.references\" target=\"_blank\" class=\"target-blank\" ng-href=\"{{url}}\">{{url}}</a>\n        </div>\n      </div>\n</script>");
$templateCache.put("app/main/incident/otherincident.html","<ng-include src=\"\'app/main/snippets/admin.html\'\"></ng-include><section class=\"incidents other-incident\"><div \nng-if=\"!vm.obj.open\" class=\"alert alert-success\" role=\"alert\"><p translate=\"INCIDENT.CLOSED\" \ntranslate-values=\"vm.object.closed\"></p></div><div ng-if=\"vm.obj.open\" class=\"alert alert-danger\" role=\"alert\"><p \ntranslate=\"INCIDENT.OPEN\" translate-values=\"vm.object.started\"></p></div><h3 \ntranslate=\"INCIDENT.TITLE_{{vm.obj.kind}}\"></h3><p translate=\"INCIDENT.ABOUT_{{vm.obj.kind}}\"></p><h3 \nclass=\"incident-errors\" translate=\"INCIDENT.ERRORS\"></h3><ul><li ng-repeat=\"err in vm.errors\">{{err}}</li></ul><h3 \nclass=\"incident-related\" translate=\"INCIDENT.RELATED\"></h3><div ng-if=\"vm.website\"><span \ntranslate=\"INCIDENT.SITE_DETAILS_PAGE\"></span> <a ui-sref=\"app.website.details({id:vm.website.id})\">{{vm.website.name}}\n</a></div><div class=\"button-with-description incident-actions\"><h3 class=\"incident-actions\" \ntranslate=\"INCIDENT.ACTIONS\"></h3><p ng-if=\"vm.obj.open\" translate=\"INCIDENT.CLOSE_DESCRIPTION\" \ntranslate-values=\"{{vm.obj.args}}\"></p><button ng-if=\"vm.obj.open\" ng-click=\"vm.close()\" class=\"btn btn-primary\" \ntranslate=\"INCIDENT.CLOSE_BUTTON\">Close</button><p ng-if=\"!vm.obj.open\" translate=\"INCIDENT.REOPEN_DESCRIPTION\" \ntranslate-values=\"{{vm.obj.args}}\"></p><button ng-if=\"!vm.obj.open\" ng-click=\"vm.reopen()\" \nclass=\"btn btn-outline-primary\" translate=\"INCIDENT.REOPEN_BUTTON\">Close</button></div></section>");
$templateCache.put("app/main/incident/scancheck.html","<ng-include src=\"\'app/main/snippets/admin.html\'\"></ng-include><section class=\"incidents about\"><h3 \ntranslate=\"INCIDENT.INTRO_SCANCHECKS\"></h3><p translate=\"INCIDENT.ABOUT_SCANCHECKS\"></p><h3 \ntranslate=\"INCIDENT.TITLE_SCANCHECKS\">About Scan-checks</h3><p>{{vm.obj.msg}}</p></section>");
$templateCache.put("app/main/incident/upcheck.html","<ng-include src=\"\'app/main/snippets/admin.html\'\"></ng-include><section class=\"incidents about\"><h3 \ntranslate=\"INCIDENT.INTRO_UPCHECKS\"></h3><p translate=\"INCIDENT.ABOUT_UPCHECKS\"></p><h3 \ntranslate=\"INCIDENT.TITLE_UPCHECKS\"></h3><p translate=\"INCIDENTS.UP_CHECK_MSG\" translate-values=\"{{vm.obj.args}}\"></p>\n</section>");
$templateCache.put("app/main/langoptions/langoptions.html","<div><h1 translate=\"LANGOPTIONS.MSG\"></h1><div></div></div>");
$templateCache.put("app/main/email/account-edit.html","<form name=\"modelForm\" layout=\"column\" ng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.continue()\" \nnovalidate=\"novalidate\"><input type=\"submit\" style=\"position: absolute; left: -9999px; width: 1px; height: 1px\">\n<wt-form wt-form=\"form\" wt-obj=\"obj\"></wt-form><ng-include src=\"\'app/main/layouts/wt-edit-buttons.html\'\"></ng-include>\n<div class=\"delete\"><button type=\"button\" ng-click=\"vm.delete()\">Delete</button></div></form>");
$templateCache.put("app/main/email/email-details.html","<div class=\"detail-list email-details\"><section class=\"basics\"><div class=\"row\"><div class=\"col-12 col-sm-6 col-xl-4\">\n<wt-field wt-value=\"{{vm.obj.get_name()}}\" wt-label=\"EMAIL.EMAILADDRESS\" wt-details=\"true\"></wt-field><a \nng-if=\"obj.domain._id\" ui-sref=\"app.domain.details({id:obj.domain._id})\" class=\"arrow-icon arrow-right\" \ntranslate=\"EMAIL.GO_TO_DOMAIN\"></a></div><div class=\"col-12 col-sm-6 col-xl-4\"><wt-field wt-obj=\"obj\" \nwt-field=\"forwards\" wt-form=\"form\" wt-type=\"list\" wt-details=\"true\"></wt-field></div></div></section></div>");
$templateCache.put("app/main/email/list_item.html","<div class=\"table-row no-gutters row\"><div class=\"name\">{{vm.list.get_name(obj) || obj._id}}</div><div \nclass=\"forwards\"><span ng-repeat=\"forward in obj.forwards\" class=\"forward\">{{forward}}</span> <span \nng-if=\"obj.forwards.length == 0\" class=\"forward\">-</span></div></div>");
$templateCache.put("app/main/email/smtp.html","<div class=\"card detail-list smtp-settings\"><div ng-if=\"vm.isAdmin\"><section class=\"edit-website\"><h3>Admin Settings\n</h3><div class=\"row\"><div class=\"col-12\"><div class=\"button-container\"><a class=\"btn btn-success\" \nui-sref=\"app.wooadmin.emailaccount-edit({id:vm.acct._id})\" translate=\"WOOADMIN.ADMIN\"></a></div></div></div></section>\n<hr class=\"section-divider\"></div><section class=\"sftp\"><h3 translate=\"EMAIL.SMTP_SETTINGS\" \ntranslate-values=\"{name:\'{{vm.acct.name}}\'}\">SMTP Settings for {{vm.acct.name}}</h3><div class=\"row\"><div \nclass=\"col-12 col-sm-6 col-xl-4\"><wt-field wt-obj=\"acct\" wt-field=\"server\" wt-details=\"true\" wt-form=\"form\"></wt-field>\n</div><div class=\"col-12 col-sm-6 col-xl-4\"><wt-field wt-obj=\"acct\" wt-field=\"username\" wt-details=\"true\" \nwt-form=\"form\"></wt-field></div><div class=\"col-12 col-sm-6 col-xl-4\"><wt-field wt-type=\"password\" wt-disabled=\"true\" \nwt-form=\"form\" wt-obj=\"acct\" wt-field=\"password\"></wt-field></div><div class=\"col-12 col-sm-6 col-xl-4\"><wt-field \nwt-obj=\"acct\" wt-field=\"ports\" wt-type=\"list\" wt-details=\"true\" wt-form=\"form\"></wt-field></div></div><a \nng-if=\"vm.isAdmin && vm.acct.external\" class=\"btn admin-only\" ng-click=\"vm.openEditView()\" translate=\"WOOADMIN.EDIT\">\n</a></section></div><div ng-if=\"vm.isAdmin\" class=\"admin-only\" id=\"account_list\" ui-view=\"account_list\"></div>");
$templateCache.put("app/main/email/verification_list_item.html","<div class=\"table-row no-gutters row\"><div class=\"domain\">{{obj.domain}}</div><div class=\"status\"><span class=\"icon\"><i\n ng-if=\"obj.verified\" class=\"status-icon status-ok\"></i> <i ng-if=\"!obj.verified\" class=\"status-icon status-waiting\">\n</i> </span><span class=\"description\"><span ng-if=\"obj.verified\" class=\"description\" \ntranslate=\"EMAIL.VERIFICATIONS.VERIFIED\">Verified</span> <span ng-if=\"!obj.verified\" class=\"description\" \ntranslate=\"EMAIL.VERIFICATIONS.NOT_VERIFIED\">Not verified</span></span></div></div>");
$templateCache.put("app/main/email/verifications.html","<div ng-if=\"vm.obj\"><div ng-repeat=\"obj in [vm.obj]\"><div class=\"title-container\"><div class=\"title-with-status\"><h1 \ntranslate=\"EMAIL.VERIFICATIONS.VERIFICATION_TITLE\" translate-values=\"{domain:\'{{vm.obj.domain}}\'}\"></h1></div></div>\n<ng-include ng-if=\"vm.operation\" src=\"\'app/main/wooadmin/models/modelstatusmsg.html\'\"></ng-include><div \nclass=\"domain-verification-container\"><div class=\"card\"><section class=\"domain-verification\"><h3 \ntranslate=\"EMAIL.VERIFICATIONS.DNS_SETTINGS_TITLE\">DNS Settings</h3><p class=\"description\" \ntranslate=\"EMAIL.VERIFICATIONS.VERIFICATION_DESC\"></p><div class=\"row detail-list\" ng-repeat=\"rec in obj.records\"><div \nclass=\"col-12 col-sm-6 col-xl-4\"><wt-field wt-value=\"{{rec.kind.toUpperCase()}}\" wt-field=\"DNSRECORD.LIST.TYPE\" \nwt-details=\"true\" wt-form=\"form\" class=\"dns-kind\"></wt-field></div><div class=\"col-12 col-sm-6 col-xl-4\"><wt-field \nwt-value=\"{{rec.subdomain}}.{{obj.domain}}\" wt-field=\"DNSRECORD.LIST.NAME\" wt-details=\"true\" wt-form=\"form\" \nclass=\"dns-host\"></wt-field></div><div class=\"col-12 col-sm-6 col-xl-4\"><wt-field wt-value=\"{{rec.data[0]}}\" \nwt-field=\"DNSRECORD.LIST.VALUE\" wt-details=\"true\" wt-form=\"form\" class=\"dns-data\"></wt-field></div></div></section><hr \nclass=\"section-divider\"><section class=\"check-verification button-with-description\"><h3 \ntranslate=\"EMAIL.VERIFICATIONS.CHECK_VERIFICATION_TITLE\">Check verification</h3><p data-block=\"description\" \ntranslate=\"EMAIL.VERIFICATIONS.CHECK_VERIFICATION_DESC\">Description</p><button data-block=\"button\" \nng-disabled=\"vm.status==\'working\'\" ng-click=\"vm.check()\" translate=\"EMAIL.VERIFICATIONS.CHECK_VERIFICATION_BTN\" \nclass=\"btn btn-primary\">Button</button></section></div></div></div></div><ng-include ng-if=\"!vm.obj\" \nsrc=\"\'app/main/wooadmin/models/modellist.html\'\" class=\"domain-verification-list\"></ng-include>");
$templateCache.put("app/main/layouts/empty.html","");
$templateCache.put("app/main/layouts/wt-alert.html","<div><h1>{{vm.data.title}}</h1><p ng-if=\"vm.data.text\">{{vm.data.text}}</p><div ng-if=\"vm.data.body\">{{vm.data.body}}\n</div><button class=\"btn btn-primary\" ng-click=\"vm.ok()\">{{vm.data.ok}}</button></div>");
$templateCache.put("app/main/layouts/wt-confirm.html","<h1>{{vm.data.title}}</h1><p ng-if=\"vm.data.text\">{{vm.data.text}}</p><p ng-if=\"vm.data.body\">{{vm.data.body}}</p><div \nclass=\"button-container\"><button ng-if=\"vm.data.cancel\" class=\"btn btn-outline-primary\" ng-click=\"vm.cancel()\" \nng-attr-autofocus=\"{{vm.data.focus!=\'ok\'||undefined}}\">{{vm.data.cancel}}</button> <button type=\"submit\" \nclass=\"btn btn-primary\" ng-click=\"vm.ok()\" ng-attr-autofocus=\"{{vm.data.focus==\'ok\'||undefined}}\">{{vm.data.ok}}\n</button></div>");
$templateCache.put("app/main/layouts/wt-details-content.html","<div ng-if=\"vm.isAdmin\" id=\"admin-info\"><p ng-if=\"vm.obj.user && vm.user && vm.obj.user!=vm.user\" \ntranslate=\"ADMIN_DETAILS_MSG\" translate_values=\"{obj_user:vm.obj.user}\"></p></div><div id=\"title\"><h1 ng-if=\"vm.title\" \ntranslate=\"{{vm.title}}\" translate_values=\"{{vm.translate_values}}\"></h1></div><wt-breadcrumbs ng-if=\"vm.breadcrumbs\" \nwt-breadcrumbs=\"{{ vm.breadcrumbs }}\"></wt-breadcrumbs><div ng-repeat=\"obj in [vm.obj]\"><ng-include \nng-show=\"vm.status!=\'ok\' || vm.non_fatal\" src=\'\"app/main/wooadmin/models/modelstatus.html\"\'></ng-include></div><div \nclass=\"wt-details-content detail-list card\"><div class=\"content\"><div ng-repeat=\"obj in [vm.obj]\"><ng-include \nng-if=\"vm.details_template\" src=\"vm.details_template\"></ng-include></div><div ng-if=\"!vm.no_buttons\"><section \nng-if=\"vm.extra_buttons_before || !vm.no_edit || !vm.no_delete || vm.extra_buttons\"><div \nclass=\"button-container bottom-actions\"><button ng-repeat=\"button in vm.extra_buttons_before\" \nng-disabled=\"vm.status!=\'ok\'\" class=\"btn btn-outline-primary\" ng-click=\"button.action()\" ng-show=\"!button.hidden\" \ntranslate=\"{{button.label}}\"></button> <button ng-if=\"!vm.no_edit\" ng-click=\"vm.edit()\" class=\"btn btn-primary\" \nng-disabled=\"vm.status!=\'ok\'\" translate=\"WOOADMIN.EDIT\"></button> <button ng-if=\"!vm.no_delete\" ng-click=\"vm.delete()\" \nclass=\"btn btn-danger\" ng-disabled=\"vm.status==\'working\'\" translate=\"WOOADMIN.DELETE\"></button> <button \nng-repeat=\"button in vm.extra_buttons\" ng-disabled=\"vm.status!=\'ok\'\" class=\"btn btn-outline-primary\" \nng-click=\"button.action()\" ng-show=\"!button.hidden\" translate=\"{{button.label}}\"></button></div></section></div></div>\n</div>");
$templateCache.put("app/main/layouts/wt-details.html","<div class=\"content\"><md-content><div ng-repeat=\"obj in [vm.obj]\"><ng-include ng-show=\"vm.status!=\'ok\'\" \nsrc=\'\"app/main/wooadmin/models/modelstatus.html\"\'></ng-include><ng-include ng-if=\"vm.details_template\" \nsrc=\"vm.details_template\"></ng-include></div></md-content><md-subheader class=\"md-no-sticky md-white-bg\" \nng-if=\"!vm.no_buttons\"><div layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"vm.cancel()\" \nclass=\"md-raised md-primary\" translate=\"WOOADMIN.BACK\"></md-button><md-button ng-if=\"!vm.no_edit\" ng-click=\"vm.edit()\" \nclass=\"md-raised md-primary\" ng-disabled=\"vm.status!=\'ok\'\" translate=\"WOOADMIN.EDIT\"></md-button><md-button \nng-if=\"!vm.no_delete\" ng-click=\"vm.delete()\" class=\"md-raised md-primary\" \nng-disabled=\"vm.status!=\'ok\' && vm.status!=\'error\' || vm.disable_delete\" translate=\"WOOADMIN.DELETE\"></md-button>\n<md-button ng-repeat=\"button in vm.extra_buttons\" ng-show=\"!button.hide\" class=\"md-raised md-primary\" \nng-click=\"button.action()\" translate=\"{{button.label}}\"></md-button></div></md-subheader></div>");
$templateCache.put("app/main/layouts/wt-domain-details-content.html","<div class=\"wt-domain-details-content\"><div ng-if=\"vm.isAdmin\" id=\"admin-info\"><p \nng-if=\"vm.obj.user && vm.user && vm.obj.user!=vm.user\" translate=\"ADMIN_DETAILS_MSG\" \ntranslate_values=\"{obj_user:vm.obj.user}\"></p></div><div class=\"title-wrapper\"><h1 ng-if=\"vm.title\" \ntranslate=\"{{vm.title}}\" translate_values=\"{{vm.translate_values}}\"></h1><div ng-repeat=\"obj in [vm.obj]\" \nclass=\"badges-and-status\"><ng-include src=\"\'app/main/wooadmin/models/modelstatusicon.html\'\" class=\"wt-website-status\">\n</ng-include><wt-domain-status-badge wt-domain-obj=\"{{obj}}\"></wt-domain-status-badge></div></div><div \nclass=\"breadcrumbs-wrapper\"><wt-breadcrumbs ng-if=\"vm.breadcrumbs\" wt-breadcrumbs=\"{{ vm.breadcrumbs }}\">\n</wt-breadcrumbs></div><div class=\"status-messages-wrapper\"><div ng-repeat=\"obj in [vm.obj]\" \nclass=\"status-message-wrapper\"><ng-include ng-show=\"vm.status!=\'ok\' || vm.non_fatal\" \nsrc=\'\"app/main/wooadmin/models/modelstatusmsg.html\"\'></ng-include></div></div><div \nclass=\"wt-details-content detail-list card\"><div class=\"content\"><div ng-repeat=\"obj in [vm.obj]\"><ng-include \nng-if=\"vm.details_template\" src=\"vm.details_template\"></ng-include></div><div ng-if=\"!vm.no_buttons\"><section \nng-if=\"vm.extra_buttons_before || !vm.no_edit || !vm.no_delete || vm.extra_buttons\"><div \nclass=\"button-container bottom-actions\"><button ng-repeat=\"button in vm.extra_buttons_before\" \nng-disabled=\"vm.status!=\'ok\'\" class=\"btn btn-outline-primary\" ng-click=\"button.action()\" ng-show=\"!button.hidden\" \ntranslate=\"{{button.label}}\"></button> <button ng-if=\"!vm.no_edit\" ng-click=\"vm.edit()\" class=\"btn btn-primary\" \nng-disabled=\"vm.status!=\'ok\'\" translate=\"WOOADMIN.EDIT\"></button> <button ng-if=\"!vm.no_delete\" ng-click=\"vm.delete()\" \nclass=\"btn btn-danger\" ng-disabled=\"vm.status==\'working\'\" translate=\"WOOADMIN.DELETE\"></button> <button \nng-repeat=\"button in vm.extra_buttons\" ng-disabled=\"vm.status!=\'ok\'\" class=\"btn btn-outline-primary\" \nng-click=\"button.action()\" ng-show=\"!button.hidden\" translate=\"{{button.label}}\"></button></div></section></div></div>\n</div></div>");
$templateCache.put("app/main/layouts/wt-edit-buttons.html","<div class=\"button-container bottom-actions\"><button type=\"button\" class=\"btn btn-outline-primary\" \nng-click=\"vm.cancel()\" translate=\"WEBSITE.CANCEL\"></button> <button type=\"submit\" class=\"btn btn-primary\" \nng-click=\"vm.continue()\" ng-disabled=\"modelForm.$invalid || vm.isSaving\" translate=\"WEBSITE.CONTINUE\"></button></div>");
$templateCache.put("app/main/layouts/wt-edit.html","<div class=\"form card\"><form name=\"modelForm\" layout=\"column\" \nng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.continue()\" novalidate=\"novalidate\"><input type=\"submit\" \nstyle=\"position: absolute; left: -9999px; width: 1px; height: 1px\"><ng-include ng-if=\"vm.edit_template\" \nsrc=\"vm.edit_template\"></ng-include><uib-tabset ng-if=\"!vm.edit_template && vm.form.tabs\"><uib-tab index=\"$index+1\" \nng-repeat=\"tab in vm.form.tabs\" heading=\"{{tab.title||tab.name.capitalize()}}\"><wt-form wt-form=\"form\" wt-obj=\"obj\" \nwt-tab=\"{{tab.name}}\"></wt-form></uib-tab></uib-tabset><wt-form ng-if=\"!vm.edit_template && !vm.form.tabs\" \nwt-form=\"form\" wt-obj=\"obj\"></wt-form><ng-include src=\"\'app/main/layouts/wt-edit-buttons.html\'\"></ng-include></form>\n<div ng-if=\"vm.form.operations\" class=\"wt-actions\"><h2 class=\"list-title\" layout=\"row\" layout-align=\"start center\" \ntranslate=\"WOOADMIN.ACTIONS\"></h2><div class=\"list-title\"><div ng-repeat=\"action in vm.form.operations\" \nclass=\"wt-admin-action\"><p translate=\"{{action.description}}\"></p><button class=\"btn btn-outline-primary\" \nng-click=\"vm.do_action($event,action)\" translate=\"{{action.name}}\"></button></div></div></div></div>");
$templateCache.put("app/main/layouts/wt-processing.html","<ng-include src=\"\'app/main/snippets/admin.html\'\" ng-repeat=\"model in [\'wordpress\']\"></ng-include><div layout=\"column\" \nng-repeat=\"obj in [vm.obj]\" layout-align=\"center center\"><ng-include layout=\"column\" layout-align=\"center center\" \nsrc=\'\"app/main/wooadmin/models/modelstatus.html\"\'></ng-include></div><button class=\"btn btn-outline-primary reload\" \nng-click=\"vm.continue()\" translate=\"WOOADMIN.CONTINUE\"></button>");
$templateCache.put("app/main/layouts/wt-unsupported.html","<h2 translate=\"WOOADMIN.UNSUPPORTED_TITLE\"></h2><p translate=\"WOOADMIN.UNSUPPORTED_P1\">\nWe\'re working on fixing this asap.</p><p translate=\"WOOADMIN.UNSUPPORTED_P2\">\nIn the meantime, we\'ll be happy to assist. Just tell us what you need in the chat window and we\'ll fix it for you.</p>\n<div class=\"button-container bottom-actions\" layout=\"row\" layout-align=\"center\" layout-margin><button \nclass=\"btn btn-primary-outline\" ng-click=\"vm.cancel()\" translate=\"WEBSITE.CANCEL\"></button></div>");
$templateCache.put("app/main/layouts/wt-wrapper.html","<div class=\"wt-content-wrapper\"><ng-include ng-if=\"vm.content\" src=\"vm.content\"></ng-include><div ng-if=\"!vm.content\" \nng-attr-id=\"{{vm.id_attr}}\" class=\"model-edit-wrapper wt-content\" ng-class=\"vm.class_attr\" layout=\"column\" flex \nlayout-fill><div ng-if=\"vm.title\" id=\"title\" class=\"wt-wrapper-title-container\"><h1 translate=\"{{vm.title}}\" \ntranslate-values=\"{{vm.translate_values}}\"></h1><wt-help-button ng-if=\"vm.helpUrl\" wt-help-url=\"{{vm.helpUrl}}\" \nwt-color=\"white\"></wt-help-button></div><wt-breadcrumbs ng-if=\"vm.breadcrumbs\" wt-breadcrumbs=\"{{ vm.breadcrumbs }}\">\n</wt-breadcrumbs><div ng-if=\"vm.introduction\" id=\"introduction\" layout=\"column\" layout-align=\"center center\"><wt-text \nwt-msg=\"{{vm.introduction}}\"></wt-text></div><ng-include src=\"vm.layout\"></ng-include></div></div>");
$templateCache.put("app/main/log/log-details.html","<div ng-repeat=\"item in [vm.item]\" class=\"log-details\"><div class=\"log-details-header\"><h4 translate=\"{{item.msg}}\" \ntranslate-values=\"{{item.data}}\"></h4><a ng-if=\"vm.state && vm.id\" ui-sref=\"{{vm.state}}({id:vm.id})\" \nclass=\"btn btn-sm btn-outline-primary\" translate=\"LOG.DETAILS.VIEW_OBJECT\">View Object</a></div><div \nclass=\"log-details-grid\"><div class=\"log-detail-item\"><label translate=\"LOG.DETAILS.DATE\">Date</label><span>\n{{item.date | date:\'yyyy-MM-dd HH:mm:ss\'}}</span></div><div class=\"log-detail-item\"><label \ntranslate=\"LOG.DETAILS.USER\">User</label><span>{{item.user}}<span \nng-if=\"item.real_user && item.real_user != item.user\"> ({{item.real_user}})</span></span></div><div \nclass=\"log-detail-item\"><label translate=\"LOG.DETAILS.MODEL\">Model</label><span>{{item.model}}</span></div><div \nclass=\"log-detail-item\" ng-if=\"item.operation.type\"><label translate=\"LOG.DETAILS.OPERATION\">Operation</label><span>\n{{item.operation.type}}</span></div></div><div class=\"log-detail-item\" ng-if=\"item.data && (item.data | json) != \'{}\'\">\n<label translate=\"LOG.DETAILS.DATA\">Data</label><pre class=\"log-data-pre\">{{item.data | json}}</pre></div><div \nclass=\"log-debug-data\"><label translate=\"LOG.DETAILS.RAW_DATA\">Raw Data</label><pre>{{item | json}}</pre></div></div>");
$templateCache.put("app/main/log/log_list_item.html","<div class=\"table-row no-gutters row\"><div class=\"user\">{{obj.user}}</div><div class=\"msg\" translate=\"{{obj.msg}}\" \ntranslate-values=\"{{obj.data}}\"></div><div class=\"date\">{{obj.date}}</div><div class=\"data\">{{obj.data}}</div><div \nclass=\"status\"><ng-include src=\"\'app/main/wooadmin/models/modelstatusicon.html\'\"></ng-include></div></div>");
$templateCache.put("app/main/settings/settings.html","<h1>Settings for {{vm.user.name}}</h1><div ng-if=\"vm.isAdmin\" class=\"admin-only\"><a type=\"button\" name=\"button\" \nng-click=\"vm.hide_admin_help=!vm.hide_admin_help\">toggle help text</a><div ng-if=\"!vm.hide_admin_help\"><p>\nAdmins can add or edit settings by creating and editing options and option groups. An option group corresponds to a \"tab\" on the settings page, and an option is a specific \"setting\". Note: to create a new option, it\'s usually better, and faster, to edit an existing (and simliar) option then click \"Save as new\". Groups and options must have the following:\n<ul><li>Model: WooUInfo</li><li>Access: default or admin (default means anyone can view and change it)</li><li>\nPath: must be a unique path in dot-notation, such as: mygroup.myopt.enabled</li></ul>\nAdditionally, an Option must have the following:<ul><li>Kind: select the kind of input to use.</li><li>\nValues: only if Kind is \"select\". Add the allowed values.</li><li>\nGroup: select the option group (i.e. \"tab\") the option belongs to. The group and option must have the same model.</li>\n</ul>\nNone of the other fields are relevant for these options, so should be left empty. Note: there are many options and option groups that have \"WooApp\" as model, which means they appear on the Website settings instead of here. Note: an option group only shows up as a tab if it has the correct Model, as noted above, and it contains at least one option (which must also have the same Model).\n</p></div><a ui-sref=\"app.wooadmin.option-edit({id:null})\">Create Option</a> <a \nui-sref=\"app.wooadmin.optiongroup-edit({id:null})\">Create Group</a> <a ui-sref=\"app.wooadmin.option-list({id:null})\">\nList All Option</a> <a ui-sref=\"app.wooadmin.optiongroup-list({id:null})\">List All Groups</a></div><div \nclass=\"form card settings\"><form name=\"modelForm\" ng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.save()\">\n<uib-tabset active=\"vm.initial_tab\"><uib-tab ng-repeat=\"group in vm.groups\" heading=\"{{group.name|translate}}\" \nselect=\"vm.onTabSelect(group)\"><ng-include src=\"\'app/main/settings/settingsgroup.html\'\"></ng-include></uib-tab>\n</uib-tabset><div class=\"button-container bottom-actions\"><button type=\"button\" class=\"btn btn-outline-primary\" \nng-click=\"vm.cancel()\" translate=\"WEBSITE.CANCEL\"></button> <button class=\"btn btn-primary\" type=\"submit\" \nng-click=\"vm.save()\" ng-disabled=\"modelForm.$invalid || vm.isSaving || vm.is_operating\" translate=\"WEBSITE.SAVE\">\n</button></div></form></div>");
$templateCache.put("app/main/settings/settingsgroup.html","<h1 translate=\"{{group.name}}\"></h1><p class=\"option-group-description\" translate=\"{{group.description}}\"></p><div \nng-if=\"group.msg\"><p ng-class=\"group.msg.class\" translate=\"{{group.msg.msg}}\"></p></div><div \nng-if=\"vm.isAdmin || !opt.disabled\" ng-repeat=\"opt in group.options\" class=\"setting-container\" \nng-class=\"{\'admin-only\': opt.access == \'admin\'}\"><a ng-if=\"vm.isAdmin\" \nui-sref=\"app.wooadmin.option-edit({id:opt._id})\" class=\"admin-only\">Edit</a><div ng-if=\"opt.msg\" \nclass=\"setting message-setting\"><p ng-class=\"opt.msg.class\" translate=\"{{opt.msg.msg}}\"></p></div><div \nng-if=\"opt.kind==\'button\'\" class=\"setting button-setting\"><button type=\"button\" class=\"btn btn-outline-primary\" \nng-click=\"vm.save(opt)\" translate=\"{{opt.name}}\"></button></div><div ng-if=\"opt.kind!=\'button\'\" \nclass=\"setting other-setting\"><h3 translate=\"{{opt.name}}\"></h3><p class=\"setting-description\" \ntranslate=\"{{opt.description}}\"></p><div class=\"input-container\" ng-switch=\"opt.kind\"><select ng-switch-when=\"select\" \nclass=\"form-control\" ng-model=\"opt.value\" ng-required=\"false\"><option ng-if=\"form.optional[field] && obj[field]\">\n</option><option ng-repeat=\"option in opt.values\" value=\"{{option.value||option}}\" translate=\"{{option.name||option}}\">\n</option></select><div ng-switch-when=\"checkbox\" class=\"custom-control custom-switch\"><input type=\"checkbox\" \nclass=\"custom-control-input\" name=\"ng-input-field\" ng-model=\"opt.value\" autocomplete=\"off\" id=\"{{opt._id}}\"><label \nclass=\"custom-control-label\" for=\"{{opt._id}}\"></label></div><textarea ng-switch-when=\"text\" name=\"ng-input-field\" \nrows=\"5\" class=\"form-control monospace\" spellcheck=\"false\" ng-model=\"opt.value\" ng-disabled=\"opt.disabled\">\n            </textarea><input ng-switch-default type=\"text\" name=\"ng-input-field\" class=\"form-control monospace\" \nspellcheck=\"false\" ng-model=\"opt.value\" ng-required=\"false\"></div></div></div>");
$templateCache.put("app/main/snippets/admin.html","<div ng-if=\"vm.isAdmin\"><section class=\"edit-website\"><h3>Admin Settings</h3><div class=\"row\"><div class=\"col-12\"><div \nclass=\"button-container\"><a ng-if=\"vm.isAdmin\" ui-sref=\"app.wooadmin.{{vm.model||model}}-edit({id:vm.id||obj_id})\" \nclass=\"btn btn-success\" translate=\"WOOADMIN.ADMIN\"></a></div></div></div></section><hr class=\"section-divider\"></div>");
$templateCache.put("app/main/sharing/accept.html","<p translate=\"SHARING.ACCEPT_TEXT\"></p><a ng-if=\"vm.isAdmin\" ui-sref=\"app.wooadmin.sharing-edit({id:vm.id})\" \ntranslate=\"WOOADMIN.ADMIN\"></a><div ng-if=\"!vm.no_buttons\" class=\"button-container\"><button ng-click=\"vm.accept()\" \nclass=\"btn btn-primary\" translate=\"SHARING.ACCEPT\"></button> <button ng-click=\"vm.reject()\" class=\"btn btn-danger\" \ntranslate=\"SHARING.REJECT\"></button> <button ng-click=\"vm.cancel()\" class=\"btn btn-outline-primary\" \ntranslate=\"WEBSITE.CANCEL\"></button></div>");
$templateCache.put("app/main/sharing/details.html","<div class=\"detail-list sharing-details\"><div ng-if=\"vm.isAdmin\"><section class=\"edit-website\"><h3>Admin Settings</h3>\n<div class=\"row\"><div class=\"col-12\"><div class=\"button-container\"><a ng-if=\"vm.isAdmin\" \nui-sref=\"app.wooadmin.sharing-edit({id:vm.id})\" class=\"btn btn-success\" translate=\"WOOADMIN.ADMIN\"></a> <a \nng-if=\"vm.isAdmin\" class=\"btn btn-link\" ui-sref=\"appf.sharing.accept({token:vm.obj.token})\" translate=\"Accept Page\">\nAccept Page</a></div></div></div></section><hr class=\"section-divider\"></div><section><div class=\"row\"><div \nclass=\"col-12 col-sm-6 col-xl-4\" ng-repeat=\"field in vm.Form.fields\"><wt-field wt-obj=\"obj\" wt-form=\"form\" \nwt-field=\"{{field}}\" wt-details=\"true\"></wt-field></div></div></section></div>");
$templateCache.put("app/main/sharing/list.html","<ng-include src=\"\'app/main/wooadmin/models/modellist.html\'\" class=\"account-sharing\"></ng-include>");
$templateCache.put("app/main/sharing/list_filter.html","<div class=\"website-list-filter\"><div class=\"wt-checkbox-container share-filter-list\"><div \nng-repeat=\"f in vm.get_filters(\'checkbox\')\" class=\"share-filter\"><label class=\"wt-field-description\"><input \ntype=\"checkbox\" name=\"{{f.name}}\" ng-model=\"f.checked\" ng-disabled=\"f.disabled\"> <span translate=\"{{f.label}}\"></span>\n</label></div></div><div class=\"filter-row\"><div ng-repeat=\"f in vm.get_filters(\'search\')\"><form class=\"table-filter\">\n<div class=\"search-container\"><input type=\"text\" ng-keydown=\"vm.handleKeydown($event)\" class=\"form-control search\" \nid=\"list-search\" placeholder=\"{{vm.translate(\'SEARCH_PLACEHOLDER\')}}\" ng-model=\"f.query\"> <a class=\"clear\" \ntranslate=\"CLEAR\" ng-click=\"f.query=\'\'\">Clear</a></div></form></div><div ng-repeat=\"f in vm.get_filters(\'select\')\" \nclass=\"filter-select-wrapper\"><select class=\"form-control filter-select\" ng-model=\"f.value\" \nng-class=\"{\'filter-active\': f.value}\"><option ng-repeat=\"opt in f.options\" value=\"{{opt.value}}\">\n{{opt.label | translate}}</option></select></div><div ng-repeat=\"f in vm.get_filters(\'custom-select\')\" \nclass=\"filter-select-wrapper\"><select class=\"form-control filter-select\" ng-model=\"f.value\" \nng-change=\"vm.filter_changed(f)\" ng-options=\"opt.value as (opt.label | translate) for opt in f.options\" \nng-class=\"{\'filter-active\': f.value}\"></select></div></div><div ng-repeat=\"f in vm.get_filters(\'input\')\"><form \nclass=\"table-filter\" ng-submit=\"vm.filter_changed(f)\"><div class=\"search-container\"><input type=\"text\" \nng-attr-id=\"filter-{{f.name}}\" placeholder=\"{{f.label}}\" ng-model=\"f.value\"></div></form></div></div>");
$templateCache.put("app/main/sharing/list_item.html","<div class=\"table-row row no-gutters\" ng-class=\"{pending: obj.request.state==\'pending\'}\"><div class=\"user\"><span \nclass=\"user-email\">{{obj.userEmail}}</span> <span ng-if=\"obj.isOutgoing\" \nclass=\"templ-badge light-purple small direction-badge\" translate=\"SHARING.FILTER_SHARED_BY_ME\"></span> <span \nng-if=\"!obj.isOutgoing\" class=\"templ-badge blue small direction-badge\" translate=\"SHARING.FILTER_SHARED_WITH_ME\">\n</span></div><div class=\"status\"><span ng-if=\"obj.request.state==\'pending\'\" class=\"templ-badge yellow small\" \ntranslate=\"SHARING.STATUS_PENDING\"></span> <span ng-if=\"obj.request.state==\'accepted\'\" class=\"templ-badge green small\" \ntranslate=\"SHARING.STATUS_ACCEPTED\"></span> <span ng-if=\"obj.request.state==\'expired\'\" class=\"templ-badge red small\" \ntranslate=\"SHARING.STATUS_EXPIRED\"></span></div><div class=\"websites\"><span ng-if=\"obj.share_all\" \ntranslate=\"SHARING.LIST.ALL_WEBSITES\"></span> <span \nng-if=\"!obj.share_all && (!obj.websiteNames || obj.websiteNames.length === 0)\" class=\"text-muted\">-</span> <span \nng-if=\"!obj.share_all && obj.websiteNames.length > 0\" class=\"website-links\"><span \nng-repeat=\"site in obj.websiteNames track by $index\"><a ui-sref=\"app.website.details({id: site.id})\">{{site.name}}</a>\n{{$last ? \'\' : \', \'}}</span></span></div><div class=\"date\"><span ng-if=\"obj.request.state==\'pending\'\" \nclass=\"date-expires\" title=\"{{obj.request.expires | date:\'yyyy-MM-dd HH:mm:ss\'}}\"><span \ntranslate=\"SHARING.LIST.EXPIRES_PREFIX\"></span> {{obj.request.expires | relativeDate}} </span><span \nng-if=\"obj.request.state==\'accepted\'\" title=\"{{obj._id | objectIdToDate | date:\'yyyy-MM-dd HH:mm:ss\'}}\">\n{{obj._id | relativeDate:\'objectId\'}} </span><span ng-if=\"obj.request.state==\'expired\'\" class=\"date-expired\" \ntitle=\"{{obj.request.expires | date:\'yyyy-MM-dd HH:mm:ss\'}}\"><span translate=\"SHARING.LIST.EXPIRED_PREFIX\"></span>\n {{obj.request.expires | relativeDate}}</span></div></div>");
$templateCache.put("app/main/sharing/list_items.html","<div class=\"table-row row no-gutters\" ng-repeat=\"obj in vm.objects\" ng-class=\"{pending: obj.request.state==\'pending\'}\" \nng-click=\"vm.openEditView($event, obj)\" aria-label=\"Open\"><div class=\"name\"><span translate=\"{{obj.name}}\" \ntranslate-values=\"{{obj.translate_values}}\"></span></div><div class=\"status\"><ng-include \nsrc=\"\'app/main/wooadmin/models/modelstatusicon.html\'\"></ng-include></div></div>");
$templateCache.put("app/main/start/start.html","<div id=\"start-page\" class=\"start-page empty-page\"><div ng-if=\"vm.message\" id=\"message-wrapper\"><div id=\"message\" \nclass=\"md-whiteframe-8dp\"><ng-include ng-if=\"vm.image\" src=\"\'app/main/animations/empty-websites.html\'\"></ng-include><h1\n translate=\"{{vm.message.title}}\"></h1><p translate=\"{{vm.message.body}}\"></p><div class=\"button-container\"><div \nng-repeat=\"action in vm.message.actions\"><div ng-switch=\"action.kind\"><a class=\"action-link\" ng-switch-when=\"link\" \nng-click=\"vm.action(action)\" translate=\"{{action.name}}\"></a><div ng-switch-when=\"button2\"><button \nclass=\"btn btn-outline-primary\" ng-click=\"vm.action(action)\" translate=\"{{action.name}}\"></button></div><div \nng-switch-default><button class=\"btn btn-primary\" ng-click=\"vm.action(action)\" translate=\"{{action.name}}\"></button>\n</div></div></div></div></div></div></div>");
$templateCache.put("app/main/upgrade/upgrade-billing-continue.html","<div class=\"spinner-border text-primary\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>");
$templateCache.put("app/main/upgrade/upgrade-billing.html","<div id=\"upgrade-billing\"><div class=\"wt-pricing-wrapper\"><div class=\"wt-pricing\"><wt-field ng-if=\"vm.select_period\" \nwt-obj=\"values\" wt-field=\"billing_period\" wt-form=\"select_period\"></wt-field><div ng-if=\"vm.values.current_amount\"><p \ntranslate=\"UPGRADE.CURRENT_COST\" translate-values=\"{{vm.values}}\"></p></div><p ng-if=\"vm.is_initial\" \ntranslate=\"UPGRADE.NEW_WEBSITE_COST\" translate-values=\"{{vm.values}}\"></p><p ng-if=\"!vm.is_initial\" \ntranslate=\"UPGRADE.NEW_COST\" translate-values=\"{{vm.values}}\"></p><div ng-if=\"vm.values.prorated_amount>0\"><p \ntranslate=\"UPGRADE.PRORATED_AMOUNT\" translate-values=\"{{vm.values}}\"></p><p translate=\"UPGRADE.PRORATE_DESCRIPTION\" \ntranslate-values=\"{{vm.values}}\"></p></div><div ng-if=\"vm.values.prorated_amount<0\"><p \ntranslate=\"UPGRADE.CREDIT_AMOUNT\" translate-values=\"{{vm.values}}\"></p><p translate=\"UPGRADE.CREDIT_DESCRIPTION\" \ntranslate-values=\"{{vm.values}}\"></p></div><div ng-if=\"vm.use_credit\"><p translate=\"UPGRADE.CREDIT\" \ntranslate-values=\"{{vm.values}}\"></p></div><div ng-if=\"vm.use_credit\"><p ng-if=\"!vm.is_initial\" \ntranslate=\"UPGRADE.CREDIT_NEW\" translate-values=\"{{vm.values}}\"></p><p ng-if=\"vm.is_initial\" \ntranslate=\"UPGRADE.CREDIT_NEW_WEBSITE\" translate-values=\"{{vm.values}}\"></p></div><div ng-if=\"!vm.is_downgrade\"><p \nclass=\"due-today\" translate=\"UPGRADE.DUE_TODAY\" translate-values=\"{{vm.values}}\"></p></div><div \nng-if=\"vm.values.currencies\"><div ng-if=\"vm.values.currencies\" class=\"input-container currency-selector\"><label \nfor=\"select-currency\" translate=\"UPGRADE.SELECT_CURRENCY\">Select Currency</label><select ng-model=\"vm.values.currency\" \nng-required=\"true\" class=\"form-control\" id=\"select-currency\"><option ng-repeat=\"c in vm.values.currencies\" \nvalue=\"{{c}}\">{{c}}</option></select></div></div><wt-form ng-if=\"vm.split_billing\" wt-obj=\"obj\" \nwt-form=\"select_period\"></wt-form></div></div><div class=\"button-container bottom-buttons\"><button \nng-disabled=\"vm.isSaving\" class=\"btn btn-outline-primary\" ng-click=\"vm.cancel()\" translate=\"{{vm.cancel_button}}\">\n</button> <button ng-disabled=\"vm.isSaving\" class=\"btn btn-primary\" ng-click=\"vm.continue()\" \ntranslate=\"{{vm.continue_button}}\"></button> <button ng-if=\"vm.complete_button2\" ng-disabled=\"vm.isSaving\" \nclass=\"btn btn-success\" ng-click=\"vm.continue(false,true)\" translate=\"{{vm.complete_button2}}\"></button> <button \nng-if=\"vm.admin_complete_button\" ng-disabled=\"vm.isSaving\" class=\"btn btn-success\" ng-click=\"vm.continue(true)\" \ntranslate=\"{{vm.admin_complete_button}}\"></button></div><div ng-show=\"vm.isSaving\" class=\"spinner-border text-primary\" \nrole=\"status\"><span class=\"sr-only\">Loading...</span></div></div>");
$templateCache.put("app/main/upgrade/upgrade-order.html","<div class=\"waiting-for-payment\"><h1 translate=\"WAITING_FOR_PAYMENT\">Waiting for payment to complete</h1><div \nng-show=\"vm.isSaving\" class=\"spinner-border text-primary\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>\n</div>");
$templateCache.put("app/main/upgrade/upgrade-thankyou.html","<h1>Thank You!</h1><md-button ng-disabled=\"vm.isSaving\" class=\"md-raised md-primary\" ng-click=\"vm.continue()\">\n{{vm.continue_button}}</md-button>");
$templateCache.put("app/main/upgrade/upgrade-trial.html","<div></div>");
$templateCache.put("app/main/options/optiongroup.html","<div class=\"button-container upper\"><button class=\"btn btn-outline-primary reload\" type=\"button\" \nng-click=\"vm.sync(group)\" translate=\"ADVANCED.RELOAD\"></button> <a ng-if=\"vm.isAdmin\" \nui-sref=\"app.wooadmin.optiongroup-edit({id:group._id})\" class=\"admin-only\">Edit</a></div><div \nng-if=\"group.description\" class=\"option-group-description\"><h2 translate=\"ADVANCED.GROUP_DESC_TITLE\"></h2><p \ntranslate=\"{{group.description}}\"></p></div><div ng-if=\"group.msg\"><p ng-class=\"group.msg.class\" \ntranslate=\"{{group.msg.msg}}\"></p></div><div ng-if=\"!opt.disabled\" ng-repeat=\"opt in group.options\" \nclass=\"setting-container\" ng-class=\"[{\'admin-only\': opt.access == \'admin\'}, opt.path]\"><a ng-if=\"vm.isAdmin\" \nui-sref=\"app.wooadmin.option-edit({id:opt._id})\" class=\"admin-only\">Edit</a><div class=\"setting other-setting\"><div \nclass=\"setting-title-container\"><h3 translate=\"{{opt.name}}\"></h3><wt-help-button ng-if=\"vm.getHelpUrl(opt.path)\" \nwt-help-url=\"{{ vm.getHelpUrl(opt.path) }}\"></wt-help-button></div><p class=\"setting-description\" \ntranslate=\"{{opt.description}}\"></p><div class=\"input-container\" ng-switch=\"opt.kind\"><select ng-switch-when=\"select\" \nclass=\"form-control\" ng-model=\"opt.value\" ng-required=\"false\"><option ng-if=\"form.optional[field] && obj[field]\">\n</option><option ng-repeat=\"option in opt.values\" ng-if=\"!option.hidden && !option.disabled\" \nvalue=\"{{option.value||option}}\" translate=\"{{option.name||option}}\"></option><option ng-repeat=\"option in opt.values\" \nng-if=\"!option.hidden && option.disabled\" value=\"{{option.value||option}}\" translate=\"{{option.name||option}}\" \ndisabled=\"disabled\"></option></select><div ng-switch-when=\"checkbox\" class=\"custom-control custom-switch\"><input \ntype=\"checkbox\" class=\"custom-control-input\" name=\"ng-input-field\" ng-model=\"opt.value\" \nng-disabled=\"form.disabled[field]\" autocomplete=\"off\" id=\"{{opt._id}}\"><label class=\"custom-control-label\" \nfor=\"{{opt._id}}\"></label></div><textarea ng-switch-when=\"text\" name=\"ng-input-field\" rows=\"5\" \nclass=\"form-control monospace\" spellcheck=\"false\" ng-model=\"opt.value\" ng-disabled=\"form.disabled[field]\">\n            \n</textarea><button ng-switch-when=\"button\" type=\"button\" class=\"btn btn-outline-primary\" ng-click=\"vm.save(opt)\" \ntranslate=\"{{opt.name}}\"></button> <input ng-switch-default type=\"text\" name=\"ng-input-field\" \nclass=\"form-control monospace\" spellcheck=\"false\" ng-model=\"opt.value\" ng-required=\"false\"></div><div \nclass=\"wt-info-wrapper\" ng-repeat=\"info in vm.getWtInfos(opt.path)\"><wt-info wt-title=\"{{ info.title }}\" \nwt-content=\"{{ info.content }}\" wt-translate-values=\"{{ info.translateValues }}\" wt-type=\"{{ info.type }}\"></wt-info>\n</div><div ng-if=\"opt.msg\" class=\"alert\" ng-class=\"opt.msg.class == \'error\' ? \'alert-danger\' : \'alert-warning\'\" \nrole=\"alert\"><p ng-if=\"opt.msg.class == \'error\'\"><span translate=\"ADVANCED.OPTION_MSG.ERROR_BODY\"></span>\n ({{ opt.msg.msg }})</p><p ng-if=\"opt.msg.class != \'error\'\">{{ opt.msg.msg }}</p></div></div></div>");
$templateCache.put("app/main/options/options.html","<h1>Settings for {{vm.doc.name}}</h1><a ui-sref=\"app.website.details({id:vm.doc._id})\">Back</a><div \nclass=\"alert alert-warning\"><strong>Important:</strong><ul><li>\nThis page is very much work in progress, only intended for Admins who know what they are doing...</li><li>\nBefore using these settings, they need to loaded from the server using the Reload button(s).</li><li>\nChanges made on the server directly will only be reflected here after a reload</li><li>\nThe \"Reload\" buttons below only reload the specific group of settings it appears under.</li><li>\nAll the \"Save\" buttons, as well as any other buttons on this page, will save all modified settings on the page, no matter where they appear.\n</li><li>\nThe \"PHP Pool options\" requires that the site\'s php configuration is up to date. This can be accomplished using the \"PHP Update Config\"\n</li></ul></div><div ng-if=\"vm.is_operating\" ng-repeat=\"obj in [vm.doc]\"><ng-include \nsrc=\"\'app/main/wooadmin/models/modelstatus.html\'\"></ng-include></div><div class=\"form card settings\"><form \nng-show=\"!vm.is_operating\" name=\"modelForm\" ng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.save()\"><uib-tabset \nactive=\"vm.initial_tab\"><uib-tab ng-repeat=\"group in vm.groups\" heading=\"{{group.name|translate}}\" \nselect=\"vm.onTabSelect(group)\"><ng-include src=\"\'app/main/options/optiongroup.html\'\"></ng-include></uib-tab>\n</uib-tabset><div class=\"button-container bottom-actions\"><button type=\"button\" class=\"btn btn-outline-primary\" \nng-click=\"vm.cancel()\" translate=\"WEBSITE.CANCEL\"></button> <button class=\"btn btn-primary\" type=\"submit\" \nng-click=\"vm.save()\" ng-disabled=\"modelForm.$invalid || vm.isSaving || vm.is_operating\" translate=\"WEBSITE.SAVE\">\n</button></div></form></div>");
$templateCache.put("app/main/usage/apps.html","<md-content><h1>Websites</h1><h3>Updated: {{usage.date.toUTCString()}}</h3><p>\nYou have created {{usage.usage}} websites out of maximum {{usage.max}}</p><p ng-if=\"usage.usage>=usage.max\" \ntranslate=\"USAGE.WEBSITE_MAX_MESSAGE\"></p></md-content>");
$templateCache.put("app/main/usage/bandwidth.html","<md-content ng-repeat=\"bw in [vm.bw]\"><h1>Bandwidth Usage</h1><h3>Updated: {{bw.updated.toUTCString()}}</h3><p>\nCurrent Usage: {{bw.usage}}</p><p>Monthly Allowed Usage: {{bw.max}}</p><p>\nProjected Usage for current Month: {{bw.projected}}</p><p>Bandwidth usage is counted from the 1st of each month.</p><p \nng-if=\"bw.projected > bw.max\">\nWarning! Your projeted usage for the current month is greater than your allowed usage. Bandwidth overage will be charged at a rate of ${{bw.overage_rate}} per GB. Consider upgrading your allowed bandwidth usage to avoid overage costs.\n</p></md-content>");
$templateCache.put("app/main/usage/bw.html","<div class=\"card bandwidth\" ng-repeat=\"bw in [usage]\"><header><div class=\"row\"><div class=\"col-6\"><h4 \ntranslate=\"DASHBOARD.BANDWIDTH.HEADING\"></h4></div><div class=\"col-6 right date\">{{bw.month}}</div></div></header><hr \nclass=\"section-divider\"><div class=\"body\"><div class=\"donut-chart\"><svg viewBox=\"0 0 32 32\"><circle r=\"16\" cx=\"16\" \ncy=\"16\" style=\"stroke-dasharray: {{ bw.current / bw.max * 100 }} 100\"/></svg><div class=\"donut-center\"></div></div><div\n class=\"numbers\"><p class=\"title\" translate=\"DASHBOARD.BANDWIDTH.USED\"></p><p class=\"data\">{{bw.current}} <span \ntranslate=\"DASHBOARD.BANDWIDTH.OF\">of</span> {{bw.max}}{{bw.unit}}</p></div></div><p class=\"overage-info\" \ntranslate=\"USAGE.BW.OVERAGE_INFO\"></p></div>");
$templateCache.put("app/main/usage/bw_per_site.html","<div class=\"card bandwidth\" ng-repeat=\"bw in [usage]\"><header><h4 translate=\"USAGE.BW_PER_SITE.HEADING\"></h4></header>\n<hr class=\"section-divider\"><div class=\"body\"><p translate=\"USAGE.BW_PER_SITE.DESC\"></p><a href=\"/usage/report/\" \nclass=\"btn btn-primary\" translate=\"USAGE.BW_PER_SITE.BTN\"></a></div></div>");
$templateCache.put("app/main/usage/dev_apps.html","<div class=\"card dev-apps\" ng-repeat=\"dev_apps in [usage]\"><header><div class=\"row\"><div class=\"col-6\"><h4 \ntranslate=\"USAGE.DEV_APPS.HEADING\"></h4></div></div></header><hr class=\"section-divider\"><div class=\"body\"><div \nclass=\"donut-chart\"><svg viewBox=\"0 0 32 32\"><circle r=\"16\" cx=\"16\" cy=\"16\" \nstyle=\"stroke-dasharray: {{ dev_apps.usage / dev_apps.max * 100 }} 100\"/></svg><div class=\"donut-center\"><span>\n{{ dev_apps.usage }}/{{ dev_apps.max }}</span></div></div><p translate=\"USAGE.DEV_APPS.DESC\" \ntranslate-values=\"{usage:\'{{dev_apps.usage}}\', max:\'{{dev_apps.max}}\'}\"></p></div></div>");
$templateCache.put("app/main/usage/domains.html","<md-content><h1>Domain Usage</h1><h3>Updated: {{usage.date.toUTCString()}}</h3><p>\nYou have {{usage.usage}} managed domains out of maximum {{usage.max}}.</p><p>\nAllowed number of managed domains will increase as you add more apps.</p></md-content>");
$templateCache.put("app/main/usage/emails.html","<md-content><h1>Email Usage</h1><h3>Updated: {{usage.date.toUTCString()}}</h3><p>\nYou have sent {{usage.usage}} emails out of maximum {{usage.max}} this month.</p><p>\nEmail quota is reset on the 1st of every month.</p><p>Email quota will be increased if you add more websites.</p>\n</md-content>");
$templateCache.put("app/main/usage/free_micro.html","");
$templateCache.put("app/main/usage/usage.html","<section class=\"usage-page\"><div ng-repeat=\"usage in vm.usage\"><div ng-if=\"usage.overage\" class=\"alert-wrapper\"><div \nclass=\"alert alert-warning\"><span translate=\"USAGE.BW.PROJECTED_OVERAGE_ALERT\"></span></div></div></div><div \nclass=\"details_template\"><div class=\"wt-usage\"><div ng-repeat=\"usage in vm.usage\" ng-class=\"usage.label\"><ng-include \nsrc=\"\'app/main/usage/\'+usage.label+\'.html\'\"></ng-include></div></div></div><a ng-if=\"vm.isAdmin\" \nui-sref=\"app.wooadmin.quota-edit({id:vm.id})\" class=\"btn btn-success admin-button\" translate=\"WOOADMIN.ADMIN\"></a>\n</section>");
$templateCache.put("app/main/vulns/details.html","<h2>Details</h2><ul><li>Type: {{obj.vuln_type}}</li><li>Published: {{obj.published_date}} (added {{obj.added_at}})</li>\n<li>Severity: {{obj.severity}}</li><li>Number of sites affected: {{obj.site_count}}</li><li ng-if=\"obj.cvss\">\nCVSS: {{obj.cvss}} ( <a href=\"https://en.wikipedia.org/wiki/Common_Vulnerability_Scoring_System\">?</a> )</li><li \nng-repeat=\"s in obj.scores\"><div ng-switch=\"s.kind\"><div ng-switch-when=\"patchstack_prio\">\nPatchstack Prio: {{ {psp1:\'low (1)\',psp2:\'medium (2)\',psp3:\'high (3)\'}[s.value] }}</div><div ng-switch-default>\n{{s.kind}}: {{s.value}}</div></div></li><li>Affected objects:<ul><li ng-repeat=\"o in vm.affects\"><a \nui-sref=\"app.wpobject.details({id:o.object,page:1})\">{{o.name}}</a><div ng-if=\"o.since\">Since: {{o.since}}</div><div \nng-if=\"o.fixed_in\">Fixed in: {{o.fixed_in}}</div></li></ul></li><li>Note: {{obj.note}}</li></ul><h2>References</h2><ul>\n<li ng-repeat=\"r in references.url\"><a target=\"_blank\" ng-href=\"{{r}}\">See also</a></li><li \nng-repeat=\"c in references.cve\"><a target=\"_blank\" ng-href=\"https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-{{c}}\">\nCVE</a></li></ul><form name=\"modelForm\" layout=\"column\" ng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.save()\" \nnovalidate=\"novalidate\"><wt-field wt-obj=\"obj\" wt-form=\"form\" wt-type=\"text\" wt-field=\"note\"></wt-field><wt-field \nwt-obj=\"obj\" wt-form=\"form\" wt-type=\"select\" wt-field=\"severity\"></wt-field></form><button type=\"button\" \nng-click=\"vm.save()\" ng-disabled=\"modelForm.$pristine || modelForm.$invalid || vm.isSaving\">Update</button><h2>Websites\n</h2><div id=\"website_list\" ui-view=\"website_list\"></div>");
$templateCache.put("app/main/vulns/list_item.html","<div class=\"table-row no-gutters row\"><div class=\"name\">{{vm.list.get_name(obj) || obj._id}}</div><div class=\"name\">\n{{obj.published_date}}</div><div class=\"status\">{{obj.site_count}}</div><div class=\"status\">{{obj.severity}}</div>\n</div>");
$templateCache.put("app/main/vulns/site_list_item.html","<div class=\"table-row no-gutters row\"><div class=\"name\">{{obj.app.name}}</div><div class=\"name\">\n{{obj.vulnerabilities.length}}</div></div>");
$templateCache.put("app/main/website/backup-complete.html","<div ng-if=\"vm.status==\'ok\'\" class=\"wt-download-backup\"><h3 translate=\"BACKUPS.DOWNLOAD\">Download</h3><a \nng-href=\"{{vm.obj.create_backup.link}}\"><span translate=\"BACKUPS.BACKUP_FILE\">Backup file</span>\n: {{vm.obj.create_backup.name}}</a></div>");
$templateCache.put("app/main/website/details-wrapper.html","<div class=\"wt-content-wrapper\"><ng-include ng-if=\"vm.content\" src=\"vm.content\"></ng-include></div>");
$templateCache.put("app/main/website/list_filter.html","<div class=\"website-list-filter\"><div class=\"wt-checkbox-container share-filter-list\"><div \nng-repeat=\"f in vm.get_filters(\'checkbox\')\" class=\"share-filter\"><label class=\"wt-field-description\"><input \ntype=\"checkbox\" name=\"{{f.name}}\" ng-model=\"f.checked\" ng-disabled=\"f.disabled\"> <span translate=\"{{f.label}}\"></span>\n</label></div></div><div class=\"filter-row\"><div ng-repeat=\"f in vm.get_filters(\'search\')\"><form class=\"table-filter\">\n<div class=\"search-container\"><input type=\"text\" ng-keydown=\"vm.handleKeydown($event)\" class=\"form-control search\" \nid=\"list-search\" placeholder=\"{{vm.translate(\'SEARCH_PLACEHOLDER\')}}\" ng-model=\"f.query\"> <a class=\"clear\" \ntranslate=\"CLEAR\" ng-click=\"f.query=\'\'\">Clear</a></div></form></div><div ng-repeat=\"f in vm.get_filters(\'select\')\" \nclass=\"filter-select-wrapper\"><select class=\"form-control filter-select\" ng-model=\"f.value\" \nng-class=\"{\'filter-active\': f.value}\"><option ng-repeat=\"opt in f.options\" value=\"{{opt.value}}\">\n{{opt.label | translate}}</option></select></div><wt-column-config wt-columns=\"vm.columnConfig\" \nwt-cookie-key=\"templ_website_columns\" wt-on-change=\"vm.onColumnsChange(columns)\"></wt-column-config></div><div \nng-repeat=\"f in vm.get_filters(\'input\')\"><form class=\"table-filter\" ng-submit=\"vm.filter_changed(f)\"><div \nclass=\"search-container\"><input type=\"text\" ng-attr-id=\"filter-{{f.name}}\" placeholder=\"{{f.label}}\" \nng-model=\"f.value\"></div></form></div></div>");
$templateCache.put("app/main/website/list_headers.html","<div class=\"table-head row no-gutters\" ng-if=\"vm.list.headers\"><div ng-repeat=\"col in vm.columnConfig\" \nng-if=\"vm.isColumnVisible(col.id)\" class=\"table-head-column-header {{col.id}}\" \nng-class=\"{\n             \'sortable\': col.sortField,\n             \'sorted\': vm.isSortedBy(col),\n             \'sort-desc\': vm.isSortedBy(col) && vm.isSortDesc(),\n             \'sort-asc\': vm.isSortedBy(col) && !vm.isSortDesc()\n         }\" \nng-click=\"col.sortField && vm.toggleSort(col)\"><span translate=\"{{col.label}}\"></span> <span ng-if=\"col.sortField\" \nclass=\"sort-indicator\"></span></div></div>");
$templateCache.put("app/main/website/list_item.html","<div class=\"table-row no-gutters row\" ng-if=\"obj.plan.code != \'blueprint\'\"><div class=\"name\" \nng-if=\"vm.isColumnVisible(\'name\')\">{{vm.list.get_name(obj) || obj.name || obj._id}} <span \nng-if=\"!obj.stopped && obj.app_class==\'live\' && obj.plan.code != \'dev-sm01\' && obj.plan.code != \'dev-micro\' && obj.plan.code != \'blueprint\'\" \nclass=\"templ-badge dark-green small\" translate=\"PRODUCTION\">Production</span> <span \nng-if=\"!obj.stopped && obj.app_class==\'staging\'\" class=\"templ-badge dark-yellow small\" translate=\"STAGING\">Staging\n</span> <span \nng-if=\"!obj.stopped && obj.app_class==\'live\' && (obj.plan.code == \'dev-sm01\' || obj.plan.code == \'dev-micro\' )\" \nclass=\"templ-badge dark-purple small\" translate=\"DEVELOPMENT\">Development</span> <span \nng-if=\"obj.plan.code == \'blueprint\'\" class=\"templ-badge dark-blue small plan ng-scope\" translate=\"BLUEPRINT\"></span> \n<span ng-if=\"obj.http_auth.enabled\" class=\"http-auth-indicator tooltip\" \nng-attr-data-tooltip=\"{{\'WEBSITE.TOOLTIPS.HTTP_AUTH\' | translate}}\" tabindex=\"0\"><img src=\"assets/icons/lock.svg\" \nalt=\"\" width=\"11\" height=\"17\"></span></div><div class=\"domain\" ng-if=\"vm.isColumnVisible(\'domain\')\"><a \nng-if=\"obj.domainn\" ng-href=\"https://{{obj.domainn}}\" target=\"_blank\" class=\"domain-link\">{{obj.domainn}}</a> <span \nng-if=\"!obj.domainn\" class=\"text-muted\">-</span></div><div class=\"plan\" ng-if=\"vm.isColumnVisible(\'plan\')\"><span \nng-if=\"obj.plan.code\" translate=\"WEBSITE.SELECT_VALUES.PLAN.{{obj.plan.code.toUpperCase()}}\"></span> <span \nng-if=\"!obj.plan.code\" class=\"text-muted\">-</span></div><div class=\"location\" ng-if=\"vm.isColumnVisible(\'location\')\">\n<img ng-if=\"obj.location\" ng-src=\"{{vm.getFlag(obj.location.code)}}\" alt=\"{{obj.location.name}}\"> <span \nclass=\"location-name\">{{obj.location.name}}</span></div><div class=\"disk\" ng-if=\"vm.isColumnVisible(\'disk\')\"><div \nng-if=\"obj.disk_usage\"><div class=\"progress\" \nng-class=\"{\'yellow\': (obj.disk_usage) >= 75, \'red\': (obj.disk_usage) >= 90}\" \nng-attr-title=\"{{obj.disk_usage}}% used of {{obj.disk_size}}GB\"><div class=\"progress-bar\" role=\"progressbar\" \nid=\"disk-usage\" style=\"width: {{obj.disk_usage}}%\" data-usage=\"{{obj.disk_usage}}%\" aria-valuenow=\"50\" \naria-valuemin=\"0\" aria-valuemax=\"100\"></div></div><span>\n{{diskFree = obj.disk_size-obj.disk_size*obj.disk_usage/100; diskFree % 1 != 0 ? diskFree.toFixed(1) : diskFree;}}GB \n<span translate=\"WEBSITE.DETAILS.DISK_FREE\">free</span></span></div><div ng-if=\"!obj.disk_usage\"><span>-</span></div>\n</div><div class=\"php\" ng-if=\"vm.isColumnVisible(\'php\')\"><span ng-if=\"obj.settings.phpgeneral.version\">\n{{obj.settings.phpgeneral.version}}</span> <span ng-if=\"!obj.settings.phpgeneral.version\" class=\"text-muted\">-</span>\n</div><div class=\"version\" ng-if=\"vm.isColumnVisible(\'version\')\"><span ng-if=\"obj.settings.wp.version\">\n{{obj.settings.wp.version}}</span> <span ng-if=\"!obj.settings.wp.version\" translate=\"WEBSITE.LIST.VERSION_UNKNOWN\">\n</span></div><div class=\"ip\" ng-if=\"vm.isColumnVisible(\'ip\')\"><span ng-if=\"obj.ip4_dedicated\">{{obj.ip4_dedicated}}\n</span> <span ng-if=\"!obj.ip4_dedicated && obj.ip4_fpcdn\">{{obj.ip4_fpcdn}}</span> <span \nng-if=\"!obj.ip4_dedicated && !obj.ip4_fpcdn && obj.ip4\">{{obj.ip4}}</span> <span \nng-if=\"!obj.ip4_dedicated && !obj.ip4_fpcdn && !obj.ip4\" class=\"text-muted\">-</span></div><div class=\"created\" \nng-if=\"vm.isColumnVisible(\'created\')\"><span ng-if=\"obj.created\" title=\"{{obj.created | date:\'yyyy-MM-dd HH:mm:ss\'}}\">\n{{obj.created | relativeDate}}</span> <span ng-if=\"!obj.created\" class=\"text-muted\">-</span></div><div class=\"status\" \nng-if=\"vm.isColumnVisible(\'status\')\"><ng-include src=\"\'app/main/wooadmin/models/modelstatusicon.html\'\"></ng-include>\n<wt-dropdown-button wt-button-text=\"QUICK_ACTIONS\" wt-button-class=\"btn btn-quick-actions\"><a class=\"wt-dropdown-item\" \nng-click=\"vm.visitApp(obj)\" translate=\"WEBSITE.LIST.VISIT_APP\" translate-values=\"{domain: obj.domainn}\"></a> <a \nclass=\"wt-dropdown-item\" ng-click=\"vm.wpAdmin(obj)\" translate=\"WEBSITE.DETAILS.WP_ADMIN_BUTTON\"></a> <a \nclass=\"wt-dropdown-item\" ng-click=\"vm.fileManager(obj)\" translate=\"WEBSITE.DETAILS.FILE_MANAGER_BUTTON\"></a>\n</wt-dropdown-button></div></div>");
$templateCache.put("app/main/website/list_item_dashboard.html","<div class=\"table-row no-gutters row\" ng-if=\"obj.plan.code != \'blueprint\'\"><div class=\"name\">\n{{vm.list.get_name(obj) || obj.name || obj._id}} <span \nng-if=\"!obj.stopped && obj.app_class==\'live\' && obj.plan.code != \'dev-sm01\' && obj.plan.code != \'dev-micro\' && obj.plan.code != \'blueprint\'\" \nclass=\"templ-badge dark-green small\" translate=\"PRODUCTION\">Production</span> <span \nng-if=\"!obj.stopped && obj.app_class==\'staging\'\" class=\"templ-badge dark-yellow small\" translate=\"STAGING\">Staging\n</span> <span \nng-if=\"!obj.stopped && obj.app_class==\'live\' && (obj.plan.code == \'dev-sm01\' || obj.plan.code == \'dev-micro\' )\" \nclass=\"templ-badge dark-purple small\" translate=\"DEVELOPMENT\">Development</span> <span \nng-if=\"obj.plan.code == \'blueprint\'\" class=\"templ-badge dark-blue small plan ng-scope\" translate=\"BLUEPRINT\"></span>\n</div><div class=\"location\"><img ng-if=\"obj.location\" ng-src=\"{{vm.getFlag(obj.location.code)}}\" \nalt=\"{{obj.location.name}}\"> <span class=\"location-name\">{{obj.location.name}}</span></div><div class=\"disk\"><div \nng-if=\"obj.disk_usage\"><div class=\"progress\" \nng-class=\"{\'yellow\': (obj.disk_usage) >= 75, \'red\': (obj.disk_usage) >= 90}\" \nng-attr-title=\"{{obj.disk_usage}}% used of {{obj.disk_size}}GB\"><div class=\"progress-bar\" role=\"progressbar\" \nid=\"disk-usage\" style=\"width: {{obj.disk_usage}}%\" data-usage=\"{{obj.disk_usage}}%\" aria-valuenow=\"50\" \naria-valuemin=\"0\" aria-valuemax=\"100\"></div></div><span>\n{{diskFree = obj.disk_size-obj.disk_size*obj.disk_usage/100; diskFree % 1 != 0 ? diskFree.toFixed(1) : diskFree;}}GB \n<span translate=\"WEBSITE.DETAILS.DISK_FREE\">free</span></span></div><div ng-if=\"!obj.disk_usage\"><span>-</span></div>\n</div><div class=\"version\"><span ng-if=\"obj.settings.wp.version\">{{obj.settings.wp.version}}</span> <span \nng-if=\"!obj.settings.wp.version\" translate=\"WEBSITE.LIST.VERSION_UNKNOWN\"></span></div><div class=\"status\"><ng-include \nsrc=\"\'app/main/wooadmin/models/modelstatusicon.html\'\"></ng-include></div></div>");
$templateCache.put("app/main/website/listdashboard.html","");
$templateCache.put("app/main/website/live-website-details.html","<div data-extend-template=\"app/main/website/website-details.html\"></div>");
$templateCache.put("app/main/website/staging-website-details.html","<div data-extend-template=\"app/main/website/website-details.html\"><div data-block=\"website-details-buttons\"><p \nstyle=\"max-width:360px\" translate=\"WEBSITE.STAGING_EDIT_NOTE\"></p></div><div data-block=\"backup-description\" \nstyle=\"max-width:300px\" translate=\"WEBSITE.DETAILS.STAGING_BACKUP_DESCRIPTION\"></div><div data-block=\"staging\" \nstyle=\"max-width:300px\"><h2 translate=\"WEBSITE.DETAILS.STAGING_DETAILS_TITLE\"></h2><p \ntranslate=\"WEBSITE.DETAILS.STAGING_DETAILS_DESCRIPTION\" translate-values=\"{live_site:obj.copy_from.name}\"></p><div \nclass=\"wt-website-details-list\"><a ng-disabled=\"vm.status!=\'ok\'\" class=\"md-button md-raised wt-secondbtn\" \nui-sref=\"app.website.copyToApp({src:obj.copy_from.app,id:obj._id})\" translate=\"WEBSITE.DETAILS.UPDATE_STAGING\"></a> <a \nng-disabled=\"vm.status!=\'ok\'\" class=\"md-button md-raised wt-secondbtn\" \nui-sref=\"app.website.details({id:obj.copy_from.app})\" translate=\"WEBSITE.DETAILS.GOTO_LIVE\">Go to Staging Site </a><a \nng-disabled=\"vm.status!=\'ok\'\" class=\"md-button md-raised wt-secondbtn\" \nui-sref=\"app.website.copyToApp({src:obj._id,id:obj.copy_from.app})\" translate=\"WEBSITE.DETAILS.COPY_TO_LIVE\"></a></div>\n</div><div data-block=\"details\"></div></div>");
$templateCache.put("app/main/website/website-backup-processing.html","");
$templateCache.put("app/main/website/website-backup.html","<div id=\"create-model\" layout=\"column\"><div id=\"title\" layout=\"column\" layout-align=\"center center\"><h1 \ntranslate=\"{{vm.title}}\"></h1></div><form name=\"modelForm\" \nng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.continue()\" novalidate=\"novalidate\"><input type=\"submit\" \nstyle=\"position: absolute; left: -9999px; width: 1px; height: 1px\"><div ng-repeat=\"form in [vm.form]\"><ng-include \nsrc=\"\'app/main/wooadmin/models/modeltabs.html\'\" ng-repeat=\"obj in [vm.backup]\"></ng-include></div></form><ng-include \nsrc=\"\'app/main/website/website-form-buttons.html\'\"></ng-include></div>");
$templateCache.put("app/main/website/website-blueprint.html","<div class=\"form card\"><form name=\"modelForm\" ng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.continue()\" \nnovalidate=\"novalidate\"><input type=\"submit\" style=\"position: absolute; left: -9999px; width: 1px; height: 1px\">\n<wt-form wt-form=\"form\" wt-obj=\"form_obj\"></wt-form></form></div><ng-include \nsrc=\"\'app/main/website/website-form-buttons.html\'\"></ng-include>");
$templateCache.put("app/main/website/website-complete-upgrade.html","<div id=\"complete-upgrade\"><p translate=\"Here are the changes that will happen.\"></p><table class=\"data-table\"><thead>\n<tr><th></th><th translate=\"Old\"></th><th class=\"new\" translate=\"New\"></th></tr></thead><tbody><tr \nng-repeat=\"d in vm.diffs\"><td translate=\"{{d.name}}\"></td><td>{{d.old}}</td><td>{{d.new}}</td></tr></tbody></table><p \ntranslate=\"These changes typically takes less than a minute, and will not lead to any downtime.\"></p><ng-include \nsrc=\"\'app/main/website/website-form-buttons.html\'\"></ng-include></div>");
$templateCache.put("app/main/website/website-copy-select-app.html","<div class=\"form card website-copy\"><wt-field wt-form=\"form\" wt-obj=\"obj\" wt-field=\"app\"></wt-field></div><ng-include \nsrc=\"\'app/main/website/website-form-buttons.html\'\"></ng-include>");
$templateCache.put("app/main/website/website-copy.html","<div class=\"form card website-copy\"><div ng-switch=\"vm.copy_direction\" class=\"copy-direction-image-wrapper\"><img \nng-switch-when=\"TO_STAGING\" src=\"assets/icons/staging/production-to-staging.svg\" alt=\"production-to-staging\"> <img \nng-switch-when=\"FROM_STAGING\" src=\"assets/icons/staging/staging-to-production.svg\" alt=\"staging-to-production\"></div>\n<form name=\"modelForm\" ng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.continue()\" novalidate=\"novalidate\"><input \ntype=\"submit\" style=\"position: absolute; left: -9999px; width: 1px; height: 1px\"><wt-form wt-form=\"form\" \nwt-obj=\"form_obj\"></wt-form><ng-include src=\"\'app/main/website/website-partial.html\'\" \nng-repeat=\"form_obj in [vm.form_obj]\"></ng-include></form><ng-include \nsrc=\"\'app/main/website/website-form-buttons.html\'\"></ng-include></div>");
$templateCache.put("app/main/website/website-create-processing.html","");
$templateCache.put("app/main/website/website-create-staging.html","<div class=\"form card\"><form name=\"modelForm\" ng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.continue()\" \nnovalidate=\"novalidate\"><input type=\"submit\" style=\"position: absolute; left: -9999px; width: 1px; height: 1px\">\n<wt-form wt-form=\"form\" wt-obj=\"form_obj\"></wt-form><ng-include ng-if=\"vm.isAdmin\" \nsrc=\"\'app/main/website/website-partial.html\'\" ng-repeat=\"form_obj in [vm.form_obj]\"></ng-include></form><ng-include \nsrc=\"\'app/main/website/website-form-buttons.html\'\"></ng-include></div>");
$templateCache.put("app/main/website/website-create.html","<div class=\"website-create form card\"><form name=\"modelForm\" layout=\"column\" \nng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.continue()\" novalidate=\"novalidate\"><input type=\"submit\" \nstyle=\"position: absolute; left: -9999px; width: 1px; height: 1px\"><wt-form wt-form=\"form\" wt-obj=\"obj\"></wt-form>\n<ng-include ng-if=\"vm.cloning\" src=\"\'app/main/website/website-partial.html\'\" \nng-repeat=\"form_obj in [vm.obj.copy_from]\"></ng-include><div ng-if=\"vm.Form.advanced\" \nclass=\"wrap-collabsible accordion\"><input id=\"collapsible\" type=\"checkbox\" class=\"collapsible-checkbox\"><label \nfor=\"collapsible\" class=\"collapsible-label\" translate=\"WEBSITE.LABELS.ADVANCED\"></label><div \nclass=\"collapsible-content\"><div ng-repeat=\"field in vm.Form.advanced.fields\" class=\"wt-field-container\"><div \nng-show=\"!vm.form.hidden[field]\"><wt-field wt-form=\"form\" wt-obj=\"obj\" wt-field=\"{{field}}\"></wt-field></div></div>\n</div></div></form><ng-include ng-if=\"vm.extra_buttons\" src=\"vm.extra_buttons\"></ng-include><ng-include \nsrc=\"\'app/main/website/website-pricing.html\'\"></ng-include><wt-info \nng-if=\"vm.Form.fields.includes(\'old_login_info\') && !vm.Form.hidden.old_login_info && !vm.Form.Obj_exists\" \nwt-title=\"WEBSITE.MIGRATE.INFO.NEXT_STEP_TITLE\" wt-content=\"WEBSITE.MIGRATE.INFO.NEXT_STEP_CONTENT\"></wt-info>\n<ng-include src=\"\'app/main/website/website-form-buttons.html\'\"></ng-include></div>");
$templateCache.put("app/main/website/website-details.html","<div class=\"details_template\" layout=\"column\" layout-align=\"center center\"><div ng-repeat=\"obj in [vm.obj]\" \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"space-between\"><div class=\"website-first-page\" layout=\"column\" \nlayout-margin><div><a><img ng-click=\"vm.home_page()\" ng-src=\"{{vm.screenshot}}\" \nstyle=\"border:solid 1px;max-height:240px\"> </a><a class=\"md-raised wt-secondbtn\" \nng-if=\"vm.obj.version>=3 && vm.status==\'ok\'\" ng-click=\"vm.generate_thumb()\" translate=\"WEBSITE.DETAILS.UPDATE_IMAGE\">\nUpdate Image</a></div><div ng-if=\"!obj.stopped\"><md-button class=\"md-raised wt-secondbtn\" \nng-disabled=\"vm.status==\'error\'\" ng-repeat=\"ap in vm.APs\" ng-click=\"ap.action($event,vm.obj)\" \ntranslate=\"{{ ap.label }}\"></md-button></div><div ng-if=\"obj.stopped\"><div translate=\"WEBSITE.DETAILS.IS_STOPPED\">\nWebsite is stopped!</div><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.status==\'error\'\" \nng-click=\"vm.start_app()\" translate=\"WEBSITE.START\">Start</md-button></div></div><div layout=\"column\"><div \nclass=\"wt-website-details-list\" data-block=\"website-details\"><h2 translate=\"WEBSITE.DETAILS.DETAILS_TITLE\"></h2><div \ndata-block=\"website-details-content\"><p><span translate=\"WEBSITE.DETAILS.NAME\">Website Name</span>: {{obj.name}}</p><p>\n<span translate=\"WEBSITE.DETAILS.DOMAIN\">Domain</span>: {{obj.domainn}}</p><p><span \ntranslate=\"WEBSITE.DETAILS.IP_ADDRESS\">IP Address</span>: {{obj.ip4}}</p><p><span translate=\"WEBSITE.DETAILS.WEBROOT\">\nWebroot</span>: {{obj.webroot||\"wordpress\"}}</p><p><span translate=\"WEBSITE.DETAILS.ADMIN_USERNAME\">Admin Username\n</span>: {{obj.app_admin.username}}</p><p><span translate=\"WEBSITE.DETAILS.ADMIN_PASSWORD\">Admin Password</span>: \n<input type=\"{{vm.show_password[\'password\'] && \'text\' || \'password\'}}\" ng-model=\"obj.app_admin.password\" \nng-required=\"false\" ng-disabled=\"true\" autocomplete=\"off\"> <input type=\"checkbox\" \nng-model=\"vm.show_password[\'password\']\" ng-checked=\"vm.show_password[\'password\']\"><label \ntranslate=\"WEBSITE.DETAILS.SHOW_PASSWORD\">Show password</label></p><p ng-if=\"!vm.ssh_password.enabled\"><span \ntranslate=\"WEBSITE.DETAILS.SSH_PASSWORD_DISABLED\"></span></p><p ng-if=\"vm.ssh_password.enabled\"><span \ntranslate=\"WEBSITE.DETAILS.SSH_USERNAME\">SFTP Username</span>: {{vm.ssh_password.user||\'woouser\'}}</p><p \nng-if=\"vm.ssh_password.enabled\"><span translate=\"WEBSITE.DETAILS.SSH_PASSWORD\">SFTP Password</span>: <input \ntype=\"{{vm.show_password[\'ssh_password\'] && \'text\' || \'password\'}}\" ng-model=\"vm.ssh_password.password\" \nng-required=\"false\" ng-disabled=\"true\" autocomplete=\"off\"> <input type=\"checkbox\" \nng-model=\"vm.show_password[\'ssh_password\']\" ng-checked=\"vm.show_password[\'ssh_password\']\"><label \ntranslate=\"WEBSITE.DETAILS.SHOW_PASSWORD\">Show password</label></p><p><span translate=\"WEBSITE.DETAILS.DB_NAME\">\nDatabase</span>: {{obj.db_admin.name}}</p><p><span translate=\"WEBSITE.DETAILS.DB_USERNAME\">DB Username</span>\n: {{obj.db_admin.user}}</p><p><span translate=\"WEBSITE.DETAILS.DB_PASSWORD\">DB Password</span>: <input \ntype=\"{{vm.show_password[\'db_password\'] && \'text\' || \'password\'}}\" ng-model=\"obj.db_admin.password\" \nng-required=\"false\" ng-disabled=\"true\" autocomplete=\"off\"> <input type=\"checkbox\" \nng-model=\"vm.show_password[\'db_password\']\" ng-checked=\"vm.show_password[\'db_password\']\"><label \ntranslate=\"WEBSITE.DETAILS.SHOW_PASSWORD\">Show password</label></p><p ng-if=\"!obj.main_app\" \ntranslate=\"WEBSITE.DETAILS.DISK_USAGE\" translate-values=\"{usage:obj.disk_usage, total:obj.disk_size}\"></p></div><div \ndata-block=\"website-details-buttons\"><md-button ng-click=\"vm.edit()\" class=\"md-raised wt-secondbtn\" \nng-disabled=\"obj.stopped || vm.status!=\'ok\'\" translate=\"WOOADMIN.EDIT\"></md-button><md-button ng-if=\"vm.test_polling\" \nng-click=\"vm.test_polling()\" class=\"md-raised wt-secondbtn\" ng-disabled=\"obj.stopped || vm.status!=\'ok\'\" \ntranslate=\"Test Polling\"></md-button></div></div><div><a ng-if=\"vm.isAdmin\" \nui-sref=\"app.wooadmin.app-edit({id:vm.id})\" translate=\"WOOADMIN.ADMIN\"></a></div></div><div layout=\"column\"><div \nclass=\"wt-website-details-list\" data-block=\"details\"><h2 translate=\"WEBSITE.DETAILS.DETAILS_TITLE2\">Details</h2><div \ndata-block=\"details-content\"><p><span translate=\"WEBSITE.DETAILS.LOCATION\">Location</span>: {{obj.location.name}}</p>\n<p><span translate=\"WEBSITE.DETAILS.PLAN\"></span>: <span \ntranslate=\"WEBSITE.SELECT_VALUES.PLAN.{{obj.plan.code.toUpperCase()}}\"></span></p><p ng-if=\"obj.plan.code==\'addon\'\">\n<span translate=\"WEBSITE.DETAILS.SHARED_SITE\"></span>: <a ui-sref=\"app.website.details({id:obj.main_app._id})\">\n{{obj.main_app.name}}</a></p></div><div data-block=\"details-buttons\"><md-button ng-disabled=\"vm.status!=\'ok\'\" \nclass=\"md-raised wt-secondbtn\" ng-click=\"vm.upgrade()\" translate=\"WEBSITE.DETAILS.UPGRADE\">Upgrade</md-button>\n<md-button ng-disabled=\"vm.status!=\'ok\'\" class=\"md-raised wt-secondbtn\" ng-click=\"vm.relocate()\" \ntranslate=\"WEBSITE.DETAILS.CHANGE_LOCATION\">Change Location</md-button></div></div><div \nclass=\"wt-website-details-list\"><h2 translate=\"WEBSITE.DETAILS.BACKUP_TITLE\">Backup</h2><div \ndata-block=\"backup-description\"></div><div><md-button ng-disabled=\"vm.status!=\'ok\'\" class=\"md-raised wt-secondbtn\" \nng-click=\"vm.create_backup()\" translate=\"WEBSITE.DETAILS.CREATE_BACKUP\">Create Backup</md-button><md-button \nng-disabled=\"vm.status!=\'ok\'\" class=\"md-raised wt-secondbtn\" ng-click=\"vm.restore_backup()\" \ntranslate=\"WEBSITE.DETAILS.RESTORE_BACKUP\">Restore Backup</md-button></div></div><div ng-if=\"obj.version>6\" \nclass=\"wt-website-details-list\" data-block=\"staging\"><h2 translate=\"WEBSITE.DETAILS.STAGING_TITLE\">Backup</h2><div>\n</div><div data-block=\"staging-buttons\"><a ng-if=\"!obj.staging_app\" ng-disabled=\"vm.status!=\'ok\'\" \nclass=\"md-button md-raised wt-secondbtn\" ui-sref=\"app.website.createStaging({live_app:obj._id})\" \ntranslate=\"WEBSITE.DETAILS.CREATE_STAGING\">Create Staging Site </a><a ng-if=\"obj.staging_app\" \nng-disabled=\"vm.status!=\'ok\'\" class=\"md-button md-raised wt-secondbtn\" \nui-sref=\"app.website.copyToApp({src:obj._id,id:obj.staging_app._id})\" translate=\"WEBSITE.DETAILS.COPY_TO_STAGING\">\nCopy to Staging </a><a ng-if=\"obj.staging_app\" ng-disabled=\"vm.status!=\'ok\'\" class=\"md-button md-raised wt-secondbtn\" \nui-sref=\"app.website.details({id:obj.staging_app._id})\" translate=\"WEBSITE.DETAILS.GOTO_STAGING\">Go to Staging</a>\n</div></div></div></div></div>");
$templateCache.put("app/main/website/website-edit-buttons.html","");
$templateCache.put("app/main/website/website-expand-partial.html","<section style=\"\"><md-expansion-panel md-component-id=\"panelOne\"><md-expansion-panel-collapsed><div class=\"\">\nPatial Backup (Admin only)</div><md-expansion-panel-icon></md-expansion-panel-icon></md-expansion-panel-collapsed>\n<md-expansion-panel-expanded><md-expansion-panel-header><div class=\"\">Patial Backup (Admin only)</div>\n<md-expansion-panel-icon></md-expansion-panel-icon></md-expansion-panel-header><md-expansion-panel-content \nng-repeat=\"form_obj in [vm.form_obj]\"><ng-include src=\"\'app/main/website/website-partial.html\'\"></ng-include>\n</md-expansion-panel-content><md-expansion-panel-footer><div flex></div><md-button class=\"\" \nng-click=\"$panel.collapse()\">Collapse</md-button></md-expansion-panel-footer></md-expansion-panel-expanded>\n</md-expansion-panel></section>");
$templateCache.put("app/main/website/website-form-buttons.html","<div class=\"button-container bottom-actions\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.continue()\" \nng-disabled=\"modelForm.$invalid || vm.isSaving\" translate=\"{{vm.continue_button||\'WEBSITE.CONTINUE\'}}\" \ntranslate-values=\"{{vm.translate_values}}\"></button> <button class=\"btn btn-outline-primary\" ng-click=\"vm.cancel()\" \ntranslate=\"{{vm.cancel_button||\'WEBSITE.CANCEL\'}}\"></button></div>");
$templateCache.put("app/main/website/website-import.html","<div class=\"form card\"><form name=\"modelForm\" ng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.continue()\" \nnovalidate=\"novalidate\"><input type=\"submit\" style=\"position: absolute; left: -9999px; width: 1px; height: 1px\">\n<wt-form wt-form=\"form\" wt-obj=\"form_obj\"></wt-form></form><ng-include \nsrc=\"\'app/main/website/website-form-buttons.html\'\"></ng-include></div>");
$templateCache.put("app/main/website/website-list-filter.html","<div ng-repeat=\"f in vm.get_filters(\'search\')\"><form class=\"table-filter\"><input type=\"text\" \nclass=\"form-control search\" id=\"{{f.name}}-search\" placeholder=\"Search\" ng-model=\"f.query\"></form></div>");
$templateCache.put("app/main/website/website-partial.html","<wt-field wt-type=\"checkbox\" wt-obj=\"form_obj\" wt-field=\"partial\" wt-label=\"{{vm.partial_label}}\" \nwt-description=\"{{vm.partial_description}}\"></wt-field><div class=\"partial-subform\"><div ng-show=\"form_obj.partial\" \nclass=\"form-check\"><input type=\"checkbox\" class=\"form-check-input\" id=\"database\" name=\"ng-input-field\" \nng-model=\"form_obj.exclude_db\"><label class=\"form-check-label\" for=\"database\" \ntranslate=\"{{vm.partial_db_description}}\"></label><p class=\"wt-field-note\"></p></div><div ng-show=\"form_obj.partial\" \nng-init=\"form_obj.exclude_files= (!form_obj.files || form_obj.files.length<1) && 1 || form_obj.exclude_files && 1 || 0\">\n<div class=\"form-check\"><input ng-model=\"form_obj.exclude_files\" class=\"form-check-input\" type=\"radio\" name=\"partial\" \nid=\"partial-1\" ng-value=\"1\" checked=\"checked\"><label class=\"form-check-label\" for=\"partial-1\" \ntranslate=\"{{vm.partial_files_exclude}}\"></label></div><div class=\"form-check\"><input \nng-model=\"form_obj.exclude_files\" class=\"form-check-input\" type=\"radio\" name=\"partial\" id=\"partial-0\" ng-value=\"0\">\n<label class=\"form-check-label\" for=\"partial-0\" translate=\"{{vm.partial_files_include}}\"></label></div></div></div>\n<md-input-container ng-show=\"form_obj.partial\" flex layout-fill layout-margin><textarea ng-model=\"form_obj.files_text\" \nclass=\"path-list form-control\">\n  </textarea><p class=\"wt-field-note\" translate=\"{{vm.partial_files_note}}\"></p>\n</md-input-container>");
$templateCache.put("app/main/website/website-pricing.html","<div ng-if=\"vm.pricing || vm.pricing.old_price\" class=\"wt-pricing-wrapper\"><div ng-if=\"vm.pricing\" class=\"wt-pricing\">\n<div ng-if=\"vm.pricing.currencies\" class=\"currency-selector\"><label for=\"select-currency\" \ntranslate=\"UPGRADE.SELECT_CURRENCY\"></label><select ng-model=\"vm.pricing.currency\" ng-required=\"true\" \nclass=\"form-control form-control-sm\" id=\"select-currency\"><option ng-repeat=\"c in vm.pricing.currencies\" value=\"{{c}}\">\n{{c}}</option></select></div><p class=\"new-pricing\" translate=\"WEBSITE.PRICING_NEW\" translate-values=\"{{vm.pricing}}\">\n</p><p ng-if=\"vm.pricing.total_discount\" class=\"new-pricing-discount\" translate=\"WEBSITE.PRICING_DISCOUNT\" \ntranslate-values=\"{{vm.pricing}}\"></p><p ng-if=\"vm.pricing.credit>0\" translate=\"WEBSITE.AVAILABLE_CREDIT\" \ntranslate-values=\"{{vm.pricing}}\"></p><p class=\"wt-vat-info\" translate=\"WEBSITE.EXLCUDING_VAT\" \ntranslate-values=\"{{vm.pricing}}\"></p></div><div ng-if=\"vm.pricing.old_price\" class=\"wt-pricing\" \ntranslate=\"WEBSITE.PRICING_OLD\" translate-values=\"{{vm.pricing}}\"></div></div>");
$templateCache.put("app/main/website/website-processing.html","<div id=\"website-processing\"><ng-include ng-if=\"vm.status==\'ok\' && vm.op_type==\'CREATE\'\" \nsrc=\'\"app/main/animations/confetti.html\"\'></ng-include><div class=\"website-processing-wrapper\"><div id=\"title\" \nlayout=\"column\" layout-align=\"center center\"><h1 ng-if=\"vm.status!=\'ok\'\" translate=\"{{vm.processing_title}}\"></h1><h1 \nng-if=\"vm.status==\'ok\'\" translate=\"{{vm.complete_title}}\"></h1></div><div layout=\"column\" ng-repeat=\"obj in [vm.obj]\" \nlayout-align=\"center center\"><ng-include layout=\"column\" layout-align=\"center center\" \nsrc=\'\"app/main/wooadmin/models/modelstatus.html\"\'></ng-include></div><div ng-if=\"vm.status==\'ok\' && !vm.non_fatal\" \nclass=\"complete-msg\"><wt-text wt-msg=\"{{vm.complete_text}}\"></wt-text></div><div \nng-if=\"vm.status==\'ok\' && vm.continue_text\" class=\"complete-msg\"><wt-text wt-msg=\"{{vm.continue_text}}\"></wt-text>\n</div><ng-include ng-if=\"vm.extra_template\" src=\"vm.extra_template\"></ng-include><div \nclass=\"button-container bottom-actions\" layout=\"row\" layout-align=\"center\" layout-margin><button \nng-hide=\"vm.object_status(vm.obj)==\'working\'\" class=\"btn btn-primary\" layout-align=\"\" ng-click=\"vm.continue($event)\" \ntranslate=\"{{vm.continue_button||\'WEBSITE.CONTINUE\'}}\"></button></div></div></div>");
$templateCache.put("app/main/website/website-restore.html","<div class=\"form card\"><form name=\"modelForm\" ng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.continue()\" \nnovalidate=\"novalidate\"><input type=\"submit\" style=\"position: absolute; left: -9999px; width: 1px; height: 1px\">\n<wt-form wt-form=\"form\" wt-obj=\"form_obj\"></wt-form><ng-include src=\"\'app/main/website/website-partial.html\'\" \nng-repeat=\"form_obj in [vm.form_obj]\"></ng-include></form><ng-include \nsrc=\"\'app/main/website/website-form-buttons.html\'\"></ng-include></div>");
$templateCache.put("app/main/website/website-upgrade.html","<div class=\"form card\"><form name=\"modelForm\" layout=\"column\" \nng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.continue()\" novalidate=\"novalidate\"><input type=\"submit\" \nstyle=\"position: absolute; left: -9999px; width: 1px; height: 1px\"><wt-form wt-form=\"form\" wt-obj=\"obj\"></wt-form>\n</form><ng-include src=\"\'app/main/website/website-pricing.html\'\"></ng-include><ng-include \nsrc=\"\'app/main/website/website-form-buttons.html\'\"></ng-include></div>");
$templateCache.put("app/main/website/website-wrapper.html","<div layout=\"column\" flex layout-align=\"center center\"><div class=\"model-edit-wrapper\" layout=\"column\" flex \nlayout-fill><div id=\"title\" layout=\"column\" layout-align=\"center center\"><h1 ng-if=\"vm.title\">{{vm.title}}</h1></div>\n<ng-include src=\"vm.layout\"></ng-include><div class=\"wrapper-bottom-margin\"></div></div></div>");
$templateCache.put("app/main/wooadmin/wooadmin.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/main/wordpress/wordpress-staging.html","<h3 translate=\"WORDPRESS.STAGING_OPTIONS\">Staging options</h3><wt-field wt-form=\"staging_form\" wt-obj=\"staging\" \nwt-field=\"enabled\"></wt-field><div ng-show=\"vm.staging.enabled\"><wt-field wt-form=\"staging_form\" wt-obj=\"staging\" \nwt-field=\"app\"></wt-field><wt-field ng-show=\"vm.staging.app<0\" wt-form=\"staging_form\" wt-obj=\"staging\" wt-field=\"name\">\n</wt-field><ng-include src=\"\'app/main/website/website-partial.html\'\" ng-repeat=\"form_obj in [vm.copy_from]\">\n</ng-include></div>");
$templateCache.put("app/main/wordpress/wordpress-update.html","<a ui-sref=\"app.website.details({id:vm.obj.app})\">Site Details</a><ng-include src=\"\'app/main/snippets/admin.html\'\" \nng-repeat=\"model in [\'wordpress\']\"></ng-include><div class=\"wordpress-updates\" ng-repeat=\"selected in [vm.selected]\">\n<section class=\"plugin-updates\"><h3 translate=\"WORDPRESS.PLUGINS\">Plugins</h3><div class=\"table\"><div \nclass=\"table-head row no-gutters\"><span class=\"checkbox\"></span> <span class=\"name\" translate=\"WORDPRESS.UPDATE_NAME\">\nNamn</span></div><label ng-repeat=\"p in vm.plugs\" class=\"table-row no-gutters row\"><span class=\"checkbox\"><input \ntype=\"checkbox\" ng-model=\"selected.plugs[p.name]\" name=\"{{p.name}}\" value=\"\"> </span><span class=\"name\">\n{{p.title||p.name}}</span> <span>{{p.version}}</span> <span>{{p.status}}</span> <span ng-if=\"p.update\" \ntranslate=\"UPDATE_{{p.update}}\"></span></label></div></section><hr class=\"section-divider\"><section \nclass=\"theme-updates\"><h3 translate=\"WORDPRESS.THEMES\">Teman</h3><div class=\"table\"><div \nclass=\"table-head row no-gutters\"><span class=\"checkbox\"></span> <span class=\"name\" translate=\"WORDPRESS.UPDATE_NAME\">\nNamn</span></div><label ng-repeat=\"p in vm.themes\" class=\"table-row no-gutters row\"><span class=\"checkbox\"><input \ntype=\"checkbox\" ng-model=\"selected.themes[p.name]\" name=\"{{p.name}}\" value=\"\"> </span><span class=\"name\">\n{{p.title||p.name}}</span></label></div></section><hr class=\"section-divider\"><section class=\"core-updates\"><h3 \ntranslate=\"WORDPRESS.CORE\">Core</h3><div class=\"table\"><label class=\"table-row no-gutters row\"><span class=\"checkbox\">\n<input type=\"checkbox\" name=\"{{vm.obj.version}}\" ng-model=\"selected.core\" value=\"\"> </span><span class=\"name\">\nWordPress Core</span></label></div></section><hr class=\"section-divider\"><section class=\"staging\"><ng-include \nsrc=\"\'app/main/wordpress/wordpress-staging.html\'\"></ng-include></section><section class=\"update\"><p \ntranslate=\"WORDPRESS.UPDATE_DESC\">Click button to update WordPress, all Plugins and Themes</p><div \nclass=\"button-container\"><button class=\"btn btn-outline-primary\" ng-click=\"vm.update()\" translate=\"WORDPRESS.UPDATE\">\n</button></div></section></div>");
$templateCache.put("app/main/wordpress/wpobject.html","<h2>Details</h2><ul><li ng-if=\"obj.kind==\'WPVersion\'\">WordPress {{obj.name}}</li><li ng-if=\"obj.kind!=\'WPVersion\'\">\n{{obj.kind}} {{obj.name}}</li><li>Number of sites using: {{vm.count}}</li><li ng-if=\"obj.vulnerabilities.length\">\nVulnerabilities <span ng-if=\"obj.vulnerabilities.length>10\">(more than 10)</span>:<ul><li \nng-repeat=\"v in obj.vulnerabilities.slice(0,10)\"><a ui-sref=\"app.vuln.from_external({external_id:v.id})\">\n{{v.vuln_type}} fixed in {{v.fixed_in}}</a></li></ul></li><li>Note: {{obj.note}}</li></ul><form name=\"modelForm\" \nlayout=\"column\" ng-submit=\"!modelForm.$invalid && !vm.isSaving && vm.save()\" novalidate=\"novalidate\"><wt-field \nwt-obj=\"obj\" wt-form=\"form\" wt-type=\"text\" wt-field=\"note\"></wt-field></form><button type=\"button\" \nng-click=\"vm.save()\" ng-disabled=\"modelForm.$pristine || modelForm.$invalid || vm.isSaving\">Update</button><h2>Websites\n</h2><div id=\"website_list\" ui-view=\"website_list\"></div>");
$templateCache.put("app/main/wooapps/bw_warning.html","<div><h2>Bandwidth Warning:</h2><p>\nCurrently {{vm.bw.usage}}, has been used of your {{vm.bw.max}} Monthly allowed bandwidth.</p><p>\nYour projected usage for the current month is: {{vm.bw.projected}}</p><p>\nBandwidth usage is reset on the 1st every month</p><p>\nOverdrawn bandwidth usage will cause extra costs, and my cause disruption of service. To order more bandwidth, please go here:\n</p></div>");
$templateCache.put("app/main/wooapps/listbody.html","<md-list class=\"woapps-list\"><md-list-item class=\"font-weight-600 list-headers list-item md-white-bg\" md-ink-ripple><p>\nStatus</p><p>Name</p><p></p></md-list-item><md-list-item class=\"list-item md-white-bg\" md-ink-ripple \nng-repeat=\"item in vm.items\" ng-click=\"vm.openEditView($event, item)\"><md-checkbox class=\"hide\" \nng-checked=\"vm.exists(item, vm.selectedItems)\" ng-click=\"vm.toggleSelectItem(item, $event)\" \naria-label=\"{{vm.exists(item, vm.selectedItems) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><p class=\"text-truncate\">\n{{item.status}}</p><p class=\"text-truncate\">{{item.name}}</p><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"WOOAPPS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.deleteApp($event,item)\" \ntranslate=\"WOOAPPS.DELETE_APP\">Delete App</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deleteContactConfirm($event,item)\" translate=\"WOOAPPS.RESTART_APP\">Restart App</md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-list-item><md-list-item class=\"no-results md-white-bg\" \nng-show=\"vm.objs.length === 0\"><p translate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item></md-list>");
$templateCache.put("app/main/wooapps/listitem.html","<p class=\"text-truncate\">Status: {{obj.status}}</p><p class=\"text-truncate\">{{obj.name}}</p>");
$templateCache.put("app/main/wooapps/listitems.html","<md-list-item class=\"list-item md-white-bg\" md-ink-ripple ng-repeat=\"obj in vm.objects\" \nng-click=\"vm.openEditView($event, obj)\" aria-label=\"Open\"><div ng-switch=\"vm.object_status(obj)\"><i \nng-switch-when=\"ok\" class=\"material-icons\">check_circle</i> <i ng-switch-when=\"error\" class=\"material-icons\">error</i>\n<div ng-switch-default class=\"spinner-border text-primary\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>\n</div><p>{{obj.name}}</p><div class=\"md-secondary\" ng-if=\"vm.list.menu\" ng-repeat=\"menu in [vm.list.menu]\"><ng-include \nsrc=\"vm.list.menu_template||\'app/main/wooadmin/models/modellistmenu.html\'\"></ng-include></div></md-list-item>");
$templateCache.put("app/main/wooapps/listmenuextra.html","<md-menu-item ng-repeat=\"ap in obj.accessPoints\"><md-button ng-click=\"vm.open_link($event,ap.url)\">{{ap.name}}\n</md-button></md-menu-item>");
$templateCache.put("app/main/wooapps/wooapps.html","<div id=\"wooapps-overview\"><div class=\"main scrollable\" ms-scroll><md-subheader class=\"md-no-sticky md-white-bg\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span>\n{{ \'WOOAPPS.WOOAPPS_NAV\' | translate }}</span></div><md-button ng-click=\"vm.openCreateView($event)\">\n{{ \'WOOAPPS.CREATE_APP\' | translate }}</md-button><md-button class=\"hide\" ng-click=\"vm.deleteSelectedApps($event)\" \nng-if=\"vm.selectedItems.length>0\">{{ \'WOOAPPS.DELETE_APPS\' | translate}}</md-button><div flex></div></div>\n</md-subheader><md-list class=\"woapps-list\"><md-list-item class=\"font-weight-600 list-headers list-item md-white-bg\" \nmd-ink-ripple><p>Status</p><p>Name</p><p class=\"show-gt-sm\">App(s)</p><p>URL</p><p class=\"show-gt-md\">IP</p><p></p>\n</md-list-item><md-list-item class=\"list-item md-white-bg\" md-ink-ripple ng-repeat=\"item in vm.items\" \nng-click=\"vm.openEditView($event, item)\"><md-checkbox class=\"hide\" ng-checked=\"vm.exists(item, vm.selectedItems)\" \nng-click=\"vm.toggleSelectItem(item, $event)\" \naria-label=\"{{vm.exists(item, vm.selectedItems) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><p class=\"text-truncate\">\n{{item.status}}</p><p class=\"text-truncate\">{{item.name}}</p><p class=\"text-truncate hide show-gt-sm\"><span \nng-if=\"item.apps.length\">{{item.apps[0]}}</span></p><p class=\"text-truncate\"><md-button ng-disabled=\"!item.url\" \nng-click=\"vm.openUrl(item.url, \'_blank\')\">{{item.url}}</md-button></p><p class=\"phone text-truncate hide show-gt-md\">\n<md-button ng-disabled=\"!item.ip\" ng-click=\"vm.openUrl(\'http://\'+item.ip, \'_blank\')\">{{item.ip}}</md-button></p><div \nclass=\"actions\" layout=\"row\" layout-align=\"start center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"WOOAPPS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.deleteApp($event,item)\" translate=\"WOOAPPS.DELETE_APP\">Delete App</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deleteContactConfirm($event,item)\" translate=\"WOOAPPS.RESTART_APP\">Restart App</md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"vm.objs.length === 0\"><p translate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div class=\"search-bar-container\"><input id=\"ms-search-bar-input\" type=\"text\" \nng-attr-placeholder=\"{{\'ADMIN.SEARCH.PLACEHOLDER\'|translate}}\" class=\"search form-control\" \nng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" ng-blur=\"MsSearchBar.collapse()\" \nng-keydown=\"MsSearchBar.handleKeydown($event)\" autocomplete=\"off\"><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\"><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\"><span \ntranslate=\"ADMIN.SEARCH.NO_RESULTS\"></span></div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" \ntabindex=\"0\" ng-click=\"MsSearchBar.handleResultClick(result)\" ng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" \nng-mousedown=\"MsSearchBar.absorbEvent($event)\" ng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" \nmd-ink-ripple><h4 class=\"title\"><span class=\"title\">{{result.title}}</span> <span ng-if=\"result.type == \'website\'\" \nclass=\"templ-badge small green\" translate=\"ADMIN.SEARCH.WEBSITE\"></span> <span ng-if=\"result.type == \'domain\'\" \nclass=\"templ-badge small light-purple\" translate=\"ADMIN.SEARCH.DOMAIN\"></span></h4><div class=\"description\" \nng-if=\"result.description\"><p ng-if=\"result.domain\">{{ result.domain }}</p><p ng-if=\"result.shared_by\" \nclass=\"shared-by\"><span translate=\"ADMIN.SEARCH.SHARED_BY\"></span>: {{ result.shared_by }}</p><p class=\"user\"><span \ntranslate=\"ADMIN.SEARCH.USER\"></span>: {{ result.user }}</p></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/main/auth/views/edit.html","<div id=\"editUser\"><form name=\"userForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input \ntype=\"email\" name=\"email\" ng-model=\"vm.user.username\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"userForm.username.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.user.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\"></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"passwordRepeat\" match-password=\"password\" \nng-model=\"vm.passwordRepeat\" placeholder=\"PasswordRepeat\" translate translate-attr-placeholder=\"USER.PASSWORD_REPEAT\">\n<div ng-messages=\"userForm.passwordRepeat.$error\" role=\"alert\"><div ng-message=\"passwordMatch\"><span \ntranslate=\"USER.ERRORS.PASSWORD_MATCH\">Passwords must match</span></div></div></md-input-container><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"userForm.$invalid || userForm.$pristine || userForm.$submitted\" translate=\"USER.SAVE\" \nng-click=\"vm.save()\">Save</md-button></form></div>");
$templateCache.put("app/main/auth/views/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F\n</span></div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><form name=\"loginForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span>\n</md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.login($event)\">LOG IN</md-button></form>\n<div class=\"separator\"><span class=\"text\" translate=\"LOGIN.OR\">OR</span></div><md-button class=\"md-raised google\"><div \nlayout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_GOOGLE\">Log in with Google</span></span></div></md-button><md-button class=\"md-raised facebook\">\n<div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_FACEBOOK\">Log in with Facebook</span></span></div></md-button><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_register\" translate=\"LOGIN.CREATE_ACCOUNT\">\nCreate an account</a></div></div></div></div>");
$templateCache.put("app/main/auth/views/login2.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div ng-show=\"!vm.login_failed\"><div \nng-show=\"!vm.login_required\"><p>Checking login. Please wait...</p></div><div ng-show=\"vm.login_required\"><div \nng-show=\"!vm.waiting_for_login\"><p>You must complete the login in a separate window. Click button to continue.</p>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.login_other_window($event)\">LOG IN</md-button></div><div \nng-show=\"vm.waiting_for_login\"><div ng-show=\"!vm.login_complete\"><p>\nWaiting for login to complete in other window. Click button to go to login page again.</p><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.login_other_window($event)\">LOG IN</md-button></div><div \nng-show=\"vm.login_complete\" layout=\"row\"><md-progress-circular id=\"login-progress\" class=\"md-accent\" md-diameter=\"32\">\n</md-progress-circular><p layout-margin>Checking account, please wait.</p></div></div></div></div><div \nng-show=\"vm.login_failed\"><form name=\"loginForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input \ntype=\"email\" name=\"email\" ng-model=\"vm.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span>\n</md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.login($event)\">LOG IN</md-button></form>\n</div></div></div></div>");
$templateCache.put("app/main/auth/views/logout.html","<div class=\"flex-scrollable\" layout=\"column\" ms-scroll><div ng-show=\"vm.logging_out\" id=\"login-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><p \ntranslate=\"LOGOUT.PROGRESS\"></p></div></div></div>");
$templateCache.put("app/main/directives/wt-breadcrumbs/wt-breadcrumbs.html","<ol class=\"wt-breadcrumbs\"><li ng-repeat=\"crumb in breadcrumbs\" class=\"wt-breadcrumb-item\"><a ng-if=\"crumb.url\" \nhref=\"{{crumb.url}}\" translate=\"{{crumb.label}}\" translate-values=\"crumb.translateValues\"></a> <span \nng-if=\"!crumb.url\" translate=\"{{crumb.label}}\" translate-values=\"crumb.translateValues\"></span></li></ol>");
$templateCache.put("app/main/directives/wt-column-config/wt-column-config.html","<div class=\"wt-column-config\" ng-class=\"{\'open\': isOpen}\"><button type=\"button\" \nclass=\"btn btn-outline-primary wt-column-config-btn\" ng-click=\"toggleDropdown()\"><svg width=\"16\" height=\"16\" \nviewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n<rect width=\"18\" height=\"18\" x=\"3\" y=\"3\" rx=\"2\"/><path d=\"M9 3v18\"/><path d=\"M15 3v18\"/></svg> <span \ntranslate=\"COLUMN_CONFIG.COLUMNS\">Columns</span></button><div class=\"wt-column-config-dropdown\"><div \nclass=\"wt-column-config-header\" translate=\"COLUMN_CONFIG.BUTTON_TITLE\">Configure columns</div><div \nclass=\"wt-column-config-list\"><label ng-repeat=\"column in columns\" class=\"wt-column-config-item\" \nng-class=\"{\'locked\': column.locked}\"><input type=\"checkbox\" ng-checked=\"isColumnVisible(column.id)\" \nng-click=\"toggleColumn(column)\" ng-disabled=\"column.locked\"> <span>{{column.label | translate}}</span></label></div>\n<div class=\"wt-column-config-footer\"><a ng-click=\"resetToDefault()\" translate=\"COLUMN_CONFIG.RESET\">Reset to default\n</a></div></div></div>");
$templateCache.put("app/main/directives/wt-domain-status-badge/wt-domain-status-badge.html","<span ng-if=\"vm.get_reg_state(vm.obj) == \'TRANSFERING\'\" class=\"templ-badge small yellow\" \ntranslate=\"DOMAINS.REGISTRATION.TRANSFERING_TO_TEMPL\"></span> <span \nng-if=\"vm.get_reg_state(vm.obj) == \'TRANSFERRED_OUT\'\" class=\"templ-badge small yellow\" \ntranslate=\"DOMAINS.REGISTRATION.TRANSFERRED_FROM_TEMPL\"></span> <span \nng-if=\"vm.get_reg_state(vm.obj) == \'REGISTERING\'\" class=\"templ-badge small yellow\" \ntranslate=\"DOMAINS.REGISTRATION.REGISTERING_AT_TEMPL\"></span> <span ng-if=\"vm.get_reg_state(vm.obj) == \'REGISTERED\'\" \nclass=\"templ-badge small green\" translate=\"DOMAINS.REGISTRATION.REGISTERED_AT_TEMPL\"></span> <span \nng-if=\"vm.get_reg_state(vm.obj) == \'DELETING\'\" class=\"templ-badge small red\" translate=\"DOMAINS.REGISTRATION.DELETING\">\n</span> <i ng-if=\"vm.obj.zone.registration.dnsSec\" class=\"templ-icon templ-icon-dnssec tooltip\" \nng-attr-data-tooltip=\"{{\'DOMAINS.REGISTRATION.DNSSEC_DESC\'|translate}}\"></i>");
$templateCache.put("app/main/directives/wt-dropdown-button/wt-dropdown-button.html","<div class=\"wt-dropdown-button-container\" ng-class=\"{\'show\': isDropdownOpen}\"><button ng-class=\"buttonClass\" \nng-click=\"toggleDropdown()\" translate=\"{{ buttonText }}\"></button><div class=\"wt-dropdown-menu\"><ng-transclude>\n</ng-transclude></div></div>");
$templateCache.put("app/main/directives/wt-form/wt-form.html","<div ng-repeat=\"field in fields\" class=\"wt-field-container\"><div ng-show=\"!form.hidden[field]\"><wt-field \nwt-form=\"form\" wt-obj=\"obj\" wt-field=\"{{field}}\"></wt-field></div></div>");
$templateCache.put("app/main/directives/wt-field/wt-checkbox.html","<h3 class=\"wt-field-header\" translate=\"{{form.label[field]||field.capitalize()}}\"></h3><div \nclass=\"custom-control custom-switch\"><input type=\"checkbox\" name=\"ng-input-field\" ng-model=\"obj[field]\" \nng-disabled=\"form.disabled[field]\" autocomplete=\"off\" class=\"custom-control-input\" id=\"{{path}}.{{field}}\"><label \nclass=\"custom-control-label wt-field-description\" translate=\"{{form.description[field]}}\" for=\"{{path}}.{{field}}\">\n</label></div><p class=\"wt-field-note\" translate=\"{{form.note[field]}}\"></p><a ng-if=\"form.help_link[field]\" \ntarget=\"_blank\" class=\"wt-field-link\" href=\"{{form.help_link[field]}}\" translate=\"{{form.help_text[field]}}\"></a>");
$templateCache.put("app/main/directives/wt-field/wt-field-description.html","<div ng-if=\"form.description[field]\" class=\"wt-field-description\"><wt-text wt-msg=\"{{form.description[field]}}\" \nwt-link=\"{{form.help_link[field]}}\" wt-link-text=\"{{form.help_text[field]}}\"></wt-text></div>");
$templateCache.put("app/main/directives/wt-field/wt-field-details.html","<label class=\"wt-field-label\" translate=\"{{form.label[field]||field.capitalize()}}\"></label><div \nclass=\"wt-field-value\" ng-switch=\"type\"><div ng-switch-when=\"password\"><input disabled=\"disabled\" \ntype=\"{{vm.show_password?\'text\':\'password\'}}\" ng-model=\"value\"><md-input-container class=\"md-block\"><label \ntranslate=\"{{vm.show_password?\'WOOADMIN.HIDE_PASSWORD\':\'WOOADMIN.SHOW_PASSWORD\'}}\"></label><input type=\"checkbox\" \nng-model=\"vm.show_password\" ng-checked=\"vm.show_password\"></md-input-container></div><div class=\"wt-field-list-value\" \nng-switch-when=\"list\"><div ng-repeat=\"val in value\" class=\"input-container\"><input type=\"text\" class=\"form-control\" \nid=\"\" value=\"{{val}}\" disabled=\"disabled\"><div class=\"actions\"><a class=\"copy\" ngclipboard \ndata-clipboard-text=\"{{val}}\">Copy</a></div></div></div><div ng-switch-default class=\"input-container\"><input \ntype=\"text\" class=\"form-control\" id=\"\" value=\"{{value}}\" disabled=\"disabled\"><div class=\"actions\"><a class=\"copy\" \nngclipboard data-clipboard-text=\"{{value}}\">Copy</a></div></div></div>");
$templateCache.put("app/main/directives/wt-field/wt-field-element.html","<div ng-switch=\"type\"><md-input-container ng-switch-when=\"select\"><label translate=\"{{form.element_label[field]}}\">\n</label><div ng-if=\"form.multiple[field]\"><md-select multiple=\"true\" ng-model=\"obj[field][i]\" \nng-disabled=\"form.disabled[field]\" ng-required=\"!form.optional[field]\"><md-option \nng-repeat=\"option in form.values[field]\" value=\"{{option.value||option}}\">{{option.name||option}}</md-option>\n</md-select></div><div ng-if=\"!form.multiple[field]\"><md-select ng-if=\"obj[field][i]._id\" ng-model=\"obj[field][i]._id\" \nng-required=\"!form.optional[field]\" ng-disabled=\"form.disabled[field]\"><md-option \nng-if=\"!form.optional[field] && obj[field][i]\"></md-option><md-option ng-repeat=\"option in form.values[field]\" \nvalue=\"{{option.value||option}}\">{{option.name||option}}</md-option><md-option \nng-if=\"!vm.includes_option(obj[field][i],form.values[field])\" value=\"{{obj[field][i]}}\">{{obj[field][i]}}</md-option>\n</md-select><md-select ng-if=\"!obj[field][i]._id\" ng-model=\"obj[field][i]\" ng-required=\"!form.optional[field]\" \nng-disabled=\"form.disabled[field]\"><md-option ng-if=\"!form.optional[field] && obj[field][i]\"></md-option><md-option \nng-repeat=\"option in form.values[field]\" value=\"{{option.value||option}}\">{{option.name||option}}</md-option><md-option\n ng-if=\"!vm.includes_option(obj[field][i],form.values[field])\" value=\"{{obj[field][i]}}\">{{obj[field][i]}}</md-option>\n</md-select></div></md-input-container><div ng-switch-default><div><label translate=\"{{form.element_label[field]}}\">\n</label><input type=\"{{!vm.show_password[field] && (type || \'text\') || \'text\'}}\" name=\"ng-input-field\" \nclass=\"form-control monospace\" ng-model=\"obj[field][i]\" ng-required=\"!form.optional[field] && type!=\'checkbox\'\" \nng-disabled=\"form.disabled[field]\" autocomplete=\"off\"></div></div></div>");
$templateCache.put("app/main/directives/wt-field/wt-field-listelem.html","<div class=\"md-block form-list-block\" ng-switch-when=\"compound\" ng-repeat=\"form in [form.subforms[field]]\"><div \nng-repeat=\"obj in [obj[field][i]]\"><ng-include src=\"\'app/main/wooadmin/models/modelfields.html\'\" \nng-repeat=\"fields in [form.fields]\"></ng-include></div></div><div class=\"md-block form-list-block\" ng-switch-default>\n<ng-include src=\"\'app/main/directives/wt-field/wt-field-element.html\'\" ng-repeat=\"type in [form.type[field]]\">\n</ng-include></div>");
$templateCache.put("app/main/directives/wt-field/wt-field-simple.html","<div ng-switch=\"type\"><md-input-container ng-switch-when=\"select\"><label \ntranslate=\"{{form.label[field]||field.capitalize()}}\"></label><div ng-if=\"form.multiple[field]\"><md-select \nmultiple=\"true\" ng-model=\"obj[field][i]\" ng-disabled=\"form.disabled[field]\" ng-required=\"!form.optional[field]\">\n<md-option ng-repeat=\"option in form.values[field]\" value=\"{{option.value||option}}\">{{option.name||option}}\n</md-option></md-select></div><div ng-if=\"!form.multiple[field]\"><md-select ng-if=\"obj[field][i]._id\" \nng-model=\"obj[field][i]._id\" ng-required=\"!form.optional[field]\" ng-disabled=\"form.disabled[field]\"><md-option \nng-if=\"!form.optional[field] && obj[field][i]\"></md-option><md-option ng-repeat=\"option in form.values[field]\" \nvalue=\"{{option.value||option}}\">{{option.name||option}}</md-option><md-option \nng-if=\"!vm.includes_option(obj[field][i],form.values[field])\" value=\"{{obj[field][i]}}\">{{obj[field][i]}}</md-option>\n</md-select><md-select ng-if=\"!obj[field][i]._id\" ng-model=\"obj[field][i]\" ng-required=\"!form.optional[field]\" \nng-disabled=\"form.disabled[field]\"><md-option ng-if=\"!form.optional[field] && obj[field][i]\"></md-option><md-option \nng-repeat=\"option in form.values[field]\" value=\"{{option.value||option}}\">{{option.name||option}}</md-option><md-option\n ng-if=\"!vm.includes_option(obj[field][i],form.values[field])\" value=\"{{obj[field][i]}}\">{{obj[field][i]}}</md-option>\n</md-select></div></md-input-container><div ng-switch-default><md-input-container class=\"md-block\"><label \ntranslate=\"{{form.label[field]||field.capitalize()}}\"></label><input \ntype=\"{{!vm.show_password[field] && (type || \'text\') || \'text\'}}\" name=\"ng-input-field\" ng-model=\"obj[field][i]\" \nng-required=\"!form.optional[field] && type!=\'checkbox\'\" ng-disabled=\"form.disabled[field]\" autocomplete=\"off\">\n</md-input-container></div></div>");
$templateCache.put("app/main/directives/wt-field/wt-field-wrapper.html","<ng-include ng-if=\"!details\" src=\"\'app/main/directives/wt-field/wt-field.html\'\"></ng-include><ng-include \nng-if=\"details\" src=\"\'app/main/directives/wt-field/wt-field-details.html\'\"></ng-include>");
$templateCache.put("app/main/directives/wt-field/wt-field.html","<div ng-switch=\"type\"><div class=\"md-block form-list-block\" layout=\"column\" ng-switch-when=\"slider\"><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-slider.html\'\"></ng-include></div><div class=\"md-block wt-list-type\" \nng-switch-when=\"list\" flex layout-fill layout-margin><h3 class=\"wt-field-header\" \ntranslate=\"{{form.label[field]||field.capitalize()}}\"></h3><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-field-description.html\'\"></ng-include><p class=\"wt-field-note\" \ntranslate=\"{{form.note[field]}}\"></p><div class=\"wt-field-list\" flex layout-fill layout-margin><div \nng-repeat=\"(i,elem) in obj[field] track by i\" class=\"wt-field\"><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-field-listelem.html\'\" ng-switch=\"vm.list_elem_type(form, field)\" flex \nlayout-fill layout-margin></ng-include><a ng-if=\"!form.disabled[field]\" \nng-click=\"vm.remove_list_element(obj[field],i)\" translate=\"WOOADMIN.REMOVE\"></a></div></div><button type=\"button\" \nng-if=\"!form.disabled[field]\" class=\"btn btn-outline-primary btn-sm\" ng-click=\"vm.add_list_element(form, obj, field)\" \ntranslate=\"WOOADMIN.ADD\"></button></div><div class=\"md-block wt-compound-type\" ng-switch-when=\"compound\"><h3 \nclass=\"wt-field-header\" translate=\"{{form.label[field]||field.capitalize()}}\"></h3><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-field-description.html\'\"></ng-include><p class=\"wt-field-note\" \ntranslate=\"{{form.note[field]}}\"></p><div class=\"md-block wt-compound-field\" \nng-repeat=\"form in [form.subforms[field]]\"><div ng-repeat=\"obj in [vm.init_compound(obj,field)]\"><fieldset \nng-disabled=\"vm.isSaving\" ng-repeat=\"path in [vm.path_add(path,field)]\"><div ng-repeat=\"field in form.fields\"><div \nng-show=\"!form.hidden[field]\"><ng-include src=\"\'app/main/directives/wt-field/wt-field.html\'\" \nng-repeat=\"type in [form.type[field]]\"></ng-include></div></div></fieldset></div><wt-info \nng-if=\"form.info.content[field]\" wt-title=\"{{ form.info.title[field] }}\" wt-content=\"{{ form.info.content[field] }}\" \nwt-type=\"{{ form.info.type[field] }}\"></wt-info></div></div><div ng-switch-when=\"select\"><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-select.html\'\"></ng-include></div><div ng-switch-when=\"plan-select\"><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-plan-select.html\'\"></ng-include></div><div ng-switch-when=\"ui-select\"><ng-include\n src=\"\'app/main/directives/wt-field/wt-ui-select.html\'\"></ng-include></div><div ng-switch-when=\"ui-select-multiple\">\n<ng-include src=\"\'app/main/directives/wt-field/wt-ui-select-multiple.html\'\"></ng-include></div><div \nng-switch-when=\"number\"><ng-include src=\"\'app/main/directives/wt-field/wt-number.html\'\"></ng-include></div><div \nng-switch-when=\"json\" flex layout-fill layout-margin><label ng-if=\"!form.no_labels\" \ntranslate=\"{{form.label[field]||field.capitalize()}}\"></label><textarea rows=\"5\" ng-model=\"obj[field]\" \nclass=\"form-control monospace\">\n        </textarea><pre ng-if=\"form.hint[field]\">{{form.hint[field]}}</pre></div><div \nng-switch-when=\"datetime\" flex layout-fill layout-margin><label ng-if=\"!form.no_labels\" \ntranslate=\"{{form.label[field]||field.capitalize()}}\"></label><input ng-model=\"obj[field]\" class=\"form-control\" \ndatetime-picker></div><div ng-switch-when=\"blob\" flex layout-fill layout-margin><h3 class=\"wt-field-header\" \ntranslate=\"{{form.label[field]||field.capitalize()}}\"></h3><pre translate=\"{{obj[field]}}\" \ntranslate-values=\"{{form.translate_values[field]}}\">\n{{obj[field]}}\n        </pre></div><div ng-switch-when=\"jsonblob\" \nflex layout-fill layout-margin><h3 class=\"wt-field-header\" translate=\"{{form.label[field]||field.capitalize()}}\"></h3>\n<pre>\n{{ obj.jsonblob[field] }}\n        </pre></div><div ng-switch-when=\"file\" flex layout-fill layout-margin>\n<ng-include src=\"\'app/main/directives/wt-field/wt-file-input.html\'\"></ng-include></div><div \nclass=\"wt-checkbox-container\" ng-switch-when=\"checkbox\"><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-checkbox.html\'\"></ng-include></div><div ng-switch-when=\"ref\" flex layout-fill \nlayout-margin><h3 class=\"wt-field-header\" translate=\"{{form.label[field]||field.capitalize()}}\"></h3><input \nng-if=\"obj[field]._id\" type=\"text\" class=\"form-control\" ng-model=\"obj[field]._id\"> <input ng-if=\"!obj[field]._id\" \ntype=\"text\" class=\"form-control\" ng-model=\"obj[field]\"></div><div ng-switch-when=\"sref\" class=\"wt-link-field\" flex \nlayout-fill layout-margin><a ng-if=\"form.sref_id[field]\" class=\"wt-field-header\" \nui-sref=\"{{form.sref[field]}}({id:form.sref_id[field]==\'this\'&&obj._id||form.sref_id[field]})\" \ntranslate=\"{{form.label[field]||field.capitalize()}}\"></a> <a ng-if=\"!form.sref_id[field]\" class=\"wt-field-header\" \nui-sref=\"{{form.sref[field]}}\" translate=\"{{form.label[field]||field.capitalize()}}\"></a></div><div \nng-switch-when=\"href\" class=\"wt-link-field\" flex layout-fill layout-margin><a ng-if=\"form.href[field]\" \nclass=\"wt-field-header\" href=\"{{form.href[field]}}\" translate=\"{{form.label[field]||field.capitalize()}}\"></a></div>\n<div ng-switch-when=\"sref-note\" flex layout-fill layout-margin><div class=\"md-block\"><h3 class=\"wt-field-header\" \ntranslate=\"{{form.label[field]||field.capitalize()}}\"></h3><p><span translate=\"{{form.description[field]}}\" \ntranslate-values=\"{{translate_values}}\"></span> <a ng-if=\"form.sref_id[field]\" class=\"wt-field-header\" \nui-sref=\"{{form.sref[field]}}({id:form.sref_id[field]})\" translate=\"{{form.sref_text[field]||field.capitalize()}}\"></a>\n</p></div></div><div ng-switch-default><label class=\"wt-field-label\" \ntranslate=\"{{form.label[field]||field.capitalize()}}\"></label><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-input.html\'\"></ng-include></div><div ng-if=\"form.edit_ref[field]\" \nclass=\"wt-admin-link\"><div ng-if=\"form.ref_value[field]\">{{form.ref_value[field]}} <a \nui-sref=\"{{form.edit_ref[field]}}({id:form.ref_id[field]||obj[field]._id||obj[field]})\">Edit</a></div><a \nng-if=\"!form.ref_value[field]\" ui-sref=\"{{form.edit_ref[field]}}\">Create</a></div></div><div \nng-if=\"form.alternatives[field] && form.alternatives[field][obj[field]]\"><div class=\"\" \nng-repeat=\"form in [form.alternatives[field][obj[field]]]\"><div ng-repeat=\"field in form.fields\"><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-field.html\'\" ng-repeat=\"type in [form.type[field]]\"></ng-include></div></div>\n</div><wt-info ng-if=\"form.info.content[field] && type != \'compound\'\" wt-title=\"{{ form.info.title[field] }}\" \nwt-content=\"{{ form.info.content[field] }}\" wt-type=\"{{ form.info.type[field] }}\"></wt-info>");
$templateCache.put("app/main/directives/wt-field/wt-file-input.html","<h3 class=\"wt-field-header\" translate=\"{{form.label[field]||field.capitalize()}}\"></h3><p class=\"wt-field-description\" \ntranslate=\"{{form.description[field]}}\"></p><md-input-container><input name=\"{{field}}\" ng-model=\"obj[field]\" \nng-required=\"!form.optional[field]\" ng-disabled=\"form.disabled[field]\" autocomplete=\"off\"></md-input-container><div>\n<label class=\"import-file\"><input style=\"display:none\" type=\"file\" id=\"files\" name=\"file\" \nonchange=\"angular.element(this).scope().vm.loadFile(this)\"><div class=\"md-button md-raised wt-secondbtn action-button\" \ntranslate=\"{{form.file_button[field]||\'WOOADMIN.LOAD_FILE\'}}\"></div></label></div><p class=\"wt-field-note\" \ntranslate=\"{{form.note[field]}}\"></p>");
$templateCache.put("app/main/directives/wt-field/wt-input.html","<md-input-container class=\"md-block\"><ng-include src=\"\'app/main/directives/wt-field/wt-field-description.html\'\">\n</ng-include><textarea rows=\"3\" ng-if=\"type==\'text\'\" name=\"{{field}}\" class=\"form-control\" ng-model=\"obj[field]\" \nng-required=\"!form.optional[field] && type!=\'checkbox\'\" ng-pattern=\"form.pattern[field]\" \nng-disabled=\"form.disabled[field]\">\n    </textarea><div class=\"input-container\"><input ng-if=\"type!=\'text\'\" \ntype=\"{{!vm.show_password[field] && (type || \'text\') || \'text\'}}\" class=\"form-control\" name=\"{{field}}\" \nng-model=\"obj[field]\" ng-required=\"!form.optional[field] && type!=\'checkbox\'\" ng-disabled=\"form.disabled[field]\" \nautocomplete=\"off\" ng-pattern=\"form.pattern[field]\" ng-attr-placeholder=\"{{form.placeholder[field]|translate}}\" \ndata-1p-ignore><div ng-if=\"\'password\'==type\"><div ng-if=\"obj[field]\" class=\"actions\"><label class=\"reveal\" \nfor=\"{{vm.path_add(path,field)}}\">Reveal</label><input type=\"checkbox\" ng-attr-id=\"{{vm.path_add(path,field)}}\" \nng-model=\"vm.show_password[field]\" ng-checked=\"vm.show_password[field]\"> <a class=\"copy\" ngclipboard \ndata-clipboard-text=\"{{obj[field]}}\">Copy</a></div></div></div><my-password-generator \nng-if=\"\'password\'==type && !form.disabled[field] && !form.disable_pwgen[field]\" field=\"obj[field]\" \npassword-length=\"form.password[field].length||15\" uppercase=\"!form.password[field].nouppercase && true\" numbers=\"true\" \nspecials=\"true\"></my-password-generator><div ng-messages=\"modelForm[field].$touched && modelForm[field].$error\" \nrole=\"alert\" class=\"validation-error\"><p ng-message=\"required\" translate=\"VALIDATION.REQUIRED_ERROR\"></p><p \nng-message=\"email\" translate=\"VALIDATION.EMAIL_ERROR\">The email is invalid.</p><p ng-message=\"pattern\" \ntranslate=\"{{form.pattern_error[field]}}\">The email is invalid.</p></div><p ng-if=\"form.note[field]\" \nclass=\"wt-field-note\" translate=\"{{form.note[field]}}\" translate-values=\"{{form.translate_values[field]}}\"></p>\n</md-input-container>");
$templateCache.put("app/main/directives/wt-field/wt-number.html","<h3 class=\"wt-field-header\" translate=\"{{form.label[field]||field.capitalize()}}\"></h3><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-field-description.html\'\"></ng-include><input type=\"{{type}}\" \nclass=\"form-control\" min=\"{{form.number[field].min}}\" max=\"{{form.number[field].max}}\" \nstep=\"{{form.number[field].step}}\" name=\"ng-input-field\" ng-model=\"obj[field]\" ng-required=\"!form.optional[field]\" \nng-disabled=\"form.disabled[field]\" autocomplete=\"off\"><p class=\"wt-field-note\" translate=\"{{form.note[field]}}\"></p>");
$templateCache.put("app/main/directives/wt-field/wt-plan-select.html","<h3 class=\"wt-field-header\" translate=\"{{form.label[field]||field.capitalize()}}\"></h3><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-field-description.html\'\"></ng-include><wt-plan-quiz></wt-plan-quiz><div \nclass=\"wt-plan-select\"><label ng-repeat=\"plan in form.values[field]\" \nng-class=\"{\n        \'selected\': obj[field] == plan.value,\n        \'development\': plan.value.includes(\'dev-\'),\n        \'blueprint\': plan.value.includes(\'blueprint\')\n    }\">\n<h4 translate=\"{{plan.name}}\"></h4><hr><p translate=\"{{\'WEBSITE.PLAN_SPECS.DESC.\'+plan.value.toUpperCase()}}\"></p>\n<input type=\"radio\" class=\"templ-radio\" name=\"{{field}}\" id=\"{{plan.value}}\" value=\"{{plan.value}}\" \nng-model=\"obj[field]\"></label></div><p class=\"wt-plan-select-selected-plan\"><span translate=\"WEBSITE.SELECTED_PLAN\">\n</span> <span class=\"plan-name\">{{\'WEBSITE.SELECT_VALUES.PLAN.\'+obj[field].toUpperCase()|translate}}</span> <span \nclass=\"plan-note\" translate=\"{{form.note[field]}}\"></span></p>");
$templateCache.put("app/main/directives/wt-field/wt-select.html","<h3 class=\"wt-field-header\" translate=\"{{form.label[field]||field.capitalize()}}\"></h3><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-field-description.html\'\"></ng-include><div ng-if=\"form.multiple[field]\"><select \nmultiple=\"true\" ng-model=\"obj[field]\" ng-disabled=\"form.disabled[field]\" ng-required=\"!form.optional[field]\" \nng-options=\"option.value||option as option.name||option|translate for option in form.values[field]\" \nclass=\"form-control\"></select></div><div ng-if=\"!form.multiple[field]\"><select ng-if=\"obj[field]._id\" \nng-model=\"obj[field]._id\" ng-required=\"!form.optional[field]\" ng-disabled=\"form.disabled[field]\" \nng-options=\"option.value||option as option.name||option|translate for option in form.values[field]\" \nclass=\"form-control\"><option style=\"display:none\" value=\"\"></option><option \nng-if=\"!vm.includes_option(obj[field]._id,form.values[field])\" value=\"{{obj[field]._id}}\">{{obj[field]._id}}</option>\n</select><select ng-if=\"!obj[field]._id\" ng-model=\"obj[field]\" ng-required=\"!form.optional[field]\" \nng-disabled=\"form.disabled[field]\" \nng-options=\"option.value||option as option.name||option|translate disable when option.disabled for option in form.values[field]\" \nclass=\"form-control\"><option style=\"display:none\" value=\"\"></option><option \nng-if=\"!vm.includes_option(obj[field],form.values[field])\" value=\"{{obj[field]}}\">{{obj[field]}}</option></select>\n</div><p class=\"wt-field-note\" translate=\"{{form.note[field]}}\"></p>");
$templateCache.put("app/main/directives/wt-field/wt-slider.html","<h3 class=\"wt-field-header\" translate=\"{{form.label[field]}}\"></h3><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-field-description.html\'\"></ng-include><p class=\"wt-field-note\" \ntranslate=\"{{form.note[field]}}\"></p><div><input type=\"range\" min=\"{{form.number[field].min}}\" \nmax=\"{{form.number[field].max}}\" step=\"{{form.number[field].step}}\" ng-model=\"obj[field]\"><div><input flex \ntype=\"number\" min=\"{{form.number[field].min}}\" max=\"{{form.number[field].max}}\" step=\"{{form.number[field].step}}\" \nng-model=\"obj[field]\" aria-label=\"{{field}}\" aria-controls=\"{{field}}-slider\" class=\"form-control\"> <span>\n{{form.unit[field]}}</span></div></div>");
$templateCache.put("app/main/directives/wt-field/wt-ui-select-multiple.html","<h3 class=\"wt-field-header\" translate=\"{{form.label[field]||field.capitalize()}}\"></h3><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-field-description.html\'\"></ng-include><div ng-if=\"true\"><ui-select \nmultiple=\"multiple\" close-on-select=\"false\" ng-required=\"!form.optional[field]\" ng-model=\"obj[field]\" \ntheme=\"bootstrap\" ng-disabled=\"form.disabled[field]\"><ui-select-match placeholder=\"{{\'SEARCH_OR_SELECT\' | translate}}\">\n{{$item.name || $item}}</ui-select-match><ui-select-choices \nrepeat=\"(item.value||item) as item in form.values[field].docs || form.values[field] | filter: $select.search\" \nrefresh=\"form.refresh[field]($select.search)\" refresh-delay=\"0\" \ninfinite-scroll=\"form.refresh[field]($select.search,true)\" infinite-scroll-distance=\"1\"><div \nng-bind-html=\"item.name || item | highlight: $select.search\"></div></ui-select-choices></ui-select></div><p \nclass=\"wt-field-note\" translate=\"{{form.note[field]}}\"></p>");
$templateCache.put("app/main/directives/wt-field/wt-ui-select.html","<h3 class=\"wt-field-header\" translate=\"{{form.label[field]||field.capitalize()}}\"></h3><ng-include \nsrc=\"\'app/main/directives/wt-field/wt-field-description.html\'\"></ng-include><div ng-if=\"form.optional[field]\">\n<ui-select ng-model=\"obj[field]\" theme=\"bootstrap\" ng-disabled=\"form.disabled[field]\"><ui-select-match \nallow-clear=\"true\" placeholder=\"{{\'SEARCH_OR_SELECT\' | translate}}\">{{$select.selected.name || $select.selected}}\n</ui-select-match><ui-select-choices \nrepeat=\"(item.value||item) as item in form.values[field].docs || form.values[field] | filter: $select.search\" \nrefresh=\"form.refresh[field]($select.search)\" refresh-delay=\"0\" \ninfinite-scroll=\"form.refresh[field]($select.search,true)\" infinite-scroll-distance=\"1\"><div \nng-bind-html=\"item.name || item | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div \nng-if=\"!form.optional[field]\"><ui-select ng-model=\"obj[field]\" theme=\"bootstrap\" ng-required=\"true\" \nng-disabled=\"form.disabled[field]\"><ui-select-match placeholder=\"{{\'SEARCH_OR_SELECT\' | translate}}\"><img \nclass=\"ui-select-item-icon\" ng-if=\"$select.selected.icon\" ng-src=\"{{ $select.selected.icon }}\" \nng-alt=\"{{ $select.selected.name }}\"> <span>{{$select.selected.name || $select.selected}}</span></ui-select-match>\n<ui-select-choices \nrepeat=\"(item.value||item) as item in form.values[field].docs || form.values[field] | filter: $select.search\" \nrefresh=\"form.refresh[field]($select.search)\" refresh-delay=\"0\" \ninfinite-scroll=\"form.refresh[field]($select.search,true)\" infinite-scroll-distance=\"1\"><wt-icon ng-if=\"item.icon\" \nwt-icon-src=\"{{ item.icon }}\" wt-icon-alt=\"{{ item.name }}\"></wt-icon><div \nng-bind-html=\"item.name || item | highlight: $select.search\"></div></ui-select-choices></ui-select></div><p \nclass=\"wt-field-note\" translate=\"{{form.note[field]}}\"></p>");
$templateCache.put("app/main/directives/wt-help-button/wt-help-button.html","<span ng-if=\"helpUrl\" ng-click=\"openHelp()\" translate=\"LEARN_MORE\" \nclass=\"wt-help-button templ-badge blue small get-help\" ng-class=\"color\"></span>");
$templateCache.put("app/main/directives/wt-info/wt-info.html","<div class=\"wt-info\" ng-class=\"class\"><div class=\"wt-info-container\"><h3 ng-if=\"title\" translate=\"{{ title }}\"></h3><p \ntranslate=\"{{ content }}\" translate-values=\"{{ translateValues }}\"></p></div></div>");
$templateCache.put("app/main/directives/wt-link/wt-link.html","");
$templateCache.put("app/main/directives/wt-message/wt-message.html","<div ng-if=\"!vm.list\" class=\"wt-message\"><h1 class=\"wt-message-title\">{{vm.message.title}}</h1><p \nclass=\"wt-message-body\">{{vm.message.body}}</p></div>");
$templateCache.put("app/main/directives/wt-plan-quiz/wt-plan-quiz-modal.html","<button ng-click=\"$dismiss()\" type=\"button\" class=\"close-modal\" aria-label=\"Close\"><i class=\"icon-close\"></i></button>\n<div id=\"templ-plan-suggester\" class=\"plan-suggester\"></div>");
$templateCache.put("app/main/directives/wt-plan-quiz/wt-plan-quiz.html","<p><span translate=\"WEBSITE.PLAN_QUIZ.QUESTION\"></span> <a href=\"#\" ng-click=\"vm.openQuiz()\">\n{{\'WEBSITE.PLAN_QUIZ.LINK\' | translate}}</a>.</p>");
$templateCache.put("app/main/directives/wt-renewal-date/wt-renewal-date.html","<span class=\"wt-date\">{{ vm.date }}</span> <span ng-if=\"vm.renewsSoon && vm.autoRenewal\" \nclass=\"templ-badge small yellow\" translate=\"DOMAINS.REGISTRATION.RENEWS_SOON\"></span> <span \nng-if=\"vm.renewsSoon && !vm.autoRenewal\" class=\"templ-badge small red\" translate=\"DOMAINS.REGISTRATION.EXPIRES_SOON\">\n</span> <span ng-if=\"vm.expired\" class=\"templ-badge small red\" translate=\"DOMAINS.REGISTRATION.EXPIRED\"></span>");
$templateCache.put("app/main/directives/wt-text/wt-text.html","<div class=\"wt-text-wrapper\"><span translate=\"{{msg|truncate:trunc}}\" translate-values=\"{{translate_values}}\"></span> \n<a ng-if=\"link\" target=\"{{target}}\" href=\"{{link}}\" translate=\"{{link_text}}\"></a></div>");
$templateCache.put("app/main/directives/wt-tooltip/wt-tooltip.html","<a class=\"tooltip\" ng-attr-data-tooltip=\"{{vm.text|translate}}\" tabindex=\"0\"><span>i</span> </a>");
$templateCache.put("app/main/directives/wt-whois/wt-whois.html","<p translate=\"DOMAINS.WHOIS.DESC\"></p><div ng-if=\"loading\"><p translate=\"DOMAINS.WHOIS.LOADING\"></p></div><div \nng-if=\"!loading && !error\"><ul><li><strong translate=\"DOMAINS.WHOIS.NS\"></strong></li><li \nng-repeat=\"ns in nameservers\">{{ ns }}</li></ul><ul><li><strong translate=\"DOMAINS.WHOIS.REGISTRAR\"></strong>\n: {{ registrar }}</li><li><strong translate=\"DOMAINS.WHOIS.RENEWAL_DATE\"></strong>: {{ expirationDate }}</li></ul>\n</div><p class=\"alert alert-warning\" ng-if=\"error\" translate=\"DOMAINS.WHOIS.ERROR\"></p>");
$templateCache.put("app/main/directives/wt-icon/wt-icon.html","<img class=\"wt-icon-img\" src=\"{{ src }}\" alt=\"{{ alt }}\" ng-class=\"class\">");
$templateCache.put("app/main/extended-support/tasks/coding.html","<div class=\"icon-container\"><img src=\"/assets/icons/extended-support/coding.svg\"></div><div \nclass=\"description-container\"><h5 translate=\"EXTENDED_SUPPORT.CODING.TITLE\"></h5><p \ntranslate=\"EXTENDED_SUPPORT.CODING.DESC\"></p><div class=\"price-container\"><p class=\"price\"><span class=\"number\" \ntranslate=\"EXTENDED_SUPPORT.CODING.PRICE\"></span> / <span class=\"unit\" translate=\"EXTENDED_SUPPORT.CODING.UNIT\"></span>\n</p></div></div><div class=\"cta-container\"><a chat-launcher href=\"#\" class=\"btn btn-outline-primary\" \ntranslate=\"CHAT_WITH_US\"></a></div>");
$templateCache.put("app/main/extended-support/tasks/debugging.html","<div class=\"icon-container\"><img src=\"/assets/icons/extended-support/debugging.svg\"></div><div \nclass=\"description-container\"><h5 translate=\"EXTENDED_SUPPORT.DEBUGGING.TITLE\"></h5><p \ntranslate=\"EXTENDED_SUPPORT.DEBUGGING.DESC\"></p><div class=\"price-container\"><p class=\"price\"><span class=\"number\" \ntranslate=\"EXTENDED_SUPPORT.DEBUGGING.PRICE\"></span> / <span class=\"unit\" translate=\"EXTENDED_SUPPORT.DEBUGGING.UNIT\">\n</span></p></div></div><div class=\"cta-container\"><a chat-launcher href=\"#\" class=\"btn btn-outline-primary\" \ntranslate=\"CHAT_WITH_US\"></a></div>");
$templateCache.put("app/main/extended-support/tasks/html-css.html","<div class=\"icon-container\"><img src=\"/assets/icons/extended-support/design.svg\"></div><div \nclass=\"description-container\"><h5 translate=\"EXTENDED_SUPPORT.HTML_CSS.TITLE\"></h5><p \ntranslate=\"EXTENDED_SUPPORT.HTML_CSS.DESC\"></p><div class=\"price-container\"><p class=\"price\"><span class=\"number\" \ntranslate=\"EXTENDED_SUPPORT.HTML_CSS.PRICE\"></span> / <span class=\"unit\" translate=\"EXTENDED_SUPPORT.HTML_CSS.UNIT\">\n</span></p></div></div><div class=\"cta-container\"><a chat-launcher href=\"#\" class=\"btn btn-outline-primary\" \ntranslate=\"CHAT_WITH_US\"></a></div>");
$templateCache.put("app/main/extended-support/tasks/speed-optimization.html","<div class=\"icon-container\"><img src=\"/assets/icons/extended-support/speed-optimization.svg\"></div><div \nclass=\"description-container\"><h5 translate=\"EXTENDED_SUPPORT.SPEED_OPTIMIZATION.TITLE\"></h5><p \ntranslate=\"EXTENDED_SUPPORT.SPEED_OPTIMIZATION.DESC\"></p><div class=\"price-container\"><p class=\"price\"><span \nclass=\"number\" translate=\"EXTENDED_SUPPORT.SPEED_OPTIMIZATION.PRICE\"></span> / <span class=\"unit\" \ntranslate=\"EXTENDED_SUPPORT.SPEED_OPTIMIZATION.UNIT\"></span></p></div><small><p class=\"disclaimer\" \ntranslate=\"EXTENDED_SUPPORT.SPEED_OPTIMIZATION.DISCLAIMER\"></p></small></div><div class=\"cta-container\"><a \nchat-launcher href=\"#\" class=\"btn btn-outline-primary\" translate=\"CHAT_WITH_US\"></a></div>");
$templateCache.put("app/main/extended-support/tasks/stress-test.html","<div class=\"icon-container\"><img src=\"/assets/icons/extended-support/stress-test.svg\"></div><div \nclass=\"description-container\"><h5 translate=\"EXTENDED_SUPPORT.STRESS_TEST.TITLE\"></h5><p \ntranslate=\"EXTENDED_SUPPORT.STRESS_TEST.DESC\"></p><div class=\"price-container\"><p class=\"price\"><span class=\"number\" \ntranslate=\"EXTENDED_SUPPORT.STRESS_TEST.PRICE\"></span> / <span class=\"unit\" \ntranslate=\"EXTENDED_SUPPORT.STRESS_TEST.UNIT\"></span></p></div></div><div class=\"cta-container\"><a chat-launcher \nhref=\"#\" class=\"btn btn-outline-primary\" translate=\"CHAT_WITH_US\"></a></div>");
$templateCache.put("app/main/extended-support/tasks/wordpress-updates.html","<div class=\"icon-container\"><img src=\"/assets/icons/extended-support/wordpress-updates.svg\"></div><div \nclass=\"description-container\"><h5 translate=\"EXTENDED_SUPPORT.UPDATES.TITLE\"></h5><p \ntranslate=\"EXTENDED_SUPPORT.UPDATES.DESC\"></p><div class=\"price-container\"><p class=\"price\"><span class=\"number\" \ntranslate=\"EXTENDED_SUPPORT.UPDATES.PRICE\"></span> / <span class=\"unit\" translate=\"EXTENDED_SUPPORT.UPDATES.UNIT\">\n</span></p></div></div><div class=\"cta-container\"><a chat-launcher href=\"#\" class=\"btn btn-outline-primary\" \ntranslate=\"CHAT_WITH_US\"></a></div>");
$templateCache.put("app/main/website/newdesign/advanced.html","<div id=\"advanced_options\" ui-view=\"advanced_options\"></div>");
$templateCache.put("app/main/website/newdesign/backup.html","<div class=\"large-feature\"><section class=\"create-backup\"><h3 data-block=\"title\" translate=\"CREATE_BACKUP\">\nCreate Backup</h3><wt-help-button wt-help-url=\"https://docs.templ.site/websites/backups/create-a-backup\">\n</wt-help-button><div class=\"row\"><div class=\"col\"><p data-block=\"description\" translate=\"CREATE_BACKUP_DESCRIPTION\">\n</p><button ng-click=\"vm.create_backup()\" ng-disabled=\"obj.stopped || vm.status!=\'ok\'\" data-block=\"button\" \nclass=\"btn btn-primary\" translate=\"CREATE_BACKUP\"></button><wt-info ng-if=\"obj.app_class==\'staging\'\" \nwt-title=\"WEBSITE.DETAILS.STAGING_BACKUP_INFO.TITLE\" wt-content=\"WEBSITE.DETAILS.STAGING_BACKUP_INFO.CONTENT\">\n</wt-info></div></div></section><hr class=\"section-divider\"><section class=\"restore-backup\"><h3 data-block=\"title\" \ntranslate=\"RESTORE_BACKUP\">Restore Backup</h3><wt-help-button \nwt-help-url=\"https://docs.templ.site/websites/backups/restore-a-backup\"></wt-help-button><div class=\"row\"><div \nclass=\"col\"><p data-block=\"description\" translate=\"RESTORE_BACKUP_DESCRIPTION\"></p><div class=\"button-container\">\n<button ng-click=\"vm.restore_backup()\" ng-disabled=\"obj.stopped || vm.status!=\'ok\'\" data-block=\"button\" \nclass=\"btn btn-primary\" translate=\"RESTORE_BACKUP\"></button> <a ng-href=\"/backup/details/{{vm.backups_id}}\" \nclass=\"btn btn-outline-primary\" translate=\"SEE_DOWNLOAD_BACKUPS\"></a></div></div></div></section><hr \nclass=\"section-divider\"><section class=\"automatic-backups\"><h3 translate=\"BACKUPS.AUTOMATIC_BACKUP_TITLE\"></h3><p \ntranslate=\"BACKUPS.AUTOMATIC_BACKUP_DESC\"></p><div class=\"backup-hour-container\"><select class=\"form-control\" \nname=\"backup_hour\" id=\"backup_hour\" ng-model=\"vm.backup_hour\" \nng-options=\"hour.value as hour.label|translate for hour in vm.backup_hours\" ng-disabled=\"vm.status!=\'ok\'\"></select>\n<ng-include ng-if=\"vm.status!=\'ok\'\" src=\"\'app/main/wooadmin/models/modelstatusicon.html\'\"></ng-include></div></section>\n</div>");
$templateCache.put("app/main/website/newdesign/blueprints.html","<div class=\"large-feature\"><section class=\"extended-support\"><h3 translate=\"WEBSITE.BLUEPRINT.TITLE\" class=\"ng-scope\">\n</h3><p translate=\"WEBSITE.BLUEPRINT.DESCRIPTION\"></p><a class=\"btn btn-outline-primary\" \nng-href=\"/website/blueprint/{{vm.obj._id}}\" translate=\"WEBSITE.BLUEPRINT.CREATE_BTN\"></a></section></div>");
$templateCache.put("app/main/website/newdesign/cronjobs.html","<section class=\"website-stats\"><h3 translate=\"STATS\">Stats</h3><p>[stats]</p></section><section \nclass=\"website-advanced\"><h3>Cron</h3><div class=\"form settings\"><div class=\"tab-content\"><div \nclass=\"setting other-setting\"><h1>Add new cronjob</h1><h3>Frequency</h3><p class=\"setting-description\">\nHow often do you want your cronjob to run?</p><div class=\"input-container\"><input type=\"text\" id=\"cron-frequency\" \nname=\"ng-input-field\" class=\"form-control monospace wide\" spellcheck=\"false\" ng-model=\"opt.value\" ng-required=\"false\" \naria-invalid=\"false\" style=\"\"><p class=\"presets small\"><span>Common settings:</span> <a id=\"5-minutes\">Every 5 minutes\n</a> <a id=\"15-minutes\">Every 15 minutes</a> <a id=\"hourly\">Hourly</a> <a id=\"daily\">Daily</a> <a id=\"weekly\">Weekly\n</a></p></div><h3>Command</h3><p class=\"setting-description\">What command do you want to run?</p><div \nclass=\"input-container\"><input type=\"text\" id=\"cron-frequency\" name=\"ng-input-field\" \nclass=\"form-control monospace wide\" spellcheck=\"false\" ng-model=\"opt.value\" ng-required=\"false\" aria-invalid=\"false\" \nstyle=\"\"></div><a href=\"#\" class=\"btn btn-primary\">Add</a><h1>Current cronjobs</h1><div class=\"table cronjob-list\"><div\n class=\"table-head row no-gutters\"><div class=\"frequency\"><span>Frequency</span></div><div class=\"command\"><span>\nCommand</span></div><div class=\"actions\"><span>Actions</span></div></div><div class=\"table-row no-gutters row\"><div \nclass=\"frequency\">*/15 * * * *</div><div class=\"command\">/home/herman/wp/wp-cron.sh 2603</div><div class=\"actions\">\n<button ng-if=\"!item.link.link\" class=\"btn btn-link\">Delete</button></div></div></div></div></div></div></section>\n<script type=\"text/javascript\">\ndocument.getElementById(\'5-minutes\').onclick = function(){\n          document.getElementById(\"cron-frequency\").value = \"*/5 * * * *\";\n    }\n\n    document.getElementById(\'15-minutes\').onclick = function(){\n          document.getElementById(\"cron-frequency\").value = \"*/15 * * * *\";\n    }\n\n    document.getElementById(\'hourly\').onclick = function(){\n          document.getElementById(\"cron-frequency\").value = \"0 * * * *\";\n    }\n\n    document.getElementById(\'daily\').onclick = function(){\n          document.getElementById(\"cron-frequency\").value = \"0 0 * * *\";\n    }\n\n    document.getElementById(\'weekly\').onclick = function(){\n          document.getElementById(\"cron-frequency\").value = \"0 0 * * SUN\";\n    }\n</script>");
$templateCache.put("app/main/website/newdesign/extended_support.html","<section class=\"extended-support\"><h3 translate=\"EXTENDED_SUPPORT.EXTENDED_SUPPORT_TITLE\" class=\"ng-scope\"></h3>\n<ng-include src=\"\'app/main/extended-support/extended-support-vertical.html\'\"></ng-include></section>");
$templateCache.put("app/main/website/newdesign/function.html","<div class=\"website-function-block\"><h2><div data-block=\"title\">Title</div></h2><div data-block=\"description\">\nDescription</div><div class=\"buttons\"><md-button data-block=\"button\" class=\"md-raised md-primary\">PRESS ME</md-button>\n</div></div>");
$templateCache.put("app/main/website/newdesign/graphs.html","<div class=\"stats\"><h1 translate=\"GRAPHS.TITLE\">Graphs</h1><p translate=\"GRAPHS.SUBTITLE\">\nMonitor your website\'s performance.</p><div \nng-init=\"\n    vm.testing_options=false;\n    vm.testData=[\n    {\n        cpu:{\n            labels:[\'time\',\'used\'],\n            data:[[1,500,0],[2,600,0],[3,700,0]]\n        },\n        mem_usage:{\n            labels:[\'time\',\'used\'],\n            data:[[1,1],[2,2]]\n        },\n        mem:{\n            labels:[\'time\',\'used\'],\n            data:[[1,1],[2,2]]\n        },\n        disk:{\n            labels:[\'time\',\'used\'],\n            data:[[1,1],[2,2]]\n        },\n        data:{\n            labels:[\'time\',\'used\'],\n            data:[[1,0],[2,0]]\n        }\n    }\n    ]\">\n</div><label class=\"h4\" for=\"range\" translate=\"GRAPHS.RANGE\">Range</label><div class=\"form-inline\"><select \nclass=\"form-control mb-2 mr-sm-2\" name=\"range\" id=\"range\" ng-model=\"vm.after\" \nng-options=\"option.value as option.name|translate for option in vm.ranges\"></select><button ng-disabled=\"vm.loading\" \nng-click=\"vm.loadData()\" class=\"btn btn-primary mb-2\" translate=\"GRAPHS.LOAD\">Reload</button></div><div \nng-if=\"vm.isAdmin\" class=\"wrap-collabsible accordion admin-only advanced-settings\"><input id=\"collapsible\" \ntype=\"checkbox\" class=\"collapsible-checkbox\"><label for=\"collapsible\" class=\"collapsible-label\" \ntranslate=\"GRAPHS.ADVANCED_SETTINGS\">Advanced Settings</label><div class=\"collapsible-content\"><div \nclass=\"advanced-settings-form\"><div class=\"advanced-settings-group\"><p>\nEnables viewing a time-span that ended N seconds ago (i.e. N seconds Before now).</p><label class=\"form-check-label\" \nfor=\"before\" translate=\"GRAPHS.BEFORE\">Before (s)</label><input class=\"form-check-input form-control\" name=\"before\" \ntype=\"number\" min=\"0\" ng-model=\"vm.before\"></div><div class=\"advanced-settings-group\"><label class=\"form-check-label\" \nfor=\"points\" translate=\"GRAPHS.POINTS\">Points</label><input class=\"form-check-input form-control\" name=\"points\" \ntype=\"number\" ng-model=\"vm.points\"></div><div class=\"advanced-settings-group admin-only\" ng-if=\"vm.isAdmin\"><label \nclass=\"form-check-label\" for=\"group\" translate=\"GRAPHS.GROUP\">Group</label><select \nclass=\"form-check-input form-control\" name=\"group\" ng-model=\"vm.group\"><option value=\"max\" translate=\"max\"></option>\n<option value=\"min\" translate=\"min\"></option><option value=\"average\" translate=\"average\"></option><option \nvalue=\"median\" translate=\"median\"></option><option value=\"sum\" translate=\"sum\"></option><option \nvalue=\"incremental-sum\" translate=\"incremental-sum\"></option></select></div><div \nclass=\"advanced-settings-group admin-only\" ng-if=\"vm.isAdmin\"><label class=\"form-check-label\" for=\"curve\" \ntranslate=\"GRAPHS.CURVE\">Curve</label><input class=\"form-check-input form-control\" name=\"curve\" type=\"checkbox\" \nng-model=\"vm.curve\"></div><div class=\"advanced-settings-group\"><label class=\"form-check-label\" for=\"chartType\" \ntranslate=\"GRAPHS.CHART_TYPE\">Chart Type</label><select class=\"form-check-input form-control\" name=\"chartType\" \nng-model=\"vm.chartType\"><option value=\"LineChart\" translate=\"Line Chart\"></option><option value=\"AreaChart\" \ntranslate=\"Area Chart\"></option></select></div><div class=\"advanced-settings-group\" ng-if=\"vm.chartType==\'AreaChart\'\">\n<label class=\"form-check-label\" for=\"stacked\" translate=\"GRAPHS.STACKED\">Stacked</label><input \nclass=\"form-check-input form-control\" name=\"stacked\" type=\"checkbox\" ng-model=\"vm.stacked\"></div></div></div></div><div\n ng-repeat=\"g in vm.graphs\" class=\"graph-container\" ng-class=\"{\'admin-only\': g.admin}\"><div ng-if=\"g.admin\"><label \nfor=\"{{g.name}}\">Hide {{g.name}}</label><input name=\"{{g.name}}\" type=\"checkbox\" ng-model=\"g.disabled\"></div><div \nng-show=\"!g.disabled\" class=\"graph\"><div ng-if=\"g.title\" class=\"graph-title\"><h3>{{g.title | translate}}</h3><a \nng-if=\"g.titletooltip\" class=\"tooltip\" ng-attr-data-tooltip=\"{{g.titletooltip | translate}}\" tabindex=\"0\"><span>i\n</span></a></div><div style=\"width:100%; height:500px\" my-googlechart chart=\"g.obj\" ng-class=\"{{g.class}}\"></div></div>\n<label ng-if=\"g.chart_options\" for=\"generic_ctype\"><select class=\"\" ng-model=\"g.ctype\" name=\"generic_ctype\"><option \nng-repeat=\"opt in g.chart_options\" value=\"{{opt.value||opt}}\">{{opt.name||opt}}</option></select></label></div></div>");
$templateCache.put("app/main/website/newdesign/import.html","<section class=\"import large-feature\"><h3 translate=\"IMPORT.TITLE\"></h3><wt-help-button \nwt-help-url=\"https://docs.templ.site/migrate-to-templ\"></wt-help-button><div class=\"row\"><div class=\"col-12\"><p \ndata-block=\"description\" translate=\"IMPORT.DESC\"></p><div class=\"button-container\"><button ng-click=\"vm.migrate()\" \nng-disabled=\"obj.stopped || vm.status!=\'ok\'\" data-block=\"button\" class=\"btn btn-primary\" \ntranslate=\"IMPORT.BTN_REQUEST_MIGRATION\"></button> <button ng-click=\"vm.import()\" \nng-disabled=\"obj.stopped || vm.status!=\'ok\'\" data-block=\"button\" class=\"btn btn-outline-primary\" \ntranslate=\"IMPORT.BTN_IMPORT_WEBSITE\"></button></div><wt-info wt-content=\"IMPORT.NOTICE\"></wt-info></div></div>\n</section><hr class=\"section-divider\"><section class=\"clone large-feature\"><h3 translate=\"TOOLS.CLONE.TITLE\"></h3><div \nclass=\"row\"><div class=\"col-12\"><p data-block=\"description\" translate=\"TOOLS.CLONE.DESC\"></p><div \nclass=\"button-container\"><a class=\"btn btn-outline-primary\" ng-class=\"{\'disabled\': obj.stopped || vm.status!=\'ok\'}\" \nui-sref=\"app.website.create({clone:obj._id})\" translate=\"TOOLS.CLONE.CLONE_TO_NEW_APP_BTN\"></a> <a \nclass=\"btn btn-outline-primary\" ng-class=\"{\'disabled\': obj.stopped || vm.status!=\'ok\'}\" \nng-click=\"vm.goto(\'app.website.copyToApp\',{src:obj._id})\" translate=\"TOOLS.CLONE.CLONE_TO_EXISTING_APP_BTN\"></a></div>\n</div></div></section><hr class=\"section-divider\"><section class=\"transfer-ownership large-feature\"><h3 \ntranslate=\"TRANSFER_OWNERSHIP.TITLE\"></h3><div class=\"row\"><div class=\"col-12\"><p data-block=\"description\" \ntranslate=\"TRANSFER_OWNERSHIP.DESC\"></p><button ng-click=\"vm.transferOwnership()\" data-block=\"button\" \nclass=\"btn btn-outline-primary\" translate=\"TRANSFER_OWNERSHIP.BTN\"></button></div></div></section>");
$templateCache.put("app/main/website/newdesign/incidents.html","<section class=\"incidents large-feature\"><h3 data-block=\"title\" translate=\"INCIDENT.INCIDENT_TAB_TITLE\">Incidents</h3>\n<div ng-if=\"(obj.incidents).length > 0\" class=\"table incident-list\"><div class=\"table-head row no-gutters\"><div \nclass=\"name\"><span translate=\"INCIDENT.INCIDENT\">Incident</span></div><div class=\"link\"><span \ntranslate=\"INCIDENT.LINK\">Link</span></div><div class=\"status\"><span translate=\"INCIDENT.STATUS\">Status</span></div>\n</div><div ng-repeat=\"inc in obj.incidents\" class=\"table-row no-gutters row\" ng-class=\"{\'admin-only\':inc.admin_only}\">\n<span class=\"name\" translate=\"{{inc.subject}}\" translate-values=\"{{inc.args}}\">{{inc.subject}}</span> <a class=\"link\" \nui-sref=\"app.incident.details({id:\'{{inc._id}}\'})\" translate=\"INCIDENT.MORE_INFORMATION\">More information</a><div \nclass=\"status\"><i class=\"status-icon status-alert\"></i></div></div></div><div ng-if=\"(obj.incidents).length == 0\" \nclass=\"row\"><div class=\"col-12\"><p translate=\"INCIDENT.NO_INCIDENTS\">No incidents</p></div></div></section>");
$templateCache.put("app/main/website/newdesign/location.html","<section class=\"change-location large-feature\"><h3 data-block=\"title\" translate=\"CHANGE_LOCATION\">Change Location</h3>\n<div class=\"row\"><div class=\"col-12 col-sm-4 col-lg-3 image-container\"><img src=\"/assets/features/datacenters.svg\" \nalt=\"Datacenters\"></div><div class=\"col-12 col-sm-8 col-lg-9 button-container\"><p data-block=\"description\" \ntranslate=\"CHANGE_LOCATION_DESCRIPTION\"></p><button ng-click=\"vm.change_location()\" \nng-disabled=\"obj.stopped || vm.status!=\'ok\'\" data-block=\"button\" class=\"btn btn-primary\" translate=\"CHANGE_LOCATION\">\n</button></div></div></section>");
$templateCache.put("app/main/website/newdesign/logs.html","<section class=\"website-logs\"><h3 translate=\"LOGS.TITLE\"></h3><div class=\"tool tool--logs\"><div class=\"log-controls\">\n<div class=\"log-controls__selects\"><div class=\"log-control-group\"><label translate=\"LOGS.LABEL_LOG\"></label><select \nclass=\"form-control form-control-sm\" ng-model=\"vm.selected_log\" \nng-options=\"o.name as (o.label | translate) for o in vm.log_options\" ng-disabled=\"vm.log_running\"></select></div><div \nclass=\"log-control-group\"><label translate=\"LOGS.LABEL_LINES\"></label><select class=\"form-control form-control-sm\" \nng-model=\"vm.selected_log_lines\" \nng-options=\"o as (\'LOGS.LINES_OPTION\' | translate:{n: o}) for o in vm.log_line_options\" ng-disabled=\"vm.log_running\">\n</select></div></div><button class=\"btn btn-outline-primary\" ng-click=\"vm.run_logs()\" \nng-disabled=\"obj.stopped || vm.status!=\'ok\' || vm.log_running\" \ntranslate=\"{{ vm.log_running ? \'LOGS.BTN_LOADING\' : \'LOGS.BTN\' }}\"></button></div><div class=\"log-result\" \nng-if=\"vm.log_running\"><div class=\"log-loading\"><div class=\"spinner-border spinner-border-sm text-primary\" \nrole=\"status\"></div><span translate=\"LOGS.BTN_LOADING\"></span></div></div><div class=\"log-result\" \nng-if=\"!vm.log_running && vm.log_error\"><div class=\"log-error\" translate=\"LOGS.FETCH_ERROR\"></div></div><div \nclass=\"log-result\" ng-show=\"!vm.log_running && !vm.log_error && vm.log_output !== null\"><div \nng-show=\"vm.log_output !== null && !vm.log_output\" class=\"log-empty\" translate=\"LOGS.EMPTY\"></div><div \nng-show=\"vm.log_output\" class=\"log-output\"><pre ng-bind=\"vm.log_output\"></pre></div></div></div></section>");
$templateCache.put("app/main/website/newdesign/opmessage.html","<div ng-if=\"!obj.operation.complete && obj.operation.slow_warning.active\" class=\"wt-statustext\" \ntranslate=\"{{obj.operation.slow_warning.reason || \'OPERATION.SLOW_WARNING\'}}\" \ntranslate-values=\"{time: obj.operation.slow_warning_delay}\"></div><div \nng-if=\"!obj.operation.complete && ! obj.operation.slow_warning.active && obj.operation.time\" class=\"wt-statustext\" \ntranslate=\"WOOADMIN.OP_TIME_MSG\" translate-values=\"{time: obj.operation.time}\"></div><div \nng-if=\"(!obj.operation.complete || (obj.operation.status || \'ok\')!=\'ok\') && obj.operation.msgs[0]\" \nclass=\"wt-statustext\" ng-repeat=\"msg in [obj.operation.msgs[obj.operation.msgs.length-1]]\"><wt-text \nwt-msg=\"{{(msg.msg||msg)}}\" wt-trunc=\"75\" wt-translate-values=\"{{msg.values}}\"></wt-text><a ng-if=\"msg.link.state\" \nui-sref=\"{{msg.link.state}}(id:{{msg.link.id}})\" translate=\"{{msg.link.name}}\"></a><div \nng-if=\"obj.operation.status==\'error\'\" class=\"wt-error-text\" translate=\"WOOADMIN.OP_ERROR_NOTIFICATION_MSG\"></div></div>");
$templateCache.put("app/main/website/newdesign/options.html","<section class=\"website-advanced\"><h3 translate=\"ADVANCED.PAGE_TITLE\"></h3><div class=\"form settings\"><div \nng-show=\"vm.is_operating\"><div class=\"spinner-border text-primary\" role=\"status\"><span class=\"sr-only\">Loading...\n</span></div></div><form ng-show=\"!vm.is_operating\" name=\"modelForm\" ng-submit=\"!modelForm.$invalid && !vm.isSaving\">\n<uib-tabset active=\"vm.initial_tab\"><uib-tab ng-repeat=\"group in vm.groups\" heading=\"{{group.name|translate}}\" \nselect=\"vm.onTabSelect(group)\" classes=\"{{vm.tabClasses(group.access)}}\"><ng-include \nsrc=\"\'app/main/options/optiongroup.html\'\"></ng-include></uib-tab></uib-tabset><div \nclass=\"button-container bottom-actions\"><button class=\"btn btn-outline-primary\" ng-click=\"vm.cancel()\" \ntranslate=\"WEBSITE.CANCEL\"></button> <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"vm.save()\" \nng-disabled=\"modelForm.$invalid || vm.isSaving || vm.is_operating\" translate=\"WEBSITE.SAVE\"></button></div></form>\n</div></section>");
$templateCache.put("app/main/website/newdesign/overview-details-2.html","<div class=\"wt-website-details-list\" data-block=\"website-details\"><div data-block=\"website-details-content\"><p><span \ntranslate=\"WEBSITE.DETAILS.IP_ADDRESS\">IP Address</span><br>{{obj.ip4}}</p><p><span \ntranslate=\"WEBSITE.DETAILS.WEBROOT\">Webroot</span><br>{{obj.webroot||\"wordpress\"}}</p><p><span \ntranslate=\"WEBSITE.DETAILS.DB_NAME\">Database</span><br>{{obj.db_admin.name}}</p><p><span \ntranslate=\"WEBSITE.DETAILS.DB_USERNAME\">DB Username</span><br>{{obj.db_admin.user}}</p><p><span \ntranslate=\"WEBSITE.DETAILS.DB_PASSWORD\">DB Password</span><br><input \ntype=\"{{vm.show_password[\'db_password\'] && \'text\' || \'password\'}}\" ng-model=\"obj.db_admin.password\" \nng-required=\"false\" ng-disabled=\"true\" autocomplete=\"off\"><br><input type=\"checkbox\" \nng-model=\"vm.show_password[\'db_password\']\" ng-checked=\"vm.show_password[\'db_password\']\"><label \ntranslate=\"WEBSITE.DETAILS.SHOW_PASSWORD\">Show password</label></p><p ng-if=\"!obj.main_app\" \ntranslate=\"WEBSITE.DETAILS.DISK_USAGE\" translate-values=\"{usage:obj.disk_usage, total:obj.disk_size}\"></p></div></div>");
$templateCache.put("app/main/website/newdesign/overview-details.html","<div class=\"wt-website-details-list\" data-block=\"website-details\"><div data-block=\"website-details-content\"><p><span \ntranslate=\"WEBSITE.DETAILS.NAME\">Website Name</span><br>{{obj.name}}</p><p><span translate=\"WEBSITE.DETAILS.DOMAIN\">\nDomain</span><br>{{obj.domainn}}</p><p><span translate=\"WEBSITE.DETAILS.ADMIN_USERNAME\">Admin Username</span><br>\n{{obj.app_admin.username}}</p><p><span translate=\"WEBSITE.DETAILS.ADMIN_PASSWORD\">Admin Password</span><br><input \ntype=\"{{vm.show_password[\'password\'] && \'text\' || \'password\'}}\" ng-model=\"obj.app_admin.password\" ng-required=\"false\" \nng-disabled=\"true\" autocomplete=\"off\"><br><input type=\"checkbox\" ng-model=\"vm.show_password[\'password\']\" \nng-checked=\"vm.show_password[\'password\']\"><label translate=\"WEBSITE.DETAILS.SHOW_PASSWORD\">Show password</label></p><p \nng-if=\"!vm.get_main().ssh_password.enabled\"><span translate=\"WEBSITE.DETAILS.SSH_PASSWORD_DISABLED\"></span></p><p \nng-if=\"vm.get_main().ssh_password.enabled\"><span translate=\"WEBSITE.DETAILS.SSH_USERNAME\">SFTP Username</span><br>\n{{obj.ssh_user||\'woouser\'}}</p><p ng-if=\"vm.get_main().ssh_password.enabled\"><span \ntranslate=\"WEBSITE.DETAILS.SSH_PASSWORD\">SFTP Password</span><br><input \ntype=\"{{vm.show_password[\'ssh_password\'] && \'text\' || \'password\'}}\" ng-model=\"vm.get_main().ssh_password.password\" \nng-required=\"false\" ng-disabled=\"true\" autocomplete=\"off\"><br><input type=\"checkbox\" \nng-model=\"vm.show_password[\'ssh_password\']\" ng-checked=\"vm.show_password[\'ssh_password\']\"><label \ntranslate=\"WEBSITE.DETAILS.SHOW_PASSWORD\">Show password</label></p></div><div data-block=\"website-details-buttons\">\n<md-button ng-click=\"vm.edit()\" class=\"md-raised md-primary md-button\" ng-disabled=\"obj.stopped || vm.status!=\'ok\'\" \ntranslate=\"WOOADMIN.EDIT\"></md-button></div></div>");
$templateCache.put("app/main/website/newdesign/overview.html","<div class=\"detail-list website-details\"><div ng-if=\"vm.isAdmin\"><section class=\"edit-website\"><h3>Admin Settings</h3>\n<div class=\"row\"><div class=\"col-12\"><div class=\"button-container\"><button class=\"btn btn-success\" \nui-sref=\"app.wooadmin.app-edit({id:vm.id})\" translate=\"WOOADMIN.ADMIN\"></button> <button class=\"btn btn-success\" \nui-sref=\"app.commands.website({id:vm.id})\" translate=\"Commands\"></button> <button class=\"btn btn-outline-primary\" \nui-sref=\"app.options.website({id:vm.id})\" translate=\"Settings\">Settings</button> <button ng-if=\"obj.stopped\" \nclass=\"btn btn-outline-primary\" ng-disabled=\"vm.status==\'error\'\" ng-click=\"vm.start_app()\" translate=\"WEBSITE.START\">\nStart</button> <button ng-if=\"obj.is_container_app()\" class=\"btn btn-outline-primary\" \nui-sref=\"app.website.details({id:obj.container.manager._id})\" translate=\"WEBSITE.SERVER\">Server</button> <button \nng-if=\"obj.is_container_server()\" class=\"btn btn-outline-primary\" ui-sref=\"app.host.details({id:obj.host._id})\" \ntranslate=\"WEBSITE.CONTAINERS\">Server</button> <button ng-click=\"vm.delete()\" data-block=\"button\" \ntranslate=\"DELETE_WEBSITE_BTN\" class=\"btn btn-danger\">Delete Website</button></div></div></div></section><hr \nclass=\"section-divider\"></div><section class=\"basics\"><div class=\"basics-container row\"><div \nclass=\"left col-12 col-sm-6 col-xl-4\"><div class=\"screenshot-container desktop\"><img class=\"img-fluid screenshot\" \nng-src=\"{{vm.screenshot}}\"><div ng-if=\"!obj.stopped && vm.status==\'ok\'\" ng-repeat=\"ap in [vm.getAP(\'home\')]\" \nclass=\"overlay\"><button class=\"btn btn-primary btn-sm go-to-site\" ng-click=\"ap.action($event,vm.obj)\" \ntranslate=\"WEBSITE.DETAILS.HOME_BUTTON\"></button> <button class=\"btn btn-primary btn-sm update-thumb\" \nng-click=\"vm.generate_thumb()\" translate=\"WEBSITE.DETAILS.UPDATE_IMAGE\"></button></div></div><div \nclass=\"screenshot-container mobile\"><img ng-repeat=\"ap in [vm.getAP(\'home\')]\" ng-click=\"ap.action($event,vm.obj)\" \nclass=\"img-fluid screenshot\" ng-src=\"{{vm.screenshot}}\"> <a class=\"btn btn-primary btn-sm update-thumb\" \nng-click=\"vm.generate_thumb()\" translate=\"WEBSITE.DETAILS.UPDATE_IMAGE\"></a></div></div><div \nclass=\"right col-12 col-sm-6 col-xl-8\"><div class=\"domain\"><label for=\"domain\" translate=\"WEBSITE.DETAILS.DOMAIN\">\nDomain</label><div class=\"input-container\"><input type=\"text\" class=\"form-control monospace\" id=\"domain\" \nng-model=\"obj.domainn\" disabled=\"disabled\"><div class=\"actions\"><a class=\"copy\" ngclipboard \ndata-clipboard-text=\"{{obj.domainn}}\">Copy</a></div></div></div><div class=\"ip-address\"><label for=\"ip-address\" \ntranslate=\"WEBSITE.DETAILS.IP_ADDRESS\">IP Address</label><a ng-if=\"obj.ip4_fpcdn\" class=\"tooltip\" \nng-attr-data-tooltip=\"{{\'WEBSITE.TOOLTIPS.IP4_FPCDN\' | translate}}\" tabindex=\"0\"><span>i</span> </a><a \nng-if=\"obj.ip4_dedicated\" class=\"tooltip\" ng-attr-data-tooltip=\"{{\'WEBSITE.TOOLTIPS.IP4_DEDICATED\' | translate}}\" \ntabindex=\"0\"><span>i</span></a><div class=\"input-container\"><input ng-if=\"obj.ip4_dedicated\" type=\"text\" \nclass=\"form-control monospace\" id=\"ip-address\" ng-model=\"obj.ip4_dedicated\" disabled=\"disabled\"> <input \nng-if=\"obj.ip4_fpcdn && !obj.ip4_dedicated\" type=\"text\" class=\"form-control monospace\" id=\"ip-address\" \nng-model=\"obj.ip4_fpcdn\" disabled=\"disabled\"> <input ng-if=\"!obj.ip4_fpcdn && !obj.ip4_dedicated\" type=\"text\" \nclass=\"form-control monospace\" id=\"ip-address\" ng-model=\"obj.ip4\" disabled=\"disabled\"><div class=\"actions\"><a \nng-if=\"obj.ip4_dedicated\" class=\"copy\" ngclipboard data-clipboard-text=\"{{obj.ip4_dedicated}}\">Copy</a> <a \nng-if=\"obj.ip4_fpcdn && !obj.ip4_dedicated\" class=\"copy\" ngclipboard data-clipboard-text=\"{{obj.ip4_fpcdn}}\">Copy</a> \n<a ng-if=\"!obj.ip4_fpcdn && !obj.ip4_dedicated\" class=\"copy\" ngclipboard data-clipboard-text=\"{{obj.ip4}}\">Copy</a>\n</div></div></div><div class=\"disk-usage\"><label for=\"disk-usage\" translate=\"WEBSITE.DETAILS.DISK_USAGE\">Disk Usage\n</label><a class=\"tooltip\" ng-attr-data-tooltip=\"{{\'WEBSITE.TOOLTIPS.DISK_USAGE\' | translate}}\" tabindex=\"0\"><span>i\n</span></a><div ng-if=\"obj.disk_usage\"><div class=\"progress\" \nng-class=\"{\'yellow\': (obj.disk_usage) >= 75, \'red\': (obj.disk_usage) >= 90}\" \nng-attr-title=\"{{obj.disk_usage}}% used of {{obj.disk_size}}GB\"><div class=\"progress-bar\" role=\"progressbar\" \nid=\"disk-usage\" style=\"width: {{obj.disk_usage}}%\" data-usage=\"{{obj.disk_usage}}%\" aria-valuenow=\"50\" \naria-valuemin=\"0\" aria-valuemax=\"100\"></div></div><p>\n{{diskFree = obj.disk_size-obj.disk_size*obj.disk_usage/100; diskFree % 1 != 0 ? diskFree.toFixed(1) : diskFree;}}GB \n<span translate=\"WEBSITE.DETAILS.DISK_FREE\">free</span></p><p class=\"of\"><span \ntranslate=\"WEBSITE.DETAILS.DISK_FREE_OF\"></span> <span>{{obj.disk_size}}GB</span></p></div><div \nng-if=\"!obj.disk_usage\"><p id=\"no-disk\">n/a</p></div></div></div></div></section><div ng-if=\"obj.http_auth.enabled\"><hr\n class=\"section-divider\"><section class=\"http-auth\"><h3 translate=\"WEBSITE.LABELS.HTTP_AUTH\"></h3><wt-help-button \nwt-help-url=\"https://docs.templ.site/websites/password-protection\"></wt-help-button><div class=\"row\"><div \nclass=\"col-12 col-sm-6 col-xl-4\"><label for=\"http-user\" translate=\"WEBSITE.DETAILS.HTTP_AUTH_USER\">User</label><div \nclass=\"input-container\"><input type=\"text\" class=\"form-control monospace\" id=\"http-user\" ng-model=\"obj.http_auth.user\" \ndisabled=\"disabled\"><div class=\"actions\"><a class=\"copy\" ngclipboard data-clipboard-text=\"{{obj.http_auth.user}}\">Copy\n</a></div></div></div><div class=\"col-12 col-sm-6 col-xl-4\"><label for=\"http-password\" \ntranslate=\"WEBSITE.DETAILS.HTTP_AUTH_PASSWORD\">Password</label><div class=\"input-container\"><input \ntype=\"{{vm.show_password[\'http-password\'] && \'text\' || \'password\'}}\" class=\"form-control monospace\" id=\"http-password\" \nng-model=\"obj.http_auth.password\" disabled=\"disabled\"><div class=\"actions\"><a class=\"reveal\" \ntranslate=\"WEBSITE.DETAILS.SHOW_PASSWORD\" ng-click=\"vm.toggle_pw(\'http-password\')\"></a> <a class=\"copy\" ngclipboard \ndata-clipboard-text=\"{{obj.http_auth.password}}\">Copy</a></div></div></div></div></section></div><hr \nclass=\"section-divider\"><section class=\"wordpress\"><h3 translate=\"WEBSITE.DETAILS.WORDPRESS\">WordPress</h3><div \nclass=\"row\" ng-repeat=\"admin in [obj.app_admin]\"><div class=\"col-12 col-sm-6 col-xl-4\"><label for=\"wp-admin-username\" \ntranslate=\"WEBSITE.DETAILS.ADMIN_USERNAME\">Admin Username</label><div class=\"input-container\"><input type=\"text\" \nclass=\"form-control monospace\" id=\"wp-admin-username\" ng-model=\"obj.app_admin.username\" disabled=\"disabled\"><div \nclass=\"actions\"><a class=\"copy\" ngclipboard data-clipboard-text=\"{{obj.app_admin.username}}\">Copy</a></div></div></div>\n<div class=\"col-12 col-sm-6 col-xl-4\"><wt-field wt-type=\"password\" wt-disabled=\"true\" wt-form=\"form.app_admin\" \nwt-obj=\"obj.app_admin\" wt-field=\"password\"></wt-field></div><div class=\"col-12 col-sm-6 col-xl-4\"><label \nfor=\"wp-core-version\" translate=\"WEBSITE.DETAILS.VERSION\">Version</label><a class=\"tooltip\" \nng-attr-data-tooltip=\"{{\'WEBSITE.TOOLTIPS.WP_VERSION\' | translate}}\" tabindex=\"0\"><span>i</span></a><p \nid=\"wp-core-version\"><i class=\"wordpress-icon\"></i>{{obj.settings.wp.version||\"unknown\"}}</p><a \nclass=\"admin-only reload\" ng-if=\"vm.isAdmin\" ng-disabled=\"vm.status==\'error\'\" \nui-sref=\"app.wordpress.update({app:obj._id})\" translate=\"WEBSITE.UPDATE_WP\" tabindex=\"0\">Update</a></div></div>\n</section><hr class=\"section-divider\"><section class=\"sftp\"><h3 translate=\"WEBSITE.DETAILS.SFTP_SSH\">SFTP/SSH</h3><div \nclass=\"row\"><div class=\"col-12 col-sm-6 col-xl-4\"><label for=\"host\" translate=\"WEBSITE.DETAILS.HOST\">Host</label><div \nclass=\"input-container\"><input type=\"text\" class=\"form-control monospace\" id=\"host\" ng-model=\"obj.ssh_host\" \ndisabled=\"disabled\"><div class=\"actions\"><a class=\"copy\" ngclipboard data-clipboard-text=\"{{obj.ssh_host}}\">Copy</a>\n</div></div></div><div class=\"col-12 col-sm-6 col-xl-4\"><label for=\"sftp-port\" translate=\"WEBSITE.DETAILS.SSH_PORT\">\nSFTP/SSH Port</label><div class=\"input-container\"><input type=\"text\" class=\"form-control monospace\" id=\"sftp-port\" \nng-if=\"obj.ssh_port\" ng-model=\"obj.ssh_port\" disabled=\"disabled\"> <input type=\"text\" class=\"form-control monospace\" \nid=\"sftp-port\" ng-if=\"!obj.ssh_port\" value=\"22\" disabled=\"disabled\"><div class=\"actions\"><a class=\"copy\" ngclipboard \ndata-clipboard-text=\"{{obj.ssh_port||\'22\'}}\">Copy</a></div></div></div><div class=\"col-12 col-sm-6 col-xl-4\"><label \nfor=\"root-folder\" translate=\"WEBSITE.DETAILS.WEBROOT\" ng-click=\"vm.toggleWebroot()\" class=\"clickable\">Webroot</label>\n<div class=\"input-container\"><input type=\"text\" class=\"form-control monospace\" id=\"root-folder\" ng-if=\"obj.webroot\" \nng-model=\"vm.webroot\" disabled=\"disabled\"> <input type=\"text\" class=\"form-control monospace\" id=\"root-folder\" \nng-if=\"!obj.webroot\" value=\"wordpress\" disabled=\"disabled\"><div class=\"actions\"><a class=\"copy\" ngclipboard \ndata-clipboard-text=\"{{obj.webroot||\'wordpress\'}}\">Copy</a></div></div></div><div class=\"col-12 col-sm-6 col-xl-4\">\n<label for=\"sftp-username\" translate=\"WEBSITE.DETAILS.SSH_USERNAME\">SFTP Username</label><div class=\"input-container\">\n<input type=\"text\" class=\"form-control monospace\" id=\"sftp-username\" ng-model=\"obj.ssh_user\" disabled=\"disabled\"><div \nclass=\"actions\"><a class=\"copy\" ngclipboard data-clipboard-text=\"{{obj.ssh_user}}\">Copy</a></div></div></div><div \nclass=\"col-12 col-sm-6 col-xl-4\"><label for=\"sftp-password\" translate=\"WEBSITE.DETAILS.SSH_PASSWORD\">SFTP Password\n</label><a class=\"tooltip\" ng-attr-data-tooltip=\"{{\'WEBSITE.TOOLTIPS.SFTP_PASSWORD\' | translate}}\" tabindex=\"0\"><span>i\n</span></a><div ng-if=\"vm.ssh_password.enabled\" class=\"input-container\"><input \ntype=\"{{vm.show_password[\'sftp-password\'] && \'text\' || \'password\'}}\" class=\"form-control monospace\" \nid=\"wp-admin-password\" ng-model=\"vm.ssh_password.password\" disabled=\"disabled\"><div class=\"actions\"><a class=\"reveal\" \ntranslate=\"WEBSITE.DETAILS.SHOW_PASSWORD\" ng-click=\"vm.toggle_pw(\'sftp-password\')\"></a> <a class=\"copy\" ngclipboard \ndata-clipboard-text=\"{{vm.ssh_password.password}}\">Copy</a></div></div><div ng-if=\"!vm.ssh_password.enabled\" \nclass=\"input-container\"><span class=\"fake-disabled-input\" translate=\"WEBSITE.DETAILS.PASSWORD_DISABLED\">\nPassword disabled</span></div></div><div class=\"col-12 col-sm-6 col-xl-4\"><label for=\"sftp-password\" \ntranslate=\"WEBSITE.DETAILS.SSH_TOOLS\">SSH Tools</label><a class=\"tooltip\" \nng-attr-data-tooltip=\"{{\'WEBSITE.TOOLTIPS.SSH_TOOLS\' | translate}}\" tabindex=\"0\"><span>i</span></a><div \nng-if=\"obj.ssh_tool_tab==\'command\'\" class=\"input-container\"><input type=\"text\" class=\"form-control monospace\" \nid=\"ssh-command\" ng-model=\"obj.ssh_command\" disabled=\"disabled\"><div class=\"actions\"><a class=\"copy\" ngclipboard \ndata-clipboard-text=\"{{obj.ssh_command}}\">Copy</a></div></div><div ng-if=\"obj.ssh_tool_tab==\'config\'\" \nclass=\"input-container\"><textarea type=\"text\" class=\"form-control monospace\" id=\"ssh-command\" rows=\"4\" \ndisabled=\"disabled\">{{obj.ssh_config}}</textarea><div class=\"actions\"><a class=\"copy\" ngclipboard \ndata-clipboard-text=\"{{obj.ssh_config}}\">Copy</a></div></div><div class=\"toggle-links\"><a \nng-click=\"obj.ssh_tool_show_command()\" ng-class=\"{\'active\': obj.ssh_tool_tab==\'command\'}\" \ntranslate=\"WEBSITE.DETAILS.SSH_COMMAND\">SSH Command</a> <a ng-click=\"obj.ssh_tool_show_config()\" \nng-class=\"{\'active\': obj.ssh_tool_tab==\'config\'}\" translate=\"WEBSITE.DETAILS.SSH_CONFIG\">SSH Config</a></div></div><div\n ng-if=\"vm.isAdmin\" class=\"col-12 col-sm-6 col-xl-8 admin-only\"><label for=\"link-group\">Links</label><div \nid=\"link.group\" class=\"link-group\"><div class=\"input-container\" ng-if=\"obj.sshfs\"><input type=\"text\" \nclass=\"form-control monospace\" id=\"sshfs-term\" ng-model=\"obj.sshfs\" disabled=\"disabled\"><div class=\"actions\"><a \nclass=\"copy\" ngclipboard data-clipboard-text=\"{{obj.sshfs}}\">Copy</a></div></div><div class=\"input-container\" \nng-if=\"obj.sshL\"><input type=\"text\" class=\"form-control monospace\" id=\"sshL-term\" ng-model=\"obj.sshL\" \ndisabled=\"disabled\"><div class=\"actions\"><a class=\"copy\" ngclipboard data-clipboard-text=\"{{obj.sshL}}\">Copy</a></div>\n</div></div></div></div></section><hr class=\"section-divider\"><section class=\"database\"><h3 \ntranslate=\"WEBSITE.DETAILS.DATABASE\">Database</h3><div class=\"row\"><div class=\"col-12 col-sm-6 col-xl-4\"><label \nfor=\"db-name\" translate=\"WEBSITE.DETAILS.DB_NAME\">Database</label><div class=\"input-container\"><input type=\"text\" \nclass=\"form-control monospace\" id=\"db-name\" ng-model=\"obj.db_admin.name\" disabled=\"disabled\"><div class=\"actions\"><a \nclass=\"copy\" ngclipboard data-clipboard-text=\"{{obj.db_admin.name}}\">Copy</a></div></div></div><div \nclass=\"col-12 col-sm-6 col-xl-4\"><label for=\"db-username\" translate=\"WEBSITE.DETAILS.DB_USERNAME\">DB Username</label>\n<div class=\"input-container\"><input type=\"text\" class=\"form-control monospace\" id=\"db-username\" \nng-model=\"obj.db_admin.user\" disabled=\"disabled\"><div class=\"actions\"><a class=\"copy\" ngclipboard \ndata-clipboard-text=\"{{obj.db_admin.user}}\">Copy</a></div></div></div><div class=\"col-12 col-sm-6 col-xl-4\"><label \nfor=\"db-password\" translate=\"WEBSITE.DETAILS.DB_PASSWORD\">DB Password</label><div class=\"input-container\"><input \ntype=\"{{vm.show_password[\'db-password\'] && \'text\' || \'password\'}}\" class=\"form-control monospace\" id=\"db-password\" \nng-model=\"obj.db_admin.password\" disabled=\"disabled\"><div class=\"actions\"><a class=\"reveal\" \ntranslate=\"WEBSITE.DETAILS.SHOW_PASSWORD\" ng-click=\"vm.toggle_pw(\'db-password\')\"></a> <a class=\"copy\" ngclipboard \ndata-clipboard-text=\"{{obj.db_admin.password}}\">Copy</a></div></div></div></div></section><hr class=\"section-divider\">\n<section class=\"edit-website button-with-description\"><h3 translate=\"WEBSITE.DETAILS.EDIT_WEBSITE_DETAILS\">\nEdit Website Details</h3><p translate=\"WEBSITE.DETAILS.EDIT_WEBSITE_DETAILS_DESCRIPTION\"></p><button \nng-click=\"vm.edit()\" class=\"btn btn-primary\" \nng-disabled=\"obj.stopped || vm.status!=\'ok\' || false && obj.app_class==\'staging\'\" \ntranslate=\"WEBSITE.DETAILS.EDIT_WEBSITE_DETAILS\">Edit Website Details</button></section><hr class=\"section-divider\">\n<section class=\"restart-server button-with-description\"><h3 data-block=\"title\" translate=\"RESTART_WEBSITE\">\nRestart Server</h3><p data-block=\"description\" translate=\"RESTART_WEBSITE_DESCRIPTION\"></p><button \nng-click=\"vm.restart_app()\" ng-disabled=\"obj.stopped || vm.status!=\'ok\'\" data-block=\"button\" \ntranslate=\"RESTART_WEBSITE_BTN\" class=\"btn btn-primary\">Restart Server</button></section><hr class=\"section-divider\">\n<section ng-if=\"obj.app_class!=\'staging\'\" class=\"delete-website button-with-description\"><h3 data-block=\"title\" \ntranslate=\"DELETE_WEBSITE\">Delete Website</h3><p data-block=\"description\" translate=\"DELETE_WEBSITE_DESCRIPTION\"></p>\n<button ng-click=\"vm.delete()\" ng-disabled=\"vm.disable_delete\" data-block=\"button\" translate=\"DELETE_WEBSITE_BTN\" \nclass=\"btn btn-danger\"></button></section><section ng-if=\"obj.app_class==\'staging\'\" \nclass=\"delete-website button-with-description\"><h3 data-block=\"title\" translate=\"DELETE_STAGING\">Delete Staging Site\n</h3><p data-block=\"description\" translate=\"DELETE_STAGING_DESCRIPTION\"></p><button ng-click=\"vm.delete()\" \nng-disabled=\"vm.disable_delete\" data-block=\"button\" translate=\"DELETE_STAGING_BTN\" class=\"btn btn-danger\"></button>\n</section></div>");
$templateCache.put("app/main/website/newdesign/plan.html","<section class=\"current-plan large-feature\"><h3 data-block=\"title\" translate=\"WEBSITE.PLAN\">Plan</h3><div \nng-if=\"vm.plan_code==\'dev-sm01\' || vm.plan_code==\'dev-micro\'\" class=\"row\"><div class=\"col-12\"><p \ntranslate=\"WEBSITE.DEVELOPMENT_SITE_DETAILS.DESC\"></p><ul><li translate=\"WEBSITE.DEVELOPMENT_SITE_DETAILS.BULLET_2\">\n</li><li translate=\"WEBSITE.DEVELOPMENT_SITE_DETAILS.BULLET_3\"></li></ul></div></div><div class=\"row\"><div \nclass=\"col-12\"><div ng-if=\"obj.app_class!=\'staging\' && obj.plan.code!=\'addon\' && obj.plan.code!=\'custom\'\"><table \nclass=\"data-table\"><thead><tr><td translate=\"WEBSITE.SELECT_VALUES.PLAN.{{obj.plan.code.toUpperCase()}}\"></td><td></td>\n</tr></thead><tbody><tr><td>CPU</td><td translate=\"WEBSITE.PLAN_SPECS.CPU.{{obj.plan.code.toUpperCase()}}\"></td></tr>\n<tr><td>RAM</td><td translate=\"WEBSITE.PLAN_SPECS.RAM.{{obj.plan.code.toUpperCase()}}\"></td></tr><tr><td \ntranslate=\"WEBSITE.PLAN_SPECS.DESC.STORAGE\">Storage</td><td>{{obj.disk_size}}GB <abbr class=\"tooltip\" \nng-if=\"vm.has_upgraded_disk()\" translate=\"WEBSITE.DETAILS.DISK_INCLUDED\" \ntranslate-values=\"{included_disk: vm.get_included_disk()}\" \nng-attr-data-tooltip=\"{{ (\'WEBSITE.DETAILS.UPGRADED_DISK\'|translate) + vm.get_additional_disk() + \'GB\' }} \"></abbr>\n</td></tr><tr><td translate=\"WEBSITE.PLAN_SPECS.DESC.BANDWIDTH\">Bandwidth</td><td \ntranslate=\"WEBSITE.PLAN_SPECS.BW.{{obj.plan.code.toUpperCase()}}\"></td></tr></tbody></table><p \ndata-block=\"description\" translate=\"CHANGE_PLAN_DESCRIPTION\"></p><button ng-click=\"vm.upgrade()\" \nng-disabled=\"obj.stopped || vm.status!=\'ok\' || vm.disable_billing\" data-block=\"button\" class=\"btn btn-primary\" \ntranslate=\"CHANGE_PLAN\"></button></div><div ng-if=\"obj.app_class==\'staging\'\"><p class=\"specs\" \ntranslate=\"WEBSITE.DETAILS.STAGING_DETAILS_DESCRIPTION\" translate-values=\"{live_site:obj.copy_from.name}\"></p><button \ndata-block=\"button\" class=\"btn btn-primary\" translate=\"CHANGE_PLAN\" disabled=\"disabled\"></button></div><div \nng-if=\"obj.plan.code==\'addon\'\"><p><span translate=\"WEBSITE.DETAILS.SHARED_SITE\"></span> <a \nui-sref=\"app.website.details({id:obj.main_app._id})\">{{obj.main_app.name}}</a>.</p><button data-block=\"button\" \nclass=\"btn btn-primary\" translate=\"CHANGE_PLAN\" disabled=\"disabled\"></button></div><div \nng-if=\"obj.plan.code==\'custom\'\"><table class=\"data-table\"><thead><tr><td \ntranslate=\"WEBSITE.SELECT_VALUES.PLAN.{{obj.plan.code.toUpperCase()}}\"></td><td></td></tr></thead><tbody><tr><td>CPU\n</td><td>{{obj.cpu}} CPU</td></tr><tr><td>RAM</td><td>{{obj.ram}}GB</td></tr><tr><td \ntranslate=\"WEBSITE.PLAN_SPECS.DESC.STORAGE\">Storage</td><td>{{obj.disk_size}}GB</td></tr><tr><td \ntranslate=\"WEBSITE.PLAN_SPECS.DESC.BANDWIDTH\">Bandwidth</td><td ng-if=\"obj.plan.code != \'custom\'\" \ntranslate=\"WEBSITE.PLAN_SPECS.BW.{{obj.plan.code.toUpperCase()}}\"></td><td ng-if=\"obj.plan.code == \'custom\'\">\n{{ obj.cpu * 4 + obj.ram * 8 }}GB</td></tr></tbody></table><p data-block=\"description\" \ntranslate=\"CHANGE_PLAN_DESCRIPTION\"></p><button ng-click=\"vm.upgrade()\" ng-disabled=\"obj.stopped || vm.status!=\'ok\'\" \ndata-block=\"button\" class=\"btn btn-primary\" translate=\"CHANGE_PLAN\"></button></div></div></div></section>");
$templateCache.put("app/main/website/newdesign/staging.html","<div class=\"large-feature\"><section ng-if=\"!vm.has_staging() && !vm.is_staging()\" class=\"staging large-feature\"><h3 \ndata-block=\"title\" translate=\"STAGING\">Staging</h3><wt-help-button \nwt-help-url=\"https://docs.templ.site/websites/staging-websites\"></wt-help-button><div class=\"row\"><div class=\"col-12\">\n<p data-block=\"description\" translate=\"CREATE_STAGING_DESCRIPTION\"></p><button ng-click=\"vm.create_staging()\" \nng-disabled=\"obj.stopped || vm.status!=\'ok\' || vm.disable_create_staging\" data-block=\"button\" class=\"btn btn-primary\" \ntranslate=\"CREATE_STAGING_BTN\"></button></div></div></section><section ng-if=\"vm.has_staging() || vm.is_staging()\" \nclass=\"staging-copy large-feature\"><h3 data-block=\"title\" translate=\"STAGING\">Staging</h3><wt-help-button \nwt-help-url=\"https://docs.templ.site/websites/staging-websites\"></wt-help-button><p \ntranslate=\"WEBSITE.DETAILS.STAGING_ACTIONS_DESCRIPTION\"></p><div class=\"copy-direction-form\"><label \nfor=\"production-to-staging\" ng-class=\"{\'is-selected\': vm.staging_copy_direction == \'production-to-staging\'}\"><span \ntranslate=\"WEBSITE.DETAILS.COPY_FROM_PRODUCTION_TO_STAGING\"></span> <img \nsrc=\"assets/icons/staging/production-to-staging.svg\" alt=\"production-to-staging\"> <input type=\"radio\" \nclass=\"templ-radio\" id=\"production-to-staging\" name=\"staging_copy_direction\" ng-model=\"vm.staging_copy_direction\" \nvalue=\"production-to-staging\"></label><label for=\"staging-to-production\" \nng-class=\"{\'is-selected\': vm.staging_copy_direction == \'staging-to-production\'}\"><span \ntranslate=\"WEBSITE.DETAILS.COPY_FROM_STAGING_TO_PRODUCTION\"></span> <img \nsrc=\"assets/icons/staging/staging-to-production.svg\" alt=\"staging-to-production\"> <input type=\"radio\" \nclass=\"templ-radio\" id=\"staging-to-production\" name=\"staging_copy_direction\" ng-model=\"vm.staging_copy_direction\" \nvalue=\"staging-to-production\"></label></div><button class=\"btn btn-primary\" ng-click=\"vm.do_copy()\" \nng-disabled=\"vm.status!=\'ok\'\" translate=\"WEBSITE.DETAILS.COPY_CONTINUE_BUTTON\"></button><div class=\"cross-site-links\">\n<button ng-if=\"vm.has_staging()\" ng-click=\"vm.go_to_staging()\" data-block=\"button\" \nclass=\"btn btn-link arrow-icon arrow-right visit-domain\" translate=\"WEBSITE.DETAILS.GO_TO_STAGING\"></button> <button \nng-if=\"vm.is_staging()\" ng-click=\"vm.go_to_production()\" class=\"btn btn-link arrow-icon arrow-right\" \ntranslate=\"WEBSITE.DETAILS.GO_TO_PRODUCTION\"></button></div></section></div>");
$templateCache.put("app/main/website/newdesign/stats.html","<div id=\"site_stats\" ui-view=\"site_stats\"></div>");
$templateCache.put("app/main/website/newdesign/tools-deactivate-plugin-modal.html","<h1 translate=\"TOOLS.DEACTIVATE_PLUGIN.MODAL_TITLE\"></h1><form name=\"deactivatePluginForm\" \nng-submit=\"!deactivatePluginForm.$invalid && vm.ok()\" novalidate=\"novalidate\"><input type=\"submit\" \nstyle=\"position: absolute; left: -9999px; width: 1px; height: 1px\"><p translate=\"TOOLS.DEACTIVATE_PLUGIN.DESC\"></p><div\n class=\"form-group\"><label for=\"deactivatePluginSlug\" translate=\"TOOLS.DEACTIVATE_PLUGIN.SLUG_LABEL\"></label><input \ntype=\"text\" class=\"form-control\" id=\"deactivatePluginSlug\" name=\"slug\" ng-model=\"vm.slug\" \nng-pattern=\"/^[a-z0-9][a-z0-9_-]*$/\" ng-trim=\"true\" autofocus \nplaceholder=\"{{ \'TOOLS.DEACTIVATE_PLUGIN.PLACEHOLDER\' | translate }}\" required></div><div class=\"button-container\">\n<button ng-click=\"vm.cancel()\" type=\"button\" class=\"btn btn-outline-primary\" translate=\"WEBSITE.CANCEL\"></button> \n<button type=\"submit\" ng-disabled=\"deactivatePluginForm.$invalid\" class=\"btn btn-primary\" \ntranslate=\"TOOLS.DEACTIVATE_PLUGIN.BTN\"></button></div></form>");
$templateCache.put("app/main/website/newdesign/tools-deactivate-plugin.html","<div class=\"tool tool--deactivate-plugin\"><div class=\"tool__header\"><div class=\"icon\"><img \nsrc=\"/assets/icons/tools/deactivate-plugin.svg?v=20260820\"></div><div class=\"description\"><h4><span \ntranslate=\"TOOLS.DEACTIVATE_PLUGIN.TITLE\"></span> <span class=\"templ-badge dark-green small new\" translate=\"NEW\">\n</span></h4><p translate=\"TOOLS.DEACTIVATE_PLUGIN.DESC\"></p></div><div class=\"action action--multi\"><button \nclass=\"btn btn-outline-danger\" ng-click=\"vm.confirm_deactivate_all_plugins()\" \nng-disabled=\"obj.stopped || vm.status!=\'ok\' || vm.deactivate_plugin_running\" \ntranslate=\"TOOLS.DEACTIVATE_PLUGIN.BTN_ALL\"></button> <button class=\"btn btn-outline-primary\" \nng-click=\"vm.open_deactivate_plugin()\" ng-disabled=\"obj.stopped || vm.status!=\'ok\' || vm.deactivate_plugin_running\" \ntranslate=\"TOOLS.DEACTIVATE_PLUGIN.BTN_SINGLE\"></button></div></div><div class=\"dp-result\" \nng-if=\"vm.deactivate_plugin_running\"><div class=\"dp-loading\"><div \nclass=\"spinner-border spinner-border-sm text-primary\" role=\"status\"></div><span \ntranslate=\"TOOLS.DEACTIVATE_PLUGIN.BTN_RUNNING\"></span></div></div><div class=\"dp-result\" \nng-if=\"!vm.deactivate_plugin_running && vm.deactivate_plugin_feedback\"><div \nng-class=\"{\n                 \'dp-success\': vm.deactivate_plugin_feedback.severity === \'success\',\n                 \'dp-warning\': vm.deactivate_plugin_feedback.severity === \'warning\',\n                 \'dp-error\':   vm.deactivate_plugin_feedback.severity === \'error\'\n             }\" \ntranslate=\"{{ vm.deactivate_plugin_feedback.key }}\" \ntranslate-values=\"{{ vm.deactivate_plugin_feedback.values || {} }}\"></div></div></div>");
$templateCache.put("app/main/website/newdesign/tools-disk-usage.html","<div class=\"tool tool--disk-usage\"><div class=\"tool__header\"><div class=\"icon\"><img \nsrc=\"/assets/icons/tools/disk-usage.svg?v=20260610-2\"></div><div class=\"description\"><h4><span \ntranslate=\"TOOLS.DISK_USAGE.TITLE\"></span> <span class=\"templ-badge dark-green small new\" translate=\"NEW\"></span></h4>\n<p translate=\"TOOLS.DISK_USAGE.DESC\"></p></div><div class=\"action\"><button class=\"btn btn-outline-primary\" \nng-click=\"vm.run_disk_usage()\" ng-disabled=\"obj.stopped || vm.status!=\'ok\' || vm.du_running\" \ntranslate=\"{{ vm.du_running ? \'TOOLS.DISK_USAGE.BTN_ANALYZING\' : \'TOOLS.DISK_USAGE.BTN\' }}\"></button></div></div><div \nclass=\"du-result\" ng-if=\"vm.du_running\"><div class=\"du-loading\"><div \nclass=\"spinner-border spinner-border-sm text-primary\" role=\"status\"></div><span \ntranslate=\"TOOLS.DISK_USAGE.BTN_ANALYZING\"></span></div></div><div class=\"du-result\" \nng-if=\"!vm.du_running && (vm.du_error || vm.du_rows !== null)\"><div class=\"du-result-bar\"><div ng-if=\"vm.du_error\" \nclass=\"du-error\" translate=\"TOOLS.DISK_USAGE.ERROR\"></div><div ng-if=\"!vm.du_error && vm.du_rows.length === 0\" \nclass=\"du-empty\" translate=\"TOOLS.DISK_USAGE.EMPTY\"></div><div ng-if=\"!vm.du_error && vm.du_rows.length > 0\" \nclass=\"du-total\"><span translate=\"TOOLS.DISK_USAGE.TOTAL\"></span> <strong>{{ vm.du_total }}</strong></div><button \nclass=\"btn btn-link du-clear\" ng-click=\"vm.clear_disk_usage()\" translate=\"TOOLS.DISK_USAGE.CLEAR\"></button></div><div \nng-if=\"!vm.du_error && vm.du_rows.length > 0\" class=\"du-table-wrap\"><table class=\"du-table\"><thead><tr><th \ntranslate=\"TOOLS.DISK_USAGE.COL_SIZE\"></th><th translate=\"TOOLS.DISK_USAGE.COL_PATH\"></th></tr></thead><tbody><tr \nng-repeat=\"row in vm.du_rows track by $index\"><td class=\"du-size\">{{ row.size }}</td><td class=\"du-path\">{{ row.path }}\n</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/website/newdesign/tools-maintenance-mode.html","<div class=\"tool tool--maintenance-mode\"><div class=\"tool__header\"><div class=\"icon\"><img \nsrc=\"/assets/icons/tools/exit-maintenance-mode.svg?v=20260820\"></div><div class=\"description\"><h4><span \ntranslate=\"TOOLS.DEACTIVATE_MAINTENANCE_MODE.TITLE\"></span> <span class=\"templ-badge dark-green small new\" \ntranslate=\"NEW\"></span></h4><p translate=\"TOOLS.DEACTIVATE_MAINTENANCE_MODE.DESC\"></p></div><div class=\"action\"><button\n class=\"btn btn-outline-primary\" ng-click=\"vm.run_deactivate_maintenance()\" \nng-disabled=\"obj.stopped || vm.status!=\'ok\' || vm.maintenance_mode_running\" \ntranslate=\"TOOLS.DEACTIVATE_MAINTENANCE_MODE.BTN\"></button></div></div><div class=\"dp-result\" \nng-if=\"vm.maintenance_mode_running\"><div class=\"dp-loading\"><div class=\"spinner-border spinner-border-sm text-primary\" \nrole=\"status\"></div><span translate=\"TOOLS.DEACTIVATE_MAINTENANCE_MODE.BTN_RUNNING\"></span></div></div><div \nclass=\"dp-result\" ng-if=\"!vm.maintenance_mode_running && vm.maintenance_mode_feedback\"><div \nng-class=\"{\n                 \'dp-success\': vm.maintenance_mode_feedback.severity === \'success\',\n                 \'dp-warning\': vm.maintenance_mode_feedback.severity === \'warning\',\n                 \'dp-error\':   vm.maintenance_mode_feedback.severity === \'error\'\n             }\" \ntranslate=\"{{ vm.maintenance_mode_feedback.key }}\"></div></div></div>");
$templateCache.put("app/main/website/newdesign/tools.html","<section class=\"website-tools\"><h3 translate=\"TOOLS.TITLE\"></h3><ng-include \nsrc=\"\'app/main/website/newdesign/tools-disk-usage.html\'\"></ng-include><hr class=\"section-divider\"><div class=\"tool\">\n<div class=\"icon\"><img src=\"/assets/icons/tools/check-vulnerabilities.svg?v=2024\"></div><div class=\"description\"><h4 \ntranslate=\"TOOLS.CHECK_VULNERABILITIES.TITLE\">Check For Vulnerabilities</h4><p \ntranslate=\"TOOLS.CHECK_VULNERABILITIES.DESC\"></p></div><div class=\"action\"><button class=\"btn btn-outline-primary\" \nng-click=\"vm.run_tool(\'check-vulnerabilities\')\" ng-disabled=\"obj.stopped || vm.status!=\'ok\'\" \ntranslate=\"TOOLS.CHECK_VULNERABILITIES.BTN\"></button></div></div><hr class=\"section-divider\"><div class=\"tool\"><div \nclass=\"icon\"><img src=\"/assets/icons/tools/clear-banned-ips.svg?v=2024\"></div><div class=\"description\"><h4 \ntranslate=\"TOOLS.CLEAR_BANNED_IPS.TITLE\">Clear Banned IPS</h4><p translate=\"TOOLS.CLEAR_BANNED_IPS.DESC\"></p></div><div\n class=\"action\"><button class=\"btn btn-outline-primary\" ng-click=\"vm.run_tool(\'clear-banned-ips\')\" \nng-disabled=\"obj.stopped || vm.status==\'working\'\" translate=\"TOOLS.CLEAR_BANNED_IPS.BTN\"></button></div></div><hr \nclass=\"section-divider\"><div class=\"tool\"><div class=\"icon\"><img src=\"/assets/icons/tools/templ-plugins.svg?v=2024\">\n</div><div class=\"description\"><h4 translate=\"TOOLS.INSTALL_TEMPL_PLUGIN.TITLE\">Install Templ Plugins</h4><p \ntranslate=\"TOOLS.INSTALL_TEMPL_PLUGIN.DESC\"></p></div><div class=\"action\"><button class=\"btn btn-outline-primary\" \nng-click=\"vm.run_tool(\'fix-plugins\')\" ng-disabled=\"obj.stopped || vm.status!=\'ok\'\" \ntranslate=\"TOOLS.INSTALL_TEMPL_PLUGIN.BTN\"></button></div></div><hr class=\"section-divider\"><ng-include \nsrc=\"\'app/main/website/newdesign/tools-deactivate-plugin.html\'\"></ng-include><hr class=\"section-divider\"><div \nclass=\"tool\"><div class=\"icon\"><img src=\"/assets/icons/tools/repair-filepermissions.svg?v=2024\"></div><div \nclass=\"description\"><h4 translate=\"TOOLS.FIX_FILE_PERMISSIONS.TITLE\">Fix File Permissions</h4><p \ntranslate=\"TOOLS.FIX_FILE_PERMISSIONS.DESC\"></p></div><div class=\"action\"><button class=\"btn btn-outline-primary\" \nng-click=\"vm.run_tool(\'fix-permissions\')\" ng-disabled=\"obj.stopped || vm.status!=\'ok\'\" \ntranslate=\"TOOLS.FIX_FILE_PERMISSIONS.BTN\"></button></div></div><hr class=\"section-divider\"><div class=\"tool\"><div \nclass=\"icon\"><img src=\"/assets/icons/tools/fix-domain.svg?v=2024\"></div><div class=\"description\"><h4 \ntranslate=\"TOOLS.FIX_DOMAIN.TITLE\">Fix Domain</h4><p translate=\"TOOLS.FIX_DOMAIN.DESC\"></p></div><div class=\"action\">\n<button class=\"btn btn-outline-primary\" ng-click=\"vm.run_tool(\'fix-domain\')\" \nng-disabled=\"obj.stopped || vm.status!=\'ok\'\" translate=\"TOOLS.FIX_DOMAIN.BTN\"></button></div></div><hr \nclass=\"section-divider\"><ng-include src=\"\'app/main/website/newdesign/tools-maintenance-mode.html\'\"></ng-include><hr \nclass=\"section-divider\"><div class=\"tool\"><div class=\"icon\"><img src=\"/assets/icons/tools/wordpress.svg?ver=2024\">\n</div><div class=\"description\"><h4 translate=\"TOOLS.INSTALL_WP.TITLE\"></h4><p translate=\"TOOLS.INSTALL_WP.DESC\"></p>\n</div><div class=\"action\"><button class=\"btn btn-outline-danger\" \nng-click=\"vm.run_tool_confirm(\'install-wp\', \'TOOLS.INSTALL_WP.CONFIRM_TITLE\', \'TOOLS.INSTALL_WP.CONFIRM_TEXT\')\" \nng-disabled=\"obj.stopped || vm.status!=\'ok\'\" translate=\"TOOLS.INSTALL_WP.BTN\"></button></div></div></section>");
$templateCache.put("app/main/website/newdesign/website-main.html","<div ng-repeat=\"obj in [vm.obj]\"><div ng-if=\"!obj.error\"><div class=\"row\"><div ng-if=\"vm.isAdmin\" id=\"admin-info\" \nclass=\"col-12\"><div ng-if=\"vm.obj.user && vm.user && vm.obj.user!=vm.user\"><a \nng-click=\"vm.auth.selectUser(vm.obj.user)\" translate=\"ADMIN_DETAILS_MSG\" translate_values=\"{obj_user:vm.obj.user}\">\nSelect</a></div></div><div class=\"title-with-buttons col-12\"><div class=\"title website-details-title\"><h1>{{vm.title}}\n</h1><div class=\"badges-and-status\"><ng-include src=\"\'app/main/wooadmin/models/modelstatusicon.html\'\" \nclass=\"wt-website-status\"></ng-include><span class=\"location\"><img ng-if=\"obj.location\" \nng-src=\"{{vm.getFlag(obj.location.code)}}\" alt=\"{{obj.location.name}}\"> <span class=\"location-name\">\n{{obj.location.name}} </span></span><span ng-if=\"vm.get_app_class()==\'production\' && !vm.has_staging()\" \nclass=\"templ-badge app-class dark-green small\" translate=\"PRODUCTION\">Production</span> <span \nng-if=\"vm.get_app_class()==\'production\' && vm.has_staging()\" ng-click=\"vm.go_to_staging()\" \nclass=\"templ-badge app-class dark-green small is-button\" translate=\"PRODUCTION\">Production</span> <span \nng-if=\"vm.get_app_class()==\'staging\' && !vm.is_staging()\" class=\"templ-badge app-class dark-yellow small\" \ntranslate=\"STAGING\">Staging</span> <span ng-if=\"vm.get_app_class()==\'staging\' && vm.is_staging()\" \nng-click=\"vm.go_to_production()\" class=\"templ-badge app-class dark-yellow small is-button\" translate=\"STAGING\">Staging\n</span> <span ng-if=\"vm.get_app_class()==\'development\' && !vm.has_staging()\" \nclass=\"templ-badge app-class dark-purple small\" translate=\"DEVELOPMENT\">Development</span> <span \nng-if=\"vm.get_app_class()==\'development\' && vm.has_staging()\" ng-click=\"vm.go_to_staging()\" \nclass=\"templ-badge app-class dark-purple small is-button\" translate=\"DEVELOPMENT\">Development</span> <span \nng-if=\"vm.get_plan_name()!=\'unknown\'\" class=\"templ-badge dark-blue small plan\" translate=\"{{vm.get_plan_name()}}\">\n</span></div><div class=\"go-to-site-container\"><a ng-repeat=\"ap in [vm.getAP(\'home\')]\" \nng-click=\"ap.action($event,vm.obj)\"><span>{{ ap.label }}</span></a></div></div><div class=\"button-container\"><button \nclass=\"btn btn-primary btn-wp-admin\" ng-disabled=\"vm.status==\'error\'\" ng-repeat=\"ap in [vm.getAP(\'admin\')]\" \nng-click=\"ap.action($event,vm.obj)\" translate=\"{{ ap.label }}\" tabindex=\"0\"></button> <button \nclass=\"btn btn-outline-primary\" ng-repeat=\"ap in [vm.getAP(\'home\')]\" ng-click=\"ap.action($event,vm.obj)\" \ntranslate=\"WEBSITE.DETAILS.HOME_BUTTON\"></button><wt-dropdown-button wt-button-text=\"CONNECT\" \nwt-button-class=\"btn btn-outline-primary\"><a ng-if=\"vm.ssh_password.url\" class=\"wt-dropdown-item\" \nng-click=\"vm.open_ssh()\" translate=\"WEBSITE.OPEN_SSH_IN_BROWSER\"></a> <a class=\"wt-dropdown-item\" \nng-disabled=\"vm.status==\'error\'\" ng-repeat=\"ap in [vm.getAP(\'sql\')]\" ng-click=\"ap.action($event,vm.obj)\" \ntranslate=\"{{ ap.label }}\"></a> <a class=\"wt-dropdown-item\" ng-disabled=\"vm.status==\'error\'\" \nng-repeat=\"ap in [vm.getAP(\'tfm\')]\" ng-click=\"ap.action($event,vm.obj)\" translate=\"{{ ap.label }}\"></a> <a \nclass=\"wt-dropdown-item admin-only\" ng-if=\"vm.isAdmin\" \nng-href=\"sftp://{{obj.ssh_user}}@{{obj.ssh_host}}:{{obj.ssh_port||\'22\'}}\" translate=\"WEBSITE.OPEN_SFTP\"></a> <a \nclass=\"wt-dropdown-item admin-only\" ng-if=\"vm.isAdmin\" \nng-href=\"ssh://{{obj.ssh_user}}@{{obj.ssh_host}}:{{obj.ssh_port||\'22\'}}\" translate=\"WEBSITE.OPEN_SSH\"></a>\n</wt-dropdown-button></div></div><div \nng-show=\"vm.show_status() || vm.plan_code==\'dev-sm01\' || vm.plan_code==\'dev-micro\'\" \nclass=\"website-details-alerts-container col-12\"><ng-include ng-show=\"vm.show_status()\" \nsrc=\'\"app/main/wooadmin/models/modelstatus.html\"\'></ng-include><span \nng-if=\"vm.plan_code==\'dev-sm01\' || vm.plan_code==\'dev-micro\'\" class=\"alert alert-info\" \ntranslate=\"WEBSITE.DEVELOPMENT_SITE_DETAILS.NOTICE_NOLIMIT\"></span></div></div><div class=\"has-subnav\"><div \nclass=\"subnav-container\" id=\"website-left\"><ul class=\"subnav\"><li ng-repeat=\"tab in vm.tabs\" \nng-if=\"vm.isAdmin || !tab.admin\"><button ng-click=\"vm.selectTab(tab.name)\" class=\"btn btn-link\" \nng-class=\"{active:vm.selected==tab.name,\'admin-only\':tab.admin}\" translate=\"{{tab.title}}\" \ntranslate-values=\"{{tab.values}}\" tabindex=\"0\"></button> <span class=\"templ-badge dark-red small\" ng-if=\"tab.count\" \nng-show=\"vm[tab.count.field]\">{{vm[tab.count.field]}}</span> <span class=\"templ-badge dark-green small new\" \nng-if=\"tab.new\" translate=\"NEW\">New</span></li></ul></div><div class=\"main-container card\" ng-repeat=\"obj in [vm.obj]\">\n<div class=\"wt-tab\" ng-show=\"vm.selected==\'overview\'\"><ng-include src=\"\'app/main/website/newdesign/overview.html\'\">\n</ng-include></div><div class=\"wt-tab\" ng-show=\"vm.selected==\'backup\'\"><ng-include \nsrc=\"\'app/main/website/newdesign/backup.html\'\"></ng-include></div><div class=\"wt-tab\" \nng-show=\"vm.selected==\'incidents\'\"><ng-include src=\"\'app/main/website/newdesign/incidents.html\'\"></ng-include></div>\n<div class=\"wt-tab\" ng-show=\"vm.selected==\'staging\'\"><ng-include src=\"\'app/main/website/newdesign/staging.html\'\">\n</ng-include></div><div class=\"wt-tab\" ng-show=\"vm.selected==\'import\'\"><ng-include \nsrc=\"\'app/main/website/newdesign/import.html\'\"></ng-include></div><div class=\"wt-tab\" ng-show=\"vm.selected==\'plan\'\">\n<ng-include src=\"\'app/main/website/newdesign/plan.html\'\"></ng-include></div><div class=\"wt-tab\" \nng-show=\"vm.selected==\'location\'\"><ng-include src=\"\'app/main/website/newdesign/location.html\'\"></ng-include></div><div \nclass=\"wt-tab\" ng-show=\"vm.selected==\'stats\'\"><ng-include src=\"\'app/main/website/newdesign/stats.html\'\"></ng-include>\n</div><div class=\"wt-tab\" ng-show=\"vm.selected==\'tools\'\"><ng-include src=\"\'app/main/website/newdesign/tools.html\'\">\n</ng-include></div><div class=\"wt-tab\" ng-show=\"vm.selected==\'logs\'\"><ng-include \nsrc=\"\'app/main/website/newdesign/logs.html\'\"></ng-include></div><div class=\"wt-tab\" ng-show=\"vm.selected==\'advanced\'\">\n<ng-include src=\"\'app/main/website/newdesign/advanced.html\'\"></ng-include></div><div class=\"wt-tab\" \nng-show=\"vm.selected==\'extended_support\'\"><ng-include src=\"\'app/main/website/newdesign/extended_support.html\'\">\n</ng-include></div><div class=\"wt-tab\" ng-show=\"vm.selected==\'blueprints\'\"><ng-include \nsrc=\"\'app/main/website/newdesign/blueprints.html\'\"></ng-include></div></div></div></div><div ng-if=\"obj.error\"><p \ntranslate=\"WEBSITE_NOT_FOUND\"></p></div></div>");
$templateCache.put("app/main/wooadmin/models/listelemfield.html","<div class=\"md-block form-list-block\" ng-switch-when=\"compound\" ng-repeat=\"form in [form.subforms[field]]\"><div \nng-repeat=\"obj in [obj[field][i]]\"><ng-include src=\"\'app/main/wooadmin/models/modelfields.html\'\" \nng-repeat=\"fields in [form.fields]\"></ng-include></div></div><div class=\"md-block form-list-block\" ng-switch-default>\n<ng-include src=\"\'app/main/wooadmin/models/modelfield2.html\'\" ng-repeat=\"type in [form.elem_type[field]]\"></ng-include>\n</div>");
$templateCache.put("app/main/wooadmin/models/modeldetails.html","<div class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-subheader \nclass=\"md-no-sticky md-white-bg\"><div layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.editing && !vm.do_edit\"><md-button ng-click=\"vm.cancel()\" ng-if=\"!vm.do_edit\" class=\"md-raised md-primary\" \ntranslate=\"WOOADMIN.BACK\"></md-button><md-button ng-click=\"vm.do_edit=true\" ng-show=\"vm.editing\" \nclass=\"md-raised md-primary\" ng-disabled=\"vm.status!=\'ok\'\" translate=\"WOOADMIN.EDIT\"></md-button><md-button \nng-click=\"vm.delete()\" ng-show=\"vm.editing\" class=\"md-raised md-primary\" \nng-disabled=\"vm.status!=\'ok\' && vm.status!=\'error\'\" translate=\"WOOADMIN.DELETE\"></md-button><md-button \nng-repeat=\"button in vm.extra_buttons\" class=\"md-raised md-primary\" ng-click=\"button.action()\" \ntranslate=\"{{button.label}}\"></md-button></div><div layout=\"row\" layout-align=\"space-between center\" \nng-if=\"!vm.editing || vm.do_edit\"><md-button ng-click=\"vm.cancel()\" ng-if=\"!vm.do_edit\" class=\"md-raised md-primary\" \ntranslate=\"WOOADMIN.BACK\"></md-button><md-button ng-click=\"vm.do_edit=false\" ng-if=\"vm.do_edit\" \nclass=\"md-raised md-primary\" translate=\"WOOADMIN.CANCEL\"></md-button><div class=\"list-title\" layout=\"row\" \nlayout-align=\"start right\"><md-button layout-align=\"\" ng-click=\"vm.save()\" class=\"md-raised md-primary\" \nng-disabled=\"(vm.editing && modelForm.$pristine) || modelForm.$invalid || vm.isSaving\" translate=\"{{vm.save_button}}\">\n</md-button></div><div flex></div></div></md-subheader><md-content ng-show=\"vm.editing && !vm.do_edit\"><div \nng-repeat=\"obj in [vm.obj]\"><ng-include ng-show=\"vm.status!=\'ok\'\" src=\'\"app/main/wooadmin/models/modelstatus.html\"\'>\n</ng-include><ng-include ng-if=\"vm.details_template\" src=\"vm.details_template\"></ng-include><form \nng-if=\"!vm.details_template\"><fieldset ng-disabled=\"true\"><div ng-repeat=\"form in [vm.form]\"><ng-include \nsrc=\"\'app/main/wooadmin/models/modeltabs.html\'\"></ng-include></div></fieldset></form></div></md-content><form \nng-show=\"!vm.editing || vm.do_edit\" name=\"modelForm\" \nng-submit=\"(!vm.editing || !modelForm.$pristine) && !modelForm.$invalid && !vm.isSaving && vm.save()\"><input \ntype=\"submit\" style=\"position: absolute; left: -9999px; width: 1px; height: 1px\"><div ng-show=\"!vm.form_loaded\"><p \ntranslate=\"WOOADMIN.LOADING\" ng-if=\"!vm.has_loaded\">Loading...</p></div><div ng-show=\"vm.form_loaded\"><div \nng-repeat=\"form in [vm.form]\"><ng-include src=\"vm.edit_template || \'app/main/wooadmin/models/modeltabs.html\'\" \nng-repeat=\"obj in [vm.obj]\"></ng-include></div></div></form></div></div>");
$templateCache.put("app/main/wooadmin/models/modeledit.html","<h2>Editing {{vm.model.name}} <span translate=\"{{vm.obj.get_name()}}\" translate-values=\"vm.obj.get_values()\"></span>\n</h2><ng-include src=\"\'app/main/layouts/wt-edit.html\'\"></ng-include><div class=\"button-container below-content\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.delete()\" translate=\"WOOADMIN.DELETE\"></a> <a class=\"btn btn-outline-primary\" \nng-click=\"vm.save_as_new()\" translate=\"WOOADMIN.SAVE_AS_NEW\"></a></div>");
$templateCache.put("app/main/wooadmin/models/modelfield.html","<div ng-switch=\"type\"><div class=\"md-block form-list-block\" layout=\"column\" ng-switch-when=\"slider\"><p>\n{{form.title[field]}}</p><md-slider-container><md-slider flex class=\"md-primary\" min=\"{{form.number[field].min}}\" \nmax=\"{{form.number[field].max}}\" step=\"{{form.number[field].step}}\" md-discrete ng-model=\"obj[field]\" \naria-label=\"{{field}}\" id=\"{{field}}-slider\"></md-slider><div class=\"input-container\"><input flex type=\"number\" \nmin=\"{{form.number[field].min}}\" max=\"{{form.number[field].max}}\" step=\"{{form.number[field].step}}\" \nng-model=\"obj[field]\" aria-label=\"{{field}}\" aria-controls=\"{{field}}-slider\"> <span>{{form.unit[field]}}</span></div>\n</md-slider-container></div><div class=\"md-block form-list-block\" ng-switch-when=\"list\" flex layout-fill layout-margin>\n<h3 ng-if=\"!form.no_labels\">{{form.label[field]||field.capitalize()}}</h3><md-list flex layout-fill layout-margin>\n<md-list-item ng-repeat=\"(i,elem) in obj[field] track by i\" flex layout=\"row\" layout-fill layout-margin><ng-include \nsrc=\"\'app/main/wooadmin/models/listelemfield.html\'\" ng-switch=\"vm.list_elem_type(form, field)\" flex layout-fill \nlayout-margin></ng-include><md-button ng-if=\"!form.disabled[field]\" ng-click=\"vm.remove_list_element(obj[field],i)\">\n{{ \'WOOADMIN.REMOVE\' | translate}}</md-button></md-list-item></md-list><md-button -if=\"!form.disabled[field]\" \nng-click=\"vm.add_list_element(form, obj, field)\">{{ \'WOOADMIN.ADD\' | translate}}</md-button></div><div \nclass=\"md-block form-list-block\" ng-switch-when=\"compound\"><h3 ng-if=\"!form.no_labels\">\n{{form.label[field]||field.capitalize()}}</h3><div class=\"md-block form-list-block\" \nng-repeat=\"form in [form.subforms[field]]\"><div ng-repeat=\"obj in [vm.init_compound(obj,field)]\"><ng-include \nsrc=\"\'app/main/wooadmin/models/modelfields.html\'\" ng-repeat=\"fields in [form.fields]\"></ng-include></div></div></div>\n<div class=\"input-container\" ng-switch-when=\"select\"><label ng-if=\"!form.no_labels\">\n{{form.label[field]||field.capitalize()}}</label><div ng-if=\"form.multiple[field]\"><select class=\"form-control\" \nmultiple=\"true\" ng-model=\"obj[field]\" \nng-options=\"option.value||option as option.name||option|translate for option in form.values[field]\" \nng-disabled=\"form.disabled[field]\" ng-required=\"!form.optional[field]\"><option \nng-repeat=\"option in form.values[field]\" value=\"{{option.value||option}}\">{{option.name||option}}</option></select>\n</div><div ng-if=\"!form.multiple[field]\"><select class=\"form-control\" ng-if=\"obj[field]._id\" ng-model=\"obj[field]._id\" \nng-required=\"!form.optional[field]\" \nng-options=\"option.value||option as option.name||option|translate for option in form.values[field]\" \nng-disabled=\"form.disabled[field]\"><option ng-if=\"form.optional[field] && obj[field]\"></option><option \nng-repeat=\"option in form.values[field]\" value=\"{{option.value||option}}\">{{option.name||option}}</option><option \nng-if=\"!vm.includes_option(obj[field],form.values[field])\" value=\"{{obj[field]}}\">{{obj[field]}}</option></select>\n<select class=\"form-control\" ng-if=\"!obj[field]._id\" ng-model=\"obj[field]\" ng-required=\"!form.optional[field]\" \nng-options=\"option.value||option as option.name||option|translate for option in form.values[field]\" \nng-disabled=\"form.disabled[field]\"><option ng-if=\"form.optional[field] && obj[field]\"></option><option \nng-repeat=\"option in form.values[field]\" value=\"{{option.value||option}}\">{{option.name||option}}</option><option \nng-if=\"!vm.includes_option(obj[field],form.values[field])\" value=\"{{obj[field]}}\">{{obj[field]}}</option></select>\n</div></div><div class=\"input-container\" ng-switch-when=\"number\"><label ng-if=\"!form.no_labels\">\n{{form.label[field]||field.capitalize()}}</label><input type=\"{{type}}\" min=\"{{form.number[field].min}}\" \nmax=\"{{form.number[field].max}}\" step=\"{{form.number[field].step}}\" name=\"ng-input-field\" ng-model=\"obj[field]\" \nng-required=\"!form.optional[field]\" ng-disabled=\"form.disabled[field]\" autocomplete=\"off\"></div><div \nclass=\"input-container\" ng-switch-when=\"json\" flex layout-fill layout-margin><label ng-if=\"!form.no_labels\">\n{{form.label[field]||field.capitalize()}}</label><textarea ng-model=\"obj[field]\" class=\"form-control\"></textarea></div>\n<div class=\"input-container\" ng-switch-when=\"id\" flex layout-fill layout-margin><label ng-if=\"!form.no_labels\">\n{{form.label[field]||field.capitalize()}}</label><input type=\"text\" ng-model=\"obj[field]._id || obj[field]\"></div><div \nclass=\"input-container\" ng-switch-when=\"ref\" flex layout-fill layout-margin><label ng-if=\"!form.no_labels\">\n{{form.label[field]||field.capitalize()}}</label><input type=\"text\" ng-model=\"obj[field]._id || obj[field]\"></div><div \nng-switch-when=\"datetime\" flex layout-fill layout-margin><label ng-if=\"!form.no_labels\" \ntranslate=\"{{form.label[field]||field.capitalize()}}\"></label><input ng-model=\"obj[field]\" class=\"form-control\" \ndatetime-picker></div><div ng-switch-default><div class=\"input-container\" class=\"md-block\"><label \nng-if=\"!form.no_labels\">{{form.label[field]||field.capitalize()}}</label><input \ntype=\"{{!vm.show_password[field] && (type || \'text\') || \'text\'}}\" class=\"form-control\" name=\"ng-input-field\" \nng-model=\"obj[field]\" ng-required=\"!form.optional[field] && type!=\'checkbox\'\" ng-disabled=\"form.disabled[field]\" \nautocomplete=\"off\"></div><div class=\"input-container\" class=\"md-block\" ng-if=\"\'password\'==type\"><label><span \nng-show=\"vm.show_password[field]\">Hide</span> <span ng-show=\"!vm.show_password[field]\">Show</span> Password</label>\n<input type=\"checkbox\" ng-model=\"vm.show_password[field]\" ng-checked=\"vm.show_password[field]\"><my-password-generator \nng-if=\"! form.disabled[field]\" field=\"obj[field]\" password-length=\"form.password[field].length||15\" \nuppercase=\"!form.password[field].nouppercase && true\" numbers=\"true\" specials=\"true\"></my-password-generator></div><div\n ng-if=\"form.edit_ref[field]\" class=\"wt-admin-link\"><div ng-if=\"form.ref_value[field]\">{{form.ref_value[field]}} <a \nui-sref=\"{{form.edit_ref[field]}}({id:form.ref_id[field]||obj[field]._id||obj[field]})\">Edit</a></div><a \nng-if=\"!form.ref_value[field]\" ui-sref=\"{{form.edit_ref[field]}}\">Create</a></div></div></div><div \nng-if=\"form.alternatives[field] && form.alternatives[field][obj[field]]\"><div class=\"md-block form-list-block\" \nng-repeat=\"form in [form.alternatives[field][obj[field]]]\"><ng-include \nsrc=\"\'app/main/wooadmin/models/modelfields.html\'\" ng-repeat=\"fields in [form.fields]\"></ng-include></div></div>");
$templateCache.put("app/main/wooadmin/models/modelfield2.html","<div ng-switch=\"type\"><md-input-container ng-switch-when=\"select\"><label>{{form.label[field]||field.capitalize()}}\n</label><div ng-if=\"form.multiple[field]\"><md-select multiple=\"true\" ng-model=\"obj[field][i]\" \nng-disabled=\"form.disabled[field]\" ng-required=\"!form.optional[field]\"><md-option \nng-repeat=\"option in form.values[field]\" value=\"{{option.value||option}}\">{{option.name||option}}</md-option>\n</md-select></div><div ng-if=\"!form.multiple[field]\"><md-select ng-if=\"obj[field][i]._id\" ng-model=\"obj[field][i]._id\" \nng-required=\"!form.optional[field]\" ng-disabled=\"form.disabled[field]\"><md-option \nng-if=\"!form.optional[field] && obj[field][i]\"></md-option><md-option ng-repeat=\"option in form.values[field]\" \nvalue=\"{{option.value||option}}\">{{option.name||option}}</md-option><md-option \nng-if=\"!vm.includes_option(obj[field][i],form.values[field])\" value=\"{{obj[field][i]}}\">{{obj[field][i]}}</md-option>\n</md-select><md-select ng-if=\"!obj[field][i]._id\" ng-model=\"obj[field][i]\" ng-required=\"!form.optional[field]\" \nng-disabled=\"form.disabled[field]\"><md-option ng-if=\"!form.optional[field] && obj[field][i]\"></md-option><md-option \nng-repeat=\"option in form.values[field]\" value=\"{{option.value||option}}\">{{option.name||option}}</md-option><md-option\n ng-if=\"!vm.includes_option(obj[field][i],form.values[field])\" value=\"{{obj[field][i]}}\">{{obj[field][i]}}</md-option>\n</md-select></div></md-input-container><div ng-switch-default><md-input-container class=\"md-block\"><label>\n{{form.label[field]||field.capitalize()}}</label><input \ntype=\"{{!vm.show_password[field] && (type || \'text\') || \'text\'}}\" name=\"ng-input-field\" ng-model=\"obj[field][i]\" \nng-required=\"!form.optional[field] && type!=\'checkbox\'\" ng-disabled=\"form.disabled[field]\" autocomplete=\"off\">\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"\'password\'==type\"><label>Show password</label><input \ntype=\"checkbox\" ng-model=\"vm.show_password[field]\" ng-checked=\"vm.show_password[field]\"><my-password-generator \nng-if=\"! form.disabled[field]\" field=\"obj[field][i]\" password-length=\"form.password[field].length||15\" \nuppercase=\"!form.password[field].nouppercase && true\" numbers=\"true\" specials=\"true\"></my-password-generator>\n</md-input-container></div></div>");
$templateCache.put("app/main/wooadmin/models/modelfields.html","<fieldset ng-disabled=\"vm.isSaving\"><div ng-repeat=\"field in fields\"><div ng-show=\"!form.hidden[field]\"><ng-include \nsrc=\"\'app/main/wooadmin/models/modelfield.html\'\" ng-repeat=\"type in [form.type[field]]\"></ng-include></div></div>\n</fieldset>");
$templateCache.put("app/main/wooadmin/models/modelform.html","<form name=\"modelForm\"><div ng-repeat=\"form in [vm.form]\"><ng-include src=\"\'app/main/wooadmin/models/modeltabs.html\'\" \nng-repeat=\"obj in [vm.obj]\"></ng-include></div></form>");
$templateCache.put("app/main/wooadmin/models/modellist.html","<div ng-if=\"vm.has_objects\"><div ng-if=\"vm.dashboard\"><ng-include src=\"vm.dashboard\"></ng-include></div><ng-include \nsrc=\"vm.list.head_template || \'app/main/wooadmin/models/modellisthead.html\'\"></ng-include><div class=\"card\"><header \nclass=\"above-tables\" ng-class=\"{\'has-actions\': vm.list.actions_template}\"><ng-include \nsrc=\"vm.list.filter_template || \'app/main/wooadmin/models/modellistfilter.html\'\" class=\"filter-container\"></ng-include>\n<ng-include ng-if=\"vm.list.actions_template\" src=\"vm.list.actions_template\" class=\"actions-container\"></ng-include>\n</header><hr class=\"section-divider\"><div class=\"table {{vm.list.tableClass}}\"><ng-include \nsrc=\"vm.list.body_template || \'app/main/wooadmin/models/modellistbody.html\'\"></ng-include></div></div><paging \nng-if=\"vm.total_pages>1\" page=\"vm.page\" page-size=\"vm.page_size\" total=\"vm.total_size\" \npaging-action=\"vm.gotoPage(page)\"></paging></div><ng-include ng-if=\"!vm.has_objects\" \nsrc=\"\'app/main/wooadmin/models/modellistempty.html\'\"></ng-include>");
$templateCache.put("app/main/wooadmin/models/modellistbody.html","<ng-include src=\"vm.list.headers_template || \'app/main/wooadmin/models/modellistheaders.html\'\"></ng-include><ng-include\n src=\"vm.list.items_template || \'app/main/wooadmin/models/modellistitems.html\'\"></ng-include>");
$templateCache.put("app/main/wooadmin/models/modellistempty.html","<div id=\"empty-page\" class=\"empty-page\"><div id=\"message-wrapper\"><div id=\"message\"><div \nng-if=\"vm.empty_animation_template\"><ng-include src=\"vm.empty_animation_template\"></ng-include></div><div \nclass=\"empty-title-container\"><h1 translate=\"{{vm.empty_title}}\"></h1><wt-help-button ng-if=\"vm.helpUrl\" \nwt-help-url=\"{{vm.helpUrl}}\" wt-color=\"white\"></wt-help-button></div><p><span translate=\"{{vm.empty_text}}\"></span></p>\n<div class=\"list-title\" layout=\"column\" layout-align=\"start right\"><div class=\"button-container\"><button \nng-if=\"!vm.no_create\" ng-disabled=\"vm.disable_create\" ng-click=\"vm.openCreateView($event)\" class=\"btn btn-primary\" \ntranslate=\"{{ vm.create_button||\'WOOADMIN.CREATE_OBJ\'}}\"></button> <button ng-repeat=\"b in vm.extra_buttons\" \nng-disabled=\"b.disabled\" ng-if=\"!b.skip_on_empty\" ng-click=\"b.fun()\" class=\"btn {{b.class || \'btn-outline-primary\'}}\" \ntranslate=\"{{ b.name }}\"></button></div></div></div></div></div>");
$templateCache.put("app/main/wooadmin/models/modellistfilter.html","<div class=\"wt-checkbox-container share-filter-list\"><div ng-repeat=\"f in vm.get_filters(\'checkbox\')\" \nclass=\"share-filter\"><label class=\"wt-field-description\"><input type=\"checkbox\" name=\"{{f.name}}\" ng-model=\"f.checked\" \nng-disabled=\"f.disabled\"> <span translate=\"{{f.label}}\"></span></label></div></div><div \nng-repeat=\"f in vm.get_filters(\'search\')\"><form class=\"table-filter\"><div class=\"search-container\"><input type=\"text\" \nng-keydown=\"vm.handleKeydown($event)\" class=\"form-control search\" id=\"list-search\" \nplaceholder=\"{{vm.translate(\'SEARCH_PLACEHOLDER\')}}\" ng-model=\"f.query\"> <a class=\"clear\" translate=\"CLEAR\" \nng-click=\"f.query=\'\'\">Clear</a></div></form></div><div ng-repeat=\"f in vm.get_filters(\'input\')\"><form \nclass=\"table-filter\" ng-submit=\"vm.filter_changed(f)\"><div class=\"search-container\"><input type=\"text\" \nng-attr-id=\"filter-{{f.name}}\" placeholder=\"{{f.label}}\" ng-model=\"f.value\"></div></form></div>");
$templateCache.put("app/main/wooadmin/models/modellisthead.html","<div class=\"title-with-buttons\"><div class=\"title\"><h1 translate=\"{{vm.Title}}\" \ntranslate-values=\"{{vm.TranslateValues}}\">Title</h1><wt-help-button ng-if=\"vm.helpUrl\" wt-help-url=\"{{vm.helpUrl}}\" \nwt-color=\"white\"></wt-help-button></div><div class=\"button-container\"><button \nng-click=\"vm.deleteSelectedItems($event)\" class=\"btn btn-secondary\" ng-show=\"vm.selectedItems.length>0\" \ntranslate=\"{{ vm.delete_button || \'WOOADMIN.DELETE_OBJ\'}}\"></button> <button ng-if=\"!vm.no_create\" \nng-disabled=\"vm.disable_create\" ng-click=\"vm.openCreateView($event)\" class=\"btn btn-primary\" \nng-attr-title=\"{{vm.create_button_title}}\" translate=\"{{ vm.create_button || \'WOOADMIN.CREATE_OBJ\' }}\"></button> \n<button ng-repeat=\"b in vm.extra_buttons\" ng-if=\"!b.sref && (!b.adminOnly||vm.isAdmin)\" ng-click=\"b.fun()\" \nng-disabled=\"b.disabled\" class=\"btn {{b.class || \'md-primary btn-outline-primary\'}}\" \nng-class=\"{\'admin-only\':b.adminOnly}\" ng-attr-title=\"{{b.title}}\" translate=\"{{ b.name }}\"></button> <a \nng-repeat=\"b in vm.extra_buttons\" ng-if=\"b.sref && (!b.adminOnly||vm.isAdmin)\" ng-disabled=\"b.disabled\" class=\"btn\" \nng-class=\"{\'admin-only\':b.adminOnly}\" ui-sref=\"{{b.sref}}\" ng-attr-title=\"{{b.title}}\" translate=\"{{ b.name }}\"></a>\n</div></div>");
$templateCache.put("app/main/wooadmin/models/modellistheaders.html","<div class=\"table-head row no-gutters\" md-ink-ripple ng-if=\"vm.list.headers\"><div \nng-repeat=\"header in vm.list.headers\" class=\"table-head-column-header {{header.class}}\" \nng-class=\"{\'sorted-by\': vm.sortBy.name == header.name, \'asc\' : vm.sortBy.order == \'ASC\'}\"><span>\n{{header.name || header}}</span></div></div>");
$templateCache.put("app/main/wooadmin/models/modellistitem.html","<div class=\"table-row row no-gutters\"><div class=\"col-10 name\" translate=\"{{vm.list.get_name(obj)||obj.id}}\" \ntranslate-values=\"{{vm.list.get_values(obj)}}\">{{vm.list.get_name(obj) || obj._id}}</div><div class=\"col-2\"><ng-include\n src=\"\'app/main/wooadmin/models/modelstatusicon.html\'\"></ng-include></div></div>");
$templateCache.put("app/main/wooadmin/models/modellistitems.html","<div ng-repeat=\"obj in vm.objects\" ng-click=\"vm.openEditView($event, obj)\" aria-label=\"Open\" tabindex=\"0\"><ng-include \nsrc=\"vm.list.item_template || \'app/main/wooadmin/models/modellistitem.html\'\"></ng-include></div>");
$templateCache.put("app/main/wooadmin/models/modellistmenu.html","<div class=\"actions\" layout=\"row\" layout-align=\"start center\"><md-menu><md-button class=\"md-icon-button\" \naria-label=\"More\" translate translate-attr-aria-label=\"WOOADMIN.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item \nng-if=\"!vm.list.nodelete\"><md-button ng-click=\"vm.deleteItem($event,obj)\" translate=\"WOOADMIN.DELETE_OBJ\"></md-button>\n</md-menu-item><md-menu-item ng-repeat=\"mitem in menu\"><md-button ng-click=\"mitem.action($event,obj)\" \ntranslate=\"{{mitem.label}}\"></md-button></md-menu-item><md-menu-item ng-repeat=\"mitem in vm.object_menu[obj._id]\">\n<md-button ng-click=\"mitem.action($event,obj)\" translate=\"{{mitem.label}}\"></md-button></md-menu-item>\n</md-menu-content></md-menu></div>");
$templateCache.put("app/main/wooadmin/models/models.html","<md-subheader class=\"md-no-sticky md-white-bg\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span>{{ \'WOOADMIN.WOOADMIN_NAV\' | translate }}</span></div><md-button \nng-click=\"vm.openCreateView($event)\">{{ \'WOOADMIN.CREATE_OBJ\' | translate }}</md-button><md-button class=\"hide\" \nng-click=\"vm.deleteSelectedObjects($event)\" ng-if=\"vm.selectedItems.length>0\">{{ \'WOOADMIN.DELETE_OBJ\' | translate}}\n</md-button><div flex></div></div></md-subheader><md-list class=\"woadmin-list\"><md-list-item \nclass=\"font-weight-600 list-headers list-item md-white-bg\" md-ink-ripple ng-repeat=\"obj in vm.objects\" \nng-click=\"vm.openEditView($event, obj)\"><md-checkbox class=\"hide\" ng-checked=\"vm.exists(item, vm.selectedItems)\" \nng-click=\"vm.toggleSelectItem(item, $event)\" \naria-label=\"{{vm.exists(item, vm.selectedItems) ? \'Deselect\' : \'Select\'}}\"></md-checkbox>{{obj}}</md-list-item>\n</md-list>");
$templateCache.put("app/main/wooadmin/models/modelstatus.html","<span ng-switch=\"vm.op_status && vm.op_status(obj) || vm.object_status(obj)\"><i ng-switch-when=\"ok\" \nclass=\"status-icon status-ok\"></i> <i ng-switch-when=\"error\" class=\"status-icon status-alert\"></i> <i \nng-switch-when=\"waiting\" class=\"status-icon status-waiting\"></i><div ng-switch-default \nclass=\"status-icon status-loading spinner-border text-primary\" role=\"status\"><span class=\"sr-only\" translate=\"LOADING\">\n</span></div></span><div class=\"alerts\" ng-repeat=\"op in [obj.operation]\"><div ng-if=\"!op.complete\"><div \nng-if=\"!op.complete && op.slow_warning.active\" class=\"alert alert-warning\" \ntranslate=\"{{op.slow_warning.reason || \'OPERATION.SLOW_WARNING\'}}\" translate-values=\"{time: op.slow_warning_delay}\">\n</div><div ng-if=\"!op.complete && ! op.slow_warning.active && op.time\" class=\"alert alert-warning\" \ntranslate=\"WOOADMIN.OP_TIME_MSG\" translate-values=\"{time: op.time}\"></div><div class=\"alert alert-info\" \nng-repeat=\"msg in [op.msgs[op.msgs.length-1]]\"><span class=\"current-action\" translate=\"{{msg.msg||msg|truncate:175}}\" \ntranslate-values=\"{{msg.values}}\"></span><span>...</span></div></div><div ng-if=\"op.complete && vm.show_op(op)\"><div \nclass=\"alert alert-info\" ng-repeat=\"msg in obj.operation.msgs\" ng-if=\"vm.show_msg(msg)\"><wt-text \nwt-msg=\"{{(msg.msg||msg)}}\" wt-trunc=\"175\" wt-translate-values=\"{{msg.values}}\"></wt-text><a ng-if=\"msg.link.state\" \nui-sref=\"{{msg.link.state}}({id:{{msg.link.id}}})\" translate=\"{{msg.link.name}}\"></a><a ng-if=\"msg.link.href\" \nhref=\"{{msg.link.href}}\" translate=\"{{msg.link.name}}\"></a></div><div ng-if=\"op.status==\'error\' && !op.non_fatal\" \nclass=\"alert alert-danger\" translate=\"WOOADMIN.OP_ERROR_NOTIFICATION_MSG\"></div></div></div>");
$templateCache.put("app/main/wooadmin/models/modelstatusicon.html","<span ng-switch=\"vm.op_status && vm.op_status(obj) || vm.object_status(obj)\"><i ng-switch-when=\"ok\" \nclass=\"list-item__status-icon list-item__status-icon--ok\"></i> <i ng-switch-when=\"error\" \nclass=\"list-item__status-icon list-item__status-icon--error\"></i> <i ng-switch-when=\"waiting\" \nclass=\"list-item__status-icon list-item__status-icon--waiting\"></i><div ng-switch-default \nclass=\"list-item__status-icon list-item__status-icon--loading spinner-border text-primary\" role=\"status\"><span \nclass=\"sr-only\" translate=\"LOADING\"></span></div></span>");
$templateCache.put("app/main/wooadmin/models/modelstatusmsg.html","<div class=\"alerts\" ng-repeat=\"op in [obj.operation]\"><div ng-if=\"!op.complete\"><div \nng-if=\"!op.complete && op.slow_warning.active\" class=\"alert alert-warning\" \ntranslate=\"{{op.slow_warning.reason || \'OPERATION.SLOW_WARNING\'}}\" translate-values=\"{time: op.slow_warning_delay}\">\n</div><div ng-if=\"!op.complete && ! op.slow_warning.active && op.time\" class=\"alert alert-warning\" \ntranslate=\"WOOADMIN.OP_TIME_MSG\" translate-values=\"{time: op.time}\"></div><div class=\"alert alert-info\" \nng-repeat=\"msg in [op.msgs[op.msgs.length-1]]\"><span translate=\"{{msg.msg||msg|truncate:trunc}}\" \ntranslate-values=\"{{msg.values}}\"></span></div></div><div ng-if=\"op.complete && vm.show_op(op)\"><div \nclass=\"alert alert-info\" ng-repeat=\"msg in obj.operation.msgs\" ng-if=\"vm.show_msg(msg)\"><wt-text \nwt-msg=\"{{(msg.msg||msg)}}\" wt-trunc=\"75\" wt-translate-values=\"{{msg.values}}\"></wt-text><a ng-if=\"msg.link.state\" \nui-sref=\"{{msg.link.state}}({id:{{msg.link.id}}})\" translate=\"{{msg.link.name}}\"></a></div><div \nng-if=\"op.status==\'error\'\" class=\"alert alert-danger\" translate=\"WOOADMIN.OP_ERROR_NOTIFICATION_MSG\"></div></div></div>");
$templateCache.put("app/main/wooadmin/models/modeltabs.html","<uib-tabset md-dynamic-height ng-if=\"form.tabs\"><uib-tab index=\"$index+1\" ng-repeat=\"tab in form.tabs\" \nheading=\"{{tab.title||tab.name.capitalize()}}\"><ng-include src=\"\'app/main/wooadmin/models/modelfields.html\'\" \nng-repeat=\"fields in [tab.fields]\"></ng-include></uib-tab></uib-tabset><ng-include ng-if=\"!vm.form.tabs\" \nsrc=\"\'app/main/wooadmin/models/modelfields.html\'\" ng-repeat=\"fields in [form.fields]\"></ng-include>");
$templateCache.put("app/main/wooadmin/models/modelwarnings.html","<div ng-if=\"obj.operation.warning\" class=\"wt-warnings\"><h2>Warnings (Admin Only):</h2><div \nng-repeat=\"msg in obj.operation.msgs\" ng-if=\"msg.is_warning\"><wt-text wt-msg=\"{{(msg.msg||msg)}}\" wt-trunc=\"75\" \nwt-translate-values=\"{{msg.values}}\"></wt-text><a ng-if=\"msg.link.state\" \nui-sref=\"{{msg.link.state}}(id:{{msg.link.id}})\" translate=\"{{msg.link.name}}\"></a></div></div>");
$templateCache.put("app/main/wooadmin/models/multilistitem.html","<div class=\"table-row row no-gutters\"><div class=\"col-5 name\" translate=\"{{vm.list.get_name(obj)||obj.id}}\" \ntranslate-values=\"{{vm.list.get_values(obj)}}\">{{vm.list.get_name(obj) || obj._id}}</div><div ng-class=\"item.class\" \nclass=\"name\" ng-repeat=\"item in vm.list.items\">{{obj[item]}}</div></div>");
$templateCache.put("app/main/wooapps/wooapp/wooapp-create.html","");
$templateCache.put("app/main/wooapps/wooapp/wooapp-edit.html","<div class=\"details_template\"><div ng-repeat=\"obj in [vm.obj]\"><div ng-if=\"vm.status==\'ok\'\"><p ng-if=\"obj.stopped\" \nclass=\"error-description\">Server is Stopped</p><md-button class=\"md-raised md-primary\" ng-if=\"!obj.stopped\" \nng-repeat=\"ap in vm.APs\" ng-click=\"ap.action($event,vm.obj)\">{{ ap.label }}</md-button><md-button ng-if=\"!obj.stopped\" \nclass=\"md-raised md-primary\" ng-click=\"vm.stop_app()\">Stop</md-button><md-button ng-if=\"obj.stopped\" \nclass=\"md-raised md-primary\" ng-click=\"vm.start_app()\">Start</md-button><md-button ng-if=\"!obj.stopped\" \nclass=\"md-raised md-primary\" ng-click=\"vm.restart_app()\">Restart</md-button><md-button ng-if=\"!obj.stopped\" \nclass=\"md-raised md-primary\" ng-click=\"vm.create_backup()\">Create Backup</md-button><md-button ng-if=\"!obj.stopped\" \nclass=\"md-raised md-primary\" ng-click=\"vm.restore_backup()\">Restore Backup</md-button></div><form><p>\nWebsite Name: {{obj.name}}</p><p>Location: {{obj.location.name}}</p><p>Plan: {{obj.plan.name}}</p><p>\nDomain: {{obj.domainn}}</p><p>IP Address: {{obj.ip4}}</p><p>Admin Username: {{obj.app_admin.username}}</p><p>\nAdmin Password: <input type=\"{{vm.show_password[\'password\'] && \'text\' || \'password\'}}\" \nng-model=\"obj.app_admin.password\" ng-required=\"false\" ng-disabled=\"true\" autocomplete=\"off\"> <input type=\"checkbox\" \nng-model=\"vm.show_password[\'password\']\" ng-checked=\"vm.show_password[\'password\']\"><label>Show password</label></p><p>\nDB Username: {{obj.db_admin.user}}</p><p>DB Password: <input \ntype=\"{{vm.show_password[\'db_password\'] && \'text\' || \'password\'}}\" ng-model=\"obj.db_admin.password\" \nng-required=\"false\" ng-disabled=\"true\" autocomplete=\"off\"> <input type=\"checkbox\" \nng-model=\"vm.show_password[\'db_password\']\" ng-checked=\"vm.show_password[\'db_password\']\"><label>Show password</label>\n</p><p ng-if=\"obj.disk_usage\">Disk usage: {{obj.disk_usage}}% of total {{obj.disk_size}}GB</p></form></div></div>");
$templateCache.put("app/main/wooapps/wooapp/wooapp.basic.html","");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<header class=\"navigation-header\"><span ng-if=\"vm.betaPanel\" class=\"templ-badge small pink beta-badge\">BETA</span> <a \nng-if=\"!vm.custom_logo\" href=\"/\"><img class=\"logo-img\" ng-src=\"{{vm.logo}}\" alt=\"Templ logo\"> </a><a \nng-if=\"vm.custom_logo\" href=\"/\"><img class=\"logo-img custom-logo\" ng-src=\"{{vm.logo}}\" alt=\"Agency logo\"> <img \nclass=\"powered-by\" src=\"/assets/logos/by-templ-1.svg\" alt=\"Powered by Templ\"></a></header><ms-navigation \nid=\"main-menu\" class=\"main-menu\"></ms-navigation><div id=\"user-nav\" class=\"btn-group\" uib-dropdown keyboard-nav><div \nid=\"simple-btn-keyboard-nav\" class=\"user-nav-content\" uib-dropdown-toggle><div class=\"gravatar\"><img class=\"avatar\" \ngravatar-src-once=\"vm.user_email\" gravatar-size=\"88\" gravatar-default=\"blank\" height=\"44px\" width=\"44px\"> <span \nclass=\"initials\">{{vm.user_initials}}</span></div><span class=\"name\">{{vm.user_first_name}}</span></div><ul \nclass=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"simple-btn-keyboard-nav\"><li class=\"my-account\" \nrole=\"menuitem\"><a target=\"templio-account\" ng-href=\"{{vm.my_account_url}}\" translate=\"WOOADMIN.MY_ACCOUNT\"></a></li>\n<li ng-if=\"vm.isAdmin\" class=\"settings admin-only\" role=\"menuitem\"><a href=\"/settings/\" translate=\"WOOADMIN.SETTINGS\">\n</a></li><li class=\"language\" role=\"menuitem\" ng-repeat=\"lang in vm.languages\"><a \nng-click=\"vm.switch_language(lang.code)\">{{lang.name}}</a></li><li class=\"logout\" role=\"menuitem\"><a \nui-sref=\"app.auth.logout\" translate=\"WOOADMIN.LOGOUT\">Log out</a></li></ul></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJane Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.auth.edit\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>Jane Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.auth.edit\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\">\n</md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-xs \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\"><span \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></span></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>Jane Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.auth.edit\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\">\n</md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>Jane Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.auth.edit\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\">\n</md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <a class=\"ms-navigation-button\" ng-if=\"node.href && node.title\" href=\"{{node.href|translate}}\"\n            target=\"{{node.target}}\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n        </a>\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && !node.href && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/directives/help-page/templates/help-page.html","<div layout=\"column\" flex layout-fill><div class=\"help-page-tools\" layout=\"row\" style=\"height:64px\" \nlayout-align=\"start center\"><md-icon class=\"help-page-control\" md-font-icon=\"icon-arrow-left\" \nng-click=\"vm.frame_back(vm.help_frame)\"></md-icon><md-icon class=\"help-page-control\" md-font-icon=\"icon-arrow-right\" \nng-click=\"vm.frame_forward(vm.help_frame)\"></md-icon><md-icon class=\"help-page-control\" md-font-icon=\"icon-reload\" \nng-click=\"vm.frame_reload(vm.help_frame)\"></md-icon><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><md-progress-circular \nng-disabled=\"!vm.help_frame.loading\" class=\"md-accent\" md-diameter=\"16\"></md-progress-circular></div><div \nclass=\"help-page-container\" layout=\"column\" layout-fill layout-padding flex></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);